// === GENERATED BY scripts/generate_template.py — DO NOT EDIT MANUALLY ===
// Template: Go API Gateway
// Total files: 95

import type { FileTreeNode } from '../types/wizard';

export const goApiDemoFileTree: FileTreeNode[] = [
    {
      name: '.claude',
      path: '.claude',
      type: 'directory',
      children: [
        {
          name: 'rules',
          path: '.claude/rules',
          type: 'directory',
          children: [
            {
              name: 'common',
              path: '.claude/rules/common',
              type: 'directory',
              children: [
                { name: 'coding-style.md', path: '.claude/rules/common/coding-style.md', type: 'file' },
                { name: 'git-workflow.md', path: '.claude/rules/common/git-workflow.md', type: 'file' },
                { name: 'security.md', path: '.claude/rules/common/security.md', type: 'file' },
                { name: 'testing.md', path: '.claude/rules/common/testing.md', type: 'file' },
              ],
            },
            {
              name: 'go',
              path: '.claude/rules/go',
              type: 'directory',
              children: [
                { name: 'coding-style.md', path: '.claude/rules/go/coding-style.md', type: 'file' },
                { name: 'testing.md', path: '.claude/rules/go/testing.md', type: 'file' },
              ],
            },
          ],
        },
        { name: 'settings.json', path: '.claude/settings.json', type: 'file' },
      ],
    },
    { name: '.editorconfig', path: '.editorconfig', type: 'file' },
    { name: '.gitattributes', path: '.gitattributes', type: 'file' },
    {
      name: '.github',
      path: '.github',
      type: 'directory',
      children: [
        { name: 'CODEOWNERS', path: '.github/CODEOWNERS', type: 'file' },
        {
          name: 'ISSUE_TEMPLATE',
          path: '.github/ISSUE_TEMPLATE',
          type: 'directory',
          children: [
            { name: 'ai_task.md', path: '.github/ISSUE_TEMPLATE/ai_task.md', type: 'file' },
            { name: 'bug_report.md', path: '.github/ISSUE_TEMPLATE/bug_report.md', type: 'file' },
            { name: 'feature_request.md', path: '.github/ISSUE_TEMPLATE/feature_request.md', type: 'file' },
          ],
        },
        { name: 'PULL_REQUEST_TEMPLATE.md', path: '.github/PULL_REQUEST_TEMPLATE.md', type: 'file' },
        {
          name: 'workflows',
          path: '.github/workflows',
          type: 'directory',
          children: [
            { name: 'ai-code-audit.yml', path: '.github/workflows/ai-code-audit.yml', type: 'file' },
            { name: 'ci.yml', path: '.github/workflows/ci.yml', type: 'file' },
            { name: 'deploy-production.yml', path: '.github/workflows/deploy-production.yml', type: 'file' },
            { name: 'deploy-staging.yml', path: '.github/workflows/deploy-staging.yml', type: 'file' },
          ],
        },
      ],
    },
    { name: '.gitignore', path: '.gitignore', type: 'file' },
    { name: '.golangci.yml', path: '.golangci.yml', type: 'file' },
    { name: '.mcp.json', path: '.mcp.json', type: 'file' },
    { name: 'CLAUDE.md', path: 'CLAUDE.md', type: 'file' },
    { name: 'README.md', path: 'README.md', type: 'file' },
    {
      name: 'docs',
      path: 'docs',
      type: 'directory',
      children: [
        { name: 'AI-USAGE-POLICY.md', path: 'docs/AI-USAGE-POLICY.md', type: 'file' },
        { name: 'ARCHITECTURE.md', path: 'docs/ARCHITECTURE.md', type: 'file' },
        { name: 'CONTRIBUTING.md', path: 'docs/CONTRIBUTING.md', type: 'file' },
        { name: 'ONBOARDING.md', path: 'docs/ONBOARDING.md', type: 'file' },
      ],
    },
    {
      name: 'git-hooks',
      path: 'git-hooks',
      type: 'directory',
      children: [
        { name: 'commit-msg', path: 'git-hooks/commit-msg', type: 'file' },
        { name: 'pre-commit', path: 'git-hooks/pre-commit', type: 'file' },
        { name: 'pre-push', path: 'git-hooks/pre-push', type: 'file' },
      ],
    },
    { name: 'go.mod', path: 'go.mod', type: 'file' },
    { name: 'install.sh', path: 'install.sh', type: 'file' },
    {
      name: 'mock-mcp-servers',
      path: 'mock-mcp-servers',
      type: 'directory',
      children: [
        { name: 'README.md', path: 'mock-mcp-servers/README.md', type: 'file' },
        { name: 'github-server.mjs', path: 'mock-mcp-servers/github-server.mjs', type: 'file' },
        { name: 'jira-server.mjs', path: 'mock-mcp-servers/jira-server.mjs', type: 'file' },
        { name: 'package.json', path: 'mock-mcp-servers/package.json', type: 'file' },
      ],
    },
    {
      name: 'playbook',
      path: 'playbook',
      type: 'directory',
      children: [
        { name: 'PLAYBOOK.md', path: 'playbook/PLAYBOOK.md', type: 'file' },
        {
          name: 'claude-overrides',
          path: 'playbook/claude-overrides',
          type: 'directory',
          children: [
            { name: '01-discovery.claude.md', path: 'playbook/claude-overrides/01-discovery.claude.md', type: 'file' },
            { name: '02-architecture.claude.md', path: 'playbook/claude-overrides/02-architecture.claude.md', type: 'file' },
            { name: '03-foundation.claude.md', path: 'playbook/claude-overrides/03-foundation.claude.md', type: 'file' },
            { name: '04-core-implementation.claude.md', path: 'playbook/claude-overrides/04-core-implementation.claude.md', type: 'file' },
            { name: '05-integration-hardening.claude.md', path: 'playbook/claude-overrides/05-integration-hardening.claude.md', type: 'file' },
            { name: '06-testing-quality.claude.md', path: 'playbook/claude-overrides/06-testing-quality.claude.md', type: 'file' },
            { name: '07-launch.claude.md', path: 'playbook/claude-overrides/07-launch.claude.md', type: 'file' },
          ],
        },
        { name: 'codeforge-phase.sh', path: 'playbook/codeforge-phase.sh', type: 'file' },
        { name: 'current-phase.json', path: 'playbook/current-phase.json', type: 'file' },
        {
          name: 'phases',
          path: 'playbook/phases',
          type: 'directory',
          children: [
            { name: '01-discovery.md', path: 'playbook/phases/01-discovery.md', type: 'file' },
            { name: '02-architecture.md', path: 'playbook/phases/02-architecture.md', type: 'file' },
            { name: '03-foundation.md', path: 'playbook/phases/03-foundation.md', type: 'file' },
            { name: '04-core-implementation.md', path: 'playbook/phases/04-core-implementation.md', type: 'file' },
            { name: '05-integration-hardening.md', path: 'playbook/phases/05-integration-hardening.md', type: 'file' },
            { name: '06-testing-quality.md', path: 'playbook/phases/06-testing-quality.md', type: 'file' },
            { name: '07-launch.md', path: 'playbook/phases/07-launch.md', type: 'file' },
          ],
        },
        {
          name: 'prompts',
          path: 'playbook/prompts',
          type: 'directory',
          children: [
            {
              name: '01',
              path: 'playbook/prompts/01',
              type: 'directory',
              children: [
                { name: 'gather-requirements.md', path: 'playbook/prompts/01/gather-requirements.md', type: 'file' },
                { name: 'nfr-checklist.md', path: 'playbook/prompts/01/nfr-checklist.md', type: 'file' },
                { name: 'user-stories.md', path: 'playbook/prompts/01/user-stories.md', type: 'file' },
              ],
            },
            {
              name: '02',
              path: 'playbook/prompts/02',
              type: 'directory',
              children: [
                { name: 'adr-generator.md', path: 'playbook/prompts/02/adr-generator.md', type: 'file' },
                { name: 'api-design.md', path: 'playbook/prompts/02/api-design.md', type: 'file' },
                { name: 'data-model-design.md', path: 'playbook/prompts/02/data-model-design.md', type: 'file' },
              ],
            },
            {
              name: '03',
              path: 'playbook/prompts/03',
              type: 'directory',
              children: [
                { name: 'ci-pipeline.md', path: 'playbook/prompts/03/ci-pipeline.md', type: 'file' },
                { name: 'iac-setup.md', path: 'playbook/prompts/03/iac-setup.md', type: 'file' },
                { name: 'project-scaffold.md', path: 'playbook/prompts/03/project-scaffold.md', type: 'file' },
              ],
            },
            {
              name: '04',
              path: 'playbook/prompts/04',
              type: 'directory',
              children: [
                { name: 'auth-implementation.md', path: 'playbook/prompts/04/auth-implementation.md', type: 'file' },
                { name: 'crud-generator.md', path: 'playbook/prompts/04/crud-generator.md', type: 'file' },
                { name: 'feature-implementation.md', path: 'playbook/prompts/04/feature-implementation.md', type: 'file' },
              ],
            },
            {
              name: '05',
              path: 'playbook/prompts/05',
              type: 'directory',
              children: [
                { name: 'integration-adapter.md', path: 'playbook/prompts/05/integration-adapter.md', type: 'file' },
                { name: 'observability-setup.md', path: 'playbook/prompts/05/observability-setup.md', type: 'file' },
                { name: 'security-hardening.md', path: 'playbook/prompts/05/security-hardening.md', type: 'file' },
              ],
            },
            {
              name: '06',
              path: 'playbook/prompts/06',
              type: 'directory',
              children: [
                { name: 'e2e-test-generator.md', path: 'playbook/prompts/06/e2e-test-generator.md', type: 'file' },
                { name: 'load-test.md', path: 'playbook/prompts/06/load-test.md', type: 'file' },
                { name: 'test-suite-generator.md', path: 'playbook/prompts/06/test-suite-generator.md', type: 'file' },
              ],
            },
            {
              name: '07',
              path: 'playbook/prompts/07',
              type: 'directory',
              children: [
                { name: 'go-live-checklist.md', path: 'playbook/prompts/07/go-live-checklist.md', type: 'file' },
                { name: 'monitoring-setup.md', path: 'playbook/prompts/07/monitoring-setup.md', type: 'file' },
                { name: 'runbook-generator.md', path: 'playbook/prompts/07/runbook-generator.md', type: 'file' },
              ],
            },
          ],
        },
      ],
    },
    {
      name: 'plugin',
      path: 'plugin',
      type: 'directory',
      children: [
        {
          name: 'codeforge-go-api-gateway',
          path: 'plugin/codeforge-go-api-gateway',
          type: 'directory',
          children: [
            {
              name: '.claude-plugin',
              path: 'plugin/codeforge-go-api-gateway/.claude-plugin',
              type: 'directory',
              children: [
                { name: 'plugin.json', path: 'plugin/codeforge-go-api-gateway/.claude-plugin/plugin.json', type: 'file' },
              ],
            },
            { name: 'README.md', path: 'plugin/codeforge-go-api-gateway/README.md', type: 'file' },
            {
              name: 'agents',
              path: 'plugin/codeforge-go-api-gateway/agents',
              type: 'directory',
              children: [
                { name: 'architect.md', path: 'plugin/codeforge-go-api-gateway/agents/architect.md', type: 'file' },
                { name: 'build-error-resolver.md', path: 'plugin/codeforge-go-api-gateway/agents/build-error-resolver.md', type: 'file' },
                { name: 'code-reviewer.md', path: 'plugin/codeforge-go-api-gateway/agents/code-reviewer.md', type: 'file' },
                { name: 'planner.md', path: 'plugin/codeforge-go-api-gateway/agents/planner.md', type: 'file' },
                { name: 'tdd-guide.md', path: 'plugin/codeforge-go-api-gateway/agents/tdd-guide.md', type: 'file' },
              ],
            },
            {
              name: 'commands',
              path: 'plugin/codeforge-go-api-gateway/commands',
              type: 'directory',
              children: [
                { name: 'build-fix.md', path: 'plugin/codeforge-go-api-gateway/commands/build-fix.md', type: 'file' },
                { name: 'code-review.md', path: 'plugin/codeforge-go-api-gateway/commands/code-review.md', type: 'file' },
                { name: 'phase.md', path: 'plugin/codeforge-go-api-gateway/commands/phase.md', type: 'file' },
                { name: 'plan.md', path: 'plugin/codeforge-go-api-gateway/commands/plan.md', type: 'file' },
                { name: 'tdd.md', path: 'plugin/codeforge-go-api-gateway/commands/tdd.md', type: 'file' },
                { name: 'verify.md', path: 'plugin/codeforge-go-api-gateway/commands/verify.md', type: 'file' },
              ],
            },
            {
              name: 'hooks',
              path: 'plugin/codeforge-go-api-gateway/hooks',
              type: 'directory',
              children: [
                { name: 'hooks.json', path: 'plugin/codeforge-go-api-gateway/hooks/hooks.json', type: 'file' },
              ],
            },
            {
              name: 'skills',
              path: 'plugin/codeforge-go-api-gateway/skills',
              type: 'directory',
              children: [
                {
                  name: 'build-fix',
                  path: 'plugin/codeforge-go-api-gateway/skills/build-fix',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-go-api-gateway/skills/build-fix/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'code-review',
                  path: 'plugin/codeforge-go-api-gateway/skills/code-review',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-go-api-gateway/skills/code-review/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'phase',
                  path: 'plugin/codeforge-go-api-gateway/skills/phase',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-go-api-gateway/skills/phase/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'plan',
                  path: 'plugin/codeforge-go-api-gateway/skills/plan',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-go-api-gateway/skills/plan/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'tdd',
                  path: 'plugin/codeforge-go-api-gateway/skills/tdd',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-go-api-gateway/skills/tdd/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'verify',
                  path: 'plugin/codeforge-go-api-gateway/skills/verify',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-go-api-gateway/skills/verify/SKILL.md', type: 'file' },
                  ],
                },
              ],
            },
          ],
        },
        { name: 'marketplace.json.example', path: 'plugin/marketplace.json.example', type: 'file' },
      ],
    },
];

export const goApiDemoFileContents: Record<string, string> = {
  '.claude/rules/common/coding-style.md': `# Coding Style Rules

## Naming Conventions

### Go Identifiers

- **Exported identifiers**: PascalCase — \`HandleCreateRoute\`, \`RateLimiter\`, \`JWTClaims\`
- **Unexported identifiers**: camelCase — \`validateToken\`, \`redisClient\`, \`circuitState\`
- **Acronyms**: Keep uppercase when exported, lowercase when unexported — \`HTTPHandler\`, \`jwtSecret\`, \`APIKey\`, \`urlPath\`
- **Interfaces**: Name by behavior, not with \`I\` prefix — \`Authenticator\`, \`RouteResolver\`, \`RateLimitStore\`
- **Single-method interfaces**: Use the \`-er\` suffix — \`Reader\`, \`Validator\`, \`Transformer\`

### Files and Packages

- **File names**: snake_case — \`rate_limiter.go\`, \`jwt_validator.go\`, \`circuit_breaker.go\`
- **Test files**: Append \`_test\` — \`rate_limiter_test.go\`, \`jwt_validator_test.go\`
- **Package names**: Short, lowercase, no underscores — \`handler\`, \`middleware\`, \`ratelimit\`, \`auth\`
- **Avoid stutter**: \`ratelimit.Limiter\` not \`ratelimit.RateLimiter\`

### Environment Variables

- **ALL_CAPS with underscores**: \`GATEWAY_PORT\`, \`REDIS_URL\`, \`JWT_PUBLIC_KEY_PATH\`, \`POSTGRES_DSN\`
- **Prefix with GATEWAY_**: All application-specific env vars use the \`GATEWAY_\` prefix

### Constants

- Use PascalCase for exported, camelCase for unexported — not ALL_CAPS
- Group related constants with \`iota\` when appropriate

\`\`\`go
// Correct
const (
    MaxRequestBodySize = 1 << 20 // 1MB
    defaultTimeout     = 30 * time.Second
)

// Incorrect
const MAX_REQUEST_BODY_SIZE = 1 << 20
\`\`\`

## File Structure

### Maximum File Length

- **Hard limit**: 300 lines per file
- If a file exceeds 300 lines, split by responsibility
- Prefer multiple focused files over one large file

### Standard File Layout

Order sections within a Go file as follows:

1. Package declaration
2. Imports (grouped and ordered — see below)
3. Constants
4. Package-level variables (minimize these)
5. Types (structs, interfaces)
6. Constructor functions (\`New...\`)
7. Methods (grouped by receiver type)
8. Unexported helper functions

\`\`\`go
package handler

import (
    "context"
    "net/http"

    "github.com/go-chi/chi/v5"
    "github.com/prometheus/client_golang/prometheus"

    "github.com/your-org/go-api-gateway/internal/model"
    "github.com/your-org/go-api-gateway/internal/service"
    "github.com/your-org/go-api-gateway/pkg/httputil"
)

const defaultPageSize = 50

// RouteHandler handles HTTP requests for route management.
type RouteHandler struct {
    routeService service.RouteService
    logger       *slog.Logger
}

// NewRouteHandler creates a RouteHandler with the given dependencies.
func NewRouteHandler(rs service.RouteService, logger *slog.Logger) *RouteHandler {
    return &RouteHandler{
        routeService: rs,
        logger:       logger,
    }
}

// ListRoutes returns all configured gateway routes.
func (h *RouteHandler) ListRoutes(w http.ResponseWriter, r *http.Request) {
    // ...
}
\`\`\`

## Import Ordering

Use three groups separated by blank lines, enforced by \`goimports\`:

\`\`\`go
import (
    // 1. Standard library
    "context"
    "fmt"
    "log/slog"
    "net/http"
    "time"

    // 2. Third-party packages
    "github.com/go-chi/chi/v5"
    "github.com/go-chi/chi/v5/middleware"
    "github.com/redis/go-redis/v9"
    "go.opentelemetry.io/otel/trace"

    // 3. Internal packages (this project)
    "github.com/your-org/go-api-gateway/internal/auth"
    "github.com/your-org/go-api-gateway/internal/model"
    "github.com/your-org/go-api-gateway/pkg/errors"
)
\`\`\`

- Never use dot imports (\`. "package"\`)
- Never use blank imports (\`_ "package"\`) except in \`main.go\` or test files for driver registration
- Alias imports only when there is a name collision

## Error Handling

### Always wrap errors with context using \`%w\`

\`\`\`go
// Correct
if err != nil {
    return fmt.Errorf("fetching route %s: %w", routeID, err)
}

// Incorrect — loses error chain
if err != nil {
    return fmt.Errorf("fetching route %s: %v", routeID, err)
}

// Incorrect — no context
if err != nil {
    return err
}
\`\`\`

### Use custom error types from \`pkg/errors\` for domain errors

\`\`\`go
if route == nil {
    return errors.NewNotFoundError("route", routeID)
}
\`\`\`

### Never ignore errors silently

\`\`\`go
// Incorrect
json.NewEncoder(w).Encode(response)

// Correct
if err := json.NewEncoder(w).Encode(response); err != nil {
    h.logger.ErrorContext(ctx, "failed to encode response", "error", err)
}
\`\`\`

## Context Propagation

- Every handler receives context from \`r.Context()\`
- Pass \`ctx\` as the first parameter to all downstream calls
- Never use \`context.Background()\` in request paths — only in \`main.go\` and initialization code
- Store request-scoped values (request ID, trace ID, user claims) in context via middleware

\`\`\`go
func (h *RouteHandler) GetRoute(w http.ResponseWriter, r *http.Request) {
    ctx := r.Context()
    routeID := chi.URLParam(r, "routeID")

    route, err := h.routeService.GetByID(ctx, routeID)
    if err != nil {
        httputil.RespondError(ctx, w, err)
        return
    }

    httputil.RespondJSON(ctx, w, http.StatusOK, route)
}
\`\`\`

## Struct Initialization

- Use named fields — never positional
- Use constructor functions (\`New...\`) that accept dependencies as interfaces

\`\`\`go
// Correct
limiter := ratelimit.NewSlidingWindowLimiter(ratelimit.Config{
    Store:    redisStore,
    Window:   time.Minute,
    MaxCount: 100,
    Logger:   logger,
})

// Incorrect — positional, unclear
limiter := ratelimit.NewSlidingWindowLimiter(redisStore, time.Minute, 100, logger)
\`\`\`

## Dependency Injection

- Accept interfaces, return structs
- Define interfaces in the package that uses them, not the package that implements them
- Keep interfaces small — prefer single-method interfaces

\`\`\`go
// Defined in internal/handler, not internal/service
type RouteService interface {
    GetByID(ctx context.Context, id string) (*model.Route, error)
    List(ctx context.Context, opts model.ListOptions) ([]model.Route, error)
}
\`\`\`

## Structured Logging

- Use \`log/slog\` exclusively — no \`log.Println\`, no \`fmt.Printf\` for logging
- Always pass context for trace correlation
- Use key-value pairs, not formatted strings

\`\`\`go
// Correct
h.logger.InfoContext(ctx, "route matched",
    "route_id", route.ID,
    "upstream", route.Upstream,
    "latency_ms", elapsed.Milliseconds(),
)

// Incorrect
h.logger.Info(fmt.Sprintf("route %s matched upstream %s in %dms", route.ID, route.Upstream, elapsed.Milliseconds()))
\`\`\`

## Middleware Style

- All middleware must follow the Chi \`func(next http.Handler) http.Handler\` pattern
- Middleware must be composable and order-independent where possible
- Document the middleware's position requirements if order matters

\`\`\`go
// RateLimit returns Chi middleware that enforces per-client rate limits.
func RateLimit(limiter *ratelimit.SlidingWindowLimiter) func(http.Handler) http.Handler {
    return func(next http.Handler) http.Handler {
        return http.HandlerFunc(func(w http.ResponseWriter, r *http.Request) {
            ctx := r.Context()
            clientID := auth.ClientIDFromContext(ctx)

            if !limiter.Allow(ctx, clientID) {
                httputil.RespondError(ctx, w, errors.NewRateLimitError(clientID))
                return
            }

            next.ServeHTTP(w, r)
        })
    }
}
\`\`\`

## Prohibited Patterns

- **No \`init()\` functions** — use explicit initialization in \`main.go\`
- **No global mutable state** — pass dependencies through constructors
- **No \`panic\` in library code** — return errors instead
- **No bare \`interface{}\`** — use \`any\` (Go 1.18+) when truly needed, prefer concrete types
- **No \`time.Sleep\` in production code** — use tickers, timers, or context deadlines
- **No hardcoded URLs, ports, or credentials** — use config via Viper/envconfig

## Doc Comments

- All exported functions, types, and constants must have doc comments
- Comments must start with the identifier name
- Use \`//\` style, not \`/* */\`

\`\`\`go
// SlidingWindowLimiter enforces rate limits using a Redis-backed sliding window algorithm.
type SlidingWindowLimiter struct { ... }

// Allow checks whether the given client is within their rate limit window.
// It returns true if the request should be allowed, false if rate limited.
func (l *SlidingWindowLimiter) Allow(ctx context.Context, clientID string) bool { ... }
\`\`\`

## Formatting

- Run \`gofmt\` and \`goimports\` on every save
- Enforced by \`golangci-lint\` in CI — see \`.github/workflows/\`
- No manual alignment of struct fields or comments — let the formatter handle it`,

  '.claude/rules/common/git-workflow.md': `# Git Workflow Rules

## Branch Strategy

This project uses **GitHub Flow** with a single protected \`main\` branch. All work happens on short-lived feature branches merged via pull requests.

### Branch Naming Convention

Format: \`type/ticket-desc\`

| Type | Purpose | Example |
|------|---------|---------|
| \`feat\` | New feature or capability | \`feat/GW-42-add-circuit-breaker\` |
| \`fix\` | Bug fix | \`fix/GW-87-redis-connection-leak\` |
| \`chore\` | Maintenance, deps, config | \`chore/GW-91-upgrade-chi-v5\` |
| \`docs\` | Documentation only | \`docs/GW-55-rate-limit-runbook\` |
| \`perf\` | Performance improvement | \`perf/GW-63-jwt-validation-cache\` |
| \`refactor\` | Code restructuring | \`refactor/GW-70-middleware-chain\` |
| \`test\` | Test additions or fixes | \`test/GW-78-handler-table-tests\` |

Rules:
- Always include the GitHub Issue number (e.g., \`GW-42\`)
- Use lowercase kebab-case for the description
- Keep descriptions short (3-5 words max)
- Branch from \`main\`, merge back to \`main\`

## Conventional Commits

Every commit message must follow the [Conventional Commits](https://www.conventionalcommits.org/) specification.

### Format

\`\`\`
type(scope): description

[optional body]

[optional footer(s)]
\`\`\`

### Types

- \`feat\` — New feature (correlates with MINOR in semver)
- \`fix\` — Bug fix (correlates with PATCH in semver)
- \`chore\` — Build process, dependencies, tooling
- \`docs\` — Documentation changes only
- \`perf\` — Performance improvement (no functional change)
- \`refactor\` — Code change that neither fixes a bug nor adds a feature
- \`test\` — Adding or correcting tests
- \`ci\` — CI/CD pipeline changes
- \`style\` — Formatting, goimports (no logic change)

### Scopes

Use the Go package or directory name as scope:

- \`handler\`, \`middleware\`, \`service\`, \`repository\`, \`model\`
- \`auth\`, \`ratelimit\`, \`circuit\`, \`config\`, \`observability\`
- \`httputil\`, \`errors\`
- \`docker\`, \`helm\`, \`terraform\`, \`ci\`

### Examples

\`\`\`
feat(ratelimit): implement sliding window algorithm with Redis

Uses EVALSHA with a Lua script for atomic sliding window rate
limiting. Supports per-client and per-route configuration.

Closes GW-42
\`\`\`

\`\`\`
fix(auth): handle expired JWT tokens with proper 401 response

Previously returned 500 when token expiry check failed due to
unchecked error from jwt.Parse. Now wraps error with %w and
returns structured JSON error response.

Fixes GW-87
\`\`\`

\`\`\`
perf(middleware): cache compiled route patterns in handler chain

Reduces per-request allocation by caching chi.RouteContext pattern
matching results. Benchmark shows 15% reduction in p99 latency.

Refs GW-63
\`\`\`

\`\`\`
chore(deps): upgrade go.opentelemetry.io/otel to v1.24.0
\`\`\`

\`\`\`
test(handler): add table-driven tests for health check endpoint
\`\`\`

### Commit Rules

- Use imperative mood: "add feature" not "added feature" or "adds feature"
- First line must be under 72 characters
- Reference the GitHub Issue number in the footer (\`Closes GW-XX\`, \`Fixes GW-XX\`, \`Refs GW-XX\`)
- Do not squash meaningful commit history — each commit should be a logical unit
- Never commit directly to \`main\`

## Pull Request Requirements

### Before Opening a PR

1. Rebase on latest \`main\`: \`git fetch origin && git rebase origin/main\`
2. Run the full local check suite:
   \`\`\`bash
   gofmt -l .
   goimports -l .
   golangci-lint run ./...
   go vet ./...
   go test -race -cover ./...
   \`\`\`
3. Ensure test coverage meets the 80% threshold
4. Verify no sensitive files are included (\`.env*\`, \`*.pem\`, production configs)

### PR Title

Must follow conventional commit format:
\`\`\`
feat(ratelimit): add per-client sliding window rate limiter
\`\`\`

### PR Description Template

Every PR must include:
- **What**: Summary of the change
- **Why**: Link to GitHub Issue and business context
- **How**: Brief technical approach
- **Testing**: What was tested and how (unit, integration, manual)
- **Observability**: Any new metrics, traces, or log fields added
- **Breaking Changes**: Any API contract or config changes

### Merge Requirements

All of the following must pass before merge:

| Requirement | Details |
|-------------|---------|
| **Code review** | At least 1 approval from a team member |
| **Lint passing** | \`golangci-lint run\` with project config (govet, errcheck, staticcheck, gosec, revive, gocyclo) |
| **Tests passing** | \`go test -race ./...\` — all unit and integration tests green |
| **Coverage threshold** | 80% minimum on changed packages |
| **CI pipeline green** | All GitHub Actions stages pass (lint, vet, test, race detection, build) |
| **No conflicts** | Branch must be up to date with \`main\` |
| **CODEOWNERS approval** | Required for sensitive paths (\`internal/auth/**\`, \`configs/production/**\`, \`deployments/**\`) |

### AI-Generated Code

When Claude Code generates or substantially modifies code:
- The PR description must include an \`AI-Assisted: Yes\` label
- Generated code must pass the same review standards as human-written code
- Reviewers should pay particular attention to security implications in \`internal/auth/**\`, \`internal/middleware/**\`, and \`internal/ratelimit/**\`

### Merge Strategy

- Use **squash merge** for single-purpose PRs (most common)
- Use **merge commit** for PRs with multiple meaningful commits that tell a story
- Delete the branch after merge

## Protected Branch: main

The \`main\` branch has the following protections:

- Direct pushes are blocked
- Force pushes are blocked
- Branch deletion is blocked
- All PR merge requirements (above) are enforced
- Status checks must pass before merge
- Stale approvals are dismissed on new pushes

## Workflow for Claude Code

When working on a task:

1. Confirm the GitHub Issue number and understand the scope
2. Create a branch following the naming convention: \`git checkout -b feat/GW-XX-short-desc\`
3. Make focused, atomic commits with conventional commit messages
4. Keep changes within the scope of the ticket — open new issues for tangential work
5. Run linting and tests before every commit
6. Open a PR with a complete description when the work is ready for review
7. Address review feedback in additional commits (do not force-push during review)
8. After approval, squash merge and delete the branch

## Sensitive Paths Requiring Extra Review

Changes to these paths require CODEOWNERS approval and security-focused review:

- \`internal/auth/**\` — JWT validation, API key verification, RBAC logic
- \`configs/production/**\` — Production configuration
- \`deployments/**\` — Kubernetes manifests, Helm values, Terraform
- \`*.pem\` — Should never be committed; reject immediately
- \`.env*\` — Should never be committed; reject immediately
- \`.github/workflows/**\` — CI/CD pipeline definitions
- \`internal/middleware/auth*.go\` — Authentication middleware
- \`internal/ratelimit/**\` — Rate limiting (abuse prevention)`,

  '.claude/rules/common/security.md': `# Security Rules — go-api-gateway

## SOC 2 Compliance Requirements

- All authentication and authorization decisions must be logged with structured slog output including request ID, client ID, action, and outcome
- Audit logs must never be suppressed, filtered, or written to stdout only — use a persistent sink (CloudWatch, S3)
- Access to production configuration, secrets, and PEM files requires documented approval
- Changes to \`internal/auth/**\`, \`config/production/**\`, \`*.pem\`, and \`.env*\` files require review from a CODEOWNERS-designated security reviewer
- Retain access logs for a minimum of 90 days in immutable storage
- Document all third-party dependencies and their security posture in \`docs/dependencies.md\`

## OWASP API Security Top 10 Enforcement

### API1 — Broken Object Level Authorization
- Every handler in \`internal/handler/\` must validate that the authenticated client has access to the requested resource
- Never rely solely on client-supplied IDs — cross-reference with the authenticated identity from context
- Use middleware in \`internal/middleware/authz.go\` to enforce RBAC before reaching handlers

### API2 — Broken Authentication
- JWT tokens must use RS256 exclusively — reject HS256 and \`none\` algorithm in \`internal/auth/jwt.go\`
- Validate \`iss\`, \`aud\`, \`exp\`, and \`nbf\` claims on every request
- API keys must be compared using \`crypto/subtle.ConstantTimeCompare\` to prevent timing attacks
- Reject tokens with excessive lifetimes (configurable max, default 1 hour)

### API3 — Broken Object Property Level Authorization
- Response transformation middleware must strip internal fields before forwarding to clients
- Never expose database IDs, internal service names, or infrastructure details in responses

### API4 — Unrestricted Resource Consumption
- Rate limiting is mandatory on all public endpoints via \`internal/ratelimit/\`
- Configure per-client, per-endpoint, and global rate limits in \`configs/*.yaml\`
- Request body size limits must be enforced in middleware (default: 1MB, configurable)
- Set timeouts on all upstream HTTP calls — no unbounded waits

### API5 — Broken Function Level Authorization
- Admin endpoints (\`/admin/**\`, \`/internal/**\`) must require elevated RBAC roles
- Separate middleware chains for public, authenticated, and admin routes in \`internal/handler/router.go\`

### API6 — Unrestricted Access to Sensitive Business Flows
- Implement progressive rate limiting for sensitive operations (login, token refresh, key generation)
- Log and alert on anomalous patterns (burst requests from single client, credential stuffing signatures)

### API7 — Server Side Request Forgery (SSRF)
- Upstream service URLs must come from configuration only — never from request parameters
- Validate and allowlist all backend service addresses in \`internal/config/\`
- Block requests to private IP ranges (10.x, 172.16-31.x, 192.168.x, 169.254.x) in outbound calls

### API8 — Security Misconfiguration
- Never run the gateway as root in Docker — use a non-root user in \`deployments/Dockerfile\`
- Disable debug endpoints and pprof in production builds
- Set security headers in response middleware: \`X-Content-Type-Options\`, \`X-Frame-Options\`, \`Strict-Transport-Security\`, \`X-Request-Id\`
- Remove \`Server\` header from all responses

### API9 — Improper Inventory Management
- All exposed routes must be documented in \`docs/api.md\`
- Deprecated endpoints must return \`Deprecation\` and \`Sunset\` headers before removal
- Shadow or test routes must never exist in production configuration

### API10 — Unsafe Consumption of APIs
- Validate and sanitize all responses from upstream services before forwarding to clients
- Enforce TLS verification on all outbound connections to backend services
- Set reasonable timeouts and circuit breakers on every upstream via \`internal/circuit/\`

## TLS and Transport Security

- TLS termination happens at the ALB — the gateway must verify it is only receiving traffic from the ALB (security group enforcement)
- All outbound connections to Redis (ElastiCache), PostgreSQL (RDS), and upstream services must use TLS
- Configure minimum TLS 1.2 for any direct TLS listeners
- Certificate files (\`*.pem\`) must never be committed to the repository — load from AWS Secrets Manager or environment
- mTLS between gateway and internal services is recommended for production

## API Key Management

- API keys must be stored as bcrypt or argon2id hashes in PostgreSQL — never in plaintext
- Key metadata (client ID, scopes, rate limit tier, created/rotated timestamps) lives in \`internal/repository/apikey.go\`
- Implement key rotation: clients can have multiple active keys during a rotation window
- Expired or revoked keys must return \`401\` immediately — check against Redis cache before hitting PostgreSQL
- Log all key creation, rotation, and revocation events with client identity
- Key prefixes (e.g., \`gw_live_\`, \`gw_test_\`) must distinguish environments and are not secret

## Secrets Handling

- Use Viper + envconfig to load secrets from environment variables — never from config YAML files
- Required secrets: \`JWT_PUBLIC_KEY_PATH\`, \`DATABASE_URL\`, \`REDIS_URL\`, \`API_KEY_ENCRYPTION_KEY\`
- Secrets must not appear in logs — configure slog sanitization in \`internal/observability/logging.go\`
- Use \`**/*.pem\`, \`.env*\`, \`configs/production/*\` in \`.gitignore\`
- Rotate secrets on a documented schedule (minimum quarterly for SOC 2)

## Input Validation

- Validate \`Content-Type\` header before parsing request bodies
- Reject unknown or unexpected query parameters on strict endpoints
- Sanitize all values written to logs to prevent log injection (newlines, control characters)
- Use \`net/http.MaxBytesReader\` to enforce body size limits before JSON decoding
- Validate JWT \`kid\` header against known key IDs before attempting verification

## Error Handling and Information Disclosure

- Production error responses must use generic messages with error codes — never expose stack traces, SQL errors, or internal paths
- Use custom error types from \`pkg/errors/\` with codes like \`ErrUnauthorized\`, \`ErrRateLimited\`, \`ErrUpstreamTimeout\`
- Log full error details server-side with slog at appropriate levels; return sanitized errors to clients
- Return consistent error response format:
  \`\`\`json
  {"error": {"code": "RATE_LIMITED", "message": "Too many requests", "request_id": "abc-123"}}
  \`\`\`

## Dependency Security

- Run \`govulncheck ./...\` in CI on every pull request
- Pin all dependency versions in \`go.mod\` — no floating versions
- Review new dependencies for security posture before adding (check maintainership, CVE history, license)
- Minimize dependency surface — prefer stdlib where feasible (e.g., \`net/http\`, \`crypto/*\`, \`encoding/json\`)
- Scan Docker images with Trivy in the CI pipeline before pushing to ECR

## Security Testing

- Write tests in \`tests/security_test.go\` for:
  - Expired JWT rejection
  - Invalid signature rejection
  - Algorithm confusion attacks (HS256 token with RS256 config)
  - Rate limit enforcement under load
  - Missing auth header returns 401
  - Forbidden role returns 403
  - Oversized request body rejection
- Run \`gosec\` via golangci-lint on every commit
- Perform load testing with security scenarios using scripts in \`scripts/\`

## Incident Response

- If a key compromise is suspected, the revocation endpoint must invalidate the key in Redis immediately (sub-second propagation)
- Circuit breakers in \`internal/circuit/\` must open on repeated 401/403 from upstream (possible credential leak)
- Alert on sudden spikes in 401/403 rates via Prometheus alerting rules
- Document incident response runbooks in \`docs/runbooks/security-incident.md\``,

  '.claude/rules/common/testing.md': `# Testing Standards — Go API Gateway

## Test Organization

All tests live alongside the code they test in \`_test.go\` files. Integration and E2E tests live in \`tests/\`. Never mix unit and integration tests in the same file.

\`\`\`
internal/handler/route_handler_test.go      # Unit tests for handler
internal/service/routing_service_test.go    # Unit tests for service
internal/ratelimit/sliding_window_test.go   # Unit tests for rate limiter
tests/integration/auth_flow_test.go         # Integration tests
tests/integration/ratelimit_test.go         # Integration with Redis
tests/e2e/gateway_routing_test.go           # Full E2E through the gateway
\`\`\`

## Table-Driven Tests Are Mandatory

Every test function must use table-driven format. No exceptions. This is the canonical Go testing pattern and is enforced in code review.

\`\`\`go
func TestJWTValidator_Validate(t *testing.T) {
	t.Parallel()

	tests := []struct {
		name        string
		token       string
		wantClaims  *model.Claims
		wantErr     error
		description string
	}{
		{
			name:        "valid token with admin role",
			token:       generateTestToken(t, "admin", time.Hour),
			wantClaims:  &model.Claims{Role: "admin"},
			wantErr:     nil,
			description: "should parse and validate a well-formed RS256 JWT",
		},
		{
			name:        "expired token",
			token:       generateTestToken(t, "user", -time.Hour),
			wantClaims:  nil,
			wantErr:     auth.ErrTokenExpired,
			description: "should reject tokens past their exp claim",
		},
		{
			name:        "empty token",
			token:       "",
			wantClaims:  nil,
			wantErr:     auth.ErrTokenMissing,
			description: "should return ErrTokenMissing for empty string",
		},
		{
			name:        "malformed token",
			token:       "not.a.jwt",
			wantClaims:  nil,
			wantErr:     auth.ErrTokenMalformed,
			description: "should reject tokens that fail parsing",
		},
	}

	for _, tt := range tests {
		t.Run(tt.name, func(t *testing.T) {
			t.Parallel()

			validator := auth.NewJWTValidator(testPublicKey)
			claims, err := validator.Validate(context.Background(), tt.token)

			if tt.wantErr != nil {
				require.ErrorIs(t, err, tt.wantErr)
				assert.Nil(t, claims)
				return
			}

			require.NoError(t, err)
			assert.Equal(t, tt.wantClaims.Role, claims.Role)
		})
	}
}
\`\`\`

### Table-Driven Test Rules

- Name the slice \`tests\` (not \`testCases\`, \`cases\`, or \`tc\`)
- Each entry must have a \`name\` field used in \`t.Run\`
- Call \`t.Parallel()\` at both the top level and inside each \`t.Run\` subtest
- Use \`require\` for fatal assertions (stops the subtest), \`assert\` for non-fatal
- Keep test names lowercase, descriptive, and hyphen-free: \`"valid token with admin role"\` not \`"Valid-Token-Admin"\`
- Struct fields should follow the pattern: inputs first, then \`want*\` fields, then optional \`description\`

## Coverage Requirements

| Package | Minimum Coverage | Rationale |
|---|---|---|
| \`internal/auth/**\` | 90% | Security-critical, SOC 2 audit scope |
| \`internal/ratelimit/**\` | 90% | Core gateway functionality |
| \`internal/middleware/**\` | 85% | Request pipeline correctness |
| \`internal/handler/**\` | 80% | HTTP layer with httptest |
| \`internal/service/**\` | 85% | Business logic |
| \`internal/repository/**\` | 70% | Data access (integration tests supplement) |
| \`internal/circuit/**\` | 85% | Reliability-critical |
| \`pkg/**\` | 80% | Shared utilities |
| **Overall project** | **80%** | Enforced in CI |

Run coverage locally:

\`\`\`bash
go test -coverprofile=coverage.out -covermode=atomic ./...
go tool cover -func=coverage.out
go tool cover -html=coverage.out -o coverage.html
\`\`\`

CI enforces the threshold. PRs that drop coverage below 80% are blocked.

## Test Categories

### Unit Tests

Unit tests have zero external dependencies. Use interfaces and mocks for all I/O boundaries.

\`\`\`go
// Mock the repository interface — do not hit PostgreSQL or Redis
type mockRouteRepository struct {
	routes map[string]*model.Route
	err    error
}

func (m *mockRouteRepository) FindByPath(ctx context.Context, path string) (*model.Route, error) {
	if m.err != nil {
		return nil, m.err
	}
	route, ok := m.routes[path]
	if !ok {
		return nil, repository.ErrRouteNotFound
	}
	return route, nil
}
\`\`\`

Unit test rules:
- Must complete in under 5 seconds per package
- No network calls, no file system writes, no database connections
- Use \`t.TempDir()\` if file system access is truly needed
- Mock interfaces, not concrete types
- Test one behavior per subtest

### HTTP Handler Tests

Use \`net/http/httptest\` for all handler tests. Test through the Chi router to validate middleware chains and route parameters.

\`\`\`go
func TestHealthHandler_Liveness(t *testing.T) {
	t.Parallel()

	tests := []struct {
		name       string
		dbHealthy  bool
		wantStatus int
		wantBody   string
	}{
		{
			name:       "all dependencies healthy",
			dbHealthy:  true,
			wantStatus: http.StatusOK,
			wantBody:   \`{"status":"ok"}\`,
		},
		{
			name:       "database unhealthy",
			dbHealthy:  false,
			wantStatus: http.StatusServiceUnavailable,
			wantBody:   \`{"status":"degraded","checks":{"database":"unhealthy"}}\`,
		},
	}

	for _, tt := range tests {
		t.Run(tt.name, func(t *testing.T) {
			t.Parallel()

			healthSvc := &mockHealthService{dbHealthy: tt.dbHealthy}
			h := handler.NewHealthHandler(healthSvc)

			r := chi.NewRouter()
			r.Get("/healthz", h.Liveness)

			req := httptest.NewRequest(http.MethodGet, "/healthz", nil)
			rec := httptest.NewRecorder()

			r.ServeHTTP(rec, req)

			assert.Equal(t, tt.wantStatus, rec.Code)
			assert.JSONEq(t, tt.wantBody, rec.Body.String())
		})
	}
}
\`\`\`

### Middleware Tests

Test middleware in isolation using a simple \`http.HandlerFunc\` as the next handler. Verify the middleware modifies the request/response correctly.

\`\`\`go
func TestRateLimitMiddleware(t *testing.T) {
	t.Parallel()

	tests := []struct {
		name         string
		requests     int
		limit        int
		wantBlocked  int
		wantHeader   string
	}{
		{
			name:        "under limit",
			requests:    5,
			limit:       10,
			wantBlocked: 0,
			wantHeader:  "5",
		},
		{
			name:        "at limit",
			requests:    10,
			limit:       10,
			wantBlocked: 0,
			wantHeader:  "0",
		},
		{
			name:        "over limit",
			requests:    15,
			limit:       10,
			wantBlocked: 5,
			wantHeader:  "0",
		},
	}

	for _, tt := range tests {
		t.Run(tt.name, func(t *testing.T) {
			t.Parallel()

			limiter := &mockRateLimiter{limit: tt.limit}
			mw := middleware.RateLimit(limiter)

			blocked := 0
			next := http.HandlerFunc(func(w http.ResponseWriter, r *http.Request) {
				w.WriteHeader(http.StatusOK)
			})

			for i := 0; i < tt.requests; i++ {
				req := httptest.NewRequest(http.MethodGet, "/", nil)
				req.RemoteAddr = "192.168.1.1:1234"
				rec := httptest.NewRecorder()

				mw(next).ServeHTTP(rec, req)

				if rec.Code == http.StatusTooManyRequests {
					blocked++
				}
			}

			assert.Equal(t, tt.wantBlocked, blocked)
		})
	}
}
\`\`\`

### Integration Tests

Integration tests require external services (PostgreSQL, Redis). They are tagged and run separately.

\`\`\`go
//go:build integration

package integration_test

import (
	"context"
	"testing"

	"github.com/stretchr/testify/require"
	"go-api-gateway/internal/ratelimit"
	"go-api-gateway/internal/repository"
)

func TestRateLimiter_SlidingWindow_Redis(t *testing.T) {
	if testing.Short() {
		t.Skip("skipping integration test in short mode")
	}

	redisClient := setupTestRedis(t)
	t.Cleanup(func() { redisClient.FlushDB(context.Background()) })

	limiter := ratelimit.NewSlidingWindowLimiter(redisClient, ratelimit.Config{
		Window: time.Minute,
		Limit:  100,
	})

	tests := []struct {
		name      string
		clientID  string
		requests  int
		wantAllow int
	}{
		{
			name:      "allows requests within window",
			clientID:  "client-a",
			requests:  50,
			wantAllow: 50,
		},
		{
			name:      "blocks after limit exceeded",
			clientID:  "client-b",
			requests:  150,
			wantAllow: 100,
		},
	}

	for _, tt := range tests {
		t.Run(tt.name, func(t *testing.T) {
			allowed := 0
			for i := 0; i < tt.requests; i++ {
				ok, err := limiter.Allow(context.Background(), tt.clientID)
				require.NoError(t, err)
				if ok {
					allowed++
				}
			}
			assert.Equal(t, tt.wantAllow, allowed)
		})
	}
}
\`\`\`

Integration test rules:
- Use build tag \`//go:build integration\` at the top of the file
- Also check \`testing.Short()\` as a secondary guard
- Use \`t.Cleanup()\` to tear down test data — never leave state in shared databases
- Use \`testcontainers-go\` or Docker Compose for local integration test infrastructure
- Integration tests run in CI after unit tests pass

Run integration tests:

\`\`\`bash
# Local with Docker
docker compose -f docker-compose.test.yml up -d
go test -tags=integration -count=1 ./tests/integration/...

# Short mode skips integration tests
go test -short ./...
\`\`\`

### E2E Tests

E2E tests spin up the full gateway binary and send real HTTP requests through it.

\`\`\`bash
go test -tags=e2e -count=1 -timeout=120s ./tests/e2e/...
\`\`\`

E2E tests validate:
- Full request routing through the gateway to mock upstream services
- JWT authentication end-to-end
- Rate limiting with real Redis
- Circuit breaker tripping and recovery
- Health check endpoints
- Graceful shutdown behavior

## Test Helpers and Fixtures

Place shared test helpers in a \`testutil\` package or as unexported helpers in \`_test.go\` files.

\`\`\`go
// internal/auth/testutil_test.go (only visible to auth package tests)

func generateTestToken(t *testing.T, role string, expiry time.Duration) string {
	t.Helper()

	claims := jwt.MapClaims{
		"sub":  "test-user-123",
		"role": role,
		"exp":  time.Now().Add(expiry).Unix(),
		"iat":  time.Now().Unix(),
	}

	token := jwt.NewWithClaims(jwt.SigningMethodRS256, claims)
	signed, err := token.SignedString(testPrivateKey)
	require.NoError(t, err)

	return signed
}
\`\`\`

Rules for test helpers:
- Always call \`t.Helper()\` as the first line — this fixes stack traces
- Test helpers must never call \`t.Fatal\` or \`t.FailNow\` unless they are setup functions
- Use \`t.Helper()\` on any function that takes \`*testing.T\` and is not a test itself
- Place test fixtures (JSON files, PEM keys) in \`testdata/\` directories — Go tooling ignores these

## Context Propagation in Tests

All functions that accept \`context.Context\` must be tested with context scenarios:

\`\`\`go
{
	name:    "cancelled context",
	ctx:     cancelledCtx(t),
	wantErr: context.Canceled,
},
{
	name:    "deadline exceeded",
	ctx:     timedOutCtx(t),
	wantErr: context.DeadlineExceeded,
},
\`\`\`

## Error Testing

Test both error types and error wrapping chains:

\`\`\`go
// Test error identity
require.ErrorIs(t, err, repository.ErrRouteNotFound)

// Test error type
var apiErr *errors.APIError
require.ErrorAs(t, err, &apiErr)
assert.Equal(t, http.StatusNotFound, apiErr.StatusCode)

// Test error message contains useful context
assert.Contains(t, err.Error(), "route /api/v1/users")
\`\`\`

## Race Detection

All unit tests run with the race detector in CI:

\`\`\`bash
go test -race -count=1 ./...
\`\`\`

Write tests that exercise concurrent access patterns, especially for:
- Rate limiter shared state
- Circuit breaker state transitions
- Connection pool access
- In-memory cache reads/writes

\`\`\`go
func TestCircuitBreaker_ConcurrentAccess(t *testing.T) {
	t.Parallel()

	cb := circuit.NewBreaker(circuit.Config{
		Threshold:   5,
		Timeout:     time.Second,
	})

	var wg sync.WaitGroup
	for i := 0; i < 100; i++ {
		wg.Add(1)
		go func() {
			defer wg.Done()
			_ = cb.Execute(context.Background(), func() error {
				return nil
			})
		}()
	}
	wg.Wait()

	assert.Equal(t, circuit.StateClosed, cb.State())
}
\`\`\`

## Benchmark Tests

Write benchmarks for performance-critical paths. These run in CI on a schedule (not on every PR) and results are tracked over time.

\`\`\`go
func BenchmarkRateLimiter_Allow(b *testing.B) {
	limiter := ratelimit.NewInMemoryLimiter(ratelimit.Config{
		Window: time.Minute,
		Limit:  10000,
	})

	ctx := context.Background()

	b.ResetTimer()
	b.RunParallel(func(pb *testing.PB) {
		for pb.Next() {
			_, _ = limiter.Allow(ctx, "bench-client")
		}
	})
}

func BenchmarkJWTValidation(b *testing.B) {
	validator := auth.NewJWTValidator(testPublicKey)
	token := generateBenchToken(b)

	ctx := context.Background()

	b.ResetTimer()
	for i := 0; i < b.N; i++ {
		_, _ = validator.Validate(ctx, token)
	}
}
\`\`\`

Run benchmarks:

\`\`\`bash
go test -bench=. -benchmem -count=5 ./internal/ratelimit/...
go test -bench=. -benchmem -count=5 ./internal/auth/...
\`\`\`

Benchmark targets for the gateway hot path:
- JWT validation: < 50µs per operation
- Rate limit check (in-memory): < 1µs per operation
- Rate limit check (Redis): < 500µs per operation
- Request routing: < 10µs per operation

## Profiling in Tests

Use \`testing.B\` with pprof for profiling:

\`\`\`bash
go test -bench=BenchmarkRateLimiter_Allow -cpuprofile=cpu.prof -memprofile=mem.prof ./internal/ratelimit/...
go tool pprof -http=:8080 cpu.prof
\`\`\`

## Test Naming Convention

\`\`\`
Test<Type>_<Method>                         # TestJWTValidator_Validate
Test<Type>_<Method>_<Scenario>              # TestCircuitBreaker_Execute_OpenState
Benchmark<Type>_<Method>                    # BenchmarkRateLimiter_Allow
\`\`\`

## What Claude Must Do When Writing Tests

1. Always use table-driven tests — no standalone assertion blocks
2. Always call \`t.Parallel()\` at both levels (test function and subtests)
3. Always use \`t.Helper()\` in helper functions
4. Use \`require\` for preconditions, \`assert\` for verifications
5. Test error paths as thoroughly as success paths
6. Include context cancellation tests for any function accepting \`context.Context\`
7. Mock at interface boundaries — never mock concrete types
8. Use \`httptest.NewRequest\` and \`httptest.NewRecorder\` for HTTP tests
9. Mount handlers on a \`chi.NewRouter()\` to test routing and middleware integration
10. Never use \`time.Sleep\` in tests — use channels, \`sync.WaitGroup\`, or \`testify/assert.Eventually\`
11. Clean up resources with \`t.Cleanup()\`, not \`defer\` in test setup functions
12. Tag integration tests with \`//go:build integration\`

## CI Test Pipeline

Tests execute in this order in GitHub Actions:

1. \`go vet ./...\` — static analysis
2. \`golangci-lint run\` — comprehensive linting
3. \`go test -race -short -coverprofile=coverage.out ./...\` — unit tests with race detection
4. Coverage threshold check (fail if < 80%)
5. \`go test -tags=integration -count=1 ./tests/integration/...\` — integration tests against Docker services
6. \`go test -tags=e2e -count=1 -timeout=120s ./tests/e2e/...\` — E2E tests against staging`,

  '.claude/rules/go/coding-style.md': `# Go Coding Style — go-api-gateway

## Effective Go Compliance

Follow [Effective Go](https://go.dev/doc/effective_go) and [Go Code Review Comments](https://github.com/golang/go/wiki/CodeReviewComments) as baseline standards. This document extends those with project-specific conventions.

## Naming

- **Files**: \`snake_case.go\` — e.g., \`rate_limiter.go\`, \`jwt_validator.go\`, \`health_check.go\`
- **Test files**: \`snake_case_test.go\` — always colocated with the source file
- **Exported identifiers**: \`PascalCase\` — \`RateLimiter\`, \`ValidateJWT\`, \`NewRouteHandler\`
- **Unexported identifiers**: \`camelCase\` — \`tokenCache\`, \`parseClaimsFromHeader\`, \`redisPool\`
- **Environment variables**: \`ALL_CAPS\` — \`GATEWAY_PORT\`, \`REDIS_URL\`, \`JWT_PUBLIC_KEY_PATH\`
- **Constants**: \`PascalCase\` for exported, \`camelCase\` for unexported — never \`ALL_CAPS\` for Go constants
- **Acronyms**: Keep consistent casing — \`HTTPHandler\`, \`JWTValidator\`, \`APIKey\`, not \`HttpHandler\`, \`JwtValidator\`, \`ApiKey\`
- **Receiver names**: Short, one or two letters, consistent across methods — \`func (rl *RateLimiter) Allow(...)\`, not \`func (rateLimiter *RateLimiter) Allow(...)\`

## Package Design

- Package names are lowercase, single-word when possible — \`handler\`, \`middleware\`, \`auth\`, \`ratelimit\`
- No \`util\` or \`common\` packages in \`internal/\` — use specific names like \`httputil\` (which lives in \`pkg/\`)
- Each package in \`internal/\` maps to a Clean Architecture layer:
  - \`handler\` → interface adapters (HTTP)
  - \`service\` → use cases / business logic
  - \`repository\` → data access
  - \`model\` → domain entities and DTOs
- Do not import \`handler\` from \`service\` or \`repository\` — dependencies flow inward only
- Avoid circular imports by defining interfaces in the consumer package

## Doc Comments

All exported functions, types, methods, and constants must have doc comments:

\`\`\`go
// RateLimiter enforces per-client request rate limits using a Redis-backed
// sliding window algorithm. It is safe for concurrent use.
type RateLimiter struct { ... }

// Allow checks whether the given client identified by key is within its
// rate limit. It returns true if the request should proceed, or false
// with a RetryAfter duration if the limit has been exceeded.
func (rl *RateLimiter) Allow(ctx context.Context, key string) (bool, time.Duration, error) { ... }
\`\`\`

Start doc comments with the identifier name. Use complete sentences. Explain behavior, not implementation.

## Error Handling

### Always wrap errors with context using \`%w\`

\`\`\`go
// Good — preserves the error chain and adds context
route, err := s.repo.FindRoute(ctx, path)
if err != nil {
    return nil, fmt.Errorf("find route for path %q: %w", path, err)
}

// Bad — loses the original error
if err != nil {
    return nil, fmt.Errorf("failed to find route: %s", err)
}

// Bad — returns bare error with no context
if err != nil {
    return nil, err
}
\`\`\`

### Use custom error types from \`pkg/errors/\` for domain errors

\`\`\`go
import gwerrors "github.com/yourorg/go-api-gateway/pkg/errors"

if client == nil {
    return gwerrors.NewNotFoundError("client", clientID)
}

if !limiter.Allow(ctx, clientID) {
    return gwerrors.NewRateLimitError(clientID, retryAfter)
}
\`\`\`

### Use \`errors.Is\` and \`errors.As\` for checking — never compare error strings

\`\`\`go
// Good
if errors.Is(err, repository.ErrRouteNotFound) {
    return gwerrors.NewNotFoundError("route", path)
}

var pgErr *pgconn.PgError
if errors.As(err, &pgErr) && pgErr.Code == "23505" {
    return gwerrors.NewConflictError("api_key", key)
}

// Bad
if err.Error() == "route not found" { ... }
if strings.Contains(err.Error(), "duplicate key") { ... }
\`\`\`

### Sentinel errors are declared as package-level variables

\`\`\`go
// ErrRouteNotFound is returned when no route matches the requested path.
var ErrRouteNotFound = errors.New("route not found")

// ErrTokenExpired is returned when a JWT has passed its expiration time.
var ErrTokenExpired = errors.New("token expired")
\`\`\`

## Interfaces

### Define interfaces in the consumer, not the implementer

\`\`\`go
// In internal/service/routing.go — the service defines what it needs
type RouteRepository interface {
    FindRoute(ctx context.Context, path string) (*model.Route, error)
    ListRoutes(ctx context.Context) ([]model.Route, error)
}

type RoutingService struct {
    repo   RouteRepository  // depends on the interface
    cache  CacheStore       // depends on the interface
    logger *slog.Logger
}
\`\`\`

### Keep interfaces small — prefer 1-3 methods

\`\`\`go
// Good — focused interface
type TokenValidator interface {
    Validate(ctx context.Context, token string) (*model.Claims, error)
}

// Good — single-purpose
type HealthChecker interface {
    Check(ctx context.Context) error
}

// Bad — too broad, hard to mock, hard to implement
type AuthService interface {
    ValidateJWT(ctx context.Context, token string) (*model.Claims, error)
    ValidateAPIKey(ctx context.Context, key string) (*model.Client, error)
    CreateAPIKey(ctx context.Context, clientID string) (string, error)
    RevokeAPIKey(ctx context.Context, key string) error
    ListPermissions(ctx context.Context, role string) ([]string, error)
    // ... 10 more methods
}
\`\`\`

### Accept interfaces, return structs

\`\`\`go
// Good — accepts interface, returns concrete type
func NewRoutingService(repo RouteRepository, cache CacheStore, logger *slog.Logger) *RoutingService {
    return &RoutingService{repo: repo, cache: cache, logger: logger}
}

// Bad — returns interface (hides the concrete type unnecessarily)
func NewRoutingService(repo RouteRepository) RouteRepository { ... }
\`\`\`

## Structured Logging with slog

### Use \`slog.Logger\` everywhere — no \`log\` stdlib, no \`fmt.Println\`

\`\`\`go
// Create loggers with context in constructors
type RateLimitMiddleware struct {
    limiter ratelimit.Limiter
    logger  *slog.Logger
}

func NewRateLimitMiddleware(limiter ratelimit.Limiter, logger *slog.Logger) *RateLimitMiddleware {
    return &RateLimitMiddleware{
        limiter: limiter,
        logger:  logger.With("component", "middleware.ratelimit"),
    }
}
\`\`\`

### Use structured key-value pairs — never string interpolation in log messages

\`\`\`go
// Good — structured, queryable, consistent
s.logger.InfoContext(ctx, "request routed",
    "method", r.Method,
    "path", r.URL.Path,
    "upstream", upstream.URL,
    "duration_ms", elapsed.Milliseconds(),
    "trace_id", trace.SpanFromContext(ctx).SpanContext().TraceID().String(),
)

s.logger.ErrorContext(ctx, "upstream request failed",
    "upstream", upstream.URL,
    "status", resp.StatusCode,
    "error", err,
    "client_id", clientID,
)

// Bad — unstructured, impossible to query
s.logger.Info(fmt.Sprintf("Routed %s %s to %s in %dms", r.Method, r.URL.Path, upstream, elapsed))
\`\`\`

### Log levels

- \`Debug\` — detailed internal state, cache hits/misses, token parsing steps
- \`Info\` — request routed, client authenticated, config reloaded, circuit state change
- \`Warn\` — rate limit approaching, upstream slow response, deprecated API version used
- \`Error\` — upstream failure, authentication failure, database error, circuit open

### Always pass context to log calls for trace correlation

\`\`\`go
// Good — enables trace ID extraction from context
s.logger.InfoContext(ctx, "jwt validated", "sub", claims.Subject, "roles", claims.Roles)

// Bad — loses trace context
s.logger.Info("jwt validated", "sub", claims.Subject)
\`\`\`

### Never log secrets, tokens, or PII

\`\`\`go
// Good — log the client ID, not the key
s.logger.InfoContext(ctx, "api key authenticated", "client_id", client.ID)

// Bad — leaks the API key
s.logger.Info("authenticated", "api_key", apiKey)

// Bad — leaks JWT
s.logger.Info("token received", "token", tokenString)
\`\`\`

## Context Propagation

Every handler, service method, and repository method must accept \`context.Context\` as the first parameter:

\`\`\`go
func (s *RoutingService) RouteRequest(ctx context.Context, req *model.IncomingRequest) (*model.RouteResult, error) { ... }
func (r *PostgresRouteRepo) FindRoute(ctx context.Context, path string) (*model.Route, error) { ... }
func (c *RedisCache) Get(ctx context.Context, key string) ([]byte, error) { ... }
\`\`\`

Pass the request context through the entire call chain — this enables distributed tracing with OpenTelemetry, request-scoped logging, and proper cancellation/timeout handling.

## Middleware Pattern

All middleware must follow the Chi middleware signature:

\`\`\`go
// LoggingMiddleware returns a Chi-compatible middleware that logs request details.
func LoggingMiddleware(logger *slog.Logger) func(http.Handler) http.Handler {
    return func(next http.Handler) http.Handler {
        return http.HandlerFunc(func(w http.ResponseWriter, r *http.Request) {
            start := time.Now()
            ww := middleware.NewWrapResponseWriter(w, r.ProtoMajor)

            defer func() {
                logger.InfoContext(r.Context(), "request completed",
                    "method", r.Method,
                    "path", r.URL.Path,
                    "status", ww.Status(),
                    "bytes", ww.BytesWritten(),
                    "duration_ms", time.Since(start).Milliseconds(),
                )
            }()

            next.ServeHTTP(ww, r)
        })
    }
}
\`\`\`

Middleware must be composable — no side effects on registration, no global state.

## Constructor Pattern

Use \`New*\` constructors for all types that require initialization. Validate inputs and return errors when construction can fail:

\`\`\`go
// NewGateway creates a configured Gateway instance. It returns an error if
// required dependencies are nil or configuration is invalid.
func NewGateway(cfg *config.Config, logger *slog.Logger, db *pgxpool.Pool, rdb *redis.Client) (*Gateway, error) {
    if cfg == nil {
        return nil, fmt.Errorf("config is required")
    }
    if logger == nil {
        return nil, fmt.Errorf("logger is required")
    }
    // ...
    return &Gateway{cfg: cfg, logger: logger, db: db, rdb: rdb}, nil
}
\`\`\`

## No \`init()\` Functions

Do not use \`init()\` functions anywhere in the codebase. They create hidden dependencies, make testing harder, and complicate startup ordering. Initialize everything explicitly in \`main()\` or constructors.

\`\`\`go
// Bad
func init() {
    prometheus.MustRegister(requestCounter)
}

// Good — register in an explicit setup function called from main
func RegisterMetrics(reg prometheus.Registerer) {
    reg.MustRegister(requestCounter)
}
\`\`\`

## Struct Initialization

Use named fields in struct literals — never positional:

\`\`\`go
// Good
route := &model.Route{
    Path:     "/api/v1/users",
    Upstream: "http://user-service:8080",
    Methods:  []string{"GET", "POST"},
    Timeout:  5 * time.Second,
}

// Bad
route := &model.Route{"/api/v1/users", "http://user-service:8080", []string{"GET", "POST"}, 5 * time.Second}
\`\`\`

## Zero Values and Nil Safety

- Design types so zero values are useful when possible
- Check for nil on pointer receivers and interface values at boundaries
- Use pointer types for optional fields in models; use value types for required fields
- Never return a non-nil error alongside a valid result

## Goroutines

- Every goroutine must have a clear shutdown path — use \`context.Context\` cancellation or \`sync.WaitGroup\`
- Never launch fire-and-forget goroutines — the gateway must shut down gracefully
- Use \`errgroup.Group\` for concurrent operations that should fail together
- Document goroutine ownership in comments

\`\`\`go
// Good — controlled lifecycle
g, ctx := errgroup.WithContext(ctx)
g.Go(func() error {
    return s.httpServer.ListenAndServe()
})
g.Go(func() error {
    <-ctx.Done()
    shutdownCtx, cancel := context.WithTimeout(context.Background(), 15*time.Second)
    defer cancel()
    return s.httpServer.Shutdown(shutdownCtx)
})
return g.Wait()
\`\`\`

## File Length

Maximum 300 lines per file. If a file exceeds this, split by responsibility:

- \`handler/routes.go\` → \`handler/routes_user.go\`, \`handler/routes_health.go\`
- \`middleware/auth.go\` → \`middleware/auth_jwt.go\`, \`middleware/auth_apikey.go\`

## Table-Driven Tests

All tests must use table-driven patterns:

\`\`\`go
func TestRateLimiter_Allow(t *testing.T) {
    tests := []struct {
        name      string
        clientID  string
        limit     int
        requests  int
        wantAllow bool
    }{
        {
            name:      "under limit allows request",
            clientID:  "client-1",
            limit:     100,
            requests:  50,
            wantAllow: true,
        },
        {
            name:      "at limit denies request",
            clientID:  "client-2",
            limit:     100,
            requests:  100,
            wantAllow: false,
        },
    }

    for _, tt := range tests {
        t.Run(tt.name, func(t *testing.T) {
            // arrange, act, assert using testify
            rl := ratelimit.New(tt.limit, mockRedis)
            for i := 0; i < tt.requests; i++ {
                _, _, _ = rl.Allow(context.Background(), tt.clientID)
            }
            got, _, err := rl.Allow(context.Background(), tt.clientID)
            require.NoError(t, err)
            assert.Equal(t, tt.wantAllow, got)
        })
    }
}
\`\`\`

Use \`testify/require\` for fatal assertions (setup failures) and \`testify/assert\` for test assertions. Use \`httptest.NewServer\` and \`httptest.NewRecorder\` for HTTP handler tests.

## Linting

All code must pass \`golangci-lint run\` with the project configuration (govet, errcheck, staticcheck, gosec, revive, gocyclo). Run \`gofmt\` and \`goimports\` before committing. CI enforces this — see \`.github/workflows/\`.`,

  '.claude/rules/go/testing.md': `# Go Testing Standards — API Gateway

## Table-Driven Tests

Every test function with more than one case MUST use table-driven format:

\`\`\`go
func TestRateLimiter_Allow(t *testing.T) {
	tests := []struct {
		name       string
		clientID   string
		limit      int
		window     time.Duration
		requests   int
		wantAllow  bool
		wantErr    error
	}{
		{
			name:      "under limit allows request",
			clientID:  "client-1",
			limit:     100,
			window:    time.Minute,
			requests:  50,
			wantAllow: true,
		},
		{
			name:      "at limit denies request",
			clientID:  "client-2",
			limit:     100,
			window:    time.Minute,
			requests:  100,
			wantAllow: false,
		},
		{
			name:    "empty client ID returns error",
			clientID: "",
			limit:   100,
			window:  time.Minute,
			wantErr: ratelimit.ErrInvalidClientID,
		},
	}

	for _, tt := range tests {
		t.Run(tt.name, func(t *testing.T) {
			// arrange, act, assert inside each subtest
		})
	}
}
\`\`\`

Rules for table-driven tests:
- Name the slice \`tests\` and the loop variable \`tt\`
- Every entry MUST have a descriptive \`name\` field
- Use \`t.Run(tt.name, ...)\` for subtests
- Use \`t.Parallel()\` at both the top-level test and inside each subtest when safe
- Keep setup logic inside the loop body, not shared mutably across iterations
- Prefix expected fields with \`want\` or \`expect\` (e.g., \`wantStatus\`, \`wantBody\`, \`wantErr\`)

## httptest for Handler Testing

All HTTP handler tests use \`net/http/httptest\` with Chi's router context:

\`\`\`go
func TestHealthHandler_Ready(t *testing.T) {
	t.Parallel()

	tests := []struct {
		name       string
		dbHealthy  bool
		redisOK    bool
		wantStatus int
		wantBody   string
	}{
		{
			name:       "all dependencies healthy",
			dbHealthy:  true,
			redisOK:    true,
			wantStatus: http.StatusOK,
			wantBody:   \`"status":"ready"\`,
		},
		{
			name:       "database down returns 503",
			dbHealthy:  false,
			redisOK:    true,
			wantStatus: http.StatusServiceUnavailable,
		},
	}

	for _, tt := range tests {
		t.Run(tt.name, func(t *testing.T) {
			t.Parallel()

			// Build dependencies with interfaces
			mockDB := &mockHealthChecker{healthy: tt.dbHealthy}
			mockRedis := &mockHealthChecker{healthy: tt.redisOK}
			svc := service.NewHealth(mockDB, mockRedis)
			h := handler.NewHealth(svc)

			// Create request and recorder
			req := httptest.NewRequest(http.MethodGet, "/healthz/ready", nil)
			rec := httptest.NewRecorder()

			// Use Chi router for proper route context
			r := chi.NewRouter()
			r.Get("/healthz/ready", h.Ready)
			r.ServeHTTP(rec, req)

			assert.Equal(t, tt.wantStatus, rec.Code)
			if tt.wantBody != "" {
				assert.Contains(t, rec.Body.String(), tt.wantBody)
			}
		})
	}
}
\`\`\`

### Handler test requirements:
- Always use \`chi.NewRouter()\` to mount handlers — never call \`handler.ServeHTTP\` directly unless testing raw \`http.Handler\` implementations
- Set Chi URL params via \`chi.NewRouteContext()\` when testing parameterized routes:

\`\`\`go
rctx := chi.NewRouteContext()
rctx.URLParams.Add("serviceID", "svc-123")
req = req.WithContext(context.WithValue(req.Context(), chi.RouteCtxKey, rctx))
\`\`\`

- Test middleware by wrapping a known test handler:

\`\`\`go
testHandler := http.HandlerFunc(func(w http.ResponseWriter, r *http.Request) {
	w.WriteHeader(http.StatusOK)
})
wrapped := middleware.RateLimit(limiter)(testHandler)
\`\`\`

- Always assert response status code, content type, and body structure
- Test error responses match the standard error envelope from \`pkg/errors/\`

## Testify Assertions

Use \`github.com/stretchr/testify/assert\` for assertions and \`require\` for fatal preconditions:

\`\`\`go
import (
	"testing"

	"github.com/stretchr/testify/assert"
	"github.com/stretchr/testify/require"
)

func TestJWTValidator_Validate(t *testing.T) {
	// Use require for setup that must succeed — test stops on failure
	key, err := rsa.GenerateKey(rand.Reader, 2048)
	require.NoError(t, err, "generating RSA key")

	token := generateTestToken(t, key, claims)
	require.NotEmpty(t, token)

	// Use assert for actual test assertions — test continues on failure
	result, err := validator.Validate(ctx, token)
	assert.NoError(t, err)
	assert.Equal(t, "user-123", result.Subject)
	assert.ElementsMatch(t, []string{"admin", "gateway:read"}, result.Roles)
	assert.WithinDuration(t, time.Now().Add(time.Hour), result.ExpiresAt, 5*time.Second)
}
\`\`\`

### When to use \`require\` vs \`assert\`:
- \`require\` — setup steps, preconditions, anything that makes subsequent assertions meaningless if it fails
- \`assert\` — actual test assertions where you want to see all failures at once
- Never use \`require\` inside a goroutine that is not the test goroutine (it calls \`t.FailNow\`)

### Preferred assertion methods:
| Scenario | Use | Avoid |
|---|---|---|
| Equality | \`assert.Equal(t, want, got)\` | \`if got != want { t.Errorf(...) }\` |
| Error check | \`assert.ErrorIs(t, err, ErrNotFound)\` | \`assert.Equal(t, err.Error(), "not found")\` |
| Error wrapping | \`assert.ErrorAs(t, err, &target)\` | Type assertion in test |
| Nil check | \`assert.Nil(t, err)\` or \`assert.NoError(t, err)\` | \`assert.Equal(t, nil, err)\` |
| Contains | \`assert.Contains(t, body, "rate limit")\` | Manual strings.Contains |
| JSON | \`assert.JSONEq(t, expected, actual)\` | String comparison of JSON |

## Mocks and Interfaces

Use interface-based dependency injection. Define mocks in test files, not in production code:

\`\`\`go
// internal/service/route_test.go

type mockRouteRepository struct {
	routes map[string]*model.Route
	err    error
}

func (m *mockRouteRepository) FindByPath(ctx context.Context, path string) (*model.Route, error) {
	if m.err != nil {
		return nil, m.err
	}
	route, ok := m.routes[path]
	if !ok {
		return nil, repository.ErrRouteNotFound
	}
	return route, nil
}
\`\`\`

Rules:
- Mock structs live in \`_test.go\` files alongside the tests that use them
- Name mocks \`mock<Interface>\` (e.g., \`mockRouteRepository\`, \`mockTokenValidator\`)
- Do NOT use mocking frameworks unless complexity demands it — prefer hand-written mocks
- Mocks must implement the same interface the production code depends on
- For Redis mocks in rate limiter tests, use \`github.com/alicebob/miniredis/v2\`
- For PostgreSQL, use \`database/sql\` with \`DATA-DOG/go-sqlmock\` or a test container

## Benchmark Tests

Write benchmarks for performance-critical paths in the gateway:

\`\`\`go
func BenchmarkRateLimiter_SlidingWindow(b *testing.B) {
	mr := miniredis.RunT(b)
	client := redis.NewClient(&redis.Options{Addr: mr.Addr()})
	limiter := ratelimit.NewSlidingWindow(client, 1000, time.Minute)
	ctx := context.Background()

	b.ResetTimer()
	b.RunParallel(func(pb *testing.PB) {
		i := 0
		for pb.Next() {
			clientID := fmt.Sprintf("client-%d", i%100)
			_, _ = limiter.Allow(ctx, clientID)
			i++
		}
	})
}

func BenchmarkJWTValidation(b *testing.B) {
	validator := setupTestValidator(b)
	token := generateValidToken(b)
	ctx := context.Background()

	b.ResetTimer()
	for i := 0; i < b.N; i++ {
		_, err := validator.Validate(ctx, token)
		if err != nil {
			b.Fatal(err)
		}
	}
}

func BenchmarkMiddlewareChain(b *testing.B) {
	// Benchmark the full middleware stack: logging → recovery → auth → rate limit → handler
	r := buildTestRouter(b)
	req := httptest.NewRequest(http.MethodGet, "/api/v1/services", nil)
	req.Header.Set("Authorization", "Bearer "+validToken)

	b.ResetTimer()
	for i := 0; i < b.N; i++ {
		rec := httptest.NewRecorder()
		r.ServeHTTP(rec, req)
	}
}
\`\`\`

### Benchmark requirements:
- Benchmark all middleware (auth, rate limiting, circuit breaker, logging)
- Benchmark request routing and path matching
- Benchmark JWT parsing and validation
- Benchmark Redis operations (use miniredis)
- Use \`b.RunParallel\` for concurrency-sensitive code
- Use \`b.ResetTimer()\` after setup
- Use \`b.ReportAllocs()\` when memory allocation matters
- Run with: \`go test -bench=. -benchmem -count=5 ./internal/...\`
- Store benchmark results and compare with \`benchstat\` before merging performance-sensitive PRs

## Integration Tests

Integration tests live in \`tests/\` and use build tags:

\`\`\`go
//go:build integration

package integration

func TestGateway_RouteToBackend(t *testing.T) {
	// Spin up test containers for PostgreSQL and Redis
	// Start the gateway binary
	// Send real HTTP requests
	// Assert responses
}
\`\`\`

Run integration tests separately:
\`\`\`bash
go test -tags=integration -v ./tests/...
\`\`\`

Use testcontainers-go for PostgreSQL and Redis in integration tests:

\`\`\`go
func setupPostgres(t *testing.T) *sql.DB {
	t.Helper()
	ctx := context.Background()
	container, err := postgres.Run(ctx, "postgres:16-alpine",
		postgres.WithDatabase("gateway_test"),
		testcontainers.WithWaitStrategy(
			wait.ForLog("database system is ready to accept connections").
				WithOccurrence(2).WithStartupTimeout(30*time.Second),
		),
	)
	require.NoError(t, err)
	t.Cleanup(func() { require.NoError(t, container.Terminate(ctx)) })

	connStr, err := container.ConnectionString(ctx, "sslmode=disable")
	require.NoError(t, err)

	db, err := sql.Open("pgx", connStr)
	require.NoError(t, err)
	return db
}
\`\`\`

## Test Helpers

Place reusable test helpers in a \`testutil\` package or as unexported helpers in test files:

\`\`\`go
// internal/auth/testutil_test.go

func generateTestToken(t *testing.T, key *rsa.PrivateKey, claims jwt.MapClaims) string {
	t.Helper()
	token := jwt.NewWithClaims(jwt.SigningMethodRS256, claims)
	signed, err := token.SignedString(key)
	require.NoError(t, err)
	return signed
}

func newAuthenticatedRequest(t *testing.T, method, path, token string) *http.Request {
	t.Helper()
	req := httptest.NewRequest(method, path, nil)
	req.Header.Set("Authorization", "Bearer "+token)
	req.Header.Set("Content-Type", "application/json")
	return req
}
\`\`\`

Rules for helpers:
- Always call \`t.Helper()\` as the first line
- Accept \`testing.TB\` when the helper works for both tests and benchmarks
- Use \`require\` inside helpers for setup failures
- Name helper files \`testutil_test.go\` or \`helpers_test.go\`

## Test Organization and Naming

\`\`\`
internal/
  middleware/
    auth.go                  # Production code
    auth_test.go             # Unit tests for auth middleware
    ratelimit.go
    ratelimit_test.go
    ratelimit_bench_test.go  # Benchmarks (separate file if large)
  handler/
    route.go
    route_test.go
  service/
    route.go
    route_test.go
tests/
  integration/
    gateway_test.go          # Full integration tests (build tag: integration)
    auth_flow_test.go
\`\`\`

Test function naming:
- \`TestTypeName_Method\` — e.g., \`TestRateLimiter_Allow\`
- \`TestTypeName_Method_condition\` — e.g., \`TestJWTValidator_Validate_expiredToken\`
- \`BenchmarkTypeName_Method\` — e.g., \`BenchmarkRateLimiter_SlidingWindow\`

## Coverage

- Minimum threshold: **80%** enforced in CI
- Run: \`go test -coverprofile=coverage.out ./internal/...\`
- View: \`go tool cover -html=coverage.out\`
- Critical paths requiring >90% coverage:
  - \`internal/auth/**\` — JWT validation, API key verification, RBAC
  - \`internal/middleware/**\` — all middleware
  - \`internal/ratelimit/**\` — rate limiting logic
  - \`internal/circuit/**\` — circuit breaker state transitions
  - \`pkg/errors/**\` — error handling

## Race Detection

All CI test runs include race detection:

\`\`\`bash
go test -race -count=1 ./...
\`\`\`

Write tests that exercise concurrent access for:
- Rate limiter (multiple goroutines hitting the same client key)
- Circuit breaker state transitions
- In-memory caches or shared state
- Middleware that reads/writes shared context values

## Test Context and Timeouts

Always use context with timeout in tests that touch external resources:

\`\`\`go
func TestRouteRepository_FindByPath(t *testing.T) {
	ctx, cancel := context.WithTimeout(context.Background(), 5*time.Second)
	defer cancel()

	route, err := repo.FindByPath(ctx, "/api/v1/users")
	require.NoError(t, err)
	assert.Equal(t, "user-service", route.Backend)
}
\`\`\`

Never use \`context.Background()\` without a timeout in integration tests. Unit tests with mocks may use bare contexts.`,

  '.claude/settings.json': `{
  "permissions": {
    "allow": [
      "Bash(go test ./...)",
      "Bash(go test -race ./...)",
      "Bash(go test -v ./...)",
      "Bash(go test -cover ./...)",
      "Bash(go test -bench=. ./...)",
      "Bash(go test -run=* ./...)",
      "Bash(go test -count=1 ./...)",
      "Bash(go vet ./...)",
      "Bash(go build ./...)",
      "Bash(go build -o bin/gateway cmd/gateway/main.go)",
      "Bash(go mod tidy)",
      "Bash(go mod download)",
      "Bash(go mod verify)",
      "Bash(go mod graph)",
      "Bash(go fmt ./...)",
      "Bash(goimports -w .)",
      "Bash(gofmt -s -w .)",
      "Bash(golangci-lint run ./...)",
      "Bash(golangci-lint run --fix ./...)",
      "Bash(go generate ./...)",
      "Bash(go doc *)",
      "Bash(go list ./...)",
      "Bash(go env *)",
      "Bash(go tool pprof *)",
      "Bash(go tool cover *)",
      "Bash(grep *)",
      "Bash(find *)",
      "Bash(cat *)",
      "Bash(head *)",
      "Bash(tail *)",
      "Bash(wc *)",
      "Bash(ls *)",
      "Bash(tree *)",
      "Bash(diff *)",
      "Bash(sort *)",
      "Bash(git status)",
      "Bash(git diff *)",
      "Bash(git log *)",
      "Bash(git branch *)",
      "Bash(git show *)",
      "Bash(git blame *)",
      "Bash(git stash *)",
      "Bash(docker build *)",
      "Bash(docker compose up *)",
      "Bash(docker compose down *)",
      "Bash(docker compose ps)",
      "Bash(docker compose logs *)",
      "Bash(helm template *)",
      "Bash(helm lint *)",
      "Bash(kubectl get *)",
      "Bash(kubectl describe *)",
      "Bash(make *)",
      "Bash(curl -s http://localhost*)",
      "Bash(jq *)",
      "Read",
      "Write",
      "Edit",
      "MultiEdit",
      "Glob",
      "Grep",
      "TodoRead",
      "TodoWrite",
      "WebFetch"
    ],
    "deny": [
      "Bash(rm -rf /)",
      "Bash(rm -rf *)",
      "Bash(git push *)",
      "Bash(git push --force *)",
      "Bash(git checkout main)",
      "Bash(git merge *)",
      "Bash(git rebase *)",
      "Bash(git reset --hard *)",
      "Bash(git clean -fd *)",
      "Bash(kubectl delete *)",
      "Bash(kubectl apply *)",
      "Bash(kubectl exec *)",
      "Bash(helm install *)",
      "Bash(helm upgrade *)",
      "Bash(helm uninstall *)",
      "Bash(docker push *)",
      "Bash(docker rm *)",
      "Bash(docker rmi *)",
      "Bash(terraform apply *)",
      "Bash(terraform destroy *)",
      "Bash(aws *)",
      "Bash(curl -X POST *)",
      "Bash(curl -X PUT *)",
      "Bash(curl -X DELETE *)",
      "Bash(sudo *)",
      "Bash(chmod 777 *)",
      "Bash(eval *)",
      "Bash(source *)",
      "Bash(export *SECRET*)",
      "Bash(export *KEY*)",
      "Bash(export *TOKEN*)",
      "Bash(export *PASSWORD*)",
      "Bash(cat *.pem)",
      "Bash(cat *.key)",
      "Bash(cat .env*)",
      "Bash(go install *)",
      "Bash(go run *)"
    ]
  },
  "env": {
    "GO111MODULE": "on",
    "GOFLAGS": "-count=1",
    "CGO_ENABLED": "0",
    "GATEWAY_ENV": "development",
    "LOG_LEVEL": "debug",
    "LOG_FORMAT": "json"
  },
  "model": {
    "default": "claude-sonnet-4-20250514",
    "codeReview": "claude-sonnet-4-20250514",
    "refactor": "claude-sonnet-4-20250514"
  },
  "contextFiles": [
    "CLAUDE.md",
    ".claude/rules/common/coding-style.md",
    ".claude/rules/common/security.md",
    ".claude/rules/common/git-workflow.md",
    ".claude/rules/common/testing.md",
    ".claude/rules/go/coding-style.md",
    "go.mod"
  ],
  "ignorePaths": [
    "vendor/",
    "bin/",
    "dist/",
    "tmp/",
    "*.exe",
    "*.test",
    "*.out",
    "*.prof",
    "*.pem",
    "*.key",
    ".env",
    ".env.*",
    "configs/production/",
    "node_modules/",
    "coverage.html",
    "coverage.out"
  ]
}`,

  '.editorconfig': `root = true

[*]
charset = utf-8
end_of_line = lf
insert_final_newline = true
trim_trailing_whitespace = true

[*.go]
indent_style = tab
indent_size = 4
tab_width = 4

[*.{yaml,yml}]
indent_style = space
indent_size = 2

[*.{json,toml}]
indent_style = space
indent_size = 2

[*.{md,markdown}]
indent_style = space
indent_size = 2
trim_trailing_whitespace = false

[*.{sh,bash}]
indent_style = space
indent_size = 2

[*.{proto}]
indent_style = space
indent_size = 2

[*.{sql}]
indent_style = space
indent_size = 2

[Dockerfile*]
indent_style = space
indent_size = 2

[*.{tf,tfvars}]
indent_style = space
indent_size = 2

[*.{helm,tpl}]
indent_style = space
indent_size = 2

[Makefile]
indent_style = tab
indent_size = 4

[go.mod]
indent_style = tab
indent_size = 4

[go.sum]
indent_style = tab
indent_size = 4

[.github/**/*.{yaml,yml}]
indent_style = space
indent_size = 2

[configs/**/*.{yaml,yml}]
indent_style = space
indent_size = 2

[deployments/**/*.{yaml,yml}]
indent_style = space
indent_size = 2`,

  '.gitattributes': `# Auto detect text files and ensure LF line endings
* text=auto eol=lf

# Go source files
*.go text eol=lf diff=golang linguist-language=Go
go.mod text eol=lf linguist-language=Go
go.sum text eol=lf linguist-generated=true

# Configuration files
*.yaml text eol=lf diff=yaml
*.yml text eol=lf diff=yaml
*.toml text eol=lf
*.json text eol=lf diff=json
*.env text eol=lf

# Documentation
*.md text eol=lf diff=markdown
*.txt text eol=lf
LICENSE text eol=lf

# Shell scripts
*.sh text eol=lf
scripts/** text eol=lf

# Docker
Dockerfile text eol=lf
Dockerfile.* text eol=lf
.dockerignore text eol=lf
docker-compose*.yml text eol=lf diff=yaml

# Kubernetes and Helm
deployments/**/*.yaml text eol=lf diff=yaml
deployments/**/*.yml text eol=lf diff=yaml
deployments/**/*.tpl text eol=lf

# Terraform
*.tf text eol=lf diff=hcl
*.tfvars text eol=lf diff=hcl
.terraform.lock.hcl text eol=lf linguist-generated=true

# GitHub Actions and templates
.github/**/*.yml text eol=lf diff=yaml
.github/**/*.md text eol=lf diff=markdown
CODEOWNERS text eol=lf

# Claude configuration
.claude/**/*.md text eol=lf diff=markdown
.claude/**/*.json text eol=lf diff=json
CLAUDE.md text eol=lf diff=markdown

# Protobuf (if used for service definitions)
*.proto text eol=lf

# SQL migrations
*.sql text eol=lf

# Certificates and keys — binary, never diff
*.pem binary
*.key binary
*.crt binary
*.p12 binary

# Compiled binaries — binary, never diff
bin/** binary
*.exe binary
*.dll binary
*.so binary
*.dylib binary

# Compressed archives
*.gz binary
*.tar binary
*.zip binary

# Images
*.png binary
*.jpg binary
*.ico binary
*.svg text eol=lf

# Vendor directory (if committed) — treat as generated
vendor/** linguist-vendored=true

# Test fixtures
tests/fixtures/** linguist-generated=true
tests/testdata/** linguist-generated=true

# Generated code markers
*_gen.go linguist-generated=true
*.pb.go linguist-generated=true
*_mock.go linguist-generated=true

# Prevent large binary diffs in PRs
*.wasm binary`,

  '.github/CODEOWNERS': `# CODEOWNERS for go-api-gateway
# Each line is a file pattern followed by one or more owners.
# Order matters — last matching pattern takes precedence.
# Owners are automatically requested for review on PRs.

# Default owners for everything in the repo
*                                   @go-api-gateway/backend-team

# Authentication, authorization, and JWT handling — security lead required
internal/auth/**                    @go-api-gateway/security-leads @go-api-gateway/platform-leads
internal/auth/jwt.go                @go-api-gateway/security-leads
internal/auth/rbac.go               @go-api-gateway/security-leads
internal/auth/apikey.go             @go-api-gateway/security-leads

# Rate limiting — platform lead required (Redis-backed, performance-critical)
internal/ratelimit/**               @go-api-gateway/platform-leads @go-api-gateway/security-leads

# Circuit breaker — platform lead required (availability-critical)
internal/circuit/**                 @go-api-gateway/platform-leads

# Middleware chain — security + platform leads (auth, rate limit, CORS, recovery)
internal/middleware/**              @go-api-gateway/platform-leads @go-api-gateway/security-leads

# Configuration — especially production configs (SOC 2 sensitive)
internal/config/**                  @go-api-gateway/platform-leads
configs/production/**               @go-api-gateway/platform-leads @go-api-gateway/security-leads
configs/staging/**                  @go-api-gateway/platform-leads

# Observability — platform lead owns tracing, metrics, logging setup
internal/observability/**           @go-api-gateway/platform-leads

# Infrastructure and deployments — platform lead required
deployments/**                      @go-api-gateway/platform-leads
deployments/kubernetes/**           @go-api-gateway/platform-leads
deployments/helm/**                 @go-api-gateway/platform-leads
deployments/docker/**               @go-api-gateway/platform-leads

# Terraform — platform lead required, security review for IAM/networking
terraform/**                        @go-api-gateway/platform-leads @go-api-gateway/security-leads

# CI/CD pipelines — platform lead owns build and deploy workflows
.github/workflows/**                @go-api-gateway/platform-leads

# GitHub repo configuration
.github/CODEOWNERS                  @go-api-gateway/platform-leads
.github/PULL_REQUEST_TEMPLATE.md    @go-api-gateway/backend-team

# Go module dependencies — conservative policy, lead review required
go.mod                              @go-api-gateway/platform-leads
go.sum                              @go-api-gateway/platform-leads

# Linter and tooling config
.golangci.yml                       @go-api-gateway/platform-leads

# Claude Code configuration and AI tooling
CLAUDE.md                           @go-api-gateway/platform-leads
.claude/**                          @go-api-gateway/platform-leads
plugin/**                           @go-api-gateway/platform-leads

# Documentation — architecture decisions and runbooks
docs/architecture/**                @go-api-gateway/platform-leads
docs/runbooks/**                    @go-api-gateway/platform-leads @go-api-gateway/security-leads

# Scripts — build, migration, load testing
scripts/**                          @go-api-gateway/platform-leads

# Sensitive file patterns — security lead must approve
*.pem                               @go-api-gateway/security-leads
*.key                               @go-api-gateway/security-leads
.env*                               @go-api-gateway/security-leads`,

  '.github/ISSUE_TEMPLATE/ai_task.md': `---
name: AI Task (Claude Code)
about: Structured task for Claude Code to implement in the go-api-gateway project
title: "[AI] "
labels: ai-task, claude-code
assignees: ''
---

## Task Summary

<!-- One-line description of what Claude Code should accomplish -->

## Task Type

<!-- Select one -->
- [ ] feat — New feature or capability
- [ ] fix — Bug fix
- [ ] refactor — Code restructuring without behavior change
- [ ] perf — Performance improvement
- [ ] test — Add or improve tests
- [ ] docs — Documentation update
- [ ] chore — Build, CI, or tooling change

## Component

<!-- Select the primary area of the codebase affected -->
- [ ] \`cmd/gateway/\` — Main entry point, server startup
- [ ] \`internal/handler/\` — Chi HTTP route handlers
- [ ] \`internal/middleware/\` — Chi middleware (auth, rate limit, logging, CORS, recovery)
- [ ] \`internal/service/\` — Business logic layer
- [ ] \`internal/repository/\` — Data access (PostgreSQL, Redis)
- [ ] \`internal/model/\` — Domain models and DTOs
- [ ] \`internal/config/\` — Configuration loading (Viper)
- [ ] \`internal/auth/\` — JWT validation, API key verification, RBAC
- [ ] \`internal/ratelimit/\` — Redis-backed rate limiting (sliding window)
- [ ] \`internal/circuit/\` — Circuit breaker implementation
- [ ] \`internal/observability/\` — OpenTelemetry, Prometheus metrics, slog
- [ ] \`pkg/httputil/\` — Shared HTTP utilities, response helpers
- [ ] \`pkg/errors/\` — Custom error types, error codes
- [ ] \`configs/\` — YAML configuration files
- [ ] \`deployments/\` — Kubernetes, Helm, Docker
- [ ] \`tests/\` — Integration and E2E tests
- [ ] Other: <!-- specify -->

## Detailed Requirements

### What

<!-- Describe the desired outcome in precise terms. Include API contracts, data structures, or behavior specifications. -->

### Why

<!-- Business or technical context. Link to architecture decisions, performance requirements, or SOC 2 controls if relevant. -->

### Constraints

<!-- Non-negotiable rules for this task -->
- [ ] Must follow Clean Architecture (handler → service → repository)
- [ ] Must use interfaces for dependency injection
- [ ] Must propagate \`context.Context\` through all layers
- [ ] Must wrap errors with \`fmt.Errorf\` and \`%w\`
- [ ] Must use \`slog\` for structured logging
- [ ] Must be composable Chi middleware (if middleware task)
- [ ] Must not use \`init()\` functions
- [ ] Must not exceed 300 lines per file
- [ ] Other: <!-- specify -->

## Acceptance Criteria

<!-- Checklist that defines "done". Be specific. -->
- [ ] <!-- e.g., GET /health returns 200 with JSON body {"status":"ok","version":"..."} -->
- [ ] <!-- e.g., Rate limiter returns 429 with Retry-After header when limit exceeded -->
- [ ] <!-- e.g., Circuit breaker opens after 5 consecutive failures within 30s -->
- [ ] All exported functions have doc comments
- [ ] Unit tests written as table-driven tests with testify assertions
- [ ] Test coverage ≥ 80% for new/modified packages
- [ ] \`golangci-lint run\` passes with zero issues
- [ ] \`go vet ./...\` passes
- [ ] \`go test -race ./...\` passes

## Technical Context

### Relevant Files

<!-- List files Claude should read before starting -->
\`\`\`
# Example:
# internal/middleware/auth.go — existing auth middleware for reference
# internal/model/route.go — route configuration model
# configs/development.yaml — current config structure
\`\`\`

### Interfaces to Implement or Consume

<!-- Paste or reference Go interfaces this task must satisfy -->
\`\`\`go
// Example:
// type RateLimiter interface {
//     Allow(ctx context.Context, key string, limit Rate) (bool, error)
//     Remaining(ctx context.Context, key string, limit Rate) (int, error)
// }
\`\`\`

### Dependencies Available

<!-- Libraries already in go.mod that should be used -->
- \`github.com/go-chi/chi/v5\` — Router and middleware
- \`github.com/redis/go-redis/v9\` — Redis client
- \`github.com/jackc/pgx/v5\` — PostgreSQL driver
- \`github.com/golang-jwt/jwt/v5\` — JWT parsing and validation
- \`github.com/stretchr/testify\` — Test assertions and mocks
- \`github.com/prometheus/client_golang\` — Prometheus metrics
- \`go.opentelemetry.io/otel\` — Distributed tracing
- \`github.com/spf13/viper\` — Configuration management
- Other: <!-- specify if needed -->

### Environment Variables

<!-- Any env vars relevant to this task -->
\`\`\`
# Example:
# GATEWAY_REDIS_URL=redis://localhost:6379/0
# GATEWAY_JWT_PUBLIC_KEY_PATH=/etc/gateway/keys/public.pem
# GATEWAY_RATE_LIMIT_DEFAULT=100
\`\`\`

## API Contract (if applicable)

### Request

\`\`\`
# METHOD /path
# Headers, query params, body
\`\`\`

### Response — Success

\`\`\`json

\`\`\`

### Response — Error

\`\`\`json

\`\`\`

## Security Considerations

<!-- SOC 2 and OWASP API Security Top 10 items relevant to this task -->
- [ ] Handles authentication/authorization (JWT, API key, RBAC)
- [ ] Processes user-supplied input (validate, sanitize)
- [ ] Touches sensitive data (PII, credentials, tokens)
- [ ] Modifies security-sensitive paths (\`internal/auth/**\`, \`config/production/**\`, \`*.pem\`)
- [ ] Requires TLS or encryption considerations
- [ ] Needs audit logging for SOC 2 compliance
- [ ] None of the above

## Performance Requirements (if applicable)

<!-- Latency, throughput, or resource constraints -->
- Target p99 latency: <!-- e.g., < 5ms for middleware, < 50ms for proxied requests -->
- Target throughput: <!-- e.g., 10,000 RPS per instance -->
- Memory budget: <!-- e.g., < 100MB RSS under load -->
- [ ] Include benchmarks (\`func BenchmarkXxx\`) in test file
- [ ] Profile with \`pprof\` if optimizing hot path

## Branch and PR

- **Branch name**: \`<!-- e.g., feat/GW-42-add-circuit-breaker -->\`
- **Base branch**: \`main\`
- **Commit prefix**: \`<!-- e.g., feat(circuit): -->\`
- **PR title**: \`<!-- e.g., feat(circuit): add circuit breaker middleware with configurable thresholds -->\`

## Related Issues / Docs

<!-- Links to related issues, ADRs, runbooks, or external docs -->
- Related: #
- Docs: \`docs/\`
- ADR: \`docs/adr/\`

## Claude Code Instructions

<!-- Special instructions for Claude Code beyond the standard rules in CLAUDE.md -->

1. Read \`CLAUDE.md\` and all rules in \`.claude/rules/\` before starting.
2. Read the files listed in **Relevant Files** above.
3. Create a feature branch following the naming convention above.
4. Implement the task following Clean Architecture layers.
5. Write table-driven tests with \`testify\` and \`httptest\` where applicable.
6. Run \`golangci-lint run\`, \`go vet ./...\`, and \`go test -race -coverprofile=coverage.out ./...\` before committing.
7. Verify coverage meets 80% threshold: \`go tool cover -func=coverage.out\`.
8. Use conventional commit messages with the prefix specified above.
9. Mark AI-generated code: add \`// Generated by Claude Code\` comment at the top of new files.
10. Open a PR using the template in \`.github/PULL_REQUEST_TEMPLATE.md\`.`,

  '.github/ISSUE_TEMPLATE/bug_report.md': `---
name: Bug Report
title: "[BUG] "
labels: ["bug", "triage"]
assignees: []
---

## Bug Description

A clear and concise description of the bug.

## Request Details

| Field | Value |
|-------|-------|
| **Route/Endpoint** | \`GET /api/v1/...\` |
| **Upstream Service** | (e.g., user-service, order-service) |
| **HTTP Method** | GET / POST / PUT / PATCH / DELETE |
| **Expected Status Code** | \`200\` |
| **Actual Status Code** | \`502\` |
| **Observed Latency** | (e.g., 1200ms, timeout after 30s) |
| **Gateway Version** | (e.g., v1.4.2, commit SHA) |
| **Environment** | staging / production |

## Authentication Context

- [ ] Unauthenticated request
- [ ] JWT Bearer token (RS256)
- [ ] API key
- [ ] OAuth2 passthrough

**Client/Tenant ID** (if applicable): 

## Middleware Chain Behavior

Which middleware layers were involved or suspected? Check all that apply:

- [ ] Rate limiting (Redis-backed sliding window)
- [ ] JWT validation / RBAC
- [ ] Circuit breaker (tripped or half-open)
- [ ] Request transformation
- [ ] Response transformation
- [ ] CORS
- [ ] Request logging / tracing
- [ ] Recovery / panic handler

## Steps to Reproduce

1. Send request to \`...\`
2. With headers: \`...\`
3. With body (if applicable): \`...\`
4. Observe response \`...\`

**cURL command to reproduce** (sanitize credentials):

\`\`\`bash
curl -v -X GET "https://gateway.example.com/api/v1/..." \\
  -H "Authorization: Bearer <redacted>" \\
  -H "Content-Type: application/json"
\`\`\`

## Expected Behavior

Describe what you expected to happen.

## Actual Behavior

Describe what actually happened. Include the response body if relevant:

\`\`\`json
{
  "error": "",
  "code": "",
  "request_id": ""
}
\`\`\`

## Observability Data

### Request ID / Trace ID

Provide the \`X-Request-ID\` or OpenTelemetry trace ID so we can look up the request in Jaeger:

- **Request ID**: 
- **Trace ID**: 
- **Jaeger Link**: 

### Relevant Logs

Paste structured log output from \`slog\` (JSON format). Redact any sensitive data:

\`\`\`json
{"time":"...","level":"ERROR","msg":"...","request_id":"...","route":"...","status":502,"latency_ms":1200}
\`\`\`

### Prometheus Metrics

If applicable, note any relevant metric anomalies:

- \`gateway_request_duration_seconds\` — elevated latency?
- \`gateway_requests_total\` — error rate spike?
- \`gateway_circuit_breaker_state\` — circuit open?
- \`gateway_rate_limit_rejected_total\` — rate limit hits?
- \`gateway_upstream_request_duration_seconds\` — upstream slow?

### Grafana Dashboard Screenshot

If available, attach a screenshot of the relevant Grafana dashboard panel showing the anomaly.

## Rate Limiting Context (if applicable)

| Field | Value |
|-------|-------|
| **Rate limit tier** | (e.g., free, pro, enterprise) |
| **Configured limit** | (e.g., 100 req/min) |
| **\`X-RateLimit-Remaining\`** | |
| **\`X-RateLimit-Reset\`** | |
| **Redis cluster** | (e.g., elasticache-prod-001) |

## Circuit Breaker Context (if applicable)

| Field | Value |
|-------|-------|
| **Upstream service** | |
| **Circuit state** | closed / open / half-open |
| **Failure threshold** | |
| **Consecutive failures** | |
| **Last state change** | |

## Infrastructure Context

| Field | Value |
|-------|-------|
| **ECS Task ID** | |
| **ECS Service** | |
| **ALB Target Group** | |
| **AWS Region** | |
| **Pod/Container** | (if K8s) |
| **Node** | |

## Impact

- [ ] Complete outage (all requests failing)
- [ ] Partial outage (specific routes or clients affected)
- [ ] Degraded performance (elevated latency, intermittent errors)
- [ ] Minor (cosmetic, logging, non-blocking)

**Affected clients/tenants**: 
**Estimated request volume impacted**: 

## Possible Root Cause

If you have a theory, describe it here. Consider:

- Upstream service degradation or deployment
- Redis connectivity or memory pressure
- PostgreSQL config store query latency
- JWT key rotation or certificate expiry
- Rate limit misconfiguration
- Circuit breaker threshold tuning
- DNS resolution issues
- Connection pool exhaustion

## Workaround

Is there a known workaround? (e.g., retry, use alternate route, bypass specific middleware)

## Additional Context

- Related issues: #
- Recent deployments or config changes:
- Load test results (if triggered under load):

## SOC 2 Checklist

> Required for production incidents per SOC 2 compliance.

- [ ] No sensitive data (tokens, API keys, PII) included in this report
- [ ] Incident logged in tracking system if production-impacting
- [ ] Security team notified if authentication/authorization related`,

  '.github/ISSUE_TEMPLATE/feature_request.md': `---
name: Feature Request
about: Propose a new route, middleware, integration, or gateway capability
title: "feat: "
labels: ["enhancement", "triage"]
assignees: ''
---

## Summary

<!-- One-sentence description of the feature. -->

## Motivation

<!-- Why is this feature needed? Link to metrics, customer feedback, or architectural goals. -->

## Feature Category

<!-- Check the most relevant category. -->

- [ ] New route / endpoint
- [ ] New middleware (Chi middleware)
- [ ] New upstream integration / backend service
- [ ] Rate limiting enhancement
- [ ] Authentication / authorization (JWT, API keys, RBAC)
- [ ] Circuit breaker / resilience
- [ ] Observability (metrics, tracing, logging)
- [ ] Configuration / admin API
- [ ] Performance optimization
- [ ] Infrastructure / deployment
- [ ] Other: <!-- describe -->

## Detailed Description

<!-- Describe the feature in detail. Include request/response examples for new routes. -->

### Proposed API Surface (if applicable)

\`\`\`
METHOD /api/v1/path
Headers: Authorization: Bearer <token>
Request Body: { ... }
Response Body: { ... }
Status Codes: 200, 400, 401, 429
\`\`\`

### Middleware Chain Position (if middleware)

<!-- Where in the Chi middleware stack should this run? Reference existing middleware order. -->
<!-- Example: After recovery, before auth; or after auth, before rate limiting -->

\`\`\`
Recovery → RequestID → Logger → [YOUR MIDDLEWARE] → Auth → RateLimit → Handler
\`\`\`

## Architecture Impact

### Affected Layers

<!-- Check all layers in internal/ that will be modified. -->

- [ ] \`internal/handler/\` — HTTP handlers
- [ ] \`internal/middleware/\` — Chi middleware
- [ ] \`internal/service/\` — Business logic
- [ ] \`internal/repository/\` — Data access (PostgreSQL / Redis)
- [ ] \`internal/model/\` — Domain models / DTOs
- [ ] \`internal/config/\` — Configuration (Viper)
- [ ] \`internal/auth/\` — Authentication / RBAC
- [ ] \`internal/ratelimit/\` — Rate limiting (Redis)
- [ ] \`internal/circuit/\` — Circuit breaker
- [ ] \`internal/observability/\` — Telemetry setup
- [ ] \`pkg/httputil/\` — Shared HTTP utilities
- [ ] \`pkg/errors/\` — Custom error types

### New Dependencies

<!-- List any new Go modules required. Remember: conservative dependency policy — justify each addition. -->

| Module | Purpose | Justification |
|--------|---------|---------------|
| — | — | — |

### Database Changes

- [ ] PostgreSQL schema migration required
- [ ] Redis key/data structure changes
- [ ] No database changes

## Configuration

<!-- What new config values are needed? Show Viper YAML and env var equivalents. -->

\`\`\`yaml
# configs/development.yaml
# example:
# feature_name:
#   enabled: true
#   timeout: 5s
\`\`\`

| Env Var | Default | Description |
|---------|---------|-------------|
| — | — | — |

## Observability

<!-- How will this feature be monitored? -->

- **Metrics (Prometheus):** <!-- e.g., gateway_feature_requests_total, gateway_feature_latency_seconds -->
- **Traces (OpenTelemetry):** <!-- e.g., new span for upstream call -->
- **Logs (slog):** <!-- e.g., structured fields to add -->
- **Alerts:** <!-- e.g., error rate > 5% triggers PagerDuty -->

## Security Considerations

<!-- Required for SOC 2 compliance. Address each item or mark N/A. -->

- [ ] Authentication required for this feature
- [ ] Authorization / RBAC roles defined
- [ ] Input validation specified (OWASP API Security Top 10)
- [ ] Sensitive data handling reviewed (no PII in logs/traces)
- [ ] Rate limiting applies to new endpoints
- [ ] TLS requirements considered
- [ ] API key rotation impact assessed
- [ ] N/A — no security impact (explain why)

## Performance Expectations

<!-- Quantify expected performance characteristics. -->

- **Expected latency added:** <!-- e.g., < 2ms p99 -->
- **Throughput impact:** <!-- e.g., no degradation at 10k RPS -->
- **Memory/CPU impact:** <!-- e.g., negligible, or +50MB for cache -->
- **Benchmark required:** <!-- yes/no — use \`go test -bench\` -->
- **Profiling needed:** <!-- pprof CPU/memory profiling -->

## Acceptance Criteria

<!-- Specific, testable criteria. Use table-driven test scenarios where possible. -->

- [ ] <!-- Criterion 1 -->
- [ ] <!-- Criterion 2 -->
- [ ] <!-- Criterion 3 -->
- [ ] Unit tests with table-driven cases (≥ 80% coverage on new code)
- [ ] Integration tests in \`tests/\` if external dependencies involved
- [ ] \`httptest\` handler tests for new routes
- [ ] \`golangci-lint run\` passes with no new warnings
- [ ] \`go vet ./...\` clean
- [ ] Race detection passes (\`go test -race ./...\`)
- [ ] Documentation updated in \`docs/\`

## Implementation Notes

<!-- Optional: suggest an approach, reference patterns in the codebase, or link to relevant docs. -->

## Related Issues

<!-- Link to related issues, PRs, or upstream service tickets. -->

- Depends on: #
- Related to: #
- Blocks: #`,

  '.github/PULL_REQUEST_TEMPLATE.md': `## Description

<!-- Provide a concise summary of the change and the problem it solves. Link the relevant GitHub Issue. -->

Resolves #<!-- issue number -->

### What changed and why?

<!-- Describe the approach taken and any alternatives considered. -->

---

## Type of Change

- [ ] \`feat\` — New feature (non-breaking)
- [ ] \`fix\` — Bug fix (non-breaking)
- [ ] \`perf\` — Performance improvement
- [ ] \`refactor\` — Code restructuring (no behavior change)
- [ ] \`docs\` — Documentation only
- [ ] \`chore\` — Build, CI, dependency updates
- [ ] \`breaking\` — Breaking change (requires major version bump)

---

## Checklist

### General

- [ ] Branch follows naming convention: \`type/GW-<number>-description\`
- [ ] Commits follow [Conventional Commits](https://www.conventionalcommits.org/) (\`feat:\`, \`fix:\`, \`perf:\`, etc.)
- [ ] Code passes \`golangci-lint run\` with no new warnings
- [ ] Code is formatted with \`gofmt\` and \`goimports\`
- [ ] No file exceeds 300 lines
- [ ] All exported functions and types have doc comments
- [ ] Errors are wrapped with \`fmt.Errorf("context: %w", err)\`
- [ ] \`context.Context\` is propagated through all handler → service → repository calls
- [ ] No \`init()\` functions introduced
- [ ] Structured logging uses \`slog\` (no \`fmt.Println\` or \`log.Printf\`)

### Testing

- [ ] Unit tests added/updated for all changed logic
- [ ] Table-driven tests used where applicable
- [ ] Tests pass locally: \`go test ./... -race -count=1\`
- [ ] Test coverage meets or exceeds 80% for changed packages
- [ ] Integration tests updated if database/Redis interactions changed (\`tests/\` directory)
- [ ] HTTP handlers tested with \`httptest.NewRecorder\` and \`chi.NewRouter\`

### Handler Changes (\`internal/handler/\`)

- [ ] Request validation occurs before any business logic
- [ ] Responses use \`pkg/httputil\` response helpers for consistent JSON structure
- [ ] Error responses use \`pkg/errors\` error codes — no raw strings in HTTP responses
- [ ] New routes registered in the appropriate Chi router group
- [ ] OpenAPI/Swagger docs updated in \`docs/\` if endpoints changed

### Middleware Changes (\`internal/middleware/\`)

- [ ] Middleware is composable Chi middleware (\`func(next http.Handler) http.Handler\`)
- [ ] Middleware order documented if ordering matters (auth before rate limit, etc.)
- [ ] Recovery middleware still wraps the chain (panic safety verified)
- [ ] No middleware silently swallows errors — all errors logged or propagated
- [ ] Benchmark added/updated: \`go test -bench=. -benchmem ./internal/middleware/...\`

### Auth Changes (\`internal/auth/\`)

> ⚠️ **Security-sensitive path — requires review from a CODEOWNERS-designated reviewer.**

- [ ] JWT validation uses RS256 with key rotation support
- [ ] API key lookup uses constant-time comparison
- [ ] RBAC permissions checked at the handler or middleware level
- [ ] No secrets, keys, or tokens hardcoded — all sourced from config/env
- [ ] Token expiration and clock skew handling verified
- [ ] Auth bypass is impossible — tested with missing, expired, and malformed tokens
- [ ] Changes reviewed against [OWASP API Security Top 10](https://owasp.org/www-project-api-security/)

### Rate Limiting Changes (\`internal/ratelimit/\`)

- [ ] Sliding window algorithm correctness verified with unit tests
- [ ] Redis key expiration set to prevent unbounded memory growth
- [ ] Rate limit headers included in responses (\`X-RateLimit-Limit\`, \`X-RateLimit-Remaining\`, \`X-RateLimit-Reset\`)
- [ ] Graceful degradation if Redis is unavailable (fail-open or fail-closed — document which)
- [ ] Per-client and per-route limits configurable via \`configs/\` YAML

### Circuit Breaker Changes (\`internal/circuit/\`)

- [ ] State transitions tested: closed → open → half-open → closed
- [ ] Thresholds and timeouts are configurable, not hardcoded
- [ ] Circuit state exposed via Prometheus metrics
- [ ] Fallback behavior documented and tested

### Configuration Changes (\`internal/config/\`, \`configs/\`)

- [ ] No secrets in YAML files — secrets use environment variables or AWS Secrets Manager
- [ ] Configuration changes are backward-compatible or migration documented
- [ ] Viper binding matches environment variable naming (\`ALL_CAPS\`, prefixed with \`GW_\`)
- [ ] Default values are sensible for local development

### Observability Changes (\`internal/observability/\`)

- [ ] New Prometheus metrics follow naming conventions (\`gateway_<subsystem>_<metric>_<unit>\`)
- [ ] OpenTelemetry spans have meaningful names and attributes
- [ ] No sensitive data (tokens, PII, request bodies) in logs, traces, or metrics
- [ ] Dashboard or alert updates documented in \`docs/runbooks/\`

### Database/Repository Changes (\`internal/repository/\`)

- [ ] SQL queries use parameterized statements (no string concatenation)
- [ ] Database migrations added to \`scripts/migrations/\` if schema changed
- [ ] Connection pooling settings reviewed (\`MaxOpenConns\`, \`MaxIdleConns\`, \`ConnMaxLifetime\`)
- [ ] Redis commands use appropriate TTLs
- [ ] Repository interfaces updated — mocks regenerated for tests

### Infrastructure/Deployment Changes (\`deployments/\`, \`.github/workflows/\`)

- [ ] Docker image builds successfully: \`docker build -f deployments/Dockerfile .\`
- [ ] Kubernetes manifests validated: \`kubectl apply --dry-run=client\`
- [ ] Health check endpoints (\`/healthz\`, \`/readyz\`) still function correctly
- [ ] Graceful shutdown tested — in-flight requests complete before termination
- [ ] Resource limits (CPU, memory) reviewed in Kubernetes manifests

---

## Performance Impact

<!-- If this change affects the hot path (request routing, middleware chain), provide benchmark results. -->

<details>
<summary>Benchmark results (expand)</summary>

\`\`\`
# Paste output of: go test -bench=. -benchmem ./internal/...
\`\`\`

</details>

- [ ] No performance regression on the request hot path
- [ ] Profiled with \`pprof\` if latency-sensitive code changed

---

## SOC 2 Compliance

- [ ] No new logging of PII, tokens, or credentials
- [ ] Audit trail maintained for auth and access control changes
- [ ] TLS configuration unchanged or strengthened
- [ ] API key rotation mechanism not broken by this change

---

## AI-Generated Code Disclosure

> Per project policy, AI-assisted code must be disclosed for traceability and review.

- [ ] **This PR contains AI-generated or AI-assisted code**

If checked:

- [ ] AI-generated sections are marked with \`// Generated with AI assistance\` comments
- [ ] All AI-generated code has been reviewed, understood, and tested by the author
- [ ] AI tool used: <!-- e.g., Claude Code, GitHub Copilot -->
- [ ] AI-generated code does not appear in security-sensitive paths (\`internal/auth/**\`, \`*.pem\`, \`.env*\`) without explicit lead review

---

## Reviewer Notes

<!-- Anything specific reviewers should focus on? Any areas of uncertainty? -->

**Suggested reviewers**: @<!-- mention relevant CODEOWNERS -->`,

  '.github/workflows/ai-code-audit.yml': `name: AI Code Audit

on:
  schedule:
    # Every Monday at 06:00 UTC (01:00 EST)
    - cron: '0 6 * * 1'
  workflow_dispatch:
    inputs:
      scope:
        description: 'Audit scope'
        required: false
        default: 'full'
        type: choice
        options:
          - full
          - security
          - performance
          - quality
      paths:
        description: 'Specific paths to audit (comma-separated, empty for all)'
        required: false
        default: ''
        type: string

permissions:
  contents: read
  issues: write
  pull-requests: read

env:
  GO_VERSION: '1.22'
  AUDIT_BRANCH: main

jobs:
  prepare-audit:
    name: Prepare Audit Context
    runs-on: ubuntu-latest
    outputs:
      file_count: \${{ steps.stats.outputs.file_count }}
      total_lines: \${{ steps.stats.outputs.total_lines }}
      recent_prs: \${{ steps.recent.outputs.pr_list }}
      scope: \${{ steps.scope.outputs.value }}
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4
        with:
          ref: \${{ env.AUDIT_BRANCH }}
          fetch-depth: 0

      - name: Determine audit scope
        id: scope
        run: |
          if [ "\${{ github.event_name }}" = "workflow_dispatch" ]; then
            echo "value=\${{ inputs.scope }}" >> "$GITHUB_OUTPUT"
          else
            echo "value=full" >> "$GITHUB_OUTPUT"
          fi

      - name: Gather codebase statistics
        id: stats
        run: |
          FILE_COUNT=$(find . -name '*.go' -not -path './vendor/*' -not -path './.git/*' | wc -l)
          TOTAL_LINES=$(find . -name '*.go' -not -path './vendor/*' -not -path './.git/*' -exec cat {} + | wc -l)
          echo "file_count=\${FILE_COUNT}" >> "$GITHUB_OUTPUT"
          echo "total_lines=\${TOTAL_LINES}" >> "$GITHUB_OUTPUT"
          echo "📊 Go files: \${FILE_COUNT}, Total lines: \${TOTAL_LINES}"

      - name: List recent PRs merged since last audit
        id: recent
        env:
          GH_TOKEN: \${{ secrets.GITHUB_TOKEN }}
        run: |
          SINCE=$(date -d '7 days ago' --iso-8601=seconds 2>/dev/null || date -v-7d +%Y-%m-%dT%H:%M:%S%z)
          PR_LIST=$(gh pr list --state merged --base main --search "merged:>=\${SINCE}" --json number,title,author --limit 20 --jq '[.[] | "\\(.number): \\(.title) (@\\(.author.login))"] | join("\\n")' || echo "none")
          {
            echo "pr_list<<EOF"
            echo "\${PR_LIST}"
            echo "EOF"
          } >> "$GITHUB_OUTPUT"

  static-analysis:
    name: Static Analysis Snapshot
    runs-on: ubuntu-latest
    needs: prepare-audit
    outputs:
      lint_issues: \${{ steps.lint.outputs.issue_count }}
      vet_clean: \${{ steps.vet.outputs.clean }}
      vuln_count: \${{ steps.vuln.outputs.count }}
      coverage: \${{ steps.coverage.outputs.percent }}
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4
        with:
          ref: \${{ env.AUDIT_BRANCH }}

      - name: Set up Go
        uses: actions/setup-go@v5
        with:
          go-version: \${{ env.GO_VERSION }}
          cache: true

      - name: Download dependencies
        run: go mod download

      - name: Run golangci-lint
        id: lint
        continue-on-error: true
        run: |
          go install github.com/golangci-lint/golangci-lint/cmd/golangci-lint@latest
          LINT_OUTPUT=$(golangci-lint run --out-format json ./... 2>/dev/null || true)
          ISSUE_COUNT=$(echo "\${LINT_OUTPUT}" | jq '.Issues | length' 2>/dev/null || echo "0")
          echo "issue_count=\${ISSUE_COUNT}" >> "$GITHUB_OUTPUT"
          echo "\${LINT_OUTPUT}" > /tmp/lint-results.json
          echo "🔍 Lint issues found: \${ISSUE_COUNT}"

      - name: Run go vet
        id: vet
        continue-on-error: true
        run: |
          if go vet ./... 2>/dev/null; then
            echo "clean=true" >> "$GITHUB_OUTPUT"
          else
            echo "clean=false" >> "$GITHUB_OUTPUT"
          fi

      - name: Run govulncheck
        id: vuln
        continue-on-error: true
        run: |
          go install golang.org/x/vuln/cmd/govulncheck@latest
          VULN_OUTPUT=$(govulncheck -json ./... 2>/dev/null || true)
          VULN_COUNT=$(echo "\${VULN_OUTPUT}" | grep -c '"OSV"' || echo "0")
          echo "count=\${VULN_COUNT}" >> "$GITHUB_OUTPUT"
          echo "\${VULN_OUTPUT}" > /tmp/vuln-results.json
          echo "🛡️ Vulnerabilities found: \${VULN_COUNT}"

      - name: Run tests with coverage
        id: coverage
        continue-on-error: true
        run: |
          go test -coverprofile=coverage.out -covermode=atomic ./... 2>/dev/null || true
          if [ -f coverage.out ]; then
            COVERAGE=$(go tool cover -func=coverage.out | grep total | awk '{print $3}' | tr -d '%')
            echo "percent=\${COVERAGE}" >> "$GITHUB_OUTPUT"
            echo "📈 Coverage: \${COVERAGE}%"
          else
            echo "percent=0" >> "$GITHUB_OUTPUT"
          fi

      - name: Upload analysis artifacts
        uses: actions/upload-artifact@v4
        with:
          name: static-analysis-results
          path: |
            /tmp/lint-results.json
            /tmp/vuln-results.json
            coverage.out
          retention-days: 30

  ai-security-audit:
    name: AI Security Audit
    runs-on: ubuntu-latest
    needs: [prepare-audit, static-analysis]
    if: needs.prepare-audit.outputs.scope == 'full' || needs.prepare-audit.outputs.scope == 'security'
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4
        with:
          ref: \${{ env.AUDIT_BRANCH }}

      - name: Security-focused code review
        id: security_review
        uses: anthropics/claude-code-action@beta
        with:
          model: claude-sonnet-4-20250514
          prompt: |
            You are performing a weekly security audit of the go-api-gateway codebase.
            This is a Go API gateway handling JWT authentication, rate limiting, and request routing.
            SOC 2 compliance is required.

            Focus areas:
            1. **Authentication & Authorization** (internal/auth/**):
               - JWT RS256 validation correctness (key rotation, expiry, audience/issuer checks)
               - API key storage and comparison (constant-time comparison, hashing)
               - RBAC enforcement completeness
               - OAuth2 passthrough security

            2. **Input Validation** (internal/handler/**):
               - Request body size limits
               - Header injection prevention
               - Path traversal in routing
               - Query parameter sanitization
               - OWASP API Security Top 10 compliance

            3. **Secrets Management**:
               - No hardcoded secrets, keys, or tokens in source
               - Proper use of environment variables via Viper/envconfig
               - PEM files not committed
               - .env files excluded from version control

            4. **Middleware Security** (internal/middleware/**):
               - CORS configuration strictness
               - Rate limiting bypass vectors
               - Recovery middleware information leakage
               - Request ID propagation for audit trails

            5. **Data Layer Security** (internal/repository/**):
               - SQL injection prevention (parameterized queries)
               - Redis command injection
               - Connection string handling
               - TLS for database connections

            6. **Dependency Security**:
               - Review go.mod for known vulnerable packages
               - Assess dependency minimality (conservative dependency policy)

            7. **Error Handling**:
               - No stack traces or internal details in HTTP responses
               - Proper error wrapping with %w
               - Sensitive data not logged

            Vulnerabilities found: \${{ needs.static-analysis.outputs.vuln_count }}

            For each finding, provide:
            - Severity: CRITICAL / HIGH / MEDIUM / LOW / INFO
            - File and line reference
            - Description of the issue
            - Recommended fix with Go code example
            - SOC 2 control reference if applicable

            Output a structured markdown report.
          allowed_tools: "Read,Glob,Grep"
        env:
          ANTHROPIC_API_KEY: \${{ secrets.ANTHROPIC_API_KEY }}

      - name: Save security audit report
        run: |
          mkdir -p audit-reports
          cat > audit-reports/security-audit.md << 'REPORT_EOF'
          # 🛡️ Security Audit Report
          **Date**: $(date -u +%Y-%m-%dT%H:%M:%SZ)
          **Branch**: \${{ env.AUDIT_BRANCH }}
          **Scope**: Security
          **Vulnerabilities (govulncheck)**: \${{ needs.static-analysis.outputs.vuln_count }}

          ## AI Review Output
          Review completed via Claude Code Action. See workflow logs for detailed findings.
          REPORT_EOF

      - name: Upload security report
        uses: actions/upload-artifact@v4
        with:
          name: security-audit-report
          path: audit-reports/
          retention-days: 90

  ai-quality-audit:
    name: AI Quality & Performance Audit
    runs-on: ubuntu-latest
    needs: [prepare-audit, static-analysis]
    if: needs.prepare-audit.outputs.scope == 'full' || needs.prepare-audit.outputs.scope == 'quality' || needs.prepare-audit.outputs.scope == 'performance'
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4
        with:
          ref: \${{ env.AUDIT_BRANCH }}

      - name: Quality and performance review
        id: quality_review
        uses: anthropics/claude-code-action@beta
        with:
          model: claude-sonnet-4-20250514
          prompt: |
            You are performing a weekly quality and performance audit of the go-api-gateway codebase.
            This is a high-performance API gateway built with Go 1.22 and Chi v5 router.

            Codebase stats:
            - Go files: \${{ needs.prepare-audit.outputs.file_count }}
            - Total lines: \${{ needs.prepare-audit.outputs.total_lines }}
            - Lint issues: \${{ needs.static-analysis.outputs.lint_issues }}
            - Test coverage: \${{ needs.static-analysis.outputs.coverage }}%
            - Coverage threshold: 80%

            Recent PRs merged this week:
            \${{ needs.prepare-audit.outputs.recent_prs }}

            **Quality Review** — check for:
            1. **Clean Architecture Compliance**:
               - handler → service → repository layering respected
               - No repository imports in handlers
               - Interfaces used for dependency injection
               - No business logic in handlers

            2. **Go Idioms & Conventions**:
               - Effective Go compliance
               - All exported functions have doc comments
               - Error wrapping with fmt.Errorf and %w
               - No init() functions
               - Context propagation on all handlers and service methods
               - Structured logging with slog (no fmt.Println or log.*)
               - snake_case for file names, PascalCase/camelCase for identifiers

            3. **Code Organization**:
               - Files under 300 lines
               - Single responsibility per file
               - Proper package boundaries
               - No circular dependencies

            4. **Testing Quality**:
               - Table-driven tests used consistently
               - httptest for handler tests
               - Mocks via interfaces (not concrete types)
               - Edge cases covered (empty input, timeouts, context cancellation)
               - Integration tests in tests/ directory

            5. **Middleware Quality** (internal/middleware/**):
               - All middleware composable as Chi middleware (func(next http.Handler) http.Handler)
               - Proper ordering (recovery → logging → auth → rate limit)
               - No middleware doing too much

            **Performance Review** — check for:
            1. **Hot Path Optimization**:
               - Middleware chain efficiency
               - Unnecessary allocations in request path
               - String concatenation in loops (use strings.Builder)
               - Proper use of sync.Pool for frequently allocated objects

            2. **Connection Management**:
               - PostgreSQL connection pooling configured
               - Redis connection pooling configured
               - HTTP client reuse for upstream calls (no new client per request)
               - Proper timeouts on all external calls

            3. **Concurrency**:
               - Goroutine leaks (missing context cancellation)
               - Race conditions (shared state without sync)
               - Channel usage correctness
               - Circuit breaker thread safety

            4. **Resource Management**:
               - Response body Close() calls
               - Database rows Close() calls
               - Graceful shutdown implementation
               - pprof endpoints available for profiling

            5. **Caching**:
               - Redis caching strategy for route configs
               - Cache invalidation correctness
               - TTL configuration

            For each finding, provide:
            - Category: QUALITY or PERFORMANCE
            - Priority: P0 (fix now) / P1 (fix this sprint) / P2 (backlog) / P3 (nice to have)
            - File and line reference
            - Description
            - Suggested improvement with code example

            Output a structured markdown report.
          allowed_tools: "Read,Glob,Grep"
        env:
          ANTHROPIC_API_KEY: \${{ secrets.ANTHROPIC_API_KEY }}

      - name: Upload quality report
        uses: actions/upload-artifact@v4
        with:
          name: quality-audit-report
          path: audit-reports/
          retention-days: 90

  create-audit-issue:
    name: Create Audit Summary Issue
    runs-on: ubuntu-latest
    needs: [prepare-audit, static-analysis, ai-security-audit, ai-quality-audit]
    if: always() && !cancelled()
    steps:
      - name: Determine overall health
        id: health
        run: |
          COVERAGE="\${{ needs.static-analysis.outputs.coverage }}"
          LINT_ISSUES="\${{ needs.static-analysis.outputs.lint_issues }}"
          VULN_COUNT="\${{ needs.static-analysis.outputs.vuln_count }}"
          VET_CLEAN="\${{ needs.static-analysis.outputs.vet_clean }}"

          # Health score (simple heuristic)
          SCORE=100

          # Deduct for low coverage
          if [ "$(echo "\${COVERAGE} < 80" | bc -l 2>/dev/null || echo 1)" = "1" ]; then
            SCORE=$((SCORE - 20))
          fi

          # Deduct for lint issues
          if [ "\${LINT_ISSUES:-0}" -gt 10 ]; then
            SCORE=$((SCORE - 15))
          elif [ "\${LINT_ISSUES:-0}" -gt 0 ]; then
            SCORE=$((SCORE - 5))
          fi

          # Deduct for vulnerabilities
          if [ "\${VULN_COUNT:-0}" -gt 0 ]; then
            SCORE=$((SCORE - 25))
          fi

          # Deduct for vet issues
          if [ "\${VET_CLEAN}" = "false" ]; then
            SCORE=$((SCORE - 10))
          fi

          if [ "\${SCORE}" -ge 90 ]; then
            EMOJI="🟢"
            STATUS="Healthy"
          elif [ "\${SCORE}" -ge 70 ]; then
            EMOJI="🟡"
            STATUS="Needs Attention"
          else
            EMOJI="🔴"
            STATUS="Action Required"
          fi

          echo "score=\${SCORE}" >> "$GITHUB_OUTPUT"
          echo "emoji=\${EMOJI}" >> "$GITHUB_OUTPUT"
          echo "status=\${STATUS}" >> "$GITHUB_OUTPUT"

      - name: Create GitHub Issue
        env:
          GH_TOKEN: \${{ secrets.GITHUB_TOKEN }}
        run: |
          AUDIT_DATE=$(date -u +%Y-%m-%d)
          WEEK_NUM=$(date -u +%V)

          cat > /tmp/audit-issue.md << 'ISSUE_EOF'
          ## \${{ steps.health.outputs.emoji }} Weekly AI Code Audit — \${{ steps.health.outputs.status }}

          **Audit Date**: AUDIT_DATE_PLACEHOLDER
          **Branch**: main
          **Scope**: \${{ needs.prepare-audit.outputs.scope }}
          **Health Score**: \${{ steps.health.outputs.score }}/100

          ### 📊 Codebase Metrics

          | Metric | Value | Status |
          |--------|-------|--------|
          | Go Files | \${{ needs.prepare-audit.outputs.file_count }} | ℹ️ |
          | Total Lines | \${{ needs.prepare-audit.outputs.total_lines }} | ℹ️ |
          | Test Coverage | \${{ needs.static-analysis.outputs.coverage }}% | \${{ needs.static-analysis.outputs.coverage >= 80 && '✅' || '❌ Below 80%' }} |
          | Lint Issues | \${{ needs.static-analysis.outputs.lint_issues }} | \${{ needs.static-analysis.outputs.lint_issues == 0 && '✅' || '⚠️' }} |
          | go vet Clean | \${{ needs.static-analysis.outputs.vet_clean }} | \${{ needs.static-analysis.outputs.vet_clean == 'true' && '✅' || '❌' }} |
          | Known Vulnerabilities | \${{ needs.static-analysis.outputs.vuln_count }} | \${{ needs.static-analysis.outputs.vuln_count == 0 && '✅' || '🔴 Fix immediately' }} |

          ### 📝 Recent PRs This Week

          \${{ needs.prepare-audit.outputs.recent_prs || 'No PRs merged this week.' }}

          ### 🔍 Audit Reports

          Detailed AI-generated reports are available as workflow artifacts:
          - **Security Audit Report** — authentication, authorization, input validation, secrets, SOC 2
          - **Quality & Performance Report** — clean architecture, Go idioms, hot paths, connection pooling

          📎 [View Workflow Run](https://github.com/\${{ github.repository }}/actions/runs/\${{ github.run_id }})

          ### 🎯 Action Items

          > Review the artifact reports and create follow-up issues for any P0/P1 findings.
          > Tag findings with \`audit-finding\` label for tracking.

          ---

          *This audit was generated automatically by the AI Code Audit workflow.*
          *Powered by Claude Code · go-api-gateway · Week WEEK_NUM_PLACEHOLDER*
          ISSUE_EOF

          # Replace placeholders
          sed -i "s/AUDIT_DATE_PLACEHOLDER/\${AUDIT_DATE}/g" /tmp/audit-issue.md
          sed -i "s/WEEK_NUM_PLACEHOLDER/\${WEEK_NUM}/g" /tmp/audit-issue.md

          gh issue create \\
            --repo "\${{ github.repository }}" \\
            --title "\${{ steps.health.outputs.emoji }} AI Code Audit — Week \${WEEK_NUM} \${AUDIT_DATE} — \${{ steps.health.outputs.status }}" \\
            --body-file /tmp/audit-issue.md \\
            --label "audit,ai-generated,maintenance"

  notify-slack:
    name: Notify Team
    runs-on: ubuntu-latest
    needs: [create-audit-issue, static-analysis]
    if: always() && !cancelled()
    steps:
      - name: Send Slack notification
        if: env.SLACK_WEBHOOK_URL != ''
        env:
          SLACK_WEBHOOK_URL: \${{ secrets.SLACK_WEBHOOK_URL }}
        run: |
          COVERAGE="\${{ needs.static-analysis.outputs.coverage }}"
          VULN_COUNT="\${{ needs.static-analysis.outputs.vuln_count }}"

          curl -s -X POST "\${SLACK_WEBHOOK_URL}" \\
            -H 'Content-Type: application/json' \\
            -d "{
              \\"text\\": \\"🔍 *Weekly AI Code Audit Complete* — go-api-gateway\\",
              \\"blocks\\": [
                {
                  \\"type\\": \\"header\\",
                  \\"text\\": {\\"type\\": \\"plain_text\\", \\"text\\": \\"🔍 Weekly AI Code Audit — go-api-gateway\\"}
                },
                {
                  \\"type\\": \\"section\\",
                  \\"fields\\": [
                    {\\"type\\": \\"mrkdwn\\", \\"text\\": \\"*Coverage:* \${COVERAGE}%\\"},
                    {\\"type\\": \\"mrkdwn\\", \\"text\\": \\"*Vulnerabilities:* \${VULN_COUNT}\\"},
                    {\\"type\\": \\"mrkdwn\\", \\"text\\": \\"*Lint Issues:* \${{ needs.static-analysis.outputs.lint_issues }}\\"},
                    {\\"type\\": \\"mrkdwn\\", \\"text\\": \\"*Vet Clean:* \${{ needs.static-analysis.outputs.vet_clean }}\\"}
                  ]
                },
                {
                  \\"type\\": \\"actions\\",
                  \\"elements\\": [
                    {
                      \\"type\\": \\"button\\",
                      \\"text\\": {\\"type\\": \\"plain_text\\", \\"text\\": \\"View Audit Run\\"},
                      \\"url\\": \\"https://github.com/\${{ github.repository }}/actions/runs/\${{ github.run_id }}\\"
                    }
                  ]
                }
              ]
            }"`,

  '.github/workflows/ci.yml': `name: CI

on:
  pull_request:
    branches: [main]
  push:
    branches: [main]

permissions:
  contents: read
  pull-requests: read

env:
  GO_VERSION: "1.22"
  GOLANGCI_LINT_VERSION: "v1.57"
  COVERAGE_THRESHOLD: 80

jobs:
  lint:
    name: Lint
    runs-on: ubuntu-latest
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Go
        uses: actions/setup-go@v5
        with:
          go-version: \${{ env.GO_VERSION }}
          cache: true

      - name: Run golangci-lint
        uses: golangci/golangci-lint-action@v4
        with:
          version: \${{ env.GOLANGCI_LINT_VERSION }}
          args: --timeout=5m --config=.golangci.yml
          skip-cache: false

  vet:
    name: Vet
    runs-on: ubuntu-latest
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Go
        uses: actions/setup-go@v5
        with:
          go-version: \${{ env.GO_VERSION }}
          cache: true

      - name: Download dependencies
        run: go mod download

      - name: Verify dependencies
        run: go mod verify

      - name: Run go vet
        run: go vet ./...

  unit-test:
    name: Unit Tests
    runs-on: ubuntu-latest
    needs: [vet]
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Go
        uses: actions/setup-go@v5
        with:
          go-version: \${{ env.GO_VERSION }}
          cache: true

      - name: Download dependencies
        run: go mod download

      - name: Run unit tests with coverage
        run: |
          go test -v -count=1 -coverprofile=coverage.out -covermode=atomic \\
            -short ./internal/... ./pkg/... ./cmd/...

      - name: Check coverage threshold
        run: |
          COVERAGE=$(go tool cover -func=coverage.out | grep total | awk '{print substr($3, 1, length($3)-1)}')
          echo "Total coverage: \${COVERAGE}%"
          if (( $(echo "$COVERAGE < \${{ env.COVERAGE_THRESHOLD }}" | bc -l) )); then
            echo "::error::Coverage \${COVERAGE}% is below threshold of \${{ env.COVERAGE_THRESHOLD }}%"
            exit 1
          fi
          echo "✅ Coverage \${COVERAGE}% meets threshold of \${{ env.COVERAGE_THRESHOLD }}%"

      - name: Upload coverage report
        uses: actions/upload-artifact@v4
        with:
          name: coverage-report
          path: coverage.out
          retention-days: 7

  race-detection:
    name: Race Detection
    runs-on: ubuntu-latest
    needs: [vet]
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Go
        uses: actions/setup-go@v5
        with:
          go-version: \${{ env.GO_VERSION }}
          cache: true

      - name: Download dependencies
        run: go mod download

      - name: Run tests with race detector
        run: go test -race -count=1 -short ./internal/... ./pkg/... ./cmd/...

  integration-test:
    name: Integration Tests
    runs-on: ubuntu-latest
    needs: [unit-test, race-detection]
    services:
      postgres:
        image: postgres:16-alpine
        env:
          POSTGRES_USER: gateway
          POSTGRES_PASSWORD: gateway_test
          POSTGRES_DB: gateway_test
        ports:
          - 5432:5432
        options: >-
          --health-cmd "pg_isready -U gateway"
          --health-interval 10s
          --health-timeout 5s
          --health-retries 5
      redis:
        image: redis:7-alpine
        ports:
          - 6379:6379
        options: >-
          --health-cmd "redis-cli ping"
          --health-interval 10s
          --health-timeout 5s
          --health-retries 5
    env:
      GATEWAY_DB_HOST: localhost
      GATEWAY_DB_PORT: 5432
      GATEWAY_DB_USER: gateway
      GATEWAY_DB_PASSWORD: gateway_test
      GATEWAY_DB_NAME: gateway_test
      GATEWAY_DB_SSLMODE: disable
      GATEWAY_REDIS_ADDR: localhost:6379
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Go
        uses: actions/setup-go@v5
        with:
          go-version: \${{ env.GO_VERSION }}
          cache: true

      - name: Download dependencies
        run: go mod download

      - name: Run database migrations
        run: |
          if [ -f scripts/migrate.sh ]; then
            chmod +x scripts/migrate.sh
            ./scripts/migrate.sh up
          fi

      - name: Run integration tests
        run: |
          go test -v -count=1 -tags=integration \\
            -timeout=5m ./tests/...

  build:
    name: Build Binary
    runs-on: ubuntu-latest
    needs: [lint, unit-test, race-detection]
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Go
        uses: actions/setup-go@v5
        with:
          go-version: \${{ env.GO_VERSION }}
          cache: true

      - name: Download dependencies
        run: go mod download

      - name: Build gateway binary
        run: |
          CGO_ENABLED=0 GOOS=linux GOARCH=amd64 \\
            go build -ldflags="-s -w -X main.version=\${{ github.sha }}" \\
            -o bin/gateway cmd/gateway/main.go

      - name: Verify binary
        run: |
          file bin/gateway
          ls -lh bin/gateway

      - name: Upload binary
        uses: actions/upload-artifact@v4
        with:
          name: gateway-binary
          path: bin/gateway
          retention-days: 3

  build-docker:
    name: Build Docker Image
    runs-on: ubuntu-latest
    needs: [build, integration-test]
    if: github.event_name == 'push' && github.ref == 'refs/heads/main'
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Docker Buildx
        uses: docker/setup-buildx-action@v3

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          aws-access-key-id: \${{ secrets.AWS_ACCESS_KEY_ID }}
          aws-secret-access-key: \${{ secrets.AWS_SECRET_ACCESS_KEY }}
          aws-region: \${{ vars.AWS_REGION || 'us-east-1' }}

      - name: Login to Amazon ECR
        id: ecr-login
        uses: aws-actions/amazon-ecr-login@v2

      - name: Build and push Docker image
        uses: docker/build-push-action@v5
        with:
          context: .
          file: deployments/Dockerfile
          push: true
          tags: |
            \${{ steps.ecr-login.outputs.registry }}/go-api-gateway:\${{ github.sha }}
            \${{ steps.ecr-login.outputs.registry }}/go-api-gateway:latest
          cache-from: type=gha
          cache-to: type=gha,mode=max
          build-args: |
            VERSION=\${{ github.sha }}

  ai-code-label:
    name: AI Code Label
    runs-on: ubuntu-latest
    if: github.event_name == 'pull_request'
    permissions:
      pull-requests: write
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Check for AI-generated code markers
        id: ai-check
        run: |
          AI_MARKERS=$(git diff origin/main...HEAD -- '*.go' | grep -c '// AI-generated\\|// Generated by Claude\\|// claude-generated' || true)
          echo "ai_markers=$AI_MARKERS" >> "$GITHUB_OUTPUT"
          if [ "$AI_MARKERS" -gt 0 ]; then
            echo "🤖 Found $AI_MARKERS AI-generated code markers"
          fi

      - name: Add AI label
        if: steps.ai-check.outputs.ai_markers > 0
        uses: actions/github-script@v7
        with:
          script: |
            github.rest.issues.addLabels({
              owner: context.repo.owner,
              repo: context.repo.repo,
              issue_number: context.issue.number,
              labels: ['ai-generated']
            });

  status-check:
    name: CI Status
    runs-on: ubuntu-latest
    needs: [lint, vet, unit-test, race-detection, integration-test, build]
    if: always()
    steps:
      - name: Check job results
        run: |
          if [[ "\${{ needs.lint.result }}" == "failure" ]] || \\
             [[ "\${{ needs.vet.result }}" == "failure" ]] || \\
             [[ "\${{ needs.unit-test.result }}" == "failure" ]] || \\
             [[ "\${{ needs.race-detection.result }}" == "failure" ]] || \\
             [[ "\${{ needs.integration-test.result }}" == "failure" ]] || \\
             [[ "\${{ needs.build.result }}" == "failure" ]]; then
            echo "::error::One or more CI jobs failed"
            exit 1
          fi
          echo "✅ All CI checks passed"`,

  '.github/workflows/deploy-production.yml': `name: Deploy Production

on:
  workflow_dispatch:
    inputs:
      version:
        description: 'Version tag to deploy (e.g., v1.2.3)'
        required: true
        type: string
      canary_percentage:
        description: 'Initial canary traffic percentage'
        required: false
        type: choice
        options:
          - '5'
          - '10'
          - '25'
        default: '10'
      skip_canary:
        description: 'Skip canary and deploy 100% immediately'
        required: false
        type: boolean
        default: false
      rollback_version:
        description: 'Version to rollback to (leave empty for normal deploy)'
        required: false
        type: string

concurrency:
  group: production-deploy
  cancel-in-progress: false

env:
  AWS_REGION: us-east-1
  ECR_REPOSITORY: go-api-gateway
  ECS_CLUSTER: gateway-production
  ECS_SERVICE: api-gateway
  HELM_RELEASE: api-gateway
  K8S_NAMESPACE: gateway-production
  BINARY_NAME: gateway
  HEALTH_CHECK_URL: https://api.production.example.com/healthz
  READINESS_CHECK_URL: https://api.production.example.com/readyz
  METRICS_URL: https://api.production.example.com/metrics

permissions:
  id-token: write
  contents: read
  deployments: write
  actions: read

jobs:
  # -------------------------------------------------------------------
  # Gate: Validate the version exists and CI passed
  # -------------------------------------------------------------------
  validate:
    name: Validate Release
    runs-on: ubuntu-latest
    outputs:
      image_tag: \${{ steps.resolve.outputs.image_tag }}
      is_rollback: \${{ steps.resolve.outputs.is_rollback }}
      deploy_version: \${{ steps.resolve.outputs.deploy_version }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Resolve deploy version
        id: resolve
        run: |
          if [ -n "\${{ inputs.rollback_version }}" ]; then
            echo "is_rollback=true" >> "$GITHUB_OUTPUT"
            echo "deploy_version=\${{ inputs.rollback_version }}" >> "$GITHUB_OUTPUT"
            echo "image_tag=\${{ inputs.rollback_version }}" >> "$GITHUB_OUTPUT"
            echo "🔄 Rollback deployment to \${{ inputs.rollback_version }}"
          else
            echo "is_rollback=false" >> "$GITHUB_OUTPUT"
            echo "deploy_version=\${{ inputs.version }}" >> "$GITHUB_OUTPUT"
            echo "image_tag=\${{ inputs.version }}" >> "$GITHUB_OUTPUT"
            echo "🚀 Forward deployment of \${{ inputs.version }}"
          fi

      - name: Verify git tag exists
        run: |
          VERSION="\${{ steps.resolve.outputs.deploy_version }}"
          if ! git rev-parse "refs/tags/\${VERSION}" >/dev/null 2>&1; then
            echo "::error::Tag \${VERSION} does not exist. Create a release first."
            exit 1
          fi
          echo "✅ Tag \${VERSION} exists"

      - name: Verify CI passed for tag
        uses: actions/github-script@v7
        with:
          script: |
            const version = '\${{ steps.resolve.outputs.deploy_version }}';
            const tag = await github.rest.git.getRef({
              owner: context.repo.owner,
              repo: context.repo.repo,
              ref: \`tags/\${version}\`
            });
            const sha = tag.data.object.sha;

            const checks = await github.rest.checks.listForRef({
              owner: context.repo.owner,
              repo: context.repo.repo,
              ref: sha,
              filter: 'latest'
            });

            const ciRun = checks.data.check_runs.find(r => r.name.includes('build') || r.name.includes('test'));
            if (!ciRun) {
              core.warning('No CI check runs found for this tag. Proceeding with caution.');
              return;
            }

            if (ciRun.conclusion !== 'success') {
              core.setFailed(\`CI check "\${ciRun.name}" has conclusion: \${ciRun.conclusion}. Cannot deploy.\`);
            }

            core.info(\`✅ CI passed for \${version} (sha: \${sha.substring(0, 8)})\`);

      - name: Verify Docker image exists in ECR
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Check ECR image
        run: |
          IMAGE_TAG="\${{ steps.resolve.outputs.image_tag }}"
          aws ecr describe-images \\
            --repository-name "\${{ env.ECR_REPOSITORY }}" \\
            --image-ids imageTag="\${IMAGE_TAG}" \\
            --region "\${{ env.AWS_REGION }}" > /dev/null 2>&1 || {
            echo "::error::Docker image \${ECR_REPOSITORY}:\${IMAGE_TAG} not found in ECR"
            exit 1
          }
          echo "✅ Docker image exists: \${ECR_REPOSITORY}:\${IMAGE_TAG}"

  # -------------------------------------------------------------------
  # Gate: Manual approval from authorized deployers
  # -------------------------------------------------------------------
  approval:
    name: Production Approval
    needs: validate
    runs-on: ubuntu-latest
    environment:
      name: production
      url: https://api.production.example.com
    steps:
      - name: Approval granted
        run: |
          echo "✅ Production deployment approved by \${{ github.actor }}"
          echo "Version: \${{ needs.validate.outputs.deploy_version }}"
          echo "Rollback: \${{ needs.validate.outputs.is_rollback }}"

  # -------------------------------------------------------------------
  # Pre-deploy: Database migrations (if any)
  # -------------------------------------------------------------------
  pre-deploy:
    name: Pre-Deploy Checks
    needs: [validate, approval]
    runs-on: ubuntu-latest
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.validate.outputs.deploy_version }}

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Run database migrations
        if: needs.validate.outputs.is_rollback == 'false'
        run: |
          echo "🗄️ Checking for pending migrations..."
          # Retrieve database URL from AWS Secrets Manager
          DB_URL=$(aws secretsmanager get-secret-value \\
            --secret-id "production/gateway/database-url" \\
            --query 'SecretString' --output text)

          # Run migrations using golang-migrate
          docker run --rm \\
            -e DATABASE_URL="\${DB_URL}" \\
            migrate/migrate:v4 \\
            -path=/migrations \\
            -database "\${DB_URL}" \\
            up || {
            echo "::error::Database migration failed. Aborting deployment."
            exit 1
          }
          echo "✅ Migrations complete"

      - name: Snapshot current deployment state
        id: snapshot
        run: |
          # Record current task definition for rollback
          CURRENT_TD=$(aws ecs describe-services \\
            --cluster "\${{ env.ECS_CLUSTER }}" \\
            --services "\${{ env.ECS_SERVICE }}" \\
            --query 'services[0].taskDefinition' \\
            --output text)
          echo "current_task_definition=\${CURRENT_TD}" >> "$GITHUB_OUTPUT"
          echo "📸 Current task definition: \${CURRENT_TD}"

  # -------------------------------------------------------------------
  # Canary deployment: Route small percentage of traffic
  # -------------------------------------------------------------------
  canary-deploy:
    name: Canary Deployment
    needs: [validate, pre-deploy]
    if: inputs.skip_canary == false
    runs-on: ubuntu-latest
    outputs:
      canary_task_definition: \${{ steps.deploy-canary.outputs.task_definition_arn }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.validate.outputs.deploy_version }}

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Login to Amazon ECR
        id: ecr-login
        uses: aws-actions/amazon-ecr-login@v2

      - name: Create GitHub deployment
        id: deployment
        uses: actions/github-script@v7
        with:
          script: |
            const deployment = await github.rest.repos.createDeployment({
              owner: context.repo.owner,
              repo: context.repo.repo,
              ref: '\${{ needs.validate.outputs.deploy_version }}',
              environment: 'production-canary',
              description: \`Canary deploy \${{ needs.validate.outputs.deploy_version }} at \${{ inputs.canary_percentage }}%\`,
              auto_merge: false,
              required_contexts: []
            });
            core.setOutput('deployment_id', deployment.data.id);

      - name: Register new task definition
        id: deploy-canary
        run: |
          IMAGE_TAG="\${{ needs.validate.outputs.image_tag }}"
          ECR_REGISTRY="\${{ steps.ecr-login.outputs.registry }}"
          FULL_IMAGE="\${ECR_REGISTRY}/\${{ env.ECR_REPOSITORY }}:\${IMAGE_TAG}"

          # Render task definition with new image
          TASK_DEF=$(aws ecs describe-task-definition \\
            --task-definition "\${{ env.ECS_SERVICE }}" \\
            --query 'taskDefinition' \\
            --output json)

          NEW_TASK_DEF=$(echo "$TASK_DEF" | jq \\
            --arg IMAGE "$FULL_IMAGE" \\
            --arg VERSION "$IMAGE_TAG" \\
            '.containerDefinitions[0].image = $IMAGE |
             .containerDefinitions[0].environment += [{"name": "APP_VERSION", "value": $VERSION}] |
             del(.taskDefinitionArn, .revision, .status, .requiresAttributes, .compatibilities, .registeredAt, .registeredBy)')

          REGISTERED=$(aws ecs register-task-definition \\
            --cli-input-json "$NEW_TASK_DEF" \\
            --query 'taskDefinition.taskDefinitionArn' \\
            --output text)

          echo "task_definition_arn=\${REGISTERED}" >> "$GITHUB_OUTPUT"
          echo "🐤 Canary task definition: \${REGISTERED}"

      - name: Deploy canary target group
        run: |
          CANARY_WEIGHT="\${{ inputs.canary_percentage }}"
          STABLE_WEIGHT=$((100 - CANARY_WEIGHT))

          echo "🔀 Setting traffic split: stable=\${STABLE_WEIGHT}%, canary=\${CANARY_WEIGHT}%"

          # Update ALB listener rule with weighted target groups
          aws elbv2 modify-rule \\
            --rule-arn "\${{ secrets.ALB_LISTENER_RULE_ARN }}" \\
            --actions "[
              {
                \\"Type\\": \\"forward\\",
                \\"ForwardConfig\\": {
                  \\"TargetGroups\\": [
                    {
                      \\"TargetGroupArn\\": \\"\${{ secrets.STABLE_TARGET_GROUP_ARN }}\\",
                      \\"Weight\\": \${STABLE_WEIGHT}
                    },
                    {
                      \\"TargetGroupArn\\": \\"\${{ secrets.CANARY_TARGET_GROUP_ARN }}\\",
                      \\"Weight\\": \${CANARY_WEIGHT}
                    }
                  ]
                }
              }
            ]"

          # Deploy canary tasks
          aws ecs update-service \\
            --cluster "\${{ env.ECS_CLUSTER }}" \\
            --service "\${{ env.ECS_SERVICE }}-canary" \\
            --task-definition "\${{ steps.deploy-canary.outputs.task_definition_arn }}" \\
            --desired-count 2

          echo "⏳ Waiting for canary service to stabilize..."
          aws ecs wait services-stable \\
            --cluster "\${{ env.ECS_CLUSTER }}" \\
            --services "\${{ env.ECS_SERVICE }}-canary"

          echo "✅ Canary deployment active at \${CANARY_WEIGHT}% traffic"

  # -------------------------------------------------------------------
  # Canary verification: Health checks, error rates, latency
  # -------------------------------------------------------------------
  canary-verify:
    name: Canary Verification
    needs: [validate, canary-deploy]
    if: inputs.skip_canary == false
    runs-on: ubuntu-latest
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.validate.outputs.deploy_version }}

      - name: Wait for canary warm-up
        run: |
          echo "⏳ Waiting 60 seconds for canary to warm up..."
          sleep 60

      - name: Health check verification
        id: health
        run: |
          MAX_RETRIES=10
          RETRY_INTERVAL=15
          for i in $(seq 1 $MAX_RETRIES); do
            echo "Health check attempt \${i}/\${MAX_RETRIES}..."
            HTTP_CODE=$(curl -s -o /dev/null -w "%{http_code}" \\
              -H "X-Canary: true" \\
              "\${{ env.HEALTH_CHECK_URL }}" || echo "000")

            if [ "$HTTP_CODE" = "200" ]; then
              echo "✅ Health check passed (HTTP \${HTTP_CODE})"
              echo "healthy=true" >> "$GITHUB_OUTPUT"
              break
            fi

            if [ "$i" = "$MAX_RETRIES" ]; then
              echo "::error::Health check failed after \${MAX_RETRIES} attempts (last HTTP \${HTTP_CODE})"
              echo "healthy=false" >> "$GITHUB_OUTPUT"
              exit 1
            fi

            echo "⏳ Retrying in \${RETRY_INTERVAL}s..."
            sleep $RETRY_INTERVAL
          done

      - name: Readiness check
        run: |
          HTTP_CODE=$(curl -s -o /dev/null -w "%{http_code}" \\
            "\${{ env.READINESS_CHECK_URL }}")
          if [ "$HTTP_CODE" != "200" ]; then
            echo "::error::Readiness check failed (HTTP \${HTTP_CODE})"
            exit 1
          fi
          echo "✅ Readiness check passed"

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Verify error rate from CloudWatch
        id: error-rate
        run: |
          echo "📊 Checking canary error rate over last 5 minutes..."

          END_TIME=$(date -u +%Y-%m-%dT%H:%M:%S)
          START_TIME=$(date -u -d '5 minutes ago' +%Y-%m-%dT%H:%M:%S 2>/dev/null || \\
                       date -u -v-5M +%Y-%m-%dT%H:%M:%S)

          # Query 5xx error rate from CloudWatch
          ERROR_RATE=$(aws cloudwatch get-metric-statistics \\
            --namespace "APIGateway/Production" \\
            --metric-name "HTTPServerErrors" \\
            --dimensions Name=ServiceName,Value="\${{ env.ECS_SERVICE }}-canary" \\
            --start-time "$START_TIME" \\
            --end-time "$END_TIME" \\
            --period 300 \\
            --statistics Average \\
            --query 'Datapoints[0].Average' \\
            --output text 2>/dev/null || echo "0")

          if [ "$ERROR_RATE" = "None" ]; then
            ERROR_RATE="0"
          fi

          echo "Error rate: \${ERROR_RATE}%"

          # Fail if error rate exceeds 1%
          THRESHOLD="1.0"
          if [ "$(echo "$ERROR_RATE > $THRESHOLD" | bc -l 2>/dev/null || echo 0)" = "1" ]; then
            echo "::error::Canary error rate \${ERROR_RATE}% exceeds threshold \${THRESHOLD}%"
            echo "passed=false" >> "$GITHUB_OUTPUT"
            exit 1
          fi

          echo "✅ Error rate \${ERROR_RATE}% within threshold"
          echo "passed=true" >> "$GITHUB_OUTPUT"

      - name: Verify latency from CloudWatch
        run: |
          END_TIME=$(date -u +%Y-%m-%dT%H:%M:%S)
          START_TIME=$(date -u -d '5 minutes ago' +%Y-%m-%dT%H:%M:%S 2>/dev/null || \\
                       date -u -v-5M +%Y-%m-%dT%H:%M:%S)

          P99_LATENCY=$(aws cloudwatch get-metric-statistics \\
            --namespace "APIGateway/Production" \\
            --metric-name "ResponseLatency" \\
            --dimensions Name=ServiceName,Value="\${{ env.ECS_SERVICE }}-canary" \\
            --start-time "$START_TIME" \\
            --end-time "$END_TIME" \\
            --period 300 \\
            --extended-statistics p99 \\
            --query 'Datapoints[0].ExtendedStatistics.p99' \\
            --output text 2>/dev/null || echo "0")

          if [ "$P99_LATENCY" = "None" ]; then
            P99_LATENCY="0"
          fi

          echo "P99 latency: \${P99_LATENCY}ms"

          # Fail if p99 latency exceeds 500ms
          THRESHOLD="500"
          if [ "$(echo "$P99_LATENCY > $THRESHOLD" | bc -l 2>/dev/null || echo 0)" = "1" ]; then
            echo "::warning::Canary P99 latency \${P99_LATENCY}ms exceeds threshold \${THRESHOLD}ms"
          fi

          echo "✅ Latency check complete"

      - name: Canary verification summary
        run: |
          echo "## 🐤 Canary Verification Summary" >> "$GITHUB_STEP_SUMMARY"
          echo "" >> "$GITHUB_STEP_SUMMARY"
          echo "| Check | Status |" >> "$GITHUB_STEP_SUMMARY"
          echo "|-------|--------|" >> "$GITHUB_STEP_SUMMARY"
          echo "| Health Check | ✅ Passed |" >> "$GITHUB_STEP_SUMMARY"
          echo "| Readiness Check | ✅ Passed |" >> "$GITHUB_STEP_SUMMARY"
          echo "| Error Rate | ✅ Within threshold |" >> "$GITHUB_STEP_SUMMARY"
          echo "| P99 Latency | ✅ Checked |" >> "$GITHUB_STEP_SUMMARY"
          echo "" >> "$GITHUB_STEP_SUMMARY"
          echo "Version: \\\`\${{ needs.validate.outputs.deploy_version }}\\\`" >> "$GITHUB_STEP_SUMMARY"
          echo "Canary traffic: \${{ inputs.canary_percentage }}%" >> "$GITHUB_STEP_SUMMARY"

  # -------------------------------------------------------------------
  # Full production rollout
  # -------------------------------------------------------------------
  production-deploy:
    name: Production Rollout
    needs: [validate, canary-deploy, canary-verify]
    if: always() && (needs.canary-verify.result == 'success' || inputs.skip_canary == true) && needs.validate.result == 'success'
    runs-on: ubuntu-latest
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.validate.outputs.deploy_version }}

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Login to Amazon ECR
        id: ecr-login
        uses: aws-actions/amazon-ecr-login@v2

      - name: Register production task definition
        id: task-def
        run: |
          IMAGE_TAG="\${{ needs.validate.outputs.image_tag }}"
          ECR_REGISTRY="\${{ steps.ecr-login.outputs.registry }}"
          FULL_IMAGE="\${ECR_REGISTRY}/\${{ env.ECR_REPOSITORY }}:\${IMAGE_TAG}"

          TASK_DEF=$(aws ecs describe-task-definition \\
            --task-definition "\${{ env.ECS_SERVICE }}" \\
            --query 'taskDefinition' \\
            --output json)

          NEW_TASK_DEF=$(echo "$TASK_DEF" | jq \\
            --arg IMAGE "$FULL_IMAGE" \\
            --arg VERSION "$IMAGE_TAG" \\
            '.containerDefinitions[0].image = $IMAGE |
             .containerDefinitions[0].environment += [{"name": "APP_VERSION", "value": $VERSION}] |
             del(.taskDefinitionArn, .revision, .status, .requiresAttributes, .compatibilities, .registeredAt, .registeredBy)')

          REGISTERED=$(aws ecs register-task-definition \\
            --cli-input-json "$NEW_TASK_DEF" \\
            --query 'taskDefinition.taskDefinitionArn' \\
            --output text)

          echo "task_definition_arn=\${REGISTERED}" >> "$GITHUB_OUTPUT"
          echo "🚀 Production task definition: \${REGISTERED}"

      - name: Shift all traffic to stable
        if: inputs.skip_canary == false
        run: |
          echo "🔀 Shifting 100% traffic to stable target group..."
          aws elbv2 modify-rule \\
            --rule-arn "\${{ secrets.ALB_LISTENER_RULE_ARN }}" \\
            --actions "[
              {
                \\"Type\\": \\"forward\\",
                \\"ForwardConfig\\": {
                  \\"TargetGroups\\": [
                    {
                      \\"TargetGroupArn\\": \\"\${{ secrets.STABLE_TARGET_GROUP_ARN }}\\",
                      \\"Weight\\": 100
                    },
                    {
                      \\"TargetGroupArn\\": \\"\${{ secrets.CANARY_TARGET_GROUP_ARN }}\\",
                      \\"Weight\\": 0
                    }
                  ]
                }
              }
            ]"

      - name: Deploy to production ECS service
        run: |
          echo "🚀 Deploying to production..."
          aws ecs update-service \\
            --cluster "\${{ env.ECS_CLUSTER }}" \\
            --service "\${{ env.ECS_SERVICE }}" \\
            --task-definition "\${{ steps.task-def.outputs.task_definition_arn }}" \\
            --force-new-deployment

          echo "⏳ Waiting for production service to stabilize..."
          aws ecs wait services-stable \\
            --cluster "\${{ env.ECS_CLUSTER }}" \\
            --services "\${{ env.ECS_SERVICE }}"

          echo "✅ Production deployment complete"

      - name: Scale down canary
        if: inputs.skip_canary == false
        run: |
          echo "🧹 Scaling down canary service..."
          aws ecs update-service \\
            --cluster "\${{ env.ECS_CLUSTER }}" \\
            --service "\${{ env.ECS_SERVICE }}-canary" \\
            --desired-count 0 || true

  # -------------------------------------------------------------------
  # Post-deploy verification
  # -------------------------------------------------------------------
  post-deploy-verify:
    name: Post-Deploy Verification
    needs: [validate, production-deploy]
    runs-on: ubuntu-latest
    steps:
      - name: Health check — production
        run: |
          MAX_RETRIES=15
          RETRY_INTERVAL=10
          for i in $(seq 1 $MAX_RETRIES); do
            echo "Production health check attempt \${i}/\${MAX_RETRIES}..."
            RESPONSE=$(curl -s -w "\\n%{http_code}" "\${{ env.HEALTH_CHECK_URL }}" || echo -e "\\n000")
            BODY=$(echo "$RESPONSE" | head -n -1)
            HTTP_CODE=$(echo "$RESPONSE" | tail -n 1)

            if [ "$HTTP_CODE" = "200" ]; then
              echo "✅ Production health check passed"
              echo "$BODY" | jq . 2>/dev/null || echo "$BODY"
              break
            fi

            if [ "$i" = "$MAX_RETRIES" ]; then
              echo "::error::Production health check failed after \${MAX_RETRIES} attempts"
              exit 1
            fi

            sleep $RETRY_INTERVAL
          done

      - name: Readiness check — production
        run: |
          HTTP_CODE=$(curl -s -o /dev/null -w "%{http_code}" "\${{ env.READINESS_CHECK_URL }}")
          if [ "$HTTP_CODE" != "200" ]; then
            echo "::error::Production readiness check failed (HTTP \${HTTP_CODE})"
            exit 1
          fi
          echo "✅ Production readiness check passed"

      - name: Verify deployed version
        run: |
          EXPECTED="\${{ needs.validate.outputs.deploy_version }}"
          ACTUAL=$(curl -s "\${{ env.HEALTH_CHECK_URL }}" | jq -r '.version // empty' 2>/dev/null || echo "unknown")

          echo "Expected version: \${EXPECTED}"
          echo "Deployed version: \${ACTUAL}"

          if [ "$ACTUAL" != "$EXPECTED" ] && [ "$ACTUAL" != "unknown" ]; then
            echo "::warning::Version mismatch — expected \${EXPECTED}, got \${ACTUAL}"
          else
            echo "✅ Version verified"
          fi

      - name: Smoke test — critical endpoints
        run: |
          FAILURES=0
          BASE_URL="https://api.production.example.com"

          echo "🔍 Running smoke tests..."

          # Test health endpoint
          if ! curl -sf "\${BASE_URL}/healthz" > /dev/null 2>&1; then
            echo "::error::Smoke test failed: GET /healthz"
            FAILURES=$((FAILURES + 1))
          else
            echo "  ✅ GET /healthz"
          fi

          # Test readiness endpoint
          if ! curl -sf "\${BASE_URL}/readyz" > /dev/null 2>&1; then
            echo "::error::Smoke test failed: GET /readyz"
            FAILURES=$((FAILURES + 1))
          else
            echo "  ✅ GET /readyz"
          fi

          # Test metrics endpoint (Prometheus)
          METRICS_CODE=$(curl -s -o /dev/null -w "%{http_code}" "\${BASE_URL}/metrics")
          if [ "$METRICS_CODE" != "200" ]; then
            echo "::error::Smoke test failed: GET /metrics (HTTP \${METRICS_CODE})"
            FAILURES=$((FAILURES + 1))
          else
            echo "  ✅ GET /metrics"
          fi

          # Test unauthenticated request returns 401
          AUTH_CODE=$(curl -s -o /dev/null -w "%{http_code}" "\${BASE_URL}/api/v1/routes")
          if [ "$AUTH_CODE" != "401" ]; then
            echo "::warning::Expected 401 for unauthenticated request, got \${AUTH_CODE}"
          else
            echo "  ✅ GET /api/v1/routes returns 401 (auth required)"
          fi

          if [ "$FAILURES" -gt 0 ]; then
            echo "::error::\${FAILURES} smoke test(s) failed"
            exit 1
          fi

          echo "✅ All smoke tests passed"

  # -------------------------------------------------------------------
  # Notify and record deployment
  # -------------------------------------------------------------------
  notify:
    name: Deployment Notification
    needs: [validate, production-deploy, post-deploy-verify]
    if: always()
    runs-on: ubuntu-latest
    steps:
      - name: Determine deployment status
        id: status
        run: |
          if [ "\${{ needs.post-deploy-verify.result }}" = "success" ]; then
            echo "status=success" >> "$GITHUB_OUTPUT"
            echo "emoji=✅" >> "$GITHUB_OUTPUT"
            echo "color=#36a64f" >> "$GITHUB_OUTPUT"
          elif [ "\${{ needs.production-deploy.result }}" = "failure" ]; then
            echo "status=failed" >> "$GITHUB_OUTPUT"
            echo "emoji=❌" >> "$GITHUB_OUTPUT"
            echo "color=#dc3545" >> "$GITHUB_OUTPUT"
          else
            echo "status=unknown" >> "$GITHUB_OUTPUT"
            echo "emoji=⚠️" >> "$GITHUB_OUTPUT"
            echo "color=#ffc107" >> "$GITHUB_OUTPUT"
          fi

      - name: Notify Slack
        if: always()
        uses: slackapi/slack-github-action@v1.26.0
        with:
          payload: |
            {
              "attachments": [
                {
                  "color": "\${{ steps.status.outputs.color }}",
                  "blocks": [
                    {
                      "type": "header",
                      "text": {
                        "type": "plain_text",
                        "text": "\${{ steps.status.outputs.emoji }} Production Deploy: \${{ steps.status.outputs.status }}"
                      }
                    },
                    {
                      "type": "section",
                      "fields": [
                        { "type": "mrkdwn", "text": "*Service:*\\ngo-api-gateway" },
                        { "type": "mrkdwn", "text": "*Version:*\\n\${{ needs.validate.outputs.deploy_version }}" },
                        { "type": "mrkdwn", "text": "*Deployed by:*\\n\${{ github.actor }}" },
                        { "type": "mrkdwn", "text": "*Rollback:*\\n\${{ needs.validate.outputs.is_rollback }}" }
                      ]
                    },
                    {
                      "type": "actions",
                      "elements": [
                        {
                          "type": "button",
                          "text": { "type": "plain_text", "text": "View Workflow" },
                          "url": "\${{ github.server_url }}/\${{ github.repository }}/actions/runs/\${{ github.run_id }}"
                        },
                        {
                          "type": "button",
                          "text": { "type": "plain_text", "text": "Grafana Dashboard" },
                          "url": "https://grafana.example.com/d/api-gateway-prod"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
        env:
          SLACK_WEBHOOK_URL: \${{ secrets.SLACK_PRODUCTION_WEBHOOK }}
          SLACK_WEBHOOK_TYPE: INCOMING_WEBHOOK

      - name: Create GitHub deployment status
        if: always()
        uses: actions/github-script@v7
        with:
          script: |
            const status = '\${{ steps.status.outputs.status }}';
            const state = status === 'success' ? 'success' : 'failure';

            // Find the deployment
            const deployments = await github.rest.repos.listDeployments({
              owner: context.repo.owner,
              repo: context.repo.repo,
              environment: 'production',
              per_page: 1
            });

            if`,

  '.github/workflows/deploy-staging.yml': `name: Deploy Staging

on:
  push:
    branches: [main]
  workflow_dispatch:
    inputs:
      skip_tests:
        description: "Skip test stage (emergency deploy)"
        required: false
        default: "false"
        type: boolean

concurrency:
  group: deploy-staging
  cancel-in-progress: true

env:
  GO_VERSION: "1.22"
  AWS_REGION: us-east-1
  ECR_REPOSITORY: go-api-gateway
  ECS_CLUSTER: gateway-staging
  ECS_SERVICE: gateway-staging-svc
  ECS_TASK_DEFINITION: deployments/ecs/task-definition-staging.json
  CONTAINER_NAME: gateway

permissions:
  id-token: write
  contents: read
  packages: write

jobs:
  lint-and-vet:
    name: Lint & Vet
    runs-on: ubuntu-latest
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Go
        uses: actions/setup-go@v5
        with:
          go-version: \${{ env.GO_VERSION }}
          cache: true

      - name: Run go vet
        run: go vet ./...

      - name: Run golangci-lint
        uses: golangci/golangci-lint-action@v4
        with:
          version: v1.57
          args: --timeout=5m

  test:
    name: Test
    runs-on: ubuntu-latest
    if: \${{ github.event.inputs.skip_tests != 'true' }}
    services:
      postgres:
        image: postgres:16-alpine
        env:
          POSTGRES_USER: gateway_test
          POSTGRES_PASSWORD: test_password
          POSTGRES_DB: gateway_test
        ports:
          - 5432:5432
        options: >-
          --health-cmd pg_isready
          --health-interval 10s
          --health-timeout 5s
          --health-retries 5
      redis:
        image: redis:7-alpine
        ports:
          - 6379:6379
        options: >-
          --health-cmd "redis-cli ping"
          --health-interval 10s
          --health-timeout 5s
          --health-retries 5
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Go
        uses: actions/setup-go@v5
        with:
          go-version: \${{ env.GO_VERSION }}
          cache: true

      - name: Run unit tests
        run: go test -race -coverprofile=coverage.out -covermode=atomic ./internal/... ./pkg/...
        env:
          DATABASE_URL: postgres://gateway_test:test_password@localhost:5432/gateway_test?sslmode=disable
          REDIS_URL: redis://localhost:6379/0

      - name: Check coverage threshold
        run: |
          COVERAGE=$(go tool cover -func=coverage.out | grep total | awk '{print $3}' | sed 's/%//')
          echo "Total coverage: \${COVERAGE}%"
          if (( $(echo "$COVERAGE < 80" | bc -l) )); then
            echo "::error::Coverage \${COVERAGE}% is below 80% threshold"
            exit 1
          fi

      - name: Run integration tests
        run: go test -race -tags=integration -timeout=5m ./tests/...
        env:
          DATABASE_URL: postgres://gateway_test:test_password@localhost:5432/gateway_test?sslmode=disable
          REDIS_URL: redis://localhost:6379/0
          GATEWAY_ENV: test

      - name: Upload coverage
        uses: actions/upload-artifact@v4
        with:
          name: coverage-report
          path: coverage.out
          retention-days: 7

  build-binary:
    name: Build Binary
    runs-on: ubuntu-latest
    needs: [lint-and-vet]
    outputs:
      version: \${{ steps.version.outputs.version }}
      commit_sha: \${{ steps.version.outputs.commit_sha }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Set up Go
        uses: actions/setup-go@v5
        with:
          go-version: \${{ env.GO_VERSION }}
          cache: true

      - name: Determine version
        id: version
        run: |
          COMMIT_SHA="\${GITHUB_SHA::8}"
          VERSION="staging-\${COMMIT_SHA}-$(date +%Y%m%d%H%M%S)"
          echo "version=\${VERSION}" >> "$GITHUB_OUTPUT"
          echo "commit_sha=\${COMMIT_SHA}" >> "$GITHUB_OUTPUT"
          echo "Building version: \${VERSION}"

      - name: Build binary
        run: |
          CGO_ENABLED=0 GOOS=linux GOARCH=amd64 go build \\
            -ldflags="-s -w \\
              -X main.version=\${{ steps.version.outputs.version }} \\
              -X main.commit=\${{ github.sha }} \\
              -X main.buildTime=$(date -u +%Y-%m-%dT%H:%M:%SZ)" \\
            -o bin/gateway \\
            cmd/gateway/main.go

      - name: Verify binary
        run: |
          file bin/gateway
          ls -lh bin/gateway

      - name: Upload binary
        uses: actions/upload-artifact@v4
        with:
          name: gateway-binary
          path: bin/gateway
          retention-days: 5

  build-and-push-image:
    name: Build & Push Docker Image
    runs-on: ubuntu-latest
    needs: [build-binary, test]
    if: |
      always() &&
      needs.build-binary.result == 'success' &&
      (needs.test.result == 'success' || needs.test.result == 'skipped')
    outputs:
      image_uri: \${{ steps.push.outputs.image_uri }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Download binary
        uses: actions/download-artifact@v4
        with:
          name: gateway-binary
          path: bin/

      - name: Make binary executable
        run: chmod +x bin/gateway

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Login to Amazon ECR
        id: ecr-login
        uses: aws-actions/amazon-ecr-login@v2

      - name: Set up Docker Buildx
        uses: docker/setup-buildx-action@v3

      - name: Build and push Docker image
        id: push
        env:
          ECR_REGISTRY: \${{ steps.ecr-login.outputs.registry }}
          IMAGE_TAG: \${{ needs.build-binary.outputs.version }}
        run: |
          IMAGE_URI="\${ECR_REGISTRY}/\${ECR_REPOSITORY}:\${IMAGE_TAG}"
          LATEST_URI="\${ECR_REGISTRY}/\${ECR_REPOSITORY}:staging-latest"

          docker buildx build \\
            --platform linux/amd64 \\
            --build-arg BINARY_PATH=bin/gateway \\
            --label "org.opencontainers.image.source=https://github.com/\${{ github.repository }}" \\
            --label "org.opencontainers.image.revision=\${{ github.sha }}" \\
            --label "org.opencontainers.image.version=\${IMAGE_TAG}" \\
            --label "ai.generated=false" \\
            --tag "\${IMAGE_URI}" \\
            --tag "\${LATEST_URI}" \\
            --file deployments/docker/Dockerfile \\
            --push \\
            .

          echo "image_uri=\${IMAGE_URI}" >> "$GITHUB_OUTPUT"
          echo "Pushed image: \${IMAGE_URI}"

      - name: Scan image for vulnerabilities
        uses: aquasecurity/trivy-action@master
        with:
          image-ref: \${{ steps.push.outputs.image_uri }}
          format: table
          exit-code: 1
          severity: CRITICAL,HIGH
          ignore-unfixed: true

  deploy-staging:
    name: Deploy to ECS Staging
    runs-on: ubuntu-latest
    needs: [build-and-push-image, build-binary]
    environment:
      name: staging
      url: https://gateway-staging.internal.example.com/health
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Update ECS task definition
        id: task-def
        uses: aws-actions/amazon-ecs-render-task-definition@v1
        with:
          task-definition: \${{ env.ECS_TASK_DEFINITION }}
          container-name: \${{ env.CONTAINER_NAME }}
          image: \${{ needs.build-and-push-image.outputs.image_uri }}
          environment-variables: |
            GATEWAY_ENV=staging
            GATEWAY_VERSION=\${{ needs.build-binary.outputs.version }}
            GATEWAY_COMMIT=\${{ github.sha }}
            OTEL_SERVICE_NAME=go-api-gateway
            OTEL_ENVIRONMENT=staging
            LOG_LEVEL=info
            LOG_FORMAT=json

      - name: Deploy to ECS
        uses: aws-actions/amazon-ecs-deploy-task-definition@v1
        with:
          task-definition: \${{ steps.task-def.outputs.task-definition }}
          service: \${{ env.ECS_SERVICE }}
          cluster: \${{ env.ECS_CLUSTER }}
          wait-for-service-stability: true
          wait-for-minutes: 10

      - name: Verify deployment health
        run: |
          echo "Waiting for service to stabilize..."
          sleep 30

          MAX_RETRIES=10
          RETRY_INTERVAL=15
          HEALTH_URL="https://gateway-staging.internal.example.com/health"

          for i in $(seq 1 $MAX_RETRIES); do
            echo "Health check attempt \${i}/\${MAX_RETRIES}..."
            HTTP_STATUS=$(curl -s -o /dev/null -w "%{http_code}" --max-time 10 "\${HEALTH_URL}" || echo "000")

            if [ "$HTTP_STATUS" = "200" ]; then
              echo "Health check passed (HTTP \${HTTP_STATUS})"
              HEALTH_BODY=$(curl -s --max-time 10 "\${HEALTH_URL}")
              echo "Response: \${HEALTH_BODY}"
              exit 0
            fi

            echo "Health check returned HTTP \${HTTP_STATUS}, retrying in \${RETRY_INTERVAL}s..."
            sleep $RETRY_INTERVAL
          done

          echo "::error::Health check failed after \${MAX_RETRIES} attempts"
          exit 1

      - name: Verify Prometheus metrics endpoint
        run: |
          METRICS_STATUS=$(curl -s -o /dev/null -w "%{http_code}" --max-time 10 \\
            "https://gateway-staging.internal.example.com/metrics" || echo "000")
          if [ "$METRICS_STATUS" = "200" ]; then
            echo "Metrics endpoint is healthy"
          else
            echo "::warning::Metrics endpoint returned HTTP \${METRICS_STATUS}"
          fi

  smoke-test:
    name: Smoke Tests
    runs-on: ubuntu-latest
    needs: [deploy-staging]
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Go
        uses: actions/setup-go@v5
        with:
          go-version: \${{ env.GO_VERSION }}
          cache: true

      - name: Run smoke tests
        run: |
          go test -tags=smoke -timeout=3m -v ./tests/smoke/...
        env:
          GATEWAY_BASE_URL: https://gateway-staging.internal.example.com
          SMOKE_TEST_API_KEY: \${{ secrets.STAGING_SMOKE_TEST_API_KEY }}

      - name: Verify rate limiting
        run: |
          echo "Sending burst of requests to verify rate limiting..."
          RATE_LIMITED=false
          for i in $(seq 1 50); do
            STATUS=$(curl -s -o /dev/null -w "%{http_code}" --max-time 5 \\
              -H "X-API-Key: \${{ secrets.STAGING_SMOKE_TEST_API_KEY }}" \\
              "https://gateway-staging.internal.example.com/api/v1/health" || echo "000")
            if [ "$STATUS" = "429" ]; then
              RATE_LIMITED=true
              echo "Rate limiting active (received 429 at request \${i})"
              break
            fi
          done
          if [ "$RATE_LIMITED" = "false" ]; then
            echo "::warning::Rate limiting did not trigger during smoke test"
          fi

  notify:
    name: Notify
    runs-on: ubuntu-latest
    needs: [deploy-staging, smoke-test, build-binary]
    if: always()
    steps:
      - name: Determine status
        id: status
        run: |
          if [ "\${{ needs.deploy-staging.result }}" = "success" ] && [ "\${{ needs.smoke-test.result }}" = "success" ]; then
            echo "status=success" >> "$GITHUB_OUTPUT"
            echo "emoji=✅" >> "$GITHUB_OUTPUT"
            echo "message=Staging deploy succeeded" >> "$GITHUB_OUTPUT"
          elif [ "\${{ needs.deploy-staging.result }}" = "success" ] && [ "\${{ needs.smoke-test.result }}" = "failure" ]; then
            echo "status=warning" >> "$GITHUB_OUTPUT"
            echo "emoji=⚠️" >> "$GITHUB_OUTPUT"
            echo "message=Staging deployed but smoke tests failed" >> "$GITHUB_OUTPUT"
          else
            echo "status=failure" >> "$GITHUB_OUTPUT"
            echo "emoji=❌" >> "$GITHUB_OUTPUT"
            echo "message=Staging deploy failed" >> "$GITHUB_OUTPUT"
          fi

      - name: Post to Slack
        if: always()
        uses: slackapi/slack-github-action@v1.26.0
        with:
          payload: |
            {
              "text": "\${{ steps.status.outputs.emoji }} go-api-gateway staging deploy",
              "blocks": [
                {
                  "type": "header",
                  "text": {
                    "type": "plain_text",
                    "text": "\${{ steps.status.outputs.emoji }} go-api-gateway — \${{ steps.status.outputs.message }}"
                  }
                },
                {
                  "type": "section",
                  "fields": [
                    { "type": "mrkdwn", "text": "*Version:*\\n\`\${{ needs.build-binary.outputs.version }}\`" },
                    { "type": "mrkdwn", "text": "*Commit:*\\n<https://github.com/\${{ github.repository }}/commit/\${{ github.sha }}|\`\${{ needs.build-binary.outputs.commit_sha }}\`>" },
                    { "type": "mrkdwn", "text": "*Triggered by:*\\n\${{ github.actor }}" },
                    { "type": "mrkdwn", "text": "*Workflow:*\\n<\${{ github.server_url }}/\${{ github.repository }}/actions/runs/\${{ github.run_id }}|View Run>" }
                  ]
                }
              ]
            }
        env:
          SLACK_WEBHOOK_URL: \${{ secrets.SLACK_DEPLOY_WEBHOOK_URL }}
          SLACK_WEBHOOK_TYPE: INCOMING_WEBHOOK`,

  '.gitignore': `# Go build artifacts
bin/
dist/
*.exe
*.exe~
*.dll
*.so
*.dylib

# Go test artifacts
coverage.out
coverage.html
*.test
*.prof
*.pprof
cpu.prof
mem.prof
*.bench

# Go vendor (we use Go modules, not vendoring)
vendor/

# Go workspace files
go.work
go.work.sum

# Environment and secrets
.env
.env.*
!.env.example
*.pem
*.key
*.crt
*.p12
*.jks

# Configuration overrides (production secrets)
configs/production/*.yaml
configs/production/*.yml
!configs/production/*.example.yaml

# IDE and editor files
.idea/
.vscode/
*.swp
*.swo
*~
.DS_Store
Thumbs.db

# Docker
docker-compose.override.yml

# Terraform state (if running locally)
*.tfstate
*.tfstate.backup
.terraform/
.terraform.lock.hcl

# Kubernetes generated
deployments/generated/

# Load test results
scripts/loadtest/results/

# Temporary files
tmp/
*.tmp
*.log

# Air live reload (development)
.air.toml.tmp

# Delve debugger
debug
debug.test

# GoReleaser
dist/

# Redis dump
dump.rdb`,

  '.golangci.yml': `run:
  timeout: 5m
  go: "1.22"
  tests: true
  modules-download-mode: readonly

output:
  formats:
    - format: colored-line-number
  sort-results: true
  sort-order:
    - severity
    - linter
    - file

linters:
  disable-all: true
  enable:
    # Required linters
    - govet
    - errcheck
    - staticcheck
    - gosec
    - revive
    - gocyclo
    # Code quality
    - ineffassign
    - unused
    - typecheck
    - goconst
    - goimports
    - misspell
    - unconvert
    - unparam
    - prealloc
    - noctx
    - bodyclose
    - exportloopref
    - errname
    - errorlint
    - wrapcheck
    - nilerr
    - nilnil
    - contextcheck
    - durationcheck
    - forbidigo
    - forcetypeassert
    - gocritic
    - godot
    - goprintffuncname
    - nakedret
    - nolintlint
    - rowserrcheck
    - sqlclosecheck
    - tenv
    - tparallel
    - wastedassign
    - whitespace

linters-settings:
  govet:
    enable-all: true
    disable:
      - fieldalignment
    settings:
      shadow:
        strict: true

  errcheck:
    check-type-assertions: true
    check-blank: true
    exclude-functions:
      - (io.Closer).Close
      - (net/http.ResponseWriter).Write

  staticcheck:
    checks:
      - "all"
      - "-SA1019" # Allow deprecated for gradual migration, review quarterly

  gosec:
    excludes:
      - G104 # Handled by errcheck
    severity: high
    confidence: medium
    config:
      G301: "0750"
      G302: "0640"
      G306: "0640"

  revive:
    severity: warning
    confidence: 0.8
    rules:
      - name: blank-imports
      - name: context-as-argument
        arguments:
          - allowTypesBefore: "*testing.T"
      - name: context-keys-type
      - name: dot-imports
      - name: error-naming
      - name: error-return
      - name: error-strings
      - name: errorf
      - name: exported
        arguments:
          - checkPrivateReceivers
          - sayRepetitiveInsteadOfStutters
      - name: increment-decrement
      - name: indent-error-flow
      - name: modifies-parameter
      - name: modifies-value-receiver
      - name: package-comments
      - name: range
      - name: receiver-naming
      - name: redefines-builtin-id
      - name: superfluous-else
      - name: time-naming
      - name: unexported-return
      - name: unreachable-code
      - name: unused-parameter
      - name: var-declaration
      - name: var-naming

  gocyclo:
    min-complexity: 15

  goconst:
    min-len: 3
    min-occurrences: 3

  goimports:
    local-prefixes: github.com/go-api-gateway

  misspell:
    locale: US

  gocritic:
    enabled-tags:
      - diagnostic
      - performance
      - style
    disabled-checks:
      - hugeParam
      - rangeValCopy

  nakedret:
    max-func-lines: 10

  prealloc:
    simple: true
    for-loops: true

  nolintlint:
    require-explanation: true
    require-specific: true

  wrapcheck:
    ignoreSigs:
      - .Errorf(
      - errors.New(
      - errors.Unwrap(
      - errors.Join(
      - .Wrap(
      - .Wrapf(
      - .WithMessage(
      - .WithMessagef(
      - .WithStack(
    ignorePackageGlobs:
      - github.com/go-api-gateway/pkg/errors

  errorlint:
    errorf: true
    errorf-multi: true
    asserts: true
    comparison: true

  forbidigo:
    forbid:
      - pattern: "fmt\\\\.Print.*"
        msg: "Use slog structured logging instead of fmt.Print"
      - pattern: "log\\\\."
        msg: "Use slog structured logging instead of log package"
      - pattern: "panic\\\\("
        msg: "Return errors instead of panicking; panics are only acceptable in main or init"

  godot:
    scope: declarations
    capital: true

issues:
  max-issues-per-linter: 50
  max-same-issues: 5
  new: false

  exclude-rules:
    # Test files get relaxed rules
    - path: _test\\.go
      linters:
        - gosec
        - wrapcheck
        - errcheck
        - forcetypeassert
        - goconst
        - gocritic
        - noctx
        - forbidigo
        - bodyclose

    # Test helpers
    - path: tests/
      linters:
        - gosec
        - wrapcheck
        - forbidigo

    # Main entry point can use panic and init
    - path: cmd/gateway/main\\.go
      linters:
        - forbidigo
      text: "panic"

    # Config loading uses Viper which returns interface{}
    - path: internal/config/
      linters:
        - forcetypeassert

    # Generated code (mocks, protobuf)
    - path: ".*_mock\\\\.go"
      linters:
        - revive
        - gocritic
        - unused

    # Migration scripts
    - path: scripts/
      linters:
        - gosec
        - wrapcheck
        - forbidigo

    # Sensitive paths — gosec must always run on auth and crypto
    # No exclusions for internal/auth/** or *.pem handling code

    # Allow dot imports for testify
    - path: _test\\.go
      text: "dot-imports"
      source: '. "github.com/stretchr/testify'

  exclude-dirs:
    - vendor
    - deployments
    - docs
    - plugin

severity:
  default-severity: warning
  case-sensitive: false
  rules:
    - linters:
        - gosec
      severity: error
    - linters:
        - errcheck
        - errorlint
      severity: error
    - linters:
        - govet
      severity: error
    - linters:
        - staticcheck
      severity: error
    - linters:
        - revive
      severity: warning
    - linters:
        - gocyclo
      severity: warning`,

  '.mcp.json': `{
  "mcpServers": {
    "github": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-github"
      ],
      "env": {
        "GITHUB_PERSONAL_ACCESS_TOKEN": "\${GITHUB_TOKEN}"
      },
      "disabled": false
    },
    "slack": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-slack"
      ],
      "env": {
        "SLACK_BOT_TOKEN": "\${SLACK_BOT_TOKEN}",
        "SLACK_TEAM_ID": "\${SLACK_TEAM_ID}"
      },
      "disabled": false
    },
    "postgres": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-postgres",
        "\${GATEWAY_DATABASE_URL}"
      ],
      "disabled": true
    },
    "prometheus": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-prometheus",
        "--prometheus-url",
        "\${PROMETHEUS_URL:-http://localhost:9090}"
      ],
      "disabled": true
    }
  }
}`,

  'CLAUDE.md': `# CLAUDE.md — Go API Gateway Project Intelligence

## Project Overview

High-performance API gateway built with Go 1.22+ and Chi v5 router. Single entry point for microservices architecture with JWT auth, rate limiting, circuit breakers, and full observability. SOC 2 compliant.

## Quick Reference

\`\`\`bash
# Build
go build -o bin/gateway cmd/gateway/main.go

# Test
go test ./... -race -coverprofile=coverage.out
go test ./... -covermode=atomic -count=1

# Lint
golangci-lint run ./...
go vet ./...

# Run locally
docker compose up -d redis postgres
go run cmd/gateway/main.go

# Integration tests
go test ./tests/... -tags=integration -v

# Benchmarks
go test -bench=. -benchmem ./internal/ratelimit/...
go test -bench=. -benchmem ./internal/middleware/...

# Profile
go tool pprof http://localhost:6060/debug/pprof/profile?seconds=30
\`\`\`

## Architecture

Clean Architecture with strict dependency direction: handler → service → repository.

\`\`\`
cmd/gateway/          Entry point, wire-up, graceful shutdown
internal/handler/     Chi route handlers — thin, delegate to services
internal/middleware/   Chi middleware (auth, ratelimit, logging, cors, recovery, tracing)
internal/service/     Business logic — no HTTP concerns
internal/repository/  Data access (PostgreSQL via pgx, Redis via go-redis)
internal/model/       Domain models and DTOs — no methods with side effects
internal/config/      Viper config loading, env var binding
internal/auth/        JWT (RS256) validation, API key verification, RBAC
internal/ratelimit/   Redis sliding window rate limiter
internal/circuit/     Circuit breaker (per-upstream)
internal/observability/ OTel tracer, Prometheus metrics, slog setup
pkg/httputil/         Response helpers, shared HTTP utilities
pkg/errors/           Custom error types with codes
\`\`\`

## Critical Conventions

### Code Style
- **Formatting**: \`gofmt\` + \`goimports\` — non-negotiable
- **Exported functions**: Must have doc comments (godoc style)
- **File length**: Max 300 lines — split if longer
- **File naming**: \`snake_case.go\` (e.g., \`rate_limiter.go\`, \`jwt_validator.go\`)
- **Identifiers**: \`PascalCase\` exported, \`camelCase\` unexported, \`ALL_CAPS\` env vars
- **No \`init()\` functions** — use explicit initialization in main or constructors

### Error Handling
- Always wrap errors: \`fmt.Errorf("operation failed: %w", err)\`
- Use \`pkg/errors\` custom types for domain errors with error codes
- Never swallow errors silently — log or return
- HTTP handlers return structured JSON error responses via \`pkg/httputil\`

### Context Propagation
- Every handler and service method takes \`context.Context\` as first parameter
- Pass request-scoped values (trace ID, user claims, request ID) via context
- Respect context cancellation in long-running operations

### Dependency Injection
- Define interfaces in the consuming package, not the implementing package
- Constructor functions return concrete types, fields accept interfaces
- Wire dependencies in \`cmd/gateway/main.go\`

### Testing
- **Table-driven tests required** — no exception
- Use \`testify/assert\` and \`testify/require\` for assertions
- HTTP tests use \`httptest.NewServer\` and \`httptest.NewRecorder\`
- Test files: \`*_test.go\` in same package for unit, \`tests/\` for integration
- Coverage threshold: 80% — CI will fail below this
- Tag integration tests: \`//go:build integration\`

### Middleware
- All middleware must be composable Chi middleware (\`func(next http.Handler) http.Handler\`)
- Order matters: recovery → request ID → logging → tracing → CORS → auth → rate limit
- Middleware must not read the request body unless it replaces it with a new \`io.ReadCloser\`

## Sensitive Paths — Extra Caution Required

- \`internal/auth/**\` — JWT validation, RBAC, API key logic. Security-critical. Require thorough review.
- \`configs/production/**\` — Production secrets references. Never commit actual secrets.
- \`*.pem\` files — RSA keys for JWT. Must be in \`.gitignore\`.
- \`.env*\` files — Environment config. Never commit.
- \`internal/ratelimit/**\` — Rate limiting bypass = DoS vulnerability.
- \`internal/middleware/auth.go\` — Authentication bypass = full compromise.

## Dependencies — Conservative Policy

Approved dependencies (do not add without team discussion):
- \`go-chi/chi/v5\` — router
- \`jackc/pgx/v5\` — PostgreSQL driver
- \`redis/go-redis/v9\` — Redis client
- \`golang-jwt/jwt/v5\` — JWT parsing
- \`spf13/viper\` — config
- \`stretchr/testify\` — test assertions
- \`prometheus/client_golang\` — metrics
- \`go.opentelemetry.io/otel\` — tracing
- \`sony/gobreaker\` — circuit breaker (or custom in \`internal/circuit/\`)
- \`rs/cors\` — CORS middleware

Adding a new dependency requires a PR description explaining why existing deps or stdlib won't work.

## Git Workflow

- **Branch naming**: \`type/TICKET-desc\` (e.g., \`feat/GW-42-add-circuit-breaker\`)
- **Commits**: Conventional commits — \`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`, \`perf:\`, \`refactor:\`, \`test:\`
- **PRs**: Require 1 approval + passing CI (lint, vet, test, race detection)
- **Protected branch**: \`main\` — no direct pushes
- **AI-generated code**: Mark with \`// Generated with AI assistance\` comment

## SOC 2 Compliance Reminders

- All authentication changes require security review
- Audit logging for auth events (login, token refresh, key rotation)
- No secrets in code or config files — use AWS Secrets Manager / env vars
- TLS termination at ALB — internal traffic over private subnets
- API key rotation support required
- Follow OWASP API Security Top 10 guidelines
- Rate limiting must be enforced per-client, not bypassable

## Performance Expectations

- P99 latency < 10ms for passthrough requests (no upstream call)
- Target: 10k+ RPS per instance
- Connection pooling for PostgreSQL (pgx pool) and Redis
- Use \`sync.Pool\` for frequently allocated objects
- Profile with \`pprof\` before optimizing — no premature optimization
- Benchmark critical paths: middleware chain, rate limiter, JWT validation

## Infrastructure

- **Runtime**: Docker on AWS ECS (Fargate)
- **Load balancer**: AWS ALB with TLS termination
- **Cache/Rate limit**: AWS ElastiCache (Redis)
- **Config DB**: AWS RDS (PostgreSQL)
- **Observability**: Prometheus → Grafana (metrics), Jaeger (traces), CloudWatch (logs)
- **IaC**: Terraform for AWS resources, Helm for Kubernetes manifests

## Common Patterns

### Adding a new route
1. Define handler in \`internal/handler/\`
2. Add service interface + implementation in \`internal/service/\`
3. Add repository if data access needed in \`internal/repository/\`
4. Register route in the Chi router setup (grouped with appropriate middleware)
5. Add table-driven tests for handler and service
6. Update API docs in \`docs/\`

### Adding new middleware
1. Implement as \`func(next http.Handler) http.Handler\` in \`internal/middleware/\`
2. Add to middleware chain in correct order
3. Test with \`httptest.NewRecorder\`
4. Document in middleware README

### Configuration
- Viper loads from: defaults → \`configs/{env}.yaml\` → environment variables
- Env vars override file config (12-factor)
- All config fields must have struct tags for both \`mapstructure\` and \`envconfig\`

## Cross-References

- See \`.claude/rules/\` for detailed coding rules and workflow instructions
- See \`playbook/\` for development methodology phases
- See \`docs/architecture.md\` for system design diagrams
- See \`docs/runbooks/\` for operational procedures
- See \`plugin/codeforge-go-api-gateway/\` for Claude Code plugin (agents, commands, skills)`,

  'README.md': `# go-api-gateway

[![CI](https://github.com/your-org/go-api-gateway/actions/workflows/ci.yml/badge.svg)](https://github.com/your-org/go-api-gateway/actions/workflows/ci.yml)
[![Deploy Staging](https://github.com/your-org/go-api-gateway/actions/workflows/deploy-staging.yml/badge.svg)](https://github.com/your-org/go-api-gateway/actions/workflows/deploy-staging.yml)
[![Go Report Card](https://goreportcard.com/badge/github.com/your-org/go-api-gateway)](https://goreportcard.com/report/github.com/your-org/go-api-gateway)
[![Coverage](https://img.shields.io/badge/coverage-%3E80%25-brightgreen)](https://github.com/your-org/go-api-gateway/actions/workflows/ci.yml)
[![Go Version](https://img.shields.io/badge/go-1.22%2B-blue)](https://go.dev/)
[![License](https://img.shields.io/badge/license-proprietary-red)]()
[![SOC 2](https://img.shields.io/badge/compliance-SOC%202-green)]()

High-performance API gateway built with Go 1.22 and [Chi v5](https://github.com/go-chi/chi), serving as the single entry point for our microservices architecture. Designed for low-latency, high-throughput traffic routing with enterprise-grade security and observability.

---

## Table of Contents

- [Features](#features)
- [Architecture](#architecture)
- [Quickstart](#quickstart)
- [Configuration](#configuration)
- [API Gateway Patterns](#api-gateway-patterns)
- [Observability](#observability)
- [Performance](#performance)
- [Testing](#testing)
- [Deployment](#deployment)
- [Project Structure](#project-structure)
- [Contributing](#contributing)
- [Security](#security)

---

## Features

| Feature | Description |
|---|---|
| **JWT Authentication (RS256)** | Validates RS256-signed JWTs with key rotation support and RBAC enforcement |
| **API Key Authentication** | Per-client API keys stored in PostgreSQL with metadata and scoping |
| **Per-Client Rate Limiting** | Redis-backed sliding window rate limiter with configurable limits per client/tier |
| **Circuit Breaker** | Protects upstream services with configurable thresholds, timeouts, and half-open probing |
| **Request Routing** | Dynamic route configuration with path-based and header-based routing to upstream services |
| **Request/Response Transformation** | Header injection, path rewriting, body transformation middleware |
| **Distributed Tracing** | OpenTelemetry integration with trace propagation across all upstream calls |
| **Prometheus Metrics** | Request latency histograms, error rates, circuit breaker state, rate limit counters |
| **Structured Logging** | \`slog\`-based JSON logging with request IDs, trace IDs, and correlation |
| **Health Checks** | Liveness and readiness probes with dependency health (PostgreSQL, Redis, upstreams) |
| **Graceful Shutdown** | Clean connection draining with configurable shutdown timeout |
| **CORS Management** | Configurable per-route CORS policies |
| **OAuth2 Passthrough** | Transparent forwarding of OAuth2 tokens to upstream services |

---

## Architecture

\`\`\`
                    ┌─────────────────────────────────────────────────┐
                    │                 API Gateway                      │
  Clients ──────►  │                                                   │
                    │  ┌─────────┐  ┌──────────┐  ┌───────────────┐  │
              TLS   │  │  Auth   │  │  Rate    │  │   Circuit     │  │
            ──────► │  │  (JWT/  │─►│  Limiter │─►│   Breaker     │──┼──► Upstream
                    │  │  APIKey)│  │  (Redis) │  │               │  │    Services
                    │  └─────────┘  └──────────┘  └───────────────┘  │
                    │       │            │               │            │
                    │       ▼            ▼               ▼            │
                    │  ┌──────────────────────────────────────────┐   │
                    │  │          Observability Layer              │   │
                    │  │  OpenTelemetry │ Prometheus │ slog        │   │
                    │  └──────────────────────────────────────────┘   │
                    │       │            │               │            │
                    │       ▼            ▼               ▼            │
                    │    Jaeger       Grafana        CloudWatch       │
                    └─────────────────────────────────────────────────┘
                              │                    │
                         PostgreSQL             Redis
                        (config, keys)     (rate limits, cache)
\`\`\`

The gateway follows **Clean Architecture** with clear separation of concerns:

- **Handler Layer** — HTTP handlers using Chi router, request parsing, response writing
- **Middleware Layer** — Composable Chi middleware chain (auth, rate limit, logging, tracing, recovery)
- **Service Layer** — Business logic, routing decisions, transformation rules
- **Repository Layer** — Data access for PostgreSQL (config, API keys) and Redis (rate limits, cache)

For detailed architecture documentation, see [docs/ARCHITECTURE.md](docs/ARCHITECTURE.md).

---

## Quickstart

### Prerequisites

- Go 1.22+
- Docker & Docker Compose
- PostgreSQL 15+
- Redis 7+

### 1. Clone and Install Dependencies

\`\`\`bash
git clone https://github.com/your-org/go-api-gateway.git
cd go-api-gateway
go mod download
\`\`\`

### 2. Start Infrastructure

\`\`\`bash
docker compose up -d postgres redis jaeger
\`\`\`

This starts:
- **PostgreSQL** on \`localhost:5432\` (config store, API key metadata)
- **Redis** on \`localhost:6379\` (rate limiting, caching)
- **Jaeger** on \`localhost:16686\` (trace UI)

### 3. Run Database Migrations

\`\`\`bash
go run scripts/migrate.go up
\`\`\`

### 4. Generate RSA Keys (Development)

\`\`\`bash
mkdir -p configs/keys
openssl genrsa -out configs/keys/jwt_private.pem 2048
openssl rsa -in configs/keys/jwt_private.pem -pubout -out configs/keys/jwt_public.pem
\`\`\`

> ⚠️ **Never commit \`.pem\` files.** They are excluded in \`.gitignore\`.

### 5. Configure Environment

\`\`\`bash
cp configs/development.yaml.example configs/development.yaml
# Or use environment variables:
export GATEWAY_SERVER_PORT=8080
export GATEWAY_DATABASE_URL="postgres://gateway:gateway@localhost:5432/gateway?sslmode=disable"
export GATEWAY_REDIS_URL="redis://localhost:6379/0"
export GATEWAY_JWT_PUBLIC_KEY_PATH="configs/keys/jwt_public.pem"
\`\`\`

### 6. Run the Gateway

\`\`\`bash
# Development with hot reload (using air)
air

# Or build and run directly
go build -o bin/gateway cmd/gateway/main.go
./bin/gateway

# Or simply
go run cmd/gateway/main.go
\`\`\`

### 7. Verify

\`\`\`bash
# Health check
curl http://localhost:8080/healthz
# {"status":"ok","checks":{"postgres":"up","redis":"up"}}

# Readiness check
curl http://localhost:8080/readyz

# Prometheus metrics
curl http://localhost:8080/metrics

# Authenticated request (with JWT)
curl -H "Authorization: Bearer <token>" http://localhost:8080/api/v1/users

# API key request
curl -H "X-API-Key: <key>" http://localhost:8080/api/v1/data
\`\`\`

### Docker

\`\`\`bash
# Build
docker build -t go-api-gateway:latest -f deployments/Dockerfile .

# Run
docker run -p 8080:8080 \\
  -e GATEWAY_DATABASE_URL="postgres://..." \\
  -e GATEWAY_REDIS_URL="redis://..." \\
  go-api-gateway:latest
\`\`\`

---

## Configuration

Configuration is loaded via [Viper](https://github.com/spf13/viper) with the following precedence (highest to lowest):

1. Environment variables (\`GATEWAY_\` prefix)
2. Config file (\`configs/<env>.yaml\`)
3. Defaults

### Key Configuration Options

\`\`\`yaml
server:
  port: 8080
  read_timeout: 5s
  write_timeout: 10s
  idle_timeout: 120s
  shutdown_timeout: 30s

database:
  url: "postgres://gateway:gateway@localhost:5432/gateway?sslmode=disable"
  max_open_conns: 25
  max_idle_conns: 10
  conn_max_lifetime: 5m

redis:
  url: "redis://localhost:6379/0"
  pool_size: 20
  min_idle_conns: 5

auth:
  jwt_public_key_path: "configs/keys/jwt_public.pem"
  jwt_issuer: "https://auth.example.com"
  jwt_audience: "api-gateway"
  api_key_header: "X-API-Key"

rate_limit:
  default_requests_per_second: 100
  default_burst: 200
  window_size: 1m
  # Per-tier overrides loaded from PostgreSQL

circuit_breaker:
  threshold: 5           # failures before opening
  timeout: 30s           # time in open state before half-open
  max_half_open: 3       # max requests in half-open state

observability:
  otel_endpoint: "localhost:4317"
  otel_service_name: "api-gateway"
  log_level: "info"
  log_format: "json"
\`\`\`

See \`configs/development.yaml.example\` for the full configuration reference.

---

## API Gateway Patterns

### Middleware Chain

Every request passes through a composable Chi middleware chain:

\`\`\`
Request → Recovery → RequestID → Logger → Tracing → CORS → Auth → RateLimit → CircuitBreaker → Handler
\`\`\`

All middleware is implemented as standard Chi middleware (\`func(next http.Handler) http.Handler\`), making them composable and testable in isolation.

### Rate Limiting

Redis-backed sliding window algorithm with per-client granularity:

- Clients identified by API key, JWT subject, or IP address
- Configurable tiers (free: 100 req/min, pro: 1000 req/min, enterprise: 10000 req/min)
- Rate limit headers returned: \`X-RateLimit-Limit\`, \`X-RateLimit-Remaining\`, \`X-RateLimit-Reset\`
- Graceful degradation: if Redis is unavailable, falls back to in-memory limiter

### Circuit Breaker

Per-upstream circuit breaker with three states:

- **Closed** — requests flow normally, failures are counted
- **Open** — requests fail fast with \`503 Service Unavailable\`
- **Half-Open** — limited probe requests to test upstream recovery

### JWT Authentication

- RS256 signature validation with key rotation support
- Claims extraction: \`sub\`, \`iss\`, \`aud\`, \`exp\`, \`roles\`, \`scopes\`
- RBAC enforcement via middleware: \`RequireRole("admin")\`, \`RequireScope("read:users")\`
- Token is propagated to upstream services via \`X-Authenticated-User\` header

---

## Observability

### Distributed Tracing (OpenTelemetry → Jaeger)

Every request gets a trace ID propagated through all upstream calls. View traces at:

- **Development**: http://localhost:16686 (Jaeger UI)
- **Staging/Production**: Jaeger via internal ALB

### Metrics (Prometheus → Grafana)

Exposed at \`/metrics\`. Key metrics:

| Metric | Type | Description |
|---|---|---|
| \`gateway_request_duration_seconds\` | Histogram | Request latency by route, method, status |
| \`gateway_requests_total\` | Counter | Total requests by route, method, status |
| \`gateway_active_connections\` | Gauge | Current active connections |
| \`gateway_rate_limit_hits_total\` | Counter | Rate limit rejections by client tier |
| \`gateway_circuit_breaker_state\` | Gauge | Circuit breaker state per upstream (0=closed, 1=half-open, 2=open) |
| \`gateway_upstream_request_duration_seconds\` | Histogram | Upstream call latency by service |
| \`gateway_auth_failures_total\` | Counter | Authentication failures by type |

### Structured Logging (slog)

JSON-formatted logs with correlation:

\`\`\`json
{
  "time": "2024-01-15T10:30:00Z",
  "level": "INFO",
  "msg": "request completed",
  "request_id": "abc-123",
  "trace_id": "4bf92f3577b34da6a3ce929d0e0e4736",
  "method": "GET",
  "path": "/api/v1/users",
  "status": 200,
  "duration_ms": 12.5,
  "client_id": "client-42"
}
\`\`\`

---

## Performance

### Benchmarks

Run benchmarks with:

\`\`\`bash
go test -bench=. -benchmem ./internal/...
\`\`\`

### Target Performance Characteristics

| Metric | Target | Notes |
|---|---|---|
| **P50 Latency** | < 5ms | Gateway overhead only (excludes upstream) |
| **P99 Latency** | < 25ms | Gateway overhead only |
| **Throughput** | > 50,000 req/s | Per instance, simple passthrough |
| **Memory** | < 128MB | Steady state under load |
| **Startup Time** | < 2s | Cold start to ready |

### Profiling

\`\`\`bash
# CPU profile
go tool pprof http://localhost:8080/debug/pprof/profile?seconds=30

# Memory profile
go tool pprof http://localhost:8080/debug/pprof/heap

# Goroutine profile
go tool pprof http://localhost:8080/debug/pprof/goroutine
\`\`\`

> ⚠️ pprof endpoints are disabled in production. Enable via \`GATEWAY_DEBUG_PPROF=true\` in non-production environments.

### Load Testing

\`\`\`bash
# Using hey (install: go install github.com/rakyll/hey@latest)
hey -n 100000 -c 200 -H "Authorization: Bearer <token>" http://localhost:8080/api/v1/users

# Using k6 (see scripts/loadtest.js)
k6 run scripts/loadtest.js
\`\`\`

### Performance Optimization Notes

- **Connection pooling**: PostgreSQL (\`max_open_conns: 25\`) and Redis (\`pool_size: 20\`) are tuned for ECS task sizing
- **Zero-allocation routing**: Chi router with pre-compiled route patterns
- **Sync.Pool**: Used for request/response buffer reuse
- **Context propagation**: All handlers accept \`context.Context\` for cancellation and timeout propagation
- **HTTP client reuse**: Single \`http.Client\` per upstream with connection pooling and keep-alive

---

## Testing

\`\`\`bash
# Run all unit tests
go test ./...

# Run with race detection
go test -race ./...

# Run with coverage (threshold: 80%)
go test -coverprofile=coverage.out ./...
go tool cover -func=coverage.out

# Run specific package tests
go test ./internal/middleware/...
go test ./internal/ratelimit/...

# Run integration tests (requires Docker infrastructure)
go test -tags=integration ./tests/...

# Run benchmarks
go test -bench=. -benchmem ./internal/...

# Lint
golangci-lint run

# Vet
go vet ./...
\`\`\`

### Testing Conventions

- **Table-driven tests** required for all test functions
- **httptest** for HTTP handler testing
- **testify** for assertions (\`require\` for fatal, \`assert\` for non-fatal)
- **Interfaces** for all dependencies to enable mocking
- **Test files** live alongside source: \`handler.go\` → \`handler_test.go\`
- **Integration tests** use build tag \`//go:build integration\`

See [docs/CONTRIBUTING.md](docs/CONTRIBUTING.md) and [.claude/rules/go/testing.md](.claude/rules/go/testing.md) for detailed testing guidelines.

---

## Deployment

### Infrastructure

- **Compute**: AWS ECS (Fargate) behind Application Load Balancer
- **Database**: Amazon RDS (PostgreSQL 15)
- **Cache**: Amazon ElastiCache (Redis 7)
- **Logs**: CloudWatch Logs
- **Tracing**: Jaeger (self-hosted on ECS)
- **Monitoring**: Prometheus + Grafana

### Deploy to Staging

Merging to \`main\` automatically deploys to staging via [GitHub Actions](.github/workflows/deploy-staging.yml).

### Deploy to Production

Production deploys require manual approval:

\`\`\`bash
# Via GitHub Actions UI — trigger deploy-production workflow
# Or via Helm:
helm upgrade --install api-gateway deployments/helm/api-gateway \\
  --namespace gateway \\
  --values deployments/helm/api-gateway/values-production.yaml
\`\`\`

### Kubernetes

\`\`\`bash
# Apply manifests directly
kubectl apply -f deployments/k8s/

# Or use Helm
helm install api-gateway deployments/helm/api-gateway -n gateway
\`\`\`

### Terraform

\`\`\`bash
cd deployments/terraform
terraform init
terraform plan -var-file=environments/staging.tfvars
terraform apply -var-file=environments/staging.tfvars
\`\`\`

---

## Project Structure

\`\`\`
go-api-gateway/
├── cmd/
│   └── gateway/              # Main entry point
│       └── main.go
├── internal/
│   ├── handler/              # HTTP handlers (Chi route handlers)
│   ├── middleware/            # Chi middleware (auth, rate limit, logging, cors, recovery)
│   ├── service/              # Business logic layer
│   ├── repository/           # Data access (PostgreSQL, Redis)
│   ├── model/                # Domain models and DTOs
│   ├── config/               # Configuration loading (Viper)
│   ├── auth/                 # JWT validation, API key verification, RBAC
│   ├── ratelimit/            # Redis-backed sliding window rate limiter
│   ├── circuit/              # Circuit breaker implementation
│   └── observability/        # OpenTelemetry, Prometheus, slog setup
├── pkg/
│   ├── httputil/             # Shared HTTP utilities, response helpers
│   └── errors/               # Custom error types, error codes
├── configs/                  # YAML config files per environment
├── deployments/              # Dockerfile, Kubernetes manifests, Helm charts, Terraform
├── scripts/                  # Migrations, load tests, build scripts
├── tests/                    # Integration and E2E tests
├── docs/                     # Architecture, API docs, runbooks
├── .github/                  # CI/CD workflows, PR templates, CODEOWNERS
├── .claude/                  # Claude Code rules and settings
└── plugin/                   # CodeForge plugin (agents, commands, skills)
\`\`\`

---

## Contributing

See [docs/CONTRIBUTING.md](docs/CONTRIBUTING.md) for:

- Branch naming: \`type/ticket-desc\` (e.g., \`feat/GW-42-add-circuit-breaker\`)
- Commit format: Conventional Commits (\`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`, \`perf:\`)
- PR requirements: tests passing, lint passing, 80%+ coverage, 1 approval
- Code review checklist

For new team members, see [docs/ONBOARDING.md](docs/ONBOARDING.md).

For AI-assisted development guidelines, see [docs/AI-USAGE-POLICY.md](docs/AI-USAGE-POLICY.md).

---

## Security

This project is SOC 2 compliant. Security considerations:

- **TLS termination** at the ALB layer; internal traffic uses mTLS where required
- **JWT RS256** with key rotation via JWKS endpoint
- **API key rotation** supported without downtime (dual-key window)
- **OWASP API Security Top 10** mitigations applied (injection, broken auth, excessive data exposure, rate limiting)
- **Secrets management** via AWS Secrets Manager; no secrets in code or config files
- **Dependency scanning** via \`govulncheck\` and Dependabot
- **Sensitive paths** (\`internal/auth/**\`, \`configs/production/**\`, \`*.pem\`, \`.env*\`) require lead review per [CODEOWNERS](.github/CODEOWNERS)

### Reporting Vulnerabilities

Do **not** open a public issue. Email security@your-org.com with details. We will acknowledge within 24 hours and provide a fix timeline within 72 hours.

---

## License

Proprietary — All rights reserved. See LICENSE file for details.`,

  'docs/AI-USAGE-POLICY.md': `# AI Usage Policy — go-api-gateway

> Effective Date: 2024-01-01
> Last Reviewed: 2024-01-01
> Owner: Engineering Lead
> Compliance: SOC 2 Type II

## Purpose

This document defines when and how the team uses Claude (and other AI coding assistants) on the go-api-gateway project. It establishes guardrails that satisfy SOC 2 audit requirements while enabling developers to move fast on a small team.

---

## 1. Approved AI Tools

| Tool | Approved Use | License |
|------|-------------|---------|
| Claude Code (CLI) | Code generation, refactoring, debugging, documentation, test writing | Anthropic commercial |
| GitHub Copilot | Inline completions (optional, secondary) | GitHub commercial |

All other AI tools require lead approval before use on this codebase.

---

## 2. General Principles

1. **AI is a force multiplier, not a replacement for engineering judgment.** Every line of AI-generated code is owned by the developer who commits it.
2. **Treat AI output as untrusted input.** Review it with the same rigor you would apply to a junior developer's PR.
3. **Never paste secrets, PEM files, production credentials, or customer data into any AI tool.** This is a SOC 2 violation.
4. **Mark AI-generated code.** All PRs containing AI-generated code must check the "AI-assisted" box in the PR template and include the \`ai-generated\` label.

---

## 3. Permitted Use Cases

### 3.1 Encouraged (Use Freely)

These tasks benefit from AI assistance and carry low risk:

- **Boilerplate generation** — new Chi handlers, repository interfaces, model structs, DTO mappings
- **Table-driven test scaffolding** — generating test cases for \`internal/handler/\`, \`internal/service/\`, \`pkg/\`
- **Documentation** — doc comments on exported functions, README sections, runbook drafts
- **Refactoring** — extracting interfaces, reducing cyclomatic complexity, splitting large files (>300 lines)
- **Error handling patterns** — wrapping errors with \`fmt.Errorf("operation: %w", err)\`
- **Configuration boilerplate** — Viper bindings, envconfig struct tags
- **Kubernetes manifests and Helm values** — non-production environments
- **Load test scripts** — \`scripts/\` directory, k6 or vegeta configurations
- **Observability instrumentation** — adding OpenTelemetry spans, Prometheus metrics, slog fields
- **Code review assistance** — asking Claude to review a diff before submitting

### 3.2 Permitted with Caution

These tasks require the developer to carefully validate AI output:

| Task | Required Validation |
|------|-------------------|
| Chi middleware implementation | Manual review of middleware chain ordering; test with \`httptest\` |
| Redis rate limiting logic (\`internal/ratelimit/\`) | Verify sliding window math; run integration tests against real Redis |
| Circuit breaker state transitions (\`internal/circuit/\`) | Verify state machine correctness; run table-driven tests for all transitions |
| SQL queries and migrations | Review for injection; run against test database; check query plans |
| Docker multi-stage builds | Verify final image has no build tools; scan with Trivy |
| GitHub Actions workflows | Review for secret exposure; test in feature branch first |
| Prometheus metric definitions | Verify cardinality; check naming against Prometheus conventions |

### 3.3 Restricted (Lead Approval Required)

These areas are security-sensitive or compliance-relevant. AI may be used to **draft** code, but the output requires explicit review by a lead or designated security reviewer before merge.

| Path / Area | Reviewer | Reason |
|-------------|----------|--------|
| \`internal/auth/**\` | @security-reviewers | JWT validation, RBAC, API key verification — authentication bypass risk |
| \`internal/middleware/auth.go\` | @security-reviewers | Auth middleware is the primary security boundary |
| \`*.pem\`, \`*.key\`, TLS configuration | @security-reviewers | Cryptographic material handling |
| \`configs/production/**\` | @platform-leads | Production configuration — availability risk |
| \`deployments/helm/values-production.yaml\` | @platform-leads | Production deployment parameters |
| \`deployments/terraform/**\` | @platform-leads | Infrastructure changes — blast radius |
| \`.github/workflows/deploy-production.yml\` | @platform-leads | Production deployment pipeline |
| \`internal/repository/**\` (schema changes) | @backend-leads | Data model changes affect all services |
| RBAC policy definitions | @security-reviewers | Authorization model — privilege escalation risk |
| OAuth2 passthrough logic | @security-reviewers | Token handling — token leakage risk |

**Process for restricted areas:**

1. Developer drafts code (with or without AI assistance)
2. Developer self-reviews against OWASP API Security Top 10
3. PR is opened with \`security-review-required\` label
4. Designated reviewer from CODEOWNERS approves
5. CI must pass all security linters (\`gosec\`, \`staticcheck\`)
6. Merge requires explicit written approval comment

### 3.4 Prohibited

AI tools must **never** be used for:

- Generating or rotating production secrets, API keys, or JWT signing keys
- Directly modifying production databases or Redis instances
- Generating compliance documentation that will be submitted to auditors without human review
- Bypassing code review by committing directly to \`main\`
- Processing customer PII, request logs containing auth tokens, or production traffic data

---

## 4. Code Review Requirements for AI-Generated Code

### 4.1 Standard Review (Non-Sensitive Paths)

All AI-generated code follows the normal PR process:

- [ ] At least 1 approval from a team member
- [ ] All CI checks pass (lint, vet, test, race detection)
- [ ] Coverage threshold met (≥80%)
- [ ] \`ai-generated\` label applied
- [ ] PR description explains what AI generated vs. what was manually written
- [ ] No \`//nolint\` directives added to suppress AI-introduced issues

### 4.2 Enhanced Review (Security-Sensitive Paths)

For paths listed in Section 3.3:

- [ ] All standard review requirements
- [ ] Review by designated owner from \`.github/CODEOWNERS\`
- [ ] \`security-review-required\` label applied
- [ ] Reviewer confirms they reviewed the AI-generated portions specifically
- [ ] Reviewer leaves explicit approval comment: "Security review complete — [area] reviewed"
- [ ] For auth changes: verify JWT validation covers all edge cases (expired, malformed, wrong algorithm, missing claims)
- [ ] For rate limiting changes: verify no bypass paths exist
- [ ] For RBAC changes: verify principle of least privilege

### 4.3 What Reviewers Should Look For in AI Code

AI-generated Go code commonly has these issues:

| Issue | What to Check |
|-------|--------------|
| **Ignored errors** | Every \`error\` return must be checked; \`errcheck\` linter catches most |
| **Missing context propagation** | All handler functions must accept and pass \`context.Context\` |
| **Incorrect mutex usage** | Check for lock/unlock pairing, defer patterns, no copying of mutexes |
| **Resource leaks** | \`resp.Body.Close()\`, database connection returns to pool, Redis client cleanup |
| **Hardcoded values** | No hardcoded ports, timeouts, URLs — use Viper config |
| **Overly broad interfaces** | Interfaces should be small and focused (Go proverb: accept interfaces, return structs) |
| **Missing \`%w\` in error wrapping** | \`fmt.Errorf("handler: %w", err)\` not \`fmt.Errorf("handler: %v", err)\` |
| **Unused dependencies** | AI may import packages that aren't needed; \`goimports\` helps |
| **Test quality** | Table-driven tests must cover edge cases, not just happy path |
| **Goroutine leaks** | Check that goroutines have cancellation via context or done channels |
| **SQL injection** | Parameterized queries only; no string concatenation in SQL |

---

## 5. AI-Generated Code Labeling

### 5.1 Git Commits

Use the \`ai:\` trailer in conventional commits when AI generated a significant portion:

\`\`\`
feat(middleware): add per-client rate limiting with sliding window

Implements Redis-based sliding window rate limiting per API key.
Configurable via Viper with defaults of 100 req/min.

AI-assisted: Claude Code (scaffolding, test generation)
\`\`\`

### 5.2 Pull Requests

The PR template includes an AI-assisted checkbox. When checked:

- Add the \`ai-generated\` label
- In the PR description, specify which files/functions were AI-generated
- Note the AI tool used and the nature of assistance (generation, refactoring, test writing)

### 5.3 CI Enforcement

The \`ai-code-audit.yml\` workflow runs on PRs with the \`ai-generated\` label and performs additional checks:

- Security-sensitive path detection
- Automatic reviewer assignment based on CODEOWNERS
- SOC 2 audit trail logging

---

## 6. SOC 2 Compliance

### 6.1 Audit Trail

For SOC 2 purposes, we maintain traceability of AI-generated code:

- **Who**: The developer who prompted and committed the code is the accountable party
- **What**: PR description documents which portions are AI-generated
- **When**: Git timestamps and PR timestamps provide chronology
- **Review**: GitHub PR review history shows human review occurred
- **Approval**: Merge requires explicit human approval

### 6.2 Risk Controls

| Control | Implementation |
|---------|---------------|
| No secrets in AI prompts | Developer training; \`.env*\` and \`*.pem\` in \`.gitignore\` |
| Human review of all code | Branch protection on \`main\`; required approvals |
| Security review for auth changes | CODEOWNERS enforcement; \`security-review-required\` label |
| AI code identification | \`ai-generated\` label; commit trailers; CI audit workflow |
| Dependency vetting | \`go mod tidy\`; Dependabot; conservative dependency policy |
| Vulnerability scanning | \`gosec\` in CI; Trivy for container images |

### 6.3 Quarterly Review

This policy is reviewed quarterly by the engineering lead. Review includes:

- Audit of PRs with \`ai-generated\` label for compliance
- Assessment of AI-related incidents (if any)
- Update of restricted paths based on threat model changes
- Team feedback on policy effectiveness

---

## 7. Incident Response

If AI-generated code causes a security incident:

1. Follow standard incident response procedures
2. Tag the incident as \`ai-related\` in the post-mortem
3. Identify the gap in review that allowed the issue
4. Update this policy with additional controls if needed
5. Report to compliance team for SOC 2 documentation

---

## 8. Training Requirements

All developers using Claude Code on this project must:

- [ ] Read this policy in full
- [ ] Read \`CLAUDE.md\` (project-level AI instructions)
- [ ] Read \`.claude/rules/common/security.md\` (security rules)
- [ ] Understand the OWASP API Security Top 10
- [ ] Complete at least one PR with AI-generated code under supervision (for new team members)

---

## 9. Quick Reference

\`\`\`
Can I use Claude for...

Writing a new Chi handler?                    ✅ Yes — review normally
Generating table-driven tests?                ✅ Yes — verify edge cases
Writing doc comments?                         ✅ Yes — check accuracy
Modifying JWT validation logic?               ⚠️  Lead approval + security review
Changing rate limiting algorithm?             ⚠️  Verify math + integration test
Updating production Helm values?              ⚠️  Platform lead approval
Generating production secrets?                ❌ Never
Pasting production logs into Claude?          ❌ Never
Committing AI code without review?            ❌ Never
\`\`\`

---

## Changelog

| Date | Change | Author |
|------|--------|--------|
| 2024-01-01 | Initial policy | Engineering Lead |`,

  'docs/ARCHITECTURE.md': `# Architecture: go-api-gateway

## Overview

The API gateway is the single entry point for all client traffic into the microservices architecture. It handles cross-cutting concerns — authentication, rate limiting, observability, and routing — so that downstream services remain focused on business logic.

\`\`\`
                    ┌─────────────────────────────────────────────────┐
                    │                   Clients                       │
                    │         (Web, Mobile, Third-Party APIs)         │
                    └──────────────────────┬──────────────────────────┘
                                           │
                                           ▼
                    ┌─────────────────────────────────────────────────┐
                    │              AWS ALB (TLS Termination)          │
                    │              ┌─────────────────────┐            │
                    │              │  ACM Certificate     │            │
                    │              └─────────────────────┘            │
                    └──────────────────────┬──────────────────────────┘
                                           │ :443 → :8080
                                           ▼
                    ┌─────────────────────────────────────────────────┐
                    │            go-api-gateway (ECS / K8s)           │
                    │                                                 │
                    │  ┌─────────────────────────────────────────┐    │
                    │  │          Chi Router + Middleware         │    │
                    │  └──────────────────┬──────────────────────┘    │
                    │                     │                            │
                    │  ┌──────┬───────┬───┴────┬──────────┐          │
                    │  │Redis │ PgSQL │  OTEL  │Prometheus│          │
                    │  └──────┘───────┘────────┘──────────┘          │
                    └──────────────────────┬──────────────────────────┘
                                           │
                    ┌──────────┬────────────┼────────────┬────────────┐
                    ▼          ▼            ▼            ▼            ▼
               ┌────────┐┌────────┐ ┌───────────┐┌──────────┐┌──────────┐
               │ User   ││ Order  │ │  Payment  ││ Catalog  ││ Notif.   │
               │ Service││ Service│ │  Service  ││ Service  ││ Service  │
               └────────┘└────────┘ └───────────┘└──────────┘└──────────┘
\`\`\`

## Request Lifecycle

Every inbound request passes through the following stages in order:

\`\`\`
Client Request
  │
  ▼
┌──────────────────────────────────────────────────────────────────────┐
│ 1. Recovery Middleware         (panic recovery, 500 response)        │
│ 2. Request ID Middleware       (X-Request-ID generation/propagation) │
│ 3. Observability Middleware    (OTEL span start, slog context)       │
│ 4. Prometheus Middleware       (request count, latency histogram)    │
│ 5. CORS Middleware             (origin validation, preflight)        │
│ 6. Real IP Middleware          (X-Forwarded-For extraction)          │
│ 7. Rate Limit Middleware       (Redis sliding window, per-client)    │
│ 8. Auth Middleware             (JWT RS256 / API key / OAuth2 pass)   │
│ 9. RBAC Middleware             (role + scope enforcement)            │
│10. Request Transform Middleware(header injection, path rewrite)      │
│11. Circuit Breaker Middleware  (per-upstream health tracking)        │
│12. Timeout Middleware          (per-route deadline enforcement)      │
├──────────────────────────────────────────────────────────────────────┤
│                        Chi Route Handler                             │
│                    (proxy / direct handler)                           │
├──────────────────────────────────────────────────────────────────────┤
│ Response Transform             (header stripping, body mapping)      │
│ Observability Finalize         (span end, log completion, metrics)   │
└──────────────────────────────────────────────────────────────────────┘
  │
  ▼
Client Response
\`\`\`

### Middleware Chain Detail

The middleware stack is composed using Chi's \`r.Use()\` and applied in the order listed above. Each middleware is a standalone \`func(http.Handler) http.Handler\` that can be tested and composed independently.

**Global middleware** (applied to all routes):

| Order | Middleware | Package | Purpose |
|-------|-----------|---------|---------|
| 1 | Recovery | \`internal/middleware\` | Catches panics, logs stack trace, returns 500 |
| 2 | RequestID | \`internal/middleware\` | Generates UUID v4 if \`X-Request-ID\` absent |
| 3 | Tracing | \`internal/observability\` | Starts OTEL span, injects into \`context.Context\` |
| 4 | Metrics | \`internal/observability\` | Records \`http_requests_total\`, \`http_request_duration_seconds\` |
| 5 | CORS | \`internal/middleware\` | Validates \`Origin\`, sets \`Access-Control-*\` headers |
| 6 | RealIP | \`internal/middleware\` | Extracts client IP from \`X-Forwarded-For\` chain |
| 7 | Logging | \`internal/middleware\` | Structured request/response log via \`slog\` |

**Route-group middleware** (applied per route group):

| Middleware | Package | Purpose |
|-----------|---------|---------|
| RateLimit | \`internal/ratelimit\` | Sliding window counter in Redis, keyed by client ID or IP |
| Auth | \`internal/auth\` | JWT RS256 validation, API key lookup, OAuth2 token passthrough |
| RBAC | \`internal/auth\` | Checks \`roles\` and \`scopes\` claims against route requirements |
| CircuitBreaker | \`internal/circuit\` | Tracks upstream failures, opens circuit after threshold |
| Timeout | \`internal/middleware\` | Enforces \`context.WithTimeout\` per route configuration |

## Clean Architecture Layers

The codebase follows Clean Architecture with strict dependency direction: handlers depend on services, services depend on repositories, and nothing depends inward on handlers.

\`\`\`
┌─────────────────────────────────────────────────────────────┐
│                     cmd/gateway/main.go                      │
│              (wire up dependencies, start server)            │
└──────────────────────────┬──────────────────────────────────┘
                           │ creates
                           ▼
┌─────────────────────────────────────────────────────────────┐
│                   internal/handler/                           │
│                                                              │
│  • Receives HTTP requests via Chi routes                     │
│  • Validates input (query params, headers, body)             │
│  • Calls service layer                                       │
│  • Serializes response using pkg/httputil                    │
│  • No business logic                                         │
└──────────────────────────┬──────────────────────────────────┘
                           │ calls interface
                           ▼
┌─────────────────────────────────────────────────────────────┐
│                   internal/service/                           │
│                                                              │
│  • Contains all business logic                               │
│  • Orchestrates repository calls                             │
│  • Implements routing decisions, transformations             │
│  • Accepts and returns domain models                         │
│  • Depends on repository interfaces (not implementations)    │
└──────────────────────────┬──────────────────────────────────┘
                           │ calls interface
                           ▼
┌─────────────────────────────────────────────────────────────┐
│                  internal/repository/                         │
│                                                              │
│  • Data access: PostgreSQL queries, Redis commands           │
│  • Implements repository interfaces                          │
│  • Manages connection pooling (pgxpool, go-redis)            │
│  • No business logic                                         │
└─────────────────────────────────────────────────────────────┘
\`\`\`

### Key Interfaces

\`\`\`go
// RouteConfigRepository loads routing rules from PostgreSQL.
type RouteConfigRepository interface {
    GetRouteByPath(ctx context.Context, method, path string) (*model.RouteConfig, error)
    ListActiveRoutes(ctx context.Context) ([]model.RouteConfig, error)
}

// RateLimitRepository manages rate limit counters in Redis.
type RateLimitRepository interface {
    Increment(ctx context.Context, key string, window time.Duration) (int64, error)
    GetCount(ctx context.Context, key string) (int64, error)
}

// APIKeyRepository validates API keys against PostgreSQL.
type APIKeyRepository interface {
    GetByHash(ctx context.Context, keyHash string) (*model.APIKey, error)
    IsRevoked(ctx context.Context, keyID string) (bool, error)
}
\`\`\`

All interfaces are defined in the consuming package (service layer), not the implementing package (repository layer). This follows the Go convention of accepting interfaces and returning structs.

## Domain Models

Located in \`internal/model/\`:

| Model | Purpose |
|-------|---------|
| \`RouteConfig\` | Upstream URL, method, path pattern, timeout, rate limit tier, required roles |
| \`APIKey\` | Key hash, client ID, scopes, rate limit tier, created/revoked timestamps |
| \`ClientIdentity\` | Extracted from JWT or API key — client ID, roles, scopes, rate limit tier |
| \`ProxyRequest\` | Transformed request ready for upstream dispatch |
| \`HealthStatus\` | Upstream health state for circuit breaker decisions |

## Configuration

Configuration is loaded via Viper with the following precedence (highest to lowest):

1. **Environment variables** (\`GATEWAY_\` prefix, e.g., \`GATEWAY_SERVER_PORT\`)
2. **Config file** (\`configs/{environment}.yaml\`)
3. **Defaults** (hardcoded in \`internal/config/config.go\`)

\`\`\`yaml
# configs/development.yaml
server:
  port: 8080
  read_timeout: 5s
  write_timeout: 10s
  idle_timeout: 120s
  shutdown_timeout: 30s

auth:
  jwt_public_key_path: /etc/gateway/keys/public.pem
  jwt_issuer: "https://auth.example.com"
  jwt_audience: "api-gateway"
  api_key_cache_ttl: 5m

rate_limit:
  default_requests_per_minute: 100
  window_size: 1m
  redis_key_prefix: "rl:"

circuit_breaker:
  failure_threshold: 5
  success_threshold: 3
  timeout: 30s
  half_open_max_requests: 2

redis:
  addr: "localhost:6379"
  password: ""
  db: 0
  pool_size: 20
  min_idle_conns: 5

postgres:
  dsn: "postgres://gateway:password@localhost:5432/gateway?sslmode=disable"
  max_open_conns: 25
  max_idle_conns: 10
  conn_max_lifetime: 5m

observability:
  otel_endpoint: "localhost:4317"
  otel_service_name: "go-api-gateway"
  prometheus_port: 9090
  log_level: "debug"
  log_format: "json"
\`\`\`

## Authentication Flow

### JWT (RS256)

\`\`\`
Client → Authorization: Bearer <token>
  │
  ▼
Auth Middleware
  ├── Extract token from Authorization header
  ├── Parse and validate JWT signature (RS256 public key)
  ├── Verify claims: exp, iss, aud, nbf
  ├── Extract client_id, roles, scopes
  ├── Build ClientIdentity and inject into context
  └── Pass to next handler
\`\`\`

### API Key

\`\`\`
Client → X-API-Key: <key>
  │
  ▼
Auth Middleware
  ├── Extract key from X-API-Key header
  ├── SHA-256 hash the key
  ├── Check Redis cache for key metadata
  │     ├── Cache hit → use cached metadata
  │     └── Cache miss → query PostgreSQL → cache result
  ├── Verify key is not revoked
  ├── Build ClientIdentity from key metadata
  └── Pass to next handler
\`\`\`

### OAuth2 Passthrough

For routes configured with \`auth_mode: oauth2_passthrough\`, the gateway forwards the \`Authorization\` header to the upstream service without validation. The upstream is responsible for token introspection.

## Rate Limiting

Rate limiting uses a **sliding window counter** algorithm implemented in Redis:

\`\`\`
Key format: rl:{client_id}:{route_group}:{window_start}

Algorithm:
  1. Calculate current window and previous window timestamps
  2. MULTI/EXEC:
     - INCR current window key
     - EXPIRE current window key (2 * window_size)
     - GET previous window key
  3. Weighted count = prev_count * overlap_ratio + current_count
  4. If weighted_count > limit → return 429 with Retry-After header
\`\`\`

Rate limit tiers are assigned per API key or JWT claim:

| Tier | Requests/min | Burst |
|------|-------------|-------|
| free | 60 | 10 |
| standard | 600 | 50 |
| premium | 6000 | 200 |
| internal | unlimited | — |

Response headers on every request:

\`\`\`
X-RateLimit-Limit: 600
X-RateLimit-Remaining: 542
X-RateLimit-Reset: 1700000060
\`\`\`

## Circuit Breaker

The circuit breaker protects the gateway from cascading failures when upstream services are unhealthy.

\`\`\`
         ┌──────────┐
         │  CLOSED   │ ◄── Normal operation, requests pass through
         └────┬──────┘
              │ failure_count >= threshold (5)
              ▼
         ┌──────────┐
         │   OPEN    │ ◄── All requests fail fast with 503
         └────┬──────┘
              │ after timeout (30s)
              ▼
         ┌──────────┐
         │HALF-OPEN  │ ◄── Allow limited probe requests (2)
         └────┬──────┘
              │
         ┌────┴────┐
    success >= 3    failure
         │              │
         ▼              ▼
    ┌──────────┐  ┌──────────┐
    │  CLOSED   │  │   OPEN    │
    └──────────┘  └──────────┘
\`\`\`

State is tracked per upstream host in memory with periodic persistence to Redis for cluster-wide coordination.

## Observability

### Distributed Tracing (OpenTelemetry)

Every request gets a trace that propagates through the gateway and into upstream services via W3C \`traceparent\` headers.

\`\`\`
Span: gateway.request
  ├── Span: middleware.auth
  ├── Span: middleware.ratelimit
  ├── Span: service.route_lookup
  ├── Span: proxy.upstream_call
  │     └── (propagated to upstream via traceparent header)
  └── Span: middleware.response_transform
\`\`\`

Traces are exported to the OTEL collector via gRPC (port 4317) and visualized in Jaeger.

### Metrics (Prometheus)

Exposed on \`:9090/metrics\`:

| Metric | Type | Labels |
|--------|------|--------|
| \`gateway_requests_total\` | Counter | \`method\`, \`path\`, \`status\`, \`client_id\` |
| \`gateway_request_duration_seconds\` | Histogram | \`method\`, \`path\`, \`upstream\` |
| \`gateway_upstream_requests_total\` | Counter | \`upstream\`, \`status\` |
| \`gateway_upstream_duration_seconds\` | Histogram | \`upstream\` |
| \`gateway_circuit_breaker_state\` | Gauge | \`upstream\`, \`state\` |
| \`gateway_rate_limit_rejected_total\` | Counter | \`client_id\`, \`tier\` |
| \`gateway_active_connections\` | Gauge | — |
| \`gateway_auth_failures_total\` | Counter | \`reason\` |

### Structured Logging (slog)

All logs are JSON-formatted with consistent fields:

\`\`\`json
{
  "time": "2024-01-15T10:30:00.000Z",
  "level": "INFO",
  "msg": "request completed",
  "request_id": "550e8400-e29b-41d4-a716-446655440000",
  "trace_id": "abc123def456",
  "method": "GET",
  "path": "/api/v1/users",
  "status": 200,
  "duration_ms": 42,
  "client_id": "client-xyz",
  "upstream": "user-service:8080"
}
\`\`\`

Log levels: \`DEBUG\` (development), \`INFO\` (staging), \`WARN\` (production default), \`ERROR\` (always).

## Health Checks

### Liveness (\`GET /healthz\`)

Returns \`200 OK\` if the process is running. No dependency checks. Used by Kubernetes liveness probe.

### Readiness (\`GET /readyz\`)

Returns \`200 OK\` only if all dependencies are reachable:

\`\`\`json
{
  "status": "ready",
  "checks": {
    "postgres": { "status": "up", "latency_ms": 2 },
    "redis": { "status": "up", "latency_ms": 1 },
    "otel_collector": { "status": "up", "latency_ms": 5 }
  }
}
\`\`\`

Returns \`503 Service Unavailable\` if any critical dependency is down. Used by Kubernetes readiness probe and ALB target group health checks.

## Graceful Shutdown

\`\`\`
SIGTERM / SIGINT received
  │
  ├── 1. Stop accepting new connections (listener close)
  ├── 2. Set readiness probe to unhealthy (ALB drains traffic)
  ├── 3. Wait for in-flight requests (up to shutdown_timeout: 30s)
  ├── 4. Close upstream connections
  ├── 5. Flush OTEL spans and Prometheus metrics
  ├── 6. Close Redis connection pool
  ├── 7. Close PostgreSQL connection pool
  └── 8. Exit 0
\`\`\`

## Deployment Topology

### AWS Production

\`\`\`
┌─────────────────────────────────────────────────────────────────────┐
│                          AWS VPC                                     │
│                                                                      │
│  ┌──────────────────────────────────────────────────────────────┐   │
│  │                    Public Subnet                              │   │
│  │  ┌────────────────────────────────────────────────────────┐  │   │
│  │  │  Application Load Balancer (ALB)                        │  │   │
│  │  │  • TLS termination (ACM certificate)                    │  │   │
│  │  │  • WAF integration                                      │  │   │
│  │  │  • Target group health checks (/readyz)                 │  │   │
│  │  └──────────────────────┬─────────────────────────────────┘  │   │
│  └─────────────────────────┼────────────────────────────────────┘   │
│                             │                                        │
│  ┌─────────────────────────┼────────────────────────────────────┐   │
│  │                  Private Subnet                               │   │
│  │                         │                                     │   │
│  │  ┌─────────────────────┼───────────────────────────────┐     │   │
│  │  │        ECS Service (Fargate)                         │     │   │
│  │  │                     │                                │     │   │
│  │  │  ┌──────────┐ ┌──────────┐ ┌──────────┐            │     │   │
│  │  │  │ Task 1   │ │ Task 2   │ │ Task 3   │            │     │   │
│  │  │  │ :8080    │ │ :8080    │ │ :8080    │            │     │   │
│  │  │  │ :9090    │ │ :9090    │ │ :9090    │            │     │   │
│  │  │  └──────────┘ └──────────┘ └──────────┘            │     │   │
│  │  │  Auto-scaling: 3–12 tasks                           │     │   │
│  │  │  CPU target: 60%                                    │     │   │
│  │  └─────────────────────────────────────────────────────┘     │   │
│  │                                                               │   │
│  │  ┌─────────────────┐  ┌─────────────────┐                   │   │
│  │  │ ElastiCache      │  │ RDS PostgreSQL   │                   │   │
│  │  │ Redis Cluster    │  │ Multi-AZ         │                   │   │
│  │  │ 3 shards         │  │ db.r6g.large     │                   │   │
│  │  │ r6g.large        │  │ Encrypted (KMS)  │                   │   │
│  │  └─────────────────┘  └─────────────────┘                   │   │
│  │                                                               │   │
│  │  ┌─────────────────────────────────────────────────────┐     │   │
│  │  │ Observability                                        │     │   │
│  │  │  • OTEL Collector (sidecar) → Jaeger / X-Ray         │     │   │
│  │  │  • Prometheus (scrape :9090) → Grafana                │     │   │
│  │  │  • CloudWatch Logs (slog JSON output)                 │     │   │
│  │  └─────────────────────────────────────────────────────┘     │   │
│  └───────────────────────────────────────────────────────────────┘   │
└─────────────────────────────────────────────────────────────────────┘
\`\`\`

### Kubernetes (Helm)

For Kubernetes deployments, the Helm chart in \`deployments/helm/\` provisions:

| Resource | Configuration |
|----------|--------------|
| Deployment | 3 replicas, rolling update (maxSurge: 1, maxUnavailable: 0) |
| Service | ClusterIP, ports 8080 (HTTP) and 9090 (metrics) |
| Ingress | NGINX ingress controller, TLS via cert-manager |
| HPA | Min 3, Max 12, target CPU 60%, target memory 70% |
| PDB | minAvailable: 2 |
| ConfigMap | Non-sensitive config (YAML) |
| Secret | JWT keys, database credentials, Redis password |
| ServiceMonitor | Prometheus Operator scrape config |

### Docker

\`\`\`dockerfile
# Multi-stage build (deployments/Dockerfile)
# Stage 1: Build with Go 1.22
# Stage 2: Distroless base (gcr.io/distroless/static-debian12)
# Final image: ~15MB, non-root user, read-only filesystem
\`\`\`

Container resource limits:

| Resource | Request | Limit |
|----------|---------|-------|
| CPU | 250m | 1000m |
| Memory | 128Mi | 512Mi |

## Performance Characteristics

### Targets

| Metric | Target | Measurement |
|--------|--------|-------------|
| P50 latency (proxy) | < 5ms overhead | Gateway processing time only |
| P99 latency (proxy) | < 20ms overhead | Gateway processing time only |
| Throughput | > 10,000 req/s per instance | Sustained, mixed workload |
| Connection pool (PG) | 25 max, 10 idle | Per instance |
| Connection pool (Redis) | 20 max, 5 idle | Per instance |

### Profiling

Performance profiling is available in non-production environments:

- **pprof**: \`GET /debug/pprof/\` (behind auth, disabled in production)
- **Benchmarks**: \`go test -bench=. -benchmem ./internal/...\`
- **Load testing**: \`scripts/load_test.sh\` (uses \`hey\` or \`vegeta\`)

### Optimization Decisions

- **Chi router**: O(1) radix tree routing, zero allocations on matched routes
- **sync.Pool**: Reuse of proxy request/response buffers
- **Connection pooling**: pgxpool for PostgreSQL, go-redis pool for Redis
- **JWT key caching**: Public key loaded once at startup, JWKS rotation via background goroutine
- **Route config caching**: Hot routes cached in memory with TTL, invalidated via PostgreSQL LISTEN/NOTIFY

## Security (SOC 2 Compliance)

### Network Security

- TLS termination at ALB (TLS 1.2+ only, strong cipher suites)
- Private subnets for all compute and data resources
- Security groups restrict ingress to ALB only
- VPC flow logs enabled

### Application Security

- JWT RS256 validation (asymmetric, no shared secrets)
- API key hashing (SHA-256, keys never stored in plaintext)
- RBAC enforcement on every protected route
- Request size limits (default 1MB)
- Header injection prevention (hop-by-hop header stripping)
- OWASP API Security Top 10 mitigations applied

### Data Security

- PostgreSQL encrypted at rest (AWS KMS)
- Redis encrypted in transit (TLS) and at rest
- No PII in logs (client IDs only, no tokens or keys)
- Secrets managed via AWS Secrets Manager, injected as environment variables

### Audit

- All authentication events logged (success and failure)
- API key creation, rotation, and revocation tracked
- Rate limit violations logged with client identity
- Structured logs shipped to CloudWatch for SOC 2 audit trail retention (90 days)

## Directory Reference

\`\`\`
go-api-gateway/
├── cmd/gateway/main.go              # Entry point, dependency wiring, server start
├── internal/
│   ├── handler/                     # Chi route handlers (thin, no business logic)
│   │   ├── proxy_handler.go         # Reverse proxy to upstream services
│   │   ├── health_handler.go        # /healthz and /readyz endpoints
│   │   └── admin_handler.go         # Route config CRUD (internal only)
│   ├── middleware/                   # Chi middleware (composable, testable)
│   │   ├── recovery.go              # Panic recovery
│   │   ├── request_id.go            # X-Request-ID generation
│   │   ├── cors.go                  # CORS handling
│   │   ├── real_ip.go               # Client IP extraction
│   │   ├── logging.go               # Structured request logging
│   │   └── timeout.go               # Per-route timeout enforcement
│   ├── service/                     # Business logic
│   │   ├── routing_service.go       # Route matching, upstream selection
│   │   ├── proxy_service.go         # Request transformation, upstream dispatch
│   │   └── health_service.go        # Dependency health aggregation
│   ├── repository/                  # Data access
│   │   ├── postgres/                # PostgreSQL implementations
│   │   │   ├── route_repo.go
│   │   │   └── apikey_repo.go
│   │   └── redis/                   # Redis implementations
│   │       ├── ratelimit_repo.go
│   │       └── cache_repo.go
│   ├── model/                       # Domain models and DTOs
│   ├── config/                      # Viper configuration loading
│   ├── auth/                        # JWT, API key, RBAC
│   ├── ratelimit/                   # Sliding window rate limiter
│   ├── circuit/                     # Circuit breaker state machine
│   └── observability/               # OTEL, Prometheus, slog setup
├── pkg/
│   ├── httputil/                    # Response helpers, error rendering
│   └── errors/                      # Custom error types, error codes
├── configs/                         # YAML config per environment
├── deployments/                     # Dockerfile, Helm charts, K8s manifests
├── scripts/                         # Build, migrate, load test
├── tests/                           # Integration and E2E tests
└── docs/                            # This file, API docs, runbooks
\`\`\`

## Decision Log

| Decision | Rationale | Date |
|----------|-----------|------|
| Chi over Gin/Echo | Idiomatic, stdlib-compatible, zero-alloc routing, composable middleware | Project start |
| RS256 over HS256 | Asymmetric keys — gateway only needs public key, no shared secret risk | Project start |
| Sliding window over fixed window | Smoother rate limiting, prevents burst at window boundaries | Project start |
| In-memory circuit breaker + Redis sync | Low latency for hot path, Redis for cluster coordination | Project start |
| pgxpool over database/sql | Native PostgreSQL driver, better performance, LISTEN/NOTIFY support | Project start |
| slog over zerolog/zap | Stdlib (Go 1.21+), no external dependency, sufficient performance | Project start |
| Distroless over Alpine | Smaller attack surface, no shell, SOC 2 compliance | Project start |`,

  'docs/CONTRIBUTING.md': `# Contributing to go-api-gateway

Welcome to the go-api-gateway project. This guide covers everything you need to write, test, and ship code that meets our standards.

## Table of Contents

- [Development Setup](#development-setup)
- [Go Conventions](#go-conventions)
- [Project Architecture](#project-architecture)
- [Writing Handlers](#writing-handlers)
- [Writing Middleware](#writing-middleware)
- [Writing Services](#writing-services)
- [Writing Repository Code](#writing-repository-code)
- [Error Handling](#error-handling)
- [Testing](#testing)
- [Observability](#observability)
- [Git Workflow](#git-workflow)
- [Pull Request Process](#pull-request-process)
- [Security](#security)
- [Using Claude Code](#using-claude-code)

---

## Development Setup

### Prerequisites

- Go 1.22+
- Docker and Docker Compose
- golangci-lint v1.56+
- PostgreSQL 15+ (or use Docker)
- Redis 7+ (or use Docker)

### Getting Started

\`\`\`bash
# Clone the repository
git clone git@github.com:<org>/go-api-gateway.git
cd go-api-gateway

# Install dependencies
go mod download

# Start infrastructure
docker compose up -d postgres redis jaeger

# Copy environment config
cp configs/development.yaml configs/local.yaml

# Run database migrations
go run scripts/migrate.go up

# Run the gateway
go run cmd/gateway/main.go

# Verify
curl http://localhost:8080/healthz
\`\`\`

### Install Git Hooks

\`\`\`bash
git config core.hooksPath git-hooks
chmod +x git-hooks/*
\`\`\`

### Useful Commands

| Command | Purpose |
|---------|---------|
| \`go test ./...\` | Run all unit tests |
| \`go test -race ./...\` | Run tests with race detector |
| \`go test -cover ./...\` | Run tests with coverage |
| \`go vet ./...\` | Run Go vet |
| \`golangci-lint run\` | Run full lint suite |
| \`go build -o bin/gateway cmd/gateway/main.go\` | Build binary |
| \`go test -bench=. ./internal/ratelimit/...\` | Run benchmarks |
| \`go tool pprof http://localhost:6060/debug/pprof/profile\` | CPU profiling |

---

## Go Conventions

We follow [Effective Go](https://go.dev/doc/effective_go) and [Go Code Review Comments](https://github.com/golang/go/wiki/CodeReviewComments). The following are project-specific conventions.

### Naming

| Element | Convention | Example |
|---------|-----------|---------|
| Files | \`snake_case.go\` | \`rate_limiter.go\` |
| Exported types/funcs | \`PascalCase\` | \`RateLimiter\`, \`NewHandler\` |
| Unexported types/funcs | \`camelCase\` | \`validateToken\`, \`clientKey\` |
| Environment variables | \`ALL_CAPS\` | \`GATEWAY_JWT_PUBLIC_KEY\` |
| Test files | \`*_test.go\` | \`rate_limiter_test.go\` |
| Interfaces | Descriptive, \`-er\` suffix when appropriate | \`TokenValidator\`, \`RouteResolver\` |

### File Length

Keep files under **300 lines**. If a file grows beyond this, split it by responsibility. For example, split \`handler.go\` into \`handler_routes.go\`, \`handler_auth.go\`, \`handler_health.go\`.

### Imports

Use \`goimports\` to organize imports into three groups separated by blank lines:

\`\`\`go
import (
    // Standard library
    "context"
    "fmt"
    "net/http"

    // Third-party
    "github.com/go-chi/chi/v5"
    "github.com/redis/go-redis/v9"

    // Internal
    "github.com/<org>/go-api-gateway/internal/model"
    "github.com/<org>/go-api-gateway/internal/service"
)
\`\`\`

### No \`init()\` Functions

Do not use \`init()\` functions. All initialization must be explicit in \`main()\` or constructor functions. This makes dependency graphs clear and testing straightforward.

### Context Propagation

Every handler, service method, and repository call must accept \`context.Context\` as its first parameter:

\`\`\`go
func (s *RouteService) Resolve(ctx context.Context, path string) (*model.Route, error) {
    // context carries trace IDs, deadlines, cancellation
}
\`\`\`

### Error Wrapping

Always wrap errors with \`fmt.Errorf\` and \`%w\` to preserve the error chain:

\`\`\`go
route, err := s.repo.FindByPath(ctx, path)
if err != nil {
    return nil, fmt.Errorf("resolving route for path %q: %w", path, err)
}
\`\`\`

### Interfaces for Dependency Injection

Define interfaces at the consumer site, not the provider:

\`\`\`go
// In internal/handler/proxy.go — the consumer defines what it needs
type routeResolver interface {
    Resolve(ctx context.Context, path string) (*model.Route, error)
}

// ProxyHandler depends on the interface, not the concrete type
type ProxyHandler struct {
    routes routeResolver
}
\`\`\`

### Doc Comments

All exported functions, types, and constants must have doc comments:

\`\`\`go
// RateLimiter enforces per-client request rate limits using a Redis-backed
// sliding window algorithm.
type RateLimiter struct {
    // ...
}

// Allow checks whether the given client key has remaining capacity.
// It returns true if the request should be allowed, along with rate limit metadata.
func (rl *RateLimiter) Allow(ctx context.Context, key string) (bool, *LimitInfo, error) {
    // ...
}
\`\`\`

### Structured Logging

Use \`log/slog\` for all logging. Never use \`fmt.Println\` or \`log.Printf\`:

\`\`\`go
slog.InfoContext(ctx, "request routed",
    slog.String("method", r.Method),
    slog.String("path", r.URL.Path),
    slog.String("upstream", upstream.URL),
    slog.Duration("latency", elapsed),
)
\`\`\`

---

## Project Architecture

We follow **Clean Architecture** with three layers:

\`\`\`
HTTP Request
    ↓
[Handler]       ← HTTP concerns: parse request, validate input, write response
    ↓
[Service]       ← Business logic: orchestration, rules, transformations
    ↓
[Repository]    ← Data access: PostgreSQL queries, Redis operations
\`\`\`

**Rules:**
- Handlers depend on services (via interfaces)
- Services depend on repositories (via interfaces)
- No layer may skip a level (handlers must not call repositories directly)
- Models flow through all layers; DTOs are handler-specific

See [docs/ARCHITECTURE.md](ARCHITECTURE.md) for the full system design.

---

## Writing Handlers

Handlers live in \`internal/handler/\` and are responsible for HTTP concerns only.

### Handler Structure

\`\`\`go
// internal/handler/routes.go

// RouteHandler handles API route management endpoints.
type RouteHandler struct {
    svc routeService
}

// routeService defines the service interface consumed by RouteHandler.
type routeService interface {
    List(ctx context.Context, opts model.ListOptions) ([]model.Route, error)
    Get(ctx context.Context, id string) (*model.Route, error)
    Create(ctx context.Context, input model.CreateRouteInput) (*model.Route, error)
}

// NewRouteHandler creates a RouteHandler with the given service.
func NewRouteHandler(svc routeService) *RouteHandler {
    return &RouteHandler{svc: svc}
}
\`\`\`

### Registering Routes

Use Chi's composable routing. Group related routes and apply middleware at the group level:

\`\`\`go
// Routes returns a Chi router with all route management endpoints mounted.
func (h *RouteHandler) Routes() chi.Router {
    r := chi.NewRouter()

    r.Get("/", h.listRoutes)
    r.Post("/", h.createRoute)
    r.Route("/{routeID}", func(r chi.Router) {
        r.Get("/", h.getRoute)
        r.Put("/", h.updateRoute)
        r.Delete("/", h.deleteRoute)
    })

    return r
}
\`\`\`

### Handler Method Pattern

Every handler method follows this pattern:

\`\`\`go
func (h *RouteHandler) getRoute(w http.ResponseWriter, r *http.Request) {
    ctx := r.Context()

    // 1. Parse input
    routeID := chi.URLParam(r, "routeID")
    if routeID == "" {
        httputil.Error(w, r, errors.NewBadRequest("routeID is required"))
        return
    }

    // 2. Call service
    route, err := h.svc.Get(ctx, routeID)
    if err != nil {
        httputil.Error(w, r, err)
        return
    }

    // 3. Write response
    httputil.JSON(w, r, http.StatusOK, route)
}
\`\`\`

**Rules for handlers:**
- No business logic — delegate to services
- Always extract \`ctx\` from the request
- Use \`httputil.JSON\` and \`httputil.Error\` for consistent responses
- Parse and validate input before calling the service
- Never log and return an error — do one or the other (services log, handlers return)

---

## Writing Middleware

Middleware lives in \`internal/middleware/\` and must be composable Chi middleware.

### Middleware Signature

All middleware must conform to Chi's \`func(next http.Handler) http.Handler\` pattern:

\`\`\`go
// internal/middleware/request_id.go

// RequestID injects a unique request ID into the context and response headers.
func RequestID(next http.Handler) http.Handler {
    return http.HandlerFunc(func(w http.ResponseWriter, r *http.Request) {
        id := r.Header.Get("X-Request-ID")
        if id == "" {
            id = uuid.NewString()
        }

        ctx := context.WithValue(r.Context(), requestIDKey, id)
        w.Header().Set("X-Request-ID", id)

        next.ServeHTTP(w, r.WithContext(ctx))
    })
}
\`\`\`

### Middleware with Dependencies

When middleware needs dependencies (Redis, config), use a constructor that returns middleware:

\`\`\`go
// RateLimit returns middleware that enforces per-client rate limits.
func RateLimit(limiter ratelimit.Limiter) func(http.Handler) http.Handler {
    return func(next http.Handler) http.Handler {
        return http.HandlerFunc(func(w http.ResponseWriter, r *http.Request) {
            ctx := r.Context()
            clientID := extractClientID(r)

            allowed, info, err := limiter.Allow(ctx, clientID)
            if err != nil {
                slog.ErrorContext(ctx, "rate limiter error", slog.String("error", err.Error()))
                // Fail open — allow the request but log the error
                next.ServeHTTP(w, r)
                return
            }

            w.Header().Set("X-RateLimit-Limit", strconv.Itoa(info.Limit))
            w.Header().Set("X-RateLimit-Remaining", strconv.Itoa(info.Remaining))
            w.Header().Set("X-RateLimit-Reset", strconv.FormatInt(info.ResetAt.Unix(), 10))

            if !allowed {
                httputil.Error(w, r, errors.NewRateLimited("rate limit exceeded"))
                return
            }

            next.ServeHTTP(w, r)
        })
    }
}
\`\`\`

### Middleware Ordering

Middleware is applied in order. Our standard chain is:

\`\`\`go
r := chi.NewRouter()

// Infrastructure (outermost — runs first on request, last on response)
r.Use(middleware.Recoverer)
r.Use(middleware.RequestID)
r.Use(middleware.RequestLogger)
r.Use(middleware.Metrics)
r.Use(middleware.Tracing)

// Security
r.Use(middleware.CORS(cfg.CORS))
r.Use(middleware.SecureHeaders)

// Traffic management
r.Use(middleware.RateLimit(limiter))
r.Use(middleware.CircuitBreaker(breaker))

// Authentication (applied per-group, not globally)
r.Group(func(r chi.Router) {
    r.Use(middleware.JWTAuth(validator))
    r.Mount("/api/v1/routes", routeHandler.Routes())
})
\`\`\`

### Middleware Checklist

Before submitting middleware, verify:

- [ ] Follows \`func(http.Handler) http.Handler\` signature (or constructor returning it)
- [ ] Calls \`next.ServeHTTP(w, r)\` on the success path
- [ ] Propagates context correctly
- [ ] Has unit tests with \`httptest.NewRecorder\`
- [ ] Handles errors gracefully (fail-open or fail-closed, documented which)
- [ ] Adds relevant headers (rate limit, request ID, etc.)
- [ ] Includes structured logging for error paths
- [ ] Does not import handler or service packages (no circular deps)

---

## Writing Services

Services live in \`internal/service/\` and contain business logic.

\`\`\`go
// internal/service/route.go

// RouteService manages API route configuration and resolution.
type RouteService struct {
    repo   routeRepository
    cache  routeCache
    logger *slog.Logger
}

// routeRepository defines the data access interface for routes.
type routeRepository interface {
    FindByID(ctx context.Context, id string) (*model.Route, error)
    FindByPath(ctx context.Context, path string) (*model.Route, error)
    List(ctx context.Context, opts model.ListOptions) ([]model.Route, error)
    Create(ctx context.Context, route *model.Route) error
}

// NewRouteService creates a RouteService with the given dependencies.
func NewRouteService(repo routeRepository, cache routeCache, logger *slog.Logger) *RouteService {
    return &RouteService{repo: repo, cache: cache, logger: logger}
}
\`\`\`

**Rules for services:**
- Accept \`context.Context\` as the first parameter on every method
- Define interfaces for dependencies at the top of the file
- Return domain errors from \`pkg/errors\` (not HTTP status codes)
- Log at this layer, not in handlers or repositories
- Coordinate between multiple repositories when needed

---

## Writing Repository Code

Repositories live in \`internal/repository/\` and handle data access.

\`\`\`go
// internal/repository/route_postgres.go

// PostgresRouteRepo implements route storage using PostgreSQL.
type PostgresRouteRepo struct {
    db *sql.DB
}

// FindByID retrieves a route by its unique identifier.
func (r *PostgresRouteRepo) FindByID(ctx context.Context, id string) (*model.Route, error) {
    var route model.Route
    err := r.db.QueryRowContext(ctx,
        \`SELECT id, path, upstream_url, methods, active, created_at, updated_at
         FROM routes WHERE id = $1\`, id,
    ).Scan(&route.ID, &route.Path, &route.UpstreamURL, &route.Methods,
        &route.Active, &route.CreatedAt, &route.UpdatedAt)
    if err != nil {
        if errors.Is(err, sql.ErrNoRows) {
            return nil, pkgerrors.NewNotFound("route", id)
        }
        return nil, fmt.Errorf("querying route by id %q: %w", id, err)
    }
    return &route, nil
}
\`\`\`

**Rules for repositories:**
- One file per backing store (e.g., \`route_postgres.go\`, \`ratelimit_redis.go\`)
- Use parameterized queries — never string concatenation for SQL
- Wrap all errors with context about the operation
- Use connection pooling (\`sql.DB\` handles this; configure \`MaxOpenConns\`, \`MaxIdleConns\`)
- Return domain model types, not database-specific types

---

## Error Handling

Use the custom error types in \`pkg/errors/\`:

\`\`\`go
// Creating errors
errors.NewBadRequest("invalid route path: must start with /")
errors.NewNotFound("route", routeID)
errors.NewUnauthorized("invalid or expired JWT")
errors.NewForbidden("insufficient permissions for admin routes")
errors.NewRateLimited("client exceeded 100 req/min limit")
errors.NewInternal("unexpected failure in route resolution")

// Wrapping errors
fmt.Errorf("creating route in postgres: %w", err)

// Checking errors in handlers (httputil.Error does this automatically)
var notFound *errors.NotFoundError
if errors.As(err, &notFound) {
    // returns 404
}
\`\`\`

The \`httputil.Error\` helper maps error types to HTTP status codes automatically. Do not set status codes in services.

---

## Testing

### Requirements

- **Minimum coverage**: 80% on all packages
- **Table-driven tests**: Required for all functions with multiple input/output combinations
- **Race detection**: All CI runs include \`-race\`
- **No test pollution**: Tests must not depend on execution order

### Table-Driven Tests

\`\`\`go
func TestRateLimiter_Allow(t *testing.T) {
    tests := []struct {
        name      string
        clientID  string
        requests  int
        limit     int
        wantAllow bool
    }{
        {
            name:      "under limit allows request",
            clientID:  "client-1",
            requests:  5,
            limit:     10,
            wantAllow: true,
        },
        {
            name:      "at limit denies request",
            clientID:  "client-2",
            requests:  10,
            limit:     10,
            wantAllow: false,
        },
    }

    for _, tt := range tests {
        t.Run(tt.name, func(t *testing.T) {
            limiter := newTestLimiter(t, tt.limit)
            for i := 0; i < tt.requests; i++ {
                _, _, _ = limiter.Allow(context.Background(), tt.clientID)
            }
            got, _, err := limiter.Allow(context.Background(), tt.clientID)
            require.NoError(t, err)
            assert.Equal(t, tt.wantAllow, got)
        })
    }
}
\`\`\`

### HTTP Handler Tests

Use \`httptest\` and Chi's test helpers:

\`\`\`go
func TestRouteHandler_GetRoute(t *testing.T) {
    mockSvc := &mockRouteService{
        getFunc: func(ctx context.Context, id string) (*model.Route, error) {
            return &model.Route{ID: id, Path: "/api/users"}, nil
        },
    }

    handler := NewRouteHandler(mockSvc)
    r := chi.NewRouter()
    r.Mount("/routes", handler.Routes())

    req := httptest.NewRequest(http.MethodGet, "/routes/route-123", nil)
    rec := httptest.NewRecorder()

    r.ServeHTTP(rec, req)

    assert.Equal(t, http.StatusOK, rec.Code)

    var resp model.Route
    err := json.NewDecoder(rec.Body).Decode(&resp)
    require.NoError(t, err)
    assert.Equal(t, "/api/users", resp.Path)
}
\`\`\`

### Middleware Tests

\`\`\`go
func TestRateLimitMiddleware_DeniesOverLimit(t *testing.T) {
    limiter := &mockLimiter{allowed: false}
    mw := RateLimit(limiter)

    handler := mw(http.HandlerFunc(func(w http.ResponseWriter, r *http.Request) {
        w.WriteHeader(http.StatusOK)
    }))

    req := httptest.NewRequest(http.MethodGet, "/", nil)
    req.Header.Set("X-API-Key", "test-client")
    rec := httptest.NewRecorder()

    handler.ServeHTTP(rec, req)

    assert.Equal(t, http.StatusTooManyRequests, rec.Code)
    assert.NotEmpty(t, rec.Header().Get("X-RateLimit-Limit"))
}
\`\`\`

### Integration Tests

Integration tests live in \`tests/\` and use build tags:

\`\`\`go
//go:build integration

package integration

func TestGateway_ProxyRouting(t *testing.T) {
    // Requires running PostgreSQL, Redis, and a mock upstream
}
\`\`\`

Run integration tests:

\`\`\`bash
go test -tags=integration ./tests/...
\`\`\`

### Benchmarks

Performance-critical code (rate limiter, JWT validation, routing) must include benchmarks:

\`\`\`go
func BenchmarkRateLimiter_Allow(b *testing.B) {
    limiter := setupBenchLimiter(b)
    ctx := context.Background()

    b.ResetTimer()
    for i := 0; i < b.N; i++ {
        _, _, _ = limiter.Allow(ctx, "bench-client")
    }
}
\`\`\`

---

## Observability

### Metrics

Use Prometheus client to expose metrics. All middleware should record:

- \`gateway_requests_total\` (counter, labels: method, path, status)
- \`gateway_request_duration_seconds\` (histogram, labels: method, path)
- \`gateway_active_connections\` (gauge)

### Tracing

Use OpenTelemetry for distributed tracing. Spans should be created in middleware and propagated via context:

\`\`\`go
ctx, span := tracer.Start(ctx, "RouteService.Resolve",
    trace.WithAttributes(attribute.String("route.path", path)),
)
defer span.End()
\`\`\`

### Logging

Use \`slog\` with context for correlation:

\`\`\`go
slog.InfoContext(ctx, "upstream response",
    slog.Int("status", resp.StatusCode),
    slog.Duration("latency", elapsed),
    slog.String("upstream", upstream),
)
\`\`\`

---

## Git Workflow

### Branch Naming

\`\`\`
feat/GW-42-add-circuit-breaker
fix/GW-58-redis-connection-leak
chore/GW-71-update-dependencies
docs/GW-80-add-runbook
perf/GW-95-optimize-jwt-validation
\`\`\`

### Commit Messages

Use [Conventional Commits](https://www.conventionalcommits.org/):

\`\`\`
feat(ratelimit): add sliding window algorithm with Redis

Implements per-client rate limiting using Redis sorted sets.
Supports configurable window size and request limits.

Refs: GW-42
\`\`\`

Valid prefixes: \`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`, \`perf:\`, \`refactor:\`, \`test:\`, \`ci:\`

### Branch Lifecycle

1. Create branch from \`main\`: \`git checkout -b feat/GW-42-add-circuit-breaker\`
2. Make focused commits with conventional messages
3. Push and open a PR against \`main\`
4. Address review feedback
5. Squash merge after approval

---

## Pull Request Process

### Before Opening a PR

\`\`\`bash
# Format code
gofmt -w .
goimports -w .

# Run linter
golangci-lint run

# Run tests
go test -race -cover ./...

# Verify build
go build -o bin/gateway cmd/gateway/main.go
\`\`\`

### PR Requirements

All PRs must satisfy:

- [ ] **Tests passing** — all unit tests green, no race conditions
- [ ] **Lint passing** — \`golangci-lint run\` reports no issues
- [ ] **Coverage ≥ 80%** — on changed packages
- [ ] **At least 1 approval** — from a code owner
- [ ] **Conventional commit title** — PR title follows \`type(scope): description\`
- [ ] **Linked issue** — reference the GitHub Issue (e.g., \`Closes #42\`)
- [ ] **No sensitive data** — no secrets, keys, or PII in code or comments

### PR Template

Fill out the [PR template](../.github/PULL_REQUEST_TEMPLATE.md) completely. Reviewers will check:

- Architecture alignment (handler → service → repository)
- Error handling (wrapped errors, no swallowed errors)
- Test quality (table-driven, edge cases, mocks via interfaces)
- Observability (metrics, tracing spans, structured logs)
- Security implications (auth bypass, injection, data exposure)

### Code Ownership

See [CODEOWNERS](../.github/CODEOWNERS). Changes to sensitive paths require additional review:

- \`internal/auth/**\` — security lead review required
- \`configs/production/**\` — ops lead review required
- \`deployments/**\` — ops lead review required
- \`*.pem\`, \`.env*\` — should never be committed

### AI-Generated Code

If you used Claude Code or any AI tool to generate code:

1. Add the \`ai-assisted\` label to the PR
2. Note which sections were AI-generated in the PR description
3. The [AI code audit workflow](../.github/workflows/ai-code-audit.yml) will run automatically
4. Ensure you have reviewed and understand all generated code — you are responsible for it

---

## Security

This project operates under **SOC 2** compliance requirements.

### Must Do

- Never commit secrets, API keys, or certificates
- Use parameterized queries for all database operations
- Validate and sanitize all input at the handler layer
- Use RS256 (asymmetric) for JWT — never HS256 with shared secrets in production
- Set appropriate timeouts on all HTTP clients and database connections
- Follow [OWASP API Security Top 10](https://owasp.org/www-project-api-security/)

### Must Not Do

- Do not log sensitive data (tokens, passwords, PII)
- Do not disable TLS verification
- Do not use \`*\` CORS origins in staging or production
- Do not store plaintext credentials in config files
- Do not bypass authentication middleware for convenience

---

## Using Claude Code

All backend developers on this project use Claude Code. Follow these guidelines:

1. **Read the rules** — Claude Code loads rules from \`.claude/rules/\`. Familiarize yourself with them.
2. **Be specific** — Give Claude Code context about which layer you're working in (handler, service, repository).
3. **Review everything** — AI-generated code must pass the same review standards as human-written code.
4. **Use the plugin** — The CodeForge plugin at \`plugin/codeforge-go-api-gateway/\` provides project-specific commands and agents.
5. **Mark AI contributions** — Use the \`ai-assisted\` PR label and note AI involvement in commit messages when substantial code was generated.

### Example Prompts

\`\`\`
"Add a new Chi middleware that validates API keys against Redis. 
Follow the pattern in internal/middleware/rate_limit.go. 
Include table-driven tests."

"Create a circuit breaker service in internal/circuit/ using the 
three-state pattern (closed, open, half-open). It should integrate 
with the existing observability setup for metrics and tracing."
\`\`\`

---

## Questions?

- **Architecture decisions**: Check [docs/ARCHITECTURE.md](ARCHITECTURE.md)
- **Runbooks**: Check \`docs/runbooks/\`
- **Slack**: Post in \`#api-gateway-dev\`
- **Issues**: Open a GitHub Issue with the appropriate template`,

  'docs/ONBOARDING.md': `# Onboarding Guide — go-api-gateway

Welcome to the API Gateway team. This guide walks you through setting up your local development environment, running the gateway, and verifying everything works end-to-end.

**Time estimate**: 45–60 minutes for full setup.

---

## Table of Contents

1. [Prerequisites](#prerequisites)
2. [Clone and Configure](#clone-and-configure)
3. [Go Toolchain Setup](#go-toolchain-setup)
4. [Local Infrastructure (PostgreSQL + Redis)](#local-infrastructure)
5. [Configuration](#configuration)
6. [Database Migrations](#database-migrations)
7. [Running the Gateway](#running-the-gateway)
8. [Verifying with curl / HTTPie](#verifying-with-curl--httpie)
9. [Running Tests](#running-tests)
10. [Observability (Local)](#observability-local)
11. [IDE Setup](#ide-setup)
12. [Git Hooks and Workflow](#git-hooks-and-workflow)
13. [Claude Code Setup](#claude-code-setup)
14. [Common Issues](#common-issues)
15. [Key Resources](#key-resources)

---

## Prerequisites

Install the following before proceeding:

| Tool | Minimum Version | Install |
|------|----------------|---------|
| Go | 1.22+ | [go.dev/dl](https://go.dev/dl/) |
| Docker + Docker Compose | 24.0+ / 2.20+ | [docs.docker.com](https://docs.docker.com/get-docker/) |
| golangci-lint | 1.57+ | \`go install github.com/golangci/golangci-lint/cmd/golangci-lint@latest\` |
| migrate | 4.17+ | \`go install -tags 'postgres' github.com/golang-migrate/migrate/v4/cmd/migrate@latest\` |
| HTTPie (optional) | 3.0+ | \`brew install httpie\` or \`pip install httpie\` |
| jq (optional) | 1.7+ | \`brew install jq\` |

Verify installations:

\`\`\`bash
go version          # go1.22.x or later
docker --version    # Docker 24.x+
docker compose version
golangci-lint --version
migrate --version
\`\`\`

---

## Clone and Configure

\`\`\`bash
# Clone the repository
git clone git@github.com:<org>/go-api-gateway.git
cd go-api-gateway

# Install git hooks
cp git-hooks/* .git/hooks/
chmod +x .git/hooks/*

# Download Go dependencies
go mod download
go mod verify
\`\`\`

---

## Go Toolchain Setup

Ensure your \`GOPATH\` and \`GOBIN\` are configured:

\`\`\`bash
# Add to your shell profile (~/.zshrc, ~/.bashrc)
export GOPATH="$HOME/go"
export GOBIN="$GOPATH/bin"
export PATH="$GOBIN:$PATH"
\`\`\`

Install development tools:

\`\`\`bash
# Linting and formatting
go install github.com/golangci/golangci-lint/cmd/golangci-lint@latest
go install golang.org/x/tools/cmd/goimports@latest

# Testing utilities
go install gotest.tools/gotestsum@latest

# Profiling
go install github.com/google/pprof@latest

# Mock generation (for interfaces)
go install go.uber.org/mock/mockgen@latest
\`\`\`

---

## Local Infrastructure

### Option A: Docker Compose (Recommended)

Start PostgreSQL, Redis, Jaeger, and Prometheus locally:

\`\`\`bash
docker compose -f deployments/docker-compose.dev.yml up -d
\`\`\`

This starts:

| Service | Port | Purpose |
|---------|------|---------|
| PostgreSQL | 5432 | Config store, API key metadata |
| Redis | 6379 | Rate limiting, caching, session store |
| Jaeger | 16686 (UI), 4318 (OTLP) | Distributed tracing |
| Prometheus | 9090 | Metrics collection |
| Grafana | 3000 | Dashboards |

Verify services are healthy:

\`\`\`bash
# PostgreSQL
docker compose -f deployments/docker-compose.dev.yml exec postgres pg_isready
# => accepting connections

# Redis
docker compose -f deployments/docker-compose.dev.yml exec redis redis-cli ping
# => PONG
\`\`\`

### Option B: Native Install

If you prefer running PostgreSQL and Redis natively (macOS):

\`\`\`bash
brew install postgresql@16 redis

brew services start postgresql@16
brew services start redis

# Create the database
createdb gateway_dev
createuser -s gateway
\`\`\`

---

## Configuration

Copy the development config template:

\`\`\`bash
cp configs/development.yaml.example configs/development.yaml
cp .env.example .env
\`\`\`

Edit \`.env\` for local overrides:

\`\`\`bash
# .env — local development overrides
GATEWAY_ENV=development
GATEWAY_PORT=8080
GATEWAY_LOG_LEVEL=debug
GATEWAY_LOG_FORMAT=text

# PostgreSQL
GATEWAY_DB_HOST=localhost
GATEWAY_DB_PORT=5432
GATEWAY_DB_USER=gateway
GATEWAY_DB_PASSWORD=gateway_dev_password
GATEWAY_DB_NAME=gateway_dev
GATEWAY_DB_SSLMODE=disable

# Redis
GATEWAY_REDIS_ADDR=localhost:6379
GATEWAY_REDIS_PASSWORD=
GATEWAY_REDIS_DB=0

# JWT (RS256) — generate dev keys below
GATEWAY_JWT_PUBLIC_KEY_PATH=configs/dev_keys/jwt_public.pem
GATEWAY_JWT_ISSUER=go-api-gateway-dev

# OpenTelemetry
OTEL_EXPORTER_OTLP_ENDPOINT=http://localhost:4318
OTEL_SERVICE_NAME=go-api-gateway
\`\`\`

### Generate Development JWT Keys

\`\`\`bash
mkdir -p configs/dev_keys

# Generate RSA key pair for JWT (RS256)
openssl genrsa -out configs/dev_keys/jwt_private.pem 2048
openssl rsa -in configs/dev_keys/jwt_private.pem -pubout -out configs/dev_keys/jwt_public.pem

# These keys are for LOCAL DEVELOPMENT ONLY
# They are gitignored — never commit private keys
\`\`\`

> **⚠️ Security**: Private keys must never be committed. The \`configs/dev_keys/\` directory is in \`.gitignore\`. Production keys are managed via AWS Secrets Manager.

---

## Database Migrations

Run migrations against your local PostgreSQL:

\`\`\`bash
# Apply all migrations
make migrate-up

# Or manually:
migrate -path scripts/migrations \\
  -database "postgres://gateway:gateway_dev_password@localhost:5432/gateway_dev?sslmode=disable" \\
  up

# Check migration status
migrate -path scripts/migrations \\
  -database "postgres://gateway:gateway_dev_password@localhost:5432/gateway_dev?sslmode=disable" \\
  version
\`\`\`

Seed development data (routes, test API keys):

\`\`\`bash
make seed-dev
# Or:
go run scripts/seed/main.go --config configs/development.yaml
\`\`\`

This creates:

- Sample upstream service routes (\`/api/v1/users\`, \`/api/v1/orders\`)
- A test API key: \`gw-dev-test-key-12345\` (rate limit: 100 req/min)
- A test JWT user with \`admin\` role

---

## Running the Gateway

### Using Make

\`\`\`bash
# Build and run
make run

# Or build first, then run the binary
make build
./bin/gateway --config configs/development.yaml
\`\`\`

### Using Go directly

\`\`\`bash
# Run without building
go run cmd/gateway/main.go --config configs/development.yaml

# Build optimized binary
go build -o bin/gateway -ldflags="-s -w" cmd/gateway/main.go
./bin/gateway
\`\`\`

### Using Docker

\`\`\`bash
docker build -t go-api-gateway:dev -f deployments/Dockerfile .
docker run -p 8080:8080 --env-file .env --network host go-api-gateway:dev
\`\`\`

You should see startup logs:

\`\`\`
{"time":"2024-...","level":"INFO","msg":"starting api gateway","version":"dev","port":8080}
{"time":"2024-...","level":"INFO","msg":"connected to postgresql","host":"localhost","db":"gateway_dev"}
{"time":"2024-...","level":"INFO","msg":"connected to redis","addr":"localhost:6379"}
{"time":"2024-...","level":"INFO","msg":"loaded 3 upstream routes"}
{"time":"2024-...","level":"INFO","msg":"server listening","addr":":8080"}
\`\`\`

---

## Verifying with curl / HTTPie

### Health Check

\`\`\`bash
# curl
curl -s http://localhost:8080/healthz | jq .

# HTTPie
http GET localhost:8080/healthz
\`\`\`

Expected response:

\`\`\`json
{
  "status": "healthy",
  "version": "dev",
  "uptime": "3.2s",
  "checks": {
    "postgresql": "ok",
    "redis": "ok"
  }
}
\`\`\`

### Readiness Check

\`\`\`bash
curl -s http://localhost:8080/readyz | jq .
\`\`\`

### Prometheus Metrics

\`\`\`bash
curl -s http://localhost:8080/metrics | head -20
\`\`\`

### Authenticated Request (JWT)

Generate a test JWT token:

\`\`\`bash
# Use the dev token generator script
TOKEN=$(go run scripts/gen_token/main.go \\
  --key configs/dev_keys/jwt_private.pem \\
  --sub "user-123" \\
  --role "admin" \\
  --exp 1h)

echo $TOKEN
\`\`\`

Make an authenticated request:

\`\`\`bash
# curl
curl -s -H "Authorization: Bearer $TOKEN" \\
  http://localhost:8080/api/v1/users | jq .

# HTTPie
http GET localhost:8080/api/v1/users "Authorization:Bearer $TOKEN"
\`\`\`

### Authenticated Request (API Key)

\`\`\`bash
# curl
curl -s -H "X-API-Key: gw-dev-test-key-12345" \\
  http://localhost:8080/api/v1/users | jq .

# HTTPie
http GET localhost:8080/api/v1/users "X-API-Key:gw-dev-test-key-12345"
\`\`\`

### Rate Limiting Verification

Hit the rate limit by sending rapid requests:

\`\`\`bash
# Send 110 requests quickly (limit is 100/min for dev key)
for i in $(seq 1 110); do
  STATUS=$(curl -s -o /dev/null -w "%{http_code}" \\
    -H "X-API-Key: gw-dev-test-key-12345" \\
    http://localhost:8080/api/v1/users)
  echo "Request $i: $STATUS"
done
\`\`\`

After 100 requests, you should see \`429 Too Many Requests\` with headers:

\`\`\`
X-RateLimit-Limit: 100
X-RateLimit-Remaining: 0
X-RateLimit-Reset: 1709234567
Retry-After: 42
\`\`\`

### Circuit Breaker Verification

If an upstream service is down, the circuit breaker opens after the configured failure threshold:

\`\`\`bash
# With upstream down, repeated requests will eventually return 503
curl -s -H "Authorization: Bearer $TOKEN" \\
  http://localhost:8080/api/v1/orders | jq .

# Response when circuit is open:
# {"error":"service_unavailable","message":"circuit breaker open for upstream: orders-service"}
\`\`\`

### Request/Response Headers

Check gateway-injected headers:

\`\`\`bash
curl -v -H "Authorization: Bearer $TOKEN" \\
  http://localhost:8080/api/v1/users 2>&1 | grep -i "x-"
\`\`\`

Expected headers:

\`\`\`
X-Request-ID: 550e8400-e29b-41d4-a716-446655440000
X-Gateway-Latency: 12ms
X-RateLimit-Limit: 100
X-RateLimit-Remaining: 99
\`\`\`

---

## Running Tests

### Unit Tests

\`\`\`bash
# All unit tests
make test

# Or directly:
go test ./... -v -count=1

# With coverage
go test ./... -coverprofile=coverage.out -covermode=atomic
go tool cover -html=coverage.out -o coverage.html
open coverage.html

# Specific package
go test ./internal/ratelimit/... -v
go test ./internal/auth/... -v
go test ./internal/middleware/... -v
\`\`\`

### With gotestsum (better output)

\`\`\`bash
gotestsum --format testdox ./...
\`\`\`

### Race Detection

\`\`\`bash
go test -race ./...
\`\`\`

### Integration Tests

Integration tests require running PostgreSQL and Redis:

\`\`\`bash
# Start infrastructure if not already running
docker compose -f deployments/docker-compose.dev.yml up -d

# Run integration tests
make test-integration

# Or:
go test -tags=integration ./tests/... -v -count=1
\`\`\`

### Benchmarks

\`\`\`bash
# Run all benchmarks
go test -bench=. -benchmem ./internal/ratelimit/...
go test -bench=. -benchmem ./internal/middleware/...

# Example output:
# BenchmarkRateLimiter_Allow-8    500000    2341 ns/op    128 B/op    3 allocs/op
# BenchmarkJWTValidation-8        200000    6123 ns/op    512 B/op    8 allocs/op
\`\`\`

### Linting

\`\`\`bash
# Full lint suite
make lint

# Or directly:
golangci-lint run ./...

# Auto-fix where possible
golangci-lint run --fix ./...
\`\`\`

### All Checks (Pre-PR)

\`\`\`bash
make check
# Runs: fmt check → vet → lint → test → race → build
\`\`\`

---

## Observability (Local)

### Jaeger (Distributed Tracing)

Open [http://localhost:16686](http://localhost:16686) in your browser.

1. Select service \`go-api-gateway\` from the dropdown
2. Click **Find Traces**
3. Click any trace to see the full request lifecycle: middleware → auth → rate limit → upstream proxy

### Prometheus (Metrics)

Open [http://localhost:9090](http://localhost:9090).

Useful queries:

\`\`\`promql
# Request rate by route
rate(gateway_http_requests_total[5m])

# P99 latency
histogram_quantile(0.99, rate(gateway_http_request_duration_seconds_bucket[5m]))

# Rate limit rejections
rate(gateway_ratelimit_rejected_total[5m])

# Circuit breaker state changes
gateway_circuit_breaker_state
\`\`\`

### Grafana (Dashboards)

Open [http://localhost:3000](http://localhost:3000) (admin/admin).

Pre-configured dashboards:

- **Gateway Overview**: Request rate, latency percentiles, error rate
- **Rate Limiting**: Per-client usage, rejections, Redis latency
- **Circuit Breakers**: State per upstream, failure rates
- **Go Runtime**: Goroutines, GC pauses, memory usage

### pprof (Profiling)

The gateway exposes pprof endpoints in development mode:

\`\`\`bash
# CPU profile (30 seconds)
go tool pprof http://localhost:8080/debug/pprof/profile?seconds=30

# Heap profile
go tool pprof http://localhost:8080/debug/pprof/heap

# Goroutine dump
curl http://localhost:8080/debug/pprof/goroutine?debug=2
\`\`\`

> **⚠️ Security**: pprof endpoints are disabled in staging and production via config. See \`configs/production.yaml\`.

---

## IDE Setup

### VS Code

Recommended extensions (see \`.vscode/extensions.json\`):

- \`golang.go\` — Go language support
- \`ms-vscode.makefile-tools\` — Makefile support
- \`redhat.vscode-yaml\` — YAML support

Settings for this project:

\`\`\`json
{
  "go.lintTool": "golangci-lint",
  "go.lintFlags": ["--fast"],
  "go.testFlags": ["-v", "-count=1"],
  "go.coverOnSave": true,
  "go.coverageDecorator": {
    "type": "gutter"
  },
  "editor.formatOnSave": true,
  "[go]": {
    "editor.defaultFormatter": "golang.go",
    "editor.codeActionsOnSave": {
      "source.organizeImports": "explicit"
    }
  }
}
\`\`\`

### GoLand / IntelliJ

1. Open the project root as a Go module project
2. Set Go SDK to 1.22+
3. Enable \`golangci-lint\` integration: **Settings → Tools → External Tools**
4. Configure run configuration for \`cmd/gateway/main.go\` with env file \`.env\`

---

## Git Hooks and Workflow

Git hooks are installed during setup (see [Clone and Configure](#clone-and-configure)):

| Hook | What It Does |
|------|-------------|
| \`pre-commit\` | Runs \`gofmt\`, \`goimports\`, \`go vet\`, file length check |
| \`commit-msg\` | Validates conventional commit format (\`feat:\`, \`fix:\`, etc.) |
| \`pre-push\` | Runs \`golangci-lint\` and \`go test -race ./...\` |

### Branch Naming

\`\`\`
feat/GW-42-add-circuit-breaker
fix/GW-57-redis-connection-leak
chore/GW-60-update-dependencies
perf/GW-63-optimize-jwt-cache
docs/GW-65-add-runbook
\`\`\`

### Commit Messages

\`\`\`
feat(ratelimit): add sliding window algorithm with Redis
fix(auth): handle expired JWT tokens gracefully
perf(middleware): reduce allocations in request logging
docs(onboarding): add pprof profiling section
chore(deps): bump chi to v5.0.12
\`\`\`

### Pull Request Flow

1. Create branch from \`main\`: \`git checkout -b feat/GW-42-add-circuit-breaker\`
2. Make changes, commit with conventional commits
3. Push and open PR — CI runs automatically
4. Get at least 1 approval from a code owner
5. Squash merge into \`main\`
6. Staging deploys automatically

---

## Claude Code Setup

All backend developers use Claude Code for development assistance.

### First-Time Setup

1. Install Claude Code: follow [claude.ai/code](https://claude.ai/code)
2. Claude will automatically read \`.claude/rules/\` and \`CLAUDE.md\` for project context
3. MCP servers are configured in \`.mcp.json\` for GitHub Issues integration

### Usage Guidelines

- Claude-generated code must pass all linting and tests before committing
- AI-assisted commits are flagged automatically in CI (see \`.github/workflows/ai-code-audit.yml\`)
- Review AI-generated code with the same rigor as human-written code
- Use Claude for: boilerplate, test generation, documentation, debugging, code review prep
- Always verify: security-sensitive code (\`internal/auth/**\`), database migrations, configuration changes

### Useful Claude Prompts for This Project

\`\`\`
"Add table-driven tests for the JWT validation function in internal/auth/jwt.go"
"Implement a new Chi middleware for request ID propagation following our middleware pattern"
"Review this handler for proper error wrapping and context propagation"
"Generate integration tests for the rate limiter against Redis"
\`\`\`

---

## Common Issues

### Port 8080 already in use

\`\`\`bash
lsof -i :8080
kill -9 <PID>
# Or change GATEWAY_PORT in .env
\`\`\`

### PostgreSQL connection refused

\`\`\`bash
# Check if PostgreSQL is running
docker compose -f deployments/docker-compose.dev.yml ps postgres

# Check logs
docker compose -f deployments/docker-compose.dev.yml logs postgres

# Restart
docker compose -f deployments/docker-compose.dev.yml restart postgres
\`\`\`

### Redis WRONGPASS or connection error

\`\`\`bash
# Verify Redis is accessible
redis-cli -h localhost -p 6379 ping

# If using Docker Compose, ensure no password is set for dev
docker compose -f deployments/docker-compose.dev.yml exec redis redis-cli ping
\`\`\`

### \`go mod tidy\` changes go.sum unexpectedly

\`\`\`bash
# Reset and re-download
rm go.sum
go mod tidy
go mod verify
\`\`\`

### golangci-lint timeout

\`\`\`bash
# Increase timeout for first run (downloads cache)
golangci-lint run --timeout 5m ./...
\`\`\`

### Migration "dirty" state

\`\`\`bash
# Force version (use with caution)
migrate -path scripts/migrations \\
  -database "postgres://gateway:gateway_dev_password@localhost:5432/gateway_dev?sslmode=disable" \\
  force <version>
\`\`\`

### Tests fail with "context deadline exceeded"

Ensure Redis and PostgreSQL are running. Integration tests have a 10-second timeout per test. If infrastructure is slow to start:

\`\`\`bash
# Wait for services to be ready
docker compose -f deployments/docker-compose.dev.yml up -d --wait
\`\`\`

---

## Key Resources

| Resource | Location |
|----------|----------|
| Architecture overview | [docs/ARCHITECTURE.md](./ARCHITECTURE.md) |
| API documentation | [docs/api/](./api/) |
| Runbooks | [docs/runbooks/](./runbooks/) |
| Project rules (Claude) | [CLAUDE.md](../CLAUDE.md) |
| CI/CD workflows | [.github/workflows/](../.github/workflows/) |
| Config reference | [configs/README.md](../configs/README.md) |
| Effective Go | [go.dev/doc/effective_go](https://go.dev/doc/effective_go) |
| Chi documentation | [go-chi.io](https://go-chi.io/) |
| OpenTelemetry Go | [opentelemetry.io/docs/go](https://opentelemetry.io/docs/languages/go/) |

---

## Checklist

Before you start your first task, confirm:

- [ ] Go 1.22+ installed and on PATH
- [ ] Docker Compose services running (PostgreSQL, Redis, Jaeger, Prometheus)
- [ ] \`.env\` configured with local settings
- [ ] Dev JWT keys generated in \`configs/dev_keys/\`
- [ ] Migrations applied successfully
- [ ] \`make run\` starts the gateway without errors
- [ ] \`curl localhost:8080/healthz\` returns \`{"status":"healthy"}\`
- [ ] \`make check\` passes (fmt, vet, lint, test, race, build)
- [ ] Git hooks installed and working
- [ ] Claude Code installed and reading project context

**Welcome to the team!** Reach out in \`#api-gateway\` on Slack if you hit any issues.`,

  'git-hooks/commit-msg': `#!/usr/bin/env bash
#
# commit-msg hook — validates conventional commit format for go-api-gateway
#
# Format: type(scope): description
#   or:   type: description
#
# Allowed types: feat, fix, chore, docs, perf, refactor, test, ci, build, style, revert
# Scope is optional but encouraged (e.g., handler, middleware, auth, ratelimit, circuit, config)
#
# Install: ln -sf ../../git-hooks/commit-msg .git/hooks/commit-msg

set -euo pipefail

COMMIT_MSG_FILE="$1"
COMMIT_MSG=$(head -1 "$COMMIT_MSG_FILE")

RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[0;33m'
NC='\\033[0m'

# Skip merge commits
if echo "$COMMIT_MSG" | grep -qE '^Merge (branch|pull request|remote-tracking)'; then
  exit 0
fi

# Skip revert commits generated by git
if echo "$COMMIT_MSG" | grep -qE '^Revert "'; then
  exit 0
fi

# Skip fixup/squash commits (used during interactive rebase)
if echo "$COMMIT_MSG" | grep -qE '^(fixup|squash)! '; then
  exit 0
fi

# Allowed conventional commit types
TYPES="feat|fix|chore|docs|perf|refactor|test|ci|build|style|revert"

# Known scopes for go-api-gateway (optional, used for suggestions)
KNOWN_SCOPES="handler|middleware|auth|ratelimit|circuit|config|service|repository|model|observability|httputil|errors|deploy|docker|helm|terraform|deps"

# Pattern: type(scope): description  OR  type: description
# - type is required, must be one of the allowed types
# - scope is optional, lowercase alphanumeric with hyphens
# - colon and space after type/scope is required
# - description must start with lowercase letter
# - description must not end with a period
CONVENTIONAL_PATTERN="^(\${TYPES})(\\([a-z][a-z0-9-]*\\))?!?: [a-z].*[^.]$"

if ! echo "$COMMIT_MSG" | grep -qE "$CONVENTIONAL_PATTERN"; then
  echo -e "\${RED}✗ Invalid commit message format\${NC}"
  echo ""
  echo -e "  Got: \${YELLOW}\${COMMIT_MSG}\${NC}"
  echo ""
  echo -e "  Expected format: \${GREEN}type(scope): description\${NC}"
  echo -e "  Or:              \${GREEN}type: description\${NC}"
  echo -e "  Breaking change: \${GREEN}type(scope)!: description\${NC}"
  echo ""
  echo -e "  Allowed types: \${GREEN}\${TYPES}\${NC}"
  echo -e "  Common scopes: \${GREEN}\${KNOWN_SCOPES}\${NC}"
  echo ""
  echo "  Rules:"
  echo "    - type must be one of the allowed types"
  echo "    - scope is optional but encouraged (lowercase, alphanumeric)"
  echo "    - colon followed by a space is required after type/scope"
  echo "    - description must start with a lowercase letter"
  echo "    - description must not end with a period"
  echo ""
  echo "  Examples:"
  echo -e "    \${GREEN}feat(ratelimit): add sliding window algorithm with redis\${NC}"
  echo -e "    \${GREEN}fix(auth): handle expired jwt tokens gracefully\${NC}"
  echo -e "    \${GREEN}perf(middleware): reduce allocation in request logging\${NC}"
  echo -e "    \${GREEN}chore(deps): bump chi to v5.1.0\${NC}"
  echo -e "    \${GREEN}docs: update api gateway architecture diagram\${NC}"
  echo -e "    \${GREEN}refactor(circuit)!: change circuit breaker state machine api\${NC}"
  echo -e "    \${GREEN}test(handler): add table-driven tests for route matching\${NC}"
  echo ""
  exit 1
fi

# Validate subject line length (max 72 characters for git log readability)
SUBJECT_LENGTH=\${#COMMIT_MSG}
MAX_SUBJECT_LENGTH=72

if [ "$SUBJECT_LENGTH" -gt "$MAX_SUBJECT_LENGTH" ]; then
  echo -e "\${RED}✗ Commit subject too long\${NC}"
  echo ""
  echo -e "  Length: \${YELLOW}\${SUBJECT_LENGTH}\${NC} characters (max \${MAX_SUBJECT_LENGTH})"
  echo -e "  Subject: \${YELLOW}\${COMMIT_MSG}\${NC}"
  echo ""
  echo "  Shorten the description to fit within \${MAX_SUBJECT_LENGTH} characters."
  echo "  Move details to the commit body (leave a blank line after the subject)."
  echo ""
  exit 1
fi

# Validate body formatting if present
BODY_LINES=$(tail -n +2 "$COMMIT_MSG_FILE")
if [ -n "$BODY_LINES" ]; then
  SECOND_LINE=$(sed -n '2p' "$COMMIT_MSG_FILE")
  if [ -n "$SECOND_LINE" ]; then
    echo -e "\${RED}✗ Missing blank line between subject and body\${NC}"
    echo ""
    echo "  The second line of a commit message must be blank."
    echo "  This separates the subject from the body for proper git log formatting."
    echo ""
    exit 1
  fi

  # Check body line length (max 100 characters)
  MAX_BODY_LENGTH=100
  LINE_NUM=0
  while IFS= read -r line; do
    LINE_NUM=$((LINE_NUM + 1))
    if [ \${#line} -gt "$MAX_BODY_LENGTH" ]; then
      echo -e "\${YELLOW}⚠ Body line \${LINE_NUM} exceeds \${MAX_BODY_LENGTH} characters (\${#line})\${NC}"
      echo "  Consider wrapping long lines for readability."
      # Warning only, don't block
    fi
  done <<< "$BODY_LINES"
fi

# Check for ticket reference in commit (optional but encouraged)
FULL_MSG=$(cat "$COMMIT_MSG_FILE")
if ! echo "$FULL_MSG" | grep -qiE '(GW-[0-9]+|#[0-9]+|closes|fixes|resolves)'; then
  echo -e "\${YELLOW}⚠ No ticket reference found (e.g., GW-42 or #42)\${NC}"
  echo "  Consider adding a reference in the subject or body for traceability."
fi

echo -e "\${GREEN}✓ Commit message format valid\${NC}"
exit 0`,

  'git-hooks/pre-commit': `#!/usr/bin/env bash
set -euo pipefail

# Pre-commit hook for go-api-gateway
# Runs golangci-lint, gofmt check, and prevents sensitive files from being committed.

RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
NC='\\033[0m'

ERRORS=0

printf "\${YELLOW}Running pre-commit checks...\${NC}\\n"

# ---------------------------------------------------------------------------
# 1. Prevent sensitive files from being committed (.env*, *.pem, private keys)
# ---------------------------------------------------------------------------
printf "\\n\${YELLOW}[1/4] Checking for sensitive files...\${NC}\\n"

SENSITIVE_PATTERNS=(
  '\\.env$'
  '\\.env\\.'
  '\\.pem$'
  '\\.key$'
  'id_rsa'
  'id_ed25519'
  '\\.p12$'
  '\\.pfx$'
  'config/production/.*'
)

STAGED_FILES=$(git diff --cached --name-only --diff-filter=ACR 2>/dev/null || true)

if [ -n "$STAGED_FILES" ]; then
  for pattern in "\${SENSITIVE_PATTERNS[@]}"; do
    MATCHES=$(echo "$STAGED_FILES" | grep -E "$pattern" || true)
    if [ -n "$MATCHES" ]; then
      printf "\${RED}BLOCKED: Sensitive file(s) detected in commit:\${NC}\\n"
      echo "$MATCHES" | while read -r f; do
        printf "  \${RED}✗ %s\${NC}\\n" "$f"
      done
      printf "\\nIf this is intentional, use: git commit --no-verify\\n"
      printf "SOC 2 compliance requires secrets stay out of version control.\\n"
      ERRORS=1
    fi
  done

  # Check for hardcoded secrets in staged Go files
  GO_FILES=$(echo "$STAGED_FILES" | grep '\\.go$' || true)
  if [ -n "$GO_FILES" ]; then
    SECRET_GREP=$(echo "$GO_FILES" | xargs grep -nE '(password|secret|api_key|apikey|token)\\s*[:=]\\s*"[^"]{8,}"' 2>/dev/null || true)
    if [ -n "$SECRET_GREP" ]; then
      printf "\${RED}BLOCKED: Possible hardcoded secrets found:\${NC}\\n"
      echo "$SECRET_GREP" | head -10
      printf "\\nUse environment variables or Viper config instead.\\n"
      ERRORS=1
    fi
  fi
fi

if [ "$ERRORS" -eq 0 ]; then
  printf "\${GREEN}  ✓ No sensitive files detected\${NC}\\n"
fi

# ---------------------------------------------------------------------------
# 2. Check gofmt / goimports formatting
# ---------------------------------------------------------------------------
printf "\\n\${YELLOW}[2/4] Checking Go formatting (gofmt)...\${NC}\\n"

if [ -n "$GO_FILES" ]; then
  UNFORMATTED=$(gofmt -l $GO_FILES 2>/dev/null || true)
  if [ -n "$UNFORMATTED" ]; then
    printf "\${RED}The following files are not formatted with gofmt:\${NC}\\n"
    echo "$UNFORMATTED" | while read -r f; do
      printf "  \${RED}✗ %s\${NC}\\n" "$f"
    done
    printf "\\nRun: gofmt -w . && goimports -w .\\n"
    ERRORS=1
  else
    printf "\${GREEN}  ✓ All Go files are properly formatted\${NC}\\n"
  fi

  # Also check goimports if available
  if command -v goimports &>/dev/null; then
    UNIMPORTED=$(goimports -l $GO_FILES 2>/dev/null || true)
    if [ -n "$UNIMPORTED" ]; then
      printf "\${RED}The following files have incorrect imports:\${NC}\\n"
      echo "$UNIMPORTED" | while read -r f; do
        printf "  \${RED}✗ %s\${NC}\\n" "$f"
      done
      printf "\\nRun: goimports -w .\\n"
      ERRORS=1
    fi
  fi
else
  printf "\${GREEN}  ✓ No Go files staged\${NC}\\n"
fi

# ---------------------------------------------------------------------------
# 3. Run go vet
# ---------------------------------------------------------------------------
printf "\\n\${YELLOW}[3/4] Running go vet...\${NC}\\n"

if [ -n "$GO_FILES" ]; then
  # Determine which packages are affected
  PACKAGES=$(echo "$GO_FILES" | xargs -I{} dirname {} | sort -u | sed 's|^|./|')
  if go vet $PACKAGES 2>&1; then
    printf "\${GREEN}  ✓ go vet passed\${NC}\\n"
  else
    printf "\${RED}  ✗ go vet found issues\${NC}\\n"
    ERRORS=1
  fi
else
  printf "\${GREEN}  ✓ No Go files to vet\${NC}\\n"
fi

# ---------------------------------------------------------------------------
# 4. Run golangci-lint (on changed packages only for speed)
# ---------------------------------------------------------------------------
printf "\\n\${YELLOW}[4/4] Running golangci-lint...\${NC}\\n"

if [ -n "$GO_FILES" ]; then
  if command -v golangci-lint &>/dev/null; then
    # Lint only the packages that have changed files for faster feedback
    LINT_PACKAGES=$(echo "$GO_FILES" | xargs -I{} dirname {} | sort -u | sed 's|^|./|' | paste -sd ' ' -)
    if golangci-lint run --new-from-rev=HEAD~1 --timeout=2m $LINT_PACKAGES 2>&1; then
      printf "\${GREEN}  ✓ golangci-lint passed\${NC}\\n"
    else
      printf "\${RED}  ✗ golangci-lint found issues\${NC}\\n"
      printf "Run: golangci-lint run --fix ./... to auto-fix where possible\\n"
      ERRORS=1
    fi
  else
    printf "\${YELLOW}  ⚠ golangci-lint not installed, skipping\${NC}\\n"
    printf "  Install: go install github.com/golangci/golangci-lint/cmd/golangci-lint@latest\\n"
  fi
else
  printf "\${GREEN}  ✓ No Go files to lint\${NC}\\n"
fi

# ---------------------------------------------------------------------------
# 5. Check file length convention (max 300 lines)
# ---------------------------------------------------------------------------
if [ -n "$GO_FILES" ]; then
  LONG_FILES=""
  for f in $GO_FILES; do
    if [ -f "$f" ]; then
      LINES=$(wc -l < "$f")
      if [ "$LINES" -gt 300 ]; then
        LONG_FILES="\${LONG_FILES}\\n  \${YELLOW}⚠ \${f} (\${LINES} lines)\${NC}"
      fi
    fi
  done
  if [ -n "$LONG_FILES" ]; then
    printf "\\n\${YELLOW}Warning: Files exceeding 300-line limit:\${NC}"
    printf "$LONG_FILES\\n"
    printf "Consider splitting into smaller, focused files.\\n"
    # Warning only — does not block commit
  fi
fi

# ---------------------------------------------------------------------------
# 6. Verify conventional commit message format (if message file exists)
# ---------------------------------------------------------------------------
# Note: Commit message validation is handled by commit-msg hook.
# This hook focuses on code quality gates.

# ---------------------------------------------------------------------------
# Summary
# ---------------------------------------------------------------------------
printf "\\n"
if [ "$ERRORS" -ne 0 ]; then
  printf "\${RED}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}\\n"
  printf "\${RED}Pre-commit checks FAILED. Fix the issues above before committing.\${NC}\\n"
  printf "\${RED}To bypass (not recommended): git commit --no-verify\${NC}\\n"
  printf "\${RED}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}\\n"
  exit 1
else
  printf "\${GREEN}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}\\n"
  printf "\${GREEN}All pre-commit checks passed ✓\${NC}\\n"
  printf "\${GREEN}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}\\n"
  exit 0
fi`,

  'git-hooks/pre-push': `#!/usr/bin/env bash
# Pre-push hook for go-api-gateway
# Runs test suite and blocks push on failure
# Install: cp git-hooks/pre-push .git/hooks/pre-push && chmod +x .git/hooks/pre-push

set -euo pipefail

# Colors for output
RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
CYAN='\\033[0;36m'
NC='\\033[0m' # No Color

# Track overall status
FAILED=0

info() {
    echo -e "\${CYAN}[pre-push]\${NC} $1"
}

success() {
    echo -e "\${GREEN}[pre-push]\${NC} ✓ $1"
}

warn() {
    echo -e "\${YELLOW}[pre-push]\${NC} ⚠ $1"
}

fail() {
    echo -e "\${RED}[pre-push]\${NC} ✗ $1"
    FAILED=1
}

# Allow skipping with SKIP_PRE_PUSH=1 git push
if [ "\${SKIP_PRE_PUSH:-0}" = "1" ]; then
    warn "Pre-push hook skipped via SKIP_PRE_PUSH=1"
    exit 0
fi

# Read push info from stdin (remote name and URL)
while read -r local_ref local_sha remote_ref remote_sha; do
    # Skip delete pushes
    if [ "$local_sha" = "0000000000000000000000000000000000000000" ]; then
        continue
    fi

    # Warn on push to main (should go through PR)
    if echo "$remote_ref" | grep -q "refs/heads/main$"; then
        warn "Pushing directly to main — ensure this is intentional (hotfix, CI, etc.)"
    fi
done

echo ""
echo -e "\${CYAN}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
echo -e "\${CYAN}  go-api-gateway pre-push checks\${NC}"
echo -e "\${CYAN}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
echo ""

# ─── Step 1: Verify Go toolchain ─────────────────────────────────────────────
if ! command -v go &>/dev/null; then
    fail "Go is not installed or not in PATH"
    exit 1
fi

GO_VERSION=$(go version | awk '{print $3}')
info "Using \${GO_VERSION}"

# ─── Step 2: go vet ──────────────────────────────────────────────────────────
info "Running go vet ./..."
if go vet ./... 2>&1; then
    success "go vet passed"
else
    fail "go vet found issues"
fi

# ─── Step 3: golangci-lint (if available) ────────────────────────────────────
if command -v golangci-lint &>/dev/null; then
    info "Running golangci-lint..."
    if golangci-lint run --timeout 3m ./... 2>&1; then
        success "golangci-lint passed"
    else
        fail "golangci-lint found issues"
    fi
else
    warn "golangci-lint not found — skipping (install: https://golangci-lint.run/usage/install/)"
fi

# ─── Step 4: Unit tests ─────────────────────────────────────────────────────
info "Running go test ./... (with race detector)"
if go test -race -count=1 -timeout 5m ./... 2>&1; then
    success "All tests passed"
else
    fail "Tests failed — push blocked"
fi

# ─── Step 5: Build verification ─────────────────────────────────────────────
info "Verifying build compiles..."
if go build -o /dev/null ./cmd/gateway/ 2>&1; then
    success "Build compiles successfully"
else
    fail "Build failed — push blocked"
fi

# ─── Step 6: Check test coverage threshold ───────────────────────────────────
COVERAGE_THRESHOLD=80

info "Checking test coverage (threshold: \${COVERAGE_THRESHOLD}%)..."
COVERAGE_OUTPUT=$(go test -coverprofile=/tmp/go-api-gateway-coverage.out ./... 2>&1) || true

if [ -f /tmp/go-api-gateway-coverage.out ]; then
    TOTAL_COVERAGE=$(go tool cover -func=/tmp/go-api-gateway-coverage.out 2>/dev/null | grep "^total:" | awk '{print $3}' | tr -d '%')

    if [ -n "$TOTAL_COVERAGE" ]; then
        # Compare using awk for float comparison
        BELOW_THRESHOLD=$(awk "BEGIN {print ($TOTAL_COVERAGE < $COVERAGE_THRESHOLD) ? 1 : 0}")
        if [ "$BELOW_THRESHOLD" = "1" ]; then
            fail "Test coverage \${TOTAL_COVERAGE}% is below threshold \${COVERAGE_THRESHOLD}%"
        else
            success "Test coverage: \${TOTAL_COVERAGE}% (threshold: \${COVERAGE_THRESHOLD}%)"
        fi
    else
        warn "Could not parse coverage — skipping threshold check"
    fi

    rm -f /tmp/go-api-gateway-coverage.out
else
    warn "Could not generate coverage profile — skipping threshold check"
fi

# ─── Step 7: Check for sensitive files ───────────────────────────────────────
info "Scanning for sensitive files in staged commits..."

SENSITIVE_PATTERNS=(
    '\\.pem$'
    '\\.key$'
    '\\.env$'
    '\\.env\\.'
    'config/production/'
    'credentials'
    'secret'
)

SENSITIVE_FOUND=0
for pattern in "\${SENSITIVE_PATTERNS[@]}"; do
    # Check files that differ from remote
    MATCHES=$(git diff --name-only HEAD @{upstream} 2>/dev/null | grep -iE "$pattern" || true)
    if [ -n "$MATCHES" ]; then
        while IFS= read -r file; do
            # Allow known safe files
            if echo "$file" | grep -qE '(\\.md$|_test\\.go$|testdata/|mock|example)'; then
                continue
            fi
            fail "Potentially sensitive file detected: \${file}"
            SENSITIVE_FOUND=1
        done <<< "$MATCHES"
    fi
done

if [ "$SENSITIVE_FOUND" = "0" ]; then
    success "No sensitive files detected"
fi

# ─── Step 8: Check for large files ──────────────────────────────────────────
MAX_FILE_SIZE_KB=1024  # 1MB

info "Checking for large files (>\${MAX_FILE_SIZE_KB}KB)..."
LARGE_FILES_FOUND=0

# Check files changed since upstream
CHANGED_FILES=$(git diff --name-only HEAD @{upstream} 2>/dev/null || git diff --name-only HEAD~1 2>/dev/null || true)
if [ -n "$CHANGED_FILES" ]; then
    while IFS= read -r file; do
        if [ -f "$file" ]; then
            FILE_SIZE_KB=$(du -k "$file" 2>/dev/null | cut -f1)
            if [ -n "$FILE_SIZE_KB" ] && [ "$FILE_SIZE_KB" -gt "$MAX_FILE_SIZE_KB" ]; then
                fail "Large file detected: \${file} (\${FILE_SIZE_KB}KB > \${MAX_FILE_SIZE_KB}KB)"
                LARGE_FILES_FOUND=1
            fi
        fi
    done <<< "$CHANGED_FILES"
fi

if [ "$LARGE_FILES_FOUND" = "0" ]; then
    success "No oversized files detected"
fi

# ─── Results ─────────────────────────────────────────────────────────────────
echo ""
echo -e "\${CYAN}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"

if [ "$FAILED" -ne 0 ]; then
    echo -e "\${RED}  Pre-push checks FAILED — push blocked\${NC}"
    echo -e "\${RED}  Fix the issues above and try again.\${NC}"
    echo ""
    echo -e "  To bypass (emergency only): \${YELLOW}SKIP_PRE_PUSH=1 git push\${NC}"
    echo -e "\${CYAN}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
    echo ""
    exit 1
else
    echo -e "\${GREEN}  All pre-push checks passed ✓\${NC}"
    echo -e "\${CYAN}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
    echo ""
    exit 0
fi`,

  'go.mod': `module github.com/yourorg/go-api-gateway

go 1.22.0

require (
	github.com/go-chi/chi/v5 v5.1.0
	github.com/go-chi/cors v1.2.1
	github.com/golang-jwt/jwt/v5 v5.2.1
	github.com/jackc/pgx/v5 v5.6.0
	github.com/prometheus/client_golang v1.19.1
	github.com/redis/go-redis/v9 v9.5.3
	github.com/spf13/viper v1.19.0
	github.com/stretchr/testify v1.9.0
	go.opentelemetry.io/otel v1.27.0
	go.opentelemetry.io/otel/exporters/otlp/otlptrace/otlptracegrpc v1.27.0
	go.opentelemetry.io/otel/exporters/prometheus v0.49.0
	go.opentelemetry.io/otel/sdk v1.27.0
	go.opentelemetry.io/otel/sdk/metric v1.27.0
	go.opentelemetry.io/otel/trace v1.27.0
	golang.org/x/time v0.5.0
)

require (
	github.com/beorn7/perks v1.0.1 // indirect
	github.com/cenkalti/backoff/v4 v4.3.0 // indirect
	github.com/cespare/xxhash/v2 v2.3.0 // indirect
	github.com/davecgh/go-spew v1.1.2-0.20180830191138-d8f796af33cc // indirect
	github.com/dgryski/go-rendezvous v0.0.0-20200823014737-9f7001d12a5f // indirect
	github.com/fsnotify/fsnotify v1.7.0 // indirect
	github.com/go-logr/logr v1.4.2 // indirect
	github.com/go-logr/stdr v1.2.2 // indirect
	github.com/grpc-ecosystem/grpc-gateway/v2 v2.20.0 // indirect
	github.com/hashicorp/hcl v1.0.0 // indirect
	github.com/jackc/pgpassfile v1.0.0 // indirect
	github.com/jackc/pgservicefile v0.0.0-20240606120523-5a60cdf6a761 // indirect
	github.com/jackc/puddle/v2 v2.2.1 // indirect
	github.com/magiconair/properties v1.8.7 // indirect
	github.com/mitchellh/mapstructure v1.5.0 // indirect
	github.com/pelletier/go-toml/v2 v2.2.2 // indirect
	github.com/pmezard/go-difflib v1.0.1-0.20181226105442-5d4384ee4fb2 // indirect
	github.com/prometheus/client_model v0.6.1 // indirect
	github.com/prometheus/common v0.54.0 // indirect
	github.com/prometheus/procfs v0.15.1 // indirect
	github.com/sagikazarmark/locafero v0.6.0 // indirect
	github.com/sagikazarmark/slog-shim v0.1.0 // indirect
	github.com/sourcegraph/conc v0.3.0 // indirect
	github.com/spf13/afero v1.11.0 // indirect
	github.com/spf13/cast v1.6.0 // indirect
	github.com/spf13/pflag v1.0.5 // indirect
	github.com/subosito/gotenv v1.6.0 // indirect
	go.opentelemetry.io/otel/metric v1.27.0 // indirect
	go.opentelemetry.io/proto/otlp v1.3.1 // indirect
	go.uber.org/multierr v1.11.0 // indirect
	golang.org/x/crypto v0.24.0 // indirect
	golang.org/x/net v0.26.0 // indirect
	golang.org/x/sync v0.7.0 // indirect
	golang.org/x/sys v0.21.0 // indirect
	golang.org/x/text v0.16.0 // indirect
	google.golang.org/genproto/googleapis/api v0.0.0-20240617180043-68d350f18fd4 // indirect
	google.golang.org/genproto/googleapis/rpc v0.0.0-20240617180043-68d350f18fd4 // indirect
	google.golang.org/grpc v1.64.0 // indirect
	google.golang.org/protobuf v1.34.2 // indirect
	gopkg.in/ini.v1 v1.67.0 // indirect
	gopkg.in/yaml.v3 v3.0.1 // indirect
)`,

  'install.sh': `#!/usr/bin/env bash
set -euo pipefail

# go-api-gateway installer
# Sets up git hooks, installs Go dependencies, configures .claude/, and installs the CodeForge plugin.

SCRIPT_DIR="$(cd "$(dirname "\${BASH_SOURCE[0]}")" && pwd)"
PROJECT_ROOT="$SCRIPT_DIR"

# Colors for output
RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
BLUE='\\033[0;34m'
NC='\\033[0m' # No Color

info()    { echo -e "\${BLUE}[INFO]\${NC}  $*"; }
success() { echo -e "\${GREEN}[OK]\${NC}    $*"; }
warn()    { echo -e "\${YELLOW}[WARN]\${NC}  $*"; }
error()   { echo -e "\${RED}[ERROR]\${NC} $*"; }

header() {
  echo ""
  echo -e "\${BLUE}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
  echo -e "\${BLUE}  $*\${NC}"
  echo -e "\${BLUE}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
}

check_command() {
  if command -v "$1" &>/dev/null; then
    success "$1 found: $(command -v "$1")"
    return 0
  else
    error "$1 not found"
    return 1
  fi
}

check_version_gte() {
  local cmd="$1"
  local required="$2"
  local current
  current="$($3)"
  if [ "$(printf '%s\\n' "$required" "$current" | sort -V | head -n1)" = "$required" ]; then
    success "$cmd version $current >= $required"
    return 0
  else
    error "$cmd version $current < $required (required)"
    return 1
  fi
}

# ─────────────────────────────────────────────────────────────
header "go-api-gateway — Project Setup"
# ─────────────────────────────────────────────────────────────

info "Project root: $PROJECT_ROOT"
cd "$PROJECT_ROOT"

ERRORS=0

# ─────────────────────────────────────────────────────────────
header "Step 1: Checking Prerequisites"
# ─────────────────────────────────────────────────────────────

# Go 1.22+
if check_command go; then
  GO_VERSION=$(go version | grep -oP '\\d+\\.\\d+(\\.\\d+)?' | head -1)
  check_version_gte "go" "1.22" "echo $GO_VERSION" || ERRORS=$((ERRORS + 1))
else
  error "Go is required. Install from https://go.dev/dl/"
  ERRORS=$((ERRORS + 1))
fi

# Git
if ! check_command git; then
  error "Git is required."
  ERRORS=$((ERRORS + 1))
fi

# Docker (optional but recommended)
if check_command docker; then
  info "Docker is available for integration tests and local development."
else
  warn "Docker not found. You won't be able to run integration tests or docker-compose locally."
fi

# docker-compose or docker compose
if command -v docker-compose &>/dev/null; then
  success "docker-compose found"
elif docker compose version &>/dev/null 2>&1; then
  success "docker compose (plugin) found"
else
  warn "docker-compose not found. Local stack (PostgreSQL, Redis) must be managed manually."
fi

# golangci-lint
if check_command golangci-lint; then
  info "golangci-lint version: $(golangci-lint --version 2>&1 | head -1)"
else
  warn "golangci-lint not found. Installing..."
  if go install github.com/golangci/golangci-lint/cmd/golangci-lint@latest 2>/dev/null; then
    success "golangci-lint installed via go install"
  else
    warn "Could not install golangci-lint. Install manually: https://golangci-lint.run/welcome/install/"
    warn "Pre-commit hook linting will be skipped until golangci-lint is available."
  fi
fi

# Node.js (for mock MCP servers)
if check_command node; then
  NODE_VERSION=$(node --version | sed 's/v//')
  info "Node.js version: $NODE_VERSION (used for mock MCP servers)"
else
  warn "Node.js not found. Mock MCP servers won't be available for local development."
  warn "This is optional — Claude Code MCP integration works without local mocks in CI."
fi

# Claude Code CLI (optional)
if check_command claude; then
  success "Claude Code CLI found"
else
  warn "Claude Code CLI not found. Install from https://docs.anthropic.com/en/docs/claude-code"
  warn "Claude Code is optional for development but required for AI-assisted workflows."
fi

if [ "$ERRORS" -gt 0 ]; then
  echo ""
  error "$ERRORS critical prerequisite(s) missing. Fix the errors above and re-run."
  exit 1
fi

# ─────────────────────────────────────────────────────────────
header "Step 2: Installing Go Dependencies"
# ─────────────────────────────────────────────────────────────

if [ -f "go.mod" ]; then
  info "Running go mod download..."
  go mod download
  success "Go module dependencies downloaded"

  info "Running go mod tidy..."
  go mod tidy
  success "go.mod and go.sum are tidy"
else
  warn "go.mod not found. Initializing Go module..."
  go mod init github.com/your-org/go-api-gateway
  success "Go module initialized. Run 'go mod tidy' after adding imports."
fi

# Install development tools
info "Installing development tools..."

TOOLS=(
  "github.com/golangci/golangci-lint/cmd/golangci-lint@latest"
  "go.uber.org/mock/mockgen@latest"
  "github.com/swaggo/swag/cmd/swag@latest"
  "github.com/air-verse/air@latest"
)

for tool in "\${TOOLS[@]}"; do
  tool_name=$(basename "\${tool%%@*}")
  if command -v "$tool_name" &>/dev/null; then
    success "$tool_name already installed"
  else
    info "Installing $tool_name..."
    if go install "$tool" 2>/dev/null; then
      success "$tool_name installed"
    else
      warn "Failed to install $tool_name — install manually if needed"
    fi
  fi
done

# ─────────────────────────────────────────────────────────────
header "Step 3: Setting Up Git Hooks"
# ─────────────────────────────────────────────────────────────

HOOKS_DIR="$PROJECT_ROOT/git-hooks"
GIT_HOOKS_DIR="$PROJECT_ROOT/.git/hooks"

if [ ! -d "$PROJECT_ROOT/.git" ]; then
  warn "Not a git repository. Initializing..."
  git init
  success "Git repository initialized"
fi

if [ -d "$HOOKS_DIR" ]; then
  # Configure git to use our hooks directory
  git config core.hooksPath git-hooks
  success "Git hooks path set to git-hooks/"

  # Ensure hooks are executable
  chmod +x "$HOOKS_DIR"/* 2>/dev/null || true

  HOOK_COUNT=$(find "$HOOKS_DIR" -maxdepth 1 -type f | wc -l)
  success "Configured $HOOK_COUNT git hook(s):"

  for hook in "$HOOKS_DIR"/*; do
    if [ -f "$hook" ]; then
      hook_name=$(basename "$hook")
      info "  ✓ $hook_name"
    fi
  done
else
  warn "git-hooks/ directory not found. Skipping hook setup."
  warn "Create git-hooks/ with pre-commit, commit-msg, and pre-push hooks."
fi

# ─────────────────────────────────────────────────────────────
header "Step 4: Configuring .claude/ Directory"
# ─────────────────────────────────────────────────────────────

CLAUDE_DIR="$PROJECT_ROOT/.claude"

if [ -d "$CLAUDE_DIR" ]; then
  success ".claude/ directory exists"

  # Validate settings.json
  if [ -f "$CLAUDE_DIR/settings.json" ]; then
    if command -v python3 &>/dev/null; then
      if python3 -c "import json; json.load(open('$CLAUDE_DIR/settings.json'))" 2>/dev/null; then
        success ".claude/settings.json is valid JSON"
      else
        error ".claude/settings.json contains invalid JSON — fix before using Claude Code"
      fi
    elif command -v jq &>/dev/null; then
      if jq empty "$CLAUDE_DIR/settings.json" 2>/dev/null; then
        success ".claude/settings.json is valid JSON"
      else
        error ".claude/settings.json contains invalid JSON"
      fi
    else
      info ".claude/settings.json exists (install jq or python3 to validate)"
    fi
  else
    warn ".claude/settings.json not found"
  fi

  # List rules
  RULES_DIR="$CLAUDE_DIR/rules"
  if [ -d "$RULES_DIR" ]; then
    RULE_COUNT=$(find "$RULES_DIR" -name "*.md" -type f | wc -l)
    success "Found $RULE_COUNT Claude rule file(s):"
    find "$RULES_DIR" -name "*.md" -type f | sort | while read -r rule; do
      rel_path="\${rule#$PROJECT_ROOT/}"
      info "  ✓ $rel_path"
    done
  fi
else
  warn ".claude/ directory not found. Creating skeleton..."
  mkdir -p "$CLAUDE_DIR/rules/common" "$CLAUDE_DIR/rules/go"
  success "Created .claude/ directory structure"
fi

# Validate .mcp.json
if [ -f "$PROJECT_ROOT/.mcp.json" ]; then
  if command -v python3 &>/dev/null; then
    if python3 -c "import json; json.load(open('$PROJECT_ROOT/.mcp.json'))" 2>/dev/null; then
      success ".mcp.json is valid JSON"
    else
      error ".mcp.json contains invalid JSON — MCP servers won't load"
    fi
  else
    info ".mcp.json exists (install python3 to validate)"
  fi
else
  warn ".mcp.json not found. MCP server integration will not be available."
fi

# ─────────────────────────────────────────────────────────────
header "Step 5: Installing CodeForge Plugin"
# ─────────────────────────────────────────────────────────────

PLUGIN_DIR="$PROJECT_ROOT/plugin/codeforge-go-api-gateway"

if [ -d "$PLUGIN_DIR" ]; then
  success "Plugin directory exists: plugin/codeforge-go-api-gateway/"

  # List plugin components
  for subdir in agents commands skills; do
    dir="$PLUGIN_DIR/$subdir"
    if [ -d "$dir" ]; then
      count=$(find "$dir" -type f | wc -l)
      success "  $subdir/: $count file(s)"
    fi
  done

  # If plugin has a manifest, validate it
  if [ -f "$PLUGIN_DIR/manifest.json" ]; then
    if command -v python3 &>/dev/null; then
      if python3 -c "import json; json.load(open('$PLUGIN_DIR/manifest.json'))" 2>/dev/null; then
        success "Plugin manifest.json is valid"
      else
        error "Plugin manifest.json contains invalid JSON"
      fi
    fi
  fi
else
  warn "Plugin directory not found at plugin/codeforge-go-api-gateway/"
  warn "Plugin will be created during template generation."
fi

# ─────────────────────────────────────────────────────────────
header "Step 6: Installing Mock MCP Servers (Optional)"
# ─────────────────────────────────────────────────────────────

MCP_DIR="$PROJECT_ROOT/mock-mcp-servers"

if [ -d "$MCP_DIR" ] && [ -f "$MCP_DIR/package.json" ]; then
  if command -v node &>/dev/null && command -v npm &>/dev/null; then
    info "Installing mock MCP server dependencies..."
    (cd "$MCP_DIR" && npm install --no-audit --no-fund 2>/dev/null)
    success "Mock MCP server dependencies installed"
  else
    warn "Node.js/npm not available. Skipping mock MCP server setup."
  fi
else
  info "No mock MCP servers to install."
fi

# ─────────────────────────────────────────────────────────────
header "Step 7: Creating Local Configuration"
# ─────────────────────────────────────────────────────────────

# Create .env from example if it doesn't exist
if [ -f "$PROJECT_ROOT/.env.example" ] && [ ! -f "$PROJECT_ROOT/.env" ]; then
  cp "$PROJECT_ROOT/.env.example" "$PROJECT_ROOT/.env"
  success "Created .env from .env.example — update with your local settings"
elif [ ! -f "$PROJECT_ROOT/.env" ]; then
  cat > "$PROJECT_ROOT/.env" <<'ENVFILE'
# go-api-gateway local development configuration
# DO NOT COMMIT THIS FILE

# Server
GATEWAY_PORT=8080
GATEWAY_ENV=development
GATEWAY_LOG_LEVEL=debug
GATEWAY_LOG_FORMAT=text

# PostgreSQL (config store, API key metadata)
POSTGRES_HOST=localhost
POSTGRES_PORT=5432
POSTGRES_USER=gateway
POSTGRES_PASSWORD=gateway_dev_password
POSTGRES_DB=gateway
POSTGRES_SSLMODE=disable

# Redis (rate limiting, caching, session store)
REDIS_HOST=localhost
REDIS_PORT=6379
REDIS_PASSWORD=
REDIS_DB=0

# JWT Authentication (RS256)
JWT_PUBLIC_KEY_PATH=configs/dev-keys/public.pem
JWT_ISSUER=go-api-gateway-dev
JWT_AUDIENCE=api-gateway

# Rate Limiting
RATE_LIMIT_DEFAULT_RPS=100
RATE_LIMIT_WINDOW_SECONDS=60

# Circuit Breaker
CIRCUIT_BREAKER_THRESHOLD=5
CIRCUIT_BREAKER_TIMEOUT_SECONDS=30

# OpenTelemetry
OTEL_EXPORTER_OTLP_ENDPOINT=http://localhost:4317
OTEL_SERVICE_NAME=go-api-gateway

# Prometheus
PROMETHEUS_METRICS_PATH=/metrics
PROMETHEUS_PORT=9090
ENVFILE
  success "Created .env with development defaults"
fi

# Create configs directory structure
mkdir -p "$PROJECT_ROOT/configs/development" \\
         "$PROJECT_ROOT/configs/staging" \\
         "$PROJECT_ROOT/configs/production" \\
         "$PROJECT_ROOT/configs/dev-keys"

if [ ! -f "$PROJECT_ROOT/configs/development/gateway.yaml" ]; then
  cat > "$PROJECT_ROOT/configs/development/gateway.yaml" <<'YAMLFILE'
server:
  port: 8080
  read_timeout: 10s
  write_timeout: 15s
  idle_timeout: 60s
  shutdown_timeout: 30s

logging:
  level: debug
  format: text

auth:
  jwt:
    issuer: go-api-gateway-dev
    audience: api-gateway
    public_key_path: configs/dev-keys/public.pem

rate_limit:
  enabled: true
  default_rps: 100
  window: 60s
  redis:
    addr: localhost:6379

circuit_breaker:
  enabled: true
  threshold: 5
  timeout: 30s

observability:
  tracing:
    enabled: true
    exporter: otlp
    endpoint: localhost:4317
  metrics:
    enabled: true
    path: /metrics
YAMLFILE
  success "Created configs/development/gateway.yaml"
fi

# Generate dev RSA keys for JWT if they don't exist
if [ ! -f "$PROJECT_ROOT/configs/dev-keys/private.pem" ]; then
  if command -v openssl &>/dev/null; then
    info "Generating development RSA key pair for JWT (RS256)..."
    openssl genrsa -out "$PROJECT_ROOT/configs/dev-keys/private.pem" 2048 2>/dev/null
    openssl rsa -in "$PROJECT_ROOT/configs/dev-keys/private.pem" \\
      -pubout -out "$PROJECT_ROOT/configs/dev-keys/public.pem" 2>/dev/null
    success "Generated dev JWT keys in configs/dev-keys/"
    warn "These keys are for LOCAL DEVELOPMENT ONLY. Never use in production."
  else
    warn "openssl not found. Generate JWT dev keys manually."
  fi
fi

# ─────────────────────────────────────────────────────────────
header "Step 8: Creating Project Directories"
# ─────────────────────────────────────────────────────────────

DIRS=(
  "cmd/gateway"
  "internal/handler"
  "internal/middleware"
  "internal/service"
  "internal/repository"
  "internal/model"
  "internal/config"
  "internal/auth"
  "internal/ratelimit"
  "internal/circuit"
  "internal/observability"
  "pkg/httputil"
  "pkg/errors"
  "deployments/docker"
  "deployments/kubernetes"
  "deployments/helm"
  "deployments/terraform"
  "scripts"
  "tests/integration"
  "tests/e2e"
  "tests/loadtest"
  "docs"
)

CREATED=0
for dir in "\${DIRS[@]}"; do
  if [ ! -d "$PROJECT_ROOT/$dir" ]; then
    mkdir -p "$PROJECT_ROOT/$dir"
    CREATED=$((CREATED + 1))
  fi
done

if [ "$CREATED" -gt 0 ]; then
  success "Created $CREATED project directories"
else
  success "All project directories already exist"
fi

# Add .gitkeep to empty directories so they're tracked
for dir in "\${DIRS[@]}"; do
  target="$PROJECT_ROOT/$dir"
  if [ -d "$target" ] && [ -z "$(ls -A "$target" 2>/dev/null)" ]; then
    touch "$target/.gitkeep"
  fi
done

# ─────────────────────────────────────────────────────────────
header "Step 9: Verifying Build"
# ─────────────────────────────────────────────────────────────

if [ -f "$PROJECT_ROOT/cmd/gateway/main.go" ]; then
  info "Running go vet..."
  if go vet ./... 2>/dev/null; then
    success "go vet passed"
  else
    warn "go vet reported issues — review before committing"
  fi

  info "Attempting build..."
  if go build -o /dev/null ./cmd/gateway/ 2>/dev/null; then
    success "Build successful"
  else
    warn "Build failed — this is expected if source files are not yet written"
  fi
else
  info "cmd/gateway/main.go not found yet. Skipping build verification."
fi

# ─────────────────────────────────────────────────────────────
header "Setup Complete"
# ─────────────────────────────────────────────────────────────

echo ""
success "go-api-gateway development environment is ready!"
echo ""
info "Quick start commands:"
echo ""
echo "  # Start local dependencies (PostgreSQL, Redis, Jaeger)"
echo "  docker-compose up -d"
echo ""
echo "  # Run the gateway"
echo "  go run cmd/gateway/main.go"
echo ""
echo "  # Run with hot reload (requires air)"
echo "  air"
echo ""
echo "  # Run tests"
echo "  go test ./..."
echo ""
echo "  # Run tests with race detection"
echo "  go test -race ./..."
echo ""
echo "  # Run linter"
echo "  golangci-lint run"
echo ""
echo "  # Run integration tests (requires Docker)"
echo "  go test -tags=integration ./tests/integration/..."
echo ""
echo "  # Build binary"
echo "  go build -o bin/gateway cmd/gateway/main.go"
echo ""
info "Documentation:"
echo "  • Architecture:   docs/ARCHITECTURE.md"
echo "  • Contributing:   docs/CONTRIBUTING.md"
echo "  • Onboarding:     docs/ONBOARDING.md"
echo "  • AI Usage Policy: docs/AI-USAGE-POLICY.md"
echo ""
info "Claude Code:"
echo "  • Rules loaded from .claude/rules/"
echo "  • MCP servers configured in .mcp.json"
echo "  • Plugin at plugin/codeforge-go-api-gateway/"
echo ""`,

  'mock-mcp-servers/README.md': `# Mock MCP Servers for go-api-gateway

Local mock MCP servers that simulate external tool integrations for Claude Code. These servers implement the [Model Context Protocol](https://modelcontextprotocol.io/) and provide offline-capable replacements for GitHub Issues, Slack, and other integrations used during development.

## Why Mock Servers?

- **Offline development**: Work without network access to GitHub, Slack, or AWS APIs
- **Deterministic responses**: Consistent tool outputs for testing Claude Code workflows
- **Safe experimentation**: No risk of modifying real issues, sending real messages, or touching production
- **Fast iteration**: No API rate limits or latency from external services

## Available Servers

### github-server.mjs

Simulates GitHub Issues and Pull Request operations relevant to the gateway project.

**Tools provided:**

| Tool | Description |
|------|-------------|
| \`get_issue\` | Fetch a GitHub issue by number (returns mock gateway-related issues) |
| \`list_issues\` | List issues with optional label/state filters |
| \`create_issue\` | Create a new issue (stored in memory for the session) |
| \`add_issue_comment\` | Add a comment to an existing issue |
| \`list_pull_requests\` | List open PRs with review status |
| \`get_pull_request\` | Get PR details including diff stats and checks |

**Mock data includes:**
- \`GW-42\`: Add circuit breaker for upstream services
- \`GW-58\`: Implement sliding window rate limiter with Redis
- \`GW-71\`: JWT RS256 validation returning 401 on expired tokens
- \`GW-85\`: OpenTelemetry trace propagation across middleware chain
- \`GW-93\`: Graceful shutdown not draining in-flight requests

### jira-server.mjs

Simulates a Jira-like ticket system (mapped to GitHub Issues workflow for this project).

**Tools provided:**

| Tool | Description |
|------|-------------|
| \`get_ticket\` | Fetch a ticket by key (e.g., GW-42) |
| \`list_tickets\` | List tickets with sprint/status/assignee filters |
| \`update_ticket_status\` | Transition a ticket (To Do → In Progress → In Review → Done) |
| \`add_ticket_comment\` | Add a comment to a ticket |
| \`get_sprint\` | Get current sprint details and velocity |

**Mock data mirrors the GitHub server with additional fields:**
- Story points, sprint assignments, acceptance criteria
- Linked PRs and blocking relationships
- SOC 2 compliance labels on security-related tickets

## Setup

### Prerequisites

- Node.js 18+ (for running MCP server processes)
- npm (for installing dependencies, if any)

### Installation

The mock servers are zero-dependency — they use only Node.js built-in modules and the MCP SDK:

\`\`\`bash
cd mock-mcp-servers
npm install  # installs @modelcontextprotocol/sdk if not already present
\`\`\`

### Configuration

Mock servers are already configured in the project root \`.mcp.json\`:

\`\`\`json
{
  "mcpServers": {
    "github": {
      "command": "node",
      "args": ["mock-mcp-servers/github-server.mjs"]
    },
    "jira": {
      "command": "node",
      "args": ["mock-mcp-servers/jira-server.mjs"]
    }
  }
}
\`\`\`

Claude Code automatically discovers and starts these servers when you open the project.

### Verify Servers Are Running

In a Claude Code session, try:

\`\`\`
Use the get_issue tool to fetch issue 42
\`\`\`

You should see a response about the circuit breaker feature (GW-42).

## Adding a New Mock Server

1. Create a new \`.mjs\` file in \`mock-mcp-servers/\`:

\`\`\`javascript
import { McpServer } from "@modelcontextprotocol/sdk/server/mcp.js";
import { StdioServerTransport } from "@modelcontextprotocol/sdk/server/stdio.js";
import { z } from "zod";

const server = new McpServer({
  name: "your-server-name",
  version: "1.0.0",
});

server.tool("your_tool", { param: z.string() }, async ({ param }) => {
  return { content: [{ type: "text", text: JSON.stringify({ result: param }) }] };
});

const transport = new StdioServerTransport();
await server.connect(transport);
\`\`\`

2. Register it in \`.mcp.json\`:

\`\`\`json
{
  "mcpServers": {
    "your-server": {
      "command": "node",
      "args": ["mock-mcp-servers/your-server.mjs"]
    }
  }
}
\`\`\`

3. Restart Claude Code to pick up the new server.

## Mock Data Conventions

- All ticket/issue numbers use the \`GW-\` prefix to match the project's branch naming convention (\`feat/GW-42-add-circuit-breaker\`)
- Mock responses include realistic fields for the go-api-gateway domain: middleware references, Chi router details, Redis/PostgreSQL mentions
- Security-related tickets are tagged with \`soc2\` and \`security\` labels
- Performance tickets reference benchmark results and pprof profiles

## Switching to Real Servers

When ready to connect to real GitHub or Jira APIs, update \`.mcp.json\` to point to the official MCP server implementations and provide appropriate credentials via environment variables. The tool names and schemas are designed to be compatible with the official GitHub MCP server.

## Troubleshooting

| Problem | Solution |
|---------|----------|
| Server not starting | Check \`node --version\` is 18+. Run the server directly: \`node mock-mcp-servers/github-server.mjs\` |
| Tool not found | Restart Claude Code after modifying \`.mcp.json\` |
| Stale data | Mock data resets on server restart (in-memory only) |
| Port conflicts | MCP servers use stdio transport, not TCP — no port conflicts possible |`,

  'mock-mcp-servers/github-server.mjs': `#!/usr/bin/env node

/**
 * Mock GitHub MCP Server for go-api-gateway
 *
 * Simulates GitHub PR, issue, repo, and CODEOWNERS operations
 * for local development and testing of Claude Code integrations.
 *
 * Usage: node mock-mcp-servers/github-server.mjs
 */

import { createServer } from "http";

const PORT = process.env.MOCK_GITHUB_PORT || 3401;
const PROJECT = "go-api-gateway";
const OWNER = "myorg";
const REPO = \`\${OWNER}/\${PROJECT}\`;

// --- In-memory state ---

let issueCounter = 100;
let prCounter = 200;

const issues = new Map([
  [
    42,
    {
      number: 42,
      title: "Add circuit breaker to upstream proxy",
      body: "Implement circuit breaker pattern for upstream service calls using a sliding window. Should integrate with existing Chi middleware chain.\\n\\n## Acceptance Criteria\\n- Configurable failure threshold and recovery timeout\\n- Per-upstream circuit state (closed, open, half-open)\\n- Prometheus metrics for circuit state transitions\\n- slog structured logging on state changes",
      state: "open",
      labels: ["enhancement", "priority:high", "component:circuit"],
      assignees: ["dev-lead"],
      milestone: "v1.0.0",
      created_at: "2024-11-01T10:00:00Z",
      updated_at: "2024-11-15T14:30:00Z",
    },
  ],
  [
    43,
    {
      number: 43,
      title: "Rate limiter returns 500 when Redis is unavailable",
      body: "When Redis connection drops, the rate limiter middleware panics instead of falling back to allow-all or returning 503.\\n\\n## Steps to Reproduce\\n1. Start gateway with Redis\\n2. Kill Redis\\n3. Send request through rate-limited route\\n4. Observe 500 instead of graceful degradation\\n\\n## Expected Behavior\\nFall back to in-memory rate limiting or allow requests with a warning log.",
      state: "open",
      labels: ["bug", "priority:critical", "component:ratelimit"],
      assignees: ["senior-dev-1"],
      milestone: "v1.0.0",
      created_at: "2024-11-10T08:00:00Z",
      updated_at: "2024-11-12T09:15:00Z",
    },
  ],
  [
    44,
    {
      number: 44,
      title: "Add OpenTelemetry trace context propagation to all handlers",
      body: "Ensure all Chi handlers propagate trace context via context.Context. Required for distributed tracing across upstream services.",
      state: "open",
      labels: ["enhancement", "component:observability"],
      assignees: [],
      milestone: "v1.0.0",
      created_at: "2024-11-12T11:00:00Z",
      updated_at: "2024-11-12T11:00:00Z",
    },
  ],
  [
    45,
    {
      number: 45,
      title: "JWT RS256 validation does not check token expiry",
      body: "Security issue: JWT middleware validates signature but does not enforce \`exp\` claim. SOC 2 compliance requires token expiry enforcement.\\n\\n## Impact\\nExpired tokens are accepted, violating session management controls.",
      state: "open",
      labels: ["bug", "security", "priority:critical", "component:auth"],
      assignees: ["dev-lead", "senior-dev-2"],
      milestone: "v0.9.1",
      created_at: "2024-11-14T16:00:00Z",
      updated_at: "2024-11-15T10:00:00Z",
    },
  ],
]);

const pullRequests = new Map([
  [
    101,
    {
      number: 101,
      title: "feat(middleware): add request ID middleware",
      body: "Adds X-Request-ID header injection middleware for Chi router.\\n\\nCloses #40\\n\\n## Changes\\n- \`internal/middleware/request_id.go\` — generates UUIDv4 request IDs\\n- \`internal/middleware/request_id_test.go\` — table-driven tests\\n- Integrated into default middleware chain",
      state: "closed",
      merged: true,
      head: { ref: "feat/GW-40-request-id-middleware" },
      base: { ref: "main" },
      labels: ["enhancement"],
      requested_reviewers: ["dev-lead"],
      created_at: "2024-11-08T09:00:00Z",
      merged_at: "2024-11-09T14:00:00Z",
      checks: { lint: "pass", vet: "pass", test: "pass", coverage: "83%" },
    },
  ],
  [
    102,
    {
      number: 102,
      title: "fix(ratelimit): handle Redis connection failures gracefully",
      body: "Fixes #43\\n\\nWhen Redis is unavailable, rate limiter now falls back to in-memory sliding window with degraded accuracy. Logs warning via slog.\\n\\n## Changes\\n- \`internal/ratelimit/redis_limiter.go\` — added fallback logic\\n- \`internal/ratelimit/memory_limiter.go\` — new in-memory fallback\\n- \`internal/ratelimit/limiter_test.go\` — tests for both paths\\n\\n## SOC 2 Note\\nFallback logs include client IP and rate limit key for audit trail.",
      state: "open",
      merged: false,
      head: { ref: "fix/GW-43-ratelimit-redis-fallback" },
      base: { ref: "main" },
      labels: ["bug", "priority:critical"],
      requested_reviewers: ["dev-lead", "senior-dev-2"],
      created_at: "2024-11-14T10:00:00Z",
      merged_at: null,
      checks: { lint: "pass", vet: "pass", test: "pass", coverage: "81%" },
      review_comments: [
        {
          path: "internal/ratelimit/redis_limiter.go",
          line: 47,
          body: "Should we add a Prometheus counter for fallback activations?",
          author: "dev-lead",
        },
      ],
    },
  ],
]);

const codeowners = \`# CODEOWNERS for go-api-gateway
* @myorg/gateway-team
internal/auth/** @myorg/security-team @dev-lead
internal/ratelimit/** @senior-dev-1 @dev-lead
internal/middleware/** @myorg/gateway-team
internal/circuit/** @dev-lead
internal/observability/** @senior-dev-2
configs/production/** @dev-lead @myorg/security-team
deployments/** @dev-lead @myorg/platform-team
*.pem @myorg/security-team
.env* @myorg/security-team
\`;

const repoFiles = new Map([
  ["CODEOWNERS", codeowners],
  [
    "go.mod",
    \`module github.com/\${REPO}

go 1.22

require (
\\tgithub.com/go-chi/chi/v5 v5.1.0
\\tgithub.com/redis/go-redis/v9 v9.5.0
\\tgithub.com/jackc/pgx/v5 v5.6.0
\\tgithub.com/golang-jwt/jwt/v5 v5.2.0
\\tgithub.com/spf13/viper v1.19.0
\\tgithub.com/stretchr/testify v1.9.0
\\tgo.opentelemetry.io/otel v1.28.0
\\tgo.opentelemetry.io/otel/exporters/prometheus v0.50.0
)\`,
  ],
]);

const branches = [
  { name: "main", protected: true },
  { name: "feat/GW-42-add-circuit-breaker", protected: false },
  { name: "fix/GW-43-ratelimit-redis-fallback", protected: false },
  { name: "feat/GW-44-otel-propagation", protected: false },
  { name: "fix/GW-45-jwt-expiry-check", protected: false },
];

const workflows = [
  {
    id: 1,
    name: "CI Pipeline",
    path: ".github/workflows/ci.yml",
    state: "active",
    jobs: [
      "lint",
      "vet",
      "unit-tests",
      "integration-tests",
      "race-detection",
      "build-binary",
      "build-docker",
    ],
  },
  {
    id: 2,
    name: "Deploy Staging",
    path: ".github/workflows/deploy-staging.yml",
    state: "active",
    jobs: ["deploy-ecs-staging"],
  },
  {
    id: 3,
    name: "Deploy Production",
    path: ".github/workflows/deploy-production.yml",
    state: "active",
    jobs: ["approval-gate", "deploy-ecs-production"],
  },
];

// --- Tool definitions ---

const tools = {
  get_issue: {
    description:
      "Get a GitHub issue by number from the go-api-gateway repository",
    inputSchema: {
      type: "object",
      properties: {
        issue_number: { type: "integer", description: "Issue number" },
      },
      required: ["issue_number"],
    },
    handler({ issue_number }) {
      const issue = issues.get(issue_number);
      if (!issue) {
        return { error: \`Issue #\${issue_number} not found in \${REPO}\` };
      }
      return { repository: REPO, ...issue };
    },
  },

  list_issues: {
    description:
      "List issues in the go-api-gateway repository with optional filters",
    inputSchema: {
      type: "object",
      properties: {
        state: {
          type: "string",
          enum: ["open", "closed", "all"],
          default: "open",
        },
        labels: {
          type: "array",
          items: { type: "string" },
          description: "Filter by labels",
        },
        milestone: { type: "string", description: "Filter by milestone" },
        assignee: { type: "string", description: "Filter by assignee" },
      },
    },
    handler({ state = "open", labels, milestone, assignee }) {
      let results = Array.from(issues.values());
      if (state !== "all") {
        results = results.filter((i) => i.state === state);
      }
      if (labels && labels.length > 0) {
        results = results.filter((i) =>
          labels.some((l) => i.labels.includes(l))
        );
      }
      if (milestone) {
        results = results.filter((i) => i.milestone === milestone);
      }
      if (assignee) {
        results = results.filter((i) => i.assignees.includes(assignee));
      }
      return { repository: REPO, total_count: results.length, issues: results };
    },
  },

  create_issue: {
    description: "Create a new issue in the go-api-gateway repository",
    inputSchema: {
      type: "object",
      properties: {
        title: { type: "string" },
        body: { type: "string" },
        labels: { type: "array", items: { type: "string" } },
        assignees: { type: "array", items: { type: "string" } },
        milestone: { type: "string" },
      },
      required: ["title"],
    },
    handler({ title, body = "", labels = [], assignees = [], milestone }) {
      const number = ++issueCounter;
      const now = new Date().toISOString();
      const issue = {
        number,
        title,
        body,
        state: "open",
        labels,
        assignees,
        milestone: milestone || null,
        created_at: now,
        updated_at: now,
      };
      issues.set(number, issue);
      return { repository: REPO, action: "created", ...issue };
    },
  },

  update_issue: {
    description: "Update an existing issue",
    inputSchema: {
      type: "object",
      properties: {
        issue_number: { type: "integer" },
        state: { type: "string", enum: ["open", "closed"] },
        title: { type: "string" },
        body: { type: "string" },
        labels: { type: "array", items: { type: "string" } },
        assignees: { type: "array", items: { type: "string" } },
      },
      required: ["issue_number"],
    },
    handler({ issue_number, ...updates }) {
      const issue = issues.get(issue_number);
      if (!issue) {
        return { error: \`Issue #\${issue_number} not found\` };
      }
      Object.entries(updates).forEach(([k, v]) => {
        if (v !== undefined) issue[k] = v;
      });
      issue.updated_at = new Date().toISOString();
      return { repository: REPO, action: "updated", ...issue };
    },
  },

  get_pull_request: {
    description: "Get a pull request by number",
    inputSchema: {
      type: "object",
      properties: {
        pr_number: { type: "integer" },
      },
      required: ["pr_number"],
    },
    handler({ pr_number }) {
      const pr = pullRequests.get(pr_number);
      if (!pr) {
        return { error: \`PR #\${pr_number} not found in \${REPO}\` };
      }
      return { repository: REPO, ...pr };
    },
  },

  list_pull_requests: {
    description: "List pull requests with optional filters",
    inputSchema: {
      type: "object",
      properties: {
        state: {
          type: "string",
          enum: ["open", "closed", "all"],
          default: "open",
        },
        base: { type: "string", description: "Filter by base branch" },
      },
    },
    handler({ state = "open", base }) {
      let results = Array.from(pullRequests.values());
      if (state !== "all") {
        results = results.filter((pr) => pr.state === state);
      }
      if (base) {
        results = results.filter((pr) => pr.base.ref === base);
      }
      return {
        repository: REPO,
        total_count: results.length,
        pull_requests: results,
      };
    },
  },

  create_pull_request: {
    description: "Create a new pull request",
    inputSchema: {
      type: "object",
      properties: {
        title: { type: "string" },
        body: { type: "string" },
        head: { type: "string", description: "Source branch" },
        base: {
          type: "string",
          description: "Target branch",
          default: "main",
        },
        labels: { type: "array", items: { type: "string" } },
        requested_reviewers: { type: "array", items: { type: "string" } },
      },
      required: ["title", "head"],
    },
    handler({
      title,
      body = "",
      head,
      base = "main",
      labels = [],
      requested_reviewers = [],
    }) {
      const number = ++prCounter;
      const now = new Date().toISOString();
      const pr = {
        number,
        title,
        body,
        state: "open",
        merged: false,
        head: { ref: head },
        base: { ref: base },
        labels,
        requested_reviewers,
        created_at: now,
        merged_at: null,
        checks: {
          lint: "pending",
          vet: "pending",
          test: "pending",
          coverage: "pending",
        },
      };
      pullRequests.set(number, pr);

      // Auto-assign reviewers from CODEOWNERS if none specified
      if (requested_reviewers.length === 0) {
        pr.requested_reviewers = ["dev-lead"];
        pr._note =
          "Auto-assigned reviewer from CODEOWNERS. CODEOWNERS enforced on main.";
      }

      return { repository: REPO, action: "created", ...pr };
    },
  },

  get_pr_checks: {
    description: "Get CI check status for a pull request",
    inputSchema: {
      type: "object",
      properties: {
        pr_number: { type: "integer" },
      },
      required: ["pr_number"],
    },
    handler({ pr_number }) {
      const pr = pullRequests.get(pr_number);
      if (!pr) {
        return { error: \`PR #\${pr_number} not found\` };
      }
      return {
        repository: REPO,
        pr_number,
        branch: pr.head.ref,
        checks: pr.checks,
        ci_pipeline: "GitHub Actions",
        stages: [
          "lint (golangci-lint run)",
          "vet (go vet ./...)",
          "unit-tests (go test -race -coverprofile=coverage.out ./...)",
          "integration-tests (go test -tags=integration ./tests/...)",
          "race-detection",
          "build-binary (go build -o bin/gateway cmd/gateway/main.go)",
          "build-docker",
        ],
        required_for_merge: ["lint", "vet", "test"],
        coverage_threshold: "80%",
      };
    },
  },

  add_pr_review_comment: {
    description: "Add a review comment to a pull request",
    inputSchema: {
      type: "object",
      properties: {
        pr_number: { type: "integer" },
        path: { type: "string", description: "File path" },
        line: { type: "integer" },
        body: { type: "string" },
      },
      required: ["pr_number", "path", "body"],
    },
    handler({ pr_number, path, line, body }) {
      const pr = pullRequests.get(pr_number);
      if (!pr) {
        return { error: \`PR #\${pr_number} not found\` };
      }
      if (!pr.review_comments) pr.review_comments = [];
      const comment = {
        path,
        line: line || null,
        body,
        author: "claude-code",
        created_at: new Date().toISOString(),
      };
      pr.review_comments.push(comment);
      return { repository: REPO, pr_number, action: "comment_added", comment };
    },
  },

  list_branches: {
    description: "List branches in the repository",
    inputSchema: {
      type: "object",
      properties: {
        protected_only: { type: "boolean", default: false },
      },
    },
    handler({ protected_only = false }) {
      let results = branches;
      if (protected_only) {
        results = results.filter((b) => b.protected);
      }
      return { repository: REPO, branches: results };
    },
  },

  get_file_contents: {
    description: "Get file contents from the repository",
    inputSchema: {
      type: "object",
      properties: {
        path: { type: "string" },
        ref: { type: "string", default: "main" },
      },
      required: ["path"],
    },
    handler({ path, ref = "main" }) {
      const content = repoFiles.get(path);
      if (!content) {
        return {
          error: \`File '\${path}' not found at ref '\${ref}' in \${REPO}\`,
        };
      }
      return {
        repository: REPO,
        path,
        ref,
        content,
        encoding: "utf-8",
      };
    },
  },

  list_workflows: {
    description: "List GitHub Actions workflows",
    inputSchema: {
      type: "object",
      properties: {},
    },
    handler() {
      return { repository: REPO, workflows };
    },
  },

  get_workflow_runs: {
    description: "Get recent workflow runs",
    inputSchema: {
      type: "object",
      properties: {
        workflow_id: { type: "integer" },
        branch: { type: "string" },
        status: {
          type: "string",
          enum: ["completed", "in_progress", "queued"],
        },
      },
    },
    handler({ workflow_id, branch, status }) {
      const wf = workflows.find((w) => w.id === (workflow_id || 1));
      const runs = [
        {
          id: 5001,
          workflow: wf ? wf.name : "CI Pipeline",
          branch: branch || "fix/GW-43-ratelimit-redis-fallback",
          status: status || "completed",
          conclusion: "success",
          duration_seconds: 187,
          jobs: {
            lint: { status: "completed", conclusion: "success", duration: 12 },
            vet: { status: "completed", conclusion: "success", duration: 8 },
            "unit-tests": {
              status: "completed",
              conclusion: "success",
              duration: 45,
              coverage: "81.3%",
            },
            "integration-tests": {
              status: "completed",
              conclusion: "success",
              duration: 62,
            },
            "race-detection": {
              status: "completed",
              conclusion: "success",
              duration: 38,
            },
            "build-binary": {
              status: "completed",
              conclusion: "success",
              duration: 15,
            },
            "build-docker": {
              status: "completed",
              conclusion: "success",
              duration: 42,
            },
          },
          created_at: "2024-11-15T10:30:00Z",
        },
      ];
      return { repository: REPO, total_count: runs.length, workflow_runs: runs };
    },
  },

  search_code: {
    description: "Search for code patterns in the repository",
    inputSchema: {
      type: "object",
      properties: {
        query: { type: "string" },
        path_filter: {
          type: "string",
          description: "Filter by path prefix (e.g., internal/middleware/)",
        },
      },
      required: ["query"],
    },
    handler({ query, path_filter }) {
      // Simulated search results for common gateway patterns
      const searchIndex = {
        "circuit breaker": [
          {
            path: "internal/circuit/breaker.go",
            matches: [
              'type CircuitBreaker struct {',
              'func NewCircuitBreaker(opts ...Option) *CircuitBreaker {',
            ],
          },
        ],
        "rate limit": [
          {
            path: "internal/ratelimit/redis_limiter.go",
            matches: [
              'func (rl *RedisLimiter) Allow(ctx context.Context, key string) (bool, error) {',
            ],
          },
          {
            path: "internal/middleware/rate_limit.go",
            matches: [
              'func RateLimit(limiter ratelimit.Limiter) func(http.Handler) http.Handler {',
            ],
          },
        ],
        jwt: [
          {
            path: "internal/auth/jwt.go",
            matches: [
              'func ValidateToken(tokenString string, keyFunc jwt.Keyfunc) (*Claims, error) {',
            ],
          },
          {
            path: "internal/middleware/auth.go",
            matches: [
              'func JWTAuth(validator auth.TokenValidator) func(http.Handler) http.Handler {',
            ],
          },
        ],
        middleware: [
          {
            path: "internal/middleware/logging.go",
            matches: [
              'func StructuredLogger(logger *slog.Logger) func(http.Handler) http.Handler {',
            ],
          },
          {
            path: "internal/middleware/recovery.go",
            matches: [
              'func Recoverer(logger *slog.Logger) func(http.Handler) http.Handler {',
            ],
          },
        ],
        "chi.Router": [
          {
            path: "cmd/gateway/main.go",
            matches: [
              'r := chi.NewRouter()',
              'r.Use(middleware.StructuredLogger(logger))',
            ],
          },
        ],
        slog: [
          {
            path: "internal/observability/logger.go",
            matches: [
              'func NewLogger(cfg config.LogConfig) *slog.Logger {',
            ],
          },
        ],
      };

      const lowerQuery = query.toLowerCase();
      let results = [];
      for (const [key, matches] of Object.entries(searchIndex)) {
        if (lowerQuery.includes(key)) {
          results.push(...matches);
        }
      }

      if (path_filter) {
        results = results.filter((r) => r.path.startsWith(path_filter));
      }

      if (results.length === 0) {
        results = [
          {
            path: "internal/",
            matches: [\`No exact matches for "\${query}" in mock index\`],
          },
        ];
      }

      return {
        repository: REPO,
        query,
        total_count: results.length,
        items: results,
      };
    },
  },

  get_codeowners: {
    description: "Get CODEOWNERS file and ownership for a given path",
    inputSchema: {
      type: "object",
      properties: {
        path: {
          type: "string",
          description: "File path to check ownership for",
        },
      },
    },
    handler({ path }) {
      const ownershipRules = [
        { pattern: "internal/auth/**", owners: ["@myorg/security-team", "@dev-lead"] },
        { pattern: "internal/ratelimit/**", owners: ["@senior-dev-1", "@dev-lead"] },
        { pattern: "internal/middleware/**", owners: ["@myorg/gateway-team"] },
        { pattern: "internal/circuit/**", owners: ["@dev-lead"] },
        { pattern: "internal/observability/**", owners: ["@senior-dev-2"] },
        { pattern: "configs/production/**", owners: ["@dev-lead", "@myorg/security-team"] },
        { pattern: "deployments/**", owners: ["@dev-lead", "@myorg/platform-team"] },
        { pattern: "*.pem", owners: ["@myorg/security-team"] },
        { pattern: ".env*", owners: ["@myorg/security-team"] },
        { pattern: "*", owners: ["@myorg/gateway-team"] },
      ];

      let matchedOwners = ["@myorg/gateway-team"];
      if (path) {
        for (const rule of ownershipRules) {
          const rulePrefix = rule.pattern
            .replace("/**", "")
            .replace("*.", ".");
          if (path.startsWith(rulePrefix) || path.endsWith(rulePrefix)) {
            matchedOwners = rule.owners;
            break;
          }
        }
      }

      return {
        repository: REPO,
        path: path || null,
        owners: matchedOwners,
        codeowners_content: codeowners,
      };
    },
  },

  create_branch: {
    description: "Create a new branch following naming convention",
    inputSchema: {
      type: "object",
      properties: {
        name: {
          type: "string",
          description: "Branch name (e.g., feat/GW-42-add-circuit-breaker)",
        },
        from: { type: "string", default: "main" },
      },
      required: ["name"],
    },
    handler({ name, from = "main" }) {
      // Validate branch naming convention: type/ticket-desc
      const validPattern = /^(feat|fix|chore|docs|perf|refactor|test)\\/GW-\\d+-.+$/;
      if (!validPattern.test(name)) {
        return {
          error: \`Branch name '\${name}' does not match required pattern: type/GW-<number>-<description>. Examples: feat/GW-42-add-circuit-breaker, fix/GW-43-redis-fallback\`,
        };
      }
      const branch = { name, protected: false, created_from: from };
      branches.push(branch);
      return { repository: REPO, action: "created", branch };
    },
  },
};

// --- MCP Protocol Handler ---

function handleRequest(method, params) {
  switch (method) {
    case "initialize":
      return {
        protocolVersion: "2024-11-05",
        capabilities: { tools: {} },
        serverInfo: {
          name: "mock-github-server",
          version: "1.0.0",
          description: \`Mock GitHub MCP server for \${REPO}\`,
        },
      };

    case "tools/list":
      return {
        tools: Object.entries(tools).map(([name, def]) => ({
          name,
          description: def.description,
          inputSchema: def.inputSchema,
        })),
      };

    case "tools/call": {
      const { name, arguments: args } = params;
      const tool = tools[name];
      if (!tool) {
        return {
          content: [
            {
              type: "text",
              text: JSON.stringify({ error: \`Unknown tool: \${name}\` }),
            },
          ],
          isError: true,
        };
      }
      try {
        const result = tool.handler(args || {});
        return {
          content: [{ type: "text", text: JSON.stringify(result, null, 2) }],
        };
      } catch (err) {
        return {
          content: [
            {
              type: "text",
              text: JSON.stringify({ error: err.message }),
            },
          ],
          isError: true,
        };
      }
    }

    default:
      return { error: { code: -32601, message: \`Method not found: \${method}\` } };
  }
}

// --- HTTP Transport (JSON-RPC over HTTP for easy testing) ---

const server = createServer((req, res) => {
  if (req.method === "GET" && req.url === "/health") {
    res.writeHead(200, { "Content-Type": "application/json" });
    res.end(
      JSON.stringify({
        status: "ok",
        server: "mock-github-mcp",
        repository: REPO,
        tools: Object.keys(tools).length,
      })
    );
    return;
  }

  if (req.method !== "POST") {
    res.writeHead(405);
    res.end("Method Not Allowed");
    return;
  }

  let body = "";
  req.on("data", (chunk) => (body += chunk));
  req.on("end", () => {
    try {
      const request = JSON.parse(body);
      const result = handleRequest(request.method, request.params || {});
      const response = {
        jsonrpc: "2.0",
        id: request.id,
        result,
      };
      res.writeHead(200, { "Content-Type": "application/json" });
      res.end(JSON.stringify(response, null, 2));
    } catch (err) {
      res.writeHead(400, { "Content-Type": "application/json" });
      res.end(
        JSON.stringify({
          jsonrpc: "2.0",
          id: null,
          error: { code: -32700, message: "Parse error", data: err.message },
        })
      );
    }
  });
});

// --- Stdio`,

  'mock-mcp-servers/jira-server.mjs': `#!/usr/bin/env node

/**
 * Mock Jira MCP Server for go-api-gateway project
 * Simulates ticket lookup, status updates, and sprint queries
 * for API gateway development tasks.
 *
 * Usage: node mock-mcp-servers/jira-server.mjs
 * Protocol: MCP (Model Context Protocol) over stdio
 */

import { createInterface } from "readline";

const PROJECT_KEY = "GW";

const MOCK_TICKETS = {
  "GW-1": {
    key: "GW-1",
    summary: "Set up Chi router with base middleware chain",
    description: "Initialize the Chi v5 router in cmd/gateway/main.go with composable middleware: logging, recovery, request ID, CORS, and real IP. Follow Clean Architecture pattern with handler → service → repository layers.",
    status: "Done",
    type: "Story",
    priority: "High",
    assignee: "alex.chen",
    labels: ["infrastructure", "router"],
    sprint: "Sprint 1",
    story_points: 5,
    acceptance_criteria: [
      "Chi v5 router initialized with middleware chain",
      "Graceful shutdown with context cancellation",
      "Health check endpoint at /healthz returns 200",
      "Readiness endpoint at /readyz checks DB and Redis",
      "Structured logging with slog configured"
    ]
  },
  "GW-2": {
    key: "GW-2",
    summary: "Implement JWT RS256 authentication middleware",
    description: "Create Chi middleware in internal/middleware/auth.go that validates JWT tokens signed with RS256. Extract claims and populate request context. Support JWKS endpoint for key rotation. Must comply with SOC 2 access control requirements.",
    status: "In Progress",
    type: "Story",
    priority: "Critical",
    assignee: "jordan.lee",
    labels: ["security", "auth", "soc2"],
    sprint: "Sprint 2",
    story_points: 8,
    acceptance_criteria: [
      "JWT RS256 validation with JWKS support",
      "Claims extracted and set in request context",
      "401 returned for missing/invalid/expired tokens",
      "RBAC role extraction from JWT claims",
      "Table-driven tests with >90% coverage",
      "Audit logging for auth failures (SOC 2)"
    ]
  },
  "GW-3": {
    key: "GW-3",
    summary: "Implement Redis-backed sliding window rate limiter",
    description: "Build per-client rate limiting in internal/ratelimit/ using Redis sorted sets for sliding window algorithm. Rate limits configurable per API key tier. Return standard rate limit headers (X-RateLimit-Limit, X-RateLimit-Remaining, X-RateLimit-Reset).",
    status: "In Progress",
    type: "Story",
    priority: "High",
    assignee: "alex.chen",
    labels: ["rate-limiting", "redis", "middleware"],
    sprint: "Sprint 2",
    story_points: 8,
    acceptance_criteria: [
      "Sliding window rate limiting with Redis sorted sets",
      "Per-client limits based on API key tier",
      "Standard rate limit response headers",
      "429 Too Many Requests with Retry-After header",
      "Graceful degradation if Redis is unavailable",
      "Benchmark tests showing <1ms overhead at p99"
    ]
  },
  "GW-4": {
    key: "GW-4",
    summary: "Add circuit breaker for upstream service calls",
    description: "Implement circuit breaker pattern in internal/circuit/ with configurable thresholds. States: closed, open, half-open. Integrate with OpenTelemetry for state change tracing. Use for all upstream HTTP calls in the gateway.",
    status: "To Do",
    type: "Story",
    priority: "High",
    assignee: "unassigned",
    labels: ["resilience", "circuit-breaker"],
    sprint: "Sprint 3",
    story_points: 5,
    acceptance_criteria: [
      "Circuit breaker with closed/open/half-open states",
      "Configurable failure threshold and recovery timeout",
      "OpenTelemetry span events on state transitions",
      "Prometheus metrics for circuit state changes",
      "503 Service Unavailable when circuit is open",
      "Per-upstream-service circuit instances"
    ]
  },
  "GW-5": {
    key: "GW-5",
    summary: "Set up OpenTelemetry distributed tracing",
    description: "Configure OpenTelemetry SDK in internal/observability/ with OTLP exporter to Jaeger. Add trace context propagation through all middleware. Create Chi middleware that starts spans for each request with route pattern as span name.",
    status: "To Do",
    type: "Story",
    priority: "Medium",
    assignee: "sam.patel",
    labels: ["observability", "tracing"],
    sprint: "Sprint 3",
    story_points: 5,
    acceptance_criteria: [
      "OTLP exporter configured for Jaeger",
      "Chi middleware creates spans per request",
      "Trace context propagated to upstream calls",
      "Span attributes include route, method, status code",
      "Trace ID included in structured log output",
      "Graceful shutdown flushes pending spans"
    ]
  },
  "GW-6": {
    key: "GW-6",
    summary: "Implement Prometheus metrics endpoint and collectors",
    description: "Add Prometheus metrics in internal/observability/metrics.go. Expose /metrics endpoint. Collect: request duration histogram, request count by route/method/status, active connections gauge, rate limit hits counter, circuit breaker state gauge.",
    status: "To Do",
    type: "Story",
    priority: "Medium",
    assignee: "sam.patel",
    labels: ["observability", "metrics", "prometheus"],
    sprint: "Sprint 3",
    story_points: 3,
    acceptance_criteria: [
      "Prometheus /metrics endpoint exposed",
      "Request duration histogram with route labels",
      "Request counter by method, route, status code",
      "Active connections gauge",
      "Rate limit hit counter by client tier",
      "Circuit breaker state gauge per upstream"
    ]
  },
  "GW-7": {
    key: "GW-7",
    summary: "API key management with PostgreSQL storage",
    description: "Build API key CRUD in internal/repository/apikey.go with PostgreSQL. Keys stored as SHA-256 hashes. Support key rotation, expiration, and tier assignment. Integrate with rate limiter for per-key limits.",
    status: "To Do",
    type: "Story",
    priority: "High",
    assignee: "jordan.lee",
    labels: ["security", "auth", "postgresql", "soc2"],
    sprint: "Sprint 2",
    story_points: 5,
    acceptance_criteria: [
      "API keys stored as SHA-256 hashes in PostgreSQL",
      "CRUD operations with proper error wrapping",
      "Key rotation without downtime",
      "Expiration enforcement with cleanup job",
      "Tier metadata for rate limit integration",
      "Audit trail for key operations (SOC 2)"
    ]
  },
  "GW-8": {
    key: "GW-8",
    summary: "Request/response transformation middleware",
    description: "Create configurable request/response transformation in internal/middleware/transform.go. Support header injection, path rewriting, request body transformation, and response header stripping. Config-driven via YAML route definitions.",
    status: "Backlog",
    type: "Story",
    priority: "Medium",
    assignee: "unassigned",
    labels: ["middleware", "routing"],
    sprint: "Sprint 4",
    story_points: 5,
    acceptance_criteria: [
      "Header injection on proxied requests",
      "Path prefix stripping and rewriting",
      "Request body JSON transformation",
      "Response header filtering",
      "YAML-based route transformation config",
      "No transformation overhead on passthrough routes"
    ]
  },
  "GW-42": {
    key: "GW-42",
    summary: "Add circuit breaker metrics to Grafana dashboard",
    description: "Create Grafana dashboard JSON for circuit breaker monitoring. Include panels for state transitions, failure rates, recovery times, and per-upstream health. Link to Jaeger traces for failed requests.",
    status: "Backlog",
    type: "Task",
    priority: "Low",
    assignee: "unassigned",
    labels: ["observability", "grafana", "circuit-breaker"],
    sprint: "Sprint 4",
    story_points: 2,
    acceptance_criteria: [
      "Grafana dashboard with circuit breaker panels",
      "State transition timeline visualization",
      "Failure rate graphs per upstream service",
      "Deep links to Jaeger traces",
      "Dashboard exported as JSON in docs/"
    ]
  },
  "GW-100": {
    key: "GW-100",
    summary: "Load testing with k6 for rate limiter validation",
    description: "Write k6 load test scripts in scripts/loadtest/ to validate rate limiter behavior under high concurrency. Test sliding window accuracy, Redis performance under load, and proper 429 response rates.",
    status: "Backlog",
    type: "Task",
    priority: "Medium",
    assignee: "unassigned",
    labels: ["testing", "performance", "rate-limiting"],
    sprint: "Sprint 4",
    story_points: 3,
    acceptance_criteria: [
      "k6 scripts for rate limit validation",
      "Test 1000 RPS with 100 concurrent clients",
      "Verify sliding window accuracy within 1% error",
      "Measure p50/p95/p99 latency under load",
      "CI integration for regression detection"
    ]
  }
};

const MOCK_SPRINTS = {
  "Sprint 1": { name: "Sprint 1", state: "closed", goal: "Foundation: Router, config, health checks, CI pipeline" },
  "Sprint 2": { name: "Sprint 2", state: "active", goal: "Security: JWT auth, API keys, rate limiting" },
  "Sprint 3": { name: "Sprint 3", state: "future", goal: "Resilience & Observability: Circuit breaker, tracing, metrics" },
  "Sprint 4": { name: "Sprint 4", state: "future", goal: "Polish: Transformations, dashboards, load testing" }
};

const TOOLS = [
  {
    name: "get_ticket",
    description: "Retrieve a Jira ticket by key (e.g., GW-42) for the go-api-gateway project",
    inputSchema: {
      type: "object",
      properties: {
        ticket_key: {
          type: "string",
          description: "Jira ticket key (e.g., GW-2, GW-42)"
        }
      },
      required: ["ticket_key"]
    }
  },
  {
    name: "search_tickets",
    description: "Search tickets by status, assignee, label, or sprint in the GW project",
    inputSchema: {
      type: "object",
      properties: {
        status: { type: "string", description: "Filter by status: To Do, In Progress, Done, Backlog" },
        assignee: { type: "string", description: "Filter by assignee username" },
        label: { type: "string", description: "Filter by label (e.g., security, middleware, observability)" },
        sprint: { type: "string", description: "Filter by sprint name (e.g., Sprint 2)" }
      }
    }
  },
  {
    name: "update_ticket_status",
    description: "Update the status of a Jira ticket",
    inputSchema: {
      type: "object",
      properties: {
        ticket_key: { type: "string", description: "Jira ticket key" },
        status: { type: "string", description: "New status: To Do, In Progress, In Review, Done" }
      },
      required: ["ticket_key", "status"]
    }
  },
  {
    name: "get_sprint",
    description: "Get sprint details and associated tickets",
    inputSchema: {
      type: "object",
      properties: {
        sprint_name: { type: "string", description: "Sprint name (e.g., Sprint 2)" }
      },
      required: ["sprint_name"]
    }
  },
  {
    name: "add_comment",
    description: "Add a comment to a Jira ticket",
    inputSchema: {
      type: "object",
      properties: {
        ticket_key: { type: "string", description: "Jira ticket key" },
        comment: { type: "string", description: "Comment text to add" }
      },
      required: ["ticket_key", "comment"]
    }
  }
];

function handleGetTicket(args) {
  const key = args.ticket_key?.toUpperCase();
  const ticket = MOCK_TICKETS[key];
  if (!ticket) {
    return { content: [{ type: "text", text: \`Ticket \${key} not found in project \${PROJECT_KEY}\` }], isError: true };
  }
  return { content: [{ type: "text", text: JSON.stringify(ticket, null, 2) }] };
}

function handleSearchTickets(args) {
  let results = Object.values(MOCK_TICKETS);
  if (args.status) {
    results = results.filter(t => t.status.toLowerCase() === args.status.toLowerCase());
  }
  if (args.assignee) {
    results = results.filter(t => t.assignee === args.assignee);
  }
  if (args.label) {
    results = results.filter(t => t.labels.includes(args.label));
  }
  if (args.sprint) {
    results = results.filter(t => t.sprint === args.sprint);
  }
  const summary = results.map(t => ({
    key: t.key,
    summary: t.summary,
    status: t.status,
    assignee: t.assignee,
    priority: t.priority
  }));
  return { content: [{ type: "text", text: JSON.stringify({ count: summary.length, tickets: summary }, null, 2) }] };
}

function handleUpdateTicketStatus(args) {
  const key = args.ticket_key?.toUpperCase();
  const ticket = MOCK_TICKETS[key];
  if (!ticket) {
    return { content: [{ type: "text", text: \`Ticket \${key} not found\` }], isError: true };
  }
  const validStatuses = ["To Do", "In Progress", "In Review", "Done"];
  if (!validStatuses.includes(args.status)) {
    return { content: [{ type: "text", text: \`Invalid status. Valid: \${validStatuses.join(", ")}\` }], isError: true };
  }
  const oldStatus = ticket.status;
  ticket.status = args.status;
  return {
    content: [{
      type: "text",
      text: JSON.stringify({ key, summary: ticket.summary, old_status: oldStatus, new_status: args.status, updated: true }, null, 2)
    }]
  };
}

function handleGetSprint(args) {
  const sprint = MOCK_SPRINTS[args.sprint_name];
  if (!sprint) {
    return { content: [{ type: "text", text: \`Sprint "\${args.sprint_name}" not found\` }], isError: true };
  }
  const tickets = Object.values(MOCK_TICKETS)
    .filter(t => t.sprint === args.sprint_name)
    .map(t => ({ key: t.key, summary: t.summary, status: t.status, assignee: t.assignee, story_points: t.story_points }));
  const totalPoints = tickets.reduce((sum, t) => sum + t.story_points, 0);
  const donePoints = tickets.filter(t => t.status === "Done").reduce((sum, t) => sum + t.story_points, 0);
  return {
    content: [{
      type: "text",
      text: JSON.stringify({ ...sprint, total_points: totalPoints, completed_points: donePoints, tickets }, null, 2)
    }]
  };
}

function handleAddComment(args) {
  const key = args.ticket_key?.toUpperCase();
  const ticket = MOCK_TICKETS[key];
  if (!ticket) {
    return { content: [{ type: "text", text: \`Ticket \${key} not found\` }], isError: true };
  }
  return {
    content: [{
      type: "text",
      text: JSON.stringify({
        key,
        comment_added: true,
        comment: args.comment,
        author: "claude-code",
        timestamp: new Date().toISOString()
      }, null, 2)
    }]
  };
}

function handleToolCall(name, args) {
  switch (name) {
    case "get_ticket": return handleGetTicket(args);
    case "search_tickets": return handleSearchTickets(args);
    case "update_ticket_status": return handleUpdateTicketStatus(args);
    case "get_sprint": return handleGetSprint(args);
    case "add_comment": return handleAddComment(args);
    default: return { content: [{ type: "text", text: \`Unknown tool: \${name}\` }], isError: true };
  }
}

function handleMessage(message) {
  const { id, method, params } = message;

  switch (method) {
    case "initialize":
      return {
        jsonrpc: "2.0",
        id,
        result: {
          protocolVersion: "2024-11-05",
          capabilities: { tools: {} },
          serverInfo: { name: "mock-jira-server-gw", version: "1.0.0" }
        }
      };

    case "notifications/initialized":
      return null;

    case "tools/list":
      return { jsonrpc: "2.0", id, result: { tools: TOOLS } };

    case "tools/call":
      return {
        jsonrpc: "2.0",
        id,
        result: handleToolCall(params.name, params.arguments || {})
      };

    default:
      return {
        jsonrpc: "2.0",
        id,
        error: { code: -32601, message: \`Method not found: \${method}\` }
      };
  }
}

const rl = createInterface({ input: process.stdin, terminal: false });

rl.on("line", (line) => {
  try {
    const message = JSON.parse(line.trim());
    const response = handleMessage(message);
    if (response) {
      process.stdout.write(JSON.stringify(response) + "\\n");
    }
  } catch (err) {
    const errorResponse = {
      jsonrpc: "2.0",
      id: null,
      error: { code: -32700, message: "Parse error" }
    };
    process.stdout.write(JSON.stringify(errorResponse) + "\\n");
  }
});

process.stderr.write("Mock Jira MCP Server (go-api-gateway) running on stdio\\n");`,

  'mock-mcp-servers/package.json': `{
  "name": "go-api-gateway-mock-mcp-servers",
  "version": "1.0.0",
  "private": true,
  "description": "Mock MCP servers for local development of go-api-gateway project",
  "type": "module",
  "scripts": {
    "start:github": "node github-server.mjs",
    "start:jira": "node jira-server.mjs",
    "start:all": "npm run start:github & npm run start:jira",
    "lint": "npx --yes eslint *.mjs",
    "check": "node --check github-server.mjs && node --check jira-server.mjs"
  },
  "dependencies": {
    "@modelcontextprotocol/sdk": "^0.5.0"
  },
  "devDependencies": {
    "eslint": "^9.0.0"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "keywords": [
    "mcp",
    "mock",
    "api-gateway",
    "development",
    "claude-code"
  ],
  "author": "go-api-gateway team",
  "license": "UNLICENSED"
}`,

  'playbook/PLAYBOOK.md': `# Go API Gateway — Development Playbook

> A structured 7-phase methodology for building, shipping, and operating the go-api-gateway project. Each phase has clear entry criteria, activities, deliverables, and exit criteria.

## How to Use This Playbook

This playbook is designed for the go-api-gateway team (2-5 developers) working in GitHub Flow. Each phase can be invoked directly via the CodeForge plugin:

\`\`\`bash
# Run any phase interactively
/phase <phase-number>

# Example: start the planning phase
/phase 1
\`\`\`

Phases are sequential for new features but can be entered independently for bug fixes, performance work, or operational tasks. The playbook integrates with Claude Code — every phase includes guidance for AI-assisted development.

---

## Phase Overview

| Phase | Name | Focus | Typical Duration |
|-------|------|-------|------------------|
| [1](#phase-1-plan) | **Plan** | Requirements, design, task breakdown | 1-2 hours |
| [2](#phase-2-architect) | **Architect** | Technical design, API contracts, data flow | 1-4 hours |
| [3](#phase-3-implement) | **Implement** | TDD, code, middleware, handlers | 1-5 days |
| [4](#phase-4-verify) | **Verify** | Testing, linting, security, benchmarks | 2-8 hours |
| [5](#phase-5-review) | **Review** | Code review, AI audit, approval | 1-4 hours |
| [6](#phase-6-deploy) | **Deploy** | Staging validation, production rollout | 1-2 hours |
| [7](#phase-7-observe) | **Observe** | Monitoring, alerting, incident response | Ongoing |

---

## Phase 1: Plan

**File**: [playbook/phases/01-plan.md](phases/01-plan.md)

### Purpose

Translate a GitHub Issue into a well-scoped implementation plan with clear acceptance criteria, risk assessment, and task breakdown specific to the API gateway domain.

### Entry Criteria

- GitHub Issue exists with a description and priority label
- Issue is assigned to a developer or pair
- Relevant context is available (upstream service contracts, traffic patterns, SLA requirements)

### Activities

1. **Analyze the requirement** — Understand the feature in the context of the gateway's request lifecycle (ingress → middleware chain → routing → upstream → response)
2. **Identify affected layers** — Map changes to Clean Architecture layers:
   - \`internal/handler/\` — New or modified Chi route handlers
   - \`internal/middleware/\` — New or modified middleware (auth, rate limit, circuit breaker)
   - \`internal/service/\` — Business logic changes
   - \`internal/repository/\` — PostgreSQL or Redis data access changes
   - \`internal/model/\` — Domain model or DTO changes
3. **Define acceptance criteria** — Specific, testable conditions including latency budgets, error handling, and edge cases
4. **Assess risks** — Security implications (SOC 2), performance impact (p99 latency), backward compatibility, upstream service dependencies
5. **Break into tasks** — Create sub-issues or a task list in the issue body, each mappable to a single commit
6. **Estimate** — T-shirt sizing (S/M/L/XL) based on layer count and integration complexity

### Deliverables

- [ ] Updated GitHub Issue with acceptance criteria
- [ ] Task breakdown (each task ≤ 1 day of work)
- [ ] Risk assessment documented in issue comments
- [ ] Branch created: \`feat/GW-<number>-<description>\` or \`fix/GW-<number>-<description>\`

### Exit Criteria

- Plan reviewed by at least one other team member (async in Slack or issue comment)
- All tasks have clear scope — no ambiguous items
- Security-sensitive changes flagged for lead review

### Claude Code Integration

\`\`\`bash
# Generate a plan from a GitHub Issue
/plan GW-42

# Claude will:
# - Read the issue description
# - Analyze the codebase for affected files
# - Propose a task breakdown with file-level changes
# - Flag security and performance concerns
\`\`\`

---

## Phase 2: Architect

**File**: [playbook/phases/02-architect.md](phases/02-architect.md)

### Purpose

Design the technical solution before writing code. Define API contracts, middleware ordering, data flow, and integration points. Prevent rework by catching design issues early.

### Entry Criteria

- Phase 1 (Plan) is complete
- Task breakdown is approved
- Branch exists

### Activities

1. **Design the request flow** — Trace the request through the middleware chain:
   \`\`\`
   Client → TLS/ALB → Recovery → RequestID → Logger → CORS → RateLimit → Auth → CircuitBreaker → Handler → Upstream
   \`\`\`
2. **Define API contracts** — Request/response schemas, HTTP status codes, error response format:
   \`\`\`go
   // Standard error response (pkg/errors/)
   type APIError struct {
       Code    string \`json:"code"\`
       Message string \`json:"message"\`
       TraceID string \`json:"trace_id,omitempty"\`
   }
   \`\`\`
3. **Design data models** — Domain models in \`internal/model/\`, database schemas, Redis key patterns
4. **Plan middleware composition** — Determine middleware ordering in Chi router, identify shared vs. route-specific middleware
5. **Define configuration** — New Viper config keys, environment variables, feature flags
6. **Document integration points** — Upstream service contracts, Redis data structures, PostgreSQL queries
7. **Consider observability** — New Prometheus metrics, span names for OpenTelemetry traces, slog fields
8. **Security review** — Authentication requirements, RBAC rules, input validation, OWASP API Security Top 10 checklist

### Deliverables

- [ ] Technical design document (in issue comment or \`docs/\` if significant)
- [ ] API contract (request/response examples)
- [ ] Middleware chain diagram (if modified)
- [ ] Database migration plan (if applicable)
- [ ] Configuration changes documented
- [ ] Interface definitions for new services/repositories

### Exit Criteria

- Design reviewed by a senior or lead developer
- No unresolved questions about data flow or error handling
- Interface contracts defined before implementation begins

### Claude Code Integration

\`\`\`bash
# Claude can help draft architecture decisions
# Use the architect agent for design guidance

# Example: design a new middleware
# Claude will reference docs/ARCHITECTURE.md and existing middleware patterns
\`\`\`

### Key Patterns for This Project

**Middleware signature** (all middleware must follow this pattern):
\`\`\`go
func MyMiddleware(opts ...Option) func(next http.Handler) http.Handler {
    return func(next http.Handler) http.Handler {
        return http.HandlerFunc(func(w http.ResponseWriter, r *http.Request) {
            // middleware logic with context propagation
            ctx := r.Context()
            next.ServeHTTP(w, r.WithContext(ctx))
        })
    }
}
\`\`\`

**Service interface** (dependency injection via interfaces):
\`\`\`go
type RouteService interface {
    ResolveUpstream(ctx context.Context, path string, method string) (*model.Upstream, error)
}
\`\`\`

**Repository interface** (data access abstraction):
\`\`\`go
type RouteRepository interface {
    GetRouteByPathAndMethod(ctx context.Context, path, method string) (*model.Route, error)
}
\`\`\`

---

## Phase 3: Implement

**File**: [playbook/phases/03-implement.md](phases/03-implement.md)

### Purpose

Write production code using Test-Driven Development. Follow Clean Architecture layers, conventional commits, and the project's coding standards.

### Entry Criteria

- Phase 2 (Architect) is complete
- Interface contracts are defined
- Branch is up to date with \`main\`

### Activities

1. **Set up the test first** (TDD Red phase):
   \`\`\`bash
   /tdd red internal/ratelimit
   \`\`\`
   - Write table-driven tests using \`testing\` + \`testify\`
   - Use \`httptest\` for handler tests
   - Mock dependencies with interfaces
   - Target the acceptance criteria from Phase 1

2. **Implement to pass** (TDD Green phase):
   \`\`\`bash
   /tdd green internal/ratelimit
   \`\`\`
   - Write the minimum code to pass tests
   - Follow file naming: \`snake_case.go\`, \`snake_case_test.go\`
   - Keep files under 300 lines
   - Propagate \`context.Context\` on all public functions
   - Wrap errors with \`fmt.Errorf("operation: %w", err)\`
   - Use \`slog\` for structured logging

3. **Refactor** (TDD Refactor phase):
   \`\`\`bash
   /tdd refactor internal/ratelimit
   \`\`\`
   - Extract shared logic
   - Ensure interfaces are minimal
   - Remove duplication
   - Add doc comments to all exported functions

4. **Commit incrementally** — One logical change per commit:
   \`\`\`bash
   git commit -m "feat(ratelimit): add sliding window rate limiter with Redis backend"
   git commit -m "test(ratelimit): add table-driven tests for sliding window algorithm"
   git commit -m "docs(ratelimit): add doc comments for exported types and functions"
   \`\`\`

### Implementation Checklist

- [ ] All exported functions have doc comments
- [ ] No \`init()\` functions
- [ ] Errors wrapped with \`%w\` verb
- [ ] Context propagated through all layers
- [ ] Structured logging with \`slog\` (no \`fmt.Println\` or \`log.Println\`)
- [ ] Interfaces used for dependency injection
- [ ] Table-driven tests with descriptive subtest names
- [ ] No hardcoded configuration values (use Viper/envconfig)
- [ ] Middleware is composable Chi middleware
- [ ] AI-generated code marked with \`// Generated with AI assistance\` comment

### File Organization

\`\`\`
internal/ratelimit/
├── limiter.go           # RateLimiter interface and options
├── sliding_window.go    # Redis sliding window implementation (≤300 lines)
├── sliding_window_test.go  # Table-driven tests
├── middleware.go        # Chi middleware wrapper
└── middleware_test.go   # HTTP handler tests with httptest
\`\`\`

### Exit Criteria

- All tests pass: \`go test ./...\`
- No race conditions: \`go test -race ./...\`
- Coverage ≥ 80% for changed packages
- \`golangci-lint run\` passes with zero issues
- \`go vet ./...\` passes
- Commits follow conventional commit format

### Claude Code Integration

\`\`\`bash
# Full TDD cycle
/tdd internal/ratelimit

# Fix build errors
/build-fix

# Claude follows the TDD skill (plugin/codeforge-go-api-gateway/skills/tdd/SKILL.md)
# and respects .claude/rules/ for coding standards
\`\`\`

---

## Phase 4: Verify

**File**: [playbook/phases/04-verify.md](phases/04-verify.md)

### Purpose

Comprehensive verification before opening a PR. Catch issues that unit tests alone won't find: integration failures, security vulnerabilities, performance regressions, and standards violations.

### Entry Criteria

- Phase 3 (Implement) is complete
- All unit tests pass locally
- Code compiles without warnings

### Activities

1. **Run the full verification suite**:
   \`\`\`bash
   /verify
   \`\`\`
   This executes the following checks in order:

2. **Static analysis**:
   \`\`\`bash
   gofmt -l .                    # Formatting check
   goimports -l .                # Import ordering
   go vet ./...                  # Go vet
   golangci-lint run             # Full lint suite (govet, errcheck, staticcheck, gosec, revive, gocyclo)
   \`\`\`

3. **Unit tests with race detection**:
   \`\`\`bash
   go test -race -coverprofile=coverage.out ./...
   go tool cover -func=coverage.out  # Verify ≥80% coverage
   \`\`\`

4. **Integration tests** (requires Docker Compose for PostgreSQL and Redis):
   \`\`\`bash
   docker compose -f deployments/docker-compose.test.yml up -d
   go test -tags=integration -race ./tests/...
   docker compose -f deployments/docker-compose.test.yml down
   \`\`\`

5. **Security checks**:
   \`\`\`bash
   gosec ./...                           # Security scanner
   go list -m -json all | nancy sleuth   # Dependency vulnerability scan
   \`\`\`
   - Review against OWASP API Security Top 10
   - Verify no secrets in code (no hardcoded keys, tokens, passwords)
   - Check that sensitive paths (\`internal/auth/**\`, \`*.pem\`, \`.env*\`) have appropriate protections

6. **Performance verification** (for performance-sensitive changes):
   \`\`\`bash
   go test -bench=. -benchmem ./internal/ratelimit/...
   go test -bench=. -benchmem ./internal/middleware/...
   \`\`\`
   - Compare benchmarks against baseline using \`benchstat\`
   - Profile with \`pprof\` if p99 latency regression is suspected

7. **Build verification**:
   \`\`\`bash
   go build -o bin/gateway cmd/gateway/main.go
   docker build -t go-api-gateway:test -f deployments/Dockerfile .
   \`\`\`

8. **Configuration validation**:
   - Verify new config keys have defaults in \`configs/development.yaml\`
   - Verify environment variable mappings in \`internal/config/\`
   - Check that production config in \`configs/production.yaml\` is not modified without lead approval

### Verification Report

After running \`/verify\`, Claude generates a report:

\`\`\`
✅ Formatting     — gofmt clean
✅ Imports        — goimports clean
✅ Vet            — no issues
✅ Lint           — golangci-lint passed (0 issues)
✅ Unit Tests     — 142 passed, 0 failed
✅ Race Detection — no races detected
✅ Coverage       — 84.2% (threshold: 80%)
✅ Security       — gosec clean, no vulnerable dependencies
✅ Build          — binary compiled successfully
⚠️ Benchmarks    — sliding_window_test.go: +3.2% allocs (review recommended)
\`\`\`

### Exit Criteria

- All verification checks pass (no ❌)
- Warnings (⚠️) are acknowledged and documented
- Coverage meets or exceeds 80%
- No known security vulnerabilities
- Binary builds and Docker image builds successfully

---

## Phase 5: Review

**File**: [playbook/phases/05-review.md](phases/05-review.md)

### Purpose

Structured code review combining human expertise with AI-assisted analysis. Ensure code quality, security, and architectural consistency before merging to \`main\`.

### Entry Criteria

- Phase 4 (Verify) is complete
- PR is opened on GitHub
- CI pipeline passes (lint, vet, test, build)
- PR description includes: what changed, why, how to test, and any deployment notes

### Activities

1. **Open the PR** with a structured description:
   \`\`\`markdown
   ## What
   Add Redis-backed sliding window rate limiter with per-client limits.

   ## Why
   GW-42: Protect upstream services from traffic spikes. SOC 2 requirement for abuse prevention.

   ## How to Test
   1. Run \`go test -race ./internal/ratelimit/...\`
   2. Start local stack: \`docker compose up -d\`
   3. Hit \`/api/v1/health\` 100 times rapidly — expect 429 after limit

   ## Deployment Notes
   - New Redis key pattern: \`ratelimit:{client_id}:{window}\`
   - New env var: \`RATE_LIMIT_DEFAULT_RPS\` (default: 100)
   - New Prometheus metric: \`gateway_rate_limit_exceeded_total\`
   \`\`\`

2. **AI-assisted review**:
   \`\`\`bash
   /code-review
   \`\`\`
   Claude analyzes the diff for:
   - Clean Architecture violations (handler calling repository directly)
   - Missing error wrapping (\`%w\`)
   - Missing context propagation
   - Unexported function missing from tests
   - Middleware composability issues
   - Security concerns (input validation, auth bypass)
   - Performance anti-patterns (unbounded allocations, missing connection pooling)

3. **Human review** — At least 1 approval required (CODEOWNERS enforced):
   - **Sensitive paths** (\`internal/auth/**\`, \`configs/production/**\`) require lead approval
   - Reviewer checks: correctness, readability, test quality, observability coverage
   - Reviewer runs the code locally if the change touches middleware chain ordering

4. **AI code audit** — Automated via \`.github/workflows/ai-code-audit.yml\`:
   - Flags AI-generated code blocks
   - Verifies AI-generated code has the \`// Generated with AI assistance\` marker
   - Checks for common AI code issues (overly verbose, unnecessary abstractions)

5. **Address feedback** — Fix issues, force-push to branch, re-request review

### Review Checklist

- [ ] PR description is complete (what, why, how to test, deployment notes)
- [ ] CI pipeline is green
- [ ] No sensitive data in diff (secrets, PEM files, production configs)
- [ ] New Prometheus metrics documented
- [ ] New config keys have defaults
- [ ] Error responses follow the standard \`APIError\` format
- [ ] Middleware ordering is correct (if modified)
- [ ] Database migrations are backward-compatible
- [ ] AI-generated code is marked

### Exit Criteria

- At least 1 human approval
- All CI checks pass
- All review comments resolved
- No unresolved security concerns
- CODEOWNERS approval for sensitive paths

---

## Phase 6: Deploy

**File**: [playbook/phases/06-deploy.md](phases/06-deploy.md)

### Purpose

Ship the change safely through staging validation and production rollout. The API gateway is a critical path component — deployment must be zero-downtime.

### Entry Criteria

- Phase 5 (Review) is complete
- PR is merged to \`main\`
- CI/CD pipeline builds and pushes Docker image

### Activities

1. **Staging deployment** (automatic via \`.github/workflows/deploy-production.yml\`):
   - Docker image built and pushed to ECR
   - Helm chart deployed to staging ECS/Kubernetes cluster
   - Health check endpoint (\`/healthz\`) returns 200
   - Readiness check endpoint (\`/readyz\`) returns 200

2. **Staging validation**:
   \`\`\`bash
   # Smoke tests against staging
   curl -s https://staging-gateway.example.com/healthz | jq .
   curl -s https://staging-gateway.example.com/readyz | jq .

   # Run integration tests against staging
   GATEWAY_URL=https://staging-gateway.example.com go test -tags=e2e ./tests/e2e/...
   \`\`\`
   - Verify new routes are accessible
   - Verify rate limiting works (hit limits, check 429 responses)
   - Verify JWT authentication (valid/invalid/expired tokens)
   - Check Prometheus metrics endpoint (\`/metrics\`)
   - Verify traces appear in Jaeger
   - Check Grafana dashboards for anomalies

3. **Production deployment** (manual approval required):
   - Approve the production deployment in GitHub Actions
   - Rolling update with zero downtime (Kubernetes rolling strategy or ECS blue/green)
   - ALB health checks gate traffic to new instances
   - Graceful shutdown ensures in-flight requests complete

4. **Post-deployment verification**:
   \`\`\`bash
   # Production smoke tests
   curl -s https://gateway.example.com/healthz | jq .

   # Check error rates in Prometheus
   # gateway_http_requests_total{status="5xx"} should not spike

   # Check p99 latency in Grafana
   # gateway_request_duration_seconds should be within SLA
   \`\`\`

5. **Rollback plan** (if issues detected):
   \`\`\`bash
   # Kubernetes rollback
   kubectl rollout undo deployment/api-gateway -n gateway

   # Or revert the merge commit
   git revert <merge-commit-sha>
   \`\`\`

### Deployment Checklist

- [ ] Staging health checks pass
- [ ] Staging smoke tests pass
- [ ] No error rate increase in staging
- [ ] Production deployment approved by lead
- [ ] Production health checks pass
- [ ] No error rate increase in production (monitor for 15 minutes)
- [ ] No latency regression in production
- [ ] Rollback plan documented and tested

### Exit Criteria

- Production deployment is healthy
- Error rates are at or below pre-deployment baseline
- p99 latency is within SLA (target: < 50ms for gateway overhead)
- No rollback needed after 30-minute observation window

---

## Phase 7: Observe

**File**: [playbook/phases/07-observe.md](phases/07-observe.md)

### Purpose

Continuous monitoring and operational excellence. The API gateway is the front door to all services — observability is not optional, it's a core feature.

### Entry Criteria

- Phase 6 (Deploy) is complete
- Production deployment is stable

### Activities

1. **Monitor key metrics** (Prometheus + Grafana):

   | Metric | Alert Threshold | Dashboard |
   |--------|----------------|-----------|
   | \`gateway_http_requests_total\` | N/A (traffic baseline) | Gateway Overview |
   | \`gateway_request_duration_seconds\` (p99) | > 100ms | Latency |
   | \`gateway_http_requests_total{status="5xx"}\` | > 1% of total | Error Rate |
   | \`gateway_rate_limit_exceeded_total\` | > 10% of client requests | Rate Limiting |
   | \`gateway_circuit_breaker_state\` | state=open | Circuit Breakers |
   | \`gateway_upstream_request_duration_seconds\` | > 500ms (p99) | Upstream Health |
   | \`gateway_active_connections\` | > 80% of max | Capacity |
   | \`go_goroutines\` | > 10,000 | Runtime |
   | \`go_memstats_alloc_bytes\` | trending up (leak) | Runtime |

2. **Distributed tracing** (OpenTelemetry + Jaeger):
   - Trace requests end-to-end: client → gateway → upstream → response
   - Identify slow middleware in the chain
   - Correlate errors across services using trace IDs
   - Sample rate: 10% in production, 100% in staging

3. **Structured logging** (slog + CloudWatch):
   - All logs include: \`trace_id\`, \`request_id\`, \`client_id\`, \`method\`, \`path\`, \`status\`, \`duration_ms\`
   - Error logs include: \`error\`, \`stack\` (for panics caught by recovery middleware)
   - Log levels: \`DEBUG\` (development), \`INFO\` (staging), \`WARN\` (production default)

4. **Alerting** (Prometheus Alertmanager → Slack):
   \`\`\`yaml
   # Example alert rules
   - alert: GatewayHighErrorRate
     expr: rate(gateway_http_requests_total{status=~"5.."}[5m]) / rate(gateway_http_requests_total[5m]) > 0.01
     for: 5m
     labels:
       severity: critical
     annotations:
       summary: "API Gateway error rate > 1%"

   - alert: GatewayHighLatency
     expr: histogram_quantile(0.99, rate(gateway_request_duration_seconds_bucket[5m])) > 0.1
     for: 5m
     labels:
       severity: warning
     annotations:
       summary: "API Gateway p99 latency > 100ms"

   - alert: CircuitBreakerOpen
     expr: gateway_circuit_breaker_state{state="open"} == 1
     for: 1m
     labels:
       severity: critical
     annotations:
       summary: "Circuit breaker open for {{ $labels.upstream }}"
   \`\`\`

5. **Incident response**:
   - Runbook: \`docs/runbooks/\` (one per alert)
   - On-call rotation: team members rotate weekly
   - Incident channel: \`#gateway-incidents\` in Slack
   - Post-incident: blameless retrospective within 48 hours

6. **Capacity planning**:
   - Review traffic trends weekly
   - Load test monthly: \`scripts/load_test.sh\` (using k6 or vegeta)
   - Scale ECS tasks or Kubernetes replicas based on \`gateway_active_connections\`
   - Redis connection pool sizing: monitor \`redis_pool_active_connections\`
   - PostgreSQL connection pool sizing: monitor \`pg_pool_active_connections\`

7. **Continuous improvement**:
   - Review slow traces weekly — optimize hot paths
   - Profile with \`pprof\` when memory or CPU trends upward
   - Update rate limit defaults based on actual traffic patterns
   - Rotate API keys and JWT signing keys per SOC 2 schedule

### Operational Checklist (Weekly)

- [ ] Review Grafana dashboards for anomalies
- [ ] Check alert history — any false positives to tune?
- [ ] Review error logs for new error patterns
- [ ] Check dependency vulnerability scan results
- [ ] Verify backup and recovery procedures for PostgreSQL config store
- [ ] Review Redis memory usage and eviction rates

### Exit Criteria

Phase 7 is ongoing. A feature's observation period ends when:
- 7 days in production with no related incidents
- Metrics are baselined and alerts are tuned
- Runbooks are written for new failure modes
- The feature is documented in \`docs/\` and \`README.md\`

---

## Phase Transitions

\`\`\`
┌─────────┐     ┌───────────┐     ┌─────────────┐     ┌──────────┐
│  1.Plan  │────▶│ 2.Architect│────▶│ 3.Implement │────▶│ 4.Verify │
└─────────┘     └───────────┘     └─────────────┘     └──────────┘
                                        ▲                    │
                                        │    ┌───────────┐   │
                                        └────│  Fix/TDD  │◀──┘ (if failures)
                                             └───────────┘
                                                             │
                                                             ▼
┌─────────┐     ┌──────────┐     ┌──────────┐
│7.Observe │◀───│ 6.Deploy  │◀───│ 5.Review │
└─────────┘     └──────────┘     └──────────┘
                     ▲                │
                     │                ▼
                     └────── (if changes requested)
\`\`\`

### Fast Paths

Not every change needs all 7 phases at full depth:

| Change Type | Phases | Notes |
|-------------|--------|-------|
| **New feature** | 1→2→3→4→5→6→7 | Full playbook |
| **Bug fix** | 1→3→4→5→6→7 | Lightweight plan, skip architecture |
| **Performance fix** | 1→2→3→4→5→6→7 | Architecture phase focuses on benchmarks |
| **Config change** | 1→4→5→6→7 | Verify + review + deploy |
| **Documentation** | 1→5 | Plan + review only |
| **Dependency update** | 1→4→5→6→7 | Verify security + compatibility |
| **Hotfix** | 3→4→5→6→7 | Emergency path, retrospective plan after |

---

## Quick Reference

### Commands

| Command | Phase | Description |
|---------|-------|-------------|
| \`/plan GW-<n>\` | 1 | Generate implementation plan from issue |
| \`/phase <n>\` | Any | Run a specific phase |
| \`/tdd <package>\` | 3 | Full TDD cycle for a package |
| \`/tdd red <package>\` | 3 | Write failing tests |
| \`/tdd green <package>\` | 3 | Implement to pass tests |
| \`/tdd refactor <package>\` | 3 | Refactor with tests green |
| \`/verify\` | 4 | Run full verification suite |
| \`/code-review\` | 5 | AI-assisted code review |
| \`/build-fix\` | 3-4 | Fix compilation or test errors |

### Key Files

| File | Purpose |
|------|---------|
| \`docs/ARCHITECTURE.md\` | System architecture and design decisions |
| \`docs/CONTRIBUTING.md\` | Contribution guidelines and standards |
| \`docs/AI-USAGE-POLICY.md\` | AI code generation policy (SOC 2) |
| \`docs/ONBOARDING.md\` | New developer onboarding guide |
| \`.claude/rules/\` | Claude Code rules for this project |
| \`CODEOWNERS\` | Code ownership for review routing |

### Standards

| Standard | Requirement |
|----------|-------------|
| Test coverage | ≥ 80% |
| Max file length | 300 lines |
| Commit format | Conventional commits |
| Branch naming | \`type/GW-<n>-description\` |
| Error handling | \`fmt.Errorf("context: %w", err)\` |
| Logging | \`slog\` structured logging |
| Context | Propagated on all handlers and services |
| Middleware | Composable Chi middleware pattern |
| AI code | Marked with \`// Generated with AI assistance\` |`,

  'playbook/claude-overrides/01-discovery.claude.md': `# Phase 01: Discovery & Requirements — Claude Overrides

## Purpose

These rules constrain Claude's behavior during the Discovery & Requirements phase for the go-api-gateway project. They ensure Claude stays focused on requirements gathering and analysis without jumping ahead to implementation.

---

## DO

- **DO** ask clarifying questions about API gateway traffic patterns, expected RPS, upstream service count, and latency budgets before proposing any solution.
- **DO** frame requirements in terms of API gateway concerns: routing rules, authentication flows, rate limiting policies, circuit breaker thresholds, and observability needs.
- **DO** reference SOC 2 compliance requirements when discussing security, audit logging, access control, and data handling requirements.
- **DO** produce user stories in the format: \`As a [API consumer / platform engineer / SRE], I want [capability], so that [business value]\`.
- **DO** distinguish between control plane requirements (configuration, API key management, route registration) and data plane requirements (request proxying, rate limiting, auth validation).
- **DO** identify non-functional requirements explicitly: p99 latency targets, throughput (RPS), availability SLA, max connection pool sizes, graceful shutdown timeout, and Redis/PostgreSQL failover behavior.
- **DO** capture upstream service contracts — expected request/response formats, timeout budgets, retry policies, and health check endpoints.
- **DO** document rate limiting requirements per client, per route, and globally with specific numbers (e.g., 1000 req/min per API key).
- **DO** list all authentication methods needed: JWT (RS256) validation, API key lookup, OAuth2 token passthrough, and mTLS if applicable.
- **DO** reference OWASP API Security Top 10 when gathering security requirements.
- **DO** capture observability requirements: what metrics to expose via Prometheus, what spans to emit via OpenTelemetry, what log fields are mandatory per request.
- **DO** identify integration points: Redis (ElastiCache), PostgreSQL (RDS), upstream microservices, AWS ALB, CloudWatch.
- **DO** produce a requirements traceability matrix mapping each requirement to a future test category (unit, integration, E2E, load).
- **DO** use GitHub Issues as the canonical format for requirements output — title, description, acceptance criteria, labels.
- **DO** validate requirements against the Clean Architecture boundary: handler → service → repository — ensuring requirements map cleanly to a layer.

## DON'T

- **DON'T** write any Go code, not even pseudocode or function signatures. This phase is requirements only.
- **DON'T** choose specific libraries or versions beyond what is already decided in the tech stack (Chi v5, slog, testify, Viper).
- **DON'T** design database schemas, Redis key structures, or API endpoint paths. That belongs in Phase 02 (Architecture).
- **DON'T** propose Kubernetes manifests, Helm values, Terraform resources, or Dockerfile contents. Infrastructure is Phase 03.
- **DON'T** skip non-functional requirements. Every feature requirement must have a corresponding NFR (latency, throughput, error budget).
- **DON'T** assume a single deployment topology. Gather requirements for both ECS and Kubernetes deployment targets.
- **DON'T** conflate the gateway's own API (admin/config endpoints) with the proxied upstream APIs. Keep them separate in requirements.
- **DON'T** ignore multi-tenancy requirements. Clarify whether rate limits, auth policies, and routing rules are per-tenant or global.
- **DON'T** produce generic SaaS requirements. Every requirement must be specific to an API gateway's responsibilities.
- **DON'T** forget to capture graceful shutdown requirements: in-flight request draining, health check de-registration, Redis connection cleanup.
- **DON'T** overlook circuit breaker requirements: per-upstream thresholds, half-open probe intervals, fallback behavior.
- **DON'T** accept vague requirements like "should be fast" or "needs security." Demand specific, measurable acceptance criteria.
- **DON'T** create ADRs (Architecture Decision Records). Those belong in Phase 02.
- **DON'T** define middleware chain ordering or composition. That is an architecture/implementation concern.
- **DON'T** discuss pprof profiling, benchmark harnesses, or performance optimization strategies. Gather performance *targets* only.

---

## Phase Gate Checklist

Before marking Phase 01 complete, verify Claude has produced:

- [ ] Functional requirements document covering: routing, auth, rate limiting, circuit breaking, health checks, observability, admin API
- [ ] Non-functional requirements with measurable targets (p99 < 10ms added latency, 10k RPS per instance, 99.95% availability)
- [ ] User stories for at least three personas: API consumer, platform engineer, SRE
- [ ] Security requirements aligned with SOC 2 and OWASP API Security Top 10
- [ ] Integration requirements for every external dependency (Redis, PostgreSQL, upstream services, AWS services)
- [ ] Requirements traceability matrix
- [ ] Open questions log with owners and due dates
- [ ] GitHub Issues created or drafted for each major requirement area

---

## Context Reminders

- This is a **Go 1.22+** project using **Chi v5** — requirements should assume Go idioms (context propagation, error wrapping, interfaces).
- The team is **small (2-5 devs)**, mostly senior — requirements can assume familiarity with distributed systems but must still be explicit.
- Deployment targets are **AWS ECS** and **Kubernetes** — gather requirements for both.
- All configuration is managed via **Viper + envconfig** — capture what needs to be configurable vs. hardcoded.
- Refer to \`playbook/phases/01-discovery.md\` for the full phase description and \`playbook/prompts/01/\` for prompt templates.`,

  'playbook/claude-overrides/02-architecture.claude.md': `# Phase 02: Architecture & Design — Claude Override Rules

## Context

These rules apply when Claude is assisting with architecture and design decisions for the go-api-gateway project. This phase produces ADRs, API contracts, data models, and system diagrams that will govern all subsequent implementation.

## DO

### Go Architecture

- DO follow Clean Architecture boundaries: \`handler → service → repository\` — never skip layers
- DO define interfaces in the consuming package, not the implementing package (Go idiom)
- DO use \`context.Context\` as the first parameter on every function that crosses a boundary
- DO design middleware as composable \`func(http.Handler) http.Handler\` compatible with Chi
- DO keep the \`cmd/gateway/main.go\` as a thin composition root — wire dependencies there, logic nowhere
- DO use constructor functions (\`NewService\`, \`NewRepository\`) that accept interfaces for dependency injection
- DO design for graceful shutdown from day one — every long-lived goroutine must respect context cancellation
- DO separate configuration structs per domain (\`AuthConfig\`, \`RateLimitConfig\`, \`CircuitBreakerConfig\`)

### API Gateway Patterns

- DO design the routing table as a declarative configuration (YAML in \`configs/\`) not hardcoded routes
- DO plan for per-route middleware chains — different upstream services need different auth/rate-limit policies
- DO design rate limiting with sliding window algorithm backed by Redis — not simple counters
- DO architect the circuit breaker as a per-upstream-service state machine (closed → open → half-open)
- DO plan request/response transformation as middleware, not embedded in handlers
- DO design health checks at two levels: shallow (\`/healthz\` — process alive) and deep (\`/readyz\` — dependencies reachable)
- DO plan for request ID propagation (\`X-Request-ID\`) through the entire middleware chain
- DO design retry logic with exponential backoff and jitter for upstream calls

### Data Model

- DO use PostgreSQL for durable configuration: route definitions, API key metadata, client registrations, RBAC policies
- DO use Redis for ephemeral/high-throughput data: rate limit counters, circuit breaker state, response cache, session tokens
- DO design the API key table with hashed keys (SHA-256), never store plaintext
- DO include \`created_at\`, \`updated_at\`, and \`deleted_at\` (soft delete) on all persistent entities
- DO design the route configuration schema to support path parameters, header-based routing, and query parameter matching
- DO plan database migrations using \`golang-migrate\` with numbered SQL files in \`migrations/\`

### API Design

- DO follow REST conventions for the gateway admin API (\`/admin/v1/routes\`, \`/admin/v1/clients\`)
- DO version the admin API from the start (\`/admin/v1/\`)
- DO use consistent error response format: \`{"error": {"code": "RATE_LIMITED", "message": "...", "request_id": "..."}}\`
- DO design the proxy path as a catch-all: \`/*\` with routing decisions made in middleware
- DO document all API contracts in OpenAPI 3.1 format in \`docs/openapi/\`

### Observability Architecture

- DO plan OpenTelemetry trace context propagation through all middleware and upstream calls
- DO design Prometheus metrics with proper labels: \`gateway_request_duration_seconds{method, path, status, upstream}\`
- DO plan structured logging with \`slog\` — every log line must include \`request_id\`, \`method\`, \`path\`, \`status\`, \`duration\`
- DO design the metrics endpoint on a separate port (\`:9090/metrics\`) from the gateway traffic port (\`:8080\`)

### Security Architecture

- DO design JWT validation as middleware that extracts claims and injects them into context
- DO plan for RS256 key rotation — support JWKS endpoint fetching with caching
- DO architect RBAC as a policy engine that maps JWT claims/scopes to allowed routes
- DO design TLS termination at the ALB layer, with the gateway trusting the \`X-Forwarded-*\` headers from ALB only
- DO plan API key authentication as a separate middleware from JWT — routes can require either or both
- DO design secrets management through AWS Secrets Manager or environment variables — never config files

### SOC 2 Compliance

- DO include audit logging in the architecture — every authentication event, every admin API mutation
- DO design access control for the admin API separately from the proxy API
- DO plan for log retention and immutability requirements in the observability architecture
- DO document data flow diagrams showing where PII and credentials traverse the system

### ADR Standards

- DO write ADRs for: router choice, auth strategy, rate limiting algorithm, circuit breaker pattern, config store, caching strategy, deployment topology
- DO use the format: Title, Status, Context, Decision, Consequences, Alternatives Considered
- DO store ADRs in \`docs/adr/\` with sequential numbering: \`0001-use-chi-router.md\`
- DO reference ADRs from code comments when implementing the decided pattern

## DON'T

### Go Anti-Patterns

- DON'T use \`init()\` functions — they hide initialization order and break testability
- DON'T design with package-level global state (global DB connections, global loggers) — inject everything
- DON'T use \`interface{}\` / \`any\` when a concrete type or specific interface is possible
- DON'T design circular package dependencies — if \`handler\` imports \`service\` and \`service\` imports \`handler\`, the architecture is wrong
- DON'T put business logic in handlers — handlers parse HTTP, call services, write HTTP responses
- DON'T design with concrete struct dependencies — always depend on interfaces for cross-layer calls
- DON'T use \`panic\` for error handling in any design — return errors up the call stack
- DON'T design packages with names like \`util\`, \`common\`, \`helpers\`, \`base\` — be specific

### API Gateway Anti-Patterns

- DON'T design the gateway to hold business logic for upstream services — it routes, authenticates, rate-limits, and observes
- DON'T design synchronous blocking calls to Redis for rate limiting without timeouts — always set deadlines
- DON'T hardcode upstream service URLs — they must come from configuration or service discovery
- DON'T design a single global rate limit — rate limits must be per-client, per-route, or per-client-per-route
- DON'T design the circuit breaker to share state across unrelated upstreams — each upstream gets its own breaker
- DON'T design request transformation that buffers entire request/response bodies in memory for large payloads — stream when possible
- DON'T design retry logic without idempotency awareness — only retry safe/idempotent methods by default (GET, HEAD, OPTIONS)
- DON'T proxy WebSocket or streaming connections through the same path as request/response — design separate handling

### Data Model Anti-Patterns

- DON'T store rate limit state in PostgreSQL — it cannot handle the write throughput; use Redis
- DON'T store secrets (JWT signing keys, API keys in plaintext, database passwords) in the config YAML files
- DON'T design the schema without indexes on frequently queried columns (API key hash, route path, client ID)
- DON'T use UUIDs as primary keys without also having a sequential internal ID for join performance
- DON'T design the route table to require a database query on every proxied request — cache routes in memory with TTL

### Security Anti-Patterns

- DON'T design JWT validation that only checks the signature — also validate \`exp\`, \`nbf\`, \`iss\`, \`aud\` claims
- DON'T design API key lookup with timing-vulnerable string comparison — use \`crypto/subtle.ConstantTimeCompare\`
- DON'T trust \`X-Forwarded-For\` from arbitrary sources — only trust headers from the known ALB CIDR range
- DON'T design the admin API to be accessible on the same port/path as the proxy API without separate authentication
- DON'T log JWT tokens, API keys, or Authorization headers — redact sensitive headers in all log output
- DON'T design CORS as permissive by default (\`*\`) — require explicit origin allowlists per route

### Observability Anti-Patterns

- DON'T design high-cardinality metric labels (e.g., user ID, request ID, full URL path with IDs) — they will explode Prometheus storage
- DON'T log request/response bodies by default — only in debug mode, and never for sensitive endpoints
- DON'T design tracing that instruments every internal function call — trace at boundary points (incoming request, outgoing upstream call, database query, Redis call)
- DON'T use \`fmt.Println\` or \`log.Printf\` anywhere in the architecture — all logging goes through \`slog\`

### Architecture Process Anti-Patterns

- DON'T skip writing ADRs for significant decisions — "we'll document it later" means never
- DON'T design the entire system in one monolithic diagram — break into: request flow, auth flow, rate limit flow, deployment topology
- DON'T over-abstract prematurely — design for the known upstream services first, generalize when the pattern is proven
- DON'T design for horizontal scaling before the single-instance architecture is correct and tested
- DON'T introduce a service mesh, message queue, or event bus unless the requirements explicitly demand it — start simple

## Architecture Review Checklist

Before completing Phase 02, verify these artifacts exist and are consistent:

1. **ADRs** in \`docs/adr/\` for all major decisions (minimum 5-7 ADRs)
2. **OpenAPI spec** in \`docs/openapi/\` for admin API and proxy behavior
3. **Data model** with PostgreSQL schema and Redis key design documented
4. **Request flow diagram** showing the full middleware chain from ingress to upstream
5. **Deployment topology** showing ECS/Kubernetes, ALB, ElastiCache, RDS relationships
6. **Security model** documenting auth flows, key rotation, and RBAC policy structure
7. **Configuration schema** documenting all environment variables and YAML config structure
8. **Dependency list** with justification for each external Go module

## Cross-References

- Phase 01 outputs (requirements, NFRs, user stories): \`playbook/prompts/01/\`
- Architecture prompts: \`playbook/prompts/02/\`
- Phase definition: \`playbook/phases/02-architecture.md\`
- Implementation will follow in Phase 03-04 under \`internal/\` package structure`,

  'playbook/claude-overrides/03-foundation.claude.md': `# Phase 03: Foundation & Scaffolding — Claude Override Rules

## Phase Context

You are scaffolding the foundation of \`go-api-gateway\`, a high-performance API gateway built with Go 1.22 and Chi v5. This phase establishes the project structure, CI/CD pipeline, infrastructure-as-code, and base configurations. Every decision here affects the entire project lifecycle.

## DO — Required Behaviors

### Project Structure

- DO follow the Go project layout exactly as defined: \`cmd/gateway/\`, \`internal/\`, \`pkg/\`, \`configs/\`, \`deployments/\`, \`scripts/\`, \`tests/\`, \`docs/\`
- DO place the single \`main.go\` entry point in \`cmd/gateway/main.go\` with minimal logic — wire dependencies and call \`run(ctx context.Context) error\`
- DO use \`internal/\` for all packages that must not be imported by external consumers
- DO use \`pkg/\` only for truly reusable utilities (\`httputil\`, \`errors\`) that could theoretically be shared
- DO create separate packages under \`internal/\` for each concern: \`handler\`, \`middleware\`, \`service\`, \`repository\`, \`model\`, \`config\`, \`auth\`, \`ratelimit\`, \`circuit\`, \`observability\`
- DO include a \`tools.go\` file with \`//go:build tools\` constraint to pin tool dependencies (golangci-lint, mockgen, etc.)
- DO create a \`Makefile\` with targets: \`build\`, \`test\`, \`lint\`, \`vet\`, \`fmt\`, \`run\`, \`docker-build\`, \`migrate\`, \`generate\`, \`bench\`
- DO generate a \`.golangci.yml\` enabling: govet, errcheck, staticcheck, gosec, revive, gocyclo (max complexity 15), goimports, misspell, unconvert, unparam

### Go Module & Dependencies

- DO initialize with \`go mod init github.com/your-org/go-api-gateway\`
- DO pin exact versions of critical dependencies in \`go.mod\` — no floating versions
- DO include only these core dependencies at scaffold time:
  - \`github.com/go-chi/chi/v5\` — router
  - \`github.com/go-chi/cors\` — CORS middleware
  - \`github.com/golang-jwt/jwt/v5\` — JWT parsing
  - \`github.com/redis/go-redis/v9\` — Redis client
  - \`github.com/jackc/pgx/v5\` — PostgreSQL driver
  - \`github.com/spf13/viper\` — configuration
  - \`github.com/kelseyhightower/envconfig\` — env var binding
  - \`go.opentelemetry.io/otel\` — tracing
  - \`github.com/prometheus/client_golang\` — metrics
  - \`github.com/stretchr/testify\` — test assertions
  - \`github.com/sony/gobreaker\` — circuit breaker
- DO run \`go mod tidy\` after any dependency change

### Configuration

- DO use Viper for YAML config loading with envconfig for environment variable overrides
- DO create config structs in \`internal/config/config.go\` with explicit types, validation tags, and doc comments
- DO provide \`configs/development.yaml\`, \`configs/staging.yaml\`, and \`configs/production.yaml\` with environment-appropriate defaults
- DO load config in this precedence order: defaults → YAML file → environment variables → CLI flags
- DO validate all configuration at startup and fail fast with clear error messages
- DO use \`time.Duration\` types for timeouts, not raw integers
- DO define separate config sections: \`Server\`, \`Database\`, \`Redis\`, \`Auth\`, \`RateLimit\`, \`CircuitBreaker\`, \`Observability\`

### Main Entry Point

- DO structure \`cmd/gateway/main.go\` with a \`run(ctx context.Context) error\` function that \`main()\` calls
- DO set up signal handling for \`SIGINT\` and \`SIGTERM\` in \`main()\` using \`signal.NotifyContext\`
- DO implement graceful shutdown: stop accepting new connections, drain in-flight requests (30s timeout), close DB pools, flush telemetry
- DO propagate \`context.Context\` from \`main\` through the entire application
- DO use \`log/slog\` as the logger, configured before anything else starts
- DO exit with \`os.Exit(1)\` only in \`main()\` — never in library code

### Chi Router Setup

- DO create the router factory in \`internal/handler/router.go\` as \`func NewRouter(deps Dependencies) chi.Router\`
- DO compose middleware in this exact order: RequestID → RealIP → Recovery → CORS → Structured Logging → Metrics → Tracing → RateLimit → Auth (on protected groups)
- DO use Chi's \`r.Group()\` and \`r.Route()\` for logical grouping of routes
- DO mount health check endpoints outside the auth middleware group: \`GET /healthz\` (liveness), \`GET /readyz\` (readiness)
- DO define a \`Dependencies\` struct that holds all injected services for handlers
- DO register Prometheus metrics endpoint at \`/metrics\` outside auth middleware
- DO register pprof endpoints at \`/debug/pprof/*\` behind a feature flag, disabled in production

### Database & Redis Foundation

- DO create connection pool factories in \`internal/repository/\` with configurable pool sizes, timeouts, and health checks
- DO use \`pgx/v5\` with \`pgxpool\` for PostgreSQL connection pooling
- DO configure Redis with \`go-redis/v9\` using connection pooling and automatic reconnection
- DO implement \`Ping()\` methods on both database clients for health check integration
- DO set connection pool limits: max open, max idle, max lifetime, max idle time
- DO use prepared statements or parameterized queries exclusively — never string concatenation for SQL

### CI/CD Pipeline

- DO create \`.github/workflows/ci.yml\` with these stages in order: lint → vet → unit tests → race detection → integration tests → build binary → build Docker image
- DO use \`golangci-lint-action\` for linting with the project's \`.golangci.yml\`
- DO run tests with \`-race -count=1 -coverprofile=coverage.out -covermode=atomic\`
- DO enforce 80% coverage threshold with \`go tool cover\`
- DO cache Go modules and build cache in CI using \`actions/cache\`
- DO build the binary with \`-ldflags "-s -w -X main.version=\${VERSION} -X main.commit=\${COMMIT}"\` for version embedding
- DO use multi-stage Docker builds: builder stage (Go 1.22) → runtime stage (distroless or alpine)
- DO scan Docker images with Trivy or Snyk in CI
- DO create \`.github/workflows/deploy-staging.yml\` triggered on merge to \`main\`

### Infrastructure as Code

- DO create Terraform modules in \`deployments/terraform/\` for: ECS service, ALB, ElastiCache Redis, RDS PostgreSQL, CloudWatch log groups, IAM roles
- DO create a Dockerfile in \`deployments/docker/Dockerfile\` using multi-stage build
- DO create Kubernetes manifests in \`deployments/k8s/\` with: Deployment, Service, ConfigMap, HorizontalPodAutoscaler, PodDisruptionBudget
- DO create a Helm chart in \`deployments/helm/\` if Helm is the deployment method
- DO set resource requests and limits on all container specs
- DO configure liveness and readiness probes pointing to \`/healthz\` and \`/readyz\`

### Code Ownership & Templates

- DO create \`CODEOWNERS\` mapping:
  - \`internal/auth/**\` → \`@security-team\`
  - \`internal/middleware/**\` → \`@platform-team\`
  - \`deployments/**\` → \`@platform-team\`
  - \`configs/production/**\` → \`@platform-team @security-team\`
  - \`*\` → \`@backend-team\`
- DO create PR template (\`.github/pull_request_template.md\`) with checklist: tests added, docs updated, no secrets, conventional commit, coverage maintained
- DO create issue templates for bug reports and feature requests

### Observability Foundation

- DO set up OpenTelemetry SDK initialization in \`internal/observability/tracing.go\` with OTLP exporter
- DO set up Prometheus metrics registry in \`internal/observability/metrics.go\` with standard HTTP metrics: request count, duration histogram, in-flight gauge, response size
- DO configure \`slog\` with JSON output in production, text output in development, with request_id, trace_id, and span_id fields
- DO create a middleware that injects the logger with request-scoped fields into the context

## DON'T — Prohibited Behaviors

### Project Structure Anti-Patterns

- DON'T create a \`src/\` directory — this is not idiomatic Go
- DON'T put business logic in \`cmd/\` — it should only contain wiring and \`main()\`
- DON'T create a \`utils/\` or \`helpers/\` package — name packages by what they provide, not what they contain
- DON'T create circular dependencies between internal packages — the dependency graph must be acyclic: handler → service → repository
- DON'T put generated code in the same file as hand-written code — use \`_gen.go\` suffix or separate directories
- DON'T create packages with only one file unless the package has a clear bounded responsibility
- DON'T nest packages more than 3 levels deep under \`internal/\`

### Go Code Anti-Patterns

- DON'T use \`init()\` functions anywhere — explicit initialization in \`main()\` or factory functions only
- DON'T use global variables for state — pass dependencies through constructors and function parameters
- DON'T use \`interface{}\` or \`any\` when a concrete type or specific interface is possible
- DON'T define interfaces in the implementing package — define them in the consuming package (accept interfaces, return structs)
- DON'T use \`panic()\` for error handling — return errors and let the caller decide
- DON'T ignore errors — every error must be checked, wrapped with \`fmt.Errorf("context: %w", err)\`, or explicitly discarded with a comment
- DON'T use \`log\` stdlib package — use \`log/slog\` exclusively
- DON'T use \`http.DefaultServeMux\` or \`http.DefaultClient\` — always create explicit instances with configured timeouts
- DON'T embed \`sync.Mutex\` in exported structs — use unexported fields
- DON'T use \`time.Sleep\` in production code — use tickers, timers, or context deadlines

### Configuration Anti-Patterns

- DON'T hardcode connection strings, secrets, ports, or timeouts
- DON'T read environment variables directly in packages other than \`internal/config\` — pass config as struct parameters
- DON'T store secrets in YAML config files — use environment variables or a secrets manager
- DON'T use \`configs/production.yaml\` for actual production secrets — it should contain only non-sensitive defaults
- DON'T create config structs without validation — use struct tags or explicit validation functions

### Dependency Anti-Patterns

- DON'T add dependencies that duplicate stdlib functionality (e.g., don't add a UUID library if \`crypto/rand\` suffices for your use case)
- DON'T add web frameworks beyond Chi — no Gin, Echo, Fiber, or net/http wrappers
- DON'T add an ORM — use \`pgx\` with raw SQL or a lightweight query builder like \`squirrel\` at most
- DON'T add \`github.com/pkg/errors\` — use stdlib \`errors\` and \`fmt.Errorf\` with \`%w\`
- DON'T add logging libraries beyond \`log/slog\` — no logrus, zap, or zerolog
- DON'T vendor dependencies — use Go module proxy and checksum database

### CI/CD Anti-Patterns

- DON'T skip the \`-race\` flag in CI test runs
- DON'T allow CI to pass with linting warnings — treat all lint issues as errors
- DON'T use \`latest\` tags for Docker base images — pin to specific versions (e.g., \`golang:1.22.5-alpine3.20\`)
- DON'T store credentials in GitHub Actions workflow files — use GitHub Secrets and OIDC for AWS
- DON'T run integration tests against production databases
- DON'T skip Docker image scanning in the pipeline

### Infrastructure Anti-Patterns

- DON'T create Kubernetes manifests without resource limits — always set CPU and memory requests/limits
- DON'T expose pprof or metrics endpoints publicly — they must be on a separate internal port or behind auth
- DON'T use \`hostNetwork\` or \`privileged\` in container specs
- DON'T create RDS instances without encryption at rest and in transit
- DON'T create ElastiCache clusters without auth tokens and encryption
- DON'T use default VPC or security groups in Terraform

### Security Anti-Patterns

- DON'T commit \`.env\` files, \`*.pem\` files, or any file containing secrets
- DON'T log request bodies that may contain credentials or PII
- DON'T disable TLS verification in HTTP clients, even in development
- DON'T use \`*\` CORS origins in staging or production configs
- DON'T create IAM roles with \`*\` resource permissions in Terraform
- DON'T store JWT signing keys in config files — load from environment or secrets manager

## Scaffold Validation Checklist

Before completing this phase, verify:

1. \`go build ./...\` succeeds with zero warnings
2. \`go vet ./...\` reports no issues
3. \`golangci-lint run\` passes with the project's \`.golangci.yml\`
4. \`go test ./... -race -count=1\` passes (even if tests are minimal stubs)
5. \`docker build -f deployments/docker/Dockerfile .\` produces a working image
6. The binary starts, binds to the configured port, and responds to \`GET /healthz\` with \`200 OK\`
7. Graceful shutdown works: sending \`SIGTERM\` drains connections and exits cleanly
8. All config values can be overridden via environment variables
9. The CI pipeline runs end-to-end on a feature branch
10. \`CODEOWNERS\` is present and correctly maps sensitive paths
11. No secrets, credentials, or PII exist in any committed file
12. The \`.gitignore\` excludes: \`bin/\`, \`*.exe\`, \`.env*\`, \`*.pem\`, \`coverage.out\`, \`vendor/\`

## File Generation Order

When scaffolding, generate files in this order to resolve dependencies correctly:

1. \`go.mod\`, \`go.sum\` — module definition
2. \`internal/config/config.go\` — configuration structs and loading
3. \`internal/observability/\` — logging, metrics, tracing setup
4. \`internal/repository/\` — database and Redis connection factories
5. \`internal/model/\` — domain types
6. \`pkg/errors/\`, \`pkg/httputil/\` — shared utilities
7. \`internal/middleware/\` — Chi middleware chain
8. \`internal/handler/router.go\` — route definitions
9. \`cmd/gateway/main.go\` — entry point wiring
10. \`configs/\` — YAML configuration files
11. \`Makefile\` — build automation
12. \`.golangci.yml\` — linter configuration
13. \`.github/\` — CI workflows, templates, CODEOWNERS
14. \`deployments/\` — Docker, Kubernetes, Terraform
15. \`tests/\` — integration test scaffolds`,

  'playbook/claude-overrides/04-core-implementation.claude.md': `# Phase 04: Core Implementation — Claude Override Rules

## Context

You are implementing core features for \`go-api-gateway\`, a high-performance API gateway built with Go 1.22 and Chi v5. This phase covers handlers, middleware, services, repositories, and the critical gateway patterns (rate limiting, circuit breakers, JWT auth, request routing). Every line of code must be production-grade, observable, and SOC 2 compliant.

---

## DO — Mandatory Practices

### Architecture & Structure

- **DO** follow Clean Architecture strictly: \`handler → service → repository\`. Handlers call services, services call repositories. Never skip layers.
- **DO** define interfaces at the consumer side (in the package that uses them), not the provider side.
- **DO** keep all HTTP concerns (request parsing, response writing, status codes) in \`internal/handler/\`. Services must not import \`net/http\`.
- **DO** use constructor functions (\`NewFooService(deps...) *FooService\`) for all structs with dependencies. Accept interfaces, return concrete types.
- **DO** propagate \`context.Context\` as the first parameter of every function that crosses a boundary (handler → service → repository → external call).
- **DO** keep files under 300 lines. Split large handlers into per-resource files (e.g., \`handler/routes.go\`, \`handler/health.go\`, \`handler/proxy.go\`).
- **DO** use snake_case for file names: \`rate_limiter.go\`, \`jwt_validator.go\`, \`circuit_breaker.go\`.

### Go Idioms & Error Handling

- **DO** wrap all errors with \`fmt.Errorf("operation context: %w", err)\` to preserve the error chain.
- **DO** define sentinel errors in \`pkg/errors/\` for domain-specific failures: \`ErrRateLimitExceeded\`, \`ErrTokenExpired\`, \`ErrCircuitOpen\`, \`ErrUpstreamTimeout\`.
- **DO** use \`errors.Is()\` and \`errors.As()\` for error checking — never compare error strings.
- **DO** return early on errors. Keep the happy path unindented.
- **DO** use typed error responses with consistent JSON structure:
  \`\`\`go
  type ErrorResponse struct {
      Code    string \`json:"code"\`
      Message string \`json:"message"\`
      TraceID string \`json:"trace_id,omitempty"\`
  }
  \`\`\`
- **DO** check every error return. The \`errcheck\` linter will enforce this.

### Chi Middleware & Handlers

- **DO** write all middleware as composable \`func(next http.Handler) http.Handler\` compatible with Chi's middleware chain.
- **DO** use \`chi.URLParam(r, "paramName")\` for path parameters — never parse \`r.URL.Path\` manually.
- **DO** use \`chi.RouteContext(r.Context())\` when you need route pattern information for metrics labels.
- **DO** register middleware in the correct order in \`cmd/gateway/main.go\`:
  1. Recovery (panic → 500)
  2. Request ID injection
  3. Structured logging
  4. OpenTelemetry tracing
  5. Prometheus metrics
  6. CORS
  7. Rate limiting
  8. Authentication (JWT / API key)
  9. RBAC authorization
- **DO** use \`r.Use()\` for router-wide middleware and \`r.With()\` for route-group middleware.
- **DO** write response helpers in \`pkg/httputil/\` for consistent JSON responses:
  \`\`\`go
  func RespondJSON(w http.ResponseWriter, status int, data any)
  func RespondError(w http.ResponseWriter, status int, err error, traceID string)
  \`\`\`

### JWT Authentication & RBAC

- **DO** validate JWT tokens using RS256 with public key verification. Load keys from PEM files or JWKS endpoint.
- **DO** extract claims into a typed struct and store in context via a context key:
  \`\`\`go
  type Claims struct {
      Subject  string   \`json:"sub"\`
      ClientID string   \`json:"client_id"\`
      Roles    []string \`json:"roles"\`
      Exp      int64    \`json:"exp"\`
  }
  \`\`\`
- **DO** implement API key validation as a separate middleware path — not mixed into JWT middleware.
- **DO** enforce RBAC at the route-group level using \`r.With(middleware.RequireRole("admin"))\`.
- **DO** log authentication failures with \`slog.Warn\` including client IP, path, and reason — but never log tokens or credentials.

### Rate Limiting

- **DO** implement sliding window rate limiting using Redis sorted sets (\`ZADD\`, \`ZREMRANGEBYSCORE\`, \`ZCARD\`).
- **DO** use a Lua script for atomic rate limit checks to avoid race conditions.
- **DO** key rate limits by client identifier (API key, JWT \`client_id\`, or IP as fallback).
- **DO** return standard rate limit headers: \`X-RateLimit-Limit\`, \`X-RateLimit-Remaining\`, \`X-RateLimit-Reset\`, \`Retry-After\`.
- **DO** return \`429 Too Many Requests\` with a JSON error body — never a bare status code.
- **DO** make rate limit configuration per-client and loadable from PostgreSQL.

### Circuit Breaker

- **DO** implement the circuit breaker with three states: Closed, Open, Half-Open.
- **DO** track failure counts and success counts per upstream service.
- **DO** expose circuit breaker state as a Prometheus gauge: \`gateway_circuit_state{upstream="service_name"}\`.
- **DO** return \`503 Service Unavailable\` when the circuit is open, with a \`Retry-After\` header.
- **DO** make thresholds configurable: \`failure_threshold\`, \`success_threshold\`, \`timeout_duration\`.

### Request Routing & Proxying

- **DO** use \`httputil.ReverseProxy\` from the standard library for upstream proxying.
- **DO** set appropriate timeouts on the proxy transport: \`DialTimeout\`, \`TLSHandshakeTimeout\`, \`ResponseHeaderTimeout\`, \`IdleConnTimeout\`.
- **DO** propagate trace context headers (\`traceparent\`, \`tracestate\`) to upstream services.
- **DO** strip or rewrite sensitive headers (\`Authorization\`, \`Cookie\`) based on route configuration before forwarding.
- **DO** add \`X-Request-ID\`, \`X-Forwarded-For\`, \`X-Forwarded-Proto\` headers to proxied requests.

### Database & Redis

- **DO** use \`pgx/v5\` (not \`database/sql\` with \`lib/pq\`) for PostgreSQL — it's faster and supports native types.
- **DO** use connection pooling with \`pgxpool\` and configure \`MaxConns\`, \`MinConns\`, \`MaxConnLifetime\`, \`MaxConnIdleTime\`.
- **DO** use \`go-redis/redis/v9\` for Redis with connection pooling and \`context.Context\` on every call.
- **DO** set Redis operation timeouts: \`DialTimeout: 5s\`, \`ReadTimeout: 3s\`, \`WriteTimeout: 3s\`.
- **DO** implement repository interfaces:
  \`\`\`go
  type RouteRepository interface {
      GetRoutes(ctx context.Context) ([]model.Route, error)
      GetRouteByPath(ctx context.Context, method, path string) (*model.Route, error)
  }
  \`\`\`

### Observability

- **DO** create spans for every handler, service method, and external call using OpenTelemetry:
  \`\`\`go
  ctx, span := tracer.Start(ctx, "service.ValidateToken")
  defer span.End()
  \`\`\`
- **DO** add span attributes for request metadata: \`http.method\`, \`http.route\`, \`http.status_code\`, \`client.id\`.
- **DO** register Prometheus metrics in \`internal/observability/metrics.go\`:
  - \`gateway_requests_total\` (counter, labels: method, route, status)
  - \`gateway_request_duration_seconds\` (histogram, labels: method, route)
  - \`gateway_upstream_duration_seconds\` (histogram, labels: upstream)
  - \`gateway_rate_limit_hits_total\` (counter, labels: client_id)
  - \`gateway_circuit_state\` (gauge, labels: upstream)
  - \`gateway_active_connections\` (gauge)
- **DO** use \`slog\` with JSON output for all logging. Include \`trace_id\`, \`request_id\`, \`client_id\` in every log line.
- **DO** log at appropriate levels: \`Debug\` for request details, \`Info\` for lifecycle events, \`Warn\` for auth failures and rate limits, \`Error\` for upstream failures and panics.

### Testing

- **DO** write table-driven tests for all business logic:
  \`\`\`go
  tests := []struct {
      name    string
      input   InputType
      want    OutputType
      wantErr error
  }{...}
  for _, tt := range tests {
      t.Run(tt.name, func(t *testing.T) { ... })
  }
  \`\`\`
- **DO** use \`httptest.NewRecorder()\` and \`httptest.NewRequest()\` for handler tests.
- **DO** use \`testify/assert\` and \`testify/require\` — \`require\` for fatal preconditions, \`assert\` for verifiable expectations.
- **DO** mock dependencies using interfaces. Define mocks in \`_test.go\` files or a \`internal/mock/\` package.
- **DO** test middleware in isolation by wrapping a dummy \`http.HandlerFunc\` and asserting on the recorder.
- **DO** write benchmark tests for hot paths: rate limiter check, JWT validation, route matching.
  \`\`\`go
  func BenchmarkRateLimiterCheck(b *testing.B) { ... }
  \`\`\`
- **DO** run tests with race detection: \`go test -race ./...\`.

### Configuration

- **DO** load configuration with Viper, supporting YAML files and environment variable overrides.
- **DO** use \`envconfig\` struct tags for environment variable mapping with \`GATEWAY_\` prefix:
  \`\`\`go
  type Config struct {
      Port           int           \`envconfig:"GATEWAY_PORT" default:"8080"\`
      ReadTimeout    time.Duration \`envconfig:"GATEWAY_READ_TIMEOUT" default:"10s"\`
      WriteTimeout   time.Duration \`envconfig:"GATEWAY_WRITE_TIMEOUT" default:"30s"\`
      ShutdownTimeout time.Duration \`envconfig:"GATEWAY_SHUTDOWN_TIMEOUT" default:"15s"\`
  }
  \`\`\`
- **DO** validate configuration at startup — fail fast with clear error messages if required values are missing.

### Graceful Shutdown

- **DO** implement graceful shutdown listening for \`SIGINT\` and \`SIGTERM\`:
  \`\`\`go
  ctx, stop := signal.NotifyContext(context.Background(), syscall.SIGINT, syscall.SIGTERM)
  defer stop()
  \`\`\`
- **DO** drain in-flight requests before shutting down. Use \`http.Server.Shutdown(ctx)\` with the configured timeout.
- **DO** close database pools and Redis connections in the shutdown sequence.

---

## DON'T — Prohibited Practices

### Architecture Violations

- **DON'T** import \`internal/handler\` from \`internal/service\` or \`internal/repository\`. Dependencies flow inward only.
- **DON'T** put business logic in handlers. Handlers parse requests, call services, and write responses — nothing else.
- **DON'T** put HTTP concerns (\`http.Request\`, \`http.ResponseWriter\`, status codes) in services or repositories.
- **DON'T** use global variables or package-level mutable state. No \`var db *sql.DB\` at package scope.
- **DON'T** use \`init()\` functions. All initialization must be explicit in \`main()\` or constructor functions.
- **DON'T** create God structs. If a struct has more than 5-7 dependencies, it needs to be decomposed.

### Go Anti-Patterns

- **DON'T** ignore errors. Never use \`_ = someFunc()\` unless there is a comment explaining why.
- **DON'T** use \`panic()\` in library code. Panics are only acceptable in \`main()\` for unrecoverable startup failures.
- **DON'T** use bare \`return err\` without wrapping. Always add context: \`return fmt.Errorf("fetching route %s: %w", path, err)\`.
- **DON'T** use \`interface{}\` or \`any\` as function parameters when a specific type or interface is possible.
- **DON'T** use \`log\` (stdlib) or \`fmt.Println\` for logging. Use \`slog\` exclusively.
- **DON'T** use string concatenation for SQL queries. Use parameterized queries (\`$1\`, \`$2\`) to prevent SQL injection.
- **DON'T** use \`time.Sleep()\` in production code. Use \`time.After()\`, \`time.NewTicker()\`, or context-based cancellation.
- **DON'T** embed \`sync.Mutex\` in exported structs. Keep mutexes unexported and document what they protect.

### Security Violations (SOC 2)

- **DON'T** log JWT tokens, API keys, passwords, or any credential material — even at Debug level.
- **DON'T** include stack traces or internal error details in HTTP responses to clients. Log them server-side, return generic messages.
- **DON'T** hardcode secrets, keys, or connection strings. Load from environment variables or a secrets manager.
- **DON'T** disable TLS verification on upstream HTTP clients (\`InsecureSkipVerify: true\`), even in staging.
- **DON'T** trust \`X-Forwarded-For\` without validating it comes from a trusted proxy (ALB).
- **DON'T** store PEM files, \`.env\` files, or any secrets in the repository. They must be in \`.gitignore\`.
- **DON'T** use \`HS256\` for JWT signing. Use \`RS256\` with asymmetric keys for SOC 2 compliance.
- **DON'T** allow unbounded request bodies. Set \`http.MaxBytesReader\` on all endpoints that accept a body.

### Middleware Mistakes

- **DON'T** write middleware that breaks the Chi chain. Always call \`next.ServeHTTP(w, r)\` on the success path.
- **DON'T** write to the response body after calling \`next.ServeHTTP()\` — the response is already committed.
- **DON'T** create middleware that depends on other middleware's context values without documenting the dependency.
- **DON'T** put rate limiting after authentication in the middleware chain — rate limiting must protect the auth layer from abuse.

### Performance Anti-Patterns

- **DON'T** create a new Redis or PostgreSQL connection per request. Use connection pools.
- **DON'T** allocate in hot paths. Pre-allocate slices, reuse buffers with \`sync.Pool\` for serialization.
- **DON'T** use \`json.Marshal\`/\`json.Unmarshal\` in hot paths without considering \`json.NewEncoder\`/\`json.NewDecoder\` for streaming.
- **DON'T** use unbounded goroutines. Use \`errgroup\` or a worker pool with a semaphore.
- **DON'T** make blocking calls without a context timeout. Every external call (Redis, PostgreSQL, upstream HTTP) must have a deadline.
- **DON'T** use \`reflect\` in request hot paths. Pre-compute route tables and validation at startup.

### Testing Anti-Patterns

- **DON'T** write tests that depend on external services (Redis, PostgreSQL) without build tags (\`//go:build integration\`).
- **DON'T** use \`time.Sleep()\` in tests to wait for async operations. Use channels, \`sync.WaitGroup\`, or \`testify/assert.Eventually\`.
- **DON'T** test private functions directly. Test through the public API of the package.
- **DON'T** write tests without assertions. Every test must verify a specific behavior.
- **DON'T** skip error assertions. If a function returns an error, the test must check it.
- **DON'T** use real cryptographic keys in tests. Generate ephemeral test keys in \`TestMain\` or test helpers.

### Dependency & Module Mistakes

- **DON'T** add dependencies without team discussion. This project follows a conservative dependency policy.
- **DON'T** use \`replace\` directives in \`go.mod\` for anything other than local development.
- **DON'T** vendor dependencies unless explicitly required for air-gapped builds.
- **DON'T** import packages from \`cmd/\` into \`internal/\` or \`pkg/\`. The \`cmd/\` package is a leaf.

---

## Code Patterns — Quick Reference

### Handler Pattern
\`\`\`go
// HandleCreateRoute creates a new route configuration.
func (h *RouteHandler) HandleCreateRoute(w http.ResponseWriter, r *http.Request) {
    ctx, span := h.tracer.Start(r.Context(), "handler.CreateRoute")
    defer span.End()

    var req model.CreateRouteRequest
    if err := json.NewDecoder(http.MaxBytesReader(w, r.Body, 1<<20)).Decode(&req); err != nil {
        httputil.RespondError(w, http.StatusBadRequest, err, trace.SpanFromContext(ctx).SpanContext().TraceID().String())
        return
    }

    route, err := h.routeService.Create(ctx, &req)
    if err != nil {
        h.handleServiceError(w, ctx, err)
        return
    }

    httputil.RespondJSON(w, http.StatusCreated, route)
}
\`\`\`

### Middleware Pattern
\`\`\`go
// RateLimit returns Chi middleware that enforces per-client rate limits.
func RateLimit(limiter ratelimit.Limiter) func(http.Handler) http.Handler {
    return func(next http.Handler) http.Handler {
        return http.HandlerFunc(func(w http.ResponseWriter, r *http.Request) {
            ctx := r.Context()
            clientID := auth.ClientIDFromContext(ctx)

            result, err := limiter.Allow(ctx, clientID)
            if err != nil {
                slog.ErrorContext(ctx, "rate limiter error", "error", err)
                next.ServeHTTP(w, r)
                return
            }

            w.Header().Set("X-RateLimit-Limit", strconv.Itoa(result.Limit))
            w.Header().Set("X-RateLimit-Remaining", strconv.Itoa(result.Remaining))
            w.Header().Set("X-RateLimit-Reset", strconv.FormatInt(result.ResetAt.Unix(), 10))

            if !result.Allowed {
                w.Header().Set("Retry-After", strconv.Itoa(result.RetryAfter))
                httputil.RespondError(w, http.StatusTooManyRequests, errors.ErrRateLimitExceeded, "")
                return
            }

            next.ServeHTTP(w, r)
        })
    }
}
\`\`\`

### Service Pattern
\`\`\`go
// Validate checks the JWT token and returns the parsed claims.
func (s *AuthService) Validate(ctx context.Context, tokenStr string) (*model.Claims, error) {
    ctx, span := s.tracer.Start(ctx, "service.AuthService.Validate")
    defer span.End()

    claims, err := s.jwtValidator.Parse(ctx, tokenStr)
    if err != nil {
        span.RecordError(err)
        span.SetStatus(codes.Error, "token validation failed")
        return nil, fmt.Errorf("validating token: %w", err)
    }

    span.SetAttributes(attribute.String("client.id", claims.ClientID))
    return claims, nil
}
\`\`\`

---

## Checklist Before Completing Phase 04

- [ ] All handlers accept \`context.Context\` and propagate it through the call chain
- [ ] All middleware is composable and registered in the documented order
- [ ] JWT validation uses RS256 with configurable JWKS/PEM source
- [ ] Rate limiter uses Redis with atomic Lua scripts
- [ ] Circuit breaker exposes state via Prometheus gauge
- [ ] All errors are wrapped with \`%w\` and context
- [ ] Structured logging with \`slog\` on every handler and middleware
- [ ] OpenTelemetry spans on every handler and service method
- [ ] Prometheus metrics registered for requests, latency, rate limits, circuit state
- [ ] Table-driven tests for all services with ≥80% coverage
- [ ] Handler tests use \`httptest\` with mocked service interfaces
- [ ] Benchmark tests exist for rate limiter, JWT validation, and route matching
- [ ] \`golangci-lint run\` passes with zero issues
- [ ] \`go test -race ./...\` passes with zero data races
- [ ] No secrets, tokens, or PEM files committed to the repository
- [ ] Graceful shutdown implemented with configurable timeout`,

  'playbook/claude-overrides/05-integration-hardening.claude.md': `# Phase 05: Integration & Hardening — Claude Override Rules

## Context

You are working on **go-api-gateway**, a high-performance API gateway built with Go 1.22 and Chi v5. This phase focuses on integrating external services (Redis, PostgreSQL, upstream microservices), hardening security for SOC 2 compliance, and wiring observability. Every decision must prioritize reliability, security, and low-latency routing.

---

## DO — Integration Patterns

- **DO** use connection pooling for all external dependencies — configure \`sql.DB\` with \`SetMaxOpenConns\`, \`SetMaxIdleConns\`, and \`SetConnMaxLifetime\` for PostgreSQL
- **DO** use \`github.com/redis/go-redis/v9\` with \`PoolSize\`, \`MinIdleConns\`, and \`DialTimeout\` configured explicitly
- **DO** implement health checks for every external dependency in \`internal/handler/health.go\` — return degraded status if Redis or PostgreSQL is unreachable, not a hard failure
- **DO** propagate \`context.Context\` through every integration call — from Chi handler → service → repository → external client
- **DO** set explicit timeouts on all outbound HTTP calls to upstream services using \`http.Client{Timeout: ...}\` — never use \`http.DefaultClient\`
- **DO** wrap all external errors with \`fmt.Errorf("component: operation: %w", err)\` to preserve error chains for debugging
- **DO** use interfaces for all external service clients so they can be mocked in tests:
  \`\`\`go
  // internal/repository/cache.go
  type CacheRepository interface {
      Get(ctx context.Context, key string) (string, error)
      Set(ctx context.Context, key string, value string, ttl time.Duration) error
  }
  \`\`\`
- **DO** implement retry logic with exponential backoff for transient failures against Redis and upstream services — use a simple helper in \`pkg/httputil/retry.go\`, not a heavy library
- **DO** use Chi middleware composition for cross-cutting concerns — stack middleware in \`cmd/gateway/main.go\` in the correct order: recovery → request ID → logging → tracing → auth → rate limiting → handler
- **DO** implement circuit breakers in \`internal/circuit/\` using a state machine (closed → open → half-open) — track failure counts per upstream host
- **DO** use Redis sliding window for rate limiting in \`internal/ratelimit/\` — implement as a Lua script executed atomically via \`redis.Eval\` to avoid race conditions
- **DO** configure TLS for Redis and PostgreSQL connections in production — use \`tls.Config\` with certificate verification enabled
- **DO** use database migrations managed by \`golang-migrate/migrate\` — store migrations in \`scripts/migrations/\` with sequential numbering

## DON'T — Integration Anti-Patterns

- **DON'T** use \`init()\` functions to establish database or Redis connections — initialize in \`main()\` and pass via dependency injection
- **DON'T** store connection strings, API keys, or JWT signing keys in code or config files — load from environment variables or AWS Secrets Manager
- **DON'T** use global variables for database pools, Redis clients, or HTTP clients — pass them as struct fields through constructors
- **DON'T** ignore \`context.Canceled\` or \`context.DeadlineExceeded\` errors — check for them explicitly and return appropriate HTTP status codes (499 or 504)
- **DON'T** retry on non-idempotent operations (POST to upstream) without explicit idempotency keys
- **DON'T** use \`panic\` for recoverable errors in integration code — return errors up the call stack
- **DON'T** log full request/response bodies in production — log only metadata (method, path, status, duration, trace ID) to avoid leaking PII
- **DON'T** hardcode upstream service URLs — load from configuration via Viper and support runtime updates
- **DON'T** create a new Redis connection per request — always use the connection pool
- **DON'T** use \`SELECT\` on different Redis databases — use key prefixes (e.g., \`ratelimit:\`, \`cache:\`, \`session:\`) for namespace isolation
- **DON'T** implement your own JWT parsing — use \`golang-jwt/jwt/v5\` with explicit algorithm validation (\`RS256\` only, reject \`none\`)
- **DON'T** trust \`X-Forwarded-For\` headers without validating against known proxy IPs — configure trusted proxies in Chi

---

## DO — Security Hardening (SOC 2)

- **DO** validate all incoming request headers, query parameters, and path parameters — use strict type parsing, reject unexpected fields
- **DO** implement request body size limits via \`http.MaxBytesReader\` in middleware — default to 1MB, configurable per route
- **DO** set security headers in a dedicated Chi middleware (\`internal/middleware/security.go\`):
  - \`X-Content-Type-Options: nosniff\`
  - \`X-Frame-Options: DENY\`
  - \`Strict-Transport-Security: max-age=31536000; includeSubDomains\`
  - \`X-Request-ID\` (generated or forwarded)
  - \`Cache-Control: no-store\` for authenticated endpoints
- **DO** implement API key rotation support — store keys with \`created_at\` and \`expires_at\` in PostgreSQL, support overlapping validity windows
- **DO** use constant-time comparison (\`crypto/subtle.ConstantTimeCompare\`) for API key and token validation
- **DO** sanitize all error messages returned to clients — never expose stack traces, internal IPs, database errors, or file paths
- **DO** implement audit logging for authentication events (login, token refresh, key usage, failed attempts) — write to a dedicated structured log stream with \`slog\`
- **DO** enforce RBAC at the middleware level — check permissions before the request reaches the handler:
  \`\`\`go
  r.With(middleware.RequireRole("admin")).Get("/admin/routes", handler.ListRoutes)
  \`\`\`
- **DO** run \`gosec\` as part of CI — fail the build on HIGH severity findings
- **DO** pin all Docker base images to specific SHA digests in \`deployments/Dockerfile\`
- **DO** scan dependencies with \`govulncheck\` on every PR
- **DO** implement request throttling per API key AND per IP — use composite keys in Redis (\`ratelimit:{api_key}:{endpoint}\`)
- **DO** validate JWT \`iss\`, \`aud\`, \`exp\`, and \`nbf\` claims explicitly — reject tokens missing any required claim
- **DO** rotate JWT signing keys using JWKS endpoint — cache the JWKS response in Redis with a short TTL (5 minutes)

## DON'T — Security Anti-Patterns

- **DON'T** log JWT tokens, API keys, passwords, or authorization headers — redact them in the logging middleware
- **DON'T** return different error messages for "user not found" vs "wrong password" — use a generic "authentication failed" response
- **DON'T** accept JWT algorithm from the token header without validation — always enforce \`RS256\` in the parser options
- **DON'T** store plaintext API keys in PostgreSQL — store bcrypt hashes or use HMAC with a server-side secret, and return the key only once at creation
- **DON'T** disable TLS verification in any HTTP client, even in staging — use proper CA certificates
- **DON'T** expose \`/debug/pprof\` endpoints in production — gate behind authentication or disable entirely via build tags
- **DON'T** use \`*\` for CORS \`Access-Control-Allow-Origin\` — configure explicit allowed origins from config
- **DON'T** embed secrets in Helm values files or Terraform state — use AWS Secrets Manager with IAM role-based access
- **DON'T** skip input validation because "the upstream will handle it" — validate at the gateway boundary

---

## DO — Observability Wiring

- **DO** initialize OpenTelemetry in \`internal/observability/tracer.go\` — configure OTLP exporter pointing to Jaeger, set service name to \`go-api-gateway\`
- **DO** create spans for every external call (Redis, PostgreSQL, upstream HTTP) — include operation name, target, and duration as span attributes
- **DO** propagate trace context (\`traceparent\` header) to upstream services — use \`otelhttp.NewTransport\` for outbound HTTP clients
- **DO** expose Prometheus metrics at \`/metrics\` — use a separate Chi router on a different port (e.g., \`:9090\`) so metrics are not exposed to public traffic
- **DO** track these Prometheus metrics at minimum:
  - \`gateway_requests_total\` (labels: method, path, status, upstream)
  - \`gateway_request_duration_seconds\` (histogram, labels: method, path, upstream)
  - \`gateway_upstream_errors_total\` (labels: upstream, error_type)
  - \`gateway_circuit_breaker_state\` (gauge, labels: upstream, state)
  - \`gateway_rate_limit_rejected_total\` (labels: api_key, endpoint)
  - \`gateway_active_connections\` (gauge)
- **DO** use \`slog\` with JSON output in production — include \`trace_id\`, \`span_id\`, \`request_id\`, \`method\`, \`path\` in every log entry
- **DO** correlate logs and traces by extracting the trace ID from the OpenTelemetry span context and adding it to the \`slog\` handler
- **DO** implement structured error logging that includes error codes defined in \`pkg/errors/\`:
  \`\`\`go
  slog.ErrorContext(ctx, "upstream request failed",
      "error_code", errors.ErrUpstreamTimeout,
      "upstream", upstreamName,
      "duration_ms", elapsed.Milliseconds(),
  )
  \`\`\`
- **DO** add readiness and liveness probes in \`internal/handler/health.go\` — liveness returns 200 if the process is running, readiness checks Redis and PostgreSQL connectivity

## DON'T — Observability Anti-Patterns

- **DON'T** use \`log.Println\` or \`fmt.Println\` — always use \`slog\` for structured, leveled logging
- **DON'T** create high-cardinality Prometheus labels — never use user IDs, request IDs, or full URLs as label values
- **DON'T** sample traces at 100% in production — configure head-based sampling at 10-20% for normal traffic, always sample errors
- **DON'T** log at DEBUG level in production — default to INFO, allow runtime level changes via config
- **DON'T** expose the \`/metrics\` endpoint on the public-facing port — use a separate internal listener
- **DON'T** forget to close OpenTelemetry spans — use \`defer span.End()\` immediately after \`tracer.Start()\`
- **DON'T** create spans inside tight loops — aggregate operations and create a single span for batch operations

---

## DO — Integration Testing

- **DO** write integration tests in \`tests/integration/\` using \`testcontainers-go\` for Redis and PostgreSQL — never mock infrastructure in integration tests
- **DO** use table-driven tests for all integration scenarios:
  \`\`\`go
  tests := []struct {
      name       string
      apiKey     string
      wantStatus int
      wantBody   string
  }{
      {"valid key", validKey, http.StatusOK, ""},
      {"expired key", expiredKey, http.StatusUnauthorized, "api key expired"},
      {"rate limited", rateLimitedKey, http.StatusTooManyRequests, ""},
  }
  \`\`\`
- **DO** test circuit breaker state transitions — verify that the breaker opens after N failures and closes after the recovery timeout
- **DO** test rate limiting under concurrent load — use \`sync.WaitGroup\` and goroutines to simulate parallel requests
- **DO** test graceful shutdown — send SIGTERM and verify in-flight requests complete while new requests are rejected
- **DO** use \`httptest.NewServer\` to create mock upstream services in tests — verify that headers, query params, and bodies are forwarded correctly
- **DO** run integration tests with \`-race\` flag in CI to detect data races in middleware and shared state
- **DO** test Redis connection failure scenarios — verify the gateway degrades gracefully (e.g., bypasses rate limiting with a warning log) rather than returning 500

## DON'T — Integration Testing Anti-Patterns

- **DON'T** use \`time.Sleep\` for synchronization in tests — use channels, \`sync.WaitGroup\`, or polling with timeout
- **DON'T** share test state between test functions — each test must set up and tear down its own data
- **DON'T** skip integration tests in CI — they must run in the pipeline with real Redis and PostgreSQL containers
- **DON'T** test against shared staging databases — always use ephemeral containers
- **DON'T** write integration tests that depend on execution order — use \`t.Parallel()\` where safe

---

## File Ownership Reminders

- Changes to \`internal/auth/**\` and \`internal/middleware/auth*.go\` require security review per CODEOWNERS
- Changes to \`configs/production/**\` require lead approval
- Changes to \`deployments/**\` require infrastructure review
- All \`.pem\` files and \`.env*\` files must be in \`.gitignore\` — fail CI if they appear in a commit

## Performance Hardening Checklist

- [ ] Run \`go test -bench=. ./internal/ratelimit/\` — sliding window must complete in <1ms p99
- [ ] Run \`go test -bench=. ./internal/middleware/\` — middleware chain overhead must be <50μs p99
- [ ] Profile with \`pprof\` under load — no goroutine leaks, memory stable over 1 hour
- [ ] Connection pool sizes tuned: PostgreSQL max 25, Redis pool 50 (adjust based on load testing)
- [ ] HTTP client connection pooling: \`MaxIdleConnsPerHost\` set to match expected upstream concurrency
- [ ] Response body streaming for large payloads — don't buffer entire upstream response in memory`,

  'playbook/claude-overrides/06-testing-quality.claude.md': `# Phase 06: Testing & Quality — Claude Override Rules

## Phase Context

You are working on testing and quality assurance for \`go-api-gateway\`, a high-performance API gateway built with Go 1.22 and Chi router. This phase covers unit tests, integration tests, end-to-end tests, load tests, and quality gates. All testing must account for the concurrent, middleware-heavy, and latency-sensitive nature of an API gateway.

## DO — Required Practices

### Table-Driven Tests

- DO write every test function as a table-driven test with \`[]struct\` and \`t.Run\`:
\`\`\`go
func TestRateLimiter_Allow(t *testing.T) {
    tests := []struct {
        name       string
        clientID   string
        limit      int
        window     time.Duration
        requests   int
        wantAllow  int
        wantDeny   int
    }{
        {
            name:      "under limit allows all",
            clientID:  "client-1",
            limit:     10,
            window:    time.Minute,
            requests:  5,
            wantAllow: 5,
            wantDeny:  0,
        },
        // ... more cases
    }
    for _, tt := range tests {
        t.Run(tt.name, func(t *testing.T) {
            // test body
        })
    }
}
\`\`\`
- DO include edge cases in every test table: empty input, nil context, expired JWT, zero-value structs, max-length strings, Unicode in headers
- DO name test cases descriptively — the name must explain the scenario without reading the test body

### Test Organization

- DO place unit tests in the same package as the code under test (\`internal/middleware/ratelimit_test.go\`)
- DO place integration tests in \`tests/integration/\` with build tag \`//go:build integration\`
- DO place end-to-end tests in \`tests/e2e/\` with build tag \`//go:build e2e\`
- DO place load tests in \`scripts/loadtest/\` using k6 or vegeta
- DO use \`testify/assert\` for assertions and \`testify/require\` for fatal preconditions
- DO use \`testify/suite\` only when shared setup/teardown across multiple test functions is genuinely needed — prefer standalone test functions

### HTTP Handler Testing

- DO test all Chi handlers using \`httptest.NewRecorder()\` and \`httptest.NewRequest()\`:
\`\`\`go
func TestHealthHandler(t *testing.T) {
    req := httptest.NewRequest(http.MethodGet, "/health", nil)
    rec := httptest.NewRecorder()

    r := chi.NewRouter()
    r.Get("/health", handler.Health)
    r.ServeHTTP(rec, req)

    assert.Equal(t, http.StatusOK, rec.Code)
}
\`\`\`
- DO test middleware by composing it onto a Chi router with a test handler downstream
- DO test the full middleware chain for critical paths (auth → rate limit → handler → response)
- DO pass \`context.Background()\` or a properly populated context into every request — never \`nil\`
- DO verify response headers (Content-Type, X-Request-ID, X-RateLimit-Remaining, Cache-Control)
- DO test both JSON response body structure and status codes

### Context and Concurrency Testing

- DO run \`go test -race ./...\` in CI on every PR — race conditions in middleware are critical bugs
- DO write concurrent tests for rate limiter, circuit breaker, and connection pool:
\`\`\`go
func TestRateLimiter_Concurrent(t *testing.T) {
    limiter := ratelimit.New(redisClient, ratelimit.Config{Limit: 100, Window: time.Minute})
    var wg sync.WaitGroup
    var allowed atomic.Int64
    for i := 0; i < 200; i++ {
        wg.Add(1)
        go func() {
            defer wg.Done()
            if limiter.Allow(context.Background(), "client-1") {
                allowed.Add(1)
            }
        }()
    }
    wg.Wait()
    assert.LessOrEqual(t, allowed.Load(), int64(100))
}
\`\`\`
- DO test context cancellation propagation through the handler chain
- DO test graceful shutdown by sending requests during \`server.Shutdown(ctx)\`

### Mocking and Test Doubles

- DO define interfaces in the consumer package and mock them for unit tests:
\`\`\`go
// internal/service/route_service.go
type RouteRepository interface {
    FindByPath(ctx context.Context, path string) (*model.Route, error)
}
\`\`\`
- DO use hand-written mocks or \`testify/mock\` — keep mocks in a \`_test.go\` file or \`internal/mock/\` package
- DO use \`miniredis\` for Redis unit tests — never require a running Redis for unit tests
- DO use \`pgxmock\` or \`sqlmock\` for PostgreSQL unit tests
- DO use real Redis and PostgreSQL in integration tests via \`testcontainers-go\`

### Integration Tests

- DO use \`testcontainers-go\` to spin up Redis and PostgreSQL for integration tests:
\`\`\`go
func TestIntegration_RateLimitWithRedis(t *testing.T) {
    if testing.Short() {
        t.Skip("skipping integration test")
    }
    ctx := context.Background()
    redisC, err := testcontainers.GenericContainer(ctx, testcontainers.GenericContainerRequest{
        ContainerRequest: testcontainers.ContainerRequest{
            Image:        "redis:7-alpine",
            ExposedPorts: []string{"6379/tcp"},
            WaitingFor:   wait.ForListeningPort("6379/tcp"),
        },
        Started: true,
    })
    require.NoError(t, err)
    t.Cleanup(func() { _ = redisC.Terminate(ctx) })
    // ... test with real Redis
}
\`\`\`
- DO test JWT validation end-to-end with real RS256 key pairs generated in test setup
- DO test database migrations run cleanly on a fresh PostgreSQL container
- DO test circuit breaker state transitions with a flaky upstream mock server

### Load and Performance Testing

- DO write k6 or vegeta load tests for critical gateway paths:
  - \`POST /auth/token\` — token issuance under load
  - \`GET /api/v1/*\` — proxied request throughput
  - Rate-limited endpoints — verify correct rejection ratio
- DO establish baseline latency benchmarks using \`testing.B\`:
\`\`\`go
func BenchmarkJWTValidation(b *testing.B) {
    token := generateTestJWT(b)
    validator := auth.NewJWTValidator(testPublicKey)
    b.ResetTimer()
    for i := 0; i < b.N; i++ {
        _, _ = validator.Validate(context.Background(), token)
    }
}
\`\`\`
- DO benchmark middleware overhead: measure p50, p95, p99 latency added by each middleware
- DO run benchmarks with \`-benchmem\` to track allocations
- DO set performance budgets: JWT validation < 1ms p99, rate limit check < 2ms p99, full proxy round-trip overhead < 5ms p99

### Coverage and Quality Gates

- DO enforce 80% code coverage minimum — fail CI if below threshold
- DO measure coverage per package, not just aggregate — \`internal/auth/\` and \`internal/ratelimit/\` must each meet 80%
- DO exclude generated code, test helpers, and \`cmd/\` from coverage calculations
- DO run \`golangci-lint run\` with gosec enabled — security linting is a quality gate
- DO run \`go vet ./...\` as a separate CI step before tests

### Error Path Testing

- DO test every error return path — not just the happy path
- DO verify error wrapping preserves the chain: \`assert.ErrorIs(t, err, repository.ErrNotFound)\`
- DO test that error responses return correct HTTP status codes and structured JSON error bodies:
\`\`\`json
{
    "error": {
        "code": "RATE_LIMIT_EXCEEDED",
        "message": "Rate limit exceeded for client",
        "retry_after": 30
    }
}
\`\`\`
- DO test that sensitive information is never leaked in error responses (no stack traces, no internal IPs, no SQL queries)
- DO test that panics in handlers are recovered by the recovery middleware and return 500

### Security Testing

- DO test JWT with expired tokens, malformed tokens, wrong algorithm (alg:none attack), missing claims
- DO test API key authentication with revoked keys, expired keys, keys with insufficient scopes
- DO test RBAC by verifying that each role can only access permitted endpoints
- DO test request size limits — verify 413 for oversized payloads
- DO test header injection and path traversal attempts return 400
- DO test CORS headers are set correctly for allowed and disallowed origins
- DO fuzz critical parsers with \`testing.F\` (Go native fuzzing):
\`\`\`go
func FuzzJWTParser(f *testing.F) {
    f.Add("eyJhbGciOiJSUzI1NiJ9.e30.invalid")
    f.Add("")
    f.Add("not.a.jwt")
    f.Fuzz(func(t *testing.T, token string) {
        _, err := auth.ParseJWT(token)
        if err == nil {
            t.Error("expected error for fuzzed input")
        }
    })
}
\`\`\`

### Test Helpers

- DO create shared test helpers in \`internal/testutil/\`:
  - \`testutil.NewTestRouter(t)\` — returns a Chi router with standard middleware
  - \`testutil.GenerateJWT(t, claims)\` — generates a valid test JWT
  - \`testutil.NewRedisClient(t)\` — returns a miniredis-backed client
  - \`testutil.AssertJSONResponse(t, rec, status, body)\` — validates JSON responses
- DO mark all test helpers with \`t.Helper()\` so failure line numbers point to the caller

## DON'T — Prohibited Practices

### Test Structure

- DON'T write tests without \`t.Run\` subtests — flat test functions with multiple assertions are forbidden
- DON'T use \`if got != want\` patterns — use \`testify/assert\` or \`testify/require\`
- DON'T write tests that depend on execution order — each \`t.Run\` must be independently runnable
- DON'T use \`time.Sleep\` in tests — use channels, \`sync.WaitGroup\`, \`testify/assert.Eventually\`, or \`require.EventuallyWithT\`
- DON'T hardcode ports in tests — use \`httptest.NewServer\` or let the OS assign ports with \`:0\`

### Mocking

- DON'T use \`gomock\` — it adds unnecessary complexity for this project size; use \`testify/mock\` or hand-written mocks
- DON'T mock the standard library (\`http.Client\`, \`time.Now\`) directly — wrap them in interfaces and mock the interface
- DON'T create mocks that return hardcoded values without verifying inputs — mocks must assert they were called with expected arguments
- DON'T use global mocks or package-level mock state — each test must set up its own mocks

### External Dependencies

- DON'T require running infrastructure (Redis, PostgreSQL, external services) for unit tests — use miniredis, sqlmock, or in-memory fakes
- DON'T skip integration tests in CI — they must run in the integration test stage with testcontainers
- DON'T make tests that call external APIs (auth providers, third-party services) — mock all external boundaries
- DON'T use \`localhost\` hardcoded addresses — derive connection strings from testcontainers or environment variables

### Coverage and Quality

- DON'T write tests that only test the happy path — every function with error returns must have error case tests
- DON'T inflate coverage with trivial getter/setter tests — focus coverage on business logic, middleware, and error handling
- DON'T ignore \`-race\` failures — a race condition in the gateway is a production incident
- DON'T skip \`gosec\` findings without a documented justification in a \`//nolint:gosec // reason\` comment
- DON'T merge PRs with coverage below 80% per package for \`internal/auth/\`, \`internal/ratelimit/\`, \`internal/middleware/\`, \`internal/circuit/\`

### Security Testing

- DON'T commit real private keys, API keys, or credentials in test fixtures — generate ephemeral keys in test setup
- DON'T skip JWT algorithm confusion tests — the \`alg:none\` attack must be explicitly tested and rejected
- DON'T trust test tokens from external sources — generate all test JWTs within the test suite using known key pairs
- DON'T disable TLS verification in integration tests without a \`t.Cleanup\` that re-enables it

### Performance Testing

- DON'T run load tests against shared environments — use dedicated staging or local Docker Compose
- DON'T write benchmarks without \`b.ResetTimer()\` after setup — setup time must not pollute benchmark results
- DON'T ignore allocation counts in benchmarks — middleware on the hot path must minimize allocations
- DON'T set unrealistic performance budgets — base them on measured baselines, not aspirational targets

### Anti-Patterns

- DON'T use \`init()\` functions in test files — use \`TestMain(m *testing.M)\` for package-level setup
- DON'T use \`reflect.DeepEqual\` — use \`testify/assert.Equal\` which provides better diff output
- DON'T write test files longer than 300 lines — split into multiple \`_test.go\` files by concern
- DON'T duplicate test setup across test functions — extract to \`t.Helper()\` functions in \`testutil\`
- DON'T log in tests with \`fmt.Println\` — use \`t.Log\` or \`t.Logf\` so output is captured by the test runner
- DON'T create test fixtures that drift from production schemas — generate fixtures from the same models used in production code

## CI Quality Gate Checklist

Before merging any PR in this phase, verify:

\`\`\`
✅ go vet ./... passes
✅ golangci-lint run passes (with gosec)
✅ go test ./... -race -count=1 passes
✅ go test ./... -coverprofile=coverage.out meets 80% per critical package
✅ go test -tags=integration ./tests/integration/... passes with testcontainers
✅ Benchmarks run with -benchmem and results recorded
✅ No time.Sleep in any test file
✅ No hardcoded credentials in test fixtures
✅ All exported test helpers have doc comments
✅ Fuzz tests exist for JWT parser and request validator
\`\`\`

## Cross-References

- Test suite generation: \`playbook/prompts/06/test-suite-generator.md\`
- E2E test patterns: \`playbook/prompts/06/e2e-test-generator.md\`
- Load test scripts: \`playbook/prompts/06/load-test.md\`
- Auth implementation (test targets): \`playbook/prompts/04/auth-implementation.md\`
- Security hardening (security test targets): \`playbook/prompts/05/security-hardening.md\`
- CI pipeline configuration: \`playbook/prompts/03/ci-pipeline.md\`
- Phase definition: \`playbook/phases/06-testing-quality.md\``,

  'playbook/claude-overrides/07-launch.claude.md': `# Phase 07: Launch & Operations — Claude Override Rules

## Phase Context

This phase covers production deployment, operational readiness, monitoring, incident response, and ongoing maintenance of the Go API gateway. Every action in this phase has direct production impact.

---

## DO ✅

### Deployment & Release

- DO use blue-green or canary deployments for the gateway binary on ECS/Kubernetes
- DO verify the gateway binary was built with \`-ldflags\` embedding version, commit SHA, and build time
- DO confirm graceful shutdown is implemented with \`signal.NotifyContext\` for SIGTERM/SIGINT
- DO ensure the gateway drains in-flight requests before shutting down (30s timeout minimum)
- DO validate Helm chart values for production: replica count ≥ 3, resource limits set, PDB configured
- DO confirm the Docker image is built FROM \`gcr.io/distroless/static-debian12\` or equivalent minimal base
- DO verify health check endpoints (\`/healthz\`, \`/readyz\`) are registered on the Chi router and return proper status
- DO ensure \`/readyz\` checks downstream dependencies: PostgreSQL connectivity, Redis connectivity, upstream service reachability
- DO use Terraform to provision and validate all AWS infrastructure (ECS, ALB, ElastiCache, RDS) before deploy
- DO tag every production release with semantic versioning: \`v1.2.3\`

### Observability & Monitoring

- DO verify OpenTelemetry trace exporter is configured for production Jaeger/OTLP endpoint
- DO confirm Prometheus metrics endpoint (\`/metrics\`) is exposed on a separate port (not the public gateway port)
- DO set up alerts for: p99 latency > 100ms, error rate > 1%, circuit breaker open events, rate limit exhaustion spikes
- DO configure slog with JSON output, \`slog.LevelInfo\` minimum, and ensure request_id and trace_id are in every log line
- DO create Grafana dashboards for: requests per second by route, latency histograms, upstream health, rate limit counters, JWT validation failures
- DO verify distributed tracing spans cover the full request lifecycle: middleware → handler → service → repository → upstream
- DO set up CloudWatch log groups with 30-day retention for production gateway logs
- DO monitor Redis memory usage and connection pool stats for rate limiting health
- DO monitor PostgreSQL connection pool utilization via \`pgxpool\` stats

### Runbooks & Incident Response

- DO write runbooks for: gateway restart procedure, rate limit override for specific clients, circuit breaker manual reset, JWT key rotation, Redis failover, upstream service degradation
- DO include \`go tool pprof\` instructions in runbooks for diagnosing CPU/memory issues in production
- DO document how to enable debug logging temporarily via config reload or environment variable
- DO ensure on-call rotation is documented with escalation paths
- DO include rollback procedures: revert Helm release, revert ECS task definition, feature flag disable

### Security & Compliance (SOC 2)

- DO verify TLS termination is configured at the ALB level with TLS 1.2+ minimum
- DO confirm API keys are stored hashed (bcrypt/argon2) in PostgreSQL, never in plaintext
- DO ensure JWT RS256 public keys are loaded from a secure source (AWS Secrets Manager or mounted volume), not hardcoded
- DO verify all sensitive configuration (database passwords, Redis auth, JWT private keys) comes from environment variables or AWS Secrets Manager
- DO confirm audit logging captures: authentication events, authorization failures, rate limit triggers, configuration changes
- DO validate that \`.env*\`, \`*.pem\`, and \`config/production/*\` are in \`.gitignore\` and never committed
- DO ensure the gateway returns generic error messages to clients (no stack traces, no internal paths)
- DO run \`gosec\` and \`govulncheck\` as final pre-deploy checks
- DO document SOC 2 evidence: access controls, change management (PR approvals), audit logs, encryption in transit/at rest

### Performance & Reliability

- DO run load tests with \`scripts/load_test.sh\` against staging before promoting to production
- DO verify connection pooling is configured: \`pgxpool\` for PostgreSQL (max 25 conns), Redis pool (max 50 conns)
- DO confirm rate limiting uses Redis sliding window algorithm and handles Redis unavailability gracefully (fail-open or fail-closed per policy)
- DO verify circuit breaker thresholds are tuned: 5 consecutive failures to open, 30s half-open retry interval
- DO benchmark critical middleware chain latency overhead (target: < 1ms added per request)
- DO set appropriate \`GOMAXPROCS\` based on container CPU limits (use \`automaxprocs\` library)
- DO configure HTTP client timeouts for all upstream calls: connect 5s, read 10s, total 30s

### Go-Specific Production Checks

- DO build with \`CGO_ENABLED=0 GOOS=linux GOARCH=amd64 go build -o bin/gateway cmd/gateway/main.go\`
- DO verify \`go.sum\` is committed and \`go mod verify\` passes in CI
- DO confirm no \`replace\` directives exist in \`go.mod\` for production builds
- DO ensure all goroutines have proper lifecycle management (context cancellation, errgroup)
- DO verify no goroutine leaks using \`goleak\` in integration tests

---

## DON'T ❌

### Deployment Anti-Patterns

- DON'T deploy directly to production without staging validation — always promote through environments
- DON'T use \`latest\` tag for Docker images — always use the specific commit SHA or semver tag
- DON'T skip the graceful shutdown implementation — abrupt termination drops in-flight requests
- DON'T run the gateway as root in the container — use a non-root user in the Dockerfile
- DON'T deploy without resource limits (CPU/memory) on Kubernetes pods or ECS tasks
- DON'T use \`go run\` in production — always use a compiled binary
- DON'T deploy on Fridays or outside team overlap hours (Americas timezone)

### Observability Anti-Patterns

- DON'T expose the \`/metrics\` Prometheus endpoint on the public gateway port — use a separate admin port
- DON'T log request/response bodies in production — they may contain PII or auth tokens
- DON'T use \`fmt.Println\` or \`log.Printf\` — all logging must go through \`slog\` with structured fields
- DON'T log JWT tokens, API keys, passwords, or any secrets at any log level
- DON'T set log level to DEBUG in production unless actively debugging (and revert immediately after)
- DON'T create high-cardinality Prometheus labels (e.g., user_id, request_id as label values)
- DON'T skip trace context propagation — ensure \`traceparent\` header is forwarded to upstream services

### Security Anti-Patterns

- DON'T store secrets in Helm values files, ConfigMaps, or environment variable defaults in code
- DON'T disable TLS verification for upstream HTTPS calls, even in staging
- DON'T return internal error details (stack traces, SQL errors, file paths) in HTTP responses to clients
- DON'T use symmetric JWT signing (HS256) — use RS256 with key rotation capability
- DON'T skip API key rotation procedures — document and automate rotation with zero downtime
- DON'T allow the gateway to serve traffic before \`/readyz\` returns healthy
- DON'T hardcode CORS allowed origins — load from configuration per environment
- DON'T ignore \`gosec\` or \`govulncheck\` findings — address or explicitly document accepted risks

### Performance Anti-Patterns

- DON'T use unbounded goroutines for upstream fan-out — use semaphores or worker pools
- DON'T skip connection pooling for PostgreSQL or Redis — creating connections per request will kill throughput
- DON'T use \`sync.Mutex\` where \`sync.RWMutex\` or atomic operations suffice in hot paths
- DON'T allocate in the request hot path unnecessarily — use \`sync.Pool\` for frequently allocated objects
- DON'T set infinite timeouts on HTTP clients for upstream calls — always set connect, read, and total timeouts
- DON'T ignore Redis latency — if rate limiting adds > 2ms p99, investigate connection pooling or pipeline batching
- DON'T skip \`pprof\` endpoint registration on the admin port — it's essential for production debugging

### Operational Anti-Patterns

- DON'T make configuration changes directly in production infrastructure — all changes through Terraform/Helm via PR
- DON'T SSH into production containers to debug — use logs, traces, metrics, and pprof endpoints
- DON'T skip post-deployment smoke tests — verify critical routes return expected status codes
- DON'T ignore circuit breaker open events — they indicate upstream degradation requiring investigation
- DON'T let rate limit Redis keys accumulate without TTL — ensure all keys have expiration set
- DON'T run database migrations during deployment — run them as a separate, pre-deploy step
- DON'T skip the go-live checklist in \`playbook/prompts/07/go-live-checklist.md\` — it exists for a reason

### Code & Process Anti-Patterns

- DON'T merge hotfixes without PR review — even urgent fixes need at least 1 approval per CODEOWNERS
- DON'T skip updating runbooks when operational procedures change
- DON'T leave TODO comments in production code paths — either fix them or create GitHub Issues
- DON'T use \`panic()\` in handler or middleware code — return proper HTTP error responses
- DON'T use \`init()\` functions — explicit initialization in \`main()\` or constructor functions only

---

## Production Readiness Checklist Reference

Before marking this phase complete, verify all items in:
- \`playbook/prompts/07/go-live-checklist.md\` — comprehensive go-live validation
- \`playbook/prompts/07/runbook-generator.md\` — operational runbook completeness
- \`playbook/prompts/07/monitoring-setup.md\` — observability stack validation

## Key Files to Validate

| File/Path | Validation |
|---|---|
| \`cmd/gateway/main.go\` | Graceful shutdown, signal handling, dependency wiring |
| \`internal/middleware/\` | All middleware composable, context propagation, no panics |
| \`internal/observability/\` | OTel exporter configured, Prometheus registry, slog setup |
| \`internal/config/\` | Viper loading from env/file, no hardcoded secrets |
| \`deployments/Dockerfile\` | Multi-stage, distroless base, non-root user, CGO_ENABLED=0 |
| \`deployments/helm/\` | Resource limits, PDB, HPA, liveness/readiness probes |
| \`configs/production.yaml\` | No secrets, references env vars or Secrets Manager |
| \`scripts/load_test.sh\` | Targets staging, validates latency and error rate thresholds |
| \`.github/workflows/\` | Full pipeline: lint → test → build → deploy with AI code flag |`,

  'playbook/codeforge-phase.sh': `#!/usr/bin/env bash
#
# codeforge-phase.sh — Phase management for go-api-gateway development methodology
#
# Manages development phases via symlink at .claude/rules/current-phase.md
# Each phase defines Claude's behavior, constraints, and focus areas.
#
# Usage:
#   ./playbook/codeforge-phase.sh [command] [phase]
#
# Commands:
#   status    Show current active phase
#   list      List all available phases
#   set       Set active phase (creates/updates symlink)
#   advance   Move to the next phase in sequence
#   revert    Move to the previous phase in sequence
#   validate  Check phase file integrity and symlink health
#   info      Show detailed info about a specific or current phase
#
# Examples:
#   ./playbook/codeforge-phase.sh status
#   ./playbook/codeforge-phase.sh set 02-blueprint
#   ./playbook/codeforge-phase.sh advance
#   ./playbook/codeforge-phase.sh info 04-build
#

set -euo pipefail

# ─── Configuration ───────────────────────────────────────────────────────────

SCRIPT_DIR="$(cd "$(dirname "\${BASH_SOURCE[0]}")" && pwd)"
PROJECT_ROOT="$(cd "\${SCRIPT_DIR}/.." && pwd)"
PLAYBOOK_DIR="\${PROJECT_ROOT}/playbook"
RULES_DIR="\${PROJECT_ROOT}/.claude/rules"
SYMLINK_PATH="\${RULES_DIR}/current-phase.md"

# Ordered phase definitions for go-api-gateway
# Format: directory-name:display-name:short-description
PHASES=(
  "01-discovery:Discovery:Understand requirements, explore API gateway patterns, gather constraints"
  "02-blueprint:Blueprint:Design architecture, define middleware chain, plan Clean Architecture layers"
  "03-plan:Plan:Break work into tasks, define handler/service/repository boundaries"
  "04-build:Build:Implement code following TDD, Chi middleware patterns, structured logging"
  "05-verify:Verify:Run tests, lint, vet, race detection, check coverage thresholds"
  "06-review:Review:Code review against Go conventions, security audit, performance check"
  "07-document:Document:Write doc comments, update API docs, architecture diagrams, runbooks"
  "08-integrate:Integrate:Integration testing, Docker build, deploy to staging, smoke tests"
)

# ─── Colors and Formatting ───────────────────────────────────────────────────

RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
BLUE='\\033[0;34m'
CYAN='\\033[0;36m'
BOLD='\\033[1m'
DIM='\\033[2m'
RESET='\\033[0m'

# Disable colors if not a terminal
if [[ ! -t 1 ]]; then
  RED='' GREEN='' YELLOW='' BLUE='' CYAN='' BOLD='' DIM='' RESET=''
fi

# ─── Helper Functions ────────────────────────────────────────────────────────

log_info() {
  echo -e "\${BLUE}ℹ\${RESET} $*"
}

log_success() {
  echo -e "\${GREEN}✓\${RESET} $*"
}

log_warn() {
  echo -e "\${YELLOW}⚠\${RESET} $*"
}

log_error() {
  echo -e "\${RED}✗\${RESET} $*" >&2
}

# Extract field from phase entry
phase_dir() {
  echo "$1" | cut -d: -f1
}

phase_name() {
  echo "$1" | cut -d: -f2
}

phase_desc() {
  echo "$1" | cut -d: -f3-
}

# Get the index of a phase by directory name prefix or full name
find_phase_index() {
  local query="$1"
  for i in "\${!PHASES[@]}"; do
    local dir
    dir="$(phase_dir "\${PHASES[$i]}")"
    if [[ "\${dir}" == "\${query}" ]] || [[ "\${dir}" == *"\${query}"* ]]; then
      echo "$i"
      return 0
    fi
  done
  return 1
}

# Get current phase directory name from symlink
get_current_phase_dir() {
  if [[ ! -L "\${SYMLINK_PATH}" ]]; then
    return 1
  fi

  local target
  target="$(readlink "\${SYMLINK_PATH}")"

  # Extract phase directory from the symlink target path
  # Symlink points to ../../playbook/<phase-dir>/phase.md or similar
  local phase_dir_name
  phase_dir_name="$(basename "$(dirname "\${target}")")"

  # Validate it's a known phase
  if find_phase_index "\${phase_dir_name}" >/dev/null 2>&1; then
    echo "\${phase_dir_name}"
    return 0
  fi

  return 1
}

# Get current phase index
get_current_phase_index() {
  local current_dir
  current_dir="$(get_current_phase_dir)" || return 1
  find_phase_index "\${current_dir}"
}

# Resolve a phase file path
get_phase_file() {
  local dir="$1"
  local phase_file="\${PLAYBOOK_DIR}/\${dir}/phase.md"
  if [[ -f "\${phase_file}" ]]; then
    echo "\${phase_file}"
    return 0
  fi
  return 1
}

# Create or update the symlink
set_symlink() {
  local phase_dir="$1"
  local phase_file
  phase_file="$(get_phase_file "\${phase_dir}")" || {
    log_error "Phase file not found: \${PLAYBOOK_DIR}/\${phase_dir}/phase.md"
    log_info "Create it first or run: \${BOLD}./playbook/codeforge-phase.sh validate\${RESET}"
    return 1
  }

  # Ensure rules directory exists
  mkdir -p "\${RULES_DIR}"

  # Compute relative path from rules dir to phase file
  local relative_path
  relative_path="$(python3 -c "import os.path; print(os.path.relpath('\${phase_file}', '\${RULES_DIR}'))" 2>/dev/null || \\
    perl -e "use File::Spec; print File::Spec->abs2rel('\${phase_file}', '\${RULES_DIR}')" 2>/dev/null || \\
    echo "../../playbook/\${phase_dir}/phase.md")"

  # Remove existing symlink or file
  if [[ -L "\${SYMLINK_PATH}" ]] || [[ -e "\${SYMLINK_PATH}" ]]; then
    rm -f "\${SYMLINK_PATH}"
  fi

  ln -s "\${relative_path}" "\${SYMLINK_PATH}"
}

# ─── Commands ────────────────────────────────────────────────────────────────

cmd_status() {
  echo -e "\${BOLD}go-api-gateway — Phase Status\${RESET}"
  echo ""

  if [[ ! -L "\${SYMLINK_PATH}" ]]; then
    if [[ -e "\${SYMLINK_PATH}" ]]; then
      log_warn "current-phase.md exists but is not a symlink"
      log_info "Run \${BOLD}./playbook/codeforge-phase.sh set <phase>\${RESET} to fix"
    else
      log_warn "No active phase set"
      log_info "Run \${BOLD}./playbook/codeforge-phase.sh set 01-discovery\${RESET} to start"
    fi
    return 1
  fi

  local current_dir current_index
  current_dir="$(get_current_phase_dir)" || {
    log_error "Symlink target is not a recognized phase"
    return 1
  }
  current_index="$(find_phase_index "\${current_dir}")"

  local entry="\${PHASES[$current_index]}"
  local name desc
  name="$(phase_name "\${entry}")"
  desc="$(phase_desc "\${entry}")"

  echo -e "  \${GREEN}●\${RESET} Active Phase: \${BOLD}\${name}\${RESET} \${DIM}(\${current_dir})\${RESET}"
  echo -e "  \${DIM}\${desc}\${RESET}"
  echo ""

  # Show position in sequence
  local total=\${#PHASES[@]}
  local position=$((current_index + 1))
  echo -e "  Progress: \${CYAN}\${position}\${RESET} / \${total}"

  # Progress bar
  local bar_width=40
  local filled=$(( (position * bar_width) / total ))
  local empty=$(( bar_width - filled ))
  printf "  ["
  printf "\${GREEN}%0.s█\${RESET}" $(seq 1 \${filled})
  if [[ \${empty} -gt 0 ]]; then
    printf "\${DIM}%0.s░\${RESET}" $(seq 1 \${empty})
  fi
  printf "]\\n"
  echo ""

  # Symlink details
  local target
  target="$(readlink "\${SYMLINK_PATH}")"
  echo -e "  \${DIM}Symlink: .claude/rules/current-phase.md → \${target}\${RESET}"
}

cmd_list() {
  echo -e "\${BOLD}go-api-gateway — Available Phases\${RESET}"
  echo ""

  local current_dir=""
  current_dir="$(get_current_phase_dir 2>/dev/null)" || true

  for i in "\${!PHASES[@]}"; do
    local entry="\${PHASES[$i]}"
    local dir name desc
    dir="$(phase_dir "\${entry}")"
    name="$(phase_name "\${entry}")"
    desc="$(phase_desc "\${entry}")"

    local marker="  "
    local color="\${RESET}"
    if [[ "\${dir}" == "\${current_dir}" ]]; then
      marker="\${GREEN}▶ \${RESET}"
      color="\${BOLD}"
    fi

    local file_status="\${GREEN}✓\${RESET}"
    if ! get_phase_file "\${dir}" >/dev/null 2>&1; then
      file_status="\${RED}✗\${RESET}"
    fi

    echo -e "\${marker}\${file_status} \${color}\${dir}\${RESET}  \${name} — \${DIM}\${desc}\${RESET}"
  done

  echo ""
  echo -e "\${DIM}▶ = active    ✓ = phase.md exists    ✗ = phase.md missing\${RESET}"
}

cmd_set() {
  local target_query="\${1:-}"

  if [[ -z "\${target_query}" ]]; then
    log_error "Phase name required"
    echo ""
    echo "Usage: $0 set <phase>"
    echo "Example: $0 set 02-blueprint"
    echo ""
    cmd_list
    return 1
  fi

  local target_index
  target_index="$(find_phase_index "\${target_query}")" || {
    log_error "Unknown phase: \${target_query}"
    echo ""
    echo "Available phases:"
    cmd_list
    return 1
  }

  local entry="\${PHASES[$target_index]}"
  local dir name desc
  dir="$(phase_dir "\${entry}")"
  name="$(phase_name "\${entry}")"
  desc="$(phase_desc "\${entry}")"

  # Check if already on this phase
  local current_dir=""
  current_dir="$(get_current_phase_dir 2>/dev/null)" || true
  if [[ "\${dir}" == "\${current_dir}" ]]; then
    log_info "Already on phase \${BOLD}\${name}\${RESET} (\${dir})"
    return 0
  fi

  # Show transition
  if [[ -n "\${current_dir}" ]]; then
    local current_index
    current_index="$(find_phase_index "\${current_dir}")"
    local current_name
    current_name="$(phase_name "\${PHASES[$current_index]}")"
    log_info "Transitioning: \${YELLOW}\${current_name}\${RESET} → \${GREEN}\${name}\${RESET}"
  fi

  set_symlink "\${dir}" || return 1

  log_success "Phase set to \${BOLD}\${name}\${RESET} (\${dir})"
  echo -e "  \${DIM}\${desc}\${RESET}"
  echo ""

  # Phase-specific hints for go-api-gateway
  case "\${dir}" in
    01-discovery)
      echo -e "  \${CYAN}Hints:\${RESET}"
      echo "  • Review API gateway requirements and traffic patterns"
      echo "  • Identify upstream services and their SLAs"
      echo "  • Document rate limiting and auth requirements"
      echo "  • Check SOC 2 compliance constraints"
      ;;
    02-blueprint)
      echo -e "  \${CYAN}Hints:\${RESET}"
      echo "  • Design Chi middleware chain ordering"
      echo "  • Define Clean Architecture layer boundaries"
      echo "  • Plan Redis schema for rate limiting (sliding window)"
      echo "  • Design JWT validation and RBAC model"
      ;;
    03-plan)
      echo -e "  \${CYAN}Hints:\${RESET}"
      echo "  • Create GitHub Issues for each component"
      echo "  • Use branch naming: feat/GW-<num>-<desc>"
      echo "  • Define handler → service → repository interfaces"
      echo "  • Plan table-driven test cases"
      ;;
    04-build)
      echo -e "  \${CYAN}Hints:\${RESET}"
      echo "  • Write tests first (TDD), then implement"
      echo "  • Use httptest for handler testing"
      echo "  • Propagate context through all layers"
      echo "  • Wrap errors with fmt.Errorf and %w"
      echo "  • Keep files under 300 lines"
      ;;
    05-verify)
      echo -e "  \${CYAN}Hints:\${RESET}"
      echo "  • go test ./... -race -coverprofile=coverage.out"
      echo "  • golangci-lint run ./..."
      echo "  • go vet ./..."
      echo "  • Ensure coverage ≥ 80%"
      echo "  • Run gosec for security scanning"
      ;;
    06-review)
      echo -e "  \${CYAN}Hints:\${RESET}"
      echo "  • Check Effective Go compliance"
      echo "  • Verify all exported functions have doc comments"
      echo "  • Review middleware composability"
      echo "  • Audit auth paths: internal/auth/**"
      echo "  • Check for OWASP API Security Top 10 issues"
      ;;
    07-document)
      echo -e "  \${CYAN}Hints:\${RESET}"
      echo "  • Update docs/ARCHITECTURE.md with changes"
      echo "  • Add godoc comments to all exported types"
      echo "  • Write runbooks for operational scenarios"
      echo "  • Document config options in configs/ YAML files"
      ;;
    08-integrate)
      echo -e "  \${CYAN}Hints:\${RESET}"
      echo "  • Run integration tests against PostgreSQL and Redis"
      echo "  • Build: go build -o bin/gateway cmd/gateway/main.go"
      echo "  • Docker: docker build -f deployments/Dockerfile ."
      echo "  • Deploy to staging via GitHub Actions"
      echo "  • Run load tests from scripts/"
      ;;
  esac
}

cmd_advance() {
  local current_index
  current_index="$(get_current_phase_index)" || {
    log_error "No active phase. Set one first:"
    echo "  $0 set 01-discovery"
    return 1
  }

  local next_index=$((current_index + 1))
  if [[ \${next_index} -ge \${#PHASES[@]} ]]; then
    local current_name
    current_name="$(phase_name "\${PHASES[$current_index]}")"
    log_warn "Already on the final phase: \${BOLD}\${current_name}\${RESET}"
    log_info "Consider cycling back to 01-discovery for the next iteration"
    return 0
  fi

  local next_dir
  next_dir="$(phase_dir "\${PHASES[$next_index]}")"
  cmd_set "\${next_dir}"
}

cmd_revert() {
  local current_index
  current_index="$(get_current_phase_index)" || {
    log_error "No active phase. Set one first:"
    echo "  $0 set 01-discovery"
    return 1
  }

  local prev_index=$((current_index - 1))
  if [[ \${prev_index} -lt 0 ]]; then
    local current_name
    current_name="$(phase_name "\${PHASES[$current_index]}")"
    log_warn "Already on the first phase: \${BOLD}\${current_name}\${RESET}"
    return 0
  fi

  local prev_dir
  prev_dir="$(phase_dir "\${PHASES[$prev_index]}")"
  cmd_set "\${prev_dir}"
}

cmd_validate() {
  echo -e "\${BOLD}go-api-gateway — Phase Validation\${RESET}"
  echo ""

  local errors=0
  local warnings=0

  # Check playbook directory
  if [[ ! -d "\${PLAYBOOK_DIR}" ]]; then
    log_error "Playbook directory missing: \${PLAYBOOK_DIR}"
    ((errors++))
  else
    log_success "Playbook directory exists"
  fi

  # Check rules directory
  if [[ ! -d "\${RULES_DIR}" ]]; then
    log_warn "Rules directory missing: \${RULES_DIR} (will be created on first set)"
    ((warnings++))
  else
    log_success "Rules directory exists"
  fi

  # Check each phase file
  echo ""
  echo -e "\${BOLD}Phase Files:\${RESET}"
  for entry in "\${PHASES[@]}"; do
    local dir name
    dir="$(phase_dir "\${entry}")"
    name="$(phase_name "\${entry}")"

    local phase_dir_path="\${PLAYBOOK_DIR}/\${dir}"
    local phase_file_path="\${phase_dir_path}/phase.md"

    if [[ ! -d "\${phase_dir_path}" ]]; then
      log_error "  Missing directory: playbook/\${dir}/"
      ((errors++))
    elif [[ ! -f "\${phase_file_path}" ]]; then
      log_error "  Missing file: playbook/\${dir}/phase.md"
      ((errors++))
    else
      # Check file is non-empty and has a title
      local line_count
      line_count="$(wc -l < "\${phase_file_path}" | tr -d ' ')"
      if [[ \${line_count} -lt 5 ]]; then
        log_warn "  playbook/\${dir}/phase.md seems sparse (\${line_count} lines)"
        ((warnings++))
      else
        log_success "  playbook/\${dir}/phase.md \${DIM}(\${line_count} lines)\${RESET}"
      fi
    fi
  done

  # Check symlink
  echo ""
  echo -e "\${BOLD}Symlink:\${RESET}"
  if [[ -L "\${SYMLINK_PATH}" ]]; then
    local target
    target="$(readlink "\${SYMLINK_PATH}")"
    if [[ -e "\${SYMLINK_PATH}" ]]; then
      log_success "Symlink valid: current-phase.md → \${target}"
    else
      log_error "Symlink broken: current-phase.md → \${target} (target does not exist)"
      ((errors++))
    fi
  elif [[ -e "\${SYMLINK_PATH}" ]]; then
    log_error "current-phase.md exists but is a regular file, not a symlink"
    ((errors++))
  else
    log_warn "No symlink set (run: $0 set 01-discovery)"
    ((warnings++))
  fi

  # Check .gitignore doesn't exclude the symlink
  local gitignore="\${PROJECT_ROOT}/.gitignore"
  if [[ -f "\${gitignore}" ]] && grep -q "current-phase.md" "\${gitignore}"; then
    log_warn ".gitignore excludes current-phase.md — phase won't be tracked in git"
    ((warnings++))
  fi

  # Summary
  echo ""
  if [[ \${errors} -eq 0 ]] && [[ \${warnings} -eq 0 ]]; then
    log_success "All checks passed"
  else
    [[ \${errors} -gt 0 ]] && log_error "\${errors} error(s) found"
    [[ \${warnings} -gt 0 ]] && log_warn "\${warnings} warning(s) found"
  fi

  return \${errors}
}

cmd_info() {
  local target_query="\${1:-}"
  local target_dir

  if [[ -z "\${target_query}" ]]; then
    target_dir="$(get_current_phase_dir)" || {
      log_error "No active phase and no phase specified"
      echo "Usage: $0 info [phase]"
      return 1
    }
  else
    local idx
    idx="$(find_phase_index "\${target_query}")" || {
      log_error "Unknown phase: \${target_query}"
      return 1
    }
    target_dir="$(phase_dir "\${PHASES[$idx]}")"
  fi

  local phase_file="\${PLAYBOOK_DIR}/\${target_dir}/phase.md"
  if [[ ! -f "\${phase_file}" ]]; then
    log_error "Phase file not found: \${phase_file}"
    return 1
  fi

  local idx
  idx="$(find_phase_index "\${target_dir}")"
  local entry="\${PHASES[$idx]}"
  local name desc
  name="$(phase_name "\${entry}")"
  desc="$(phase_desc "\${entry}")"

  echo -e "\${BOLD}Phase: \${name}\${RESET} \${DIM}(\${target_dir})\${RESET}"
  echo -e "\${DIM}\${desc}\${RESET}"
  echo -e "\${DIM}$(printf '%.0s─' {1..60})\${RESET}"
  echo ""
  cat "\${phase_file}"
}

cmd_help() {
  echo -e "\${BOLD}codeforge-phase.sh\${RESET} — Phase management for go-api-gateway"
  echo ""
  echo -e "\${BOLD}USAGE\${RESET}"
  echo "  ./playbook/codeforge-phase.sh <command> [args]"
  echo ""
  echo -e "\${BOLD}COMMANDS\${RESET}"
  echo "  status              Show current active phase"
  echo "  list                List all available phases"
  echo "  set <phase>         Set active phase (e.g., 02-blueprint)"
  echo "  advance             Move to the next phase"
  echo "  revert              Move to the previous phase"
  echo "  validate            Check phase file integrity"
  echo "  info [phase]        Show phase details (default: current)"
  echo "  help                Show this help message"
  echo ""
  echo -e "\${BOLD}PHASES\${RESET}"
  for entry in "\${PHASES[@]}"; do
    local dir name
    dir="$(phase_dir "\${entry}")"
    name="$(phase_name "\${entry}")"
    printf "  %-18s %s\\n" "\${dir}" "\${name}"
  done
  echo ""
  echo -e "\${BOLD}EXAMPLES\${RESET}"
  echo "  $0 set 01-discovery       # Start with discovery"
  echo "  $0 advance                # Move to next phase"
  echo "  $0 set build              # Fuzzy match to 04-build"
  echo "  $0 info 05-verify         # Show verify phase details"
  echo ""
  echo -e "\${BOLD}HOW IT WORKS\${RESET}"
  echo "  Manages a symlink at .claude/rules/current-phase.md that points"
  echo "  to the active phase definition in playbook/<phase>/phase.md."
  echo "  Claude reads this symlink to understand current development context,"
  echo "  constraints, and expected behaviors for the go-api-gateway project."
}

# ─── Main ────────────────────────────────────────────────────────────────────

main() {
  local command="\${1:-help}"
  shift || true

  case "\${command}" in
    status)   cmd_status "$@" ;;
    list|ls)  cmd_list "$@" ;;
    set)      cmd_set "$@" ;;
    advance|next) cmd_advance "$@" ;;
    revert|prev)  cmd_revert "$@" ;;
    validate|check) cmd_validate "$@" ;;
    info|show) cmd_info "$@" ;;
    help|--help|-h) cmd_help "$@" ;;
    *)
      log_error "Unknown command: \${command}"
      echo ""
      cmd_help
      exit 1
      ;;
  esac
}

main "$@"`,

  'playbook/current-phase.json': `{
  "currentPhase": 1,
  "phaseId": "foundation",
  "startedAt": null,
  "updatedAt": null
}`,

  'playbook/phases/01-discovery.md': `# Phase 01: Discovery & Requirements

## Overview

The Discovery phase establishes the foundation for the Go API Gateway project. This phase focuses on understanding the traffic patterns, downstream service landscape, security requirements, and operational constraints before writing any production code. Every decision made here directly impacts the architecture defined in Phase 02.

**Duration**: 3–5 days  
**Phase Owner**: Tech Lead  
**Participants**: All backend developers, DevOps, downstream service owners  
**Prerequisites**: Access to existing service topology, traffic metrics, and SOC 2 compliance requirements

---

## Objectives

### 1. Define Gateway Scope and Boundaries

- Identify which downstream services the gateway will proxy (service registry)
- Determine which cross-cutting concerns the gateway owns vs. what stays in services
- Establish the boundary between gateway responsibilities and service mesh responsibilities
- Decide on protocol support: HTTP/1.1, HTTP/2, gRPC passthrough, WebSocket

### 2. Capture Traffic and Performance Requirements

- Document expected requests per second (RPS) at P50, P95, P99
- Define latency budgets: maximum added latency the gateway may introduce (target: <5ms P99 overhead)
- Identify peak traffic patterns (time-of-day, seasonal, event-driven)
- Determine maximum concurrent connections and connection pooling requirements
- Establish throughput targets for \`go test -bench\` baseline benchmarks

### 3. Map Authentication and Authorization Flows

- Document all authentication methods: JWT (RS256), API keys, OAuth2 passthrough
- Define RBAC model: roles, permissions, resource-level access control
- Identify JWT issuer(s) and JWKS endpoint(s) for key rotation
- Map API key lifecycle: creation, rotation, revocation, metadata storage in PostgreSQL
- Document OAuth2 scopes and token introspection requirements
- Review SOC 2 requirements for access logging and audit trails

### 4. Define Rate Limiting Strategy

- Identify rate limiting dimensions: per-client, per-API-key, per-endpoint, per-IP
- Define rate limit tiers (free, standard, premium) and their quotas
- Choose algorithm: sliding window (Redis-backed) vs. token bucket
- Determine burst allowance and quota reset behavior
- Document rate limit header conventions (\`X-RateLimit-Limit\`, \`X-RateLimit-Remaining\`, \`X-RateLimit-Reset\`)

### 5. Establish Observability Requirements

- Define SLIs and SLOs for the gateway (availability, latency, error rate)
- Identify required Prometheus metrics: request count, latency histogram, error rate by status code, active connections, circuit breaker state
- Define distributed tracing requirements: trace context propagation, span naming, sampling rate
- Establish structured logging fields: \`request_id\`, \`client_id\`, \`method\`, \`path\`, \`status\`, \`duration_ms\`, \`trace_id\`
- Determine alerting thresholds for PagerDuty/Slack integration

### 6. Document Operational Constraints

- Define deployment targets: AWS ECS behind ALB, Kubernetes via Helm
- Identify Redis topology: AWS ElastiCache cluster mode, failover behavior
- Identify PostgreSQL requirements: RDS instance class, connection limits, read replicas
- Document TLS termination strategy (ALB vs. gateway-level)
- Define graceful shutdown requirements: drain timeout, in-flight request handling
- Establish health check contracts: \`/healthz\` (liveness), \`/readyz\` (readiness)

---

## Deliverables

### D1: Service Routing Map

A document or diagram listing every downstream service, its base URL, health check endpoint, expected latency, and the route prefix the gateway will expose.

\`\`\`yaml
# Example: configs/routes.yaml (draft)
routes:
  - prefix: /api/v1/users
    upstream: http://user-service:8080
    timeout: 5s
    retry: 2
    circuit_breaker: enabled
  - prefix: /api/v1/orders
    upstream: http://order-service:8080
    timeout: 10s
    retry: 1
    circuit_breaker: enabled
  - prefix: /api/v1/payments
    upstream: http://payment-service:8080
    timeout: 15s
    retry: 0
    circuit_breaker: enabled
    auth: required
    rate_limit: strict
\`\`\`

**Location**: \`docs/service-routing-map.md\`  
**Format**: Markdown table + YAML draft config  
**Owner**: Tech Lead

### D2: Authentication & Authorization Specification

Detailed specification of every auth flow the gateway must support, including JWT claim structure, RBAC permission matrix, API key format, and OAuth2 passthrough behavior.

Must include:
- JWT payload schema with required claims (\`sub\`, \`iss\`, \`exp\`, \`roles\`, \`permissions\`)
- JWKS endpoint configuration and key rotation strategy
- API key format, storage schema in PostgreSQL (\`internal/repository/\`)
- Permission matrix mapping roles to endpoint access
- SOC 2 audit logging requirements for auth events

**Location**: \`docs/auth-specification.md\`  
**Format**: Markdown with JSON schema examples  
**Owner**: Senior Developer

### D3: Rate Limiting Configuration Spec

Document defining rate limit tiers, algorithms, Redis key structure, and behavior on Redis failure (fail-open vs. fail-closed).

Must include:
- Tier definitions with requests/second and requests/minute quotas
- Redis key naming convention: \`ratelimit:{client_id}:{endpoint}:{window}\`
- Sliding window algorithm pseudocode
- Degradation strategy when Redis is unavailable
- Response format for 429 Too Many Requests

**Location**: \`docs/rate-limiting-spec.md\`  
**Format**: Markdown  
**Owner**: Senior Developer

### D4: Performance Budget

Quantified performance targets that will drive architecture decisions and benchmark tests.

| Metric | Target | Measurement |
|---|---|---|
| Gateway overhead (P50) | <2ms | \`go test -bench\` on middleware chain |
| Gateway overhead (P99) | <5ms | Load test with \`k6\` or \`vegeta\` |
| Throughput | >10,000 RPS per instance | Load test on c5.xlarge equivalent |
| Memory per connection | <10KB | \`pprof\` heap analysis |
| Startup time | <3s | Time to first \`/readyz\` 200 |
| Graceful shutdown drain | 30s max | Integration test |
| JWT validation | <500µs P99 | \`go test -bench\` on \`internal/auth/\` |
| Redis round-trip (rate limit) | <1ms P99 | Benchmark against ElastiCache |

**Location**: \`docs/performance-budget.md\`  
**Format**: Markdown table  
**Owner**: Tech Lead

### D5: Observability Contract

Specification of all metrics, traces, and log fields the gateway will emit.

Must include:
- Prometheus metric names, types, and labels (following \`gateway_\` prefix convention)
- OpenTelemetry span structure and attribute naming
- slog field catalog with types and when each field is emitted
- Dashboard requirements for Grafana
- Jaeger trace query patterns for debugging
- Alert definitions with severity levels

**Location**: \`docs/observability-contract.md\`  
**Format**: Markdown  
**Owner**: Senior Developer

### D6: Compliance Checklist

SOC 2 requirements mapped to gateway implementation tasks.

| SOC 2 Control | Gateway Requirement | Implementation |
|---|---|---|
| CC6.1 - Logical Access | JWT validation on all protected routes | \`internal/auth/jwt.go\` |
| CC6.1 - Logical Access | API key verification with expiry | \`internal/auth/apikey.go\` |
| CC6.3 - Access Removal | API key revocation, JWT expiry enforcement | \`internal/repository/apikey.go\` |
| CC7.2 - Monitoring | Structured audit logs for all auth events | \`internal/middleware/audit.go\` |
| CC7.2 - Monitoring | Request/response logging (no PII) | \`internal/middleware/logging.go\` |
| CC8.1 - Change Management | All changes via PR with review | \`.github/CODEOWNERS\` |
| A1.2 - Availability | Health checks, circuit breakers, graceful shutdown | \`internal/handler/health.go\` |

**Location**: \`docs/compliance-checklist.md\`  
**Format**: Markdown table  
**Owner**: Tech Lead

### D7: GitHub Issues Backlog (Draft)

Initial set of GitHub Issues created from discovery findings, labeled and estimated. These will be refined in Phase 02 (Architecture) and Phase 03 (Planning).

Minimum issues to create:
- [ ] \`feat: JWT authentication middleware\`
- [ ] \`feat: API key authentication middleware\`
- [ ] \`feat: Redis-backed sliding window rate limiter\`
- [ ] \`feat: Circuit breaker for upstream services\`
- [ ] \`feat: Request routing with Chi\`
- [ ] \`feat: Prometheus metrics middleware\`
- [ ] \`feat: OpenTelemetry tracing middleware\`
- [ ] \`feat: Structured logging middleware (slog)\`
- [ ] \`feat: Health check endpoints (/healthz, /readyz)\`
- [ ] \`feat: Graceful shutdown with connection draining\`
- [ ] \`feat: CORS middleware\`
- [ ] \`feat: Request ID propagation middleware\`
- [ ] \`chore: Docker build and Kubernetes manifests\`
- [ ] \`chore: CI/CD pipeline (GitHub Actions)\`
- [ ] \`docs: API documentation and runbooks\`

**Location**: GitHub Issues  
**Format**: GitHub Issue with labels (\`phase:discovery\`, \`type:feature\`, \`type:chore\`)  
**Owner**: All developers

---

## Activities

### Week 1, Days 1–2: Information Gathering

| Activity | Participants | Output |
|---|---|---|
| Inventory downstream services | Tech Lead, DevOps | Service routing map draft |
| Review existing auth infrastructure | Senior Dev, Tech Lead | Auth flow diagrams |
| Collect traffic metrics from ALB/CloudWatch | DevOps | Traffic baseline data |
| Review SOC 2 audit requirements | Tech Lead | Compliance checklist draft |
| Survey team on Go library preferences | All developers | Dependency shortlist |

### Week 1, Days 3–4: Specification Writing

| Activity | Participants | Output |
|---|---|---|
| Write auth specification | Senior Dev | D2: Auth spec |
| Write rate limiting specification | Senior Dev | D3: Rate limit spec |
| Define performance budget | Tech Lead | D4: Performance budget |
| Define observability contract | Senior Dev | D5: Observability contract |
| Finalize service routing map | Tech Lead, DevOps | D1: Routing map |

### Week 1, Day 5: Review and Sign-Off

| Activity | Participants | Output |
|---|---|---|
| Team review of all deliverables | All developers | Feedback incorporated |
| Create GitHub Issues backlog | All developers | D7: Issues created |
| Phase gate review | Tech Lead | Phase completion decision |

---

## Using Claude in This Phase

Claude can accelerate discovery work. Use the following commands:

### Generate Service Routing Map Draft

\`\`\`
/phase discovery

Analyze the following list of downstream services and generate a service routing map
in the format specified in docs/service-routing-map.md. Include timeout recommendations
based on the service type (read-heavy vs. write-heavy).
\`\`\`

### Draft Auth Specification

\`\`\`
/plan

Create an authentication specification for the gateway covering:
1. JWT RS256 validation with JWKS rotation
2. API key verification with PostgreSQL storage
3. RBAC permission matrix for 3 roles: admin, service, readonly
4. SOC 2 audit logging requirements
Output as docs/auth-specification.md
\`\`\`

### Review Rate Limiting Design

\`\`\`
/code-review

Review this rate limiting specification for:
- Redis key structure efficiency
- Sliding window algorithm correctness
- Fail-open vs fail-closed tradeoffs
- Compliance with SOC 2 CC6.1
\`\`\`

### Validate Performance Budget

\`\`\`
/verify

Check that the performance budget in docs/performance-budget.md is:
- Internally consistent (P50 < P99)
- Achievable with Go/Chi on c5.xlarge
- Measurable with go test -bench and pprof
\`\`\`

---

## Quality Gates

All gates must pass before proceeding to [Phase 02: Architecture](./02-architecture.md).

### Gate 1: Service Inventory Complete

- [ ] All downstream services identified with base URLs
- [ ] Health check endpoints documented for each service
- [ ] Timeout and retry defaults established per service
- [ ] Circuit breaker thresholds proposed per service

### Gate 2: Auth Flows Fully Specified

- [ ] JWT claim schema defined with required and optional fields
- [ ] JWKS endpoint(s) identified and accessible
- [ ] API key format and storage schema defined
- [ ] RBAC permission matrix covers all planned endpoints
- [ ] OAuth2 passthrough behavior documented
- [ ] SOC 2 audit logging requirements mapped to implementation

### Gate 3: Rate Limiting Strategy Defined

- [ ] Rate limit tiers defined with numeric quotas
- [ ] Redis key structure designed and reviewed
- [ ] Algorithm chosen with pseudocode or reference implementation
- [ ] Degradation behavior documented (Redis failure scenario)
- [ ] Rate limit response headers specified

### Gate 4: Performance Budget Established

- [ ] Latency targets defined at P50, P95, P99
- [ ] Throughput target defined (RPS per instance)
- [ ] Memory budget defined per connection
- [ ] Startup time target defined
- [ ] All targets are measurable with \`go test -bench\`, \`pprof\`, or load testing tools

### Gate 5: Observability Contract Complete

- [ ] Prometheus metrics catalog with names, types, and labels
- [ ] OpenTelemetry span naming convention defined
- [ ] slog field catalog with types
- [ ] SLIs and SLOs defined with numeric targets
- [ ] Alert thresholds defined with severity levels

### Gate 6: Compliance Requirements Mapped

- [ ] SOC 2 controls mapped to gateway implementation tasks
- [ ] Sensitive paths identified (\`internal/auth/**\`, \`*.pem\`, \`.env*\`)
- [ ] PII handling rules documented (what must NOT be logged)
- [ ] API key rotation procedure outlined

### Gate 7: Team Alignment

- [ ] All deliverables reviewed by at least 2 team members
- [ ] GitHub Issues backlog created with labels
- [ ] No unresolved blocking questions
- [ ] Phase 02 kickoff date confirmed

---

## Risk Register

| Risk | Likelihood | Impact | Mitigation |
|---|---|---|---|
| Downstream service owners unavailable for discovery | Medium | High | Schedule interviews in first 2 days; use existing docs as fallback |
| Traffic estimates inaccurate | Medium | Medium | Design for 3x estimated peak; validate with load tests in Phase 05 |
| JWT issuer doesn't support JWKS | Low | High | Fall back to static public key config; document rotation procedure |
| Redis latency exceeds budget in ElastiCache | Low | High | Benchmark early in Phase 05; have local cache fallback design ready |
| SOC 2 requirements unclear | Medium | Medium | Engage compliance team early; document assumptions for auditor review |

---

## Phase Completion

When all quality gates pass, update the phase tracker:

\`\`\`bash
./playbook/codeforge-phase.sh set 02-architecture
\`\`\`

This updates \`playbook/current-phase.json\` and signals to all team members and Claude commands that the project has moved to architecture design.

**Next Phase**: [Phase 02: Architecture & Design](./02-architecture.md)`,

  'playbook/phases/02-architecture.md': `# Phase 02: Architecture & Design

## Phase Overview

| Attribute       | Value                                                    |
|-----------------|----------------------------------------------------------|
| **Phase**       | 02 — Architecture & Design                               |
| **Duration**    | 3–5 days                                                 |
| **Predecessor** | [Phase 01: Requirements & Planning](./01-requirements.md)|
| **Successor**   | [Phase 03: Environment Setup](./03-environment.md)       |
| **Owner**       | Tech Lead / Senior Engineer                              |
| **Approvers**   | All backend developers (consensus), Product Owner (sign-off) |

## Objectives

1. **Define the system architecture** for the Go API gateway — component boundaries, data flow, deployment topology, and failure modes.
2. **Establish Clean Architecture layers** — handler → service → repository — with explicit interface contracts between each layer.
3. **Design the middleware pipeline** — ordering, composability, and short-circuit behavior for Chi middleware chains.
4. **Specify data models and storage strategy** — PostgreSQL schema for configuration/API key metadata, Redis key design for rate limiting and caching.
5. **Document cross-cutting concerns** — authentication flow (JWT RS256, API keys, OAuth2 passthrough), rate limiting algorithm, circuit breaker state machine, observability instrumentation.
6. **Identify security boundaries** — TLS termination, OWASP API Security Top 10 mitigations, SOC 2 control mapping.
7. **Produce ADRs** (Architecture Decision Records) for every non-obvious choice.

## Inputs (from Phase 01)

- Prioritized feature list with acceptance criteria
- Non-functional requirements (latency targets, throughput, availability SLA)
- Upstream service inventory (services the gateway will route to)
- Threat model draft
- GitHub Issues for all planned work items

## Deliverables

### D1: System Architecture Diagram

**File**: \`docs/architecture/system-overview.md\`

Document the high-level topology:

\`\`\`
Client → ALB (TLS termination) → ECS / K8s Pod
  └─ go-api-gateway process
       ├─ Chi Router
       │    ├─ Global Middleware Chain
       │    │    ├─ RequestID
       │    │    ├─ RealIP
       │    │    ├─ Recoverer
       │    │    ├─ CORS
       │    │    ├─ OpenTelemetry Trace
       │    │    ├─ Prometheus Metrics
       │    │    ├─ Structured Logging (slog)
       │    │    ├─ Rate Limiter
       │    │    └─ JWT / API Key Auth
       │    └─ Route Groups
       │         ├─ /api/v1/* → upstream services
       │         ├─ /health   → health check handler
       │         └─ /metrics  → Prometheus handler
       ├─ PostgreSQL (config store, API key metadata)
       ├─ Redis (rate limit counters, response cache)
       └─ OpenTelemetry Collector → Jaeger / CloudWatch
\`\`\`

Include:
- Network diagram showing VPC, subnets, security groups
- Data flow for a typical authenticated request (sequence diagram)
- Data flow for a rate-limited/rejected request
- Failure scenarios (Redis down, upstream timeout, PostgreSQL unreachable)

### D2: Clean Architecture Layer Contracts

**File**: \`docs/architecture/layer-contracts.md\`

Define the interface boundaries between layers:

\`\`\`go
// internal/handler — HTTP layer
// Depends on: service interfaces
// Produces: HTTP responses
// Rules: No business logic, no direct DB access, context propagation required

// internal/service — Business logic layer
// Depends on: repository interfaces
// Produces: Domain models, business errors
// Rules: No HTTP awareness, no SQL, testable with mock repositories

// internal/repository — Data access layer
// Depends on: database drivers (pgx, go-redis)
// Produces: Domain models from storage
// Rules: No business logic, query-only, connection pooling managed here

// internal/middleware — Chi middleware
// Depends on: service interfaces (auth, rate limit)
// Rules: Must be composable, must call next.ServeHTTP or short-circuit
\`\`\`

For each layer, specify:
- Exported interfaces (e.g., \`service.Authenticator\`, \`repository.RouteConfigStore\`)
- Error types returned (using \`pkg/errors\` custom types)
- Context values set/read (request ID, authenticated user, trace span)
- Concurrency guarantees

### D3: Middleware Pipeline Design

**File**: \`docs/architecture/middleware-pipeline.md\`

Define the exact ordering and behavior of the Chi middleware chain:

| Order | Middleware          | Package                        | Short-circuits? | Description                                      |
|-------|---------------------|--------------------------------|-----------------|--------------------------------------------------|
| 1     | RequestID           | \`internal/middleware\`          | No              | Generates or extracts \`X-Request-ID\`             |
| 2     | RealIP              | \`chi/middleware\`               | No              | Extracts client IP from \`X-Forwarded-For\`        |
| 3     | Recoverer           | \`internal/middleware\`          | On panic        | Catches panics, logs stack trace, returns 500    |
| 4     | CORS                | \`internal/middleware\`          | On preflight    | Handles CORS preflight, sets headers             |
| 5     | OTelTrace           | \`internal/observability\`       | No              | Starts OpenTelemetry span, injects into context  |
| 6     | PrometheusMetrics   | \`internal/observability\`       | No              | Records request duration, status code, path      |
| 7     | StructuredLogger    | \`internal/middleware\`          | No              | Logs request start/end with slog                 |
| 8     | RateLimiter         | \`internal/ratelimit\`           | On limit hit    | Sliding window via Redis, returns 429            |
| 9     | Authenticator       | \`internal/auth\`                | On auth failure | JWT RS256 validation or API key lookup           |
| 10    | RBAC                | \`internal/auth\`                | On forbidden    | Role-based access control check                  |
| 11    | CircuitBreaker      | \`internal/circuit\`             | On open circuit | Per-upstream circuit breaker, returns 503        |

For each middleware, document:
- Input (headers, context values read)
- Output (context values set, headers added)
- Failure behavior (HTTP status, error body, metrics emitted)
- Configuration knobs (env vars, config file keys)

### D4: Data Model & Storage Design

**File**: \`docs/architecture/data-model.md\`

#### PostgreSQL Schema

\`\`\`sql
-- Route configuration (hot-reloadable)
CREATE TABLE route_configs (
    id          UUID PRIMARY KEY DEFAULT gen_random_uuid(),
    path_prefix VARCHAR(255) NOT NULL,
    upstream_url VARCHAR(512) NOT NULL,
    methods     TEXT[] NOT NULL DEFAULT '{GET}',
    strip_prefix BOOLEAN DEFAULT true,
    timeout_ms  INT DEFAULT 30000,
    retries     INT DEFAULT 1,
    active      BOOLEAN DEFAULT true,
    created_at  TIMESTAMPTZ DEFAULT now(),
    updated_at  TIMESTAMPTZ DEFAULT now()
);

-- API key metadata
CREATE TABLE api_keys (
    id          UUID PRIMARY KEY DEFAULT gen_random_uuid(),
    key_hash    VARCHAR(64) NOT NULL UNIQUE,  -- SHA-256 of the key
    client_name VARCHAR(255) NOT NULL,
    roles       TEXT[] NOT NULL DEFAULT '{reader}',
    rate_limit  INT DEFAULT 1000,             -- requests per minute
    active      BOOLEAN DEFAULT true,
    expires_at  TIMESTAMPTZ,
    created_at  TIMESTAMPTZ DEFAULT now(),
    rotated_at  TIMESTAMPTZ
);

CREATE INDEX idx_api_keys_hash ON api_keys(key_hash) WHERE active = true;
\`\`\`

#### Redis Key Design

\`\`\`
ratelimit:{client_id}:{window}   → sorted set (sliding window log)
cache:{method}:{path_hash}       → string (cached response, TTL-based)
circuit:{upstream_host}           → hash {state, failure_count, last_failure, next_retry}
config:routes:version             → string (config version for cache invalidation)
\`\`\`

Document TTL strategy, eviction policy, and behavior when Redis is unavailable (fail-open vs fail-closed per feature).

### D5: Authentication & Authorization Design

**File**: \`docs/architecture/auth-design.md\`

Document three authentication strategies:

1. **JWT (RS256)** — Primary for service-to-service and user-facing APIs
   - Public key rotation strategy (JWKS endpoint or mounted PEM files)
   - Claims required: \`sub\`, \`iss\`, \`exp\`, \`iat\`, \`roles\`
   - Token validation: signature, expiry, issuer whitelist
   - Context propagation: \`auth.UserFromContext(ctx)\`

2. **API Keys** — For third-party integrations
   - Key format: \`gw_live_\` prefix + 32-byte random (base62)
   - Storage: SHA-256 hash in PostgreSQL, never store plaintext
   - Rotation: dual-key window (old key valid for 24h after rotation)
   - Rate limit: per-key configurable

3. **OAuth2 Passthrough** — For delegated auth to upstream services
   - Gateway validates token format, forwards to upstream for full validation
   - Gateway adds \`X-Forwarded-Auth\` header

Map to SOC 2 controls:
- CC6.1 (Logical access security)
- CC6.3 (Access removal)
- CC7.2 (System monitoring)

### D6: Rate Limiting Design

**File**: \`docs/architecture/rate-limiting.md\`

Algorithm: **Sliding Window Log** (Redis sorted set)

\`\`\`
For each request:
  1. key = ratelimit:{client_id}:{window_name}
  2. now = current Unix timestamp (microseconds)
  3. window_start = now - window_size
  4. ZREMRANGEBYSCORE key 0 window_start       # prune old entries
  5. count = ZCARD key                          # count in window
  6. if count >= limit: return 429
  7. ZADD key now now                           # add current request
  8. EXPIRE key window_size_seconds             # TTL safety net
\`\`\`

Design decisions:
- Per-client limits (configurable per API key, default from config)
- Response headers: \`X-RateLimit-Limit\`, \`X-RateLimit-Remaining\`, \`X-RateLimit-Reset\`
- Redis failure mode: **fail-open** with local in-memory fallback (token bucket, degraded accuracy)
- Lua script for atomic Redis operations (steps 3–8 in single EVAL)

### D7: Circuit Breaker Design

**File**: \`docs/architecture/circuit-breaker.md\`

State machine: **Closed → Open → Half-Open → Closed**

| State     | Behavior                                                        |
|-----------|-----------------------------------------------------------------|
| Closed    | Requests pass through. Track failures in sliding window.        |
| Open      | All requests immediately return 503. Timer starts.              |
| Half-Open | Allow N probe requests. If success → Closed. If fail → Open.   |

Configuration per upstream:
\`\`\`yaml
circuit_breaker:
  failure_threshold: 5        # failures to trip
  success_threshold: 3        # successes in half-open to close
  timeout: 30s                # time in open state before half-open
  window: 60s                 # sliding window for failure counting
  monitored_errors:
    - 502
    - 503
    - 504
    - timeout
\`\`\`

State stored in Redis (shared across gateway instances). Prometheus metrics: \`gateway_circuit_breaker_state{upstream="..."}\`.

### D8: Observability Design

**File**: \`docs/architecture/observability.md\`

#### Tracing (OpenTelemetry → Jaeger)
- Every request gets a trace with spans for: middleware chain, auth, rate limit check, upstream call, response transformation
- Trace ID propagated via \`traceparent\` header (W3C Trace Context)
- Sampling: 10% in production, 100% in staging

#### Metrics (Prometheus)
Key metrics:
\`\`\`
gateway_requests_total{method, path, status, client}
gateway_request_duration_seconds{method, path, status}
gateway_upstream_duration_seconds{upstream, status}
gateway_rate_limit_hits_total{client}
gateway_circuit_breaker_state{upstream}
gateway_active_connections
gateway_auth_failures_total{reason}
\`\`\`

#### Logging (slog)
- JSON format in production, text in development
- Fields: \`request_id\`, \`trace_id\`, \`client_id\`, \`method\`, \`path\`, \`status\`, \`duration_ms\`, \`upstream\`
- Log levels: DEBUG (development), INFO (staging), WARN (production default)
- Sensitive data never logged: tokens, API keys, request bodies with PII

### D9: Architecture Decision Records

**Directory**: \`docs/architecture/adr/\`

Create ADRs for:

| ADR   | Title                                              | Decision                                    |
|-------|----------------------------------------------------|---------------------------------------------|
| ADR-001 | Router selection                                 | Chi v5 — lightweight, idiomatic, composable |
| ADR-002 | Rate limiting algorithm                          | Sliding window log — accuracy over simplicity |
| ADR-003 | JWT signing algorithm                            | RS256 — asymmetric, key rotation friendly   |
| ADR-004 | Configuration management                         | Viper + envconfig — file + env var overlay  |
| ADR-005 | Redis failure mode for rate limiting             | Fail-open with local fallback               |
| ADR-006 | Circuit breaker state storage                    | Redis — shared state across instances       |
| ADR-007 | Structured logging library                       | slog (stdlib) — no external dependency      |
| ADR-008 | Database driver                                  | pgx v5 — performance, native PostgreSQL     |
| ADR-009 | Dependency injection approach                    | Constructor injection with interfaces       |
| ADR-010 | Error handling strategy                          | Custom error types with codes, wrap with %w |

ADR format:
\`\`\`markdown
# ADR-NNN: Title
## Status: Accepted | Superseded | Deprecated
## Context: Why this decision was needed
## Decision: What we chose
## Consequences: Trade-offs, risks, follow-up actions
## Alternatives Considered: What we rejected and why
\`\`\`

### D10: API Contract

**File**: \`docs/architecture/api-contract.md\`

Define the gateway's own API surface (not upstream APIs):

\`\`\`
GET  /health              → 200 {status, version, uptime, checks}
GET  /health/ready        → 200 | 503 (readiness probe)
GET  /health/live         → 200 (liveness probe)
GET  /metrics             → Prometheus text format
POST /admin/routes        → Create route config (admin only)
GET  /admin/routes        → List route configs (admin only)
PUT  /admin/routes/{id}   → Update route config (admin only)
DELETE /admin/routes/{id} → Deactivate route config (admin only)
POST /admin/keys          → Generate API key (admin only)
DELETE /admin/keys/{id}   → Revoke API key (admin only)
ANY  /api/v1/*            → Proxy to upstream (authenticated)
\`\`\`

Standard error response format:
\`\`\`json
{
  "error": {
    "code": "RATE_LIMIT_EXCEEDED",
    "message": "Rate limit exceeded. Retry after 12 seconds.",
    "request_id": "req_abc123",
    "details": {}
  }
}
\`\`\`

## Quality Gates

All gates must pass before proceeding to Phase 03.

### QG-1: Architecture Review

- [ ] System architecture diagram reviewed by all backend developers
- [ ] Sequence diagrams cover: happy path, auth failure, rate limit, circuit open, upstream timeout
- [ ] Failure modes documented for every external dependency (PostgreSQL, Redis, upstream services)
- [ ] No single point of failure identified without a documented mitigation

### QG-2: Interface Contracts Defined

- [ ] All inter-layer interfaces defined as Go interface types (even if implementation is deferred)
- [ ] Interface files created: \`internal/service/interfaces.go\`, \`internal/repository/interfaces.go\`
- [ ] Each interface method has a doc comment describing behavior, errors, and context usage
- [ ] Mock generation strategy decided (e.g., \`go generate\` with \`mockgen\` or hand-written)

### QG-3: Security Review

- [ ] Authentication flows reviewed against OWASP API Security Top 10
- [ ] API key storage uses SHA-256 hashing (no plaintext, no reversible encryption)
- [ ] JWT validation checks: signature, expiry, issuer, audience
- [ ] Rate limiting prevents abuse without degrading legitimate traffic
- [ ] Sensitive paths identified: \`internal/auth/**\`, \`configs/production/**\`, \`*.pem\`, \`.env*\`
- [ ] SOC 2 control mapping documented for CC6.1, CC6.3, CC7.2

### QG-4: Data Model Review

- [ ] PostgreSQL schema supports all identified use cases
- [ ] Indexes defined for query patterns (API key lookup by hash, active route configs)
- [ ] Redis key naming convention documented and consistent
- [ ] TTL and eviction strategy defined for every Redis key pattern
- [ ] Migration strategy defined (golang-migrate or similar)

### QG-5: Observability Coverage

- [ ] Every middleware emits at least one metric or span
- [ ] Trace context propagated end-to-end (client → gateway → upstream)
- [ ] Alert thresholds defined for: error rate > 1%, p99 latency > 500ms, circuit breaker open
- [ ] Dashboard mockups or specifications created for Grafana
- [ ] Runbook stubs created for top 5 anticipated incidents

### QG-6: Performance Targets Documented

- [ ] Latency budget defined: gateway overhead < 5ms p99 (excluding upstream)
- [ ] Throughput target defined: > 10,000 RPS per instance
- [ ] Connection pooling configured: PostgreSQL (pgxpool), Redis (go-redis pool)
- [ ] Benchmark test plan created (using \`go test -bench\` and load testing with k6/vegeta)
- [ ] pprof endpoints planned for CPU and memory profiling in non-production

### QG-7: ADRs Complete

- [ ] All 10 ADRs written and reviewed
- [ ] Each ADR includes at least 2 alternatives considered
- [ ] No open questions or TBDs remaining in ADR decisions
- [ ] ADRs linked from main architecture document

### QG-8: Team Alignment

- [ ] Architecture walkthrough session completed with all developers
- [ ] Questions and concerns documented and addressed
- [ ] Package dependency graph reviewed (no circular dependencies)
- [ ] Estimated complexity per component agreed upon for Phase 03 planning

## Claude Code Usage in This Phase

### Recommended Commands

\`\`\`bash
# Use the architect agent for design exploration
/architect "Design the middleware pipeline ordering for the Chi router"

# Use the planner to break architecture into implementation tasks
/plan "Break down the rate limiting design into implementation tasks"

# Review architecture documents
/code-review docs/architecture/layer-contracts.md
\`\`\`

### Architecture Exploration Prompts

\`\`\`
"Given our Clean Architecture with handler → service → repository layers,
define the Go interfaces for the authentication service. Include JWT
validation, API key verification, and RBAC checking. Each method should
accept context.Context as the first parameter and return domain-specific
error types."

"Design the Redis Lua script for sliding window rate limiting. It should
be atomic, handle the ZREMRANGEBYSCORE + ZCARD + ZADD + EXPIRE sequence
in a single EVAL call. Return the current count and TTL."

"Generate the OpenTelemetry middleware for Chi that creates a span per
request, sets standard HTTP attributes, and propagates trace context
to upstream calls."
\`\`\`

### Validation Prompts

\`\`\`
"Review this circuit breaker design for race conditions when multiple
gateway instances share state via Redis. Identify potential issues with
the half-open → closed transition."

"Analyze this middleware ordering for security gaps. Could a request
bypass rate limiting or authentication due to middleware short-circuiting?"
\`\`\`

## Anti-Patterns to Avoid

| Anti-Pattern                    | Why It's Harmful                                          | What to Do Instead                              |
|---------------------------------|-----------------------------------------------------------|-------------------------------------------------|
| God middleware                  | Single middleware doing auth + rate limit + logging        | One concern per middleware, compose with Chi     |
| Leaky abstractions              | Handlers importing \`pgx\` or \`go-redis\` directly          | Depend on interfaces, inject implementations    |
| Shared mutable state            | Global variables for config or connections                | Pass dependencies via constructors              |
| Over-engineering                | Building plugin systems or dynamic middleware loading     | Start simple, add complexity when needed        |
| Ignoring failure modes          | Assuming Redis/PostgreSQL are always available            | Design degraded modes for every dependency      |
| Premature optimization          | Custom allocators before profiling                        | Benchmark first with \`go test -bench\`, then optimize |

## Transition Criteria

To move to **Phase 03: Environment Setup**:

1. All deliverables (D1–D10) are committed to \`docs/architecture/\`
2. All quality gates (QG-1 through QG-8) pass
3. Architecture review PR approved by at least 1 lead and 1 senior developer
4. \`playbook/current-phase.json\` updated to \`{"phase": "03-environment", "status": "active"}\`
5. GitHub Issues created for all implementation tasks identified during architecture

\`\`\`bash
# Transition command
./playbook/codeforge-phase.sh advance 03-environment
\`\`\`

## References

- [Effective Go](https://go.dev/doc/effective_go)
- [Go Code Review Comments](https://github.com/golang/go/wiki/CodeReviewComments)
- [Chi Router Documentation](https://go-chi.io/)
- [OWASP API Security Top 10](https://owasp.org/API-Security/)
- [SOC 2 Trust Services Criteria](https://www.aicpa.org/soc2)
- [OpenTelemetry Go SDK](https://opentelemetry.io/docs/languages/go/)
- [Circuit Breaker Pattern (Microsoft)](https://learn.microsoft.com/en-us/azure/architecture/patterns/circuit-breaker)
- [Phase 01: Requirements & Planning](./01-requirements.md)
- [Phase 03: Environment Setup](./03-environment.md)`,

  'playbook/phases/03-foundation.md': `# Phase 03: Foundation & Scaffolding

## Phase Overview

| Attribute       | Value                                                    |
|-----------------|----------------------------------------------------------|
| **Phase**       | 03 — Foundation & Scaffolding                            |
| **Duration**    | 3–5 days                                                 |
| **Predecessor** | [Phase 02: Architecture & Design](./02-architecture.md)  |
| **Successor**   | [Phase 04: Core Implementation](./04-core.md)            |
| **Owner**       | Lead Engineer                                            |
| **Approver**    | Tech Lead                                                |

## Objectives

1. **Establish the Go project skeleton** following Clean Architecture (handler → service → repository) with all key directories in place
2. **Wire up the Chi router** with a minimal health-check endpoint to prove the HTTP server boots and responds
3. **Configure structured logging** with \`slog\`, **metrics** with Prometheus, and **tracing** with OpenTelemetry so every subsequent feature inherits observability from day one
4. **Set up configuration loading** via Viper + envconfig with environment-specific YAML files for development, staging, and production
5. **Establish database connectivity** to PostgreSQL (config store) and Redis (rate limiting / caching) with connection pooling and health probes
6. **Implement graceful shutdown** handling OS signals (SIGINT, SIGTERM) to drain in-flight requests before exit
7. **Create the CI pipeline** in GitHub Actions covering lint, vet, unit tests, race detection, and Docker image build
8. **Containerize the gateway** with a multi-stage Dockerfile producing a minimal scratch-based image
9. **Seed the test infrastructure** with table-driven test patterns, httptest helpers, and testify assertions so the team has a clear testing template

## Deliverables

### D1 — Project Skeleton

All directories from the canonical layout exist with at least a \`doc.go\` or initial source file:

\`\`\`
cmd/gateway/main.go
internal/handler/health.go
internal/middleware/doc.go
internal/service/doc.go
internal/repository/doc.go
internal/model/doc.go
internal/config/config.go
internal/auth/doc.go
internal/ratelimit/doc.go
internal/circuit/doc.go
internal/observability/logger.go
internal/observability/metrics.go
internal/observability/tracer.go
pkg/httputil/response.go
pkg/errors/errors.go
configs/development.yaml
configs/staging.yaml
configs/production.yaml
\`\`\`

### D2 — Configuration System

- \`internal/config/config.go\` — Viper-based loader reading YAML + environment variable overrides
- Struct-based config with validation tags
- Sensitive values (DB passwords, JWT secrets) loaded exclusively from environment variables — never from YAML files
- Config struct covers: server (port, timeouts), database (PostgreSQL DSN, pool size), Redis (address, pool size, TLS), auth (JWT public key path, issuer), rate limiting (default RPS, burst), observability (OTEL endpoint, log level)

\`\`\`go
// Example config struct shape
type Config struct {
    Server        ServerConfig
    Database      DatabaseConfig
    Redis         RedisConfig
    Auth          AuthConfig
    RateLimit     RateLimitConfig
    Observability ObservabilityConfig
}
\`\`\`

### D3 — HTTP Server with Chi Router

- \`cmd/gateway/main.go\` — entry point that loads config, initializes dependencies, starts the server, and handles graceful shutdown
- Chi router with base middleware stack:
  - \`middleware.RequestID\` — inject unique request ID
  - \`middleware.RealIP\` — extract client IP behind ALB
  - Custom \`slog\` request logger
  - \`middleware.Recoverer\` — panic recovery
  - \`middleware.Heartbeat("/ping")\` — lightweight liveness probe
- Health endpoint: \`GET /healthz\` returning JSON with service status, uptime, and dependency checks (PostgreSQL, Redis)
- Readiness endpoint: \`GET /readyz\` returning 200 only when all dependencies are connected

### D4 — Database Connectivity

- \`internal/repository/postgres.go\` — PostgreSQL connection using \`pgxpool\` with:
  - Connection pooling (min 2, max 10 configurable)
  - Health check via \`pool.Ping(ctx)\`
  - Context propagation on all queries
  - Connection string from environment variable only
- \`internal/repository/redis.go\` — Redis connection using \`go-redis/redis/v9\` with:
  - Connection pooling
  - TLS support for ElastiCache
  - Health check via \`client.Ping(ctx)\`
  - Configurable read/write timeouts

### D5 — Observability Foundation

- **Structured Logging** (\`internal/observability/logger.go\`):
  - \`slog.Logger\` configured with JSON handler for production, text handler for development
  - Default attributes: service name, version, environment
  - Log level configurable via config
  - Context-aware logging extracting request ID and trace ID

- **Prometheus Metrics** (\`internal/observability/metrics.go\`):
  - HTTP request duration histogram (\`gateway_http_request_duration_seconds\`)
  - HTTP request counter by method, path, status (\`gateway_http_requests_total\`)
  - Active connections gauge (\`gateway_active_connections\`)
  - Upstream latency histogram (\`gateway_upstream_duration_seconds\`)
  - \`/metrics\` endpoint exposed on a separate admin port

- **OpenTelemetry Tracing** (\`internal/observability/tracer.go\`):
  - OTLP exporter configured for Jaeger
  - Trace context propagation via W3C TraceContext
  - Resource attributes: service.name, service.version, deployment.environment
  - Span creation helper that injects into \`context.Context\`

### D6 — Shared Utilities

- \`pkg/httputil/response.go\`:
  - \`WriteJSON(w, status, data)\` — standard JSON response writer
  - \`WriteError(w, status, code, message)\` — standard error response following RFC 7807 Problem Details
  - Response envelope: \`{"data": ..., "meta": {"request_id": "...", "timestamp": "..."}}\`

- \`pkg/errors/errors.go\`:
  - Custom error types: \`ErrNotFound\`, \`ErrUnauthorized\`, \`ErrForbidden\`, \`ErrRateLimited\`, \`ErrBadRequest\`, \`ErrInternal\`, \`ErrUpstreamTimeout\`
  - Error codes enum for machine-readable error identification
  - \`Wrap(err, code, message)\` function using \`fmt.Errorf\` with \`%w\`
  - \`ToHTTPStatus(err)\` mapping custom errors to HTTP status codes

### D7 — Graceful Shutdown

- Listen for \`SIGINT\` and \`SIGTERM\` via \`signal.NotifyContext\`
- On signal: stop accepting new connections, drain in-flight requests (configurable timeout, default 30s), close PostgreSQL pool, close Redis client, flush OpenTelemetry spans, flush Prometheus metrics, log shutdown completion
- If drain timeout expires, force exit with \`os.Exit(1)\`

### D8 — Dockerfile

Multi-stage build:

\`\`\`dockerfile
# Stage 1: Build
FROM golang:1.22-alpine AS builder
# ... build with CGO_ENABLED=0

# Stage 2: Runtime
FROM scratch
COPY --from=builder /app/bin/gateway /gateway
COPY --from=builder /etc/ssl/certs/ca-certificates.crt /etc/ssl/certs/
EXPOSE 8080 9090
ENTRYPOINT ["/gateway"]
\`\`\`

- Port 8080 for gateway traffic, port 9090 for admin/metrics
- Non-root user in the build stage
- Health check instruction for Docker/ECS

### D9 — CI Pipeline (GitHub Actions)

\`.github/workflows/ci.yml\` covering:

| Step                | Command                                                  | Fail Threshold |
|---------------------|----------------------------------------------------------|----------------|
| Lint                | \`golangci-lint run ./...\`                                | Any finding    |
| Vet                 | \`go vet ./...\`                                           | Any finding    |
| Unit Tests          | \`go test -race -coverprofile=coverage.out ./...\`         | < 80% coverage |
| Race Detection      | Included in test step via \`-race\`                        | Any race       |
| Build Binary        | \`go build -o bin/gateway cmd/gateway/main.go\`            | Build failure  |
| Build Docker Image  | \`docker build -t go-api-gateway:$SHA .\`                  | Build failure  |

### D10 — Test Infrastructure

- \`internal/handler/health_test.go\` — table-driven test using \`httptest.NewRecorder\` and \`chi.NewRouter\`, asserting JSON response shape and status codes
- \`internal/config/config_test.go\` — tests for config loading with environment variable overrides
- \`pkg/httputil/response_test.go\` — tests for JSON response helpers
- \`pkg/errors/errors_test.go\` — tests for error wrapping, unwrapping, and HTTP status mapping
- Test helper in \`tests/testutil/helpers.go\`:
  - \`NewTestRouter()\` — returns a Chi router with test middleware
  - \`NewTestLogger()\` — returns a \`slog.Logger\` writing to \`bytes.Buffer\`
  - \`AssertJSONResponse(t, rec, status, key, expected)\` — common assertion

## Tasks

### Skeleton & Config (Day 1)

| #  | Task                                          | Assignee | Est  |
|----|-----------------------------------------------|----------|------|
| 1  | Create directory structure with doc.go files  | Dev      | 1h   |
| 2  | Implement \`internal/config/config.go\`         | Dev      | 2h   |
| 3  | Write config tests with env var overrides     | Dev      | 1h   |
| 4  | Create \`configs/*.yaml\` for all environments  | Dev      | 1h   |
| 5  | Implement \`pkg/errors/errors.go\` + tests      | Dev      | 2h   |
| 6  | Implement \`pkg/httputil/response.go\` + tests  | Dev      | 1h   |

### HTTP Server & Health (Day 2)

| #  | Task                                          | Assignee | Est  |
|----|-----------------------------------------------|----------|------|
| 7  | Implement \`cmd/gateway/main.go\` with Chi      | Dev      | 3h   |
| 8  | Implement health handler + tests              | Dev      | 2h   |
| 9  | Implement graceful shutdown                   | Dev      | 2h   |
| 10 | Wire base middleware stack                    | Dev      | 1h   |

### Database & Observability (Day 3)

| #  | Task                                          | Assignee | Est  |
|----|-----------------------------------------------|----------|------|
| 11 | Implement PostgreSQL connection + pool        | Dev      | 2h   |
| 12 | Implement Redis connection + pool             | Dev      | 2h   |
| 13 | Implement \`slog\` logger setup                | Dev      | 1h   |
| 14 | Implement Prometheus metrics + \`/metrics\`     | Dev      | 2h   |
| 15 | Implement OpenTelemetry tracer setup          | Dev      | 2h   |

### CI & Containerization (Day 4)

| #  | Task                                          | Assignee | Est  |
|----|-----------------------------------------------|----------|------|
| 16 | Create multi-stage Dockerfile                 | Dev      | 1h   |
| 17 | Create \`.github/workflows/ci.yml\`             | Dev      | 2h   |
| 18 | Create \`tests/testutil/helpers.go\`            | Dev      | 1h   |
| 19 | Verify full CI pipeline passes                | Dev      | 1h   |
| 20 | Write \`docker-compose.yml\` for local dev      | Dev      | 1h   |

### Polish & Review (Day 5)

| #  | Task                                          | Assignee | Est  |
|----|-----------------------------------------------|----------|------|
| 21 | Run \`golangci-lint\` and fix all findings      | Dev      | 1h   |
| 22 | Ensure all exported functions have doc comments | Dev    | 1h   |
| 23 | Verify coverage ≥ 80% on all new packages    | Dev      | 1h   |
| 24 | Peer review all foundation PRs                | Lead     | 2h   |
| 25 | Update \`playbook/current-phase.json\` to 04    | Dev      | 15m  |

## Architecture Decisions

### ADR-F01: Chi over stdlib ServeMux

Chi v5 provides composable middleware, route groups, URL parameters, and sub-routers while remaining lightweight and idiomatic. The stdlib \`http.ServeMux\` (even with Go 1.22 improvements) lacks middleware composition needed for the gateway's layered middleware chain (auth → rate limit → circuit breaker → proxy).

### ADR-F02: pgxpool over database/sql

\`pgxpool\` provides native PostgreSQL protocol support, prepared statement caching, connection health checks, and superior performance over \`database/sql\` + \`lib/pq\`. It also supports \`pgx.Rows\` scanning directly into structs.

### ADR-F03: Separate Admin Port

Metrics (\`/metrics\`), profiling (\`/debug/pprof\`), and health endpoints run on port 9090, separate from gateway traffic on port 8080. This allows Kubernetes to probe health without traversing the gateway middleware chain and prevents external exposure of admin endpoints via ALB rules.

### ADR-F04: scratch Base Image

The production Docker image uses \`scratch\` (not \`alpine\`) to minimize attack surface for SOC 2 compliance. The Go binary is statically compiled with \`CGO_ENABLED=0\`. CA certificates are copied from the builder stage for TLS connectivity to upstream services, RDS, and ElastiCache.

## Quality Gates

All gates must pass before advancing to [Phase 04: Core Implementation](./04-core.md).

### QG-01: Build & Lint

- [ ] \`go build -o bin/gateway cmd/gateway/main.go\` succeeds with zero warnings
- [ ] \`golangci-lint run ./...\` passes with zero findings (govet, errcheck, staticcheck, gosec, revive, gocyclo)
- [ ] \`go vet ./...\` reports zero issues
- [ ] \`gofmt -l .\` returns no files (all code formatted)
- [ ] \`goimports -l .\` returns no files (all imports organized)

### QG-02: Tests & Coverage

- [ ] \`go test -race ./...\` passes with zero failures and zero data races
- [ ] Code coverage ≥ 80% across all new packages (\`internal/config\`, \`internal/handler\`, \`pkg/httputil\`, \`pkg/errors\`)
- [ ] Table-driven tests used in all test files
- [ ] \`httptest\` used for all handler tests — no real HTTP server started

### QG-03: Server Functionality

- [ ] Gateway starts on port 8080 and admin on port 9090
- [ ] \`GET /ping\` returns \`200 OK\` with response time < 1ms
- [ ] \`GET /healthz\` returns JSON with service name, version, uptime, and dependency status
- [ ] \`GET /readyz\` returns \`503 Service Unavailable\` when PostgreSQL or Redis is unreachable
- [ ] \`GET /metrics\` returns Prometheus-formatted metrics including \`gateway_http_requests_total\`
- [ ] Server shuts down gracefully within 30s on SIGTERM, logging shutdown steps

### QG-04: Database Connectivity

- [ ] PostgreSQL connection pool initializes with configured min/max connections
- [ ] Redis connection establishes with TLS when configured
- [ ] Both connections are health-checked during \`/healthz\` and \`/readyz\`
- [ ] Connection failures are logged with structured \`slog\` output including error context

### QG-05: Observability

- [ ] All log output is structured JSON in production mode
- [ ] Request ID is present in every log line for HTTP requests
- [ ] Prometheus metrics are registered and increment on requests
- [ ] OpenTelemetry tracer initializes without error (even if collector is unavailable — must not block startup)

### QG-06: Configuration

- [ ] Config loads from \`configs/development.yaml\` by default
- [ ] Environment variables override YAML values (e.g., \`GATEWAY_SERVER_PORT=9999\`)
- [ ] Sensitive values (DB password, JWT key) are only accepted from environment variables
- [ ] Missing required config values cause startup failure with a clear error message

### QG-07: Container & CI

- [ ] Docker image builds successfully with multi-stage build
- [ ] Docker image size < 20MB (scratch base + static binary)
- [ ] GitHub Actions CI pipeline runs all stages (lint → vet → test → build → docker)
- [ ] CI fails on lint violations, test failures, or coverage below 80%

### QG-08: Code Quality

- [ ] All exported functions and types have doc comments
- [ ] No \`init()\` functions anywhere in the codebase
- [ ] All handler functions accept \`context.Context\` (via \`http.Request.Context()\`)
- [ ] All errors are wrapped with \`fmt.Errorf("...: %w", err)\`
- [ ] No file exceeds 300 lines
- [ ] File names use \`snake_case.go\`
- [ ] CODEOWNERS file covers \`internal/auth/**\` and \`configs/production/**\`

### QG-09: Security (SOC 2 Baseline)

- [ ] No secrets, passwords, or keys in any committed file
- [ ] \`.gitignore\` excludes \`.env*\`, \`*.pem\`, \`*.key\`, \`bin/\`, \`coverage.out\`
- [ ] \`gosec\` linter passes with zero high-severity findings
- [ ] Docker image runs as non-root (verified via \`USER\` instruction or scratch constraints)
- [ ] TLS configuration is available for Redis and PostgreSQL connections

## Verification Commands

Run these commands to verify all quality gates:

\`\`\`bash
# Build
go build -o bin/gateway cmd/gateway/main.go

# Lint & Vet
golangci-lint run ./...
go vet ./...

# Tests with race detection and coverage
go test -race -coverprofile=coverage.out ./...
go tool cover -func=coverage.out | grep total

# Format check
test -z "$(gofmt -l .)"

# Docker build
docker build -t go-api-gateway:test .
docker images go-api-gateway:test --format '{{.Size}}'

# Smoke test (requires docker-compose up -d for PostgreSQL and Redis)
docker-compose up -d postgres redis
go run cmd/gateway/main.go &
sleep 2
curl -s http://localhost:8080/ping
curl -s http://localhost:8080/healthz | jq .
curl -s http://localhost:9090/metrics | head -20
kill %1

# Security scan
gosec ./...
\`\`\`

## Risk Register

| Risk                                       | Likelihood | Impact | Mitigation                                                        |
|--------------------------------------------|------------|--------|-------------------------------------------------------------------|
| pgxpool version incompatibility with RDS   | Low        | High   | Pin pgx v5, test against RDS-compatible PostgreSQL 15 in Docker   |
| Redis TLS handshake failures in CI         | Medium     | Medium | Use non-TLS Redis in CI, TLS integration test in staging only     |
| OpenTelemetry SDK bloats binary size       | Low        | Low    | Monitor binary size in CI, consider OTEL contrib slim packages    |
| Config loading order confusion             | Medium     | Medium | Document precedence: defaults → YAML → env vars, add startup log |
| Graceful shutdown not draining long requests | Low      | High   | Integration test with slow handler + SIGTERM, verify drain log    |

## Dependencies on Previous Phases

- **Phase 01 (Discovery)**: Project requirements, SLA targets (p99 latency < 50ms for health endpoints)
- **Phase 02 (Architecture)**: Clean Architecture layer boundaries, middleware chain order, port assignments, ADRs for technology choices

## Outputs for Next Phase

Phase 04 (Core Implementation) depends on:

- Working Chi router with middleware chain ready for auth and rate limiting middleware insertion
- PostgreSQL and Redis repositories with interfaces defined for dependency injection
- Observability pipeline (logging, metrics, tracing) integrated so core features inherit instrumentation
- Test helpers and patterns established for consistent testing across the team
- CI pipeline validating every PR before merge to \`main\`

## Phase Completion Checklist

- [ ] All deliverables (D1–D10) implemented and merged to \`main\`
- [ ] All quality gates (QG-01–QG-09) passing
- [ ] CI pipeline green on \`main\` branch
- [ ] No open \`golangci-lint\` findings
- [ ] Architecture decisions (ADR-F01–F04) documented in \`docs/adr/\`
- [ ] Team walkthrough completed — all developers can run the gateway locally
- [ ] \`playbook/current-phase.json\` updated to phase \`04\``,

  'playbook/phases/04-core-implementation.md': `# Phase 04: Core Implementation

## Overview

Phase 04 transforms the foundation scaffolding from Phase 03 into a working API gateway. This phase delivers the core request pipeline: incoming HTTP requests flow through Chi middleware (authentication, rate limiting, logging, tracing) into handlers that route traffic to upstream services. Every component follows Clean Architecture boundaries and is built test-first using table-driven tests.

**Duration**: 2–3 sprints (4–6 weeks)
**Prerequisites**: Phase 03 (Foundation) complete — project compiles, CI pipeline green, database migrations run, config loading works
**Phase Tag**: \`phase-04-core-implementation\`

---

## Objectives

| # | Objective | Success Metric |
|---|-----------|----------------|
| 1 | Implement JWT authentication middleware with RS256 validation and RBAC | Token validation <2ms p99; rejects expired/malformed tokens; role enforcement on protected routes |
| 2 | Implement Redis-backed rate limiting with sliding window algorithm | Per-client rate limiting accurate within 1% at 10k req/s; Redis round-trip <1ms p99 |
| 3 | Build reverse proxy handler with configurable upstream routing | Routes requests to correct upstream; preserves headers; handles timeouts gracefully |
| 4 | Implement circuit breaker pattern for upstream resilience | Opens after configurable failure threshold; half-open probe works; metrics emitted |
| 5 | Build request/response transformation pipeline | Header injection, path rewriting, body transformation work per route config |
| 6 | Integrate OpenTelemetry tracing across the full request lifecycle | Trace ID propagated end-to-end; spans visible in Jaeger; context flows through all layers |
| 7 | Expose Prometheus metrics for all gateway operations | Request count, latency histograms, error rates, rate limit hits, circuit breaker state |
| 8 | Implement structured logging with slog across all components | Every request logged with trace ID, client ID, route, status, latency |
| 9 | Achieve ≥80% test coverage with table-driven tests | \`go test -coverprofile\` reports ≥80% on all \`internal/\` packages |
| 10 | Pass golangci-lint with zero findings | \`golangci-lint run ./...\` exits 0 with full linter suite enabled |

---

## Deliverables

### D1: Authentication & Authorization (\`internal/auth/\`, \`internal/middleware/\`)

**Files**:
- \`internal/auth/jwt.go\` — RS256 JWT validator, key rotation support, claims extraction
- \`internal/auth/jwt_test.go\` — Table-driven tests: valid token, expired, wrong algorithm, missing claims, malformed
- \`internal/auth/apikey.go\` — API key verification against PostgreSQL with Redis cache
- \`internal/auth/apikey_test.go\` — Table-driven tests: valid key, revoked, expired, rate-limited key
- \`internal/auth/rbac.go\` — Role-based access control, permission checking against route requirements
- \`internal/auth/rbac_test.go\` — Table-driven tests: admin access, user access, insufficient role, multiple roles
- \`internal/middleware/auth.go\` — Chi middleware that extracts credentials, calls auth service, sets context
- \`internal/middleware/auth_test.go\` — httptest-based tests for the full middleware chain

**Implementation Notes**:
- Use \`crypto/rsa\` for RS256; load public keys from PEM files or JWKS endpoint
- Store parsed keys in memory with TTL-based refresh (no \`init()\` — use constructor)
- Claims must include \`sub\`, \`iss\`, \`exp\`, \`iat\`, \`roles\` (custom claim)
- API key lookup: Redis first → PostgreSQL fallback → cache on miss
- All functions accept \`context.Context\` as first parameter
- Errors wrapped with \`fmt.Errorf("auth: %w", err)\` pattern

\`\`\`go
// Example interface — auth service boundary
type TokenValidator interface {
    ValidateToken(ctx context.Context, tokenString string) (*Claims, error)
}

type APIKeyVerifier interface {
    VerifyKey(ctx context.Context, key string) (*ClientIdentity, error)
}

type RBACChecker interface {
    HasPermission(ctx context.Context, identity *ClientIdentity, resource, action string) (bool, error)
}
\`\`\`

**Quality Gate**: All auth tests pass. No token bypass possible. Expired tokens rejected. Invalid signatures rejected. RBAC denies unauthorized access.

---

### D2: Rate Limiting (\`internal/ratelimit/\`, \`internal/middleware/\`)

**Files**:
- \`internal/ratelimit/sliding_window.go\` — Redis-backed sliding window rate limiter
- \`internal/ratelimit/sliding_window_test.go\` — Table-driven tests with Redis testcontainer or mock
- \`internal/ratelimit/config.go\` — Per-client and per-route rate limit configuration
- \`internal/middleware/ratelimit.go\` — Chi middleware that extracts client identity and enforces limits
- \`internal/middleware/ratelimit_test.go\` — httptest tests: under limit, at limit, over limit, burst

**Implementation Notes**:
- Sliding window algorithm using Redis sorted sets (\`ZADD\`, \`ZREMRANGEBYSCORE\`, \`ZCARD\`)
- Key format: \`ratelimit:{client_id}:{route_pattern}:{window_start}\`
- Return \`429 Too Many Requests\` with \`Retry-After\` and \`X-RateLimit-Remaining\` headers
- Support tiered limits: free (100/min), basic (1000/min), premium (10000/min)
- Redis operations must use pipeline to minimize round-trips
- Graceful degradation: if Redis is unavailable, allow traffic (fail-open) and log warning

\`\`\`go
// Rate limiter interface
type Limiter interface {
    Allow(ctx context.Context, key string, limit Rate) (*Result, error)
}

type Result struct {
    Allowed    bool
    Remaining  int
    ResetAt    time.Time
    RetryAfter time.Duration
}
\`\`\`

**Quality Gate**: Rate limiter accurate within 1% under concurrent load. \`Retry-After\` header correct. Fail-open behavior verified. Redis pipeline used (not individual commands).

---

### D3: Request Routing & Reverse Proxy (\`internal/handler/\`, \`internal/service/\`)

**Files**:
- \`internal/handler/proxy.go\` — Chi handler that proxies requests to upstream services
- \`internal/handler/proxy_test.go\` — httptest with mock upstream servers
- \`internal/service/router.go\` — Route resolution: maps incoming path to upstream service config
- \`internal/service/router_test.go\` — Table-driven: exact match, prefix match, wildcard, no match
- \`internal/model/route.go\` — Route configuration model (upstream URL, timeout, retry policy, strip prefix)
- \`internal/repository/route_repo.go\` — Load route configs from PostgreSQL with Redis cache
- \`internal/repository/route_repo_test.go\` — Repository tests with sqlmock

**Implementation Notes**:
- Use \`net/http/httputil.ReverseProxy\` as the base, with custom \`Director\` and \`ModifyResponse\`
- Connection pooling: configure \`http.Transport\` with \`MaxIdleConns\`, \`MaxIdleConnsPerHost\`, \`IdleConnTimeout\`
- Timeout per upstream: configurable via route config, enforced with \`context.WithTimeout\`
- Preserve original headers; add \`X-Forwarded-For\`, \`X-Request-ID\`, \`X-Correlation-ID\`
- Strip gateway-specific headers before forwarding (e.g., \`Authorization\` if gateway handles auth)
- Route config hot-reload: watch PostgreSQL for changes, refresh Redis cache

\`\`\`go
// Route model
type Route struct {
    ID            string        \`json:"id" db:"id"\`
    PathPattern   string        \`json:"path_pattern" db:"path_pattern"\`
    Methods       []string      \`json:"methods" db:"methods"\`
    UpstreamURL   string        \`json:"upstream_url" db:"upstream_url"\`
    StripPrefix   string        \`json:"strip_prefix" db:"strip_prefix"\`
    Timeout       time.Duration \`json:"timeout" db:"timeout"\`
    RetryCount    int           \`json:"retry_count" db:"retry_count"\`
    AuthRequired  bool          \`json:"auth_required" db:"auth_required"\`
    RateLimit     string        \`json:"rate_limit" db:"rate_limit"\`
    CircuitBreaker bool         \`json:"circuit_breaker" db:"circuit_breaker"\`
}
\`\`\`

**Quality Gate**: Requests route to correct upstream. Path rewriting works. Timeouts enforced. Connection pool configured. Headers propagated correctly.

---

### D4: Circuit Breaker (\`internal/circuit/\`)

**Files**:
- \`internal/circuit/breaker.go\` — Circuit breaker state machine (closed → open → half-open)
- \`internal/circuit/breaker_test.go\` — Table-driven tests for all state transitions
- \`internal/circuit/registry.go\` — Per-upstream circuit breaker registry (thread-safe)
- \`internal/circuit/registry_test.go\` — Concurrent access tests

**Implementation Notes**:
- Three states: Closed (normal), Open (failing, reject fast), Half-Open (probe with single request)
- Configurable per upstream: failure threshold, success threshold (half-open), timeout (open duration)
- Use \`sync.RWMutex\` for thread safety — no external dependencies
- Emit Prometheus metrics on state transitions: \`gateway_circuit_breaker_state{upstream="svc-users"}\`
- Return \`503 Service Unavailable\` with structured error body when circuit is open

\`\`\`go
type Breaker struct {
    name             string
    maxFailures      int
    resetTimeout     time.Duration
    halfOpenMaxCalls int
    // internal state managed with mutex
}

type State int
const (
    StateClosed   State = iota
    StateOpen
    StateHalfOpen
)
\`\`\`

**Quality Gate**: State transitions correct under concurrent load. Open circuit rejects immediately (<0.1ms). Half-open allows exactly configured probe count. Metrics emitted on every transition.

---

### D5: Request/Response Transformation (\`internal/middleware/\`)

**Files**:
- \`internal/middleware/transform.go\` — Request/response transformation middleware
- \`internal/middleware/transform_test.go\` — Table-driven tests for each transformation type

**Transformations**:
- **Header injection**: Add/remove/override headers on request and response
- **Path rewriting**: Regex-based path transformation before upstream routing
- **Query parameter manipulation**: Add/remove query params
- **Response header cleanup**: Remove upstream internal headers before returning to client
- **CORS handling**: Configurable per-route CORS headers

**Quality Gate**: Each transformation type has ≥3 test cases. Transformations compose correctly. No mutation of original request when not intended.

---

### D6: Observability Integration (\`internal/observability/\`, \`internal/middleware/\`)

**Files**:
- \`internal/observability/tracer.go\` — OpenTelemetry tracer provider setup (OTLP exporter → Jaeger)
- \`internal/observability/metrics.go\` — Prometheus metrics registry, custom gateway metrics
- \`internal/observability/logger.go\` — slog configuration with JSON output, log level from config
- \`internal/middleware/tracing.go\` — Chi middleware that starts spans, propagates trace context
- \`internal/middleware/tracing_test.go\` — Verify span creation and context propagation
- \`internal/middleware/metrics.go\` — Chi middleware that records request metrics
- \`internal/middleware/metrics_test.go\` — Verify metric labels and histogram observations
- \`internal/middleware/logging.go\` — Chi middleware for structured request/response logging
- \`internal/middleware/logging_test.go\` — Verify log output contains required fields
- \`internal/handler/health.go\` — Health check endpoint (\`/healthz\`, \`/readyz\`)
- \`internal/handler/health_test.go\` — Health check tests (healthy, degraded, unhealthy)

**Prometheus Metrics**:
\`\`\`
gateway_requests_total{method, route, status, client_id}
gateway_request_duration_seconds{method, route}  (histogram)
gateway_upstream_duration_seconds{upstream}       (histogram)
gateway_rate_limit_hits_total{client_id, route}
gateway_circuit_breaker_state{upstream}           (gauge: 0=closed, 1=open, 2=half-open)
gateway_active_connections                        (gauge)
gateway_auth_failures_total{reason}
\`\`\`

**Structured Log Fields** (every request):
\`\`\`json
{
  "level": "INFO",
  "msg": "request completed",
  "trace_id": "abc123",
  "span_id": "def456",
  "method": "GET",
  "path": "/api/v1/users",
  "status": 200,
  "latency_ms": 12.5,
  "client_id": "client-xyz",
  "upstream": "users-service",
  "request_id": "req-789"
}
\`\`\`

**Quality Gate**: Traces visible in Jaeger for end-to-end request flow. Prometheus \`/metrics\` endpoint returns all defined metrics. Every request produces a structured log line with trace ID.

---

### D7: Middleware Chain Assembly (\`cmd/gateway/\`)

**Files**:
- \`cmd/gateway/main.go\` — Updated to wire all middleware and handlers
- \`internal/handler/routes.go\` — Chi router setup with middleware chain

**Middleware Order** (critical — order matters):
\`\`\`go
r := chi.NewRouter()

// 1. Recovery (outermost — catches panics)
r.Use(middleware.Recovery)

// 2. Request ID generation
r.Use(middleware.RequestID)

// 3. Tracing (start span early)
r.Use(middleware.Tracing)

// 4. Structured logging
r.Use(middleware.Logging)

// 5. Prometheus metrics
r.Use(middleware.Metrics)

// 6. CORS
r.Use(middleware.CORS)

// 7. Authentication (sets identity in context)
r.Use(middleware.Auth)

// 8. Rate limiting (uses identity from auth)
r.Use(middleware.RateLimit)

// 9. Request transformation
r.Use(middleware.Transform)

// Routes
r.Get("/healthz", handler.Healthz)
r.Get("/readyz", handler.Readyz)
r.Get("/metrics", promhttp.Handler())
r.Handle("/*", handler.Proxy)
\`\`\`

**Quality Gate**: Gateway starts, accepts requests, routes through full middleware chain, returns correct responses. Graceful shutdown works (in-flight requests complete).

---

## Implementation Order

Execute deliverables in this order to manage dependencies:

\`\`\`
Week 1-2:
  D6 (Observability) — logging, metrics, tracing setup first so all subsequent
                        code emits telemetry from the start
  D1 (Auth)          — JWT + API key validation, RBAC

Week 2-3:
  D2 (Rate Limiting) — Redis sliding window, middleware
  D4 (Circuit Breaker) — State machine, registry

Week 3-4:
  D3 (Routing & Proxy) — Reverse proxy, route resolution, upstream management
  D5 (Transformations) — Header/path/query manipulation

Week 4:
  D7 (Assembly)      — Wire everything together, integration tests
\`\`\`

**Rationale**: Observability first means every component built afterward automatically has logging, metrics, and tracing. Auth before rate limiting because rate limiting keys off client identity. Circuit breaker before proxy because the proxy handler uses it.

---

## Quality Gates

All gates must pass before Phase 04 is considered complete.

### Gate 1: Test Coverage ≥80%

\`\`\`bash
go test -coverprofile=coverage.out ./internal/...
go tool cover -func=coverage.out | grep total
# Must show ≥80.0%
\`\`\`

**Per-package minimums**:
| Package | Minimum Coverage |
|---------|-----------------|
| \`internal/auth\` | 90% |
| \`internal/ratelimit\` | 85% |
| \`internal/circuit\` | 90% |
| \`internal/middleware\` | 80% |
| \`internal/handler\` | 80% |
| \`internal/service\` | 85% |
| \`internal/repository\` | 75% |

### Gate 2: Lint Clean

\`\`\`bash
golangci-lint run ./...
# Exit code 0, zero findings
\`\`\`

Enabled linters: \`govet\`, \`errcheck\`, \`staticcheck\`, \`gosec\`, \`revive\`, \`gocyclo\`, \`goimports\`, \`ineffassign\`, \`unused\`, \`misspell\`

### Gate 3: Race Condition Free

\`\`\`bash
go test -race ./internal/...
# Exit code 0, no race conditions detected
\`\`\`

Critical for: circuit breaker (concurrent state transitions), rate limiter (concurrent Redis access), middleware chain (concurrent request handling).

### Gate 4: All Exported Functions Documented

\`\`\`bash
# Every exported function, type, and method must have a doc comment
# revive linter with exported rule enforces this
golangci-lint run --enable revive ./...
\`\`\`

### Gate 5: No init() Functions

\`\`\`bash
grep -r "func init()" internal/ cmd/
# Must return no results
\`\`\`

### Gate 6: Context Propagation Verified

Every handler and service method must accept \`context.Context\` as the first parameter. Verify with:

\`\`\`bash
# Custom check: all handler funcs have (http.ResponseWriter, *http.Request)
# All service methods have (ctx context.Context, ...) as first param
go vet ./...
\`\`\`

### Gate 7: Integration Test Suite Passes

\`\`\`bash
# Requires Docker (PostgreSQL + Redis)
docker compose -f deployments/docker-compose.test.yml up -d
go test -tags=integration ./tests/...
docker compose -f deployments/docker-compose.test.yml down
\`\`\`

Integration tests must cover:
- Full request lifecycle: client → gateway → mock upstream → response
- JWT authentication end-to-end
- Rate limiting with real Redis
- Circuit breaker state transitions under upstream failure
- Health check reflects actual dependency status

### Gate 8: Benchmark Baselines Established

\`\`\`bash
go test -bench=. -benchmem ./internal/auth/...
go test -bench=. -benchmem ./internal/ratelimit/...
go test -bench=. -benchmem ./internal/circuit/...
go test -bench=. -benchmem ./internal/middleware/...
\`\`\`

**Performance targets**:
| Operation | Target p99 | Max Allocs |
|-----------|-----------|------------|
| JWT validation | <2ms | <10 allocs/op |
| Rate limit check (Redis) | <1ms | <5 allocs/op |
| Circuit breaker check | <0.01ms | 0 allocs/op |
| Full middleware chain (no upstream) | <5ms | <50 allocs/op |

Store benchmark results in \`docs/benchmarks/phase-04-baseline.txt\` for regression tracking.

### Gate 9: Security Review

- [ ] JWT: RS256 only, no \`alg: none\` accepted, no HS256 fallback
- [ ] API keys: hashed in PostgreSQL (bcrypt or argon2), never logged
- [ ] Rate limit keys: no PII in Redis key names
- [ ] Error responses: no stack traces or internal details in production
- [ ] Headers: \`X-Content-Type-Options: nosniff\`, \`X-Frame-Options: DENY\` set
- [ ] TLS: gateway expects TLS termination at ALB; internal traffic over private subnet
- [ ] OWASP API Security Top 10: injection via headers mitigated, broken auth tested
- [ ] SOC 2: audit log for auth failures, rate limit overrides, config changes

### Gate 10: Documentation Updated

- [ ] \`docs/architecture.md\` updated with middleware chain diagram
- [ ] \`docs/api.md\` documents health check, metrics, and proxy endpoints
- [ ] \`docs/configuration.md\` documents all new config keys (rate limits, circuit breaker thresholds, JWT settings)
- [ ] \`docs/runbooks/auth-failure.md\` — troubleshooting auth issues
- [ ] \`docs/runbooks/rate-limit-tuning.md\` — adjusting rate limits
- [ ] \`docs/runbooks/circuit-breaker.md\` — understanding and resetting circuit breakers
- [ ] All exported types and functions have GoDoc comments

---

## File Length Enforcement

No file in \`internal/\` or \`cmd/\` may exceed 300 lines. If a file approaches this limit:

1. Extract a sub-package or helper file
2. Move test helpers to \`_test.go\` helper files or \`testutil/\` package
3. Split large test files by concern (e.g., \`jwt_valid_test.go\`, \`jwt_invalid_test.go\`)

Check with:
\`\`\`bash
find internal/ cmd/ -name '*.go' -exec awk 'END{if(NR>300) print FILENAME": "NR" lines"}' {} \\;
\`\`\`

---

## Dependency Inventory

New dependencies introduced in this phase (conservative policy — justify each):

| Dependency | Purpose | Justification |
|-----------|---------|---------------|
| \`github.com/go-chi/chi/v5\` | HTTP router | Already in foundation; composable middleware |
| \`github.com/redis/go-redis/v9\` | Redis client | Rate limiting, caching; official client |
| \`github.com/golang-jwt/jwt/v5\` | JWT parsing | Industry standard, actively maintained |
| \`github.com/prometheus/client_golang\` | Prometheus metrics | Standard Go Prometheus client |
| \`go.opentelemetry.io/otel\` | Distributed tracing | CNCF standard for observability |
| \`go.opentelemetry.io/otel/exporters/otlp\` | OTLP exporter | Export traces to Jaeger/collector |
| \`github.com/stretchr/testify\` | Test assertions | Already in foundation; cleaner test code |

**No additional dependencies** should be added without team discussion. Use stdlib where possible (\`net/http/httputil\` for reverse proxy, \`crypto/rsa\` for JWT, \`sync\` for circuit breaker).

---

## Common Pitfalls

1. **Middleware ordering**: Auth must come before rate limiting. Tracing must come before logging (so log lines include trace ID). Recovery must be outermost.
2. **Context leaks**: Always use \`context.WithTimeout\` for upstream calls; never use \`context.Background()\` in handlers.
3. **Redis connection exhaustion**: Set \`MaxRetries\`, \`PoolSize\`, \`MinIdleConns\` on Redis client. Monitor with \`redis_pool_*\` metrics.
4. **JWT key caching**: Don't reload PEM files on every request. Cache parsed \`*rsa.PublicKey\` in memory with periodic refresh.
5. **Circuit breaker per-upstream**: Don't use a single global breaker. Each upstream gets its own \`Breaker\` instance via the registry.
6. **Goroutine leaks in tests**: Use \`goleak\` or verify goroutine count in integration tests.
7. **Table-driven test naming**: Use descriptive subtest names — \`t.Run("expired_token_returns_401", ...)\` not \`t.Run("test1", ...)\`.

---

## Phase Completion Checklist

\`\`\`
[ ] D1: Auth middleware — JWT, API keys, RBAC implemented and tested
[ ] D2: Rate limiting — sliding window with Redis, middleware integrated
[ ] D3: Reverse proxy — routing, upstream management, header propagation
[ ] D4: Circuit breaker — state machine, per-upstream registry
[ ] D5: Transformations — header/path/query manipulation
[ ] D6: Observability — tracing, metrics, structured logging
[ ] D7: Assembly — full middleware chain wired, gateway starts and routes
[ ] All quality gates pass (coverage, lint, race, benchmarks, security)
[ ] Documentation updated
[ ] Benchmark baselines recorded
[ ] Phase tag created: git tag phase-04-core-implementation
[ ] current-phase.json updated to phase 05
\`\`\`

---

## Transition to Phase 05

With core implementation complete, Phase 05 (Testing & Hardening) focuses on:

- Load testing with \`k6\` or \`vegeta\` to validate performance targets
- Chaos testing: kill Redis, kill upstream, network partitions
- Fuzz testing on JWT parser and header transformation
- Security scanning with \`gosec\` and \`trivy\` on Docker image
- pprof profiling under load to identify bottlenecks
- Connection pool tuning based on load test results

See [Phase 05: Testing & Hardening](./05-testing-hardening.md) for details.`,

  'playbook/phases/05-integration-hardening.md': `# Phase 05 — Integration & Hardening

## Overview

Phase 05 brings all gateway components together into a cohesive, production-grade system. Individual modules (authentication, rate limiting, circuit breakers, routing, observability) are integrated end-to-end, hardened against failure modes, and validated under realistic conditions. This phase transforms working components into a resilient API gateway ready for production traffic.

## Prerequisites

- Phase 03 (Foundation) complete: project structure, configuration, database schemas, core middleware
- Phase 04 (Core Development) complete: all handler/service/repository layers implemented and unit-tested
- All individual components passing unit tests at ≥80% coverage
- PostgreSQL and Redis dependencies running in local Docker Compose
- CI pipeline green on \`main\` branch

## Objectives

### 1. End-to-End Middleware Chain Integration

Wire the complete Chi middleware chain in the correct order and verify request lifecycle:

\`\`\`go
// cmd/gateway/main.go — middleware ordering matters
r := chi.NewRouter()
r.Use(middleware.RequestID)           // assign trace-friendly request ID
r.Use(middleware.RealIP)              // extract client IP behind ALB
r.Use(observability.TracingMiddleware) // OpenTelemetry span creation
r.Use(observability.MetricsMiddleware) // Prometheus request metrics
r.Use(middleware.LoggingMiddleware)    // slog structured access log
r.Use(middleware.RecoveryMiddleware)   // panic recovery with stack trace
r.Use(middleware.CORSMiddleware)       // CORS headers
r.Use(middleware.TimeoutMiddleware)    // per-request deadline (30s default)
r.Use(ratelimit.Middleware)           // Redis sliding window rate limit
r.Use(auth.JWTMiddleware)            // RS256 JWT validation + RBAC
\`\`\`

Validate that:
- Context propagation flows through every middleware layer
- Request IDs appear in all log entries and trace spans
- Errors at any layer produce correct HTTP status codes and structured error responses
- Middleware short-circuits appropriately (rate limit → 429 before auth, auth → 401 before handler)

### 2. Integration Testing

Write integration tests in \`tests/\` that exercise real infrastructure:

\`\`\`
tests/
  integration/
    auth_flow_test.go         # JWT issuance → validation → RBAC enforcement
    ratelimit_test.go         # Redis-backed rate limiting under concurrent load
    circuit_breaker_test.go   # Upstream failure → open circuit → fallback → recovery
    routing_test.go           # Dynamic route matching, path params, query forwarding
    health_check_test.go      # Liveness + readiness with dependency checks
    graceful_shutdown_test.go # In-flight request completion on SIGTERM
    observability_test.go     # Trace propagation, metric emission, log correlation
    e2e_gateway_test.go       # Full request lifecycle through all middleware
\`\`\`

Integration test requirements:
- Use \`testcontainers-go\` for PostgreSQL and Redis (no mocks for integration tests)
- Use \`httptest.Server\` wrapping the real Chi router
- Table-driven test structure with descriptive subtests
- Tests must be tagged: \`//go:build integration\`
- Run separately in CI: \`go test -tags=integration -race -timeout 120s ./tests/integration/...\`

### 3. Authentication Hardening

Validate all authentication paths under adversarial conditions:

| Scenario | Expected Behavior |
|---|---|
| Expired JWT | 401 with \`token_expired\` error code |
| JWT signed with wrong key | 401 with \`invalid_signature\` error code |
| JWT with tampered claims | 401 with \`invalid_token\` error code |
| JWT missing required RBAC role | 403 with \`insufficient_permissions\` error code |
| API key not found in PostgreSQL | 401 with \`invalid_api_key\` error code |
| API key revoked | 401 with \`api_key_revoked\` error code |
| API key rate limit exceeded | 429 with \`rate_limit_exceeded\` error code |
| Missing Authorization header | 401 with \`missing_credentials\` error code |
| RS256 key rotation (JWKS refresh) | Seamless validation with new key |
| Concurrent auth requests | No race conditions in key cache |

Verify SOC 2 audit logging:
- All authentication failures logged with client IP, request ID, failure reason
- Successful authentications logged with subject, roles, API key ID
- No sensitive data (tokens, keys) in log output
- Audit log entries include timestamps in RFC 3339 format

### 4. Rate Limiting Hardening

Validate Redis-backed sliding window rate limiter:

\`\`\`go
// tests/integration/ratelimit_test.go
func TestRateLimiting(t *testing.T) {
    tests := []struct {
        name           string
        clientID       string
        requestCount   int
        windowDuration time.Duration
        limit          int
        wantBlocked    int
    }{
        {"under limit", "client-a", 50, time.Minute, 100, 0},
        {"at limit", "client-b", 100, time.Minute, 100, 0},
        {"over limit", "client-c", 150, time.Minute, 100, 50},
        {"separate clients isolated", "client-d", 100, time.Minute, 100, 0},
        {"window reset", "client-e", 100, 1 * time.Second, 100, 0}, // wait, retry
    }
    // ...
}
\`\`\`

Hardening scenarios:
- Redis connection failure → fallback to local in-memory rate limiter (degraded mode)
- Redis latency spike → timeout after 50ms, allow request (fail-open)
- Concurrent requests from same client → atomic counter increment (no race)
- Rate limit headers present: \`X-RateLimit-Limit\`, \`X-RateLimit-Remaining\`, \`X-RateLimit-Reset\`
- Per-client and per-route rate limit configuration from PostgreSQL

### 5. Circuit Breaker Hardening

Validate circuit breaker state machine for upstream services:

\`\`\`
States: Closed → Open → Half-Open → Closed
                ↑                      |
                └──────────────────────┘ (on failure in half-open)
\`\`\`

| Scenario | Threshold | Expected State Transition |
|---|---|---|
| 5 consecutive upstream 5xx | 5 failures | Closed → Open |
| Open circuit, request arrives | — | Return 503 with \`circuit_open\` error, no upstream call |
| Open for 30s, probe request | timeout elapsed | Open → Half-Open, send 1 probe |
| Probe succeeds | — | Half-Open → Closed |
| Probe fails | — | Half-Open → Open (reset timer) |
| Upstream timeout (>5s) | counts as failure | Increment failure counter |
| Upstream returns 4xx | not a failure | No state change |

Integration test: spin up a mock upstream with controllable failure injection, verify state transitions and metric emissions (\`gateway_circuit_breaker_state{upstream="service-a"}\`).

### 6. Observability Integration

Verify the full observability stack works end-to-end:

**Distributed Tracing (OpenTelemetry → Jaeger)**
- Every request creates a root span with \`gateway.request\` operation
- Middleware layers create child spans: \`auth.validate\`, \`ratelimit.check\`, \`circuit.check\`
- Upstream proxy calls propagate trace context via \`traceparent\` header
- Span attributes include: \`http.method\`, \`http.route\`, \`http.status_code\`, \`client.id\`
- Error spans include \`error=true\` and \`error.message\` attributes

**Metrics (Prometheus)**
- \`gateway_requests_total{method, route, status}\` — request counter
- \`gateway_request_duration_seconds{method, route}\` — latency histogram
- \`gateway_active_connections\` — gauge of in-flight requests
- \`gateway_rate_limit_hits_total{client_id}\` — rate limit rejections
- \`gateway_circuit_breaker_state{upstream}\` — circuit state (0=closed, 1=open, 2=half-open)
- \`gateway_upstream_request_duration_seconds{upstream}\` — upstream latency
- \`/metrics\` endpoint returns valid Prometheus exposition format

**Structured Logging (slog)**
- All log entries include: \`request_id\`, \`trace_id\`, \`span_id\`, \`method\`, \`path\`, \`client_ip\`
- Log levels used correctly: DEBUG for middleware entry/exit, INFO for requests, WARN for degraded mode, ERROR for failures
- No \`fmt.Println\` or \`log.Printf\` anywhere in codebase
- Log output is JSON in staging/production, text in development

### 7. Graceful Shutdown

Verify the gateway handles termination signals correctly:

\`\`\`go
// Expected shutdown sequence:
// 1. Receive SIGTERM/SIGINT
// 2. Stop accepting new connections
// 3. Wait for in-flight requests to complete (up to 30s)
// 4. Close Redis connection pool
// 5. Close PostgreSQL connection pool
// 6. Flush OpenTelemetry spans
// 7. Log shutdown complete
// 8. Exit 0
\`\`\`

Test scenarios:
- In-flight request completes before timeout → clean shutdown, exit 0
- In-flight request exceeds 30s grace period → force close, exit 0, log warning
- Health check returns 503 during shutdown (readiness probe fails, ALB drains)
- No goroutine leaks after shutdown (\`goleak\` check)

### 8. Security Hardening

Apply OWASP API Security Top 10 mitigations:

| OWASP Risk | Mitigation | Verification |
|---|---|---|
| API1: Broken Object Level Auth | RBAC enforcement per route | Integration test with role matrix |
| API2: Broken Authentication | RS256 JWT, key rotation, constant-time comparison | Auth hardening tests above |
| API3: Broken Object Property Level Auth | Response field filtering by role | Transform middleware test |
| API4: Unrestricted Resource Consumption | Per-client rate limiting | Rate limit hardening tests above |
| API5: Broken Function Level Auth | Route-level RBAC middleware | Forbidden route access tests |
| API7: Server Side Request Forgery | Upstream allowlist validation | Reject non-allowlisted upstreams |
| API8: Security Misconfiguration | TLS required, secure headers, no debug in prod | Config validation test |

Additional hardening:
- Request body size limit: 1MB default, configurable per route
- Request header count limit: 100 headers max
- Slow loris protection via read/write timeouts on \`http.Server\`
- No stack traces in production error responses
- Security headers: \`X-Content-Type-Options: nosniff\`, \`X-Frame-Options: DENY\`, \`Strict-Transport-Security\`
- \`gosec\` linter passing with zero findings

### 9. Performance Baseline

Establish performance benchmarks before production deployment:

\`\`\`bash
# Run Go benchmarks
go test -bench=. -benchmem -count=5 ./internal/... | tee benchmarks/baseline.txt

# Key benchmarks to write
BenchmarkMiddlewareChain          # Full middleware stack overhead
BenchmarkJWTValidation            # RS256 token validation
BenchmarkRateLimitCheck           # Redis sliding window check
BenchmarkCircuitBreakerCheck      # Circuit state evaluation
BenchmarkRouteMatching            # Chi router path matching
BenchmarkResponseSerialization    # JSON response encoding
\`\`\`

Performance targets:
- p50 latency through full middleware chain: <5ms (excluding upstream)
- p99 latency through full middleware chain: <20ms (excluding upstream)
- Throughput: >10,000 requests/second on 2 vCPU
- Memory: <100MB RSS under steady-state load
- No goroutine leaks under sustained load (verify with pprof)

Load testing with \`scripts/load_test.sh\`:
\`\`\`bash
# Use k6 or vegeta for load testing
vegeta attack -rate=5000/s -duration=60s -targets=targets.txt | vegeta report
\`\`\`

Profile with pprof:
\`\`\`bash
go tool pprof http://localhost:6060/debug/pprof/profile?seconds=30
go tool pprof http://localhost:6060/debug/pprof/heap
\`\`\`

### 10. Docker & Local Environment

Validate the complete local development environment:

\`\`\`yaml
# docker-compose.yml services
services:
  gateway:       # Go binary with hot reload (air)
  postgres:      # Config store, API key metadata
  redis:         # Rate limiting, caching
  jaeger:        # Trace visualization
  prometheus:    # Metrics collection
  grafana:       # Dashboards
  mock-upstream: # Controllable mock for integration testing
\`\`\`

Verify:
- \`docker compose up\` starts all services and gateway is healthy within 30s
- Gateway connects to PostgreSQL and Redis on startup (retry with backoff)
- Jaeger UI shows traces at \`http://localhost:16686\`
- Prometheus scrapes gateway metrics at \`http://localhost:9090\`
- Grafana dashboard loads with gateway panels at \`http://localhost:3000\`

## Deliverables

| # | Deliverable | Location | Acceptance Criteria |
|---|---|---|---|
| 1 | Integration test suite | \`tests/integration/\` | All tests pass with \`-race\`, ≥80% coverage of integration paths |
| 2 | Auth hardening tests | \`tests/integration/auth_flow_test.go\` | All adversarial scenarios in auth matrix covered |
| 3 | Rate limit hardening tests | \`tests/integration/ratelimit_test.go\` | Redis failure fallback verified, concurrent safety proven |
| 4 | Circuit breaker tests | \`tests/integration/circuit_breaker_test.go\` | All state transitions verified with metrics |
| 5 | Observability validation | \`tests/integration/observability_test.go\` | Traces, metrics, and logs correlated by request ID |
| 6 | Graceful shutdown test | \`tests/integration/graceful_shutdown_test.go\` | Clean shutdown with in-flight requests, no goroutine leaks |
| 7 | Security hardening | \`internal/middleware/security.go\` | OWASP mitigations applied, \`gosec\` clean |
| 8 | Performance benchmarks | \`benchmarks/baseline.txt\` | Baseline numbers documented, targets met |
| 9 | Load test scripts | \`scripts/load_test.sh\` | Reproducible load test with documented results |
| 10 | Docker Compose environment | \`docker-compose.yml\` | Full stack starts and gateway passes health checks |
| 11 | Runbook draft | \`docs/runbook.md\` | Incident response procedures for common failure modes |

## Quality Gates

All gates must pass before advancing to Phase 06 (Deployment & Release):

### Gate 1: Integration Tests Green
\`\`\`bash
go test -tags=integration -race -timeout 120s -coverprofile=integration.cov ./tests/integration/...
# All tests PASS, no race conditions detected
\`\`\`

### Gate 2: Full Lint Suite Clean
\`\`\`bash
golangci-lint run --config .golangci.yml ./...
# Zero issues (govet, errcheck, staticcheck, gosec, revive, gocyclo)
\`\`\`

### Gate 3: Coverage Threshold Met
\`\`\`bash
go test -coverprofile=coverage.out ./...
go tool cover -func=coverage.out | grep total
# total: (statements) >= 80.0%
\`\`\`

### Gate 4: Race Detector Clean
\`\`\`bash
go test -race ./...
# Zero data races detected
\`\`\`

### Gate 5: Security Scan Clean
\`\`\`bash
gosec -fmt=json ./...
# Zero HIGH or MEDIUM findings
\`\`\`

### Gate 6: Performance Targets Met
\`\`\`bash
go test -bench=BenchmarkMiddlewareChain -benchmem -count=5 ./internal/middleware/
# Verify p99 < 20ms, allocation count within budget
\`\`\`

### Gate 7: Docker Environment Healthy
\`\`\`bash
docker compose up -d
scripts/health_check.sh  # All services healthy within 60s
docker compose down
\`\`\`

### Gate 8: No Goroutine Leaks
\`\`\`bash
go test -tags=integration ./tests/integration/... -run TestGracefulShutdown
# goleak reports zero unexpected goroutines
\`\`\`

### Gate 9: Documentation Complete
- [ ] \`docs/runbook.md\` covers: startup, shutdown, rate limit tuning, circuit breaker tuning, key rotation
- [ ] \`docs/architecture.md\` updated with integration diagrams
- [ ] All exported functions in \`internal/\` have doc comments
- [ ] \`README.md\` updated with local development instructions

### Gate 10: Code Review Approval
- [ ] PR reviewed by at least 1 senior/lead developer
- [ ] No unresolved review comments
- [ ] CODEOWNERS approval for \`internal/auth/**\` and \`internal/middleware/**\`
- [ ] AI-generated code flagged per CI policy

## Common Failure Modes & Mitigations

| Failure Mode | Detection | Mitigation |
|---|---|---|
| Redis connection lost | Health check fails, rate limit errors in logs | Fallback to in-memory limiter, alert on-call |
| PostgreSQL connection lost | Health check fails, config reload errors | Serve from cached config, alert on-call |
| JWT signing key expired | Auth failures spike in metrics | Automated JWKS refresh, key rotation runbook |
| Upstream service down | Circuit breaker opens, 503 responses | Return cached response or graceful degradation |
| Memory leak under load | RSS growth in Prometheus, OOM kill | pprof heap analysis, goroutine leak check |
| Slow upstream causing timeout cascade | p99 latency spike, active connections gauge rising | Circuit breaker opens, request timeout enforced |

## Phase Transition

When all quality gates pass:

\`\`\`bash
./playbook/codeforge-phase.sh set 6
\`\`\`

Phase 06 (Deployment & Release) covers: Terraform infrastructure provisioning, Helm chart finalization, CI/CD pipeline for staging and production, canary deployment strategy, and production readiness review.`,

  'playbook/phases/06-testing-quality.md': `# Phase 06: Testing & Quality

## Phase Overview

**Phase**: 06 of 10
**Name**: Testing & Quality
**Duration**: 1–2 sprints
**Goal**: Establish comprehensive test coverage, performance benchmarks, and quality gates that ensure the API gateway meets reliability, security, and performance requirements for production traffic.

## Prerequisites

- Phase 05 (Core Development) substantially complete
- Core middleware chain functional: auth, rate limiting, routing, circuit breaker
- PostgreSQL and Redis integrations operational
- OpenTelemetry and Prometheus instrumentation in place
- CI pipeline running lint, vet, and basic unit tests

## Objectives

1. **Achieve ≥80% code coverage** across all packages with meaningful, non-trivial tests
2. **Establish table-driven unit tests** for every handler, service, and repository
3. **Build integration test suite** covering PostgreSQL, Redis, and end-to-end HTTP flows
4. **Create performance benchmarks** for critical hot paths (routing, auth, rate limiting)
5. **Validate security posture** against OWASP API Security Top 10 and SOC 2 controls
6. **Implement race condition detection** as a mandatory CI gate
7. **Set up load testing** to validate throughput and latency SLAs
8. **Harden error handling** — verify all errors are wrapped, logged, and returned correctly

## Deliverables

### 6.1 Unit Test Suite

**Location**: \`*_test.go\` files colocated with source

#### Handler Tests (\`internal/handler/\`)

\`\`\`
internal/handler/
  route_handler_test.go       # Request routing, path matching, upstream forwarding
  health_handler_test.go      # Liveness and readiness probe responses
  admin_handler_test.go       # Config reload, route management endpoints
\`\`\`

- Use \`httptest.NewRecorder()\` and \`httptest.NewRequest()\` for all handler tests
- Mock service layer via interfaces — never hit real databases in unit tests
- Test all HTTP status codes: 200, 201, 400, 401, 403, 404, 429, 500, 502, 503
- Verify response body structure, headers, and content type
- Test Chi URL parameter extraction (\`chi.URLParam\`)

\`\`\`go
// Example: table-driven handler test pattern
func TestRouteHandler_Forward(t *testing.T) {
    tests := []struct {
        name           string
        method         string
        path           string
        setupMock      func(*mocks.MockRouteService)
        wantStatus     int
        wantBodyContains string
    }{
        {
            name:       "valid route forwards successfully",
            method:     http.MethodGet,
            path:       "/api/v1/users",
            setupMock:  func(m *mocks.MockRouteService) { m.On("Forward", mock.Anything, mock.Anything).Return(nil) },
            wantStatus: http.StatusOK,
        },
        {
            name:       "unknown route returns 404",
            method:     http.MethodGet,
            path:       "/api/v1/nonexistent",
            setupMock:  func(m *mocks.MockRouteService) { m.On("Forward", mock.Anything, mock.Anything).Return(ErrRouteNotFound) },
            wantStatus: http.StatusNotFound,
        },
        // ... additional cases
    }
    for _, tt := range tests {
        t.Run(tt.name, func(t *testing.T) {
            // arrange, act, assert
        })
    }
}
\`\`\`

#### Middleware Tests (\`internal/middleware/\`)

\`\`\`
internal/middleware/
  auth_middleware_test.go      # JWT validation, API key verification, RBAC enforcement
  ratelimit_middleware_test.go # Per-client rate limiting, burst handling, Redis fallback
  logging_middleware_test.go   # Request/response logging, sensitive field redaction
  cors_middleware_test.go      # CORS header validation, preflight handling
  recovery_middleware_test.go  # Panic recovery, error response format
  requestid_middleware_test.go # X-Request-ID generation and propagation
\`\`\`

- Verify middleware composes correctly as Chi middleware (\`func(next http.Handler) http.Handler\`)
- Test middleware ordering dependencies (e.g., auth before rate limiting)
- Test bypass conditions (e.g., health check paths skip auth)
- Verify context propagation through middleware chain

#### Service Tests (\`internal/service/\`)

\`\`\`
internal/service/
  route_service_test.go       # Route matching, upstream selection, retry logic
  auth_service_test.go        # Token validation, claims extraction, key rotation
  ratelimit_service_test.go   # Sliding window algorithm, quota calculation
  circuit_service_test.go     # State transitions: closed → open → half-open
  config_service_test.go      # Dynamic config reload, validation
\`\`\`

- Mock repository interfaces — test business logic in isolation
- Test error wrapping: every error path must use \`fmt.Errorf("context: %w", err)\`
- Verify context cancellation is respected
- Test concurrent access patterns where applicable

#### Auth Package Tests (\`internal/auth/\`)

\`\`\`
internal/auth/
  jwt_test.go                 # RS256 validation, claims parsing, expiry, audience
  apikey_test.go              # API key lookup, hash comparison, rotation
  rbac_test.go                # Role-based access control, permission checks
\`\`\`

- Test with valid, expired, malformed, and tampered JWTs
- Test RS256 with actual test key pairs (committed in \`testdata/\`)
- Verify constant-time comparison for API key validation
- Test RBAC with multiple role hierarchies

#### Rate Limiter Tests (\`internal/ratelimit/\`)

\`\`\`
internal/ratelimit/
  sliding_window_test.go      # Algorithm correctness, window boundaries
  limiter_test.go             # Client identification, quota lookup, fallback
\`\`\`

- Test sliding window edge cases: exact boundary, mid-window, window rollover
- Test fallback behavior when Redis is unavailable
- Test concurrent requests from same client

#### Circuit Breaker Tests (\`internal/circuit/\`)

\`\`\`
internal/circuit/
  breaker_test.go             # State machine transitions, thresholds, timeouts
\`\`\`

- Test state transitions: closed → open (after N failures), open → half-open (after timeout), half-open → closed (on success)
- Test concurrent state reads during transitions
- Test per-upstream circuit isolation

#### Repository Tests (\`internal/repository/\`)

\`\`\`
internal/repository/
  route_repo_test.go          # Route CRUD, query patterns
  apikey_repo_test.go         # API key storage, lookup by hash
\`\`\`

- Unit tests use mock interfaces
- Integration tests (see 6.2) use real databases

#### Error Package Tests (\`pkg/errors/\`)

\`\`\`
pkg/errors/
  errors_test.go              # Error types, codes, wrapping, HTTP status mapping
\`\`\`

- Verify \`errors.Is()\` and \`errors.As()\` work correctly with custom types
- Test error code to HTTP status mapping

### 6.2 Integration Test Suite

**Location**: \`tests/integration/\`

\`\`\`
tests/integration/
  gateway_test.go             # Full request lifecycle through gateway
  auth_integration_test.go    # JWT + PostgreSQL API key validation
  ratelimit_integration_test.go # Rate limiting with real Redis
  routing_integration_test.go # Request routing to mock upstreams
  circuit_integration_test.go # Circuit breaker with failing upstreams
  health_test.go              # Health check with dependency verification
  config_reload_test.go       # Dynamic configuration reload
  docker-compose.test.yml     # PostgreSQL + Redis for test environment
\`\`\`

#### Test Infrastructure

\`\`\`yaml
# tests/integration/docker-compose.test.yml
services:
  postgres-test:
    image: postgres:16-alpine
    environment:
      POSTGRES_DB: gateway_test
      POSTGRES_USER: test
      POSTGRES_PASSWORD: test
    ports:
      - "5433:5432"
    tmpfs:
      - /var/lib/postgresql/data  # RAM-backed for speed

  redis-test:
    image: redis:7-alpine
    ports:
      - "6380:6379"
    command: redis-server --save ""  # No persistence for speed

  mock-upstream:
    image: kennethreitz/httpbin
    ports:
      - "8081:80"
\`\`\`

#### Integration Test Patterns

- Use build tags: \`//go:build integration\`
- Each test gets a clean database state (truncate tables in \`TestMain\` or per-test setup)
- Use \`t.Cleanup()\` for resource teardown
- Test full HTTP request lifecycle: client → gateway → upstream → client
- Verify distributed tracing spans are created correctly
- Verify Prometheus metrics are incremented

\`\`\`go
//go:build integration

package integration

func TestGateway_FullRequestLifecycle(t *testing.T) {
    // Start gateway with test config
    // Send authenticated request
    // Verify routing to mock upstream
    // Verify response transformation
    // Verify metrics incremented
    // Verify trace spans created
    // Verify structured log entries
}
\`\`\`

### 6.3 Performance Benchmarks

**Location**: Colocated \`*_test.go\` files with \`Benchmark\` prefix

\`\`\`go
// internal/middleware/auth_middleware_test.go
func BenchmarkJWTValidation(b *testing.B) {
    token := generateTestJWT(b)
    validator := auth.NewJWTValidator(testPublicKey)
    b.ResetTimer()
    b.RunParallel(func(pb *testing.PB) {
        for pb.Next() {
            _, err := validator.Validate(context.Background(), token)
            require.NoError(b, err)
        }
    })
}

// internal/ratelimit/sliding_window_test.go
func BenchmarkSlidingWindowCheck(b *testing.B) { /* ... */ }

// internal/handler/route_handler_test.go
func BenchmarkRouteMatching(b *testing.B) { /* ... */ }

// internal/middleware/full_chain_test.go
func BenchmarkFullMiddlewareChain(b *testing.B) { /* ... */ }
\`\`\`

**Required benchmarks**:

| Benchmark | Target | Notes |
|-----------|--------|-------|
| JWT RS256 validation | < 100µs/op | Hot path — every authenticated request |
| API key lookup (cached) | < 10µs/op | Redis cache hit |
| Rate limit check | < 50µs/op | Redis EVALSHA sliding window |
| Route matching (50 routes) | < 5µs/op | Chi router trie lookup |
| Full middleware chain | < 500µs/op | All middleware, no upstream call |
| Request/response logging | < 20µs/op | slog structured output |

Run benchmarks:

\`\`\`bash
go test -bench=. -benchmem -count=5 -run=^$ ./internal/...
\`\`\`

### 6.4 Load Tests

**Location**: \`scripts/loadtest/\`

\`\`\`
scripts/loadtest/
  k6-gateway.js               # k6 load test script
  k6-auth-flow.js             # Authentication-focused load test
  k6-ratelimit.js             # Rate limiting validation under load
  vegeta-targets.txt           # Vegeta attack targets
  run-loadtest.sh             # Orchestration script
\`\`\`

**k6 SLA validation**:

\`\`\`javascript
// scripts/loadtest/k6-gateway.js
export const options = {
  stages: [
    { duration: '30s', target: 100 },   // Ramp up
    { duration: '2m',  target: 500 },   // Sustained load
    { duration: '30s', target: 1000 },  // Peak
    { duration: '30s', target: 0 },     // Ramp down
  ],
  thresholds: {
    http_req_duration: ['p(95)<100', 'p(99)<250'],  // ms
    http_req_failed: ['rate<0.01'],                   // <1% error rate
    http_reqs: ['rate>1000'],                         // >1000 RPS sustained
  },
};
\`\`\`

**Vegeta for sustained throughput testing**:

\`\`\`bash
echo "GET http://localhost:8080/api/v1/health" | \\
  vegeta attack -duration=60s -rate=2000/s | \\
  vegeta report
\`\`\`

### 6.5 Security Tests

**Location**: \`tests/security/\`

\`\`\`
tests/security/
  jwt_security_test.go        # JWT attack vectors
  injection_test.go           # Header injection, path traversal
  ratelimit_bypass_test.go    # Rate limit circumvention attempts
  tls_test.go                 # TLS configuration validation
  apikey_security_test.go     # Timing attacks, key enumeration
\`\`\`

**OWASP API Security Top 10 coverage**:

| OWASP Risk | Test Coverage |
|------------|---------------|
| API1: Broken Object Level Auth | RBAC enforcement tests, resource isolation |
| API2: Broken Authentication | JWT tampering, expired tokens, algorithm confusion |
| API3: Broken Object Property Level Auth | Response field filtering tests |
| API4: Unrestricted Resource Consumption | Rate limiting tests, payload size limits |
| API5: Broken Function Level Auth | Admin endpoint access control |
| API6: Unrestricted Access to Sensitive Business Flows | Circuit breaker, abuse detection |
| API7: Server Side Request Forgery | Upstream URL validation, allowlist enforcement |
| API8: Security Misconfiguration | TLS settings, CORS policy, header exposure |
| API9: Improper Inventory Management | Route registration audit, deprecated endpoint detection |
| API10: Unsafe Consumption of APIs | Upstream response validation, timeout enforcement |

**SOC 2 specific tests**:

- Verify audit log completeness (all auth events logged)
- Verify sensitive data redaction in logs (no tokens, keys, or PII)
- Verify API key hash storage (never plaintext)
- Verify TLS minimum version (TLS 1.2+)
- Verify graceful shutdown drains connections

### 6.6 Profiling Artifacts

**Location**: \`scripts/profile/\`

\`\`\`
scripts/profile/
  run-pprof.sh                # CPU and memory profiling script
  analyze-traces.sh           # Trace analysis for latency hotspots
\`\`\`

\`\`\`bash
#!/usr/bin/env bash
# scripts/profile/run-pprof.sh
# Profile the gateway under load

# CPU profile (30 seconds)
curl -o cpu.prof "http://localhost:6060/debug/pprof/profile?seconds=30"
go tool pprof -http=:8090 cpu.prof

# Memory profile
curl -o heap.prof "http://localhost:6060/debug/pprof/heap"
go tool pprof -http=:8091 heap.prof

# Goroutine profile (detect leaks)
curl -o goroutine.prof "http://localhost:6060/debug/pprof/goroutine"
go tool pprof -http=:8092 goroutine.prof

# Mutex contention
curl -o mutex.prof "http://localhost:6060/debug/pprof/mutex"
go tool pprof -http=:8093 mutex.prof
\`\`\`

### 6.7 Test Utilities

**Location**: \`internal/testutil/\`

\`\`\`
internal/testutil/
  fixtures.go                 # Test JWT tokens, API keys, route configs
  helpers.go                  # Common test setup, assertion helpers
  mocks.go                    # Shared mock implementations
  testdb.go                   # Test database setup/teardown
  testredis.go                # Test Redis setup/teardown
\`\`\`

- Generate RS256 test key pair once, store in \`internal/testutil/testdata/\`
- Provide \`NewTestGateway(t *testing.T)\` that wires up a fully configured gateway for integration tests
- Provide \`NewMockUpstream(t *testing.T, responses map[string]http.HandlerFunc)\` for upstream simulation

## Quality Gates

All gates must pass before Phase 06 is considered complete.

### Gate 1: Code Coverage

\`\`\`bash
go test -coverprofile=coverage.out -covermode=atomic ./internal/... ./pkg/...
go tool cover -func=coverage.out | grep total | awk '{print $3}'
# Must be ≥ 80%
\`\`\`

**Per-package minimums**:

| Package | Minimum Coverage |
|---------|-----------------|
| \`internal/auth\` | 90% |
| \`internal/middleware\` | 85% |
| \`internal/handler\` | 80% |
| \`internal/service\` | 85% |
| \`internal/ratelimit\` | 90% |
| \`internal/circuit\` | 90% |
| \`pkg/errors\` | 95% |
| \`pkg/httputil\` | 85% |

### Gate 2: All Tests Pass

\`\`\`bash
# Unit tests
go test -v -count=1 ./internal/... ./pkg/...

# Integration tests
go test -v -count=1 -tags=integration ./tests/integration/...

# Race detection
go test -race -count=1 ./internal/... ./pkg/...
\`\`\`

- Zero test failures
- Zero data races detected
- All tests complete within 5 minutes (unit) / 10 minutes (integration)

### Gate 3: Linting Clean

\`\`\`bash
golangci-lint run --config .golangci.yml ./...
\`\`\`

- Zero errors from: govet, errcheck, staticcheck, gosec, revive, gocyclo
- Cyclomatic complexity ≤ 15 per function
- No \`gosec\` findings of severity HIGH or CRITICAL

### Gate 4: Benchmark Baselines Established

\`\`\`bash
go test -bench=. -benchmem -count=5 -run=^$ ./internal/... | tee benchmarks.txt
\`\`\`

- All benchmarks documented with target thresholds
- No benchmark exceeds 2x its target
- Zero allocations in hot-path benchmarks where possible
- Benchmark results committed to \`docs/benchmarks.md\`

### Gate 5: Security Scan

\`\`\`bash
# Static analysis
gosec -fmt=json -out=gosec-report.json ./...

# Dependency vulnerabilities
govulncheck ./...

# Docker image scan
trivy image go-api-gateway:latest --severity HIGH,CRITICAL
\`\`\`

- Zero HIGH/CRITICAL findings in gosec
- Zero known vulnerabilities in dependencies
- Zero HIGH/CRITICAL CVEs in Docker image

### Gate 6: Load Test SLAs Met

| Metric | Threshold |
|--------|-----------|
| p95 latency (passthrough) | < 100ms |
| p99 latency (passthrough) | < 250ms |
| Error rate at 1000 RPS | < 1% |
| Sustained throughput | > 1000 RPS |
| Memory under load (30 min) | No growth trend (no leaks) |
| Graceful shutdown drain | < 30 seconds |

### Gate 7: Documentation

- [ ] All exported functions have doc comments
- [ ] \`godoc\` renders cleanly for all public packages
- [ ] Test patterns documented in \`docs/testing.md\`
- [ ] Benchmark results documented in \`docs/benchmarks.md\`
- [ ] Security test coverage mapped to OWASP risks in \`docs/security-testing.md\`

## CI Pipeline Integration

### GitHub Actions Test Workflow

\`\`\`yaml
# .github/workflows/test.yml additions for Phase 06
jobs:
  unit-test:
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4
      - uses: actions/setup-go@v5
        with:
          go-version: '1.22'
      - run: go test -v -race -coverprofile=coverage.out -covermode=atomic ./internal/... ./pkg/...
      - run: |
          COVERAGE=$(go tool cover -func=coverage.out | grep total | awk '{print $3}' | tr -d '%')
          if (( $(echo "$COVERAGE < 80" | bc -l) )); then
            echo "Coverage $COVERAGE% is below 80% threshold"
            exit 1
          fi

  integration-test:
    runs-on: ubuntu-latest
    services:
      postgres:
        image: postgres:16-alpine
        env:
          POSTGRES_DB: gateway_test
          POSTGRES_USER: test
          POSTGRES_PASSWORD: test
        ports:
          - 5432:5432
      redis:
        image: redis:7-alpine
        ports:
          - 6379:6379
    steps:
      - uses: actions/checkout@v4
      - uses: actions/setup-go@v5
        with:
          go-version: '1.22'
      - run: go test -v -count=1 -tags=integration ./tests/integration/...

  security-scan:
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4
      - uses: actions/setup-go@v5
        with:
          go-version: '1.22'
      - run: go install golang.org/x/vuln/cmd/govulncheck@latest
      - run: govulncheck ./...
      - run: go install github.com/securego/gosec/v2/cmd/gosec@latest
      - run: gosec -fmt=json -out=gosec-report.json ./...

  benchmark:
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4
      - uses: actions/setup-go@v5
        with:
          go-version: '1.22'
      - run: go test -bench=. -benchmem -count=3 -run=^$ ./internal/... | tee benchmark-results.txt
      - uses: actions/upload-artifact@v4
        with:
          name: benchmark-results
          path: benchmark-results.txt
\`\`\`

## Test Execution Commands

\`\`\`bash
# Run all unit tests with coverage
go test -v -race -coverprofile=coverage.out ./internal/... ./pkg/...

# View coverage report in browser
go tool cover -html=coverage.out

# Run integration tests (requires Docker services)
docker compose -f tests/integration/docker-compose.test.yml up -d
go test -v -tags=integration ./tests/integration/...
docker compose -f tests/integration/docker-compose.test.yml down

# Run benchmarks
go test -bench=. -benchmem -count=5 -run=^$ ./internal/...

# Run race detector
go test -race -count=3 ./...

# Run security scan
gosec ./...
govulncheck ./...

# Run load test
k6 run scripts/loadtest/k6-gateway.js

# Profile under load
go tool pprof http://localhost:6060/debug/pprof/profile?seconds=30
\`\`\`

## Common Issues & Resolutions

| Issue | Resolution |
|-------|------------|
| Flaky tests from Redis timing | Use \`t.Helper()\` with retry logic; ensure clean state per test |
| Race conditions in circuit breaker | Use \`sync.RWMutex\` or \`atomic\` operations; verify with \`-race\` |
| Integration tests slow | Use \`tmpfs\` for PostgreSQL, disable Redis persistence, parallelize with \`t.Parallel()\` |
| Coverage gaps in error paths | Add table-driven test cases for every \`error\` return; use fault injection |
| Benchmark variance | Run with \`-count=5\` minimum; use \`benchstat\` for comparison |
| Mock drift from interfaces | Generate mocks with \`mockery\`; regenerate on interface changes |

## Phase Completion Checklist

- [ ] Unit tests written for all handlers, services, repositories, middleware
- [ ] Table-driven test pattern used consistently
- [ ] Integration tests cover full request lifecycle
- [ ] Race detection passes with zero findings
- [ ] Code coverage ≥ 80% overall, per-package minimums met
- [ ] Performance benchmarks established and documented
- [ ] Load tests validate throughput and latency SLAs
- [ ] Security tests cover OWASP API Security Top 10
- [ ] SOC 2 audit logging verified in tests
- [ ] gosec and govulncheck report zero HIGH/CRITICAL findings
- [ ] CI pipeline runs all test stages on every PR
- [ ] Test documentation complete (\`docs/testing.md\`, \`docs/benchmarks.md\`)
- [ ] Profiling scripts operational and documented
- [ ] \`godoc\` renders cleanly for all exported symbols

## Next Phase

→ [Phase 07: Security Hardening](./07-security-hardening.md) — TLS configuration, secret management, penetration testing, SOC 2 control validation

## Related Files

- [Phase 05: Core Development](./05-core-development.md) — Implementation being tested
- [Playbook Overview](../PLAYBOOK.md) — Full phase sequence
- [TDD Skill](../../plugin/codeforge-go-api-gateway/skills/tdd/SKILL.md) — Test-driven development workflow
- [Verify Skill](../../plugin/codeforge-go-api-gateway/skills/verify/SKILL.md) — Automated verification checks`,

  'playbook/phases/07-launch.md': `# Phase 07: Launch & Operations

## Overview

Phase 07 transitions the Go API gateway from a tested, hardened artifact into a production-serving system. This phase covers the final production deployment, traffic cutover, operational readiness verification, and establishment of ongoing operational practices. The gateway becomes the live entry point for all downstream microservices.

## Objectives

1. **Production Deployment** — Deploy the gateway binary to AWS ECS behind ALB with zero-downtime rollout
2. **Traffic Cutover** — Migrate traffic from the existing entry point (or direct service access) to the gateway incrementally
3. **Operational Readiness** — Confirm monitoring, alerting, runbooks, and on-call procedures are active and tested
4. **Performance Baseline** — Establish production performance baselines under real traffic for future comparison
5. **Incident Response Validation** — Verify the team can detect, triage, and resolve gateway incidents within SLA
6. **SOC 2 Evidence Collection** — Ensure all production controls are documented and auditable

## Prerequisites

Before entering this phase, confirm all Phase 06 quality gates are met:

- [ ] All tests passing (\`go test ./...\` with race detector, ≥80% coverage)
- [ ] \`golangci-lint run\` clean (zero findings)
- [ ] Load test results meet latency targets (p99 < 50ms for passthrough routing)
- [ ] Security scan clean (gosec, container image scan, dependency audit)
- [ ] Staging deployment validated with synthetic traffic for ≥48 hours
- [ ] Circuit breaker, rate limiter, and auth middleware verified under failure conditions
- [ ] Docker image built, tagged, and pushed to ECR with immutable tag

## Deliverables

### 7.1 Production Infrastructure

- [ ] Terraform apply for production environment (RDS, ElastiCache, ECS, ALB, CloudWatch)
- [ ] TLS certificates provisioned and configured on ALB (ACM)
- [ ] DNS records created/updated for gateway endpoint
- [ ] Redis ElastiCache cluster sized for rate limiting workload (connection pool validated)
- [ ] PostgreSQL RDS instance with config store schema migrated
- [ ] ECS task definition with resource limits, health check path, and graceful shutdown timeout
- [ ] Security groups restrict traffic: ALB → ECS only, ECS → RDS/Redis only
- [ ] Secrets stored in AWS Secrets Manager (JWT signing keys, DB credentials, API keys)

\`\`\`bash
# Verify infrastructure
cd deployments/terraform/production
terraform plan -out=prod.tfplan
terraform apply prod.tfplan

# Validate connectivity from ECS task
scripts/validate-connectivity.sh --env production
\`\`\`

### 7.2 Deployment Pipeline — Production Stage

- [ ] GitHub Actions production deployment workflow activated
- [ ] Deployment requires manual approval gate after staging validation
- [ ] Rolling deployment strategy configured (minimum healthy percent: 100%, maximum percent: 200%)
- [ ] Automatic rollback on health check failure (ALB target group health)
- [ ] Deployment tagged with git SHA, timestamp, and \`ai-assisted\` label where applicable
- [ ] CODEOWNERS approval required for \`deployments/\` and \`configs/production/\` changes

\`\`\`yaml
# .github/workflows/deploy-production.yml excerpt
jobs:
  deploy-production:
    needs: [deploy-staging, staging-validation]
    environment: production
    steps:
      - name: Deploy to ECS
        run: |
          aws ecs update-service \\
            --cluster go-api-gateway-prod \\
            --service gateway \\
            --task-definition gateway:\${{ steps.task-def.outputs.revision }} \\
            --force-new-deployment
      - name: Wait for stability
        run: |
          aws ecs wait services-stable \\
            --cluster go-api-gateway-prod \\
            --services gateway
\`\`\`

### 7.3 Traffic Cutover Plan

- [ ] Canary deployment: route 5% → 25% → 50% → 100% of traffic via ALB weighted target groups
- [ ] Each increment held for minimum 15 minutes with monitoring review
- [ ] Rollback procedure documented and tested (shift traffic back to previous target group)
- [ ] Downstream service teams notified at each cutover stage via Slack \`#gateway-launch\`
- [ ] Client-facing API key migration plan executed (existing keys loaded into PostgreSQL config store)

**Cutover checklist per increment:**

| Step | Traffic % | Hold Time | Validation |
|------|-----------|-----------|------------|
| 1 | 5% | 15 min | Error rate < 0.1%, p99 < 50ms |
| 2 | 25% | 15 min | Rate limiter functioning, JWT auth passing |
| 3 | 50% | 30 min | Circuit breakers stable, no upstream degradation |
| 4 | 100% | 60 min | Full production baseline captured |

### 7.4 Observability — Production Configuration

- [ ] Prometheus scraping \`/metrics\` endpoint on ECS tasks (via service discovery)
- [ ] Grafana dashboards deployed and accessible to the team:
  - **Gateway Overview**: request rate, error rate, latency percentiles, active connections
  - **Rate Limiting**: requests throttled per client, Redis latency, sliding window state
  - **Authentication**: JWT validation success/failure, API key usage, RBAC denials
  - **Circuit Breakers**: per-upstream state (closed/open/half-open), trip count, recovery time
  - **Infrastructure**: ECS CPU/memory, Redis connections, PostgreSQL connection pool, ALB metrics
- [ ] OpenTelemetry traces flowing to Jaeger (sample rate configured for production: 10%)
- [ ] slog structured logs shipping to CloudWatch Logs with JSON format
- [ ] Log retention set to 90 days (SOC 2 requirement)

\`\`\`go
// internal/observability/metrics.go — key production metrics
var (
    RequestsTotal = promauto.NewCounterVec(prometheus.CounterOpts{
        Name: "gateway_requests_total",
        Help: "Total requests processed by the gateway",
    }, []string{"method", "path", "status", "upstream"})

    RequestDuration = promauto.NewHistogramVec(prometheus.HistogramOpts{
        Name:    "gateway_request_duration_seconds",
        Help:    "Request duration in seconds",
        Buckets: []float64{0.001, 0.005, 0.01, 0.025, 0.05, 0.1, 0.25, 0.5, 1.0},
    }, []string{"method", "path", "upstream"})

    CircuitBreakerState = promauto.NewGaugeVec(prometheus.GaugeOpts{
        Name: "gateway_circuit_breaker_state",
        Help: "Circuit breaker state (0=closed, 1=half-open, 2=open)",
    }, []string{"upstream"})
)
\`\`\`

### 7.5 Alerting Rules

- [ ] Alerts configured in Prometheus Alertmanager with Slack integration (\`#gateway-alerts\`)
- [ ] PagerDuty integration for critical alerts (P1)

| Alert | Condition | Severity | Action |
|-------|-----------|----------|--------|
| High Error Rate | 5xx rate > 1% for 5 min | Critical (P1) | Page on-call, check upstream health |
| High Latency | p99 > 100ms for 5 min | Warning (P2) | Investigate, check Redis/DB latency |
| Rate Limiter Redis Down | Redis connection failures > 0 for 1 min | Critical (P1) | Failover to local rate limiter, page on-call |
| Circuit Breaker Open | Any upstream circuit open for > 2 min | Warning (P2) | Check upstream service health |
| Auth Failure Spike | JWT/API key failures > 10% for 3 min | Warning (P2) | Check for key rotation issues, possible attack |
| ECS Task Unhealthy | Health check failures > 2 consecutive | Critical (P1) | ECS auto-replaces, investigate root cause |
| Certificate Expiry | TLS cert expires in < 14 days | Warning (P2) | Renew ACM certificate |
| High Memory Usage | Container memory > 80% for 10 min | Warning (P2) | Check for leaks with pprof, consider scaling |

### 7.6 Runbooks

- [ ] Runbooks written and stored in \`docs/runbooks/\`:
  - \`docs/runbooks/gateway-high-error-rate.md\`
  - \`docs/runbooks/gateway-high-latency.md\`
  - \`docs/runbooks/redis-connection-failure.md\`
  - \`docs/runbooks/circuit-breaker-open.md\`
  - \`docs/runbooks/jwt-key-rotation.md\`
  - \`docs/runbooks/api-key-rotation.md\`
  - \`docs/runbooks/rollback-deployment.md\`
  - \`docs/runbooks/scaling-ecs-tasks.md\`
  - \`docs/runbooks/database-migration.md\`

Each runbook must include:
1. **Symptoms** — What the alert looks like, what users experience
2. **Diagnosis** — Commands to run, dashboards to check, logs to query
3. **Resolution** — Step-by-step fix with exact commands
4. **Escalation** — When and who to escalate to
5. **Post-incident** — What to document after resolution

### 7.7 Operational Procedures

- [ ] On-call rotation established (weekly rotation across team)
- [ ] Graceful shutdown verified in production (SIGTERM → drain connections → exit)
- [ ] JWT signing key rotation procedure tested (RS256 key pair rotation with overlap period)
- [ ] API key rotation procedure tested (create new key → notify client → deprecate old key)
- [ ] Database migration procedure documented (\`scripts/migrate.sh --env production\`)
- [ ] Scaling procedure documented (horizontal: ECS desired count; vertical: task CPU/memory)
- [ ] Backup verification: RDS automated backups enabled, point-in-time recovery tested
- [ ] Redis failover tested (ElastiCache Multi-AZ automatic failover)

### 7.8 SOC 2 Production Controls

- [ ] Access control: production AWS access restricted to leads via IAM roles
- [ ] Change management: all production changes require PR with CODEOWNERS approval
- [ ] Audit logging: CloudTrail enabled for all API calls to production resources
- [ ] Encryption at rest: RDS encrypted, ElastiCache encrypted, ECS task storage encrypted
- [ ] Encryption in transit: TLS 1.2+ enforced on ALB, mTLS to upstream services where supported
- [ ] Vulnerability management: container image scanning in ECR, automated dependency updates
- [ ] Incident response: documented procedure, tested during launch
- [ ] Data retention: logs retained 90 days, traces retained 30 days, metrics retained 1 year
- [ ] Evidence artifacts collected and stored in \`docs/compliance/soc2/\`

### 7.9 Production Performance Baseline

- [ ] Baseline captured under real traffic after 100% cutover (minimum 24 hours of data):

| Metric | Target | Actual |
|--------|--------|--------|
| p50 latency (passthrough) | < 5ms | ___ms |
| p95 latency (passthrough) | < 25ms | ___ms |
| p99 latency (passthrough) | < 50ms | ___ms |
| p50 latency (with auth + rate limit) | < 10ms | ___ms |
| p99 latency (with auth + rate limit) | < 75ms | ___ms |
| Max sustained RPS (single instance) | > 5,000 | ___ |
| Error rate (steady state) | < 0.01% | ___% |
| Redis rate limit check latency | < 2ms | ___ms |
| JWT validation latency | < 1ms | ___ms |
| Memory usage (steady state) | < 256MB | ___MB |
| Goroutine count (steady state) | < 1,000 | ___ |

- [ ] pprof profiles captured and archived for baseline comparison:

\`\`\`bash
# Capture production profiles (via port-forward or internal endpoint)
go tool pprof http://gateway-internal:6060/debug/pprof/heap
go tool pprof http://gateway-internal:6060/debug/pprof/profile?seconds=30
go tool pprof http://gateway-internal:6060/debug/pprof/goroutine
\`\`\`

### 7.10 Documentation Finalization

- [ ] \`docs/architecture/gateway-architecture.md\` — updated with production topology
- [ ] \`docs/api/routing-config.md\` — how to add/modify routes
- [ ] \`docs/api/authentication.md\` — JWT and API key usage for consumers
- [ ] \`docs/operations/deployment-guide.md\` — end-to-end deployment procedure
- [ ] \`docs/operations/monitoring-guide.md\` — dashboard locations, alert meanings
- [ ] \`docs/operations/troubleshooting.md\` — common issues and resolutions
- [ ] \`README.md\` updated with production status, architecture diagram, quick start
- [ ] ADRs (Architecture Decision Records) finalized in \`docs/adr/\`

## Quality Gates

All gates must pass before the phase is considered complete:

### Gate 1: Infrastructure Verified
- [ ] All Terraform resources in \`applied\` state with no drift
- [ ] Connectivity validated: ECS → RDS, ECS → Redis, ALB → ECS
- [ ] TLS termination working (certificate valid, HTTPS enforced)
- [ ] DNS resolving to ALB endpoint

### Gate 2: Deployment Pipeline Proven
- [ ] Production deployment executed successfully via GitHub Actions
- [ ] Rolling update completed with zero downtime (verified via ALB metrics)
- [ ] Rollback tested: previous task definition redeployed successfully
- [ ] Deployment audit trail captured (who, when, what SHA, approval)

### Gate 3: Traffic Cutover Complete
- [ ] 100% of traffic routing through the gateway
- [ ] All downstream services reachable through gateway routes
- [ ] No increase in error rate compared to pre-gateway baseline
- [ ] Client-reported issues: zero blocking issues

### Gate 4: Observability Active
- [ ] All five Grafana dashboards rendering production data
- [ ] Traces visible in Jaeger with end-to-end request flow
- [ ] Structured logs queryable in CloudWatch Logs Insights
- [ ] All alerting rules firing correctly (tested with synthetic failures)

### Gate 5: Operational Readiness
- [ ] On-call rotation active with at least 2 team members trained
- [ ] All 9 runbooks reviewed and approved by team lead
- [ ] Key rotation procedures tested in production
- [ ] Graceful shutdown verified (zero dropped requests during deploy)
- [ ] Scaling tested: ECS task count increased and decreased without issues

### Gate 6: SOC 2 Compliance
- [ ] All production controls documented in \`docs/compliance/soc2/\`
- [ ] Access control evidence captured (IAM policies, CODEOWNERS)
- [ ] Encryption evidence captured (TLS config, RDS/Redis encryption settings)
- [ ] Audit log evidence captured (CloudTrail, deployment logs)
- [ ] Change management evidence captured (PR history, approval records)

### Gate 7: Performance Validated
- [ ] Production baseline table completed with actual values
- [ ] All latency targets met under real traffic
- [ ] No memory leaks detected over 24-hour observation period
- [ ] Goroutine count stable (no unbounded growth)
- [ ] pprof baseline profiles archived

## Phase Completion Criteria

\`\`\`bash
# Run the phase validation
./playbook/codeforge-phase.sh validate 07

# Expected output:
# ✅ Production infrastructure deployed and verified
# ✅ Deployment pipeline executing successfully
# ✅ 100% traffic cutover complete
# ✅ All observability systems active
# ✅ Alerting rules configured and tested
# ✅ Runbooks written and reviewed
# ✅ On-call rotation established
# ✅ SOC 2 controls documented
# ✅ Performance baseline captured
# ✅ Documentation finalized
\`\`\`

## Post-Launch Activities (First 7 Days)

| Day | Activity |
|-----|----------|
| Day 1 | Active monitoring, team available for rapid response |
| Day 2 | Review first 24h metrics, tune alert thresholds if noisy |
| Day 3 | Address any non-critical issues found during launch |
| Day 4 | Capture and share performance baseline with team |
| Day 5 | Conduct launch retrospective, document lessons learned |
| Day 6 | Plan Phase 08 backlog (optimizations, new features) |
| Day 7 | Transition to steady-state operations, reduce monitoring intensity |

## Risk Mitigation

| Risk | Mitigation | Owner |
|------|------------|-------|
| Upstream service incompatibility | Canary rollout with per-increment validation | Lead |
| Redis ElastiCache failure | Local in-memory fallback rate limiter (\`internal/ratelimit/fallback.go\`) | Senior |
| JWT key compromise | Documented rotation procedure, short-lived tokens (15 min) | Lead |
| Traffic spike beyond capacity | ECS auto-scaling policy, ALB request throttling | Senior |
| Configuration error in production | Config validation on startup, rollback procedure | Mid |
| Database migration failure | Migration tested in staging, point-in-time recovery available | Senior |

## Rollback Plan

If critical issues are detected during or after cutover:

1. **Immediate** (< 5 min): Shift ALB weighted target group back to 0% gateway traffic
2. **Short-term** (< 30 min): Revert ECS task definition to previous known-good revision
3. **Full rollback** (< 1 hour): Restore DNS to pre-gateway configuration

\`\`\`bash
# Emergency rollback commands
# 1. Shift traffic away from gateway
aws elbv2 modify-rule --rule-arn $RULE_ARN \\
  --actions '[{"Type":"forward","ForwardConfig":{"TargetGroups":[{"TargetGroupArn":"'$PREVIOUS_TG'","Weight":100},{"TargetGroupArn":"'$GATEWAY_TG'","Weight":0}]}}]'

# 2. Revert to previous task definition
aws ecs update-service --cluster go-api-gateway-prod --service gateway \\
  --task-definition gateway:$PREVIOUS_REVISION --force-new-deployment
\`\`\`

## Next Phase

Upon successful completion of all quality gates and the 7-day stabilization period, proceed to **Phase 08: Optimization & Iteration** — focusing on performance tuning, feature additions, and operational improvements based on production learnings.

Update the phase tracker:

\`\`\`bash
./playbook/codeforge-phase.sh set 08
\`\`\``,

  'playbook/prompts/01/gather-requirements.md': `# Gather Requirements — Phase 01 Discovery

> **Copy-paste this prompt into Claude Code** to kick off requirements gathering for a feature, endpoint, or component of the go-api-gateway project.

---

## Prompt

\`\`\`
I need you to act as a senior API gateway engineer and help me gather requirements for a new piece of work in the go-api-gateway project.

## Context

This is a high-performance API gateway built with Go 1.22 and Chi v5. It serves as the single entry point for a microservices architecture. The stack includes:

- **Router**: Chi v5 (composable middleware)
- **Auth**: JWT (RS256), API keys, OAuth2 passthrough
- **Rate Limiting**: Redis-backed sliding window, per-client
- **Data Stores**: PostgreSQL (config, API key metadata), Redis (rate limits, caching)
- **Observability**: OpenTelemetry traces, Prometheus metrics, slog structured logging
- **Patterns**: Clean Architecture (handler → service → repository), circuit breakers, graceful shutdown
- **Compliance**: SOC 2
- **Deployment**: AWS ECS, Docker, Kubernetes, Helm

The project layout follows:
- \`cmd/gateway/\` — entry point
- \`internal/handler/\` — Chi route handlers
- \`internal/middleware/\` — Chi middleware (auth, rate limit, logging, cors, recovery)
- \`internal/service/\` — business logic
- \`internal/repository/\` — data access (PostgreSQL, Redis)
- \`internal/model/\` — domain models and DTOs
- \`internal/config/\` — Viper configuration
- \`internal/auth/\` — JWT validation, API key verification, RBAC
- \`internal/ratelimit/\` — Redis rate limiting
- \`internal/circuit/\` — circuit breaker
- \`internal/observability/\` — OTel, Prometheus, slog
- \`pkg/httputil/\` — response helpers
- \`pkg/errors/\` — custom error types

## The Work

[REPLACE THIS: Describe the feature, endpoint, bug fix, or component you want to build. Examples:
- "Add a /v1/health/ready endpoint that checks PostgreSQL and Redis connectivity"
- "Implement per-route rate limiting with configurable limits in YAML"
- "Add circuit breaker middleware for upstream service calls"
- "Build an API key rotation mechanism with zero-downtime cutover"
]

## What I Need You To Gather

Walk me through a structured requirements gathering process. For each area below, ask me clarifying questions before making assumptions, then produce a requirements document.

### 1. Functional Requirements
- What is the exact behavior expected?
- What HTTP methods, paths, request/response shapes are involved?
- What Chi middleware should be applied to these routes?
- What upstream services or data stores are touched?
- What happens on success? On each failure mode?

### 2. Non-Functional Requirements
- **Latency**: What is the acceptable p99 latency budget for this path? (Gateway overhead target: <5ms)
- **Throughput**: Expected RPS for this endpoint/feature?
- **Availability**: Does this need circuit breaker protection?
- **Caching**: Should responses be cached in Redis? TTL?
- **Connection pooling**: Any new database or HTTP client connections needed?

### 3. Security & Compliance (SOC 2)
- Does this touch sensitive paths? (\`internal/auth/**\`, \`config/production/**\`, \`*.pem\`, \`.env*\`)
- What authentication is required? (JWT, API key, none, internal-only)
- What RBAC roles/permissions apply?
- Are there OWASP API Security Top 10 concerns? (injection, BOLA, rate limiting, etc.)
- Does this require TLS termination or mTLS to upstream?
- Are there audit logging requirements for SOC 2?
- Does any PII or secret material flow through this path?

### 4. Observability
- What Prometheus metrics should be emitted? (counters, histograms, gauges)
- What OpenTelemetry span attributes should be added?
- What slog fields should be logged at each level (info, warn, error)?
- Should this be included in health check probes (\`/healthz\`, \`/readyz\`)?

### 5. Data Model & Storage
- Are new PostgreSQL tables or migrations needed?
- Are new Redis key patterns needed? What TTLs?
- What repository interfaces need to be defined in \`internal/repository/\`?
- What domain models go in \`internal/model/\`?

### 6. API Contract
- Request schema (headers, query params, body)
- Response schema (success, error shapes using \`pkg/errors/\` codes)
- HTTP status codes for each scenario
- Content-Type expectations
- Pagination, filtering, sorting if applicable

### 7. Architecture Decisions
- Which layer owns this logic? (handler, middleware, service, repository)
- Are new interfaces needed for dependency injection?
- Does this require a new Chi middleware or can existing middleware be composed?
- Any new packages or dependencies? (We follow a conservative dependency policy)
- Does this change the middleware chain order? (Order matters in Chi)

### 8. Testing Strategy
- What table-driven unit tests are needed? (required by convention)
- What \`httptest\` handler tests are needed?
- What integration tests against PostgreSQL/Redis are needed? (in \`tests/\`)
- What edge cases and failure modes must be covered?
- Are benchmark tests needed? (\`go test -bench\`)
- Target: 80% coverage minimum

### 9. Configuration
- What new Viper config keys are needed? (in \`configs/*.yaml\`)
- What new environment variables? (ALL_CAPS naming)
- Are there per-environment differences (dev, staging, production)?
- Do defaults need to be safe for local development?

### 10. Deployment & Rollout
- Does this need a database migration? (run via \`scripts/\`)
- Does this need Redis schema changes?
- Can this be deployed behind a feature flag?
- Is a canary or blue-green rollout needed?
- Does the Helm chart or Kubernetes manifest need changes? (\`deployments/\`)
- Any AWS infrastructure changes? (ECS task def, ALB rules, ElastiCache, RDS)

## Output Format

After gathering answers, produce a structured requirements document with:

1. **Title**: Short name for the work item
2. **Ticket Reference**: GitHub Issue number (e.g., GW-XX)
3. **Summary**: 2-3 sentence description
4. **Functional Requirements**: Numbered list
5. **Non-Functional Requirements**: Table (requirement, target, measurement)
6. **Security Requirements**: Numbered list with SOC 2 references
7. **API Contract**: Request/response examples with curl
8. **Data Model Changes**: SQL migration snippets if applicable
9. **Architecture**: Which packages are touched, new interfaces
10. **Testing Plan**: List of test cases with expected coverage
11. **Configuration Changes**: New config keys with defaults
12. **Deployment Notes**: Migration steps, rollout strategy
13. **Open Questions**: Anything unresolved
14. **Acceptance Criteria**: Checkboxes for definition of done

Save the output to \`docs/requirements/GW-XX-<short-name>.md\`.

## Rules
- Ask questions before assuming. Do not hallucinate requirements.
- Reference actual project paths and conventions.
- All exported functions must have doc comments.
- Errors must use \`fmt.Errorf\` with \`%w\` wrapping.
- Context propagation is required on all handlers.
- No \`init()\` functions.
- File names use snake_case, max 300 lines per file.
- Conventional commits: feat:, fix:, chore:, docs:, perf:
- Branch naming: type/GW-XX-short-desc
\`\`\`

---

## How to Use

1. **Copy** the entire prompt block above.
2. **Paste** it into Claude Code.
3. **Replace** the \`[REPLACE THIS: ...]\` section with your actual feature description.
4. **Answer** Claude's clarifying questions — it will ask before assuming.
5. **Review** the generated requirements document in \`docs/requirements/\`.
6. **Commit** with \`docs: add requirements for GW-XX <feature>\`.

## Example Replacements

**Rate limiting per route:**
\`\`\`
Implement per-route rate limiting where each route definition in configs/routes.yaml
can specify its own rate limit (requests per window). The rate limiter should use
the existing Redis sliding window in internal/ratelimit/ but support route-level
overrides on top of the per-client defaults.
\`\`\`

**Circuit breaker middleware:**
\`\`\`
Add a circuit breaker Chi middleware in internal/circuit/ that wraps upstream HTTP
calls. It should use a half-open/open/closed state machine, store state in Redis
for cross-instance consistency, and emit Prometheus metrics for state transitions.
\`\`\`

**API key rotation:**
\`\`\`
Build an API key rotation flow where clients can request a new key via
POST /v1/keys/rotate. The old key should remain valid for a configurable grace
period (default 24h). Keys are stored in PostgreSQL with metadata. This must
satisfy SOC 2 access control requirements.
\`\`\`

## What Happens Next

After requirements are gathered and saved:

1. Move to **Phase 02 — Architecture** using \`playbook/prompts/02/create-design-doc.md\`
2. The requirements doc becomes input for the architecture design
3. Reference it in your GitHub Issue and PR description
4. Use \`/phase check 01\` to verify Phase 01 completion criteria`,

  'playbook/prompts/01/nfr-checklist.md': `# NFR Checklist — Phase 01 Discovery

> **Copy-paste this prompt into Claude Code** to generate a comprehensive Non-Functional Requirements checklist for the go-api-gateway project. Run this after completing \`gather-requirements.md\` and \`user-stories.md\`.

---

## Prompt

\`\`\`
You are helping define Non-Functional Requirements (NFRs) for the go-api-gateway project — a high-performance API gateway built with Go 1.22 and Chi v5 router. This gateway serves as the single entry point for a microservices architecture deployed on AWS (ECS, ALB, ElastiCache, RDS).

Review any existing requirements in docs/requirements.md and user stories in docs/user-stories.md, then produce a comprehensive NFR checklist covering every category below. Each NFR must be measurable, testable, and specific to an API gateway workload.

## Context

- Language: Go 1.22+ with Chi v5 router
- Databases: PostgreSQL (config store), Redis (rate limiting, caching)
- Auth: JWT (RS256), API keys, OAuth2 passthrough
- Observability: OpenTelemetry traces, Prometheus metrics, slog structured logging
- Deployment: Docker on AWS ECS behind ALB, with Kubernetes/Helm option
- Compliance: SOC 2
- Architecture: Clean Architecture (handler → service → repository)
- Team: 2-5 backend developers, Americas timezone

## NFR Categories to Cover

### 1. Performance & Latency
Define measurable targets for:
- P50, P95, P99 request latency through the gateway (proxy overhead only, excluding upstream)
- Target throughput in requests per second per instance
- Maximum acceptable proxy overhead added by the gateway (in milliseconds)
- Connection pool sizing for PostgreSQL and Redis
- Keep-alive and connection reuse targets for upstream HTTP clients
- Benchmark requirements: define which paths must have Go benchmarks (e.g., JWT validation, rate limit check, middleware chain)
- pprof profiling: when and how profiling endpoints are exposed (staging only, behind auth)
- Startup time target (time from process start to ready to serve traffic)
- Graceful shutdown drain period

### 2. Scalability
Define targets for:
- Horizontal scaling behavior (ECS auto-scaling triggers: CPU, request count, latency)
- Maximum concurrent connections per instance
- Redis connection pool limits under load
- Behavior under 10x normal traffic (graceful degradation strategy)
- Rate limiting accuracy under distributed deployment (multiple gateway instances sharing Redis)
- Circuit breaker state synchronization across instances (or lack thereof — local state is acceptable)

### 3. Reliability & Availability
Define targets for:
- Uptime SLA (e.g., 99.9%, 99.95%)
- Health check endpoints: /healthz (liveness), /readyz (readiness) — what each checks
- Circuit breaker thresholds: failure rate %, window size, half-open retry count
- Retry policy for upstream services (max retries, backoff strategy, idempotency requirements)
- Timeout hierarchy: client read timeout > gateway handler timeout > upstream call timeout
- Graceful shutdown: in-flight request drain timeout, SIGTERM handling
- Redis unavailability behavior (fail-open or fail-closed for rate limiting)
- PostgreSQL unavailability behavior (serve from cache, reject config changes)

### 4. Security (SOC 2 Aligned)
Define requirements for:
- TLS: minimum version (TLS 1.2+), cipher suites, TLS termination at ALB vs gateway
- JWT validation: RS256 key rotation support, JWKS endpoint caching, token expiry enforcement
- API key management: hashing algorithm (bcrypt/argon2), rotation policy, revocation latency
- OWASP API Security Top 10 coverage: which items are addressed and how
- Rate limiting as abuse prevention: per-client, per-IP, per-endpoint limits
- Request size limits (max header size, max body size)
- CORS policy: allowed origins, methods, headers — configurable per route
- Input validation and sanitization on all gateway-processed fields
- Secrets management: no secrets in code, environment variable injection, AWS Secrets Manager
- Audit logging: what events are logged (auth failures, rate limit hits, config changes)
- Dependency scanning: govulncheck frequency, CVE response SLA
- Container security: non-root user, read-only filesystem, minimal base image (distroless/scratch)
- RBAC: role definitions, permission granularity, enforcement points

### 5. Observability & Monitoring
Define requirements for:
- Structured logging with slog: required fields (request_id, trace_id, client_id, method, path, status, latency_ms)
- Log levels: what goes at DEBUG, INFO, WARN, ERROR
- OpenTelemetry tracing: span naming convention, required span attributes, sampling rate
- Prometheus metrics: required metrics (request_duration_seconds histogram, requests_total counter, active_connections gauge, circuit_breaker_state gauge, rate_limit_hits_total counter, upstream_duration_seconds histogram)
- Alerting thresholds: P99 latency > X ms, error rate > Y%, circuit breaker open, Redis connection failures
- Dashboard requirements: Grafana dashboards for gateway overview, per-upstream health, rate limiting stats
- Distributed tracing: trace context propagation (W3C Trace Context), Jaeger as backend
- Log retention period (SOC 2 requirement: minimum 90 days)

### 6. Maintainability & Code Quality
Define requirements for:
- Test coverage: minimum 80% overall, 90% for internal/auth/** and internal/ratelimit/**
- golangci-lint: enabled linters (govet, errcheck, staticcheck, gosec, revive, gocyclo)
- Max cyclomatic complexity per function (e.g., 15)
- Max file length: 300 lines
- Table-driven tests required for all handler and service tests
- Integration tests: required for Redis rate limiting, PostgreSQL config store, JWT validation flow
- Documentation: all exported functions must have doc comments, architecture decision records for major choices
- Dependency policy: conservative, justify every new dependency, prefer stdlib

### 7. Deployment & Operations
Define requirements for:
- Docker image size target (e.g., < 20MB with scratch/distroless base)
- Container resource limits: CPU, memory requests and limits for ECS/Kubernetes
- Configuration: environment-based config with Viper, no config files baked into images
- Database migrations: versioned, reversible, run as separate job before deployment
- Blue-green or rolling deployment strategy
- Rollback time target (< 5 minutes)
- Feature flags: how new routing rules or middleware are toggled
- Runbook requirements: incident response for gateway down, Redis down, high latency, certificate expiry

### 8. Compatibility & Integration
Define requirements for:
- Upstream service protocol support (HTTP/1.1, HTTP/2, gRPC passthrough)
- Request/response transformation capabilities (header injection, path rewriting)
- Backward compatibility policy for gateway API changes
- Client SDK compatibility (if any)
- Webhook support for gateway events (rate limit exceeded, circuit breaker state change)

## Output Format

Write the NFR checklist to docs/nfr-checklist.md with this structure:

\`\`\`markdown
# Non-Functional Requirements — go-api-gateway

> Generated during Phase 01 Discovery. Each NFR is measurable and testable.
> Last updated: [date]

## 1. Performance & Latency

| ID | Requirement | Target | Measurement Method |
|----|-------------|--------|--------------------|
| PERF-001 | P99 proxy overhead | < 5ms | Go benchmark + load test |
| ... | ... | ... | ... |

## 2. Scalability
[same table format]

## 3. Reliability & Availability
[same table format]

## 4. Security
[same table format]

## 5. Observability & Monitoring
[same table format]

## 6. Maintainability & Code Quality
[same table format]

## 7. Deployment & Operations
[same table format]

## 8. Compatibility & Integration
[same table format]

## Acceptance Criteria
- [ ] All NFRs have measurable targets
- [ ] All NFRs have defined measurement methods
- [ ] Security NFRs align with SOC 2 Type II controls
- [ ] Performance targets validated against expected traffic model
- [ ] Team has reviewed and agreed on all targets
\`\`\`

Populate every row with specific, realistic values appropriate for a production API gateway handling 5,000-50,000 RPS. Do not leave placeholders — fill in concrete numbers, durations, and thresholds.

If docs/requirements.md or docs/user-stories.md exist, cross-reference them and note which user stories each NFR supports. If they don't exist yet, note that these should be cross-referenced once available.

Save the output to docs/nfr-checklist.md.
\`\`\`

---

## When to Use

Run this prompt during **Phase 01 — Discovery** after you have gathered initial requirements and written user stories. The NFR checklist becomes a contract that guides architecture decisions in Phase 02 and acceptance criteria in Phase 06.

## Expected Output

- \`docs/nfr-checklist.md\` — a comprehensive, tabular NFR document with 40-60 specific, measurable requirements

## Follow-Up Actions

1. Review the generated NFRs with the team — adjust targets based on actual traffic projections
2. Flag any NFRs that require infrastructure changes (e.g., Redis cluster mode for distributed rate limiting)
3. Feed performance NFRs into Phase 02 architecture decisions (see \`playbook/prompts/02/\`)
4. Feed security NFRs into the threat model (see \`playbook/prompts/02/threat-model.md\` if available)
5. Use NFR IDs in test names: \`TestPERF001_ProxyOverheadUnder5ms\``,

  'playbook/prompts/01/user-stories.md': `# Phase 01 — User Stories Prompt

> Copy-paste this prompt into Claude Code to generate user stories for the Go API Gateway.

---

You are a product analyst working on **go-api-gateway**, a high-performance API gateway built with Go 1.22 and Chi router. The gateway serves as the single entry point for a microservices architecture deployed on AWS ECS.

## Your Task

Generate a comprehensive set of user stories for the API gateway. Organize them by epic. Each story must follow the format:

\`\`\`
### [EPIC-ID]-[STORY-NUM]: <Title>

**As a** <persona>,
**I want** <capability>,
**So that** <business value>.

**Acceptance Criteria:**
- [ ] Given <precondition>, when <action>, then <expected result>
- [ ] Given <precondition>, when <action>, then <expected result>

**Technical Notes:**
- <implementation hints relevant to Go/Chi/Redis/PostgreSQL>

**Priority:** P0 | P1 | P2
**Estimate:** S | M | L | XL
\`\`\`

## Personas

Use these personas specific to an API gateway:

| Persona | Description |
|---------|-------------|
| **API Consumer** | External developer calling APIs through the gateway |
| **Service Owner** | Internal developer whose microservice sits behind the gateway |
| **Platform Engineer** | Engineer operating, deploying, and monitoring the gateway |
| **Security Engineer** | Engineer responsible for authentication, authorization, and SOC 2 compliance |
| **API Product Manager** | Stakeholder managing API access, rate limits, and client onboarding |

## Epics to Cover

Generate stories for each of these epics:

### EPIC-01: Request Routing & Proxying
- Route matching (path-based, header-based, method-based)
- Upstream service discovery and forwarding
- Request/response transformation (header injection, path rewriting)
- Chi router configuration and middleware chain composition
- Wildcard and parameterized route support
- Timeout and retry policies per upstream

### EPIC-02: Authentication & Authorization
- JWT validation (RS256) with JWKS endpoint support
- API key authentication with PostgreSQL-backed key store
- OAuth2 token passthrough to upstream services
- Role-Based Access Control (RBAC) per route
- Token refresh and revocation handling
- Multi-tenant isolation (tenant ID extracted from JWT claims)
- SOC 2 compliance: audit logging of all auth events

### EPIC-03: Rate Limiting & Throttling
- Per-client rate limiting using Redis sliding window
- Configurable rate limit tiers (free, standard, premium)
- Rate limit headers in responses (X-RateLimit-Limit, X-RateLimit-Remaining, X-RateLimit-Reset)
- Burst allowance configuration
- Global rate limiting for DDoS protection
- Rate limit override per API key or tenant

### EPIC-04: Resilience & Circuit Breaking
- Circuit breaker per upstream service (closed → open → half-open)
- Configurable failure thresholds and recovery timeouts
- Fallback responses when circuit is open
- Bulkhead pattern (connection pool isolation per upstream)
- Graceful degradation under load
- Health-check-driven circuit state

### EPIC-05: Observability & Monitoring
- Distributed tracing with OpenTelemetry (trace context propagation)
- Prometheus metrics (request count, latency histograms, error rates, circuit breaker state)
- Structured logging with slog (request ID, trace ID, client ID in every log)
- Health check endpoints (/healthz, /readyz)
- Audit trail for security events (stored in PostgreSQL)
- Grafana dashboard compatibility
- Jaeger trace export

### EPIC-06: Configuration & Management
- YAML-based route configuration (loaded via Viper)
- Hot-reload of route config without restart
- API key provisioning and rotation via admin API
- Rate limit tier management
- Upstream service registration
- Environment-specific config (development, staging, production)

### EPIC-07: Operations & Deployment
- Docker image build (multi-stage, distroless base)
- Kubernetes deployment with Helm charts
- Graceful shutdown (drain in-flight requests)
- Rolling deployments with zero downtime
- Terraform for AWS infrastructure (ECS, ALB, ElastiCache, RDS)
- Startup and shutdown lifecycle hooks

### EPIC-08: Security Hardening
- TLS termination at ALB, mTLS to upstreams
- CORS middleware (configurable per route)
- Request body size limits
- IP allowlist/denylist
- SQL injection and header injection prevention
- OWASP API Security Top 10 mitigations
- Secret management (no secrets in config files, use AWS Secrets Manager)
- SOC 2 audit log retention (90 days minimum)

## Requirements

1. Generate **at least 5 stories per epic** (more for complex epics like Auth and Rate Limiting)
2. Acceptance criteria must be **testable** — reference specific HTTP status codes, headers, log fields, and metric names
3. Technical notes must reference the actual tech stack: Go 1.22, Chi v5, Redis, PostgreSQL, OpenTelemetry, Prometheus, slog, Viper, Docker, Kubernetes, AWS
4. Prioritize stories: P0 = MVP (gateway won't function without it), P1 = launch requirement, P2 = post-launch enhancement
5. Estimates: S = 1-2 days, M = 3-5 days, L = 1-2 weeks, XL = 2+ weeks
6. Include **edge cases** in acceptance criteria (malformed tokens, Redis unavailable, upstream timeout, config parse errors)
7. Reference the project's Clean Architecture layers: handler → service → repository
8. Reference the directory structure: \`internal/handler/\`, \`internal/middleware/\`, \`internal/service/\`, \`internal/auth/\`, \`internal/ratelimit/\`, \`internal/circuit/\`, \`internal/observability/\`
9. Tag stories that touch **sensitive paths** (\`internal/auth/**\`, \`configs/production/**\`) — these require security review
10. For SOC 2 relevant stories, add a \`**Compliance:** SOC 2 — <control reference>\` line

## Output Format

Output a single Markdown document with:
- A summary table of all epics with story counts and P0/P1/P2 breakdown
- Each epic as an H2 section
- Stories within each epic as H3 sections
- A final section listing **cross-cutting concerns** (stories that span multiple epics)
- A **dependency graph** showing which stories block others

Save the output to \`docs/user-stories.md\`.

## Context Files

Before generating, review these files for alignment:
- \`playbook/phases/01-discovery.md\` — current phase requirements
- \`playbook/PLAYBOOK.md\` — overall methodology
- \`docs/\` — any existing architecture or design docs

---

**Run this prompt now. Generate the complete user stories document.**`,

  'playbook/prompts/02/adr-generator.md': `# ADR Generator — Phase 02: Architecture

## Copy-Pasteable Prompt for Claude Code

Use this prompt during Phase 02 (Architecture) to generate Architecture Decision Records (ADRs) for the go-api-gateway project. Paste the entire block below into Claude Code.

---

\`\`\`
I need you to generate Architecture Decision Records (ADRs) for the go-api-gateway project. This is a high-performance API gateway built with Go 1.22 and Chi v5 router, serving as the single entry point for a microservices architecture.

## Project Context

- **Language**: Go 1.22+ with strict linting (golangci-lint)
- **Router**: Chi v5 (composable middleware, idiomatic Go)
- **Databases**: PostgreSQL (config store, API key metadata), Redis (rate limiting, caching, session store)
- **Auth**: JWT (RS256), API keys, OAuth2 passthrough
- **Observability**: OpenTelemetry (traces), Prometheus (metrics), slog (structured logging)
- **Cloud**: AWS (ECS, ALB, ElastiCache, RDS)
- **Architecture**: Clean Architecture (handler → service → repository)
- **Compliance**: SOC 2

## ADR Format

Use the following format for each ADR. Place files in \`docs/adr/\` with naming convention \`NNNN-short-title.md\`:

\`\`\`markdown
# ADR-NNNN: Title

**Status**: Proposed | Accepted | Deprecated | Superseded by ADR-XXXX
**Date**: YYYY-MM-DD
**Deciders**: Team
**Tags**: [relevant, tags]

## Context

What is the issue that we're seeing that is motivating this decision or change?
Include technical constraints, SOC 2 requirements, performance targets, and team context (small team, 2-5 developers).

## Decision

What is the change that we're proposing and/or doing?
Be specific about Go packages, configuration, and implementation approach.

## Consequences

### Positive
- What becomes easier or better?

### Negative
- What becomes harder or worse?

### Risks
- What could go wrong and how do we mitigate it?

## Alternatives Considered

| Alternative | Pros | Cons | Why Rejected |
|---|---|---|---|

## Implementation Notes

- Specific Go packages, interfaces, file locations in the project structure
- Reference to \`internal/\` package paths where applicable
- Migration or rollout considerations

## References

- Links to relevant Go docs, library repos, RFCs, or OWASP guidelines
\`\`\`

## ADRs to Generate

Generate the following ADRs based on the key architectural decisions for this API gateway. For each one, think deeply about the tradeoffs in the context of a Go API gateway handling high-throughput traffic.

### ADR-0001: Chi v5 as HTTP Router
- Why Chi over stdlib mux (Go 1.22), Gin, Echo, Fiber
- Composable middleware chain as the core gateway pattern
- Compatibility with net/http interfaces
- Performance characteristics for API gateway workloads (low allocation, minimal overhead)

### ADR-0002: Clean Architecture with Handler-Service-Repository Layers
- Why strict layering for an API gateway (most gateways are flat middleware chains)
- Interface-based dependency injection for testability
- Where gateway-specific concerns (routing rules, transformations) live
- File organization under \`internal/\` following Go conventions
- Max 300 lines per file constraint

### ADR-0003: JWT Authentication with RS256
- Why RS256 over HS256 (asymmetric key distribution across services)
- Key rotation strategy and JWKS endpoint
- Token validation flow in middleware (\`internal/auth/jwt.go\`)
- RBAC claim structure and enforcement
- SOC 2 implications: audit logging of auth decisions, key management

### ADR-0004: Redis-Based Rate Limiting with Sliding Window
- Why sliding window over fixed window or token bucket for API gateway use case
- Redis as the backing store (vs in-memory, vs distributed consensus)
- Per-client rate limiting keyed by API key, JWT subject, or IP
- Lua script for atomic sliding window operations
- Failure mode: what happens when Redis is unavailable (fail-open vs fail-closed)
- Implementation in \`internal/ratelimit/\`

### ADR-0005: Circuit Breaker Pattern for Upstream Services
- Why circuit breaker is essential for an API gateway
- State machine: closed → open → half-open
- Per-upstream-service circuit configuration
- Integration with Chi middleware chain
- Metrics emission for circuit state changes (Prometheus)
- Implementation in \`internal/circuit/\`
- Comparison: custom implementation vs sony/gobreaker vs resilience4j-style

### ADR-0006: OpenTelemetry for Distributed Tracing
- Why OpenTelemetry over Jaeger client directly or AWS X-Ray SDK
- Trace context propagation through the gateway to upstream services
- Span creation strategy: one span per middleware? per handler? per upstream call?
- Baggage propagation for request correlation
- Sampling strategy for high-throughput gateway traffic
- Integration with slog for correlated logs
- Implementation in \`internal/observability/\`

### ADR-0007: Structured Logging with slog
- Why slog (stdlib) over zerolog, zap, logrus
- Log levels strategy for API gateway (what's INFO vs DEBUG vs WARN)
- Mandatory fields: request_id, trace_id, client_id, method, path, status, latency_ms
- Sensitive data redaction (Authorization headers, request bodies)
- SOC 2 audit trail requirements
- Performance: pre-allocated attributes, handler groups

### ADR-0008: Configuration Management with Viper
- Why Viper + envconfig over just environment variables or just YAML
- Configuration hierarchy: defaults → YAML file → environment variables → flags
- Hot-reload for rate limit configs and routing rules without restart
- Secrets handling: no secrets in config files, AWS Secrets Manager integration
- Environment-specific configs in \`configs/\` directory
- SOC 2: configuration change audit trail

### ADR-0009: PostgreSQL for Configuration and API Key Storage
- Why PostgreSQL over DynamoDB, etcd, or Consul for gateway config
- Schema design for routing rules, API key metadata, client configurations
- Connection pooling strategy (pgxpool) for low-latency gateway
- Migration strategy (golang-migrate)
- Read-through cache with Redis to avoid DB hits on every request
- Implementation in \`internal/repository/\`

### ADR-0010: Graceful Shutdown and Health Check Strategy
- Kubernetes readiness vs liveness probes
- Drain period: stop accepting new connections, finish in-flight requests
- Health check endpoint design (\`/healthz\`, \`/readyz\`)
- Dependency health checks: PostgreSQL, Redis, upstream services
- Signal handling in \`cmd/gateway/main.go\`
- ALB deregistration delay coordination

### ADR-0011: Request/Response Transformation Pipeline
- Why the gateway needs transformation (header injection, body rewriting, path rewriting)
- Middleware-based vs plugin-based transformation
- Ordering guarantees in the transformation pipeline
- Performance impact: minimize allocations, avoid unnecessary body reads
- Configuration-driven transformations vs code-driven

### ADR-0012: Deployment Strategy — ECS with ALB
- Why ECS over EKS for a small team (2-5 developers)
- ALB integration for TLS termination, health checks, and routing
- Blue/green deployment with CodeDeploy
- Auto-scaling based on request count and latency metrics
- Terraform for infrastructure, GitHub Actions for CI/CD pipeline
- SOC 2: deployment audit trail, rollback procedures

## Output Instructions

1. Generate each ADR as a separate file with the exact path: \`docs/adr/NNNN-short-title.md\`
2. Be specific to Go — reference actual packages (\`github.com/go-chi/chi/v5\`, \`github.com/redis/go-redis/v9\`, \`github.com/jackc/pgx/v5\`, \`go.opentelemetry.io/otel\`, etc.)
3. Reference the project's directory structure (\`internal/handler/\`, \`internal/middleware/\`, \`internal/service/\`, etc.)
4. Include concrete Go interface definitions or type signatures where they clarify the decision
5. Consider SOC 2 compliance implications for each decision
6. Consider performance implications — this is a gateway in the hot path of every request
7. Be opinionated — make a clear decision, don't hedge
8. Also generate a \`docs/adr/README.md\` index file listing all ADRs with their status and a one-line summary

After generating the ADRs, create a summary of the key architectural constraints and invariants that should be enforced across the codebase. Save this as \`docs/architecture-constraints.md\`.
\`\`\`

---

## When to Use This Prompt

- At the start of Phase 02 (Architecture) after requirements are gathered from Phase 01
- When a new significant technical decision needs to be documented
- During architecture review sessions
- When onboarding new team members who need to understand "why" decisions were made

## Expected Output

| File | Description |
|---|---|
| \`docs/adr/README.md\` | Index of all ADRs with status and summary |
| \`docs/adr/0001-chi-v5-http-router.md\` | Router selection decision |
| \`docs/adr/0002-clean-architecture-layers.md\` | Layered architecture decision |
| \`docs/adr/0003-jwt-rs256-authentication.md\` | Authentication approach |
| \`docs/adr/0004-redis-sliding-window-rate-limiting.md\` | Rate limiting strategy |
| \`docs/adr/0005-circuit-breaker-pattern.md\` | Circuit breaker for upstreams |
| \`docs/adr/0006-opentelemetry-distributed-tracing.md\` | Tracing infrastructure |
| \`docs/adr/0007-structured-logging-slog.md\` | Logging strategy |
| \`docs/adr/0008-viper-configuration-management.md\` | Config management |
| \`docs/adr/0009-postgresql-config-apikey-store.md\` | Database selection |
| \`docs/adr/0010-graceful-shutdown-health-checks.md\` | Lifecycle management |
| \`docs/adr/0011-request-response-transformation.md\` | Transformation pipeline |
| \`docs/adr/0012-ecs-alb-deployment.md\` | Deployment strategy |
| \`docs/architecture-constraints.md\` | Enforced invariants |

## Follow-Up Actions

After generating ADRs, proceed with:

1. **Review ADRs** — Each ADR should be reviewed by at least one other team member before status moves to \`Accepted\`
2. **Extract interfaces** — Use ADR implementation notes to define Go interfaces in \`internal/\` packages
3. **Update CLAUDE.md** — Add key architectural constraints from ADRs to the project rules
4. **Create GitHub Issues** — For each ADR, create implementation tickets tagged with \`architecture\`
5. **Run Phase 02 gate check** — Use \`/phase check 02\` to verify all architecture artifacts are complete

## Adding New ADRs Later

To add a new ADR after initial generation, paste this shorter prompt:

\`\`\`
Generate a new ADR for the go-api-gateway project following the format in docs/adr/. 
The next available number is ADR-NNNN.

Decision topic: [describe the decision]

Context: This is a Go 1.22 API gateway using Chi v5, Clean Architecture, 
deployed on AWS ECS. SOC 2 compliant. See existing ADRs in docs/adr/ for 
style and depth reference.

Update docs/adr/README.md to include the new entry.
\`\`\`

## Validating ADR Quality

Each ADR should pass these checks:

- [ ] Status is explicitly set (Proposed for new ADRs)
- [ ] Context explains the "why" with specific gateway constraints
- [ ] Decision is concrete — names specific Go packages and file paths
- [ ] At least 2 alternatives were considered with clear rejection reasons
- [ ] Consequences include both positive and negative impacts
- [ ] SOC 2 implications are addressed where relevant
- [ ] Performance impact is discussed (this is a hot-path gateway)
- [ ] Implementation notes reference actual \`internal/\` package paths
- [ ] No generic advice — everything is specific to this Go API gateway`,

  'playbook/prompts/02/api-design.md': `# API Design Prompt — Phase 02: Architecture

> **Copy-paste this prompt into Claude Code** to design the API surface for the go-api-gateway project.

---

## Prompt

\`\`\`
You are the API architect for the go-api-gateway project — a high-performance API gateway built with Go 1.22 and Chi v5 router. Design the complete API surface following RESTful conventions, Clean Architecture principles, and SOC 2 compliance requirements.

## Context

This gateway is the single entry point for a microservices architecture. It handles:
- Proxying requests to upstream services
- JWT (RS256) authentication and RBAC authorization
- Per-client rate limiting via Redis (sliding window)
- Circuit breaker pattern for upstream resilience
- Request/response transformation
- Comprehensive observability (OpenTelemetry traces, Prometheus metrics, structured logging)

The project uses Chi v5 for routing, PostgreSQL for config/metadata storage, and Redis for rate limiting and caching.

## Deliverables

### 1. Route Definitions

Define all Chi routes organized by concern. For each route, specify:
- HTTP method and path
- Handler function name (e.g., \`handler.CreateRoute\`)
- Required middleware chain (auth, rate limit, RBAC role, etc.)
- Request/response types (Go struct names from \`internal/model/\`)
- HTTP status codes for success and error cases

Organize routes into these groups:

**Admin API (internal management, requires admin JWT):**
- Route management (CRUD for upstream service routes)
- API key management (create, revoke, rotate, list)
- Rate limit policy management (per-client, per-route, global)
- Circuit breaker configuration
- Gateway health and readiness

**Proxy API (the actual gateway traffic):**
- Catch-all proxy handler with dynamic routing
- Middleware chain ordering for proxy requests

**Observability API (metrics and health):**
- Health check (liveness)
- Readiness check (dependencies)
- Prometheus metrics endpoint
- pprof debug endpoints (conditionally enabled)

### 2. Request/Response Models

Define Go structs in \`internal/model/\` for:
- Route configuration (upstream URL, path prefix, methods, timeout, retry policy)
- API key (key hash, client ID, scopes, rate limit tier, expiry)
- Rate limit policy (requests per window, window duration, burst)
- Circuit breaker config (failure threshold, timeout, half-open max)
- Standard API error response (code, message, request ID, timestamp)
- Standard paginated list response
- Health check response (status, dependencies, version, uptime)

Follow these Go conventions:
- Use \`json\` struct tags with \`omitempty\` where appropriate
- Use \`time.Duration\` for durations, \`time.Time\` for timestamps
- Use pointer types for optional fields
- Add doc comments on all exported types and fields
- Use custom types for enums (e.g., \`type CircuitState string\`)

### 3. Middleware Chain Design

Define the Chi middleware chain ordering for both admin and proxy routes. Specify:
- The exact order middleware executes (outer to inner)
- Which middleware is applied globally vs. per-route-group
- Middleware function signatures following Chi's \`func(next http.Handler) http.Handler\` pattern

Standard middleware to include:
- \`middleware.RequestID\` — inject X-Request-ID (use Chi's built-in or custom with slog)
- \`middleware.Recoverer\` — panic recovery with structured error logging
- \`middleware.RealIP\` — extract client IP from X-Forwarded-For
- \`middleware.Timeout\` — per-request timeout with context cancellation
- \`middleware.CORS\` — configurable CORS headers
- \`middleware.Compress\` — gzip response compression
- \`middleware.RequestLogger\` — structured request/response logging via slog
- \`middleware.JWTAuth\` — RS256 JWT validation, extract claims to context
- \`middleware.APIKeyAuth\` — API key validation from X-API-Key header
- \`middleware.RateLimit\` — per-client sliding window rate limit via Redis
- \`middleware.RBAC\` — role-based access control from JWT claims
- \`middleware.CircuitBreaker\` — per-upstream circuit breaker
- \`middleware.Metrics\` — Prometheus request duration, status code counters
- \`middleware.Tracing\` — OpenTelemetry span creation and propagation

### 4. Error Response Contract

Define a consistent error response format used across all endpoints:

\`\`\`go
// ErrorResponse is the standard API error envelope.
type ErrorResponse struct {
    Error     ErrorDetail \`json:"error"\`
    RequestID string      \`json:"request_id"\`
    Timestamp time.Time   \`json:"timestamp"\`
}

type ErrorDetail struct {
    Code    string            \`json:"code"\`
    Message string            \`json:"message"\`
    Details map[string]string \`json:"details,omitempty"\`
}
\`\`\`

Define error codes for:
- Authentication failures (expired token, invalid signature, missing token)
- Authorization failures (insufficient role, scope mismatch)
- Rate limiting (limit exceeded, include Retry-After header)
- Circuit breaker (upstream unavailable)
- Validation errors (bad request body, missing required fields)
- Not found (route not configured, upstream not found)
- Internal errors (masked for clients, detailed in logs)

Map each error code to an HTTP status code.

### 5. Chi Router Setup

Provide the router initialization code for \`cmd/gateway/main.go\` and \`internal/handler/router.go\`:

\`\`\`go
// router.go — show the full Chi router setup
func NewRouter(cfg *config.Config, deps *Dependencies) chi.Router {
    // Global middleware
    // Route groups with specific middleware
    // Admin routes
    // Proxy catch-all
    // Observability routes
}
\`\`\`

### 6. OpenAPI Hints

For each admin endpoint, provide enough detail to generate an OpenAPI 3.0 spec later:
- Operation ID
- Summary and description
- Request body schema reference
- Response schema references (success + errors)
- Security scheme (Bearer JWT or API Key)
- Rate limit headers (X-RateLimit-Limit, X-RateLimit-Remaining, X-RateLimit-Reset)

## Constraints

- All handler functions live in \`internal/handler/\` with one file per resource (routes.go, apikeys.go, ratelimit.go, health.go, proxy.go)
- All middleware lives in \`internal/middleware/\` with one file per middleware
- All models live in \`internal/model/\` with logical grouping (route.go, apikey.go, ratelimit.go, circuit.go, errors.go, common.go)
- Use \`context.Context\` propagation on every handler and service method
- Use \`httputil.RespondJSON\` and \`httputil.RespondError\` helpers from \`pkg/httputil/\` for consistent responses
- Follow Effective Go naming: exported types are PascalCase, JSON tags are snake_case
- File names use snake_case
- No file should exceed 300 lines
- Use interfaces for all service dependencies (enables testing with mocks)
- All routes must be testable with \`httptest\` and table-driven tests
- Admin API must be on a separate port or path prefix (/admin/v1/) from proxy traffic
- Include pagination on all list endpoints (cursor-based preferred, offset acceptable)
- Rate limit headers must be included on every proxy response
- SOC 2: all admin mutations must produce audit log entries

## Output Format

Structure your response as:

1. **Route Table** — Markdown table with Method, Path, Handler, Middleware, Auth
2. **Model Definitions** — Go struct code blocks for \`internal/model/\`
3. **Middleware Chain** — Ordered list with rationale for ordering
4. **Error Code Map** — Table mapping error codes to HTTP status and description
5. **Router Code** — Go code for \`internal/handler/router.go\`
6. **File Manifest** — List of files to create with brief description

Reference the project structure:
- cmd/gateway/ (entry point)
- internal/handler/ (HTTP handlers)
- internal/middleware/ (Chi middleware)
- internal/service/ (business logic interfaces + implementations)
- internal/repository/ (data access interfaces + implementations)
- internal/model/ (domain models)
- internal/config/ (Viper configuration)
- pkg/httputil/ (response helpers)
- pkg/errors/ (custom error types)
\`\`\`

---

## Usage Notes

- Run this prompt after completing Phase 01 (Discovery) and having requirements documented in \`docs/requirements.md\`
- The output feeds directly into Phase 03 (Foundation) where you scaffold the actual files
- Review the route table with the team before proceeding — changing routes later is expensive
- Save the output to \`docs/api-design.md\` for reference during implementation
- Use the model definitions as the starting point for \`internal/model/\` files
- The middleware chain ordering is critical for correctness — auth before rate limiting, tracing wrapping everything

## Follow-Up Prompts

After this design is approved, continue with:
- \`playbook/prompts/03/scaffold-handlers.md\` — Generate handler stubs from the route table
- \`playbook/prompts/03/scaffold-middleware.md\` — Generate middleware implementations
- \`playbook/prompts/03/scaffold-models.md\` — Generate model files from the struct definitions

## Validation Checklist

After Claude generates the design, verify:

- [ ] Every admin endpoint requires authentication
- [ ] Proxy catch-all route is last in the router
- [ ] Middleware ordering: tracing → request ID → recovery → logging → metrics → auth → rate limit → RBAC → handler
- [ ] All list endpoints support pagination
- [ ] Error codes cover all failure modes (auth, authz, rate limit, circuit breaker, validation, not found, internal)
- [ ] Rate limit headers defined (X-RateLimit-Limit, X-RateLimit-Remaining, X-RateLimit-Reset, Retry-After)
- [ ] Health endpoint has no authentication (ALB needs unauthenticated access)
- [ ] Readiness endpoint checks PostgreSQL and Redis connectivity
- [ ] Admin API is isolated from proxy traffic (separate path prefix or port)
- [ ] All models have JSON struct tags
- [ ] Audit logging mentioned for admin mutations (SOC 2)
- [ ] Circuit breaker config is per-upstream, not global
- [ ] Request timeout is configurable per-route
- [ ] pprof endpoints are behind a feature flag or admin auth`,

  'playbook/prompts/02/data-model-design.md': `# Data Model Design — Phase 02: Architecture

## Prompt for Claude Code

Copy and paste the following prompt into Claude Code to design the data models, database schemas, and domain types for the go-api-gateway project.

---

You are a senior Go architect designing the data model layer for a high-performance API gateway. The gateway uses PostgreSQL as its configuration store and API key metadata store, and Redis for rate limiting, caching, and session data.

## Context

- **Project**: go-api-gateway — single entry point for a microservices architecture
- **Architecture**: Clean Architecture (handler → service → repository)
- **Language**: Go 1.22+ with strict typing, no ORM (use database/sql + sqlx)
- **Databases**: PostgreSQL (persistent config), Redis (ephemeral/operational data)
- **Compliance**: SOC 2 — audit trails, data classification, encryption at rest
- **Directory**: Domain models go in \`internal/model/\`, repository interfaces in \`internal/repository/\`

## Task

Design the complete data model for the API gateway. For each model, produce:

1. **Go struct definitions** in \`internal/model/\` with proper JSON, DB, and validation tags
2. **PostgreSQL migration SQL** in \`scripts/migrations/\`
3. **Repository interface** in \`internal/repository/\`
4. **Redis key schema** for operational data

## Domain Models Required

### 1. Route Configuration (\`internal/model/route.go\`)

The core routing table that maps incoming requests to upstream services:

\`\`\`
Fields needed:
- ID (UUID, primary key)
- Name (unique human-readable identifier, e.g., "user-service-v2")
- Method (HTTP method: GET, POST, PUT, DELETE, PATCH, or * for all)
- PathPattern (Chi-compatible path, e.g., "/api/v2/users/{id}")
- UpstreamURL (target service base URL)
- StripPrefix (path prefix to strip before forwarding)
- TimeoutMs (per-route timeout in milliseconds, default 30000)
- RetryCount (number of retries, default 0)
- RetryBackoffMs (backoff between retries)
- CircuitBreakerEnabled (bool)
- CircuitBreakerThreshold (failure count to trip)
- RateLimitOverride (optional per-route rate limit, requests/minute)
- AuthRequired (bool, default true)
- RequiredRoles ([]string — RBAC roles needed)
- Headers (map[string]string — headers to inject into upstream request)
- Active (bool, soft enable/disable)
- Priority (int, for route matching order)
- Metadata (JSONB, extensible)
- CreatedAt, UpdatedAt timestamps
- CreatedBy, UpdatedBy (audit trail — user or system identifier)
\`\`\`

### 2. API Consumer (\`internal/model/consumer.go\`)

Represents a registered API client/consumer:

\`\`\`
Fields needed:
- ID (UUID)
- Name (organization or service name)
- Description
- ContactEmail
- Tier (enum: free, standard, premium, enterprise)
- RateLimitPerMinute (tier-based default, overridable)
- RateLimitPerHour
- BurstLimit
- Active (bool)
- AllowedOrigins ([]string — CORS)
- AllowedIPs ([]string — IP whitelist, empty = all)
- Metadata (JSONB)
- CreatedAt, UpdatedAt
- CreatedBy, UpdatedBy
\`\`\`

### 3. API Key (\`internal/model/apikey.go\`)

API keys issued to consumers:

\`\`\`
Fields needed:
- ID (UUID)
- ConsumerID (FK to Consumer)
- KeyHash (SHA-256 hash of the actual key — NEVER store plaintext)
- KeyPrefix (first 8 chars for identification, e.g., "gw_live_a1b2c3d4")
- Name (human label, e.g., "Production Key")
- Roles ([]string — RBAC roles granted)
- Scopes ([]string — fine-grained permissions, e.g., "routes:read")
- ExpiresAt (nullable — null means no expiry)
- LastUsedAt (nullable)
- LastUsedIP (nullable)
- Active (bool)
- RevokedAt (nullable timestamp)
- RevokedBy (nullable)
- RevokedReason (nullable)
- CreatedAt, UpdatedAt
- CreatedBy
\`\`\`

### 4. Audit Log (\`internal/model/audit.go\`)

SOC 2 audit trail for configuration changes:

\`\`\`
Fields needed:
- ID (UUID)
- Timestamp
- ActorID (who made the change — user ID or "system")
- ActorType (enum: user, apikey, system)
- Action (enum: create, update, delete, enable, disable, revoke)
- ResourceType (enum: route, consumer, apikey, config)
- ResourceID (UUID of affected resource)
- Changes (JSONB — before/after diff)
- IPAddress
- UserAgent
- RequestID (correlation ID)
- Metadata (JSONB)
\`\`\`

### 5. Gateway Config (\`internal/model/gateway_config.go\`)

Global gateway configuration stored in DB (hot-reloadable):

\`\`\`
Fields needed:
- ID (UUID)
- Key (unique string, e.g., "global.rate_limit.default")
- Value (string — parsed by application)
- ValueType (enum: string, int, bool, json, duration)
- Description
- Active (bool)
- UpdatedAt
- UpdatedBy
\`\`\`

## Redis Key Schema (\`internal/model/redis_keys.go\`)

Define constants and builder functions for all Redis keys:

\`\`\`
Rate Limiting:
- gw:rl:consumer:{consumer_id}:min — sliding window per minute
- gw:rl:consumer:{consumer_id}:hr — sliding window per hour
- gw:rl:route:{route_id}:min — per-route rate limit
- gw:rl:ip:{ip_address}:min — IP-based rate limit

Circuit Breaker:
- gw:cb:{route_id}:failures — failure counter
- gw:cb:{route_id}:state — open/closed/half-open
- gw:cb:{route_id}:last_failure — timestamp

Caching:
- gw:cache:route:{method}:{path_hash} — route resolution cache
- gw:cache:consumer:{key_prefix} — consumer lookup cache
- gw:cache:config:{key} — gateway config cache

Session/Auth:
- gw:auth:jwt:blacklist:{jti} — revoked JWT tokens
- gw:auth:apikey:{key_prefix} — API key validation cache
\`\`\`

## Repository Interfaces (\`internal/repository/\`)

Define interfaces following Go conventions:

\`\`\`go
// RouteRepository, ConsumerRepository, APIKeyRepository, AuditRepository, ConfigRepository
// Each with CRUD + domain-specific query methods
// Use context.Context as first parameter on all methods
// Return (result, error) tuples
// Use domain model types, not database types
\`\`\`

## Requirements

1. **Go structs**: Use proper field tags (\`json\`, \`db\` for sqlx, \`validate\` for go-playground/validator). Use \`time.Time\` for timestamps, \`uuid.UUID\` for IDs (google/uuid). Use pointer types for nullable fields. Add doc comments on all exported types and fields.

2. **PostgreSQL migrations**: Use numbered migration files (e.g., \`000001_create_routes.up.sql\`, \`000001_create_routes.down.sql\`). Include indexes on frequently queried columns. Add CHECK constraints for enums. Use \`gen_random_uuid()\` for default UUIDs. Add \`created_at\`/\`updated_at\` triggers.

3. **Repository interfaces**: One file per aggregate root. Include \`List\` methods with filtering/pagination support. Include a \`Tx\` method or accept \`*sql.Tx\` for transactional operations. Keep interfaces small and focused (Interface Segregation).

4. **Redis keys**: Use a \`RedisKey\` builder pattern with type-safe functions. Include TTL constants for each key category. Document the data type stored at each key (string, sorted set, hash).

5. **Data classification** (SOC 2):
   - Mark fields as PII, sensitive, or internal in doc comments
   - API key hashes are sensitive — never log or expose
   - Consumer contact emails are PII
   - Audit logs are immutable — no UPDATE or DELETE operations

6. **Validation**: Add struct-level validation tags. Create a \`Validate()\` method on each model. Validate enums, URL formats, CIDR ranges for IP allowlists.

7. **Pagination**: Define a shared \`PageRequest\` and \`PageResponse[T]\` generic type in \`internal/model/pagination.go\`.

## Output Structure

Generate the following files:

\`\`\`
internal/model/
  route.go
  consumer.go
  apikey.go
  audit.go
  gateway_config.go
  redis_keys.go
  pagination.go
  enums.go          # Shared enum types (Tier, Action, ActorType, etc.)
  validate.go       # Shared validation helpers

internal/repository/
  route_repository.go
  consumer_repository.go
  apikey_repository.go
  audit_repository.go
  config_repository.go

scripts/migrations/
  000001_create_routes.up.sql
  000001_create_routes.down.sql
  000002_create_consumers.up.sql
  000002_create_consumers.down.sql
  000003_create_api_keys.up.sql
  000003_create_api_keys.down.sql
  000004_create_audit_log.up.sql
  000004_create_audit_log.down.sql
  000005_create_gateway_config.up.sql
  000005_create_gateway_config.down.sql
\`\`\`

## Constraints

- No ORM — use \`database/sql\` and \`sqlx\` only
- No \`init()\` functions
- All errors wrapped with \`fmt.Errorf("operation: %w", err)\`
- File length must not exceed 300 lines — split if needed
- Use \`internal/\` to prevent external imports
- Follow Effective Go naming: \`APIKey\` not \`ApiKey\`, \`ID\` not \`Id\`, \`URL\` not \`Url\`
- Table-driven validation tests should be generated alongside models
- All timestamps in UTC

## Verification

After generating, confirm:
- [ ] \`go vet ./internal/model/...\` passes
- [ ] \`go vet ./internal/repository/...\` passes
- [ ] All exported types have doc comments
- [ ] No plaintext API key storage anywhere
- [ ] Audit log has no update/delete repository methods
- [ ] Redis keys use consistent prefix \`gw:\`
- [ ] Migration files are idempotent (IF NOT EXISTS where appropriate)
- [ ] Pagination generic type compiles with Go 1.22

---

## Usage Notes

- Run this prompt after completing API design (\`api-design.md\`) so route paths are known
- The models generated here feed directly into Phase 03 (Foundation) repository implementations
- Reference the ADRs from \`adr-generator.md\` for decisions on UUID strategy, pagination approach, and Redis key design
- After generation, run \`golangci-lint run ./internal/model/... ./internal/repository/...\` to verify lint compliance`,

  'playbook/prompts/03/ci-pipeline.md': `# CI Pipeline Setup — Phase 03 Foundation

## Prompt for Claude Code

Copy and paste the following prompt into Claude Code to generate the GitHub Actions CI/CD pipeline for the go-api-gateway project.

---

\`\`\`
I need you to create the complete CI/CD pipeline for our Go API gateway project. This is a high-performance API gateway built with Go 1.22 and Chi router, deployed to AWS ECS. We follow GitHub Flow with conventional commits and need SOC 2 compliant pipelines.

## What to Generate

### 1. \`.github/workflows/ci.yml\` — Main CI Pipeline

Create a GitHub Actions workflow triggered on push to \`main\` and on all pull requests. It must have these stages in order:

**Stage: Lint**
- Use golangci-lint v1.59+ with the config at \`.golangci.yml\`
- Run \`golangci-lint run ./...\`
- Fail fast on lint errors — do not proceed to other stages

**Stage: Vet**
- Run \`go vet ./...\`
- This catches issues golangci-lint may miss (e.g., printf format mismatches)

**Stage: Unit Tests**
- Run \`go test -v -count=1 -coverprofile=coverage.out -covermode=atomic ./internal/... ./pkg/...\`
- Exclude integration tests using build tag: \`-tags=!integration\`
- Upload coverage to the workflow artifacts
- Fail if coverage drops below 80% — use a step that parses \`go tool cover -func=coverage.out\` and checks the total

**Stage: Integration Tests**
- Use service containers for PostgreSQL 16 and Redis 7
- PostgreSQL config: user \`testuser\`, password \`testpass\`, db \`gateway_test\`, health check with \`pg_isready\`
- Redis config: default port 6379, health check with \`redis-cli ping\`
- Set environment variables: \`DATABASE_URL\`, \`REDIS_URL\`, \`GATEWAY_ENV=test\`
- Run \`go test -v -count=1 -tags=integration ./tests/...\`
- Timeout: 10 minutes

**Stage: Race Detection**
- Run \`go test -race -count=1 ./internal/... ./pkg/...\`
- This is critical for a concurrent API gateway — race conditions in middleware or rate limiting are unacceptable

**Stage: Build Binary**
- Build with: \`CGO_ENABLED=0 GOOS=linux GOARCH=amd64 go build -ldflags="-s -w -X main.version=\${{ github.sha }} -X main.buildTime=$(date -u +%Y-%m-%dT%H:%M:%SZ)" -o bin/gateway cmd/gateway/main.go\`
- Upload \`bin/gateway\` as a workflow artifact

**Stage: Security Scan**
- Run \`gosec ./...\` for static security analysis
- Run \`govulncheck ./...\` for known vulnerability detection
- These are required for SOC 2 compliance

**Stage: Build Docker Image**
- Only run on push to \`main\` (not on PRs)
- Use the multi-stage Dockerfile at \`deployments/docker/Dockerfile\`
- Tag with: \`\${{ github.sha }}\`, \`latest\`, and semver if tagged
- Push to ECR: \`\${{ secrets.AWS_ACCOUNT_ID }}.dkr.ecr.\${{ secrets.AWS_REGION }}.amazonaws.com/go-api-gateway\`
- Use OIDC for AWS authentication (no long-lived credentials — SOC 2 requirement)

**AI Code Flagging:**
- Add a step that checks for the \`ai-generated\` label or \`🤖\` marker in PR descriptions
- If detected, add a comment noting that AI-generated code requires additional review per our team policy

**Caching:**
- Cache Go modules using \`actions/cache\` with key based on \`go.sum\`
- Cache golangci-lint cache
- Cache Go build cache (\`~/.cache/go-build\`)

**Notifications:**
- On failure of \`main\` branch builds, post to Slack channel via webhook \`\${{ secrets.SLACK_WEBHOOK_CI }}\`
- Include: commit SHA, author, failed stage, link to workflow run

### 2. \`.github/workflows/deploy-staging.yml\` — Auto Deploy to Staging

Create a workflow triggered on successful completion of the CI workflow on \`main\`:

- Authenticate to AWS via OIDC
- Pull the Docker image tagged with the triggering commit SHA
- Update the ECS task definition for \`go-api-gateway-staging\` service
- Wait for deployment stability (5 minutes timeout)
- Run smoke tests against the staging URL: \`\${{ secrets.STAGING_URL }}\`
  - \`GET /healthz\` — expect 200
  - \`GET /readyz\` — expect 200
  - \`GET /metrics\` — expect 200 with Prometheus format
- On failure, automatically roll back to the previous task definition
- Post deployment status to Slack

### 3. \`.github/workflows/deploy-production.yml\` — Manual Production Deploy

Create a workflow with \`workflow_dispatch\` trigger requiring:
- Input: \`image_tag\` (required, the Docker image SHA to deploy)
- Input: \`confirm\` (required, must be "yes-deploy-production")
- Environment: \`production\` (with required reviewers configured in GitHub)

Steps:
- Validate the \`confirm\` input matches exactly
- Verify the image tag exists in ECR
- Update ECS task definition for \`go-api-gateway-production\`
- Use rolling deployment (minimum healthy 50%, maximum 200%)
- Run smoke tests against production health endpoints
- On failure, roll back and alert via Slack and PagerDuty webhook
- Create a GitHub deployment record

### 4. \`.golangci.yml\` — Linter Configuration

Configure golangci-lint with these linters enabled:
- \`govet\` — correctness checks
- \`errcheck\` — unchecked errors (critical for gateway reliability)
- \`staticcheck\` — advanced static analysis
- \`gosec\` — security-focused linting (SOC 2)
- \`revive\` — style and best practices
- \`gocyclo\` — cyclomatic complexity (max 15)
- \`goconst\` — repeated string literals
- \`misspell\` — typo detection
- \`prealloc\` — slice preallocation (performance matters for gateway)
- \`bodyclose\` — unclosed HTTP response bodies (critical for proxy/gateway)
- \`noctx\` — HTTP requests without context (we require context propagation)
- \`exportloopref\` — loop variable capture bugs
- \`unparam\` — unused function parameters

Exclusions:
- Skip \`errcheck\` in \`_test.go\` files
- Skip \`gosec\` G104 (unhandled errors) in test files
- Exclude \`tests/\` directory from \`gocyclo\`

Settings:
- \`gocyclo.min-complexity: 15\`
- \`goconst.min-len: 3\`
- \`goconst.min-occurrences: 3\`
- \`revive\` rules: exported functions must have comments, no blank imports except for side effects

### 5. \`.github/workflows/pr-checks.yml\` — PR Quality Gates

Create a workflow for pull request events that:
- Validates conventional commit format in PR title
- Checks branch naming matches \`type/ticket-desc\` pattern (e.g., \`feat/GW-42-add-circuit-breaker\`)
- Verifies \`go.sum\` is tidy (\`go mod tidy\` produces no diff)
- Checks no files exceed 300 lines (excluding generated code and test fixtures)
- Validates that changes to \`internal/auth/**\`, \`configs/production/**\`, \`*.pem\`, \`.env*\` trigger a warning comment requesting security review
- Checks that new exported functions have doc comments

### 6. \`.github/CODEOWNERS\`

Set up code ownership:
- \`*\` → \`@go-api-gateway/backend\`
- \`internal/auth/**\` → \`@go-api-gateway/security-leads\`
- \`configs/production/**\` → \`@go-api-gateway/security-leads @go-api-gateway/platform\`
- \`deployments/**\` → \`@go-api-gateway/platform\`
- \`.github/**\` → \`@go-api-gateway/platform\`
- \`internal/ratelimit/**\` → \`@go-api-gateway/backend-leads\`
- \`internal/circuit/**\` → \`@go-api-gateway/backend-leads\`
- \`*.pem\` → \`@go-api-gateway/security-leads\`
- \`.env*\` → \`@go-api-gateway/security-leads\`

### 7. \`Makefile\` — Developer Convenience

Create a Makefile with these targets that mirror CI stages:
- \`make lint\` — run golangci-lint
- \`make vet\` — run go vet
- \`make test\` — run unit tests with coverage
- \`make test-integration\` — run integration tests (requires local Docker services)
- \`make test-race\` — run race detection tests
- \`make test-all\` — run all tests
- \`make build\` — build the binary with version info
- \`make docker-build\` — build Docker image locally
- \`make docker-run\` — run the gateway locally with Docker Compose
- \`make security\` — run gosec and govulncheck
- \`make coverage\` — generate and open HTML coverage report
- \`make bench\` — run benchmarks for hot paths (middleware, rate limiter, router)
- \`make pprof\` — start the gateway with pprof enabled
- \`make clean\` — remove build artifacts
- \`make ci\` — run the full CI pipeline locally (lint, vet, test, race, security, build)
- \`make migrate-up\` — run database migrations
- \`make migrate-down\` — rollback last migration
- \`make generate\` — run go generate

Include a \`.PHONY\` declaration and use Go-idiomatic variable names at the top (\`GO\`, \`GOFLAGS\`, \`BINARY_NAME\`, \`VERSION\`).

## Constraints

- All workflows must use pinned action versions (SHA, not tags) for supply chain security (SOC 2)
- Use \`permissions\` blocks on every workflow — principle of least privilege
- Never expose secrets in logs — use masking
- Go version must be specified as \`1.22.x\` using \`actions/setup-go\`
- All test stages must have explicit timeouts
- Docker builds must use \`--no-cache\` in CI for reproducibility
- Include \`concurrency\` groups to cancel redundant workflow runs on the same branch
- Add workflow-level \`env\` block for common variables: \`GO_VERSION: '1.22'\`, \`REGISTRY\`, \`IMAGE_NAME\`

## Directory Structure Reference

The project follows this layout:
- \`cmd/gateway/\` — main entry point
- \`internal/\` — all private packages (handler, middleware, service, repository, model, config, auth, ratelimit, circuit, observability)
- \`pkg/\` — shared utilities (httputil, errors)
- \`configs/\` — YAML config files
- \`deployments/\` — Docker, Kubernetes, Helm
- \`tests/\` — integration and E2E tests
- \`scripts/\` — build and utility scripts

Generate all files with production-quality content. Use comments to explain non-obvious decisions. Ensure the pipeline is fast (target under 5 minutes for PR checks) by maximizing parallelism where stages don't depend on each other.
\`\`\`

---

## Expected Output Files

| File | Purpose |
|------|---------|
| \`.github/workflows/ci.yml\` | Main CI pipeline with all stages |
| \`.github/workflows/deploy-staging.yml\` | Auto-deploy to staging on main |
| \`.github/workflows/deploy-production.yml\` | Manual production deployment |
| \`.github/workflows/pr-checks.yml\` | PR quality gates and validation |
| \`.golangci.yml\` | Linter configuration |
| \`.github/CODEOWNERS\` | Code ownership rules |
| \`Makefile\` | Developer convenience targets |

## Verification Checklist

After Claude generates the files, verify:

- [ ] \`ci.yml\` has all 8 stages: lint, vet, unit tests, integration tests, race detection, build binary, security scan, Docker build
- [ ] Integration test stage has PostgreSQL and Redis service containers with health checks
- [ ] Coverage threshold enforcement step exists and checks for 80%
- [ ] Race detection runs as a separate stage (not combined with unit tests)
- [ ] Docker build only runs on \`main\` push, not on PRs
- [ ] AWS authentication uses OIDC, not access keys
- [ ] All actions use pinned SHA versions
- [ ] \`permissions\` blocks are present on every workflow
- [ ] \`concurrency\` groups prevent redundant runs
- [ ] \`.golangci.yml\` includes \`bodyclose\` and \`noctx\` (critical for gateway/proxy code)
- [ ] \`CODEOWNERS\` protects \`internal/auth/**\` and production configs
- [ ] \`Makefile\` has a \`ci\` target that mirrors the full pipeline
- [ ] Production deploy requires manual confirmation input
- [ ] Staging deploy runs smoke tests and can auto-rollback
- [ ] Slack notifications on failure for \`main\` branch
- [ ] Sensitive path changes trigger security review warnings in PRs
- [ ] Go module cache is configured for faster builds
- [ ] Build binary includes version and build time via ldflags

## Follow-Up Prompts

After the pipeline is generated, use these prompts to refine:

1. **Add benchmark regression detection**: "Add a CI stage that runs \`go test -bench=. -benchmem ./internal/middleware/... ./internal/ratelimit/...\` and compares results against the \`main\` branch baseline using \`benchstat\`. Fail if any hot path regresses by more than 10%."

2. **Add dependency review**: "Add a step to the PR workflow that uses \`actions/dependency-review-action\` to flag new dependencies with known vulnerabilities or restrictive licenses. We follow a conservative dependency policy."

3. **Add load test stage**: "Create a \`.github/workflows/load-test.yml\` that runs on-demand against staging using \`k6\` with the script at \`scripts/load-test.js\`. Test scenarios: baseline (100 RPS for 2 min), stress (ramp to 1000 RPS), and spike (0 to 500 RPS instant). Post results as a PR comment."

4. **Add SBOM generation**: "Add a step to the Docker build stage that generates a Software Bill of Materials (SBOM) using \`syft\` and attests it to the image using \`cosign\`. This is required for SOC 2 supply chain security."`,

  'playbook/prompts/03/iac-setup.md': `# IaC Setup — Phase 03 Foundation

## Copy-Pasteable Prompt for Claude Code

\`\`\`
You are setting up Infrastructure as Code (IaC) for the go-api-gateway project. This is a high-performance API gateway deployed on AWS using Terraform and Kubernetes (Helm). The infrastructure must meet SOC 2 compliance requirements.

## Context

- Project: go-api-gateway — API gateway with rate limiting, JWT auth, circuit breakers, and observability
- Cloud: AWS (ECS/EKS, ALB, ElastiCache Redis, RDS PostgreSQL, CloudWatch)
- IaC Tool: Terraform (with remote state in S3 + DynamoDB locking)
- Container Orchestration: Kubernetes with Helm charts
- Environments: development, staging, production
- Compliance: SOC 2 (encryption at rest, encryption in transit, audit logging, least privilege IAM)

## Directory Structure to Generate

\`\`\`
deployments/
  terraform/
    environments/
      dev/
        main.tf
        variables.tf
        terraform.tfvars
        backend.tf
      staging/
        main.tf
        variables.tf
        terraform.tfvars
        backend.tf
      production/
        main.tf
        variables.tf
        terraform.tfvars
        backend.tf
    modules/
      networking/
        main.tf
        variables.tf
        outputs.tf
      ecs/
        main.tf
        variables.tf
        outputs.tf
      rds/
        main.tf
        variables.tf
        outputs.tf
      elasticache/
        main.tf
        variables.tf
        outputs.tf
      alb/
        main.tf
        variables.tf
        outputs.tf
      monitoring/
        main.tf
        variables.tf
        outputs.tf
  kubernetes/
    helm/
      go-api-gateway/
        Chart.yaml
        values.yaml
        values-staging.yaml
        values-production.yaml
        templates/
          deployment.yaml
          service.yaml
          ingress.yaml
          hpa.yaml
          configmap.yaml
          secret.yaml
          serviceaccount.yaml
          pdb.yaml
          _helpers.tpl
  docker/
    Dockerfile
    Dockerfile.dev
    .dockerignore
\`\`\`

## Terraform Requirements

### Networking Module
- VPC with public/private subnets across 3 AZs
- NAT Gateway for private subnet egress
- VPC Flow Logs enabled (SOC 2: audit logging)
- Security groups: ALB (443 inbound), gateway service (8080 from ALB only), RDS (5432 from gateway SG only), Redis (6379 from gateway SG only)
- No public IPs on service instances
- Network ACLs restricting unnecessary traffic

### RDS Module (PostgreSQL)
- PostgreSQL 16 on db.t3.medium (dev) / db.r6g.large (production)
- Multi-AZ for staging and production
- Encryption at rest with KMS (SOC 2)
- Automated backups with 30-day retention (production)
- Performance Insights enabled
- Parameter group: \`log_statement = 'all'\` for production (SOC 2 audit)
- Private subnet placement only
- IAM database authentication enabled
- Deletion protection on production

### ElastiCache Module (Redis)
- Redis 7.x cluster mode
- r6g.large for production, cache.t3.medium for dev
- Encryption at rest and in transit (SOC 2)
- Auth token required
- Automatic failover for staging/production
- Private subnet placement only
- Used for: rate limiting (sliding window counters), response caching, session store

### ALB Module
- Application Load Balancer in public subnets
- HTTPS listener (443) with ACM certificate
- HTTP listener (80) redirecting to HTTPS
- Health check: GET /healthz with 5s interval, 2 healthy threshold
- Access logs to S3 bucket (SOC 2: audit trail)
- WAF integration for OWASP API Security Top 10 protection
- Target group with gateway service on port 8080

### ECS Module
- Fargate launch type (serverless containers)
- Task definition: 512 CPU / 1024 MiB (dev), 2048 CPU / 4096 MiB (production)
- Service with desired count: 2 (dev), 3 (staging), 6 (production)
- Auto-scaling: target tracking on CPU (60%) and ALB request count
- Task role with least-privilege IAM (SOC 2)
- Execution role for ECR pull and CloudWatch logs
- Environment variables injected from SSM Parameter Store (secrets)
- CloudWatch log group with 90-day retention

### Monitoring Module
- CloudWatch alarms: high CPU, high memory, 5xx error rate, high latency (p99 > 500ms)
- SNS topic for alerts
- CloudWatch dashboard for gateway metrics
- Prometheus endpoint exposed for custom metrics scraping
- X-Ray / OpenTelemetry collector sidecar configuration

### Remote State
- S3 bucket with versioning and encryption for state files
- DynamoDB table for state locking
- Separate state per environment
- Bucket policy restricting access to CI/CD role and admin role only

### Tagging Strategy
All resources must have these tags:
\`\`\`hcl
tags = {
  Project     = "go-api-gateway"
  Environment = var.environment
  ManagedBy   = "terraform"
  Team        = "platform"
  Compliance  = "soc2"
}
\`\`\`

## Dockerfile Requirements

### Production Dockerfile (multi-stage)
- Stage 1: Build with golang:1.22-alpine
  - Copy go.mod and go.sum first (layer caching)
  - Run \`go mod download\`
  - Copy source code
  - Build with CGO_DISABLED=1, static binary: \`go build -ldflags="-s -w -X main.version=\${VERSION}" -o /bin/gateway cmd/gateway/main.go\`
- Stage 2: Runtime with gcr.io/distroless/static-debian12
  - Copy binary from build stage
  - Non-root user (65534)
  - Expose port 8080 (HTTP), 9090 (metrics), 6060 (pprof — dev only)
  - Health check: HEALTHCHECK --interval=10s --timeout=3s CMD ["/bin/gateway", "healthcheck"]
  - ENTRYPOINT ["/bin/gateway"]

### Development Dockerfile
- Based on golang:1.22-alpine
- Install air (hot reload), delve (debugger), golangci-lint
- Mount source code as volume
- Expose ports 8080, 9090, 6060, 2345 (delve)
- CMD ["air", "-c", ".air.toml"]

### .dockerignore
- Exclude: .git, .github, .claude, docs, playbook, plugin, *.md, bin/, tmp/, vendor/ (if not vendoring), .env*, *.pem

## Helm Chart Requirements

### Chart.yaml
- apiVersion: v2
- name: go-api-gateway
- version: 0.1.0
- appVersion: "0.1.0"

### Deployment
- Rolling update strategy: maxSurge 1, maxUnavailable 0
- Readiness probe: GET /healthz, initialDelaySeconds 5, periodSeconds 10
- Liveness probe: GET /healthz, initialDelaySeconds 15, periodSeconds 20
- Startup probe: GET /healthz, failureThreshold 30, periodSeconds 2
- Resource requests/limits configurable per environment
- Pod anti-affinity: prefer spreading across nodes
- Topology spread constraints across AZs
- Security context: runAsNonRoot, readOnlyRootFilesystem, drop ALL capabilities
- Service account with IRSA annotations for AWS access
- Environment variables from ConfigMap and Secret references
- Sidecar: OpenTelemetry collector (optional, toggled via values)

### HPA
- Min replicas: 2 (staging), 4 (production)
- Max replicas: 10 (staging), 50 (production)
- Target CPU utilization: 60%
- Target memory utilization: 75%
- Custom metric: http_requests_per_second (from Prometheus adapter)
- Scale-down stabilization: 300s

### PodDisruptionBudget
- minAvailable: 1 (staging), 50% (production)

### Ingress
- nginx ingress class
- TLS termination
- Rate limiting annotations
- CORS headers
- Proxy buffer size for large JWT headers

### ConfigMap
- Gateway configuration: upstream routes, timeouts, rate limit defaults
- Redis connection string (non-secret parts)
- PostgreSQL host/port/database (non-secret parts)
- OpenTelemetry collector endpoint
- Log level, log format

### Secret (external-secrets or sealed-secrets reference)
- JWT signing keys (RS256 private/public key paths)
- Redis auth token
- PostgreSQL credentials
- API key encryption key
- Do NOT store actual secrets in Helm values — reference ExternalSecret or SealedSecret CRDs

## SOC 2 Compliance Checklist for IaC
- [ ] All data encrypted at rest (RDS, ElastiCache, S3, EBS)
- [ ] All data encrypted in transit (TLS 1.2+ everywhere)
- [ ] VPC Flow Logs enabled
- [ ] ALB access logs enabled
- [ ] CloudWatch log retention >= 90 days
- [ ] IAM roles follow least privilege
- [ ] No hardcoded secrets in Terraform or Helm
- [ ] Secrets managed via SSM Parameter Store or Secrets Manager
- [ ] Database audit logging enabled
- [ ] Deletion protection on production databases
- [ ] MFA delete on S3 state bucket
- [ ] Terraform state encrypted at rest
- [ ] Network segmentation (private subnets for data tier)
- [ ] WAF rules for OWASP API Security Top 10

## Output Format

Generate each file with its full path as a header comment. Use realistic values for development environment and parameterized values for staging/production. Include inline comments explaining SOC 2 relevant configurations.

Reference the project's CI pipeline at \`.github/workflows/\` for how Docker images are built and pushed. Reference \`configs/\` directory for application-level YAML configuration that gets mounted via ConfigMap.

After generating the IaC files, provide:
1. A \`scripts/tf-init.sh\` script that initializes Terraform for a given environment
2. A \`scripts/helm-deploy.sh\` script that deploys the Helm chart to a given environment
3. A summary of what manual steps are needed (ACM certificate, DNS, initial secrets seeding)

Ensure all Terraform follows HashiCorp style conventions and passes \`terraform fmt\` and \`terraform validate\`. Ensure all Helm templates pass \`helm lint\` and \`helm template\` rendering.
\`\`\`

## When to Use

Run this prompt during **Phase 03 — Foundation** after the project scaffold (\`project-scaffold.md\`) and CI pipeline (\`ci-pipeline.md\`) are in place. The IaC setup depends on:

- Architecture decisions from Phase 02 (see \`playbook/prompts/02/adr-generator.md\`)
- Data model design from Phase 02 (see \`playbook/prompts/02/data-model-design.md\` for PostgreSQL schema)
- API design from Phase 02 (see \`playbook/prompts/02/api-design.md\` for route definitions)

## Verification After Running

\`\`\`bash
# Validate Terraform
cd deployments/terraform/environments/dev
terraform init
terraform validate
terraform fmt -check -recursive ../../

# Lint Helm chart
helm lint deployments/kubernetes/helm/go-api-gateway
helm template test deployments/kubernetes/helm/go-api-gateway

# Build Docker image
docker build -f deployments/docker/Dockerfile -t go-api-gateway:test .
docker build -f deployments/docker/Dockerfile.dev -t go-api-gateway:dev .

# Verify distroless image has no shell (security)
docker run --rm go-api-gateway:test /bin/sh 2>&1 | grep -q "not found" && echo "PASS: No shell in production image"

# Check image size (should be < 20MB for distroless + static Go binary)
docker images go-api-gateway:test --format "{{.Size}}"
\`\`\`

## Related Prompts

- \`playbook/prompts/03/project-scaffold.md\` — Project directory structure (run first)
- \`playbook/prompts/03/ci-pipeline.md\` — GitHub Actions workflows that build and deploy using this IaC
- \`playbook/prompts/02/data-model-design.md\` — PostgreSQL schema that RDS will host
- \`playbook/prompts/05/observability-setup.md\` — OpenTelemetry and Prometheus configuration that integrates with the monitoring module`,

  'playbook/prompts/03/project-scaffold.md': `# Phase 03 Prompt: Project Scaffold — Go API Gateway

> **Copy-paste this prompt into Claude Code to scaffold the go-api-gateway project foundation.**
> Run after Phase 02 (Architecture) is complete and ADRs are finalized.

---

## Prompt

\`\`\`
You are scaffolding the foundation for "go-api-gateway" — a high-performance API gateway built with Go 1.22 and Chi v5. This is Phase 03 (Foundation) of the CodeForge playbook.

## Context

Review these files before starting:
- playbook/phases/03-foundation.md (phase requirements)
- docs/architecture/ (any ADRs from Phase 02)
- docs/api/ (API design from Phase 02)

## What to Generate

### 1. Go Module Initialization

Initialize the Go module and create go.mod with these dependencies:

\`\`\`
module github.com/your-org/go-api-gateway

go 1.22

require (
    github.com/go-chi/chi/v5          // HTTP router
    github.com/go-chi/cors             // CORS middleware
    github.com/golang-jwt/jwt/v5       // JWT parsing and validation
    github.com/redis/go-redis/v9       // Redis client
    github.com/jackc/pgx/v5            // PostgreSQL driver
    github.com/spf13/viper             // Configuration management
    github.com/kelseyhightower/envconfig // Environment variable binding
    github.com/stretchr/testify        // Test assertions
    github.com/prometheus/client_golang // Prometheus metrics
    go.opentelemetry.io/otel           // OpenTelemetry API
    go.opentelemetry.io/otel/sdk       // OpenTelemetry SDK
    go.opentelemetry.io/otel/exporters/otlp/otlptrace // OTLP trace exporter
    go.opentelemetry.io/contrib/instrumentation/net/http/otelhttp // HTTP instrumentation
    golang.org/x/time                  // Rate limiter (token bucket)
)
\`\`\`

### 2. Directory Structure

Create the full directory tree with placeholder files. Every Go package directory must have at least a doc.go with a package comment:

\`\`\`
cmd/
  gateway/
    main.go                    # Entry point: config load, DI wiring, server start, graceful shutdown

internal/
  handler/
    doc.go
    health.go                  # GET /healthz, GET /readyz endpoints
    health_test.go             # Table-driven tests for health handlers
    router.go                  # Chi router setup, middleware chain, route registration

  middleware/
    doc.go
    auth.go                    # JWT validation middleware (RS256)
    auth_test.go
    ratelimit.go               # Per-client rate limiting middleware
    ratelimit_test.go
    logging.go                 # Structured request/response logging with slog
    logging_test.go
    recovery.go                # Panic recovery middleware
    recovery_test.go
    requestid.go               # X-Request-ID generation/propagation
    requestid_test.go
    cors.go                    # CORS configuration wrapper
    cors_test.go

  service/
    doc.go
    gateway.go                 # Core gateway/proxy logic interface and implementation
    gateway_test.go

  repository/
    doc.go
    postgres.go                # PostgreSQL connection pool, health check
    postgres_test.go
    redis.go                   # Redis connection, health check
    redis_test.go
    route_store.go             # Route configuration CRUD from PostgreSQL
    route_store_test.go

  model/
    doc.go
    route.go                   # Route, Upstream, RouteConfig domain models
    request.go                 # GatewayRequest, GatewayResponse DTOs
    errors.go                  # Domain error types (ErrRouteNotFound, ErrUpstreamTimeout, etc.)
    auth.go                    # Claims, APIKey, Permission models

  config/
    doc.go
    config.go                  # Config struct with Viper loading
    config_test.go

  auth/
    doc.go
    jwt.go                     # JWT validator interface and RS256 implementation
    jwt_test.go
    apikey.go                  # API key verification against PostgreSQL/Redis
    apikey_test.go
    rbac.go                    # Role-based access control checks
    rbac_test.go

  ratelimit/
    doc.go
    limiter.go                 # Rate limiter interface
    redis_limiter.go           # Redis sliding window implementation
    redis_limiter_test.go

  circuit/
    doc.go
    breaker.go                 # Circuit breaker interface and implementation
    breaker_test.go

  observability/
    doc.go
    tracing.go                 # OpenTelemetry tracer provider setup
    metrics.go                 # Prometheus metrics registration (request count, latency histogram, etc.)
    logging.go                 # slog handler configuration (JSON, log level)

pkg/
  httputil/
    response.go                # JSON response helpers: WriteJSON, WriteError, WriteNoContent
    response_test.go

  errors/
    codes.go                   # Error code constants (e.g., ErrCodeUnauthorized, ErrCodeRateLimited)
    apierror.go                # APIError struct with Code, Message, Details, HTTP status mapping
    apierror_test.go

configs/
  development.yaml             # Dev config (local Redis/Postgres, debug logging, relaxed rate limits)
  staging.yaml                 # Staging config (ElastiCache, RDS, info logging)
  production.yaml              # Production config (strict rate limits, warn logging, TLS)

deployments/
  docker/
    Dockerfile                 # Multi-stage build: build with Go 1.22, run on distroless
    Dockerfile.dev             # Development Dockerfile with hot reload (air)
    docker-compose.yaml        # Local dev: gateway + PostgreSQL + Redis + Jaeger + Prometheus
  kubernetes/
    namespace.yaml
    deployment.yaml
    service.yaml
    configmap.yaml
    hpa.yaml                   # Horizontal Pod Autoscaler
  helm/
    Chart.yaml
    values.yaml
    values-staging.yaml
    values-production.yaml

scripts/
  migrate.sh                   # Run database migrations
  load-test.sh                 # k6 or vegeta load test runner
  lint.sh                      # golangci-lint wrapper
  build.sh                     # Build binary with version info via ldflags

tests/
  integration/
    gateway_test.go            # Integration test with real Redis + PostgreSQL (testcontainers)
    auth_test.go               # JWT auth integration test
  e2e/
    proxy_test.go              # End-to-end proxy routing test

docs/
  architecture/                # ADRs from Phase 02 (preserve existing)
  api/                         # API docs from Phase 02 (preserve existing)
  runbooks/
    incident-response.md       # Placeholder
    deployment.md              # Placeholder

.github/
  workflows/
    ci.yaml                    # Full CI pipeline (lint, vet, test, race, build, docker)
    deploy-staging.yaml        # Deploy to staging on merge to main
  PULL_REQUEST_TEMPLATE.md
  CODEOWNERS

.claude/
  settings.json                # Claude Code project settings (already exists, preserve)

.golangci.yml                  # golangci-lint configuration
.gitignore                     # Go-specific gitignore
Makefile                       # Common targets: build, test, lint, run, docker-build, migrate
README.md                      # Project overview, quickstart, architecture summary
\`\`\`

### 3. Key File Contents — Be Specific

#### cmd/gateway/main.go
- Use \`context.Background()\` with signal handling (\`os.Signal\`, \`syscall.SIGTERM\`, \`syscall.SIGINT\`)
- Load config via \`internal/config\` using Viper
- Initialize PostgreSQL connection pool (\`pgxpool\`)
- Initialize Redis client (\`go-redis\`)
- Initialize OpenTelemetry tracer provider
- Initialize Prometheus metrics
- Wire dependencies: repositories → services → handlers
- Build Chi router via \`internal/handler.NewRouter()\`
- Start \`http.Server\` with read/write timeouts (10s read, 30s write, 120s idle)
- Graceful shutdown with 30-second drain period
- Use \`slog.Default()\` for structured logging throughout
- NO init() functions

#### internal/handler/router.go
- Export \`NewRouter(deps Dependencies) chi.Router\` function
- \`Dependencies\` struct holds all injected services
- Middleware chain order:
  1. \`middleware.RequestID\`
  2. \`middleware.RealIP\` (from Chi)
  3. \`middleware.Logging\` (custom slog)
  4. \`middleware.Recovery\`
  5. \`middleware.CORS\`
  6. \`middleware.Prometheus\` (metrics collection)
  7. \`otelhttp.NewMiddleware\` (tracing)
- Route groups:
  - \`/healthz\` — unauthenticated health check
  - \`/readyz\` — unauthenticated readiness check
  - \`/metrics\` — Prometheus metrics endpoint
  - \`/api/v1/*\` — authenticated routes with rate limiting and auth middleware

#### internal/handler/health.go
- \`HealthHandler\` struct with PostgreSQL and Redis health check dependencies
- \`Healthz\` handler returns 200 with \`{"status": "ok", "version": "..."}\`
- \`Readyz\` handler checks PostgreSQL and Redis connectivity, returns 200 or 503
- Both handlers accept \`context.Context\` from request

#### internal/middleware/auth.go
- \`JWTAuth(validator auth.JWTValidator) func(http.Handler) http.Handler\`
- Extract Bearer token from Authorization header
- Validate JWT signature (RS256) and claims (exp, iss, aud)
- Inject claims into request context via \`context.WithValue\`
- Return 401 with structured APIError on failure
- Must be composable Chi middleware signature

#### internal/middleware/ratelimit.go
- \`RateLimit(limiter ratelimit.Limiter) func(http.Handler) http.Handler\`
- Extract client identifier from JWT claims or API key or IP
- Call limiter to check/decrement quota
- Set \`X-RateLimit-Limit\`, \`X-RateLimit-Remaining\`, \`X-RateLimit-Reset\` headers
- Return 429 with structured APIError and \`Retry-After\` header when exceeded

#### internal/config/config.go
- \`Config\` struct with nested structs: \`ServerConfig\`, \`PostgresConfig\`, \`RedisConfig\`, \`AuthConfig\`, \`RateLimitConfig\`, \`ObservabilityConfig\`
- \`Load(configPath string) (*Config, error)\` function using Viper
- Support YAML file + environment variable overrides (prefix: \`GATEWAY_\`)
- Validate required fields, return descriptive errors
- Sensitive fields (DB password, JWT secret) loaded only from env vars, never from YAML

#### internal/model/errors.go
- Define sentinel errors: \`ErrRouteNotFound\`, \`ErrUpstreamTimeout\`, \`ErrUpstreamUnavailable\`, \`ErrUnauthorized\`, \`ErrForbidden\`, \`ErrRateLimited\`
- All errors implement \`error\` interface
- Wrap with \`fmt.Errorf("context: %w", err)\` pattern

#### pkg/errors/apierror.go
- \`APIError\` struct: \`Code string\`, \`Message string\`, \`Details map[string]any\`, \`HTTPStatus int\`
- \`func (e *APIError) Error() string\`
- Constructor functions: \`NewUnauthorized()\`, \`NewForbidden()\`, \`NewRateLimited()\`, \`NewBadRequest()\`, \`NewInternal()\`
- \`ToHTTPResponse(w http.ResponseWriter)\` method that writes JSON

#### pkg/httputil/response.go
- \`WriteJSON(w http.ResponseWriter, status int, data any) error\`
- \`WriteError(w http.ResponseWriter, err *errors.APIError)\`
- \`WriteNoContent(w http.ResponseWriter)\`
- Set \`Content-Type: application/json\` header
- Use \`encoding/json.NewEncoder\` for streaming

#### .golangci.yml
- Enable linters: govet, errcheck, staticcheck, gosec, revive, gocyclo, goimports, unused, ineffassign, misspell, prealloc
- Set gocyclo max complexity to 15
- Set max line length to 120
- Exclude test files from some linters (gocyclo, funlen)
- Set revive rules for exported function comments

#### Makefile
Targets:
- \`build\`: \`go build -ldflags "-X main.version=$(VERSION)" -o bin/gateway cmd/gateway/main.go\`
- \`test\`: \`go test -race -coverprofile=coverage.out ./...\`
- \`test-integration\`: \`go test -race -tags=integration ./tests/...\`
- \`lint\`: \`golangci-lint run ./...\`
- \`vet\`: \`go vet ./...\`
- \`fmt\`: \`goimports -w . && gofmt -w .\`
- \`run\`: \`go run cmd/gateway/main.go\`
- \`docker-build\`: \`docker build -t go-api-gateway:$(VERSION) -f deployments/docker/Dockerfile .\`
- \`docker-up\`: \`docker-compose -f deployments/docker/docker-compose.yaml up -d\`
- \`docker-down\`: \`docker-compose -f deployments/docker/docker-compose.yaml down\`
- \`migrate\`: \`./scripts/migrate.sh\`
- \`coverage\`: parse coverage.out, fail if below 80%
- \`clean\`: remove bin/ and coverage files

#### .github/workflows/ci.yaml
Jobs:
1. **lint**: Run golangci-lint with Go 1.22
2. **test**: Run \`go test -race -coverprofile=coverage.out ./...\`, upload coverage, fail if < 80%
3. **integration**: Start PostgreSQL and Redis services, run integration tests with \`-tags=integration\`
4. **build**: Build binary, build Docker image, push to ECR on main branch
- Use Go 1.22 in all jobs
- Cache Go modules and build cache
- Mark AI-generated code with \`ai-generated\` label detection

#### .github/CODEOWNERS
\`\`\`
# Auth and security — requires security-aware reviewer
internal/auth/**    @your-org/security-reviewers
internal/middleware/auth.go  @your-org/security-reviewers
*.pem               @your-org/security-reviewers
configs/production.yaml @your-org/platform-leads

# Core gateway logic
internal/service/**  @your-org/backend-leads
internal/handler/**  @your-org/backend-leads

# Infrastructure
deployments/**       @your-org/platform-leads
.github/workflows/** @your-org/platform-leads
\`\`\`

#### deployments/docker/Dockerfile
- Stage 1: \`golang:1.22-alpine\` — build with CGO_DISABLED=1, GOOS=linux
- Stage 2: \`gcr.io/distroless/static-debian12\` — copy binary, expose 8080, run as nonroot
- Include health check: \`HEALTHCHECK CMD ["/gateway", "healthcheck"]\` or use wget

#### deployments/docker/docker-compose.yaml
Services:
- \`gateway\`: build from Dockerfile.dev, ports 8080:8080, depends on postgres, redis
- \`postgres\`: postgres:16-alpine, port 5432, with init script volume
- \`redis\`: redis:7-alpine, port 6379
- \`jaeger\`: jaegertracing/all-in-one, ports 16686 (UI), 4318 (OTLP)
- \`prometheus\`: prom/prometheus, port 9090, with config volume

#### .gitignore
- bin/, vendor/, coverage.out, *.pem, .env, .env.*, *.exe, __debug_bin
- IDE files: .idea/, .vscode/, *.swp
- OS files: .DS_Store, Thumbs.db

### 4. Test Stubs

Every \`_test.go\` file must:
- Use table-driven tests with \`t.Run()\`
- Use \`testify/assert\` or \`testify/require\` for assertions
- Use \`httptest.NewRecorder()\` and \`httptest.NewRequest()\` for HTTP tests
- Include at least one test case stub with a \`// TODO: implement\` comment
- Follow naming: \`TestFunctionName_Scenario\`

Example pattern for health_test.go:
\`\`\`go
func TestHealthz_ReturnsOK(t *testing.T) {
    tests := []struct {
        name       string
        wantStatus int
        wantBody   string
    }{
        {
            name:       "healthy service returns 200",
            wantStatus: http.StatusOK,
            wantBody:   \`"status":"ok"\`,
        },
    }
    for _, tt := range tests {
        t.Run(tt.name, func(t *testing.T) {
            // TODO: implement
        })
    }
}
\`\`\`

### 5. Configuration Files

#### configs/development.yaml
\`\`\`yaml
server:
  host: "0.0.0.0"
  port: 8080
  read_timeout: 10s
  write_timeout: 30s
  idle_timeout: 120s

postgres:
  host: localhost
  port: 5432
  database: gateway_dev
  user: gateway
  max_conns: 10
  min_conns: 2

redis:
  addr: localhost:6379
  db: 0
  pool_size: 10

auth:
  jwt_issuer: "https://auth.dev.example.com"
  jwt_audience: "go-api-gateway"
  # jwt_public_key loaded from GATEWAY_AUTH_JWT_PUBLIC_KEY env var

rate_limit:
  enabled: true
  default_rpm: 1000
  burst: 50

observability:
  log_level: debug
  log_format: text
  tracing_enabled: true
  tracing_endpoint: "http://localhost:4318"
  metrics_enabled: true
\`\`\`

### 6. Conventions to Enforce

- Every exported type and function has a doc comment
- No \`init()\` functions anywhere
- All errors wrapped with \`%w\`
- Context passed as first parameter to all functions that do I/O
- Interfaces defined in the package that uses them (consumer-side interfaces)
- Use \`//go:generate\` comments where appropriate (e.g., mocks)
- File names use snake_case
- Max 300 lines per file — split if larger

### 7. Verification

After scaffolding, run these commands and confirm they pass:
1. \`go mod tidy\` — no errors
2. \`go vet ./...\` — no issues
3. \`go build ./...\` — compiles successfully
4. \`go test ./...\` — all test stubs pass (or skip gracefully)
5. \`golangci-lint run ./...\` — no lint errors (create .golangci.yml first)

Report the results of each command.

## Output Format

Create all files with their full content. Do not use placeholder comments like "add code here" — write real, compilable Go code for every file. Test files should have real test structure with TODO comments only for the test body logic that depends on unimplemented features.

After creating all files, run the verification commands and report results.

## Important

- This is a SOC 2 compliant project. Never commit secrets, passwords, or private keys to any file.
- All sensitive configuration must come from environment variables.
- The scaffold must compile and pass \`go vet\` on first run.
- Follow Effective Go and Go Code Review Comments guidelines throughout.
\`\`\`

---

## Usage

1. Ensure Phase 02 artifacts exist in \`docs/architecture/\` and \`docs/api/\`
2. Open Claude Code in the project root
3. Copy-paste the prompt above
4. Review generated files, especially:
   - \`cmd/gateway/main.go\` — verify graceful shutdown and DI wiring
   - \`internal/handler/router.go\` — verify middleware chain order
   - \`internal/middleware/auth.go\` — verify JWT validation approach
   - \`.golangci.yml\` — verify linter configuration
   - \`Makefile\` — verify all targets work
5. Run \`make lint && make test\` to confirm scaffold integrity
6. Commit with: \`feat: scaffold project foundation (Phase 03)\`

## Post-Scaffold Checklist

- [ ] \`go mod tidy\` succeeds
- [ ] \`go vet ./...\` passes
- [ ] \`go build ./...\` compiles
- [ ] \`go test ./...\` passes
- [ ] \`golangci-lint run\` passes
- [ ] \`docker-compose up\` starts all services
- [ ] \`/healthz\` endpoint returns 200
- [ ] \`/readyz\` endpoint checks dependencies
- [ ] \`/metrics\` endpoint exposes Prometheus metrics
- [ ] All doc.go files have package comments
- [ ] No secrets in any committed file
- [ ] CODEOWNERS file matches team structure
- [ ] CI workflow runs successfully on push
- [ ] Update \`playbook/current-phase.json\` to Phase 03 complete

## Next Phase

After scaffold is verified, proceed to **Phase 04 (Core Implementation)** using \`playbook/prompts/04/\` prompts to implement the gateway proxy logic, JWT authentication, rate limiting, and circuit breaker.`,

  'playbook/prompts/04/auth-implementation.md': `# Auth Implementation Prompt — Phase 04: Core Implementation

> Copy-paste this prompt into Claude Code to implement the JWT authentication, API key verification, and RBAC middleware for the go-api-gateway.

---

## Prompt

\`\`\`
You are implementing the authentication and authorization layer for the go-api-gateway project. This is a critical security component — every design decision must prioritize correctness and SOC 2 compliance.

## Context

Review these files before starting:
- \`internal/auth/\` — target directory for all auth code
- \`internal/middleware/\` — where Chi middleware wrappers live
- \`internal/model/\` — domain models and DTOs
- \`internal/config/\` — Viper configuration loading
- \`internal/repository/\` — data access layer (PostgreSQL, Redis)
- \`pkg/errors/\` — custom error types and error codes
- \`docs/\` — any existing ADRs or API design docs

## Requirements

### 1. JWT Validation (\`internal/auth/jwt.go\`)

Implement a JWT validator with these specifications:

- **Algorithm**: RS256 only — reject tokens signed with any other algorithm (prevent algorithm confusion attacks per OWASP API Security Top 10)
- **Key Management**: Load RSA public keys from PEM files or JWKS endpoint (configurable via Viper)
- **Key Rotation**: Support multiple active public keys identified by \`kid\` header claim for zero-downtime key rotation
- **Claims Validation**:
  - \`exp\` — reject expired tokens (with configurable clock skew tolerance, default 30s)
  - \`nbf\` — reject tokens not yet valid
  - \`iss\` — validate against allowed issuers list from config
  - \`aud\` — validate against expected audience(s)
  - \`sub\` — extract and propagate as authenticated principal
- **Custom Claims**: Extract \`roles\`, \`permissions\`, \`client_id\`, and \`tenant_id\` into a typed \`AuthClaims\` struct
- **Interface**: Define a \`TokenValidator\` interface so implementations are swappable for testing

\`\`\`go
// TokenValidator validates and parses JWT tokens.
type TokenValidator interface {
    Validate(ctx context.Context, tokenString string) (*AuthClaims, error)
}
\`\`\`

- **Errors**: Return typed errors (e.g., \`ErrTokenExpired\`, \`ErrTokenMalformed\`, \`ErrInvalidSignature\`, \`ErrInvalidIssuer\`) wrapping with \`fmt.Errorf\` and \`%w\`
- **Logging**: Use \`slog\` to log validation failures at Warn level with \`client_id\`, \`iss\`, and failure reason — never log the token itself
- **Testing**: Write table-driven tests covering: valid token, expired token, wrong algorithm, invalid signature, missing claims, unknown kid, clock skew edge cases

### 2. API Key Verification (\`internal/auth/apikey.go\`)

Implement API key authentication:

- **Storage**: API key metadata stored in PostgreSQL (\`api_keys\` table: \`id\`, \`key_hash\`, \`client_id\`, \`tenant_id\`, \`roles\`, \`rate_limit_tier\`, \`is_active\`, \`expires_at\`, \`created_at\`, \`last_used_at\`)
- **Hashing**: Store only SHA-256 hashes of API keys — never store plaintext keys
- **Lookup Flow**:
  1. Extract key from \`X-API-Key\` header or \`api_key\` query parameter (header preferred)
  2. Hash the provided key with SHA-256
  3. Check Redis cache first (\`apikey:{hash}\` with 5-minute TTL)
  4. On cache miss, query PostgreSQL and populate Redis cache
  5. Validate \`is_active\` and \`expires_at\`
  6. Update \`last_used_at\` asynchronously (fire-and-forget goroutine with recovery)
- **Interface**: Define an \`APIKeyVerifier\` interface

\`\`\`go
// APIKeyVerifier verifies API keys and returns associated claims.
type APIKeyVerifier interface {
    Verify(ctx context.Context, key string) (*AuthClaims, error)
}
\`\`\`

- **Rate Limit Tier**: Include \`rate_limit_tier\` in returned claims so the rate limiter middleware can apply per-client limits
- **Revocation**: When a key is revoked, delete the Redis cache entry immediately
- **Testing**: Table-driven tests with mock repository. Test: valid key, expired key, revoked key, cache hit, cache miss, nonexistent key

### 3. AuthClaims Model (\`internal/auth/claims.go\`)

Define the unified claims struct used by both JWT and API key auth:

\`\`\`go
// AuthClaims represents the authenticated principal's identity and permissions.
type AuthClaims struct {
    Subject       string    // sub claim or client_id
    ClientID      string    // OAuth2 client_id or API key client_id
    TenantID      string    // multi-tenant isolation identifier
    Roles         []string  // role-based access control roles
    Permissions   []string  // fine-grained permissions
    RateLimitTier string    // rate limit tier (e.g., "free", "pro", "enterprise")
    Issuer        string    // token issuer
    ExpiresAt     time.Time // token expiration
    AuthMethod    string    // "jwt", "apikey", or "oauth2"
}
\`\`\`

- Add a \`ContextKey\` type and helper functions: \`ClaimsFromContext(ctx) (*AuthClaims, bool)\` and \`ContextWithClaims(ctx, claims) context.Context\`
- Never use string keys for context — use an unexported typed key

### 4. RBAC Middleware (\`internal/middleware/rbac.go\`)

Implement role-based and permission-based access control as composable Chi middleware:

\`\`\`go
// RequireRoles returns Chi middleware that requires the authenticated user to have ALL specified roles.
func RequireRoles(roles ...string) func(http.Handler) http.Handler

// RequireAnyRole returns Chi middleware that requires the authenticated user to have AT LEAST ONE of the specified roles.
func RequireAnyRole(roles ...string) func(http.Handler) http.Handler

// RequirePermissions returns Chi middleware that requires ALL specified permissions.
func RequirePermissions(perms ...string) func(http.Handler) http.Handler
\`\`\`

- Extract \`AuthClaims\` from context (set by auth middleware)
- Return 401 Unauthorized if no claims in context
- Return 403 Forbidden if claims exist but roles/permissions insufficient
- Use structured JSON error responses from \`pkg/errors/\` or \`pkg/httputil/\`
- Log authorization failures at Warn level with \`slog\` including \`subject\`, \`required_roles\`, \`actual_roles\`, \`path\`, \`method\`

### 5. Authentication Middleware (\`internal/middleware/auth.go\`)

Implement the main authentication Chi middleware that orchestrates JWT and API key validation:

\`\`\`go
// Authenticator returns Chi middleware that authenticates requests via JWT or API key.
func Authenticator(jwtValidator auth.TokenValidator, apiKeyVerifier auth.APIKeyVerifier) func(http.Handler) http.Handler
\`\`\`

- **Auth Strategy Selection**:
  1. Check \`Authorization: Bearer <token>\` header → JWT validation
  2. Check \`X-API-Key\` header or \`api_key\` query param → API key verification
  3. If neither present → 401 with \`{"error": "missing_credentials", "message": "..."}\`
- **On Success**: Store \`AuthClaims\` in request context, set \`X-Client-ID\` and \`X-Tenant-ID\` response headers for downstream services
- **On Failure**: Return appropriate 401 response with error code, log with \`slog\`
- **Optional Mode**: Support an \`OptionalAuth\` variant that does not reject unauthenticated requests but still populates claims if credentials are present (for public endpoints that behave differently when authenticated)
- **OpenTelemetry**: Add span attributes for \`auth.method\`, \`auth.client_id\`, \`auth.tenant_id\` to the current trace span

### 6. OAuth2 Token Introspection (Passthrough) (\`internal/auth/oauth2.go\`)

Implement OAuth2 token introspection for opaque tokens:

- Call a configurable introspection endpoint (RFC 7662)
- Cache introspection results in Redis with TTL matching token expiry (max 5 minutes)
- Convert introspection response to \`AuthClaims\`
- Circuit breaker on the introspection endpoint (use \`internal/circuit/\` if available, otherwise implement a simple one)
- Interface: \`OAuth2Introspector\` with \`Introspect(ctx, token) (*AuthClaims, error)\`

## Architecture Constraints

- Follow Clean Architecture: middleware → auth (service layer) → repository
- All dependencies injected via interfaces — no global state, no \`init()\` functions
- Context propagation required on every function that does I/O
- Errors wrapped with \`fmt.Errorf("operation: %w", err)\` pattern
- All exported functions and types must have doc comments
- File length must not exceed 300 lines — split into multiple files if needed
- Use \`slog\` for all logging — structured fields, never interpolated strings

## Security Checklist (SOC 2)

- [ ] RS256 algorithm enforcement — no \`alg: none\`, no HMAC confusion
- [ ] Constant-time comparison for API key hashes (\`crypto/subtle.ConstantTimeCompare\`)
- [ ] No tokens or API keys in logs — ever
- [ ] Rate limit authentication failures (defer to rate limit middleware, but track \`auth_failure_total\` Prometheus counter)
- [ ] TLS assumed at ALB — but validate \`X-Forwarded-Proto\` if needed
- [ ] Audit log: emit structured log entry for every auth success and failure with timestamp, client_id, IP, method, path
- [ ] Key rotation: support multiple active signing keys via \`kid\`

## Observability

- **Prometheus Metrics** (register in \`internal/observability/\`):
  - \`gateway_auth_requests_total{method="jwt|apikey|oauth2",status="success|failure",reason="..."}\`
  - \`gateway_auth_duration_seconds{method="jwt|apikey|oauth2"}\` (histogram)
  - \`gateway_apikey_cache_hits_total\` / \`gateway_apikey_cache_misses_total\`
- **OpenTelemetry Spans**: Create child spans for \`auth.validate_jwt\`, \`auth.verify_apikey\`, \`auth.introspect_oauth2\`
- **slog Fields**: Always include \`trace_id\` from context in log entries

## Implementation Order

1. \`internal/auth/claims.go\` — AuthClaims struct and context helpers
2. \`internal/auth/jwt.go\` — JWT validator with RS256
3. \`internal/auth/jwt_test.go\` — table-driven tests (generate test RSA keys in test setup)
4. \`internal/auth/apikey.go\` — API key verifier
5. \`internal/auth/apikey_test.go\` — table-driven tests with mock repo
6. \`internal/auth/oauth2.go\` — OAuth2 introspection
7. \`internal/auth/oauth2_test.go\` — tests with httptest server
8. \`internal/middleware/auth.go\` — authentication middleware
9. \`internal/middleware/auth_test.go\` — tests with httptest and Chi test router
10. \`internal/middleware/rbac.go\` — RBAC middleware
11. \`internal/middleware/rbac_test.go\` — table-driven tests

## TDD Approach

For each file, follow this cycle:
1. Write the interface or function signature first
2. Write table-driven tests covering happy path, error cases, and edge cases
3. Run \`go test ./internal/auth/... -v\` — confirm tests fail (red)
4. Implement the minimum code to pass
5. Run \`go test ./internal/auth/... -v -race\` — confirm tests pass (green)
6. Refactor for clarity and performance
7. Run \`golangci-lint run ./internal/auth/...\` — fix any lint issues
8. Verify coverage: \`go test ./internal/auth/... -coverprofile=coverage.out && go tool cover -func=coverage.out\` — target 80%+

## Output Format

For each file:
1. State the file path
2. Explain key design decisions in a brief comment block at the top
3. Implement the complete, production-ready code
4. Include all imports, no placeholder comments like "// TODO: implement"

Start with \`internal/auth/claims.go\` and proceed through the implementation order. After each file, pause and ask if I want to review before continuing.
\`\`\`

---

## Usage Notes

- **Prerequisites**: Ensure Phase 03 scaffold is complete (\`cmd/gateway/main.go\`, \`internal/config/\`, \`pkg/errors/\` exist)
- **Estimated Time**: 2-3 hours for full implementation with tests
- **Review Checkpoints**: Claude will pause after each file — use this to verify alignment with your existing code
- **Customization**: Adjust the \`AuthClaims\` fields if your identity provider uses different claim names
- **Follow-up Prompts**:
  - "Run all auth tests with race detection: \`go test ./internal/auth/... ./internal/middleware/... -race -v\`"
  - "Show me the Prometheus metrics registration for auth counters"
  - "Add benchmark tests for JWT validation: \`func BenchmarkValidateJWT(b *testing.B)\`"
  - "Generate a migration file for the \`api_keys\` table in \`scripts/migrations/\`"

## Related Prompts

- [Data Model Design](../02/data-model-design.md) — for the \`api_keys\` table schema
- [API Design](../02/api-design.md) — for endpoint auth requirements
- [CI Pipeline](../03/ci-pipeline.md) — for running auth tests in CI`,

  'playbook/prompts/04/crud-generator.md': `# CRUD Generator — Phase 04: Core Implementation

## Purpose

Copy-pasteable prompt for Claude Code to generate a complete CRUD resource for the go-api-gateway project. This produces handler, service, repository, model, migrations, and table-driven tests following Clean Architecture conventions.

---

## Prompt

\`\`\`
You are implementing a new CRUD resource for the go-api-gateway project. Generate all layers following Clean Architecture (handler → service → repository) with full test coverage.

## Resource Definition

Resource name: {{RESOURCE_NAME}}
Database table: {{TABLE_NAME}}
Description: {{DESCRIPTION}}

Fields:
{{FIELDS}}
# Example:
# - id: uuid, primary key, generated
# - name: string, required, max 255
# - description: string, optional, max 1024
# - rate_limit: int, required, min 1, max 100000
# - is_active: bool, required, default true
# - metadata: jsonb, optional
# - created_at: timestamp, generated
# - updated_at: timestamp, generated
# - deleted_at: timestamp, nullable (soft delete)

## Architecture Rules

Follow the go-api-gateway project structure exactly:

### 1. Model — \`internal/model/{{RESOURCE_SNAKE}}.go\`

- Define the domain struct with JSON and DB tags
- Define CreateRequest, UpdateRequest, ListParams DTOs
- Define a Response DTO that omits internal fields
- Use \`time.Time\` for timestamps, \`*time.Time\` for nullable timestamps
- Use \`json.RawMessage\` for JSONB fields
- Add validation methods that return \`[]error\`
- All exported types and functions must have doc comments
- File must not exceed 300 lines

\`\`\`go
// Example shape:
// {{RESOURCE_PASCAL}} represents a {{DESCRIPTION}} in the gateway.
type {{RESOURCE_PASCAL}} struct {
    ID          uuid.UUID        \`json:"id" db:"id"\`
    // ... fields
    CreatedAt   time.Time        \`json:"created_at" db:"created_at"\`
    UpdatedAt   time.Time        \`json:"updated_at" db:"updated_at"\`
    DeletedAt   *time.Time       \`json:"-" db:"deleted_at"\`
}

// Create{{RESOURCE_PASCAL}}Request is the DTO for creating a new {{RESOURCE_SNAKE}}.
type Create{{RESOURCE_PASCAL}}Request struct { ... }

// Validate checks all business rules for the create request.
func (r *Create{{RESOURCE_PASCAL}}Request) Validate() []error { ... }
\`\`\`

### 2. Repository Interface — \`internal/repository/{{RESOURCE_SNAKE}}.go\`

- Define the interface in the repository package
- Use context.Context as the first parameter on every method
- Return wrapped errors with \`fmt.Errorf("{{method}}: %w", err)\`
- Implement with PostgreSQL using \`database/sql\` or \`pgx\`
- Use parameterized queries (never string concatenation)
- Support soft deletes (WHERE deleted_at IS NULL)
- Support pagination with cursor-based or offset/limit
- Include a \`Count\` method for list endpoints

\`\`\`go
// {{RESOURCE_PASCAL}}Repository defines data access for {{RESOURCE_SNAKE}} resources.
type {{RESOURCE_PASCAL}}Repository interface {
    Create(ctx context.Context, entity *model.{{RESOURCE_PASCAL}}) error
    GetByID(ctx context.Context, id uuid.UUID) (*model.{{RESOURCE_PASCAL}}, error)
    List(ctx context.Context, params model.List{{RESOURCE_PASCAL}}Params) ([]model.{{RESOURCE_PASCAL}}, error)
    Count(ctx context.Context, params model.List{{RESOURCE_PASCAL}}Params) (int64, error)
    Update(ctx context.Context, entity *model.{{RESOURCE_PASCAL}}) error
    Delete(ctx context.Context, id uuid.UUID) error
}
\`\`\`

### 3. Repository Implementation — \`internal/repository/postgres/{{RESOURCE_SNAKE}}.go\`

- Implement the interface using \`*sql.DB\` or \`*pgxpool.Pool\`
- Constructor: \`NewPostgres{{RESOURCE_PASCAL}}Repository(db *sql.DB) *postgres{{RESOURCE_PASCAL}}Repository\`
- Use \`slog\` for structured logging on errors
- Wrap all errors: \`fmt.Errorf("postgres.{{method}}: %w", err)\`
- Map \`sql.ErrNoRows\` to a custom \`errors.ErrNotFound\`
- Handle unique constraint violations → \`errors.ErrConflict\`
- Use \`RETURNING\` clause for Create and Update
- Set \`updated_at = NOW()\` on updates
- Soft delete: \`UPDATE ... SET deleted_at = NOW() WHERE id = $1 AND deleted_at IS NULL\`

### 4. Service — \`internal/service/{{RESOURCE_SNAKE}}.go\`

- Accept the repository interface (dependency injection)
- Constructor: \`New{{RESOURCE_PASCAL}}Service(repo repository.{{RESOURCE_PASCAL}}Repository, logger *slog.Logger) *{{RESOURCE_PASCAL}}Service\`
- Validate DTOs before calling repository
- Apply business rules (authorization checks, field defaults, etc.)
- Return domain errors from \`pkg/errors\`
- Propagate context on every call
- Log at appropriate levels: Info for mutations, Debug for reads, Error for failures

\`\`\`go
// {{RESOURCE_PASCAL}}Service handles business logic for {{RESOURCE_SNAKE}} resources.
type {{RESOURCE_PASCAL}}Service struct {
    repo   repository.{{RESOURCE_PASCAL}}Repository
    logger *slog.Logger
}
\`\`\`

### 5. Handler — \`internal/handler/{{RESOURCE_SNAKE}}.go\`

- Chi-idiomatic handlers using \`chi.URLParam\` for path params
- Constructor: \`New{{RESOURCE_PASCAL}}Handler(svc *service.{{RESOURCE_PASCAL}}Service, logger *slog.Logger) *{{RESOURCE_PASCAL}}Handler\`
- Provide a \`Routes() chi.Router\` method that returns a sub-router with all CRUD routes
- Parse and validate request bodies with \`json.NewDecoder(r.Body).Decode\`
- Set \`r.Body = http.MaxBytesReader(w, r.Body, 1<<20)\` (1MB limit)
- Use \`pkg/httputil\` response helpers for consistent JSON responses
- Map service errors to HTTP status codes:
  - \`errors.ErrNotFound\` → 404
  - \`errors.ErrConflict\` → 409
  - \`errors.ErrValidation\` → 422
  - \`errors.ErrUnauthorized\` → 401
  - \`errors.ErrForbidden\` → 403
  - Default → 500
- Extract request ID from context for structured logging
- Extract authenticated user from context for audit logging

\`\`\`go
// Routes returns a chi.Router with all {{RESOURCE_SNAKE}} CRUD routes mounted.
func (h *{{RESOURCE_PASCAL}}Handler) Routes() chi.Router {
    r := chi.NewRouter()
    r.Post("/", h.Create)
    r.Get("/", h.List)
    r.Route("/{id}", func(r chi.Router) {
        r.Get("/", h.GetByID)
        r.Put("/", h.Update)
        r.Delete("/", h.Delete)
    })
    return r
}
\`\`\`

### 6. Migration — \`scripts/migrations/{{TIMESTAMP}}_create_{{TABLE_NAME}}.up.sql\`

- Use \`CREATE TABLE IF NOT EXISTS\`
- Add appropriate indexes (primary key, unique constraints, foreign keys)
- Add a GIN index for JSONB columns
- Add an index on \`deleted_at\` for soft delete queries
- Add \`created_at DEFAULT NOW()\` and \`updated_at DEFAULT NOW()\`
- Create a trigger for auto-updating \`updated_at\`
- Include the corresponding \`.down.sql\` migration

\`\`\`sql
-- {{TIMESTAMP}}_create_{{TABLE_NAME}}.up.sql
CREATE TABLE IF NOT EXISTS {{TABLE_NAME}} (
    id UUID PRIMARY KEY DEFAULT gen_random_uuid(),
    -- ... columns from field definitions
    created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
    updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
    deleted_at TIMESTAMPTZ
);

CREATE INDEX idx_{{TABLE_NAME}}_deleted_at ON {{TABLE_NAME}} (deleted_at) WHERE deleted_at IS NULL;

CREATE OR REPLACE FUNCTION update_{{TABLE_NAME}}_updated_at()
RETURNS TRIGGER AS $$
BEGIN
    NEW.updated_at = NOW();
    RETURN NEW;
END;
$$ LANGUAGE plpgsql;

CREATE TRIGGER trigger_{{TABLE_NAME}}_updated_at
    BEFORE UPDATE ON {{TABLE_NAME}}
    FOR EACH ROW
    EXECUTE FUNCTION update_{{TABLE_NAME}}_updated_at();
\`\`\`

### 7. Tests

Generate table-driven tests for every layer:

**Repository tests** — \`internal/repository/postgres/{{RESOURCE_SNAKE}}_test.go\`
- Use testcontainers-go or a test database
- Test each method: Create, GetByID, List, Count, Update, Delete
- Test error cases: not found, duplicate, invalid input
- Test soft delete behavior (deleted records excluded from List/GetByID)
- Test pagination parameters

**Service tests** — \`internal/service/{{RESOURCE_SNAKE}}_test.go\`
- Mock the repository interface using a hand-written mock or testify/mock
- Test validation failures return appropriate errors
- Test business rule enforcement
- Test context propagation
- Test logging output with a test slog handler

**Handler tests** — \`internal/handler/{{RESOURCE_SNAKE}}_test.go\`
- Use \`httptest.NewRecorder\` and \`httptest.NewRequest\`
- Use \`chi.NewRouter\` to mount routes for realistic path param parsing
- Test each endpoint: POST, GET list, GET by ID, PUT, DELETE
- Test request validation (malformed JSON, missing fields, invalid UUIDs)
- Test error response format consistency
- Test HTTP status code mapping
- Test MaxBytesReader enforcement (oversized body → 413)
- Assert response Content-Type is \`application/json\`

\`\`\`go
// Example test shape:
func TestCreate{{RESOURCE_PASCAL}}(t *testing.T) {
    tests := []struct {
        name       string
        body       string
        setupMock  func(*mock{{RESOURCE_PASCAL}}Service)
        wantStatus int
        wantBody   string
    }{
        {
            name: "success",
            body: \`{"name":"test","rate_limit":1000}\`,
            setupMock: func(m *mock{{RESOURCE_PASCAL}}Service) {
                m.createFn = func(ctx context.Context, req *model.Create{{RESOURCE_PASCAL}}Request) (*model.{{RESOURCE_PASCAL}}, error) {
                    return &model.{{RESOURCE_PASCAL}}{ID: uuid.New(), Name: "test"}, nil
                }
            },
            wantStatus: http.StatusCreated,
        },
        // ... more cases
    }
    for _, tt := range tests {
        t.Run(tt.name, func(t *testing.T) {
            // ... test implementation
        })
    }
}
\`\`\`

### 8. Wire It Up — Registration snippet

Provide a snippet showing how to register the new resource in \`cmd/gateway/main.go\`:

\`\`\`go
// In the router setup section:
{{RESOURCE_SNAKE}}Repo := postgres.NewPostgres{{RESOURCE_PASCAL}}Repository(db)
{{RESOURCE_SNAKE}}Svc := service.New{{RESOURCE_PASCAL}}Service({{RESOURCE_SNAKE}}Repo, logger)
{{RESOURCE_SNAKE}}Handler := handler.New{{RESOURCE_PASCAL}}Handler({{RESOURCE_SNAKE}}Svc, logger)

r.Route("/api/v1/{{RESOURCE_PLURAL}}", func(r chi.Router) {
    r.Use(middleware.JWTAuth)       // Require authentication
    r.Use(middleware.RateLimit)     // Per-client rate limiting
    r.Mount("/", {{RESOURCE_SNAKE}}Handler.Routes())
})
\`\`\`

## Constraints

- All files must pass \`golangci-lint run\` (govet, errcheck, staticcheck, gosec, revive, gocyclo)
- All files must pass \`gofmt\` and \`goimports\`
- No file may exceed 300 lines — split if necessary
- No \`init()\` functions
- No global mutable state
- All exported functions must have doc comments
- Use \`context.Context\` as the first parameter on all public methods
- Wrap all errors with \`fmt.Errorf\` and \`%w\` verb
- Use \`slog\` for all logging (no fmt.Println, no log package)
- Use \`uuid.UUID\` (google/uuid) for all IDs
- SQL queries must use parameterized placeholders ($1, $2, ...)
- Test coverage must be ≥80% for each file
- Follow SOC 2 considerations: log all mutations with actor, sanitize error messages in responses (no internal details leaked)

## Output Format

Generate each file separately with its full path as a header comment. Generate files in this order:
1. Model
2. Custom errors (if new error types needed in pkg/errors)
3. Repository interface
4. Repository implementation
5. Service
6. Handler
7. Migration (up and down)
8. Tests (repository, service, handler)
9. Registration snippet

After generating, run:
- \`gofmt -w .\`
- \`goimports -w .\`
- \`golangci-lint run ./internal/...\`
- \`go test -race -cover ./internal/handler/... ./internal/service/... ./internal/repository/...\`

Report any lint errors or test failures and fix them before considering the task complete.
\`\`\`

---

## Usage

1. Copy the prompt above into Claude Code
2. Replace the template variables:
   - \`{{RESOURCE_NAME}}\` — e.g., \`Route\`
   - \`{{RESOURCE_SNAKE}}\` — e.g., \`route\`
   - \`{{RESOURCE_PASCAL}}\` — e.g., \`Route\`
   - \`{{RESOURCE_PLURAL}}\` — e.g., \`routes\`
   - \`{{TABLE_NAME}}\` — e.g., \`routes\`
   - \`{{DESCRIPTION}}\` — e.g., \`an API route configuration mapping upstream paths to downstream services\`
   - \`{{FIELDS}}\` — list your fields
   - \`{{TIMESTAMP}}\` — e.g., \`20240115120000\`
3. Claude Code generates all files, runs linting and tests, and fixes issues

## Common Resources for go-api-gateway

| Resource | Table | Description |
|----------|-------|-------------|
| Route | routes | API route configuration mapping upstream paths to downstream services |
| Consumer | consumers | API consumers (clients) with authentication credentials and rate limit tiers |
| Plugin | plugins | Middleware plugins (rate limit, transform, cache) attached to routes or consumers |
| Certificate | certificates | TLS certificates for upstream mTLS connections |
| Upstream | upstreams | Backend service definitions with health check and load balancing config |
| Target | targets | Individual backend instances belonging to an upstream |
| APIKey | api_keys | API key records with scopes, expiration, and rotation tracking |
| AuditLog | audit_logs | Immutable audit trail of configuration changes (SOC 2 requirement) |

## Checklist

After generation, verify:

- [ ] Model has validation methods with descriptive error messages
- [ ] Repository uses parameterized queries (no SQL injection)
- [ ] Repository wraps all errors with context
- [ ] Repository maps \`sql.ErrNoRows\` to \`errors.ErrNotFound\`
- [ ] Service validates before calling repository
- [ ] Service logs mutations at Info level with actor context
- [ ] Handler uses \`http.MaxBytesReader\` on request bodies
- [ ] Handler maps domain errors to correct HTTP status codes
- [ ] Handler never leaks internal error details in responses
- [ ] Migration includes indexes, soft delete support, and updated_at trigger
- [ ] All tests are table-driven
- [ ] Handler tests use \`chi.NewRouter\` for realistic routing
- [ ] Test coverage ≥80% per file
- [ ] \`golangci-lint run\` passes with zero issues
- [ ] \`go test -race ./...\` passes (no data races)
- [ ] No file exceeds 300 lines
- [ ] All exported identifiers have doc comments
- [ ] Audit logging captures who made changes (SOC 2)`,

  'playbook/prompts/04/feature-implementation.md': `# Feature Implementation Prompt — Phase 04: Core Implementation

> Copy-paste this prompt into Claude Code when implementing a new feature for the go-api-gateway project.

---

## Prompt

\`\`\`
You are implementing a feature for the go-api-gateway project — a high-performance API gateway built with Go 1.22 and Chi v5 router. Follow Clean Architecture (handler → service → repository) and all project conventions strictly.

## Feature to Implement

**Ticket**: [PASTE TICKET ID, e.g., GW-42]
**Title**: [PASTE FEATURE TITLE, e.g., "Add per-client sliding window rate limiter"]
**Description**: [PASTE FEATURE DESCRIPTION OR ACCEPTANCE CRITERIA]

## Implementation Constraints

### Architecture — Clean Architecture Layers
1. **handler** (\`internal/handler/\`): HTTP concerns only — parse request, call service, write response. Must accept \`context.Context\` from Chi. No business logic.
2. **service** (\`internal/service/\`): Business logic. Accepts interfaces for dependencies (repository, external clients). Returns domain models or custom errors.
3. **repository** (\`internal/repository/\`): Data access — PostgreSQL queries, Redis commands. Returns domain models. Wraps all errors with \`fmt.Errorf("repo.Method: %w", err)\`.
4. **model** (\`internal/model/\`): Domain structs and DTOs. No methods with side effects.
5. **middleware** (\`internal/middleware/\`): Chi-compatible middleware. Must follow \`func(next http.Handler) http.Handler\` signature.

### Go Conventions (Enforced)
- All exported functions and types MUST have doc comments
- Errors MUST be wrapped: \`fmt.Errorf("functionName: %w", err)\`
- No \`init()\` functions anywhere
- Context propagation required on every handler and service method
- Use \`slog\` for structured logging — include request_id, trace_id where available
- Interfaces for dependency injection — define interfaces in the consuming package
- File names use snake_case, max 300 lines per file
- Use \`context.Context\` as the first parameter for all service and repository methods

### Testing Requirements (TDD — write tests first)
- Table-driven tests required for all logic with multiple cases
- Use \`testify/assert\` and \`testify/require\` for assertions
- Use \`httptest\` for handler tests
- Use interfaces + mocks for service/repository boundaries
- Test file naming: \`*_test.go\` in the same package
- Minimum 80% coverage for new code
- Include edge cases: nil inputs, empty strings, context cancellation, timeout, unauthorized, rate limited

### API Gateway Patterns
- Rate limiting: sliding window algorithm with Redis (\`internal/ratelimit/\`)
- Circuit breaker: track failures per upstream, open/half-open/closed states (\`internal/circuit/\`)
- JWT validation: RS256 verification, claims extraction, RBAC enforcement (\`internal/auth/\`)
- Request routing: Chi route groups with middleware chains
- Health checks: \`/healthz\` (liveness), \`/readyz\` (readiness — checks Redis + PostgreSQL)
- Middleware ordering: recovery → request_id → logging → tracing → cors → auth → rate_limit → handler

### Observability (Required on all new code)
- OpenTelemetry spans: create child spans for service and repository calls
  \`\`\`go
  ctx, span := tracer.Start(ctx, "service.MethodName")
  defer span.End()
  \`\`\`
- Prometheus metrics: increment counters, observe histograms for latency
- Structured logging with \`slog\`: log at appropriate levels (Debug for flow, Info for events, Warn for degraded, Error for failures)
- Include \`request_id\` and \`trace_id\` in all log entries

### Security (SOC 2 Compliance)
- Never log secrets, tokens, API keys, or PII
- Validate and sanitize all input — use allow-lists where possible
- Return generic error messages to clients; log detailed errors server-side
- JWT tokens must be validated on every request to protected routes
- API keys must be constant-time compared (\`crypto/subtle.ConstantTimeCompare\`)
- Rate limit responses must use HTTP 429 with \`Retry-After\` header

### File Organization
Place files according to this structure:
\`\`\`
internal/handler/       → HTTP handlers (one file per resource/domain)
internal/handler/*_test.go → Handler tests with httptest
internal/service/       → Business logic (one file per domain)
internal/service/*_test.go → Service tests with mocked dependencies
internal/repository/    → Data access (one file per store: postgres, redis)
internal/repository/*_test.go → Repository tests
internal/model/         → Structs, DTOs, enums
internal/middleware/     → Chi middleware functions
internal/middleware/*_test.go → Middleware tests
pkg/errors/             → Custom error types if needed
pkg/httputil/           → Response helpers (JSON response, error response)
\`\`\`

## Implementation Steps

Execute these steps in order:

### Step 1: Define the Interface
Create or extend the interface in the consuming package. Example:
\`\`\`go
// internal/service/rate_limiter.go
// RateLimitStore defines the contract for rate limit persistence.
type RateLimitStore interface {
    IncrementWindow(ctx context.Context, key string, window time.Duration) (int64, error)
    GetCurrentCount(ctx context.Context, key string) (int64, error)
}
\`\`\`

### Step 2: Write Failing Tests (TDD Red Phase)
Write table-driven tests for the service layer first:
\`\`\`go
func TestServiceMethod(t *testing.T) {
    tests := []struct {
        name    string
        input   InputType
        setup   func(*MockDep)
        want    OutputType
        wantErr error
    }{
        // happy path, edge cases, error cases
    }
    for _, tt := range tests {
        t.Run(tt.name, func(t *testing.T) {
            // arrange, act, assert
        })
    }
}
\`\`\`

### Step 3: Implement the Minimum Code (TDD Green Phase)
Write just enough code to make tests pass. Follow the layer boundaries strictly.

### Step 4: Refactor (TDD Refactor Phase)
- Extract shared logic into helpers
- Ensure error wrapping is consistent
- Add doc comments to all exported symbols
- Verify file length < 300 lines

### Step 5: Wire Up the Handler
Register the Chi route with appropriate middleware chain:
\`\`\`go
r.Route("/api/v1/resource", func(r chi.Router) {
    r.Use(middleware.Auth(jwtValidator))
    r.Use(middleware.RateLimit(limiter))
    r.Get("/", handler.ListResources)
    r.Post("/", handler.CreateResource)
})
\`\`\`

### Step 6: Add Handler Tests
Test with \`httptest.NewRecorder()\` and \`httptest.NewRequest()\`:
- Test HTTP status codes (200, 201, 400, 401, 403, 429, 500)
- Test response body structure
- Test middleware integration (auth rejection, rate limit rejection)
- Test context propagation

### Step 7: Add Observability
- Add OpenTelemetry span to each service method
- Add Prometheus counter/histogram where appropriate
- Add structured log lines at Info level for operations, Error level for failures

### Step 8: Verify
Run the full verification suite:
\`\`\`bash
gofmt -l .
goimports -l .
golangci-lint run ./...
go vet ./...
go test -race -coverprofile=coverage.out ./...
go tool cover -func=coverage.out | grep total
\`\`\`

## Output Format

For each file you create or modify, show:
1. The full file path
2. The complete file content (not partial diffs)
3. A brief explanation of what the file does and why

After implementation, provide:
- A summary of all files created/modified
- The test commands to run
- The coverage report expectation
- Any follow-up items (e.g., migration needed, config change, docs update)

## Branch and Commit Convention

Branch: \`feat/[TICKET-ID]-[short-description]\` (e.g., \`feat/GW-42-sliding-window-rate-limiter\`)

Commits should be atomic and use conventional format:
- \`feat(ratelimit): add sliding window rate limiter with Redis backend\`
- \`test(ratelimit): add table-driven tests for sliding window logic\`
- \`feat(middleware): wire rate limit middleware into Chi router\`
- \`docs(ratelimit): add rate limiting configuration to README\`

Mark AI-generated code with a trailing comment on the file header:
\`\`\`go
// Package ratelimit implements sliding window rate limiting with Redis.
// Generated with AI assistance — review required.
\`\`\`
\`\`\`

---

## Usage Notes

1. **Replace the bracketed placeholders** at the top with your actual ticket details before pasting
2. **Run this prompt once per feature** — it produces a complete implementation pass
3. **Pair with \`/tdd\`** command from the plugin for iterative red-green-refactor cycles
4. **Follow up with \`/code-review\`** command before opening a PR
5. **Run \`/verify\`** to confirm lint, vet, tests, and coverage pass

## Example: Rate Limiter Feature

Replace the Feature section with:

\`\`\`
**Ticket**: GW-42
**Title**: Add per-client sliding window rate limiter
**Description**:
- Implement sliding window rate limiting using Redis MULTI/EXEC
- Rate limits configurable per API key tier (free: 100/min, pro: 1000/min, enterprise: 10000/min)
- Return HTTP 429 with Retry-After header when limit exceeded
- Expose prometheus metric: gateway_rate_limit_exceeded_total{client_id, tier}
- Must handle Redis unavailability gracefully (fail open with warning log)
- Acceptance: table-driven tests for all tiers, Redis failure, window expiry
\`\`\`

## Example: Circuit Breaker Feature

Replace the Feature section with:

\`\`\`
**Ticket**: GW-58
**Title**: Add circuit breaker for upstream service calls
**Description**:
- Implement circuit breaker with three states: closed, open, half-open
- Configurable thresholds: failure_count (default 5), timeout (default 30s), half_open_max (default 3)
- Track failures per upstream host
- Return HTTP 503 with upstream identifier when circuit is open
- Expose prometheus metrics: gateway_circuit_state{upstream, state}, gateway_circuit_trips_total{upstream}
- Must be safe for concurrent access (sync.RWMutex or atomic operations)
- Acceptance: tests for state transitions, concurrent access, timeout recovery
\`\`\`

## Checklist Before PR

- [ ] All tests pass: \`go test -race ./...\`
- [ ] Coverage ≥ 80%: \`go tool cover -func=coverage.out\`
- [ ] Lint clean: \`golangci-lint run ./...\`
- [ ] No \`init()\` functions added
- [ ] All exported symbols have doc comments
- [ ] Errors wrapped with \`%w\`
- [ ] Context propagated through all layers
- [ ] Structured logging with \`slog\` (no \`fmt.Println\`, no \`log.Println\`)
- [ ] OpenTelemetry spans on service methods
- [ ] Prometheus metrics for observable operations
- [ ] No secrets or PII in logs
- [ ] File lengths under 300 lines
- [ ] AI-generated code flagged in file header
- [ ] Conventional commit messages
- [ ] Branch named \`feat/TICKET-short-desc\``,

  'playbook/prompts/05/integration-adapter.md': `# Integration Adapter — Phase 05 Prompt

> Copy-paste this prompt into Claude Code when building integration adapters for external services in the go-api-gateway project. Adapters live in \`internal/repository/\` or dedicated packages under \`internal/\` and follow Clean Architecture boundaries.

---

## Prompt

\`\`\`
You are implementing an integration adapter for the go-api-gateway project. This adapter connects the gateway to an external system while maintaining Clean Architecture boundaries and SOC 2 compliance.

## Context

- Project: go-api-gateway — high-performance API gateway built with Go 1.22 and Chi v5
- Architecture: Clean Architecture (handler → service → repository)
- Observability: OpenTelemetry traces, Prometheus metrics, slog structured logging
- Error handling: All errors wrapped with fmt.Errorf and %w verb
- Config: Viper + envconfig, loaded from configs/ YAML files and environment variables
- Dependencies: Conservative policy — justify every new import

## Target Integration

**System**: [REPLACE: e.g., Redis, PostgreSQL, upstream HTTP service, AWS S3, external OAuth provider]
**Purpose**: [REPLACE: e.g., rate limit state storage, config persistence, upstream routing, token introspection]
**Package location**: [REPLACE: e.g., internal/repository/redis, internal/repository/postgres, internal/upstream]

## Architecture Requirements

### Interface-First Design

1. Define the adapter interface in the **service layer** or a shared \`internal/port/\` package — never in the adapter package itself
2. The interface must describe business capabilities, not infrastructure details:

\`\`\`go
// internal/port/ratelimit.go
package port

import "context"

// RateLimitStore manages rate limit state for API clients.
type RateLimitStore interface {
    // Increment increments the request count for the given key within the window.
    // Returns the current count and the remaining TTL for the window.
    Increment(ctx context.Context, key string, window time.Duration) (count int64, ttl time.Duration, err error)

    // IsAllowed checks whether the key has remaining capacity under the given limit.
    IsAllowed(ctx context.Context, key string, limit int64, window time.Duration) (allowed bool, err error)

    // Reset clears the rate limit state for the given key.
    Reset(ctx context.Context, key string) error
}
\`\`\`

3. The concrete adapter implements this interface in its own package
4. Wire dependencies via constructor injection — no global state, no init() functions

### Adapter Implementation

Implement the adapter with these patterns:

\`\`\`go
// internal/repository/redis/ratelimit.go
package redis

import (
    "context"
    "fmt"
    "time"

    "github.com/redis/go-redis/v9"
    "go.opentelemetry.io/otel"
    "go.opentelemetry.io/otel/attribute"
    "log/slog"

    "github.com/your-org/go-api-gateway/internal/port"
)

var tracer = otel.Tracer("go-api-gateway/repository/redis")

// RateLimitStore implements port.RateLimitStore using Redis sliding window counters.
type RateLimitStore struct {
    client *redis.Client
    logger *slog.Logger
}

// NewRateLimitStore creates a RateLimitStore with the given Redis client.
// Returns an error if the client is nil or the connection cannot be verified.
func NewRateLimitStore(client *redis.Client, logger *slog.Logger) (*RateLimitStore, error) {
    if client == nil {
        return nil, fmt.Errorf("redis client must not be nil")
    }
    if logger == nil {
        logger = slog.Default()
    }
    return &RateLimitStore{client: client, logger: logger}, nil
}
\`\`\`

### Mandatory Patterns

Apply ALL of the following to the adapter:

1. **Context propagation**: Every method accepts \`context.Context\` as the first parameter. Pass it to all downstream calls. Respect cancellation and deadlines.

2. **OpenTelemetry tracing**: Create a span for every external call:
   \`\`\`go
   ctx, span := tracer.Start(ctx, "redis.ratelimit.Increment",
       trace.WithAttributes(
           attribute.String("ratelimit.key", key),
           attribute.Int64("ratelimit.window_ms", window.Milliseconds()),
       ))
   defer span.End()
   \`\`\`

3. **Prometheus metrics**: Register and update metrics for each operation:
   - \`gateway_adapter_requests_total{adapter, operation, status}\` — counter
   - \`gateway_adapter_duration_seconds{adapter, operation}\` — histogram
   - \`gateway_adapter_errors_total{adapter, operation, error_type}\` — counter

4. **Structured logging with slog**:
   \`\`\`go
   s.logger.InfoContext(ctx, "rate limit incremented",
       slog.String("key", key),
       slog.Int64("count", count),
       slog.Duration("ttl", ttl),
   )
   \`\`\`
   Log at Debug for routine operations, Info for state changes, Warn for degraded states, Error for failures.

5. **Error wrapping**: Always wrap errors with context:
   \`\`\`go
   if err != nil {
       span.RecordError(err)
       span.SetStatus(codes.Error, "redis increment failed")
       return 0, 0, fmt.Errorf("redis ratelimit increment key=%s: %w", key, err)
   }
   \`\`\`

6. **Connection health check**: Expose a \`Ping(ctx context.Context) error\` or \`HealthCheck(ctx context.Context) error\` method for the gateway's health endpoint.

7. **Graceful shutdown**: Expose a \`Close() error\` method that drains connections cleanly. Register it in the application's shutdown sequence.

8. **Timeouts and deadlines**: Apply per-operation timeouts. Do not rely solely on the caller's context:
   \`\`\`go
   opCtx, cancel := context.WithTimeout(ctx, 500*time.Millisecond)
   defer cancel()
   \`\`\`

9. **Circuit breaker integration**: If this adapter calls an external network service, wrap calls with the circuit breaker from \`internal/circuit/\`:
   \`\`\`go
   err := s.breaker.Execute(ctx, func(ctx context.Context) error {
       return s.client.Ping(ctx).Err()
   })
   \`\`\`

10. **Connection pooling**: Configure pool size, idle timeout, and max lifetime. Document the defaults:
    \`\`\`go
    // Default Redis pool: 10 connections, 5 min idle timeout, 30 min max lifetime
    \`\`\`

### Configuration

Load adapter config through Viper. Define a typed config struct:

\`\`\`go
// internal/repository/redis/config.go
package redis

import "time"

// Config holds Redis connection configuration.
type Config struct {
    Addr         string        \`mapstructure:"addr" envconfig:"REDIS_ADDR"\`
    Password     string        \`mapstructure:"password" envconfig:"REDIS_PASSWORD"\`
    DB           int           \`mapstructure:"db" envconfig:"REDIS_DB"\`
    PoolSize     int           \`mapstructure:"pool_size" envconfig:"REDIS_POOL_SIZE"\`
    ReadTimeout  time.Duration \`mapstructure:"read_timeout" envconfig:"REDIS_READ_TIMEOUT"\`
    WriteTimeout time.Duration \`mapstructure:"write_timeout" envconfig:"REDIS_WRITE_TIMEOUT"\`
    MaxRetries   int           \`mapstructure:"max_retries" envconfig:"REDIS_MAX_RETRIES"\`
    TLSEnabled   bool          \`mapstructure:"tls_enabled" envconfig:"REDIS_TLS_ENABLED"\`
}
\`\`\`

- Sensitive values (passwords, connection strings) MUST come from environment variables or a secrets manager — never committed to configs/ YAML
- TLS must be configurable and enabled by default in staging/production (SOC 2)
- Validate config at startup — fail fast on invalid values

### Security (SOC 2)

- Enable TLS for all external connections (Redis TLS, PostgreSQL sslmode=require, HTTPS for upstream services)
- Never log sensitive data (passwords, tokens, PII). Redact in slog output.
- Rotate credentials via environment variables — no hardcoded secrets
- Apply least-privilege database roles (read-only where possible)
- Audit log connection events (connect, disconnect, auth failure)
- Validate and sanitize all inputs before passing to external systems (SQL injection, Redis injection)

## File Structure

Generate these files for the adapter:

1. **Interface definition**: \`internal/port/[capability].go\` — the business interface
2. **Config struct**: \`internal/repository/[system]/config.go\` — typed configuration
3. **Client factory**: \`internal/repository/[system]/client.go\` — connection setup, pool config, TLS
4. **Adapter implementation**: \`internal/repository/[system]/[capability].go\` — the concrete implementation
5. **Health check**: Include \`Ping\` / \`HealthCheck\` in the adapter or a separate \`health.go\`
6. **Unit tests**: \`internal/repository/[system]/[capability]_test.go\` — table-driven tests with mocks
7. **Integration tests**: \`tests/integration/[system]_test.go\` — tests against real service (build-tagged)

## Testing Requirements

### Unit Tests

- Use table-driven tests with testify assertions
- Mock the external client using interfaces or test doubles (e.g., miniredis for Redis, pgxmock for PostgreSQL)
- Test all error paths: connection failure, timeout, invalid response, context cancellation
- Test circuit breaker transitions: closed → open → half-open
- Verify that spans are created (use tracetest.SpanRecorder)
- Verify that metrics are incremented (use promtest or manual registry inspection)
- File must stay under 300 lines — split into multiple test files if needed

\`\`\`go
func TestRateLimitStore_Increment(t *testing.T) {
    tests := []struct {
        name      string
        key       string
        window    time.Duration
        setup     func(mr *miniredis.Miniredis)
        wantCount int64
        wantErr   bool
    }{
        {
            name:   "first request in window",
            key:    "client:abc:minute",
            window: time.Minute,
            setup:  func(mr *miniredis.Miniredis) {},
            wantCount: 1,
        },
        {
            name:   "existing counter incremented",
            key:    "client:abc:minute",
            window: time.Minute,
            setup: func(mr *miniredis.Miniredis) {
                mr.Set("client:abc:minute", "5")
                mr.SetTTL("client:abc:minute", time.Minute)
            },
            wantCount: 6,
        },
        // ... more cases: expired key, Redis down, context cancelled
    }

    for _, tt := range tests {
        t.Run(tt.name, func(t *testing.T) {
            mr := miniredis.RunT(t)
            tt.setup(mr)
            client := redis.NewClient(&redis.Options{Addr: mr.Addr()})
            store, err := NewRateLimitStore(client, slog.Default())
            require.NoError(t, err)

            count, _, err := store.Increment(context.Background(), tt.key, tt.window)
            if tt.wantErr {
                assert.Error(t, err)
                return
            }
            assert.NoError(t, err)
            assert.Equal(t, tt.wantCount, count)
        })
    }
}
\`\`\`

### Integration Tests

- Use build tag \`//go:build integration\`
- Spin up dependencies with testcontainers-go or expect them via environment variables
- Test real connection lifecycle: connect, operate, reconnect after failure, graceful close
- Place in \`tests/integration/\` directory

## Deliverables Checklist

Before marking this adapter complete, verify:

- [ ] Interface defined in \`internal/port/\` — no infrastructure leakage
- [ ] Constructor validates inputs and returns typed errors
- [ ] All methods accept \`context.Context\` as first parameter
- [ ] OpenTelemetry spans on every external call with relevant attributes
- [ ] Prometheus metrics registered (requests, duration, errors)
- [ ] Structured slog logging at appropriate levels
- [ ] Errors wrapped with \`fmt.Errorf\` and \`%w\`
- [ ] TLS configurable and enabled for non-local environments
- [ ] No secrets in code or config files — environment variables only
- [ ] Connection pooling configured with documented defaults
- [ ] Health check method implemented and wired to \`/healthz\` or \`/readyz\`
- [ ] Graceful shutdown via \`Close()\` method
- [ ] Circuit breaker wrapping network calls (if applicable)
- [ ] Per-operation timeouts applied
- [ ] Table-driven unit tests with ≥80% coverage
- [ ] Integration test with build tag
- [ ] All files under 300 lines
- [ ] \`golangci-lint run\` passes with zero issues
- [ ] \`go vet ./...\` clean
- [ ] All exported functions and types have doc comments
- [ ] Commit message follows conventional commits: \`feat(adapter): add Redis rate limit store\`

## Example Invocation

After pasting this prompt, tell Claude Code:

"Implement the Redis rate limit adapter. The interface should support sliding window rate limiting with per-client keys. Use the redis/go-redis/v9 client. Include circuit breaker integration from internal/circuit/. Generate all files listed above with full tests."

Or for PostgreSQL:

"Implement the PostgreSQL route config adapter. The interface should support CRUD for route configurations and API key metadata. Use pgx/v5 with connection pooling. Generate all files with full tests."

Or for upstream HTTP services:

"Implement the upstream HTTP proxy adapter. The interface should support forwarding requests to backend services with configurable timeouts, retries, and header transformation. Use net/http with connection pooling. Include circuit breaker per upstream host."
\`\`\`

---

## When to Use This Prompt

Use this prompt during **Phase 05 — Integration & Hardening** (see \`playbook/phases/05-integration-hardening.md\`) for:

- Connecting to Redis for rate limiting, caching, or session storage
- Connecting to PostgreSQL for route configuration, API key metadata, or audit logs
- Building HTTP clients for upstream service proxying
- Integrating with AWS services (S3, SQS, Secrets Manager)
- Adding OAuth2 token introspection endpoints
- Wiring external authentication providers

## Related Prompts

- \`playbook/prompts/04/feature-implementation.md\` — for the service layer that consumes these adapters
- \`playbook/prompts/04/auth-implementation.md\` — for JWT/API key auth adapters specifically
- \`playbook/prompts/06/integration-test.md\` — for comprehensive integration test suites
- \`playbook/prompts/02/data-model-design.md\` — for the data models these adapters persist

## Related Commands

- \`/plan\` — break the adapter into subtasks before implementation
- \`/tdd\` — drive the adapter implementation from tests
- \`/verify\` — validate the adapter meets all checklist items
- \`/build-fix\` — resolve compilation or lint errors after generation`,

  'playbook/prompts/05/observability-setup.md': `# Observability Setup — Phase 05 Integration & Hardening

> Copy-pasteable prompt for Claude Code. Sets up comprehensive observability for the go-api-gateway: OpenTelemetry distributed tracing, Prometheus metrics, structured logging with slog, health checks, and Grafana dashboards.

---

## Prompt

\`\`\`
You are working on the go-api-gateway project — a high-performance API gateway built with Go 1.22 and Chi v5 router. We are in Phase 05 (Integration & Hardening) and need to implement comprehensive observability.

## Project Context

- Router: Chi v5 with composable middleware
- Architecture: Clean Architecture (handler → service → repository)
- Cloud: AWS (ECS, ALB, ElastiCache, RDS, CloudWatch)
- Compliance: SOC 2 (audit logging required)
- Observability stack: OpenTelemetry (traces), Prometheus (metrics), slog (structured logging), Jaeger (trace visualization), Grafana (dashboards)
- Config: Viper + envconfig
- Existing directories: internal/observability/, internal/middleware/, internal/handler/, pkg/httputil/

## What to Implement

### 1. OpenTelemetry Tracing Setup — \`internal/observability/tracing.go\`

Create the OpenTelemetry tracer provider initialization:

- Initialize OTLP gRPC exporter targeting a configurable endpoint (default: localhost:4317)
- Configure resource attributes: service.name=go-api-gateway, service.version from build info, deployment.environment from config
- Set up BatchSpanProcessor with sensible defaults (max queue size 2048, batch timeout 5s, max export batch 512)
- Support sampling configuration: always_on for staging, parent_based with ratio (0.1) for production
- Return a shutdown function for graceful teardown
- Propagate W3C TraceContext and Baggage
- All exported functions must have doc comments
- Use this signature pattern:

\`\`\`go
// InitTracer initializes the OpenTelemetry tracer provider with OTLP export.
// It returns a shutdown function that must be called on application exit.
func InitTracer(ctx context.Context, cfg TracingConfig) (func(context.Context) error, error)
\`\`\`

### 2. Prometheus Metrics — \`internal/observability/metrics.go\`

Define and register custom Prometheus metrics for the API gateway:

\`\`\`go
// Gateway-specific metrics
var (
    RequestsTotal       *prometheus.CounterVec     // labels: method, path, status_code, upstream
    RequestDuration     *prometheus.HistogramVec    // labels: method, path, upstream
    RequestsInFlight    *prometheus.GaugeVec        // labels: upstream
    UpstreamLatency     *prometheus.HistogramVec    // labels: upstream, method
    RateLimitHits       *prometheus.CounterVec      // labels: client_id, limit_type
    CircuitBreakerState *prometheus.GaugeVec        // labels: upstream, state
    AuthFailures        *prometheus.CounterVec      // labels: auth_type, reason
    CacheHits           *prometheus.CounterVec      // labels: cache_name, hit_or_miss
    ActiveConnections   prometheus.Gauge
)
\`\`\`

- Use appropriate histogram buckets for API gateway latency: {.005, .01, .025, .05, .1, .25, .5, 1, 2.5, 5, 10}
- Create an InitMetrics() function that registers all metrics
- Create a MetricsHandler() that returns the promhttp.Handler() for the /metrics endpoint
- Include Go runtime metrics (process, memory, goroutines)

### 3. Structured Logging — \`internal/observability/logging.go\`

Set up slog-based structured logging:

- Configure slog with JSON handler for production, text handler for development
- Add default attributes: service, version, environment
- Create a middleware-compatible logger that extracts trace_id and span_id from OpenTelemetry context
- Support log levels configurable via environment variable (LOG_LEVEL)
- Include a ContextWithLogger/LoggerFromContext pattern for propagation
- Add a RequestLogger type that implements slog.Handler to enrich logs with request metadata
- SOC 2 requirement: ensure all authentication events, authorization decisions, and configuration changes are logged at INFO level minimum

\`\`\`go
// NewLogger creates a configured slog.Logger for the gateway.
func NewLogger(cfg LoggingConfig) *slog.Logger

// WithTraceContext returns a logger enriched with OpenTelemetry trace and span IDs.
func WithTraceContext(ctx context.Context, logger *slog.Logger) *slog.Logger

// ContextWithLogger stores the logger in the context.
func ContextWithLogger(ctx context.Context, logger *slog.Logger) context.Context

// LoggerFromContext retrieves the logger from context, falling back to the default.
func LoggerFromContext(ctx context.Context) *slog.Logger
\`\`\`

### 4. Observability Middleware — \`internal/middleware/observability.go\`

Create Chi middleware that ties everything together:

\`\`\`go
// Metrics returns Chi middleware that records Prometheus metrics for every request.
func Metrics() func(next http.Handler) http.Handler

// Tracing returns Chi middleware that creates OpenTelemetry spans for every request.
// It extracts the route pattern from Chi for low-cardinality span names.
func Tracing(tracer trace.Tracer) func(next http.Handler) http.Handler

// RequestLogging returns Chi middleware that logs request/response details.
// It logs: method, path, status, duration, request_id, client_ip, user_agent.
// Sensitive headers (Authorization, Cookie) are redacted.
func RequestLogging(logger *slog.Logger) func(next http.Handler) http.Handler
\`\`\`

Key requirements:
- Use chi.RouteContext(r.Context()).RoutePattern() for low-cardinality metric labels and span names (not raw URL paths)
- Wrap the http.ResponseWriter to capture status code and bytes written
- Add request_id to every request (generate UUID if X-Request-ID header is absent)
- Propagate request_id, trace_id, span_id through context for correlation
- Redact Authorization and Cookie headers in logs
- Record request body size and response body size as span attributes
- Set span status to Error for 5xx responses

### 5. Health Check Handler — \`internal/handler/health.go\`

Implement health check endpoints required for Kubernetes and ALB:

\`\`\`go
// GET /healthz — liveness probe (always returns 200 if process is running)
// GET /readyz — readiness probe (checks PostgreSQL, Redis connectivity)
// GET /healthz/detailed — detailed health with component status (requires auth)
\`\`\`

- Readiness checks must have timeouts (2 seconds per dependency)
- Detailed health returns JSON with each component's status, latency, and last_check timestamp
- Record health check results as Prometheus metrics (gateway_health_check_status gauge)
- Do NOT trace health check endpoints (exclude from tracing middleware to reduce noise)

### 6. Configuration — \`internal/observability/config.go\`

Define configuration structs loaded by Viper:

\`\`\`go
type ObservabilityConfig struct {
    Tracing TracingConfig
    Metrics MetricsConfig
    Logging LoggingConfig
}

type TracingConfig struct {
    Enabled      bool    \`mapstructure:"enabled"\`
    Endpoint     string  \`mapstructure:"endpoint"\`      // OTLP endpoint
    SampleRatio  float64 \`mapstructure:"sample_ratio"\`  // 0.0-1.0
    Environment  string  \`mapstructure:"environment"\`
    Insecure     bool    \`mapstructure:"insecure"\`       // TLS for OTLP
}

type MetricsConfig struct {
    Enabled bool   \`mapstructure:"enabled"\`
    Path    string \`mapstructure:"path"\`    // default: /metrics
    Port    int    \`mapstructure:"port"\`    // default: 9090
}

type LoggingConfig struct {
    Level  string \`mapstructure:"level"\`   // debug, info, warn, error
    Format string \`mapstructure:"format"\`  // json, text
}
\`\`\`

### 7. Middleware Chain Integration — show how to wire into \`cmd/gateway/main.go\`

Show the middleware ordering on the Chi router:

\`\`\`go
r := chi.NewRouter()

// Observability middleware (outermost — captures everything)
r.Use(middleware.RequestID)           // assign/propagate request ID
r.Use(middleware.Tracing(tracer))     // OpenTelemetry span creation
r.Use(middleware.RequestLogging(logger)) // structured request logging
r.Use(middleware.Metrics())           // Prometheus metrics recording
r.Use(middleware.Recoverer(logger))   // panic recovery with stack trace logging

// Security middleware
r.Use(middleware.CORS(corsConfig))
r.Use(middleware.RateLimiter(limiter))
r.Use(middleware.Auth(authService))

// Health endpoints (outside auth middleware)
r.Get("/healthz", healthHandler.Liveness)
r.Get("/readyz", healthHandler.Readiness)
\`\`\`

### 8. Grafana Dashboard — \`deployments/grafana/gateway-dashboard.json\`

Generate a Grafana dashboard JSON with panels for:
- Request rate (requests/sec by status code)
- P50/P95/P99 latency
- Error rate (4xx and 5xx)
- Rate limit hits over time
- Circuit breaker state changes
- Upstream latency by service
- Active connections
- Go runtime metrics (goroutines, heap, GC pause)

### 9. Tests

Write table-driven tests for:

- \`internal/observability/logging_test.go\` — verify trace context enrichment, log level filtering, header redaction
- \`internal/middleware/observability_test.go\` — verify metrics recording, span creation, request ID propagation using httptest
- \`internal/handler/health_test.go\` — verify liveness always 200, readiness reflects dependency state, detailed health requires auth

Use testify for assertions. Use httptest.NewRecorder and httptest.NewRequest. Mock dependencies with interfaces.

## Constraints

- All files must be under 300 lines. Split if necessary.
- All exported functions must have doc comments.
- Errors must be wrapped with fmt.Errorf("context: %w", err).
- No init() functions — use explicit initialization.
- Context propagation required on all functions that do I/O.
- Follow Effective Go and Go Code Review Comments.
- Use interfaces for dependency injection (especially health check dependencies).
- Conservative dependency policy — only use: go.opentelemetry.io/otel, github.com/prometheus/client_golang, github.com/go-chi/chi/v5, github.com/stretchr/testify.
- SOC 2: all auth events and config changes must be logged. Sensitive data must never appear in logs or traces.

## File Naming

Use snake_case for all Go files:
- internal/observability/tracing.go
- internal/observability/metrics.go
- internal/observability/logging.go
- internal/observability/config.go
- internal/middleware/observability.go
- internal/middleware/request_id.go
- internal/handler/health.go
- deployments/grafana/gateway_dashboard.json

## Expected Output

Generate all files listed above with complete, compilable Go code. Include appropriate package declarations, imports, and build tags where needed. Each file should be production-ready, not a skeleton.

After generating, run:
1. \`go vet ./internal/observability/... ./internal/middleware/... ./internal/handler/...\`
2. \`golangci-lint run ./internal/observability/... ./internal/middleware/... ./internal/handler/...\`
3. \`go test -v -race -count=1 ./internal/observability/... ./internal/middleware/... ./internal/handler/...\`

Verify all tests pass and coverage meets the 80% threshold for the new files.
\`\`\`

---

## Verification Checklist

After Claude Code completes the implementation, verify:

- [ ] \`internal/observability/tracing.go\` — OTLP exporter, BatchSpanProcessor, W3C propagation, shutdown function
- [ ] \`internal/observability/metrics.go\` — all gateway metrics registered, appropriate histogram buckets
- [ ] \`internal/observability/logging.go\` — slog setup, trace context enrichment, context propagation helpers
- [ ] \`internal/observability/config.go\` — Viper-compatible config structs with mapstructure tags
- [ ] \`internal/middleware/observability.go\` — Metrics, Tracing, RequestLogging middleware using Chi route patterns
- [ ] \`internal/middleware/request_id.go\` — UUID generation, X-Request-ID header propagation
- [ ] \`internal/handler/health.go\` — /healthz, /readyz, /healthz/detailed with dependency checks and timeouts
- [ ] \`deployments/grafana/gateway_dashboard.json\` — dashboard with all specified panels
- [ ] All tests pass with \`go test -race\`
- [ ] No linting errors from \`golangci-lint run\`
- [ ] Authorization and Cookie headers are redacted in logs
- [ ] Health check endpoints are excluded from tracing
- [ ] Span names use Chi route patterns (e.g., \`GET /api/v1/users/{id}\`) not raw paths
- [ ] Metrics use low-cardinality labels (route patterns, not raw URLs)
- [ ] SOC 2 audit events: auth success/failure, rate limit enforcement, config changes logged at INFO+
- [ ] Graceful shutdown calls tracer provider Shutdown()
- [ ] No init() functions anywhere

## Related Files

- \`playbook/phases/05-integration-hardening.md\` — phase definition and exit criteria
- \`playbook/prompts/05/security-hardening.md\` — security hardening prompt (complementary)
- \`playbook/prompts/05/integration-adapter.md\` — upstream service integration
- \`playbook/prompts/03/ci-pipeline.md\` — CI pipeline that runs these tests
- \`playbook/prompts/04/auth-implementation.md\` — auth middleware that emits observability events`,

  'playbook/prompts/05/security-hardening.md': `# Security Hardening — Phase 05 Prompt

> Copy-paste this prompt into Claude Code to perform comprehensive security hardening on the go-api-gateway project.

---

## Prompt

\`\`\`
You are a security engineer hardening the go-api-gateway project for SOC 2 compliance and production readiness. This is a Go 1.22+ API gateway built with Chi v5 that handles JWT authentication, rate limiting, and request routing for a microservices architecture.

## Context

Review the current codebase structure:
- cmd/gateway/ — main entry point
- internal/auth/ — JWT validation, API key verification, RBAC
- internal/middleware/ — Chi middleware chain (auth, rate limit, logging, cors, recovery)
- internal/handler/ — HTTP route handlers
- internal/service/ — business logic
- internal/repository/ — PostgreSQL and Redis data access
- internal/ratelimit/ — Redis-backed sliding window rate limiting
- internal/config/ — Viper configuration loading
- pkg/errors/ — custom error types
- pkg/httputil/ — response helpers

Read the existing code in these directories before making changes.

## Security Hardening Tasks

### 1. Input Validation and Sanitization

Harden all HTTP handlers in internal/handler/:

- Validate Content-Type headers strictly (reject unexpected types with 415)
- Enforce maximum request body sizes per endpoint using http.MaxBytesReader
- Validate all path parameters, query parameters, and headers against allowlists
- Sanitize and validate JWT claims after decoding (issuer, audience, expiry, not-before)
- Reject requests with duplicate headers that could cause parsing ambiguity
- Validate upstream service URLs against an allowlist to prevent SSRF
- Add request ID validation (must be valid UUID if provided)

Create or update internal/middleware/validation.go:

\`\`\`go
// Package middleware provides Chi-compatible middleware for the API gateway.
package middleware

// MaxBodySize returns middleware that limits request body size.
// Different endpoints may have different limits.
func MaxBodySize(bytes int64) func(http.Handler) http.Handler

// ValidateContentType returns middleware that enforces allowed content types.
func ValidateContentType(allowed ...string) func(http.Handler) http.Handler

// SanitizeHeaders returns middleware that removes or validates dangerous headers.
func SanitizeHeaders(next http.Handler) http.Handler
\`\`\`

### 2. Authentication Hardening (internal/auth/)

Review and harden the JWT and API key authentication:

- Ensure RS256 algorithm is enforced explicitly — reject tokens with alg:none or HS256
- Validate the JWT kid (key ID) header against known keys before verification
- Implement JWT claim validation: iss, aud, exp, nbf, iat with clock skew tolerance of 30 seconds max
- Add API key hashing — store only SHA-256 hashes in PostgreSQL, never plaintext
- Implement API key rotation support: allow two active keys per client during rotation window
- Add brute-force protection: track failed auth attempts per IP in Redis with exponential backoff
- Ensure timing-safe comparison for API key validation using crypto/subtle.ConstantTimeCompare
- Add token revocation checking against Redis blacklist

Create internal/auth/bruteforce.go:

\`\`\`go
// Package auth provides authentication and authorization for the API gateway.
package auth

// BruteForceProtector tracks failed authentication attempts and applies
// exponential backoff to prevent credential stuffing attacks.
type BruteForceProtector struct {
    redis  RedisClient
    maxAttempts int
    windowDuration time.Duration
    backoffBase time.Duration
}

// CheckAllowed returns whether the given IP is allowed to attempt authentication.
// Returns the remaining lockout duration if blocked.
func (b *BruteForceProtector) CheckAllowed(ctx context.Context, ip string) (bool, time.Duration, error)

// RecordFailure records a failed authentication attempt for the given IP.
func (b *BruteForceProtector) RecordFailure(ctx context.Context, ip string) error

// RecordSuccess clears the failure counter for the given IP.
func (b *BruteForceProtector) RecordSuccess(ctx context.Context, ip string) error
\`\`\`

### 3. TLS and Transport Security

Create or update internal/middleware/security_headers.go:

\`\`\`go
// SecurityHeaders adds security-related HTTP headers to all responses.
// This middleware should be early in the Chi middleware chain.
func SecurityHeaders(next http.Handler) http.Handler
\`\`\`

The middleware must set:
- Strict-Transport-Security: max-age=31536000; includeSubDomains; preload
- X-Content-Type-Options: nosniff
- X-Frame-Options: DENY
- X-XSS-Protection: 0 (disabled in favor of CSP)
- Content-Security-Policy: default-src 'none'; frame-ancestors 'none'
- Cache-Control: no-store, no-cache, must-revalidate (for API responses)
- Referrer-Policy: strict-origin-when-cross-origin
- Permissions-Policy: geolocation=(), camera=(), microphone=()

Also ensure the gateway server in cmd/gateway/main.go configures TLS:
- TLS 1.2 minimum (tls.VersionTLS12)
- Prefer server cipher suites
- Use only strong cipher suites (TLS_ECDHE_RSA_WITH_AES_256_GCM_SHA384, TLS_ECDHE_RSA_WITH_AES_128_GCM_SHA256, TLS 1.3 suites)
- Set appropriate timeouts: ReadTimeout 5s, WriteTimeout 10s, IdleTimeout 120s, ReadHeaderTimeout 2s

### 4. Rate Limiting Hardening (internal/ratelimit/)

Review and harden the Redis-backed rate limiter:

- Ensure rate limit keys include client ID, IP, and endpoint to prevent cross-client interference
- Use Redis Lua scripts for atomic check-and-increment to prevent race conditions
- Add separate rate limit tiers: per-client global, per-client per-endpoint, per-IP (unauthenticated)
- Include rate limit headers in responses: X-RateLimit-Limit, X-RateLimit-Remaining, X-RateLimit-Reset
- Add rate limit bypass protection: validate X-Forwarded-For against trusted proxy list only
- Implement graceful degradation: if Redis is unavailable, apply conservative in-memory rate limits rather than failing open

Create internal/ratelimit/lua.go with embedded Lua scripts:

\`\`\`go
// Package ratelimit provides Redis-backed rate limiting for the API gateway.
package ratelimit

// slidingWindowScript is the Lua script for atomic sliding window rate limiting.
// It ensures check-and-increment is atomic to prevent race conditions.
//go:embed scripts/sliding_window.lua
var slidingWindowScript string
\`\`\`

### 5. CORS Hardening (internal/middleware/cors.go)

Review and harden CORS configuration:

- Use explicit origin allowlist loaded from config — never use wildcard "*" in production
- Validate Origin header against the allowlist using exact match (no regex that could be bypassed)
- Restrict allowed methods to only those actually used: GET, POST, PUT, DELETE, OPTIONS
- Restrict allowed headers to a specific set
- Set Access-Control-Max-Age to 3600 (1 hour)
- Never reflect the Origin header back without validation
- Ensure preflight responses have appropriate caching

### 6. Error Handling and Information Leakage

Review all error responses across the codebase:

- Ensure internal error details (stack traces, SQL errors, Redis errors) are never exposed to clients
- Use generic error messages for 5xx responses: "internal server error" only
- Map all internal errors to appropriate HTTP status codes in pkg/errors/
- Log full error details server-side with slog at appropriate levels
- Ensure panic recovery middleware in internal/middleware/recovery.go catches all panics and returns 500 without leaking details
- Remove any debug endpoints or verbose error modes that could be enabled in production

Update pkg/errors/errors.go to ensure safe error mapping:

\`\`\`go
// Package errors provides custom error types and safe error mapping for the API gateway.
package errors

// ToHTTPError maps an internal error to a safe client-facing error response.
// Internal details are stripped; only the error code and safe message are returned.
func ToHTTPError(err error) (statusCode int, response ErrorResponse)

// ErrorResponse is the standard error response returned to API clients.
// It never contains internal implementation details.
type ErrorResponse struct {
    Code    string \`json:"code"\`
    Message string \`json:"message"\`
    TraceID string \`json:"trace_id,omitempty"\`
}
\`\`\`

### 7. Secrets Management

Audit the codebase for secrets handling:

- Ensure no secrets are hardcoded — check all files for strings that look like keys, passwords, tokens
- Verify internal/config/ loads secrets from environment variables or AWS Secrets Manager, never from config YAML files
- Ensure secrets are not logged — audit all slog calls to confirm no sensitive fields are logged
- Add a slog hook or wrapper that redacts known sensitive field names: password, token, secret, api_key, authorization
- Ensure Redis and PostgreSQL connection strings with credentials are loaded from env vars
- Verify .gitignore includes: *.pem, *.key, .env*, configs/production/

Create internal/observability/redact.go:

\`\`\`go
// Package observability provides logging, metrics, and tracing for the API gateway.
package observability

// RedactingHandler wraps an slog.Handler to redact sensitive field values.
// Fields matching sensitive key patterns are replaced with "[REDACTED]".
type RedactingHandler struct {
    inner          slog.Handler
    sensitiveKeys  map[string]bool
}

// NewRedactingHandler creates a handler that redacts values for the given keys.
func NewRedactingHandler(inner slog.Handler, keys []string) *RedactingHandler
\`\`\`

### 8. Dependency Security

- Run \`govulncheck ./...\` and report any known vulnerabilities
- Review go.mod for unnecessary dependencies — flag any that could be replaced with stdlib
- Ensure all dependencies are pinned to exact versions (no floating tags)
- Check that no dependencies pull in CGO requirements that could introduce memory safety issues
- Verify the Docker image uses a minimal base (distroless or alpine) with no shell

### 9. Circuit Breaker Security (internal/circuit/)

Review the circuit breaker for security implications:

- Ensure circuit breaker state changes are logged with slog for audit trail
- Prevent circuit breaker configuration from being modified at runtime without authentication
- Ensure half-open state probe requests don't bypass authentication or rate limiting
- Add metrics for circuit breaker state transitions (Prometheus counters)

### 10. SOC 2 Audit Trail

Ensure comprehensive audit logging for SOC 2 compliance:

- Log all authentication events: success, failure, token refresh, API key usage
- Log all authorization decisions: RBAC allow/deny with role and resource
- Log all rate limit events: throttled requests with client ID and endpoint
- Log all configuration changes with who/what/when
- Log all admin API access
- Ensure all log entries include: timestamp, trace_id, client_id, source_ip, user_agent, endpoint, method, status_code
- Ensure logs are structured JSON via slog for ingestion into CloudWatch

Create internal/middleware/audit.go:

\`\`\`go
// AuditLog is Chi middleware that records an audit trail of all API requests.
// It captures authentication context, request metadata, and response status
// for SOC 2 compliance.
func AuditLog(logger *slog.Logger) func(http.Handler) http.Handler
\`\`\`

## Output Requirements

For each task:
1. Read the existing code first
2. Identify specific vulnerabilities or gaps
3. Implement the fix with full Go code
4. Write table-driven tests using testify and httptest
5. Ensure all exported functions have doc comments
6. Keep files under 300 lines — split if needed
7. Use context propagation on all functions that do I/O
8. Wrap errors with fmt.Errorf and %w

After all changes:
- Run \`golangci-lint run ./...\` and fix any issues
- Run \`go vet ./...\`
- Run \`go test -race -cover ./...\` and verify coverage >= 80%
- Run \`govulncheck ./...\` if available
- Summarize all changes made with security rationale for each

## Files to Create or Modify

New files:
- internal/middleware/validation.go
- internal/middleware/validation_test.go
- internal/middleware/security_headers.go
- internal/middleware/security_headers_test.go
- internal/middleware/audit.go
- internal/middleware/audit_test.go
- internal/auth/bruteforce.go
- internal/auth/bruteforce_test.go
- internal/ratelimit/lua.go
- internal/ratelimit/scripts/sliding_window.lua
- internal/observability/redact.go
- internal/observability/redact_test.go
- pkg/errors/errors.go (update)

Modified files (review and harden):
- cmd/gateway/main.go (TLS config, timeouts)
- internal/auth/jwt.go (algorithm pinning, claim validation)
- internal/auth/apikey.go (hashing, timing-safe comparison)
- internal/middleware/cors.go (origin allowlist)
- internal/middleware/recovery.go (information leakage)
- internal/ratelimit/limiter.go (atomic operations, degradation)
- internal/config/config.go (secrets from env only)
- .gitignore (sensitive file patterns)

## Security Standards Reference

- OWASP API Security Top 10 (2023)
- SOC 2 Type II — Security, Availability, Confidentiality
- CIS Benchmarks for Docker/Kubernetes
- Go Secure Coding Guidelines (OWASP)
- NIST 800-63B (authentication)

Proceed with the security hardening. Start by reading the existing codebase, then work through each task systematically.
\`\`\`

---

## When to Use

Run this prompt during **Phase 05 — Integration & Hardening**, after core features (authentication, rate limiting, routing, circuit breaker) are implemented and passing tests. This prompt assumes the code from Phase 04 is complete and functional.

## Prerequisites

- Phase 04 complete: auth, rate limiting, routing, circuit breaker all implemented
- \`go test ./...\` passes with ≥80% coverage
- \`golangci-lint run\` passes
- Redis and PostgreSQL are available (local Docker or test instances)
- \`govulncheck\` installed: \`go install golang.org/x/vuln/cmd/govulncheck@latest\`

## Expected Outcomes

| Area | Before | After |
|------|--------|-------|
| JWT validation | Basic token parsing | Algorithm pinning, claim validation, revocation checking |
| API keys | Plaintext storage | SHA-256 hashed, timing-safe comparison, rotation support |
| Rate limiting | Basic Redis counter | Atomic Lua scripts, graceful degradation, per-tier limits |
| Error responses | May leak internals | Generic messages, safe error mapping, no stack traces |
| Headers | Minimal | Full security header suite (HSTS, CSP, etc.) |
| Logging | Basic | Redacted sensitive fields, SOC 2 audit trail |
| TLS | Default config | TLS 1.2+, strong ciphers, proper timeouts |
| Brute force | None | Exponential backoff per IP with Redis tracking |
| CORS | Permissive | Strict origin allowlist, no wildcard |
| Dependencies | Unchecked | govulncheck clean, minimal deps, pinned versions |

## Follow-Up

After completing this prompt:
1. Run the full verification: \`/project:verify\`
2. Review changes with: \`/project:code-review\`
3. Proceed to Phase 06 (Testing & Quality) with \`playbook/prompts/06/load-testing.md\`
4. Document security decisions as ADRs using \`playbook/prompts/02/adr-generator.md\`
5. Update the threat model in \`docs/security/threat-model.md\`

## Related Files

- \`playbook/phases/05-integration-hardening.md\` — Phase 05 definition and exit criteria
- \`playbook/prompts/04/auth-implementation.md\` — Original auth implementation prompt
- \`plugin/codeforge-go-api-gateway/commands/verify.md\` — Verification command
- \`configs/\` — Configuration files to audit for hardcoded secrets`,

  'playbook/prompts/06/e2e-test-generator.md': `# E2E Test Generator — Phase 06: Testing & Quality

> **Copy-paste this prompt into Claude Code to generate end-to-end tests for the go-api-gateway.**
> Covers full request lifecycle through the API gateway: routing, authentication, rate limiting, circuit breaking, and upstream proxying.

---

## Prompt

\`\`\`
You are an expert Go backend engineer writing end-to-end tests for the go-api-gateway project. E2E tests validate the full request lifecycle from client request through the gateway to upstream services and back.

## Project Context

- Go 1.22+ with Chi v5 router
- Clean Architecture: handler → service → repository
- PostgreSQL for config/API key metadata, Redis for rate limiting/caching
- JWT (RS256) authentication, API key auth, RBAC
- Per-client rate limiting (Redis sliding window)
- Circuit breaker pattern for upstream services
- OpenTelemetry tracing, Prometheus metrics, slog structured logging
- SOC 2 compliance requirements
- Test framework: stdlib testing + testify + httptest
- Coverage threshold: 80%

## Directory Structure

Place E2E tests in:
- tests/e2e/              — E2E test files
- tests/e2e/testdata/     — Fixtures (JWTs, configs, request/response bodies)
- tests/e2e/helpers/      — Shared test utilities

## What to Generate

### 1. tests/e2e/helpers/gateway.go — Test Gateway Server

Create a helper that boots the full gateway stack for E2E testing:

\`\`\`go
// Package helpers provides shared utilities for E2E tests.
package helpers

// TestGateway encapsulates a fully wired gateway for E2E testing.
// It starts real HTTP servers for the gateway and mock upstreams,
// connects to test PostgreSQL and Redis instances (via testcontainers or env),
// and provides methods to make authenticated requests.
type TestGateway struct {
    Server       *httptest.Server
    BaseURL      string
    AdminToken   string
    UserToken    string
    APIKey       string
    RedisClient  *redis.Client
    DB           *sql.DB
    Upstreams    map[string]*httptest.Server // service name → mock upstream
}

// NewTestGateway wires all real components:
// - Load config from tests/e2e/testdata/e2e-config.yaml
// - Connect to test PostgreSQL (use GATEWAY_TEST_DB_URL env or testcontainers)
// - Connect to test Redis (use GATEWAY_TEST_REDIS_URL env or testcontainers)
// - Register mock upstream servers for "users-service", "orders-service", "inventory-service"
// - Build the full Chi router with ALL middleware (auth, rate limit, logging, cors, recovery, tracing)
// - Seed test data: API keys, route configs, RBAC roles
// - Generate valid JWT tokens (admin, user roles) using test RSA keys
// - Return a started httptest.Server
func NewTestGateway(t *testing.T) *TestGateway { ... }

// Close tears down all servers, connections, and cleans test data.
func (tg *TestGateway) Close() { ... }

// Request creates an *http.Request with common headers (Content-Type, correlation ID).
func (tg *TestGateway) Request(method, path string, body io.Reader) *http.Request { ... }

// AuthRequest creates a request with a Bearer JWT token.
func (tg *TestGateway) AuthRequest(method, path string, body io.Reader, token string) *http.Request { ... }

// APIKeyRequest creates a request with X-API-Key header.
func (tg *TestGateway) APIKeyRequest(method, path string, body io.Reader, apiKey string) *http.Request { ... }

// Do executes a request and returns the response. Fails the test on transport errors.
func (tg *TestGateway) Do(t *testing.T, req *http.Request) *http.Response { ... }

// ResetRateLimits flushes rate limit keys from Redis between tests.
func (tg *TestGateway) ResetRateLimits(t *testing.T) { ... }

// SetUpstreamHandler replaces the handler for a named upstream to simulate different behaviors.
func (tg *TestGateway) SetUpstreamHandler(name string, handler http.HandlerFunc) { ... }
\`\`\`

Use build tags: \`//go:build e2e\`

### 2. tests/e2e/helpers/assertions.go — Response Assertion Helpers

\`\`\`go
// AssertStatus checks the HTTP status code.
func AssertStatus(t *testing.T, resp *http.Response, expected int) { ... }

// AssertJSON unmarshals the response body into dst and asserts Content-Type is application/json.
func AssertJSON(t *testing.T, resp *http.Response, dst interface{}) { ... }

// AssertErrorResponse checks the gateway error response format:
// {"error": {"code": "...", "message": "..."}}
func AssertErrorResponse(t *testing.T, resp *http.Response, expectedStatus int, expectedCode string) { ... }

// AssertHeader checks a response header value.
func AssertHeader(t *testing.T, resp *http.Response, key, expected string) { ... }

// AssertHeaderExists checks that a response header is present.
func AssertHeaderExists(t *testing.T, resp *http.Response, key string) { ... }

// AssertRateLimitHeaders checks X-RateLimit-Limit, X-RateLimit-Remaining, X-RateLimit-Reset.
func AssertRateLimitHeaders(t *testing.T, resp *http.Response) { ... }

// AssertTraceHeaders checks that trace context headers are propagated (traceparent).
func AssertTraceHeaders(t *testing.T, resp *http.Response) { ... }

// ReadBody reads and closes the response body, failing on error.
func ReadBody(t *testing.T, resp *http.Response) []byte { ... }
\`\`\`

### 3. tests/e2e/helpers/jwt.go — Test JWT Generation

\`\`\`go
// GenerateTestRSAKeys generates an RSA key pair for test JWT signing.
func GenerateTestRSAKeys(t *testing.T) (*rsa.PrivateKey, *rsa.PublicKey) { ... }

// GenerateTestJWT creates a signed JWT with the given claims.
// Standard claims: sub, iss, aud, exp, iat, jti
// Custom claims: role (string), permissions ([]string), client_id (string)
func GenerateTestJWT(t *testing.T, key *rsa.PrivateKey, claims map[string]interface{}) string { ... }

// GenerateExpiredJWT creates a JWT that expired 1 hour ago.
func GenerateExpiredJWT(t *testing.T, key *rsa.PrivateKey) string { ... }

// GenerateJWTWithRole creates a JWT with a specific role for RBAC testing.
func GenerateJWTWithRole(t *testing.T, key *rsa.PrivateKey, role string) string { ... }
\`\`\`

### 4. tests/e2e/routing_test.go — Request Routing E2E Tests

Test the full proxy routing lifecycle with table-driven tests:

\`\`\`go
//go:build e2e

func TestE2E_RequestRouting(t *testing.T) {
    // Test cases (table-driven):
    // - "GET /api/v1/users proxies to users-service"
    //   → Verify request reaches correct upstream, response returned to client
    // - "POST /api/v1/orders proxies to orders-service"
    //   → Verify request body is forwarded, upstream receives correct Content-Type
    // - "Request headers are forwarded to upstream"
    //   → Set custom headers, verify upstream receives them
    // - "X-Forwarded-For and X-Request-ID are injected"
    //   → Verify gateway adds standard proxy headers
    // - "Upstream response headers are forwarded to client"
    //   → Upstream sets custom header, verify client receives it
    // - "Unknown route returns 404 with gateway error format"
    //   → GET /api/v1/nonexistent → 404 {"error": {"code": "ROUTE_NOT_FOUND"}}
    // - "Method not allowed returns 405"
    //   → DELETE on a GET-only route → 405
    // - "Query parameters are forwarded to upstream"
    //   → GET /api/v1/users?page=2&limit=10 → upstream receives query params
    // - "Path parameters are correctly routed"
    //   → GET /api/v1/users/123 → upstream receives /123
    // - "Large request body is proxied correctly"
    //   → POST with 1MB JSON body → upstream receives complete body
    // - "Upstream 5xx is forwarded to client"
    //   → Upstream returns 503 → client receives 503 with gateway wrapper
    // - "Request timeout returns 504"
    //   → Upstream delays 30s, gateway timeout is 10s → 504 Gateway Timeout
}
\`\`\`

For each test:
- Use \`tg.SetUpstreamHandler()\` to configure mock upstream behavior
- Assert both the client response AND what the upstream received
- Verify correlation/trace IDs flow through the entire chain

### 5. tests/e2e/auth_test.go — Authentication & Authorization E2E Tests

\`\`\`go
//go:build e2e

func TestE2E_JWTAuthentication(t *testing.T) {
    // Table-driven tests:
    // - "Valid JWT grants access to protected route"
    // - "Missing Authorization header returns 401"
    //   → {"error": {"code": "AUTH_MISSING_TOKEN"}}
    // - "Malformed JWT returns 401"
    //   → Authorization: Bearer not-a-jwt
    // - "Expired JWT returns 401"
    //   → {"error": {"code": "AUTH_TOKEN_EXPIRED"}}
    // - "JWT signed with wrong key returns 401"
    //   → {"error": {"code": "AUTH_INVALID_SIGNATURE"}}
    // - "JWT with invalid audience returns 401"
    // - "JWT with invalid issuer returns 401"
    // - "JWT claims are available to upstream via X-User-ID, X-User-Role headers"
}

func TestE2E_APIKeyAuthentication(t *testing.T) {
    // Table-driven tests:
    // - "Valid API key in X-API-Key header grants access"
    // - "Invalid API key returns 401"
    // - "Revoked API key returns 401"
    // - "Expired API key returns 401"
    // - "API key rate limits are per-key"
}

func TestE2E_RBAC(t *testing.T) {
    // Table-driven tests:
    // - "Admin role can access admin routes"
    //   → GET /api/v1/admin/routes → 200
    // - "User role cannot access admin routes"
    //   → GET /api/v1/admin/routes → 403 {"error": {"code": "AUTH_FORBIDDEN"}}
    // - "Service role can access internal routes"
    // - "Permissions are checked for specific operations"
    //   → JWT with permissions: ["users:read"] can GET but not POST to /api/v1/users
}

func TestE2E_PublicRoutes(t *testing.T) {
    // - "Health check is accessible without auth"
    //   → GET /healthz → 200
    // - "Readiness check is accessible without auth"
    //   → GET /readyz → 200
    // - "Metrics endpoint is accessible without auth (or with basic auth)"
    //   → GET /metrics → 200
    // - "Public routes do not require JWT"
    //   → Routes configured as public in route config
}
\`\`\`

### 6. tests/e2e/ratelimit_test.go — Rate Limiting E2E Tests

\`\`\`go
//go:build e2e

func TestE2E_RateLimiting(t *testing.T) {
    // IMPORTANT: Call tg.ResetRateLimits(t) in setup

    // Table-driven tests:
    // - "Requests within rate limit succeed"
    //   → Send 5 requests when limit is 10/min → all return 200
    //   → Verify X-RateLimit-Remaining decrements
    // - "Requests exceeding rate limit return 429"
    //   → Send 11 requests when limit is 10/min → 11th returns 429
    //   → {"error": {"code": "RATE_LIMIT_EXCEEDED"}}
    //   → Verify Retry-After header is present
    // - "Rate limit headers are present on all responses"
    //   → X-RateLimit-Limit, X-RateLimit-Remaining, X-RateLimit-Reset
    // - "Rate limits are per-client (by API key)"
    //   → Client A exhausts limit, Client B still has quota
    // - "Rate limits are per-client (by JWT subject)"
    //   → User A exhausts limit, User B still has quota
    // - "Different routes can have different rate limits"
    //   → /api/v1/users has 100/min, /api/v1/search has 20/min
    // - "Rate limit resets after window expires"
    //   → Exhaust limit, wait for window, verify requests succeed again
    //   → (Use short window like 2s for test speed)
}

func TestE2E_RateLimitRedisFailure(t *testing.T) {
    // - "When Redis is unavailable, gateway fails open (allows requests)"
    //   → Or fails closed depending on config — test the configured behavior
    //   → Verify degraded mode is logged
}
\`\`\`

### 7. tests/e2e/circuit_breaker_test.go — Circuit Breaker E2E Tests

\`\`\`go
//go:build e2e

func TestE2E_CircuitBreaker(t *testing.T) {
    // - "Circuit opens after consecutive upstream failures"
    //   → Configure upstream to return 500
    //   → Send requests until circuit opens (e.g., 5 consecutive failures)
    //   → Next request returns 503 {"error": {"code": "CIRCUIT_OPEN"}} without hitting upstream
    // - "Circuit half-opens after timeout"
    //   → After circuit opens, wait for half-open timeout
    //   → Next request is sent to upstream (probe)
    // - "Circuit closes after successful probe"
    //   → Fix upstream (return 200), send request during half-open
    //   → Circuit closes, subsequent requests succeed
    // - "Circuit remains open if probe fails"
    //   → Upstream still failing during half-open → circuit stays open
    // - "Circuit breaker is per-upstream-service"
    //   → users-service circuit opens, orders-service still works
    // - "Upstream timeouts count as failures"
    //   → Upstream delays beyond timeout → counts toward circuit threshold
}
\`\`\`

### 8. tests/e2e/observability_test.go — Observability E2E Tests

\`\`\`go
//go:build e2e

func TestE2E_HealthChecks(t *testing.T) {
    // - "GET /healthz returns 200 with status"
    //   → {"status": "healthy", "version": "..."}
    // - "GET /readyz returns 200 when all dependencies are up"
    //   → {"status": "ready", "checks": {"postgres": "up", "redis": "up"}}
    // - "GET /readyz returns 503 when a dependency is down"
    //   → Stop Redis → {"status": "not_ready", "checks": {"redis": "down"}}
}

func TestE2E_Metrics(t *testing.T) {
    // - "GET /metrics returns Prometheus metrics"
    //   → Content-Type: text/plain
    //   → Contains gateway_requests_total
    //   → Contains gateway_request_duration_seconds
    //   → Contains gateway_upstream_requests_total
    // - "Metrics increment after requests"
    //   → Scrape metrics, send request, scrape again, verify counter incremented
    // - "Error metrics are recorded"
    //   → Send request that returns 500, verify error counter incremented
}

func TestE2E_RequestCorrelation(t *testing.T) {
    // - "X-Request-ID is generated if not provided"
    //   → Send request without X-Request-ID → response has X-Request-ID
    // - "X-Request-ID is preserved if provided"
    //   → Send request with X-Request-ID: abc-123 → response has same ID
    //   → Upstream receives same X-Request-ID
    // - "Traceparent header is propagated"
    //   → Send request with traceparent → upstream receives traceparent
}
\`\`\`

### 9. tests/e2e/security_test.go — Security E2E Tests (SOC 2)

\`\`\`go
//go:build e2e

func TestE2E_SecurityHeaders(t *testing.T) {
    // - "Response includes security headers"
    //   → X-Content-Type-Options: nosniff
    //   → X-Frame-Options: DENY
    //   → Strict-Transport-Security (if configured)
    //   → X-XSS-Protection: 0 (modern approach)
    //   → Content-Security-Policy
    // - "Server header is not exposed"
    //   → Response should not contain Server header or should be generic
    // - "CORS headers are correct for allowed origins"
    //   → OPTIONS request with allowed origin → correct Access-Control-* headers
    // - "CORS rejects disallowed origins"
    //   → OPTIONS request with evil.com → no Access-Control-Allow-Origin
}

func TestE2E_InputValidation(t *testing.T) {
    // - "Oversized request body is rejected"
    //   → POST with 11MB body (limit is 10MB) → 413 Payload Too Large
    // - "Malformed JSON returns 400"
    //   → POST with invalid JSON → 400 {"error": {"code": "INVALID_REQUEST_BODY"}}
    // - "Path traversal attempts are blocked"
    //   → GET /api/v1/../../../etc/passwd → 400 or 404
    // - "SQL injection in query params does not cause errors"
    //   → GET /api/v1/users?id=1;DROP TABLE users → upstream receives sanitized params
    // - "Request with null bytes is rejected"
    //   → Header or path containing \\x00 → 400
}

func TestE2E_AuditLogging(t *testing.T) {
    // - "Authentication failures are logged"
    //   → Send request with invalid JWT → verify structured log entry exists
    //   → Log contains: client_ip, path, method, error_code, timestamp
    // - "Rate limit violations are logged"
    //   → Exceed rate limit → verify log entry with client identifier
    // - "Sensitive headers are not logged"
    //   → Authorization header value must not appear in logs
    //   → X-API-Key value must not appear in logs
}
\`\`\`

### 10. tests/e2e/graceful_shutdown_test.go — Graceful Shutdown E2E Test

\`\`\`go
//go:build e2e

func TestE2E_GracefulShutdown(t *testing.T) {
    // This test requires a real process (not httptest.Server).
    // Start the gateway binary as a subprocess.

    // - "In-flight requests complete during shutdown"
    //   → Start a slow request (upstream delays 3s)
    //   → Send SIGTERM to gateway process
    //   → Slow request completes successfully
    //   → New requests after SIGTERM are rejected (connection refused)
    // - "Gateway exits with code 0 after graceful shutdown"
    // - "Shutdown timeout is respected"
    //   → If in-flight request takes longer than shutdown timeout → force exit
}
\`\`\`

## Implementation Requirements

1. **Build tag**: Every E2E test file must have \`//go:build e2e\` so they don't run with \`go test ./...\`
2. **Table-driven tests**: Use \`tests := []struct{ name string; ... }\` pattern with \`t.Run(tt.name, ...)\`
3. **testify assertions**: Use \`assert\` for soft assertions, \`require\` for hard assertions that should stop the test
4. **Parallel safety**: Tests within a file can use \`t.Parallel()\` where they don't share state. Rate limit tests should NOT be parallel.
5. **Test isolation**: Each test function gets a fresh \`TestGateway\` or resets state between subtests
6. **Context propagation**: All HTTP requests must use \`req.WithContext(ctx)\` with test context
7. **Timeouts**: Use \`testing.Short()\` to skip slow tests. Set reasonable timeouts (10s per request max).
8. **Error wrapping**: Use \`fmt.Errorf("...: %w", err)\` in helpers
9. **Structured logging**: Test helpers should use \`t.Logf\` for debug output
10. **Cleanup**: Use \`t.Cleanup()\` for teardown, not defer in test functions
11. **Doc comments**: All exported functions in helpers must have doc comments
12. **File length**: Keep each file under 300 lines. Split if needed.

## Running E2E Tests

The tests should be runnable with:
\`\`\`bash
# With external PostgreSQL and Redis
GATEWAY_TEST_DB_URL=postgres://... GATEWAY_TEST_REDIS_URL=redis://... go test -tags=e2e -v -timeout=5m ./tests/e2e/...

# With testcontainers (auto-start dependencies)
go test -tags=e2e -v -timeout=5m ./tests/e2e/...
\`\`\`

## Makefile Target

\`\`\`makefile
.PHONY: test-e2e
test-e2e:
	go test -tags=e2e -v -timeout=5m -count=1 ./tests/e2e/...
\`\`\`

## What NOT to Generate

- Do not generate unit tests (those are in playbook/prompts/06/test-suite-generator.md)
- Do not generate load/performance tests (those are in playbook/prompts/06/load-test.md)
- Do not generate the actual gateway code — only the E2E tests
- Do not mock Redis or PostgreSQL — E2E tests use real instances
- Do not use init() functions

Generate all files listed above with complete, compilable Go code. Use realistic test data and assertions. Every test should validate a specific behavior that matters for a production API gateway.
\`\`\`

---

## Usage

1. Ensure Phase 06 is active: \`./playbook/codeforge-phase.sh set 6\`
2. Copy the prompt above into Claude Code
3. Review generated files in \`tests/e2e/\`
4. Run: \`go test -tags=e2e -v -timeout=5m ./tests/e2e/...\`
5. Verify all tests pass against running PostgreSQL and Redis instances

## Checklist

- [ ] All files have \`//go:build e2e\` build tag
- [ ] \`TestGateway\` helper boots full gateway stack with real dependencies
- [ ] JWT helper generates valid RS256 tokens with configurable claims
- [ ] Routing tests cover proxy forwarding, header injection, timeouts
- [ ] Auth tests cover JWT, API key, RBAC, and public routes
- [ ] Rate limit tests verify per-client limits, headers, and Redis failure modes
- [ ] Circuit breaker tests cover open/half-open/closed state transitions
- [ ] Observability tests verify health checks, metrics, and correlation IDs
- [ ] Security tests cover headers, CORS, input validation, audit logging (SOC 2)
- [ ] Graceful shutdown test validates in-flight request completion
- [ ] Table-driven test pattern used consistently
- [ ] No \`init()\` functions, no global state
- [ ] All exported helpers have doc comments
- [ ] Files are under 300 lines each

## Related Prompts

- [playbook/prompts/06/test-suite-generator.md](../06/test-suite-generator.md) — Unit and integration tests
- [playbook/prompts/06/load-test.md](../06/load-test.md) — Performance and load testing
- [playbook/prompts/05/observability-setup.md](../05/observability-setup.md) — Metrics and tracing setup
- [playbook/prompts/04/auth-implementation.md](../04/auth-implementation.md) — Auth implementation being tested`,

  'playbook/prompts/06/load-test.md': `# Phase 06 Prompt: Load Testing

> Copy-paste this prompt into Claude Code to generate comprehensive load testing infrastructure for the go-api-gateway.

---

## Prompt

You are working on **go-api-gateway**, a high-performance API gateway built with Go 1.22 and Chi router. I need you to create a comprehensive load testing suite that validates the gateway can handle production traffic patterns with acceptable latency and throughput.

### Context

This API gateway is the single entry point for a microservices architecture. It must handle:
- High-throughput request routing with sub-10ms p99 added latency
- Per-client rate limiting via Redis (sliding window algorithm)
- JWT (RS256) authentication on every request
- Circuit breaker state transitions under backend failures
- Concurrent connections from hundreds of clients
- Graceful degradation under load spikes

The gateway is deployed on AWS ECS behind an ALB, with ElastiCache (Redis) for rate limiting and RDS (PostgreSQL) for configuration.

### Requirements

#### 1. k6 Load Test Scripts (\`scripts/loadtest/\`)

Create the following k6 test scripts:

**\`scripts/loadtest/config.js\`** — Shared configuration:
- Define environment-based target URLs (local, staging, production)
- Define common thresholds: p95 < 50ms, p99 < 100ms, error rate < 0.1%, request rate > 5000 rps
- Define reusable HTTP headers (Authorization Bearer JWT, API keys, Content-Type)
- Export helper functions for generating test JWTs with configurable claims and expiry
- Export helper for building authenticated requests

**\`scripts/loadtest/scenarios/baseline.js\`** — Baseline performance test:
- Ramp up from 0 to 100 VUs over 2 minutes
- Hold at 100 VUs for 5 minutes
- Ramp down over 1 minute
- Test routes: health check (\`GET /healthz\`), proxy pass-through (\`GET /api/v1/users\`, \`GET /api/v1/orders\`), authenticated routes
- Assert p95 latency < 30ms for health checks, < 100ms for proxy routes
- Track custom metrics: \`gateway_overhead_ms\` (total - backend), \`auth_validation_ms\`

**\`scripts/loadtest/scenarios/stress.js\`** — Stress test to find breaking point:
- Ramp from 0 to 500 VUs over 5 minutes, then to 1000 VUs over 5 minutes
- Hold at 1000 VUs for 10 minutes
- Ramp down over 2 minutes
- Mix of authenticated and unauthenticated requests (80/20)
- Track when error rate exceeds 1% to identify capacity ceiling
- Include \`abortOnFail\` threshold for error rate > 5%

**\`scripts/loadtest/scenarios/spike.js\`** — Spike test for sudden traffic bursts:
- Start at 50 VUs, spike to 800 VUs in 10 seconds
- Hold spike for 2 minutes
- Drop back to 50 VUs
- Repeat spike pattern 3 times
- Validate recovery time (latency returns to baseline within 30 seconds of spike end)
- Assert no 5xx errors during recovery

**\`scripts/loadtest/scenarios/rate-limit.js\`** — Rate limiter validation under load:
- 200 VUs all using the same API key (should trigger rate limits)
- 200 VUs each using unique API keys (should not trigger rate limits)
- Validate that rate-limited requests receive HTTP 429 with correct \`Retry-After\` header
- Validate that non-rate-limited requests maintain < 50ms p95
- Assert rate limiter accuracy: 429 count should be within 5% of expected based on configured limits
- Test sliding window behavior: verify limit resets correctly

**\`scripts/loadtest/scenarios/circuit-breaker.js\`** — Circuit breaker behavior under backend failures:
- Start with healthy backends, establish baseline
- Simulate backend failures (route to intentionally failing upstream)
- Validate circuit opens after configured failure threshold
- Validate requests get fast-fail (< 5ms) when circuit is open
- Validate half-open state allows probe requests through
- Validate circuit closes when backend recovers
- Track state transition timing

**\`scripts/loadtest/scenarios/soak.js\`** — Soak test for memory leaks and resource exhaustion:
- 200 VUs sustained for 2 hours
- Mixed traffic: 40% reads, 30% authenticated writes, 20% rate-limited, 10% invalid requests
- Monitor for latency degradation over time (p99 should not increase by more than 20% from first 5 minutes)
- Track iteration rate stability
- Export metrics for memory/goroutine analysis via pprof

#### 2. Go Benchmark Tests (\`internal/benchmark/\`)

**\`internal/benchmark/middleware_bench_test.go\`** — Benchmark individual middleware:
\`\`\`
BenchmarkAuthMiddleware — JWT RS256 validation throughput
BenchmarkRateLimitMiddleware — Redis-backed rate limit check
BenchmarkLoggingMiddleware — slog structured logging overhead
BenchmarkCORSMiddleware — CORS header injection
BenchmarkRecoveryMiddleware — Panic recovery overhead
BenchmarkFullMiddlewareChain — All middleware composed via Chi
\`\`\`
- Use \`testing.B\` with \`b.ReportAllocs()\` for allocation tracking
- Use \`httptest.NewRecorder\` and \`httptest.NewRequest\` for realistic HTTP context
- Include sub-benchmarks for different payload sizes (empty, 1KB, 100KB, 1MB)
- Use table-driven benchmark patterns

**\`internal/benchmark/routing_bench_test.go\`** — Benchmark Chi router performance:
- Benchmark route matching with 10, 50, 200 registered routes
- Benchmark parameterized routes (\`/api/v1/users/{id}\`)
- Benchmark wildcard routes
- Compare with and without middleware chains

**\`internal/benchmark/ratelimit_bench_test.go\`** — Benchmark rate limiter:
- Benchmark sliding window check against Redis (use miniredis for isolation)
- Benchmark concurrent rate limit checks (10, 100, 1000 goroutines)
- Benchmark with different window sizes and limits
- Track allocations per check

**\`internal/benchmark/auth_bench_test.go\`** — Benchmark authentication:
- Benchmark JWT RS256 token parsing and validation
- Benchmark JWT with different claim sizes
- Benchmark API key lookup (Redis cache hit vs PostgreSQL fallback)
- Benchmark RBAC permission check with varying policy complexity

#### 3. pprof Integration (\`internal/observability/pprof.go\`)

- Register pprof endpoints on a separate admin port (\`:6060\`)
- Only enable in non-production environments (controlled by config)
- Expose: \`/debug/pprof/\`, \`/debug/pprof/heap\`, \`/debug/pprof/goroutine\`, \`/debug/pprof/profile\`, \`/debug/pprof/trace\`
- Add middleware to protect pprof endpoints with admin API key
- Document how to capture profiles during load tests

#### 4. Load Test Runner Script (\`scripts/loadtest/run.sh\`)

Create a bash script that:
- Accepts arguments: \`--scenario\` (baseline|stress|spike|rate-limit|circuit-breaker|soak), \`--env\` (local|staging), \`--output\` (json|html)
- Validates k6 is installed, checks target is reachable
- Runs the selected k6 scenario with appropriate environment variables
- Captures output in \`scripts/loadtest/results/\` with timestamped filenames
- Generates an HTML report if \`--output html\` is specified
- Exits with non-zero code if any threshold is breached
- Supports \`--all\` flag to run baseline, stress, spike, and rate-limit in sequence
- Prints summary table at the end

#### 5. CI Integration (\`scripts/loadtest/ci-loadtest.sh\`)

Create a CI-focused script that:
- Runs baseline scenario against a local Docker Compose environment
- Uses reduced VU counts suitable for CI runners (10 VUs, 30 second duration)
- Asserts core thresholds: p95 < 100ms, error rate < 1%
- Outputs results in JSON for GitHub Actions artifact upload
- Can be called from \`.github/workflows/\` as a post-deploy verification step

#### 6. Docker Compose for Load Test Environment (\`scripts/loadtest/docker-compose.yml\`)

- Gateway service built from project Dockerfile
- Redis service (for rate limiting)
- PostgreSQL service (with seed data for config)
- Mock upstream services (simple Go HTTP servers returning configurable responses with configurable latency)
- Prometheus for metrics collection during tests
- Grafana with pre-configured dashboard for load test visualization
- k6 service that can run tests against the gateway
- Network configuration to simulate realistic latency between services

#### 7. Grafana Dashboard (\`scripts/loadtest/grafana/dashboards/load-test.json\`)

Create a Grafana dashboard JSON with panels for:
- Request rate (rps) over time
- Latency percentiles (p50, p95, p99) over time
- Error rate by status code
- Rate limiter: accepted vs rejected requests
- Circuit breaker state transitions
- Go runtime: goroutines, heap size, GC pause duration
- Redis: command latency, connection pool usage
- Upstream: response time by backend service

### Constraints

- All Go code must pass \`golangci-lint run\` with the project's linter config (govet, errcheck, staticcheck, gosec, revive, gocyclo)
- All exported functions must have doc comments per project convention
- Use \`context.Context\` propagation in all benchmark helpers
- Use table-driven patterns for benchmarks
- k6 scripts must use ES6 modules syntax
- File names must use snake_case
- Max 300 lines per file — split into multiple files if needed
- No \`init()\` functions
- Errors must be wrapped with \`fmt.Errorf\` and \`%w\`
- Use \`slog\` for any logging in Go test helpers
- Follow Clean Architecture: any test helpers that touch Redis/PostgreSQL go through repository interfaces

### Output Structure

\`\`\`
scripts/loadtest/
  config.js
  run.sh
  ci-loadtest.sh
  docker-compose.yml
  scenarios/
    baseline.js
    stress.js
    spike.js
    rate_limit.js
    circuit_breaker.js
    soak.js
  results/
    .gitkeep
  grafana/
    dashboards/
      load-test.json
    provisioning/
      dashboards.yml
      datasources.yml
internal/
  benchmark/
    middleware_bench_test.go
    routing_bench_test.go
    ratelimit_bench_test.go
    auth_bench_test.go
    doc.go
  observability/
    pprof.go
\`\`\`

### Acceptance Criteria

- [ ] \`k6 run scripts/loadtest/scenarios/baseline.js\` completes with all thresholds passing against local Docker Compose
- [ ] \`go test -bench=. -benchmem ./internal/benchmark/...\` runs all benchmarks with zero test failures
- [ ] \`scripts/loadtest/run.sh --scenario baseline --env local\` executes end-to-end and produces results file
- [ ] \`scripts/loadtest/ci-loadtest.sh\` exits 0 when gateway meets performance SLOs
- [ ] \`docker compose -f scripts/loadtest/docker-compose.yml up\` starts full load test environment
- [ ] Grafana dashboard loads and displays real-time metrics during load test
- [ ] pprof endpoints are accessible on \`:6060\` in development mode and blocked in production
- [ ] All Go benchmark files pass \`golangci-lint run\`
- [ ] Benchmark results show < 1KB allocation per middleware chain invocation
- [ ] Rate limit load test confirms 429 responses within 5% accuracy of configured limits

### SOC 2 Considerations

- Load test scripts must not contain real credentials — use generated test JWTs and dummy API keys
- Production load testing requires change management approval (document in runbook)
- Load test results should be retained for audit trail (store in \`results/\` with timestamps)
- pprof must be disabled in production to prevent information disclosure
- Mock upstream services must not connect to real downstream services

### Performance Baselines to Validate

| Metric | Target | Critical |
|--------|--------|----------|
| Health check p99 | < 5ms | < 20ms |
| Authenticated proxy p95 | < 50ms | < 100ms |
| Authenticated proxy p99 | < 100ms | < 200ms |
| Rate limit check overhead | < 2ms | < 5ms |
| JWT validation overhead | < 1ms | < 3ms |
| Circuit breaker fast-fail | < 1ms | < 5ms |
| Throughput (baseline) | > 5,000 rps | > 2,000 rps |
| Throughput (stress) | > 10,000 rps | > 5,000 rps |
| Error rate (normal) | < 0.1% | < 1% |
| Memory growth (soak 2hr) | < 20% | < 50% |

After generating all files, run \`go test -bench=. -benchmem -count=3 ./internal/benchmark/...\` and \`golangci-lint run ./internal/...\` to verify everything compiles and passes linting. Summarize the benchmark results and flag any allocations that seem excessive for a hot-path API gateway.`,

  'playbook/prompts/06/test-suite-generator.md': `# Test Suite Generator — Phase 06: Testing & Quality

> **Copy-paste this prompt into Claude Code to generate comprehensive test suites for go-api-gateway components.**

---

## Prompt

\`\`\`
You are a senior Go engineer generating a comprehensive test suite for the go-api-gateway project. This is a high-performance API gateway built with Go 1.22 and Chi v5, following Clean Architecture (handler → service → repository).

## Project Context

- **Architecture**: Clean Architecture with strict layer separation
- **Router**: Chi v5 with composable middleware chains
- **Auth**: JWT (RS256), API keys, RBAC
- **Data stores**: PostgreSQL (config, API key metadata), Redis (rate limiting, caching)
- **Observability**: OpenTelemetry traces, Prometheus metrics, slog structured logging
- **Compliance**: SOC 2 — audit logging and security tests are mandatory
- **Coverage threshold**: 80% minimum, measured by \`go test -coverprofile\`

## Test Taxonomy

Generate tests across ALL of these categories:

### 1. Unit Tests (per-package, isolated, fast)

Place unit tests alongside source files (\`*_test.go\` in the same package).

**internal/middleware/ tests:**
- \`auth_middleware_test.go\` — valid JWT passes, expired JWT returns 401, malformed token returns 401, missing Authorization header returns 401, wrong signing algorithm returns 401, RBAC role enforcement (admin vs reader), API key fallback when JWT absent, context propagation of claims
- \`ratelimit_middleware_test.go\` — request under limit passes, request at limit returns 429, rate limit headers (X-RateLimit-Limit, X-RateLimit-Remaining, X-RateLimit-Reset) are set, per-client keying by API key and IP, Redis unavailable falls open (fail-open policy), sliding window correctness
- \`logging_middleware_test.go\` — request ID injected into context, slog fields include method/path/status/duration/trace_id, sensitive headers (Authorization, Cookie) are redacted
- \`recovery_middleware_test.go\` — panic returns 500 JSON response, panic is logged with stack trace, metrics counter incremented
- \`cors_middleware_test.go\` — preflight OPTIONS returns correct headers, disallowed origin is rejected, credentials flag set correctly

**internal/auth/ tests:**
- \`jwt_validator_test.go\` — RS256 signature verification, token expiry, audience/issuer claims, key rotation (multiple valid keys), clock skew tolerance
- \`apikey_verifier_test.go\` — valid key returns client metadata, revoked key returns error, expired key returns error, key hash comparison (constant-time)
- \`rbac_test.go\` — role hierarchy enforcement, permission matrix (table-driven), unknown role denied by default

**internal/service/ tests:**
- \`routing_service_test.go\` — route matching by path prefix, host-based routing, header-based routing, fallback to default upstream, upstream health check integration
- \`transform_service_test.go\` — request header injection, response header stripping, body transformation (JSON field mapping), content-type negotiation

**internal/circuit/ tests:**
- \`breaker_test.go\` — closed state passes requests, failure threshold triggers open, open state returns fast-fail error, half-open allows probe request, successful probe closes circuit, concurrent access safety, per-upstream isolation, state transition callbacks

**internal/ratelimit/ tests:**
- \`sliding_window_test.go\` — window boundary correctness, counter increment and expiry, Redis script atomicity, multiple clients isolated

**internal/repository/ tests:**
- \`route_repository_test.go\` — CRUD operations with sqlmock, query parameter binding, error wrapping with %w
- \`apikey_repository_test.go\` — lookup by hash, soft delete, last_used_at update

**pkg/errors/ tests:**
- \`errors_test.go\` — error code mapping, HTTP status derivation, error wrapping preserves chain, Is/As compatibility

**pkg/httputil/ tests:**
- \`response_test.go\` — JSON response formatting, error response structure, pagination headers

### 2. Integration Tests (tests/ directory, build tag \`integration\`)

Place in \`tests/integration/\` with \`//go:build integration\` tag.

- \`auth_flow_test.go\` — full JWT acquisition → authenticated request → authorized resource access
- \`ratelimit_integration_test.go\` — real Redis sliding window with multiple goroutines, verify atomic counter behavior
- \`routing_integration_test.go\` — spin up httptest upstream servers, verify gateway routes to correct backend, verify circuit breaker trips on upstream failure
- \`repository_integration_test.go\` — real PostgreSQL via testcontainers-go, run migrations, verify CRUD
- \`middleware_chain_test.go\` — full Chi middleware stack (recovery → logging → cors → auth → ratelimit → handler), verify ordering and context propagation
- \`health_check_test.go\` — /healthz returns 200 when deps healthy, returns 503 when Redis down, returns 503 when PostgreSQL down
- \`graceful_shutdown_test.go\` — in-flight requests complete before shutdown, new requests rejected after shutdown signal

### 3. Benchmark Tests

Place alongside unit tests with \`Benchmark\` prefix.

- \`BenchmarkJWTValidation\` — RS256 token validation throughput
- \`BenchmarkRateLimitCheck\` — sliding window check with mock Redis
- \`BenchmarkRouteMatching\` — Chi router dispatch with 50/100/500 routes
- \`BenchmarkMiddlewareChain\` — full middleware stack overhead per request
- \`BenchmarkCircuitBreakerCheck\` — state check under concurrent load
- \`BenchmarkJSONResponse\` — response serialization for typical payloads

### 4. Fuzz Tests (Go 1.22 native fuzzing)

- \`FuzzJWTParser\` — malformed token inputs
- \`FuzzRouteMatching\` — random path inputs against route table
- \`FuzzRequestTransform\` — malformed JSON body transformation
- \`FuzzAPIKeyParsing\` — random Authorization header values

## Test Patterns — MANDATORY

### Table-Driven Tests
Every test function MUST use table-driven pattern:

\`\`\`go
func TestJWTValidator_Validate(t *testing.T) {
    tests := []struct {
        name      string
        token     string
        wantErr   bool
        errCode   string
        wantClaim string
    }{
        {
            name:      "valid token with admin role",
            token:     generateTestJWT(t, "admin", time.Hour),
            wantErr:   false,
            wantClaim: "admin",
        },
        {
            name:    "expired token",
            token:   generateTestJWT(t, "admin", -time.Hour),
            wantErr: true,
            errCode: "TOKEN_EXPIRED",
        },
        // ... more cases
    }

    for _, tt := range tests {
        t.Run(tt.name, func(t *testing.T) {
            // arrange, act, assert
        })
    }
}
\`\`\`

### Interface Mocks (no mocking frameworks — use manual mocks)
\`\`\`go
// internal/auth/mock_test.go
type mockKeyStore struct {
    keys map[string]*rsa.PublicKey
    err  error
}

func (m *mockKeyStore) GetPublicKey(ctx context.Context, kid string) (*rsa.PublicKey, error) {
    if m.err != nil {
        return nil, m.err
    }
    key, ok := m.keys[kid]
    if !ok {
        return nil, fmt.Errorf("key %s not found: %w", kid, auth.ErrKeyNotFound)
    }
    return key, nil
}
\`\`\`

### HTTP Handler Tests with httptest
\`\`\`go
func TestRouteHandler_ListRoutes(t *testing.T) {
    svc := &mockRoutingService{
        routes: []model.Route{{ID: "r1", Path: "/api/v1/users", Upstream: "http://users:8080"}},
    }
    h := handler.NewRouteHandler(svc, slog.Default())

    r := chi.NewRouter()
    r.Get("/admin/routes", h.ListRoutes)

    req := httptest.NewRequest(http.MethodGet, "/admin/routes", nil)
    req = req.WithContext(auth.WithClaims(req.Context(), validAdminClaims))
    rec := httptest.NewRecorder()

    r.ServeHTTP(rec, req)

    assert.Equal(t, http.StatusOK, rec.Code)
    // ... assert response body
}
\`\`\`

### Context Propagation Verification
Every handler test MUST verify:
- \`context.Context\` is passed through all layers
- Trace ID from OpenTelemetry is present in context
- Request-scoped values (claims, request ID, client ID) survive middleware chain

### Error Wrapping Verification
\`\`\`go
assert.ErrorIs(t, err, repository.ErrNotFound)
assert.ErrorAs(t, err, &apiErr)
assert.Equal(t, "ROUTE_NOT_FOUND", apiErr.Code)
\`\`\`

## Test Helpers — Generate These

### \`internal/testutil/jwt.go\`
- \`GenerateTestKeyPair(t *testing.T) (*rsa.PrivateKey, *rsa.PublicKey)\` — deterministic test RSA key pair
- \`GenerateTestJWT(t *testing.T, claims map[string]interface{}, key *rsa.PrivateKey, opts ...JWTOption) string\`
- \`ExpiredJWT(t *testing.T) string\`
- \`MalformedJWT() string\`
- \`JWTWithRole(t *testing.T, role string) string\`

### \`internal/testutil/redis.go\`
- \`SetupTestRedis(t *testing.T) *redis.Client\` — connect to test Redis or skip
- \`FlushTestRedis(t *testing.T, client *redis.Client)\`
- \`MockRedisClient\` — in-memory mock implementing redis commands used by rate limiter

### \`internal/testutil/postgres.go\`
- \`SetupTestDB(t *testing.T) *sql.DB\` — testcontainers-go PostgreSQL or skip
- \`RunMigrations(t *testing.T, db *sql.DB)\`
- \`SeedTestData(t *testing.T, db *sql.DB, fixtures ...Fixture)\`
- \`TruncateTables(t *testing.T, db *sql.DB, tables ...string)\`

### \`internal/testutil/http.go\`
- \`NewTestRouter(t *testing.T, opts ...RouterOption) chi.Router\` — pre-configured Chi router with test middleware
- \`AuthenticatedRequest(t *testing.T, method, path string, body io.Reader, role string) *http.Request\`
- \`AssertJSONResponse(t *testing.T, rec *httptest.ResponseRecorder, status int, bodyContains map[string]interface{})\`
- \`NewUpstreamServer(t *testing.T, handler http.HandlerFunc) *httptest.Server\` — mock upstream for routing tests

### \`internal/testutil/fixtures.go\`
- \`TestRoute() model.Route\`
- \`TestAPIKey() model.APIKey\`
- \`TestClientConfig() model.ClientConfig\`
- \`TestRateLimitConfig() model.RateLimitConfig\`

## Security-Specific Tests (SOC 2)

Generate a dedicated \`tests/security/\` directory with \`//go:build security\` tag:

- \`auth_bypass_test.go\` — attempt access without token, with forged token, with token signed by wrong key, with token for different audience, with revoked API key
- \`injection_test.go\` — SQL injection via route path parameters, header injection via X-Forwarded-For, log injection via crafted User-Agent
- \`rate_limit_bypass_test.go\` — attempt bypass via X-Forwarded-For spoofing, attempt bypass via multiple API keys, verify rate limit applies after auth failure
- \`sensitive_data_test.go\` — verify Authorization header not logged, verify API key not in response body, verify PII not in trace spans, verify error messages don't leak internal details
- \`tls_test.go\` — verify TLS 1.2 minimum, verify strong cipher suites, verify HSTS header present
- \`audit_log_test.go\` — verify auth failures logged with client IP, verify admin actions logged, verify log entries include correlation ID

## Output Requirements

For the component I specify, generate:

1. **Complete test file(s)** — compilable Go code, proper package declaration, all imports
2. **Test helper files** if needed by the tests
3. **Mock implementations** for interfaces the component depends on
4. **Makefile targets** for running the specific test category:
   \`\`\`makefile
   test-unit:
   	go test -v -race -count=1 -coverprofile=coverage.out ./internal/...
   
   test-integration:
   	go test -v -race -tags=integration -count=1 ./tests/integration/...
   
   test-security:
   	go test -v -race -tags=security -count=1 ./tests/security/...
   
   test-bench:
   	go test -bench=. -benchmem -count=3 ./internal/...
   
   test-fuzz:
   	go test -fuzz=Fuzz -fuzztime=30s ./internal/auth/...
   
   test-coverage:
   	go test -race -coverprofile=coverage.out ./...
   	go tool cover -func=coverage.out
   	@echo "Checking coverage threshold..."
   	@go tool cover -func=coverage.out | grep total | awk '{print $$3}' | sed 's/%//' | \\
   		awk '{if ($$1 < 80) {print "FAIL: coverage " $$1 "% < 80%"; exit 1} else {print "PASS: coverage " $$1 "%"}}'
   \`\`\`

## Constraints

- Use \`testing\` stdlib + \`github.com/stretchr/testify/assert\` + \`github.com/stretchr/testify/require\` only
- NO testify suites — use table-driven tests with subtests
- NO gomock or mockgen — use hand-written interface mocks
- NO init() functions in test files
- All test functions must call \`t.Helper()\` in helper functions
- All test functions must call \`t.Parallel()\` where safe (no shared mutable state)
- Use \`t.Cleanup()\` for teardown, not defer in test functions
- Errors must be checked with \`require.NoError\` for fatal, \`assert.NoError\` for non-fatal
- Context timeout of 5s on all integration tests: \`ctx, cancel := context.WithTimeout(context.Background(), 5*time.Second)\`
- File names: \`<source_file>_test.go\` for unit tests, \`<feature>_test.go\` for integration tests

## What to Generate

Generate the test suite for: [SPECIFY COMPONENT]

Options:
- \`middleware/auth\` — auth middleware unit tests + mocks
- \`middleware/ratelimit\` — rate limit middleware unit tests + Redis mock
- \`middleware/all\` — all middleware tests
- \`auth/jwt\` — JWT validator unit tests + test key helpers
- \`auth/apikey\` — API key verifier unit tests
- \`auth/rbac\` — RBAC unit tests with permission matrix
- \`service/routing\` — routing service unit tests + mock upstream
- \`service/transform\` — transform service unit tests
- \`circuit\` — circuit breaker unit tests + benchmarks + fuzz
- \`repository/routes\` — route repository tests with sqlmock
- \`repository/apikeys\` — API key repository tests with sqlmock
- \`handlers\` — all HTTP handler tests
- \`integration/auth\` — auth integration flow tests
- \`integration/routing\` — routing integration with httptest upstreams
- \`integration/ratelimit\` — rate limit integration with real Redis
- \`security\` — full SOC 2 security test suite
- \`benchmarks\` — all benchmark tests
- \`fuzz\` — all fuzz tests
- \`helpers\` — all test utility packages (testutil/*)
- \`all\` — everything

Replace [SPECIFY COMPONENT] above with your choice, then paste this entire prompt into Claude Code.
\`\`\`

---

## Usage

1. Copy the entire prompt above
2. Replace \`[SPECIFY COMPONENT]\` at the bottom with the component you want tests for (e.g., \`middleware/auth\`)
3. Paste into Claude Code
4. Review generated tests for correctness and completeness
5. Run \`go test -v -race ./internal/...\` to verify compilation
6. Check coverage with \`go test -coverprofile=coverage.out ./... && go tool cover -func=coverage.out\`

## Phase 06 Completion Criteria

| Metric | Target | Command |
|--------|--------|---------|
| Unit test coverage | ≥ 80% | \`go test -coverprofile=coverage.out ./internal/... && go tool cover -func=coverage.out\` |
| Race conditions | 0 | \`go test -race ./...\` |
| Integration tests pass | All green | \`go test -tags=integration ./tests/integration/...\` |
| Security tests pass | All green | \`go test -tags=security ./tests/security/...\` |
| Benchmarks baselined | Recorded | \`go test -bench=. -benchmem ./internal/... > benchmarks.txt\` |
| Fuzz tests | No crashes in 60s | \`go test -fuzz=Fuzz -fuzztime=60s ./internal/auth/...\` |
| golangci-lint | 0 issues in test files | \`golangci-lint run --tests ./...\` |

## Related Prompts

- [playbook/prompts/04/feature-implementation.md](../04/feature-implementation.md) — implementation patterns these tests validate
- [playbook/prompts/04/auth-implementation.md](../04/auth-implementation.md) — auth implementation under test
- [playbook/prompts/05/security-hardening.md](../05/security-hardening.md) — security controls validated by security tests
- [playbook/prompts/03/ci-pipeline.md](../03/ci-pipeline.md) — CI pipeline that runs these tests`,

  'playbook/prompts/07/go-live-checklist.md': `# Go-Live Checklist — Phase 07 Launch

> **Copy-paste this prompt into Claude Code when preparing the go-api-gateway for production launch.**

---

You are helping launch **go-api-gateway** — a high-performance API gateway built with Go 1.22 and Chi v5 on AWS (ECS, ALB, ElastiCache, RDS). This is a SOC 2 compliant service that handles JWT authentication, rate limiting, circuit breaking, and request routing for a microservices architecture.

## Context Files to Read First

Read these files to understand the current state of the project:

\`\`\`
playbook/current-phase.json
playbook/phases/07-launch.md
playbook/phases/06-testing-quality.md
docs/architecture.md (if exists)
docs/runbooks/ (if exists)
configs/production.yaml (if exists)
deployments/ (all Kubernetes manifests, Helm values, Dockerfiles)
.github/workflows/ (all CI/CD pipelines)
internal/config/config.go
internal/observability/
\`\`\`

## Task: Generate a Comprehensive Go-Live Checklist

Produce a detailed, actionable go-live checklist at \`docs/go-live-checklist.md\`. This is not a generic checklist — it must be specific to this Go API gateway, its infrastructure, and its SOC 2 compliance requirements.

### 1. Build & Binary Verification

- [ ] \`go build -o bin/gateway cmd/gateway/main.go\` succeeds with zero warnings
- [ ] \`golangci-lint run ./...\` passes (govet, errcheck, staticcheck, gosec, revive, gocyclo — all clean)
- [ ] \`go vet ./...\` reports no issues
- [ ] \`go test -race ./...\` passes with no data races detected
- [ ] Test coverage meets or exceeds 80% threshold: \`go test -coverprofile=coverage.out ./... && go tool cover -func=coverage.out\`
- [ ] Binary is statically compiled for linux/amd64: \`CGO_ENABLED=0 GOOS=linux GOARCH=amd64 go build -ldflags="-s -w" -o bin/gateway cmd/gateway/main.go\`
- [ ] Build version and commit SHA are embedded via \`-ldflags\`: verify with \`./bin/gateway --version\`
- [ ] \`go mod tidy\` produces no diff — all dependencies are clean
- [ ] \`go mod verify\` confirms no tampered dependencies
- [ ] No \`replace\` directives remain in \`go.mod\` for production

### 2. Docker & Container

- [ ] Docker image builds successfully: \`docker build -t go-api-gateway:latest -f deployments/Dockerfile .\`
- [ ] Image uses distroless or scratch base (no shell, minimal attack surface)
- [ ] Image runs as non-root user (verify \`USER\` directive in Dockerfile)
- [ ] Image size is under 30MB (Go static binary + distroless)
- [ ] Container starts and responds to health check: \`curl http://localhost:8080/healthz\`
- [ ] Readiness probe endpoint works: \`curl http://localhost:8080/readyz\`
- [ ] Container respects \`SIGTERM\` for graceful shutdown (verify with \`docker stop\` — connections drain)
- [ ] No secrets baked into the image — verify with \`docker history\` and \`docker inspect\`
- [ ] Image is scanned for CVEs: \`trivy image go-api-gateway:latest\` (zero critical/high)
- [ ] Image is tagged with commit SHA and semantic version, not just \`latest\`
- [ ] ECR repository exists and image is pushed: \`aws ecr describe-images --repository-name go-api-gateway\`

### 3. Configuration & Secrets

- [ ] Production config file \`configs/production.yaml\` is reviewed and correct
- [ ] All environment variables are documented in \`docs/configuration.md\`
- [ ] Secrets are stored in AWS Secrets Manager or SSM Parameter Store — not in config files, env vars in task definitions, or image
- [ ] JWT RS256 public key is loaded from Secrets Manager, not filesystem
- [ ] Database connection string uses IAM authentication or Secrets Manager rotation
- [ ] Redis AUTH password is sourced from Secrets Manager
- [ ] TLS certificates are managed by ACM (not self-signed)
- [ ] No \`.env\` files, \`*.pem\` files, or hardcoded credentials in the repository: \`git log --all -p -- '*.pem' '.env*'\` returns nothing
- [ ] Viper config precedence is correct: env vars override YAML, YAML overrides defaults
- [ ] \`LOG_LEVEL\` is set to \`info\` (not \`debug\`) for production
- [ ] \`GIN_MODE\` / equivalent Chi production mode is configured (no debug middleware)
- [ ] Rate limit thresholds are set to production values (not development defaults)
- [ ] Circuit breaker thresholds are tuned based on load test results

### 4. Database & Data Store Readiness

#### PostgreSQL (RDS)

- [ ] RDS instance is provisioned in production VPC with Multi-AZ enabled
- [ ] Database migrations are applied and verified: \`scripts/migrate.sh up\`
- [ ] Migration rollback is tested: \`scripts/migrate.sh down 1\` then \`scripts/migrate.sh up\`
- [ ] Connection pooling is configured (max open: 25, max idle: 10, max lifetime: 5m) — verify in \`internal/repository/postgres.go\`
- [ ] Read replicas are configured if needed for config lookups
- [ ] Automated backups are enabled (7-day retention minimum for SOC 2)
- [ ] Point-in-time recovery is enabled
- [ ] Database user has least-privilege permissions (no superuser)
- [ ] \`pg_stat_statements\` extension is enabled for query monitoring
- [ ] Slow query logging is enabled (threshold: 100ms)

#### Redis (ElastiCache)

- [ ] ElastiCache Redis cluster is provisioned with encryption at rest and in transit
- [ ] Redis AUTH is enabled
- [ ] Cluster mode is appropriate for rate limiting workload
- [ ] Eviction policy is set to \`volatile-lru\` or \`allkeys-lru\`
- [ ] \`maxmemory\` is configured with headroom for burst traffic
- [ ] Connection pool settings in \`internal/repository/redis.go\` match production needs (pool size, timeouts)
- [ ] Redis Sentinel or Cluster failover is tested
- [ ] Rate limit keys use appropriate TTLs (sliding window counters expire)

### 5. Networking & Security

- [ ] ALB is provisioned with HTTPS listener (TLS 1.2+ only)
- [ ] HTTP → HTTPS redirect is configured on ALB
- [ ] Security groups restrict inbound traffic: ALB accepts 443 only from allowed CIDRs, ECS tasks accept traffic only from ALB
- [ ] VPC subnets: ALB in public subnets, ECS tasks in private subnets, RDS/ElastiCache in isolated subnets
- [ ] NAT Gateway is configured for outbound traffic from private subnets
- [ ] WAF is attached to ALB with OWASP API Security Top 10 rules
- [ ] DDoS protection via AWS Shield Standard (or Advanced if required)
- [ ] CORS middleware in \`internal/middleware/cors.go\` is configured with production allowed origins (not \`*\`)
- [ ] Request body size limits are enforced (e.g., 1MB max)
- [ ] Timeout middleware is configured: read timeout 5s, write timeout 10s, idle timeout 120s
- [ ] \`X-Request-ID\` header is generated and propagated for all requests
- [ ] Security headers middleware sets: \`X-Content-Type-Options: nosniff\`, \`X-Frame-Options: DENY\`, \`Strict-Transport-Security\`
- [ ] API key rotation procedure is documented and tested
- [ ] JWT token expiry is set to appropriate duration (e.g., 15 minutes for access tokens)
- [ ] RBAC policies are loaded and verified for all protected routes

### 6. Observability & Monitoring

#### OpenTelemetry / Tracing

- [ ] OpenTelemetry SDK is initialized in \`internal/observability/tracing.go\`
- [ ] OTLP exporter is configured to send traces to production collector (Jaeger or AWS X-Ray)
- [ ] Trace sampling rate is set for production (e.g., 10% or adaptive sampling — not 100%)
- [ ] Spans include: handler name, HTTP method, status code, route pattern, upstream service
- [ ] Context propagation works end-to-end (W3C Trace Context headers)
- [ ] Trace IDs appear in structured logs for correlation

#### Prometheus Metrics

- [ ] Prometheus metrics endpoint is exposed: \`GET /metrics\` (on a separate port or behind auth)
- [ ] Key metrics are registered:
  - \`gateway_requests_total\` (counter, labels: method, route, status)
  - \`gateway_request_duration_seconds\` (histogram, labels: method, route)
  - \`gateway_active_connections\` (gauge)
  - \`gateway_rate_limit_hits_total\` (counter, labels: client_id)
  - \`gateway_circuit_breaker_state\` (gauge, labels: upstream, state)
  - \`gateway_upstream_request_duration_seconds\` (histogram, labels: upstream)
  - \`gateway_auth_failures_total\` (counter, labels: reason)
- [ ] Prometheus scrape target is configured in monitoring stack
- [ ] Grafana dashboards are created for gateway overview, latency, error rates, rate limiting, circuit breaker states
- [ ] Metric cardinality is bounded (no unbounded label values like user IDs or request paths)

#### Structured Logging (slog)

- [ ] slog is configured with JSON output in production: \`internal/observability/logging.go\`
- [ ] Log level is \`INFO\` for production (configurable via env var)
- [ ] Request logs include: method, path, status, duration, request_id, client_ip, user_agent
- [ ] Sensitive data is NOT logged: Authorization headers, API keys, request bodies with PII
- [ ] Logs are shipped to CloudWatch Logs via ECS log driver
- [ ] Log retention policy is set (90 days minimum for SOC 2)
- [ ] Error logs include stack traces via \`slog.Error\` with error attributes

#### Alerting

- [ ] Alert: Error rate > 5% for 5 minutes → PagerDuty/Slack
- [ ] Alert: P99 latency > 500ms for 10 minutes → Slack
- [ ] Alert: Circuit breaker OPEN for any upstream → PagerDuty
- [ ] Alert: Rate limit exhaustion > 50% of clients → Slack
- [ ] Alert: Health check failures → PagerDuty
- [ ] Alert: Redis connection failures → PagerDuty
- [ ] Alert: PostgreSQL connection pool exhaustion → PagerDuty
- [ ] Alert: CPU > 80% sustained for 10 minutes → Slack
- [ ] Alert: Memory > 80% sustained for 10 minutes → Slack
- [ ] Alert: ECS task restart count > 3 in 15 minutes → PagerDuty
- [ ] All alerts have documented runbooks in \`docs/runbooks/\`

### 7. Performance Validation

- [ ] Load test results from Phase 06 are reviewed (see \`playbook/prompts/06/load-test.md\`)
- [ ] P50 latency < 10ms for passthrough requests (no auth, no rate limit)
- [ ] P99 latency < 100ms for authenticated + rate-limited requests
- [ ] Gateway handles target RPS (document: _____ RPS) with < 1% error rate
- [ ] Memory profile is stable under load (no leaks): \`go tool pprof http://localhost:6060/debug/pprof/heap\`
- [ ] Goroutine count is stable under load (no goroutine leaks): \`go tool pprof http://localhost:6060/debug/pprof/goroutine\`
- [ ] Connection pooling to PostgreSQL and Redis is efficient under load
- [ ] Graceful shutdown drains in-flight requests within 30 seconds
- [ ] Auto-scaling policy is configured: scale out at 70% CPU, scale in at 30% CPU
- [ ] pprof endpoints are disabled or auth-protected in production

### 8. Deployment & Infrastructure

- [ ] Terraform state is in S3 with DynamoDB locking
- [ ] Terraform plan for production shows no unexpected changes: \`terraform plan -var-file=production.tfvars\`
- [ ] ECS service is configured with:
  - Desired count: minimum 2 tasks (for availability)
  - Health check grace period: 60 seconds
  - Deployment circuit breaker enabled
  - Rolling update: min healthy 100%, max 200%
- [ ] ECS task definition specifies CPU/memory limits matching load test findings
- [ ] ALB target group health check: path \`/healthz\`, interval 15s, healthy threshold 2, unhealthy threshold 3
- [ ] Blue/green or rolling deployment strategy is configured and tested
- [ ] Rollback procedure is documented and tested: \`docs/runbooks/rollback.md\`
- [ ] DNS is configured (Route 53 or external) pointing to ALB
- [ ] SSL certificate is valid and auto-renewing via ACM

### 9. CI/CD Pipeline Verification

- [ ] GitHub Actions workflow \`.github/workflows/ci.yml\` runs all stages:
  1. Lint (\`golangci-lint run\`)
  2. Vet (\`go vet ./...\`)
  3. Unit Tests (\`go test -short ./...\`)
  4. Integration Tests (\`go test -tags=integration ./tests/...\`)
  5. Race Detection (\`go test -race ./...\`)
  6. Build Binary
  7. Build Docker Image
  8. Push to ECR
  9. Deploy to Staging (auto)
  10. Deploy to Production (manual approval)
- [ ] CODEOWNERS file is configured: \`internal/auth/**\` and \`configs/production/**\` require lead approval
- [ ] Branch protection on \`main\`: require PR, 1 approval, status checks passing, no force push
- [ ] AI-generated code is flagged in PRs (per CI/CD policy)
- [ ] Staging deployment is verified before production promotion
- [ ] Production deployment requires manual approval gate

### 10. SOC 2 Compliance

- [ ] All access to production infrastructure requires MFA
- [ ] IAM roles follow least-privilege principle (ECS task role, CI/CD role)
- [ ] Audit logging is enabled: CloudTrail for AWS API calls, gateway access logs
- [ ] Data encryption at rest: RDS (AES-256), ElastiCache (AES-256), S3 (SSE-S3)
- [ ] Data encryption in transit: TLS 1.2+ everywhere (ALB, RDS, ElastiCache, upstream services)
- [ ] Secrets rotation is automated (RDS password, Redis AUTH, JWT signing keys)
- [ ] Vulnerability scanning is automated in CI (gosec, trivy)
- [ ] Incident response plan is documented: \`docs/runbooks/incident-response.md\`
- [ ] Change management: all production changes go through PR review
- [ ] Access reviews: document who has production access and review quarterly
- [ ] Backup and recovery procedures are documented and tested
- [ ] Log retention meets compliance requirements (90+ days)
- [ ] API rate limiting protects against abuse (per-client limits documented)

### 11. Documentation

- [ ] \`README.md\` is up to date with build, run, and deploy instructions
- [ ] \`docs/architecture.md\` reflects the final architecture
- [ ] \`docs/configuration.md\` lists all config options and environment variables
- [ ] \`docs/api.md\` or OpenAPI spec documents all gateway endpoints
- [ ] \`docs/runbooks/\` contains:
  - \`rollback.md\` — how to roll back a bad deployment
  - \`incident-response.md\` — escalation paths and procedures
  - \`scaling.md\` — how to manually scale and when auto-scaling triggers
  - \`database-recovery.md\` — RDS restore procedures
  - \`redis-failover.md\` — ElastiCache failover procedures
  - \`circuit-breaker-reset.md\` — how to manually reset circuit breakers
  - \`rate-limit-override.md\` — how to adjust rate limits for specific clients
  - \`certificate-renewal.md\` — TLS cert management
- [ ] ADRs (Architecture Decision Records) are current in \`docs/adr/\`
- [ ] On-call rotation is established and documented

### 12. Smoke Tests (Post-Deploy)

After deploying to production, run these smoke tests:

\`\`\`bash
GATEWAY_URL="https://api.yourdomain.com"

# 1. Health check
curl -sf "\${GATEWAY_URL}/healthz" | jq .
# Expected: {"status":"healthy","version":"...","uptime":"..."}

# 2. Readiness check
curl -sf "\${GATEWAY_URL}/readyz" | jq .
# Expected: {"status":"ready","postgres":"ok","redis":"ok"}

# 3. Unauthenticated request returns 401
curl -s -o /dev/null -w "%{http_code}" "\${GATEWAY_URL}/api/v1/protected"
# Expected: 401

# 4. Authenticated request succeeds
curl -sf -H "Authorization: Bearer \${JWT_TOKEN}" "\${GATEWAY_URL}/api/v1/protected" | jq .
# Expected: 200 with response body

# 5. Rate limiting works (burst requests)
for i in $(seq 1 110); do
  curl -s -o /dev/null -w "%{http_code}\\n" -H "Authorization: Bearer \${JWT_TOKEN}" "\${GATEWAY_URL}/api/v1/protected"
done | sort | uniq -c
# Expected: mix of 200s and 429s (rate limit exceeded)

# 6. Invalid JWT returns 401
curl -s -o /dev/null -w "%{http_code}" -H "Authorization: Bearer invalid.token.here" "\${GATEWAY_URL}/api/v1/protected"
# Expected: 401

# 7. Metrics endpoint (if exposed)
curl -sf "\${GATEWAY_URL}:9090/metrics" | grep gateway_requests_total
# Expected: Prometheus metrics output

# 8. Request ID propagation
curl -sf -D - "\${GATEWAY_URL}/healthz" 2>&1 | grep -i x-request-id
# Expected: X-Request-Id header present

# 9. CORS preflight
curl -sf -X OPTIONS -H "Origin: https://app.yourdomain.com" -H "Access-Control-Request-Method: GET" -D - "\${GATEWAY_URL}/api/v1/protected" 2>&1 | grep -i access-control
# Expected: Access-Control-Allow-Origin header present

# 10. Upstream routing (verify a known route reaches the correct backend)
curl -sf -H "Authorization: Bearer \${JWT_TOKEN}" "\${GATEWAY_URL}/api/v1/users/me" | jq .
# Expected: Response from user service via gateway
\`\`\`

### 13. Go-Live Sign-Off

| Role | Name | Sign-Off | Date |
|------|------|----------|------|
| Tech Lead | | ☐ | |
| Backend Engineer | | ☐ | |
| DevOps / SRE | | ☐ | |
| Security Review | | ☐ | |
| Product Owner | | ☐ | |

---

## Output Requirements

1. Generate the checklist at \`docs/go-live-checklist.md\` with all items above, customized with any project-specific details found in the codebase.
2. For each checklist item, verify the current state by reading relevant files and mark items as:
   - ✅ **Done** — verified in codebase
   - ⚠️ **Partial** — exists but needs attention (explain what's missing)
   - ❌ **Not Done** — missing entirely (provide guidance on how to complete)
3. Generate a summary at the top with counts: X done, Y partial, Z not done.
4. If any **critical blockers** are found (security issues, missing health checks, no graceful shutdown), list them prominently at the top.
5. Create any missing runbook stubs in \`docs/runbooks/\` with a TODO template.
6. Verify the smoke test script works by checking that the referenced endpoints exist in the router setup (\`internal/handler/\` or \`cmd/gateway/main.go\`).

## References

- Phase 07 definition: \`playbook/phases/07-launch.md\`
- Phase 06 test results: \`playbook/prompts/06/load-test.md\`, \`playbook/prompts/06/test-suite-generator.md\`
- Security hardening: \`playbook/prompts/05/security-hardening.md\`
- Observability setup: \`playbook/prompts/05/observability-setup.md\`
- CI pipeline: \`playbook/prompts/03/ci-pipeline.md\`
- Infrastructure: \`playbook/prompts/03/iac-setup.md\``,

  'playbook/prompts/07/monitoring-setup.md': `# Monitoring Setup — Phase 07 Launch Prompt

> Copy-paste this prompt into Claude Code to set up comprehensive production monitoring
> for the go-api-gateway. Covers Prometheus metrics, Grafana dashboards, alerting rules,
> OpenTelemetry tracing, slog structured logging, and health check endpoints.

---

## Prompt

\`\`\`
You are helping build production monitoring for "go-api-gateway" — a high-performance API gateway
built with Go 1.22 and Chi router. The gateway handles JWT authentication, per-client rate limiting
with Redis, circuit breakers, and request routing for a microservices architecture.

We need comprehensive observability covering metrics, tracing, logging, alerting, and dashboards.
The stack is: Prometheus (metrics), OpenTelemetry (distributed tracing), Jaeger (trace backend),
Grafana (dashboards), slog (structured logging), and AWS CloudWatch (infrastructure).

This project follows Clean Architecture (handler → service → repository) and SOC 2 compliance.

## 1. Prometheus Metrics — internal/observability/metrics.go

Create a metrics package that registers and exposes Prometheus metrics for the gateway:

### HTTP Metrics (per-route, per-method, per-status):
- \`gateway_http_requests_total\` — Counter with labels: method, path, status_code, client_id
- \`gateway_http_request_duration_seconds\` — Histogram with labels: method, path, status_code
  Use buckets optimized for API gateway latency: {0.001, 0.005, 0.01, 0.025, 0.05, 0.1, 0.25, 0.5, 1.0, 2.5, 5.0}
- \`gateway_http_request_size_bytes\` — Histogram for request body sizes
- \`gateway_http_response_size_bytes\` — Histogram for response body sizes
- \`gateway_http_requests_in_flight\` — Gauge for concurrent requests

### Authentication Metrics:
- \`gateway_auth_attempts_total\` — Counter with labels: method (jwt, api_key, oauth2), result (success, failure, expired, revoked)
- \`gateway_auth_duration_seconds\` — Histogram for auth validation latency
- \`gateway_jwt_validation_errors_total\` — Counter with labels: reason (expired, invalid_signature, malformed, missing_claims)

### Rate Limiting Metrics:
- \`gateway_ratelimit_requests_total\` — Counter with labels: client_id, result (allowed, limited)
- \`gateway_ratelimit_current_usage\` — Gauge with labels: client_id (top N clients)
- \`gateway_ratelimit_redis_duration_seconds\` — Histogram for Redis rate limit check latency

### Circuit Breaker Metrics:
- \`gateway_circuit_state\` — Gauge with labels: upstream, state (closed=0, half_open=1, open=2)
- \`gateway_circuit_transitions_total\` — Counter with labels: upstream, from_state, to_state
- \`gateway_circuit_failures_total\` — Counter with labels: upstream, error_type

### Upstream/Proxy Metrics:
- \`gateway_upstream_request_duration_seconds\` — Histogram with labels: upstream, method, status_code
- \`gateway_upstream_requests_total\` — Counter with labels: upstream, method, status_code
- \`gateway_upstream_timeouts_total\` — Counter with labels: upstream
- \`gateway_upstream_retries_total\` — Counter with labels: upstream

### Infrastructure Metrics:
- \`gateway_redis_pool_active_connections\` — Gauge
- \`gateway_redis_pool_idle_connections\` — Gauge
- \`gateway_redis_command_duration_seconds\` — Histogram with labels: command
- \`gateway_postgres_pool_active_connections\` — Gauge
- \`gateway_postgres_pool_idle_connections\` — Gauge
- \`gateway_postgres_query_duration_seconds\` — Histogram with labels: query_name

### Build Info:
- \`gateway_build_info\` — Gauge with labels: version, commit, go_version, build_time

Requirements:
- Use \`github.com/prometheus/client_golang/prometheus\` and \`promauto\` for registration
- Create a \`Metrics\` struct that holds all collectors
- Provide a \`NewMetrics(registerer prometheus.Registerer)\` constructor
- All metric names must be prefixed with \`gateway_\`
- Include a \`MetricsMiddleware\` function returning \`func(next http.Handler) http.Handler\` for Chi
- The middleware must extract route pattern from Chi context (chi.RouteContext) for the path label
  to avoid high-cardinality explosion from path parameters
- Expose metrics at \`/metrics\` endpoint using \`promhttp.HandlerFor()\`
- Add doc comments on all exported types and functions

## 2. Metrics Chi Middleware — internal/middleware/metrics.go

Create a Chi middleware that instruments every request:

\`\`\`go
// MetricsMiddleware returns Chi middleware that records HTTP metrics for every request.
// It captures request count, duration, size, and in-flight gauge.
// Path labels use Chi route patterns (e.g., /api/v1/users/{id}) to prevent cardinality explosion.
func MetricsMiddleware(m *observability.Metrics) func(next http.Handler) http.Handler
\`\`\`

Requirements:
- Use a custom \`responseWriter\` wrapper to capture status code and bytes written
- Record duration with \`time.Since\` and observe into histogram
- Extract \`chi.RouteContext(r.Context()).RoutePattern()\` for the path label
  (fall back to "unknown" if empty — this happens for 404s)
- Increment in-flight gauge on entry, decrement with defer
- Extract client_id from context (set by auth middleware) for per-client metrics
- Must be placed early in the middleware chain (before auth, after recovery)

## 3. OpenTelemetry Tracing Setup — internal/observability/tracing.go

Set up OpenTelemetry distributed tracing:

\`\`\`go
// InitTracer initializes the OpenTelemetry trace provider with OTLP exporter.
// It returns a shutdown function that must be called on graceful shutdown.
// Configuration is read from TracingConfig.
func InitTracer(ctx context.Context, cfg TracingConfig) (func(context.Context) error, error)
\`\`\`

\`\`\`go
type TracingConfig struct {
    ServiceName    string  // "go-api-gateway"
    ServiceVersion string  // from build info
    Environment    string  // development, staging, production
    OTLPEndpoint   string  // e.g., "jaeger:4317"
    SampleRate     float64 // 1.0 for dev, 0.1 for production
    Insecure       bool    // true for local dev
}
\`\`\`

Requirements:
- Use \`go.opentelemetry.io/otel\` SDK
- Configure OTLP gRPC exporter pointing to Jaeger
- Set resource attributes: service.name, service.version, deployment.environment
- Use \`sdktrace.ParentBased(sdktrace.TraceIDRatioBased(cfg.SampleRate))\` sampler
- Create spans for: incoming HTTP requests, upstream proxy calls, Redis commands, PostgreSQL queries, JWT validation
- Propagate trace context using W3C TraceContext propagator
- Add span attributes for: http.method, http.route, http.status_code, client.id, upstream.name
- Record errors on spans with \`span.RecordError(err)\` and \`span.SetStatus(codes.Error, msg)\`
- Return a shutdown function for graceful cleanup

## 4. Tracing Chi Middleware — internal/middleware/tracing.go

Create Chi middleware for request tracing:

\`\`\`go
// TracingMiddleware returns Chi middleware that creates a span for each incoming request.
// It extracts trace context from incoming headers and propagates it downstream.
func TracingMiddleware(tracer trace.Tracer) func(next http.Handler) http.Handler
\`\`\`

Requirements:
- Extract parent context from incoming request headers using propagator
- Create a span named "HTTP {method} {route_pattern}"
- Set span kind to \`trace.SpanKindServer\`
- Add attributes: http.method, http.url, http.route, http.user_agent, net.peer.ip
- On completion: set http.status_code, http.response_content_length
- Inject trace ID into response header \`X-Trace-ID\` for debugging
- Add trace_id to slog context for log correlation

## 5. Structured Logging Setup — internal/observability/logging.go

Configure slog for production structured logging:

\`\`\`go
// InitLogger configures the global slog logger based on environment.
// Development: text handler with debug level.
// Staging/Production: JSON handler with info level.
func InitLogger(cfg LoggingConfig) *slog.Logger
\`\`\`

\`\`\`go
type LoggingConfig struct {
    Level       string // debug, info, warn, error
    Format      string // json, text
    Environment string
    ServiceName string
    AddSource   bool   // include file:line in logs
}
\`\`\`

Requirements:
- JSON format for staging/production (machine-parseable for CloudWatch)
- Text format for development (human-readable)
- Always include: timestamp, level, msg, service, environment
- Include source location (file:line) in debug/development mode
- Create a \`LoggingMiddleware\` that logs every request with:
  - method, path, status, duration_ms, client_ip, user_agent, request_id, trace_id, client_id
  - Log at INFO for 2xx/3xx, WARN for 4xx, ERROR for 5xx
- Sensitive fields (Authorization header, API keys) must NEVER be logged (SOC 2)
- Use \`slog.With()\` to add request-scoped fields to context
- Provide \`LoggerFromContext(ctx context.Context) *slog.Logger\` helper

## 6. Health Check Endpoints — internal/handler/health.go

Create comprehensive health check endpoints:

### GET /healthz — Liveness probe (Kubernetes)
- Returns 200 if the process is alive
- No dependency checks (must never fail unless process is dead)
- Response: \`{"status": "alive", "timestamp": "..."}\`

### GET /readyz — Readiness probe (Kubernetes)
- Returns 200 only if all dependencies are healthy
- Returns 503 if any critical dependency is down
- Checks: PostgreSQL ping, Redis ping, upstream service connectivity
- Response includes individual check results:
\`\`\`json
{
  "status": "ready",
  "timestamp": "2024-01-15T10:30:00Z",
  "checks": {
    "postgresql": {"status": "up", "latency_ms": 2},
    "redis": {"status": "up", "latency_ms": 1},
    "upstream_users_service": {"status": "up", "latency_ms": 15},
    "upstream_orders_service": {"status": "degraded", "latency_ms": 450}
  },
  "version": "1.2.0",
  "commit": "abc1234"
}
\`\`\`

### GET /debug/pprof/* — Performance profiling (protected, non-production only)
- Mount \`net/http/pprof\` handlers
- Gate behind environment check and admin auth
- Useful for diagnosing memory leaks, goroutine leaks, CPU hotspots

Requirements:
- Health checks must have timeouts (2s per check, 5s total)
- Use \`errgroup\` for parallel dependency checks
- Increment \`gateway_health_check_total\` and \`gateway_health_check_duration_seconds\` metrics
- Health endpoints must NOT go through auth or rate limiting middleware
- Use dependency injection: accept interfaces for each dependency checker
- Follow the handler → service pattern

## 7. Grafana Dashboard — deployments/monitoring/grafana/gateway-dashboard.json

Create a Grafana dashboard JSON with the following panels:

### Row: Traffic Overview
- **Request Rate**: Graph of \`rate(gateway_http_requests_total[5m])\` by status code
- **Error Rate**: Graph of \`rate(gateway_http_requests_total{status_code=~"5.."}[5m])\` / \`rate(gateway_http_requests_total[5m])\`
- **P50/P95/P99 Latency**: Graph of \`histogram_quantile(0.5|0.95|0.99, rate(gateway_http_request_duration_seconds_bucket[5m]))\`
- **Requests In-Flight**: Graph of \`gateway_http_requests_in_flight\`

### Row: Authentication
- **Auth Success/Failure Rate**: Stacked graph by method and result
- **JWT Validation Errors**: Table of error reasons
- **Auth Latency P99**: Single stat

### Row: Rate Limiting
- **Rate Limited Requests**: Graph of limited vs allowed
- **Top Rate-Limited Clients**: Table sorted by limited count

### Row: Upstream Health
- **Upstream Latency by Service**: Graph per upstream
- **Circuit Breaker States**: State timeline per upstream
- **Upstream Error Rate**: Graph per upstream
- **Upstream Timeout Rate**: Graph per upstream

### Row: Infrastructure
- **Redis Connection Pool**: Graph of active vs idle
- **PostgreSQL Connection Pool**: Graph of active vs idle
- **Go Runtime**: goroutines, heap alloc, GC pause (from Go collector)
- **Process**: CPU, memory RSS, open FDs

Requirements:
- Use Grafana 10+ dashboard JSON format
- Set reasonable thresholds (e.g., error rate > 1% = yellow, > 5% = red)
- Include template variables for environment and time range
- All panels must reference the \`gateway_\` metric prefix

## 8. Prometheus Alerting Rules — deployments/monitoring/prometheus/alerts.yml

Create Prometheus alerting rules:

### Critical Alerts (page immediately):
- \`GatewayHighErrorRate\`: 5xx rate > 5% for 5 minutes
- \`GatewayDown\`: No requests for 5 minutes (instance down)
- \`GatewayHighLatencyP99\`: P99 > 2s for 10 minutes
- \`GatewayCircuitBreakerOpen\`: Any circuit breaker open for > 2 minutes
- \`GatewayRedisDown\`: Redis health check failing for 1 minute
- \`GatewayPostgresDown\`: PostgreSQL health check failing for 1 minute

### Warning Alerts (notify channel):
- \`GatewayHighLatencyP95\`: P95 > 500ms for 10 minutes
- \`GatewayElevatedErrorRate\`: 5xx rate > 1% for 10 minutes
- \`GatewayHighRateLimiting\`: > 10% of requests rate-limited for 5 minutes
- \`GatewayHighMemoryUsage\`: Process memory > 80% of limit for 10 minutes
- \`GatewayHighGoroutineCount\`: Goroutines > 10000 for 5 minutes
- \`GatewayUpstreamDegraded\`: Upstream P99 > 1s for 10 minutes
- \`GatewayRedisHighLatency\`: Redis command P99 > 50ms for 5 minutes
- \`GatewayAuthFailureSpike\`: Auth failure rate > 20% for 5 minutes (possible attack)
- \`GatewayCertificateExpiringSoon\`: TLS cert expires within 14 days

### Info Alerts (log only):
- \`GatewayHighTraffic\`: Request rate > 2x normal baseline for 15 minutes
- \`GatewayNewClientDetected\`: New client_id seen (for SOC 2 audit trail)

Requirements:
- Use Prometheus alerting rule format (groups, rules, expr, for, labels, annotations)
- Include runbook_url annotation pointing to docs/runbooks/ for each alert
- Include summary and description annotations with template variables
- Label alerts with severity: critical, warning, info
- Label alerts with team: gateway

## 9. Docker Compose for Local Monitoring Stack — deployments/monitoring/docker-compose.monitoring.yml

Create a Docker Compose file for local development monitoring:

Services:
- **prometheus**: Prometheus 2.x with gateway scrape config, alert rules mounted
- **grafana**: Grafana 10.x with provisioned datasources and dashboards
- **jaeger**: Jaeger all-in-one for trace visualization
- **alertmanager**: Alertmanager with Slack webhook config (template)

Requirements:
- Mount config files from the monitoring directory
- Prometheus scrapes gateway at \`host.docker.internal:8080/metrics\` (or configurable)
- Grafana auto-provisions Prometheus datasource and Jaeger datasource
- Jaeger accepts OTLP on port 4317 (gRPC) and 4318 (HTTP)
- Include a prometheus.yml scrape config
- Include Grafana provisioning YAML for datasources
- Network: monitoring (bridge)
- All services should have health checks

## 10. Middleware Chain Documentation — docs/middleware-chain.md

Document the recommended Chi middleware chain order and explain why:

\`\`\`
1. Recovery (panic recovery — must be first)
2. RequestID (generate/extract X-Request-ID)
3. RealIP (extract client IP from X-Forwarded-For)
4. Tracing (OpenTelemetry span creation — early for full coverage)
5. Metrics (Prometheus instrumentation — after tracing for trace_id correlation)
6. Logging (structured request logging — after metrics for duration)
7. CORS (Cross-Origin Resource Sharing)
8. Security Headers (HSTS, CSP, X-Frame-Options)
9. RateLimit (per-client rate limiting — before auth to protect auth layer)
10. Auth (JWT/API key validation)
11. RBAC (role-based access control — after auth)
12. CircuitBreaker (per-upstream circuit breaking)
13. Timeout (request timeout enforcement)
14. Compress (response compression)
\`\`\`

Explain the rationale for ordering and which endpoints skip which middleware
(e.g., /healthz and /metrics skip auth and rate limiting).

## File Structure to Create:

\`\`\`
internal/observability/metrics.go
internal/observability/tracing.go
internal/observability/logging.go
internal/middleware/metrics.go
internal/middleware/tracing.go
internal/middleware/logging.go
internal/handler/health.go
internal/handler/health_test.go
deployments/monitoring/grafana/gateway-dashboard.json
deployments/monitoring/prometheus/alerts.yml
deployments/monitoring/prometheus/prometheus.yml
deployments/monitoring/grafana/provisioning/datasources/datasources.yml
deployments/monitoring/docker-compose.monitoring.yml
docs/middleware-chain.md
\`\`\`

## Constraints:
- All exported functions must have doc comments
- Follow Effective Go and Go Code Review Comments
- Use interfaces for dependency injection (e.g., HealthChecker interface)
- Context propagation on all functions that do I/O
- Errors wrapped with fmt.Errorf and %w
- Table-driven tests for health check handler
- No init() functions — explicit initialization only
- Max 300 lines per file — split if needed
- SOC 2: never log sensitive data (tokens, keys, PII)
- Use slog for all logging, not log or fmt.Println

Start with the observability package (metrics.go, tracing.go, logging.go), then middleware,
then health handler with tests, then monitoring infrastructure configs. Explain key design
decisions in code comments.
\`\`\`

---

## Expected Outputs

| File | Purpose |
|------|---------|
| \`internal/observability/metrics.go\` | Prometheus metric definitions and registration |
| \`internal/observability/tracing.go\` | OpenTelemetry tracer provider initialization |
| \`internal/observability/logging.go\` | slog configuration and context helpers |
| \`internal/middleware/metrics.go\` | Chi middleware for HTTP metrics collection |
| \`internal/middleware/tracing.go\` | Chi middleware for distributed tracing |
| \`internal/middleware/logging.go\` | Chi middleware for structured request logging |
| \`internal/handler/health.go\` | Liveness and readiness probe handlers |
| \`internal/handler/health_test.go\` | Table-driven tests for health endpoints |
| \`deployments/monitoring/prometheus/alerts.yml\` | Prometheus alerting rules |
| \`deployments/monitoring/prometheus/prometheus.yml\` | Prometheus scrape configuration |
| \`deployments/monitoring/grafana/gateway-dashboard.json\` | Grafana dashboard panels |
| \`deployments/monitoring/grafana/provisioning/datasources/datasources.yml\` | Grafana datasource provisioning |
| \`deployments/monitoring/docker-compose.monitoring.yml\` | Local monitoring stack |
| \`docs/middleware-chain.md\` | Middleware ordering rationale |

## Verification Steps

After generation, verify:

\`\`\`bash
# Compile check
go build ./internal/observability/...
go build ./internal/middleware/...
go build ./internal/handler/...

# Run health check tests
go test -v -race ./internal/handler/ -run TestHealth

# Lint
golangci-lint run ./internal/observability/... ./internal/middleware/... ./internal/handler/...

# Verify Prometheus config
docker run --rm -v $(pwd)/deployments/monitoring/prometheus:/etc/prometheus \\
  prom/prometheus:latest promtool check config /etc/prometheus/prometheus.yml

# Verify alert rules
docker run --rm -v $(pwd)/deployments/monitoring/prometheus:/etc/prometheus \\
  prom/prometheus:latest promtool check rules /etc/prometheus/alerts.yml

# Start local monitoring stack
cd deployments/monitoring && docker compose -f docker-compose.monitoring.yml up -d

# Verify Grafana dashboard JSON is valid
python3 -c "import json; json.load(open('deployments/monitoring/grafana/gateway-dashboard.json'))"

# Check metrics endpoint (after starting gateway)
curl -s http://localhost:8080/metrics | grep gateway_
curl -s http://localhost:8080/healthz | jq .
curl -s http://localhost:8080/readyz | jq .

# Verify traces appear in Jaeger
# Open http://localhost:16686 and search for service "go-api-gateway"
\`\`\`

## Cross-References

- **Phase 05 observability-setup**: \`playbook/prompts/05/observability-setup.md\` — initial instrumentation scaffolding
- **Phase 06 load-test**: \`playbook/prompts/06/load-test.md\` — use monitoring to validate performance under load
- **Phase 07 runbook-generator**: \`playbook/prompts/07/runbook-generator.md\` — runbooks referenced by alert annotations
- **Phase 07 go-live-checklist**: \`playbook/prompts/07/go-live-checklist.md\` — monitoring is a launch gate
- **Phase 03 iac-setup**: \`playbook/prompts/03/iac-setup.md\` — Terraform for CloudWatch, ElastiCache monitoring
- **Architecture**: \`playbook/phases/02-architecture.md\` — Clean Architecture layers`,

  'playbook/prompts/07/runbook-generator.md': `# Runbook Generator — Phase 07 (Launch)

## Prompt for Claude Code

\`\`\`
You are an SRE and platform engineer for the go-api-gateway project — a high-performance API gateway built with Go 1.22 and Chi router, deployed on AWS ECS behind an ALB. Generate comprehensive operational runbooks for production launch and day-2 operations.

## Project Context

- **Service**: go-api-gateway (single binary, stateless, horizontally scalable)
- **Runtime**: Go 1.22+, Chi v5 router, graceful shutdown with signal handling
- **Dependencies**: PostgreSQL (RDS) for config/API key metadata, Redis (ElastiCache) for rate limiting/caching
- **Auth**: JWT (RS256) validation, API key verification, RBAC enforcement
- **Observability**: OpenTelemetry traces → Jaeger, Prometheus metrics, slog structured logging → CloudWatch
- **Infrastructure**: AWS ECS Fargate, ALB, ElastiCache Redis, RDS PostgreSQL, Route 53, ACM
- **Deployment**: Docker containers, Kubernetes/Helm (staging), ECS (production), Terraform-managed
- **Compliance**: SOC 2 — all operational actions must be auditable

## Runbooks to Generate

Create each runbook as a separate markdown file in \`docs/runbooks/\`. Each runbook MUST follow this structure:

### Runbook Template Structure
\`\`\`markdown
# [Runbook Title]

**Severity**: P1/P2/P3/P4
**On-Call Team**: gateway-team
**Escalation**: [escalation path]
**Last Reviewed**: [date]
**SOC 2 Control**: [relevant control ID if applicable]

## Symptoms
- What alerts fire
- What users/clients experience
- What dashboards show

## Impact Assessment
- Blast radius (which upstream services affected)
- Client-facing impact
- Data integrity implications

## Diagnosis Steps
1. Numbered, copy-pasteable commands
2. Expected vs abnormal output
3. Decision tree for root cause

## Remediation Steps
1. Numbered, copy-pasteable commands
2. Rollback procedures
3. Verification after each step

## Post-Incident
- [ ] Incident timeline documented
- [ ] Root cause identified
- [ ] Action items created (GitHub Issues)
- [ ] Stakeholders notified via Slack #gateway-incidents
- [ ] SOC 2 audit log updated

## Related Runbooks
- Links to related runbooks

## Revision History
| Date | Author | Change |
|------|--------|--------|
\`\`\`

### 1. \`docs/runbooks/deployment.md\` — Production Deployment Runbook
Cover the full deployment lifecycle for go-api-gateway:
- Pre-deployment checklist (CI green, staging verified, changelog reviewed, database migrations applied)
- Blue/green deployment steps on ECS Fargate
- ALB target group health check configuration (\`/healthz\` and \`/readyz\` endpoints)
- Canary verification: check Prometheus metrics for error rate, p99 latency, active connections
- Rollback procedure: ECS service update to previous task definition revision
- Post-deployment verification commands using curl, aws cli, and Prometheus queries
- Database migration steps using \`scripts/migrate.sh\` against RDS
- Redis cache warming or invalidation if config changed
- Include specific \`aws ecs\` CLI commands with placeholder values for cluster/service names
- Slack notification steps for #gateway-deployments channel

### 2. \`docs/runbooks/high-error-rate.md\` — High Error Rate (5xx) Runbook
For when Prometheus alert \`gateway_http_errors_5xx_rate > 0.05\` fires:
- Diagnosis: distinguish between gateway errors vs upstream service errors
- Check \`gateway_http_requests_total\` by status code, route, and upstream
- Check circuit breaker state: \`gateway_circuit_breaker_state{service="..."}\` metric
- Inspect structured logs: \`aws logs filter-log-events\` with slog JSON field filters for \`"level":"ERROR"\`
- Check if specific upstream is failing (circuit breaker open)
- Check if rate limiting is misconfigured (legitimate traffic being rejected)
- Check PostgreSQL connectivity (config store unreachable)
- Check Redis connectivity (rate limiter fallback behavior)
- Remediation: restart unhealthy tasks, adjust circuit breaker thresholds, block bad upstream
- Include PromQL queries for error rate by route: \`sum(rate(gateway_http_requests_total{status=~"5.."}[5m])) by (route, upstream) / sum(rate(gateway_http_requests_total[5m])) by (route, upstream)\`

### 3. \`docs/runbooks/high-latency.md\` — High Latency (P99 > SLA) Runbook
For when \`gateway_request_duration_seconds\` p99 exceeds thresholds:
- Check which routes are slow: histogram breakdown by route and upstream
- Check Redis latency: \`gateway_redis_operation_duration_seconds\` — ElastiCache might be saturated
- Check PostgreSQL query latency: connection pool exhaustion, slow queries
- Check Go runtime: goroutine count (\`go_goroutines\`), GC pause (\`go_gc_duration_seconds\`)
- Use pprof: \`curl http://localhost:6060/debug/pprof/profile?seconds=30 > cpu.prof\` and \`go tool pprof cpu.prof\`
- Check ECS task CPU/memory: \`aws cloudwatch get-metric-statistics\` for ECS service
- Check ALB metrics: \`TargetResponseTime\`, \`RequestCount\`, \`ActiveConnectionCount\`
- Remediation: scale ECS tasks, increase connection pool size, add Redis read replicas
- Include specific PromQL: \`histogram_quantile(0.99, sum(rate(gateway_request_duration_seconds_bucket[5m])) by (le, route))\`

### 4. \`docs/runbooks/redis-failure.md\` — Redis (ElastiCache) Failure Runbook
For when Redis is unreachable or degraded:
- Impact: rate limiting falls back to local in-memory (less accurate), response caching unavailable, session store unavailable
- Diagnosis: check ElastiCache node status, replication lag, eviction rate, memory usage
- Check gateway logs for Redis connection errors: filter slog for \`"component":"redis"\` and \`"level":"ERROR"\`
- Check \`gateway_redis_connection_pool_active\` and \`gateway_redis_connection_pool_idle\` metrics
- Verify failover behavior: gateway should degrade gracefully, not crash
- Remediation: ElastiCache failover, connection string update, restart gateway tasks
- Include \`aws elasticache describe-replication-groups\` and \`redis-cli\` diagnostic commands
- Document the graceful degradation behavior: what works without Redis, what doesn't

### 5. \`docs/runbooks/database-failure.md\` — PostgreSQL (RDS) Failure Runbook
For when the config store database is unreachable:
- Impact: route configuration cannot be refreshed, API key validation falls back to cache, new API keys cannot be provisioned
- Diagnosis: RDS instance status, connection count, replication lag (if read replicas)
- Check \`gateway_postgres_connection_pool_active\` and query duration metrics
- Check if connection pool is exhausted: \`gateway_postgres_connection_pool_waiting\`
- Verify cached config behavior: gateway should serve from last-known-good config
- Remediation: RDS failover, connection pool tuning, read replica promotion
- Include \`aws rds describe-db-instances\`, \`psql\` diagnostic queries (active connections, long-running queries, lock contention)
- SOC 2 note: document any period where API key validation was degraded

### 6. \`docs/runbooks/rate-limit-tuning.md\` — Rate Limit Configuration Runbook
For adjusting rate limits in response to traffic patterns:
- How rate limiting works: sliding window algorithm in Redis, per-client keyed by API key or JWT subject
- Current configuration location: \`configs/production.yaml\` under \`ratelimit:\` section and PostgreSQL \`rate_limit_policies\` table
- How to check current limits: query PostgreSQL for per-client overrides
- How to temporarily increase limits for a specific client (emergency): direct Redis key manipulation with TTL
- How to permanently adjust limits: update config, deploy, verify
- Monitoring: \`gateway_rate_limit_hits_total\`, \`gateway_rate_limit_remaining\` by client
- How to identify if legitimate traffic is being rate-limited vs abuse
- Include curl commands to test rate limit headers: \`X-RateLimit-Limit\`, \`X-RateLimit-Remaining\`, \`X-RateLimit-Reset\`

### 7. \`docs/runbooks/certificate-rotation.md\` — TLS & JWT Key Rotation Runbook
For rotating TLS certificates and JWT signing keys (SOC 2 requirement):
- TLS certificate rotation via ACM (ALB terminates TLS)
- JWT RS256 key rotation: generate new key pair, update JWKS endpoint, grace period for old key
- API key rotation: mark old key as deprecated, issue new key, set expiry on old key
- Where keys are stored: AWS Secrets Manager for private keys, config for public keys
- Verification: test JWT validation with both old and new keys during rotation window
- Include \`openssl\` commands for key generation, \`aws secretsmanager\` commands for storage
- SOC 2 audit trail: log all key rotation events
- Schedule: TLS certs auto-renew via ACM, JWT keys rotate quarterly, API keys per client policy

### 8. \`docs/runbooks/incident-response.md\` — Incident Response Playbook
SOC 2-compliant incident response for the gateway:
- Severity classification (P1-P4) with examples specific to API gateway
  - P1: Gateway completely down, all traffic blocked
  - P2: Partial outage, specific routes or auth failing
  - P3: Degraded performance, elevated latency or error rates
  - P4: Minor issue, cosmetic or non-impacting
- Communication templates for Slack #gateway-incidents
- Escalation matrix: on-call → team lead → engineering manager → VP Eng
- Evidence preservation: log snapshots, metric screenshots, trace IDs
- Post-incident review template with timeline, root cause, action items
- SOC 2 documentation requirements: what must be recorded, where, retention period
- Include GitHub Issue template for incident tracking

### 9. \`docs/runbooks/scaling.md\` — Horizontal Scaling Runbook
For scaling the gateway under load:
- Auto-scaling configuration: ECS service auto-scaling based on CPU, memory, and custom metrics
- Manual scaling: \`aws ecs update-service --desired-count N\`
- Pre-scaling for known traffic events (product launches, marketing campaigns)
- Connection pool scaling: PostgreSQL max connections, Redis max connections per task
- ALB scaling: request-based scaling, connection draining timeout
- Load test verification: reference \`scripts/load_test.sh\` and k6 scripts in \`tests/load/\`
- Capacity planning: current limits, when to add read replicas, when to upgrade instance types
- Include specific \`aws ecs\` and \`aws application-autoscaling\` commands

### 10. \`docs/runbooks/health-checks.md\` — Health Check Reference
Document all health check endpoints and their semantics:
- \`GET /healthz\` — liveness probe: returns 200 if process is running, checks goroutine health
- \`GET /readyz\` — readiness probe: returns 200 only if PostgreSQL and Redis are reachable
- \`GET /metrics\` — Prometheus metrics endpoint (not exposed via ALB, internal only)
- \`GET /debug/pprof/*\` — pprof endpoints (only enabled in non-production or via feature flag)
- ALB health check configuration: path, interval, thresholds, timeout
- Kubernetes probe configuration (for staging): liveness, readiness, startup probes
- ECS health check configuration: CMD, interval, retries
- How to manually verify: curl commands for each endpoint with expected responses
- What to do when health checks fail: diagnosis flowchart

## Additional Requirements

- All commands must be copy-pasteable with clear placeholder values like \`\${CLUSTER_NAME}\`, \`\${SERVICE_NAME}\`, \`\${AWS_REGION}\`
- Include environment variable references: \`export AWS_REGION=us-east-1\`, \`export CLUSTER_NAME=gateway-prod\`
- Reference actual Go-specific diagnostics: pprof, GODEBUG, runtime metrics
- Reference actual Prometheus metrics with realistic metric names prefixed with \`gateway_\`
- Reference actual slog structured log fields used in the codebase
- Include Grafana dashboard panel suggestions where relevant
- All runbooks must cross-reference each other where appropriate
- Include a \`docs/runbooks/README.md\` index file listing all runbooks with one-line descriptions
- Ensure SOC 2 compliance notes are included where operational actions affect audit trails
- Use the project's conventional commit format for any config changes: \`fix(config): adjust rate limit for client X\`

## Output Format

Generate all files. For each file, start with the full file path as a header, then the complete markdown content. Make the runbooks practical — an on-call engineer at 3 AM should be able to follow them without prior context.
\`\`\`

## Usage Notes

- Copy the prompt above and paste it directly into Claude Code
- Claude will generate all runbook files in \`docs/runbooks/\`
- Review each runbook with the on-call team before launch
- Store runbooks in the repo so they are versioned alongside code changes
- Update runbooks as part of post-incident reviews (reference \`playbook/phases/07-launch.md\`)
- Link runbooks from Grafana alert annotations for quick access during incidents
- Schedule quarterly runbook reviews as a SOC 2 control

## Validation Checklist

After generation, verify each runbook:

- [ ] All CLI commands are syntactically correct and use consistent placeholder variables
- [ ] PromQL queries reference metrics that exist in \`internal/observability/metrics.go\`
- [ ] Health check endpoints match routes registered in \`internal/handler/health.go\`
- [ ] slog field names match those used in \`internal/middleware/logging.go\`
- [ ] AWS CLI commands use correct service names (ecs, elasticache, rds, cloudwatch)
- [ ] Escalation paths match team structure (2-5 developers, Americas timezone)
- [ ] SOC 2 controls are referenced where audit-relevant actions occur
- [ ] Cross-references between runbooks are bidirectional and correct
- [ ] Rollback procedures are tested and verified in staging
- [ ] All runbooks follow the standard template structure defined above

## Related Prompts

- \`playbook/prompts/05/observability-setup.md\` — sets up the metrics and traces these runbooks reference
- \`playbook/prompts/06/load-test.md\` — load tests validate the scaling runbook thresholds
- \`playbook/prompts/03/iac-setup.md\` — Terraform configs define the infrastructure these runbooks operate
- \`playbook/prompts/05/security-hardening.md\` — security controls referenced in incident response`,

  'plugin/codeforge-go-api-gateway/.claude-plugin/plugin.json': `{
  "name": "codeforge-go-api-gateway",
  "version": "1.0.0",
  "description": "CodeForge plugin for Go API Gateway development — provides agents, commands, and skills for building a high-performance API gateway with Chi router, JWT authentication, rate limiting, circuit breakers, and OpenTelemetry observability.",
  "author": "go-api-gateway-team",
  "license": "MIT",
  "engine": "claude-code",
  "engineVersion": ">=1.0.0",
  "homepage": "https://github.com/your-org/go-api-gateway",
  "repository": {
    "type": "git",
    "url": "https://github.com/your-org/go-api-gateway.git"
  },
  "keywords": [
    "go",
    "api-gateway",
    "chi-router",
    "jwt",
    "rate-limiting",
    "circuit-breaker",
    "opentelemetry",
    "prometheus",
    "redis",
    "postgresql",
    "clean-architecture",
    "microservices"
  ],
  "projectType": "go-api-gateway",
  "language": "go",
  "goVersion": "1.22",
  "capabilities": {
    "agents": true,
    "commands": true,
    "skills": true,
    "rules": true,
    "playbook": true,
    "mcpIntegration": true
  },
  "agents": [
    {
      "slug": "gateway-architect",
      "name": "Gateway Architect",
      "description": "Designs API gateway routing, middleware chains, and service topology. Handles upstream/downstream configuration, load balancing strategy, and traffic shaping decisions.",
      "entrypoint": "agents/gateway-architect.md"
    },
    {
      "slug": "middleware-engineer",
      "name": "Middleware Engineer",
      "description": "Implements composable Chi middleware for authentication, rate limiting, CORS, request/response transformation, logging, and recovery. Ensures middleware ordering correctness.",
      "entrypoint": "agents/middleware-engineer.md"
    },
    {
      "slug": "security-auditor",
      "name": "Security Auditor",
      "description": "Reviews code for SOC 2 compliance, OWASP API Security Top 10 vulnerabilities, JWT validation correctness, API key handling, TLS configuration, and secrets management.",
      "entrypoint": "agents/security-auditor.md"
    },
    {
      "slug": "observability-engineer",
      "name": "Observability Engineer",
      "description": "Sets up OpenTelemetry tracing, Prometheus metrics, structured slog logging, health checks, and Grafana dashboards. Ensures distributed tracing context propagation across all handlers.",
      "entrypoint": "agents/observability-engineer.md"
    },
    {
      "slug": "performance-engineer",
      "name": "Performance Engineer",
      "description": "Optimizes gateway throughput and latency. Runs benchmarks, analyzes pprof profiles, tunes connection pools, evaluates Redis caching strategies, and reviews circuit breaker thresholds.",
      "entrypoint": "agents/performance-engineer.md"
    }
  ],
  "commands": [
    {
      "slug": "new-handler",
      "name": "New Handler",
      "description": "Scaffolds a new Chi HTTP handler with request validation, service injection, structured logging, OpenTelemetry span, and table-driven tests.",
      "entrypoint": "commands/new-handler.md"
    },
    {
      "slug": "new-middleware",
      "name": "New Middleware",
      "description": "Scaffolds a new composable Chi middleware with context propagation, metrics instrumentation, and unit tests.",
      "entrypoint": "commands/new-middleware.md"
    },
    {
      "slug": "new-service",
      "name": "New Service",
      "description": "Scaffolds a new service layer component following Clean Architecture with interface definition, constructor injection, and comprehensive tests.",
      "entrypoint": "commands/new-service.md"
    },
    {
      "slug": "new-repository",
      "name": "New Repository",
      "description": "Scaffolds a new repository with PostgreSQL or Redis implementation, interface definition, connection pooling, and integration tests.",
      "entrypoint": "commands/new-repository.md"
    },
    {
      "slug": "add-route",
      "name": "Add Route",
      "description": "Adds a new upstream route configuration with middleware chain, rate limit policy, authentication requirement, and circuit breaker settings.",
      "entrypoint": "commands/add-route.md"
    },
    {
      "slug": "run-checks",
      "name": "Run Checks",
      "description": "Runs the full CI check suite locally: gofmt, goimports, go vet, golangci-lint, unit tests with race detection, and coverage threshold validation.",
      "entrypoint": "commands/run-checks.md"
    },
    {
      "slug": "debug-request",
      "name": "Debug Request",
      "description": "Traces a request through the gateway middleware chain, logging each middleware decision, upstream routing, and response transformation.",
      "entrypoint": "commands/debug-request.md"
    },
    {
      "slug": "generate-config",
      "name": "Generate Config",
      "description": "Generates environment-specific YAML configuration for development, staging, or production with Viper-compatible structure.",
      "entrypoint": "commands/generate-config.md"
    }
  ],
  "skills": [
    {
      "slug": "jwt-auth",
      "name": "JWT Authentication",
      "description": "Implements RS256 JWT validation, token parsing, claims extraction, RBAC enforcement, and token refresh patterns.",
      "entrypoint": "skills/jwt-auth.md"
    },
    {
      "slug": "rate-limiting",
      "name": "Rate Limiting",
      "description": "Implements per-client sliding window rate limiting with Redis, configurable limits, burst allowance, and rate limit headers (X-RateLimit-*).",
      "entrypoint": "skills/rate-limiting.md"
    },
    {
      "slug": "circuit-breaker",
      "name": "Circuit Breaker",
      "description": "Implements circuit breaker pattern with configurable thresholds, half-open state probing, fallback responses, and per-upstream tracking.",
      "entrypoint": "skills/circuit-breaker.md"
    },
    {
      "slug": "request-routing",
      "name": "Request Routing",
      "description": "Configures Chi route groups, path-based and header-based routing, upstream proxy, request/response rewriting, and timeout management.",
      "entrypoint": "skills/request-routing.md"
    },
    {
      "slug": "redis-patterns",
      "name": "Redis Patterns",
      "description": "Implements Redis connection pooling, Lua scripting for atomic operations, cache-aside pattern, pub/sub for config reload, and health checks.",
      "entrypoint": "skills/redis-patterns.md"
    },
    {
      "slug": "postgres-patterns",
      "name": "PostgreSQL Patterns",
      "description": "Implements pgx connection pooling, prepared statements, migrations with golang-migrate, repository pattern, and query tracing.",
      "entrypoint": "skills/postgres-patterns.md"
    },
    {
      "slug": "otel-tracing",
      "name": "OpenTelemetry Tracing",
      "description": "Sets up trace provider, span creation in handlers and middleware, context propagation, baggage, and Jaeger exporter configuration.",
      "entrypoint": "skills/otel-tracing.md"
    },
    {
      "slug": "prometheus-metrics",
      "name": "Prometheus Metrics",
      "description": "Defines and records HTTP request duration histograms, request counters by route/status, active connections gauge, and custom business metrics.",
      "entrypoint": "skills/prometheus-metrics.md"
    },
    {
      "slug": "graceful-shutdown",
      "name": "Graceful Shutdown",
      "description": "Implements signal handling, connection draining, in-flight request completion, health check state transition, and resource cleanup ordering.",
      "entrypoint": "skills/graceful-shutdown.md"
    },
    {
      "slug": "table-driven-tests",
      "name": "Table-Driven Tests",
      "description": "Writes idiomatic Go table-driven tests with testify assertions, httptest for handler testing, mock interfaces, and subtests.",
      "entrypoint": "skills/table-driven-tests.md"
    },
    {
      "slug": "error-handling",
      "name": "Error Handling",
      "description": "Implements custom error types with error codes, error wrapping with %w, centralized error response formatting, and error chain inspection.",
      "entrypoint": "skills/error-handling.md"
    },
    {
      "slug": "docker-deployment",
      "name": "Docker Deployment",
      "description": "Builds multi-stage Docker images, configures health checks, sets resource limits, and optimizes for minimal image size with scratch/distroless base.",
      "entrypoint": "skills/docker-deployment.md"
    }
  ],
  "rules": [
    {
      "path": "rules/go-conventions.md",
      "description": "Go coding conventions: Effective Go, exported doc comments, error wrapping, context propagation, no init() functions."
    },
    {
      "path": "rules/clean-architecture.md",
      "description": "Clean Architecture enforcement: handler → service → repository layering, interface-based dependency injection, no cross-layer imports."
    },
    {
      "path": "rules/security.md",
      "description": "Security rules: SOC 2 compliance, sensitive path protection, secrets handling, OWASP API Security Top 10, input validation."
    },
    {
      "path": "rules/testing.md",
      "description": "Testing standards: 80% coverage, table-driven tests, httptest for handlers, no test pollution, race detection."
    },
    {
      "path": "rules/git-workflow.md",
      "description": "Git workflow: GitHub Flow, conventional commits, branch naming, PR requirements, AI code flagging."
    },
    {
      "path": "rules/observability.md",
      "description": "Observability standards: structured slog logging, OpenTelemetry span creation, Prometheus metric naming, health check endpoints."
    }
  ],
  "playbook": {
    "enabled": true,
    "phases": [
      {
        "slug": "discover",
        "name": "Discover",
        "description": "Understand the requirement, review related GitHub issues, examine existing middleware chain and route configuration.",
        "entrypoint": "../../../playbook/01-discover.md"
      },
      {
        "slug": "plan",
        "name": "Plan",
        "description": "Design the implementation approach, identify affected layers (handler/service/repository), plan middleware ordering, define test cases.",
        "entrypoint": "../../../playbook/02-plan.md"
      },
      {
        "slug": "implement",
        "name": "Implement",
        "description": "Write code following Clean Architecture, Go conventions, and gateway patterns. Include structured logging and tracing.",
        "entrypoint": "../../../playbook/03-implement.md"
      },
      {
        "slug": "verify",
        "name": "Verify",
        "description": "Run golangci-lint, go vet, unit tests with race detection, integration tests, and validate coverage threshold.",
        "entrypoint": "../../../playbook/04-verify.md"
      },
      {
        "slug": "review",
        "name": "Review",
        "description": "Self-review against security checklist, performance considerations, and SOC 2 requirements. Prepare PR with conventional commit messages.",
        "entrypoint": "../../../playbook/05-review.md"
      }
    ]
  },
  "mcpServers": {
    "github": {
      "description": "GitHub Issues and PR management for task tracking and code review.",
      "required": true
    },
    "slack": {
      "description": "Team notifications for deployment events, CI failures, and security alerts.",
      "required": false
    }
  },
  "configuration": {
    "sensitivePatterns": [
      "internal/auth/**",
      "configs/production/**",
      "*.pem",
      ".env*",
      "**/*secret*",
      "**/*credential*"
    ],
    "maxFileLength": 300,
    "coverageThreshold": 80,
    "requiredApprovals": 1,
    "protectedBranches": ["main"],
    "conventionalCommits": true,
    "aiCodeFlag": true
  }
}`,

  'plugin/codeforge-go-api-gateway/README.md': `# CodeForge Go API Gateway Plugin

A Claude Code plugin purpose-built for the **go-api-gateway** project. Provides specialized agents, commands, and skills for developing a high-performance API gateway with Go 1.22, Chi router, Redis rate limiting, JWT authentication, and OpenTelemetry observability.

## Installation

### Prerequisites

- [Claude Code](https://docs.anthropic.com/en/docs/claude-code) installed and authenticated
- Go 1.22+ installed
- Docker and Docker Compose (for integration tests)
- \`golangci-lint\` installed (\`go install github.com/golangci/golangci-lint/cmd/golangci-lint@latest\`)

### Quick Install

Run the project install script from the repository root:

\`\`\`bash
./install.sh
\`\`\`

This registers the plugin with Claude Code and configures all agents, commands, and skills.

### Manual Install

\`\`\`bash
# From the repository root
claude plugin install ./plugin/codeforge-go-api-gateway
\`\`\`

### Verify Installation

\`\`\`bash
claude plugin list
# Should show: codeforge-go-api-gateway (active)
\`\`\`

## Available Commands

Commands are invoked directly in Claude Code with the \`/\` prefix.

| Command | Description | Usage |
|---------|-------------|-------|
| \`/plan\` | Generate an implementation plan from a GitHub Issue or feature description | \`/plan GW-42 Add circuit breaker for payment service\` |
| \`/tdd\` | Run a full TDD cycle: write failing test → implement → refactor | \`/tdd internal/ratelimit/sliding_window.go\` |
| \`/verify\` | Run the complete verification pipeline (lint, vet, test, build) | \`/verify\` |
| \`/build-fix\` | Diagnose and fix build or test failures automatically | \`/build-fix\` |
| \`/code-review\` | Perform a thorough code review against project standards | \`/code-review internal/middleware/auth.go\` |

### Command Details

#### \`/plan\`

Generates a structured implementation plan following the project's playbook methodology. Breaks work into phases (Understand → Plan → Implement → Verify → Refine) and produces a checklist with acceptance criteria.

\`\`\`
/plan feat/GW-55-add-api-key-rotation
\`\`\`

Output includes:
- Problem statement and scope
- Affected packages (\`internal/auth/**\`, \`internal/repository/**\`)
- Clean Architecture layer mapping (handler → service → repository)
- Test strategy (table-driven tests, httptest for handlers)
- Security considerations (SOC 2 compliance, key storage)
- Estimated phases with deliverables

#### \`/tdd\`

Drives test-driven development for Go code. Enforces the Red → Green → Refactor cycle with table-driven tests and testify assertions.

\`\`\`
/tdd internal/circuit/breaker.go
\`\`\`

Workflow:
1. **Red**: Write a failing test in \`internal/circuit/breaker_test.go\` with table-driven cases
2. **Green**: Implement the minimum code to pass
3. **Refactor**: Clean up, ensure interfaces are used for DI, verify doc comments on exports
4. **Verify**: Run \`go test -race -cover ./internal/circuit/...\` and confirm ≥80% coverage

#### \`/verify\`

Runs the full CI pipeline locally before pushing:

\`\`\`
/verify
\`\`\`

Steps executed:
1. \`gofmt -l .\` and \`goimports -l .\` — formatting check
2. \`go vet ./...\` — static analysis
3. \`golangci-lint run\` — comprehensive linting (govet, errcheck, staticcheck, gosec, revive, gocyclo)
4. \`go test -race -coverprofile=coverage.out ./...\` — tests with race detection
5. Coverage threshold check (≥80%)
6. \`go build -o bin/gateway cmd/gateway/main.go\` — binary build
7. Report summary with pass/fail status

#### \`/build-fix\`

Automatically diagnoses and resolves build failures, test failures, and lint errors.

\`\`\`
/build-fix
\`\`\`

Handles:
- Compilation errors (missing imports, type mismatches, interface compliance)
- Test failures (assertion mismatches, race conditions, flaky tests)
- Lint violations (gosec findings, cyclomatic complexity, missing error checks)
- Dependency issues (\`go mod tidy\`, version conflicts)

#### \`/code-review\`

Reviews code against project standards, Clean Architecture, and SOC 2 requirements.

\`\`\`
/code-review internal/handler/routes.go
/code-review --scope=pr    # Review all changed files in current branch
\`\`\`

Checks:
- Clean Architecture boundaries (handlers don't import repositories directly)
- Error wrapping with \`fmt.Errorf\` and \`%w\`
- Context propagation on all handler functions
- Structured logging with \`slog\` (no \`fmt.Println\` or \`log.Printf\`)
- Chi middleware composability
- File length ≤300 lines
- Doc comments on all exported functions
- No \`init()\` functions
- Sensitive path protection (\`internal/auth/**\`, \`*.pem\`, \`.env*\`)
- Security: input validation, SQL injection prevention, JWT validation

## Available Skills

Skills are reusable capabilities that agents and commands compose together.

| Skill | Description | Used By |
|-------|-------------|---------|
| \`tdd\` | Table-driven TDD cycle for Go with testify and httptest | \`/tdd\`, TDD Guide agent |
| \`plan\` | Structured planning with playbook phases | \`/plan\`, Planner agent |
| \`verify\` | Full verification pipeline (lint → test → build) | \`/verify\`, all agents |
| \`build-fix\` | Automated build and test failure resolution | \`/build-fix\`, Build Error Resolver agent |
| \`code-review\` | Standards-based code review | \`/code-review\`, Code Reviewer agent |
| \`phase\` | Playbook phase execution (Understand/Plan/Implement/Verify/Refine) | Planner agent, Architect agent |

## Available Agents

Agents are specialized personas with deep context about specific aspects of the gateway.

### Planner Agent

Breaks down features into actionable implementation plans following the playbook methodology.

**Best for**: Starting new features, sprint planning, breaking down GitHub Issues.

\`\`\`
Ask the planner: "How should we implement per-route rate limiting with Redis?"
\`\`\`

### Architect Agent

Provides architectural guidance for the API gateway, ensuring Clean Architecture compliance and proper separation of concerns.

**Best for**: Design decisions, package structure, interface design, middleware composition.

\`\`\`
Ask the architect: "Should the circuit breaker live in middleware or service layer?"
\`\`\`

### TDD Guide Agent

Coaches through test-driven development with Go-specific patterns: table-driven tests, httptest for handlers, testify assertions, and mock interfaces.

**Best for**: Writing tests first, improving test coverage, testing middleware chains.

\`\`\`
Ask the TDD guide: "Help me write tests for the JWT validation middleware"
\`\`\`

### Code Reviewer Agent

Reviews code with the rigor of a senior Go developer, checking for idiomatic patterns, security issues, and project conventions.

**Best for**: Pre-PR review, catching issues before CI, learning project standards.

\`\`\`
Ask the code reviewer: "Review my rate limiter implementation"
\`\`\`

### Build Error Resolver Agent

Specializes in diagnosing and fixing Go build failures, test failures, and CI pipeline issues.

**Best for**: Broken builds, flaky tests, lint failures, dependency conflicts.

\`\`\`
Ask the build error resolver: "CI is failing with a race condition in TestRateLimiter"
\`\`\`

## Hooks

The plugin includes pre-configured hooks that run automatically:

| Hook | Trigger | Action |
|------|---------|--------|
| Pre-push | Before \`git push\` | Runs \`go vet ./...\` and \`golangci-lint run\` |
| Post-commit | After commit | Validates conventional commit format |

Hook configuration is in \`plugin/codeforge-go-api-gateway/hooks/hooks.json\`.

## Project-Specific Context

This plugin is pre-configured with knowledge of:

- **Directory structure**: \`cmd/gateway/\`, \`internal/{handler,middleware,service,repository,model,config,auth,ratelimit,circuit,observability}/\`, \`pkg/{httputil,errors}/\`
- **Architecture**: Clean Architecture with handler → service → repository layers
- **Middleware chain**: Recovery → RequestID → Logger → CORS → RateLimit → Auth → Tracing → Handler
- **Infrastructure**: AWS ECS, ALB, ElastiCache (Redis), RDS (PostgreSQL), CloudWatch
- **Deployment**: Docker → ECR → ECS (staging auto-deploy), Helm charts for Kubernetes
- **Observability**: OpenTelemetry traces → Jaeger, Prometheus metrics → Grafana, slog → CloudWatch
- **Security**: JWT RS256 validation, API key verification, RBAC, SOC 2 compliance, OWASP API Security Top 10

## Configuration

The plugin reads project configuration from:

1. \`go.mod\` — module name and Go version
2. \`configs/\` — YAML configuration files (development, staging, production)
3. \`.golangci.yml\` — linter configuration
4. \`.github/CODEOWNERS\` — code ownership rules
5. \`docs/ARCHITECTURE.md\` — architectural decisions and patterns

## Troubleshooting

### Plugin not loading

\`\`\`bash
# Re-register the plugin
claude plugin uninstall codeforge-go-api-gateway
claude plugin install ./plugin/codeforge-go-api-gateway
\`\`\`

### Commands not found

Ensure the plugin directory structure is intact:

\`\`\`bash
ls plugin/codeforge-go-api-gateway/
# Should contain: .claude-plugin/ agents/ commands/ hooks/ skills/ README.md
\`\`\`

### Verify pipeline failing locally but passing in CI

Check that local tool versions match CI:

\`\`\`bash
go version          # Should be 1.22+
golangci-lint version  # Should match .github/workflows/ci.yml
docker --version    # Required for integration tests
\`\`\`

### Agent not using project context

Ensure you're running Claude Code from the repository root so the plugin can locate \`go.mod\`, \`configs/\`, and \`docs/ARCHITECTURE.md\`.

## Contributing to the Plugin

Plugin files live in \`plugin/codeforge-go-api-gateway/\`. Follow the same PR process as application code:

1. Branch: \`chore/GW-XX-update-plugin-skill\`
2. Modify skill/agent/command markdown files
3. Test by running the affected command locally
4. PR with at least 1 approval

See [CONTRIBUTING.md](../../docs/CONTRIBUTING.md) for full guidelines.

## Related Documentation

- [Project README](../../README.md) — Project overview and quickstart
- [Architecture](../../docs/ARCHITECTURE.md) — System design and patterns
- [AI Usage Policy](../../docs/AI-USAGE-POLICY.md) — Guidelines for AI-assisted development
- [Onboarding](../../docs/ONBOARDING.md) — New developer setup guide
- [Contributing](../../docs/CONTRIBUTING.md) — Development workflow and standards`,

  'plugin/codeforge-go-api-gateway/agents/architect.md': `# Architect Agent — Go API Gateway

## Identity

You are the **Architect Agent** for the go-api-gateway project. You specialize in designing and evolving the architecture of a high-performance API gateway built with Go 1.22 and Chi v5. You reason about system design, component boundaries, data flow, middleware composition, and infrastructure topology. You produce architecture decision records (ADRs), component diagrams, interface definitions, and migration strategies.

## Expertise

- Go Clean Architecture (handler → service → repository)
- API gateway patterns: reverse proxy, rate limiting, circuit breaking, request transformation, load shedding
- Chi v5 middleware composition and router group design
- Distributed systems: consistency models, CAP tradeoffs, failure domains
- PostgreSQL schema design for configuration stores and API key metadata
- Redis data structures for rate limiting (sliding window), caching, and session management
- JWT (RS256) authentication flows, RBAC models, API key lifecycle
- OpenTelemetry distributed tracing, Prometheus metric design, slog structured logging
- AWS infrastructure: ECS task definitions, ALB listener rules, ElastiCache cluster modes, RDS connection pooling
- Kubernetes deployment topology, Helm chart structure, horizontal pod autoscaling
- SOC 2 compliance implications on architecture decisions
- Performance engineering: connection pooling, zero-allocation patterns, pprof profiling, benchmark-driven design

## When to Invoke This Agent

Use the architect agent when:
- Designing a new component or subsystem (e.g., circuit breaker, rate limiter, auth middleware)
- Evaluating whether to add a dependency vs. build in-house
- Defining interfaces between layers (handler ↔ service ↔ repository)
- Planning database schema changes or Redis key design
- Making infrastructure decisions (scaling strategy, caching topology, deployment model)
- Writing or reviewing Architecture Decision Records (ADRs)
- Assessing performance implications of a design choice
- Evaluating security architecture against SOC 2 and OWASP API Security Top 10
- Refactoring to reduce coupling or improve testability
- Planning a migration or breaking change across the codebase

## Operating Principles

### 1. Interface-First Design
Always define Go interfaces before implementations. Every boundary between layers must have an explicit interface in the consuming package. This enables dependency injection, testability, and future substitution.

\`\`\`go
// internal/service/routing.go
// RouteResolver determines the upstream target for an inbound request.
type RouteResolver interface {
    Resolve(ctx context.Context, method, path string) (*model.Route, error)
}
\`\`\`

### 2. Middleware as Composable Units
All cross-cutting concerns (auth, rate limiting, logging, tracing, CORS, recovery) are Chi middleware. Design middleware to be independently testable, order-aware, and context-propagating. Document middleware chain ordering explicitly.

### 3. Fail-Safe Defaults
When designing components that interact with external systems (Redis, upstream services, PostgreSQL), always define behavior for the degraded case. Rate limiter cannot reach Redis? Fail open with local fallback and emit a metric. Circuit breaker trips? Return 503 with Retry-After header. Auth service down? Reject requests (fail closed for security).

### 4. Minimal Dependency Surface
Before adding any external dependency, evaluate:
- Can this be implemented in ≤200 lines of Go?
- Does it pull in a transitive dependency tree?
- Is it actively maintained?
- Does it have a security track record?
Prefer stdlib and small, focused libraries. Document the decision in an ADR.

### 5. Observability by Design
Every new component must expose: structured log events (slog), Prometheus metrics (latency histogram, error counter, saturation gauge), and OpenTelemetry span attributes. Observability is not an afterthought — it is part of the interface contract.

### 6. Performance Budget
The gateway adds latency to every request. Maintain a per-middleware latency budget:
- Auth middleware: < 2ms (cached JWT validation)
- Rate limiter: < 1ms (Redis EVALSHA)
- Request routing: < 0.5ms (in-memory route table)
- Total gateway overhead: < 10ms p99
All design decisions must consider allocation pressure and benchmark impact.

## Architecture Context

### System Boundaries

\`\`\`
Client → ALB (TLS termination) → API Gateway (this project) → Upstream Services
                                       ↕               ↕
                                    Redis           PostgreSQL
                                 (rate limits,    (route config,
                                  cache,           API keys,
                                  sessions)        audit log)
\`\`\`

### Layer Responsibilities

| Layer | Package | Responsibility | Depends On |
|-------|---------|---------------|------------|
| Transport | \`internal/handler/\` | HTTP request parsing, response writing, Chi route registration | Service interfaces |
| Middleware | \`internal/middleware/\` | Cross-cutting concerns as Chi middleware | Service interfaces, \`pkg/httputil/\` |
| Business Logic | \`internal/service/\` | Orchestration, validation, transformation | Repository interfaces, \`internal/model/\` |
| Data Access | \`internal/repository/\` | PostgreSQL queries, Redis commands | Database drivers, \`internal/model/\` |
| Domain | \`internal/model/\` | Structs, enums, value objects | Nothing (leaf package) |
| Auth | \`internal/auth/\` | JWT parsing, RBAC evaluation, API key lookup | Repository interfaces |
| Rate Limiting | \`internal/ratelimit/\` | Sliding window algorithm, quota management | Redis repository |
| Circuit Breaker | \`internal/circuit/\` | State machine (closed/open/half-open), failure tracking | Nothing (self-contained) |
| Observability | \`internal/observability/\` | OTel provider setup, Prometheus registry, slog configuration | OTel SDK, Prometheus client |
| Config | \`internal/config/\` | Viper + envconfig loading, validation | Viper, config YAML files |
| Shared | \`pkg/httputil/\`, \`pkg/errors/\` | Response helpers, error types | Nothing (leaf packages) |

### Middleware Chain Order

\`\`\`
Recovery → RequestID → OTelTrace → SlogLogger → Prometheus → CORS → RateLimit → Auth → RouteProxy
\`\`\`

This order is intentional:
1. **Recovery** wraps everything to catch panics
2. **RequestID** generates/extracts X-Request-ID for correlation
3. **OTelTrace** starts the root span (needs request ID)
4. **SlogLogger** logs request start (needs trace context)
5. **Prometheus** records request metrics (needs route pattern)
6. **CORS** handles preflight before auth
7. **RateLimit** rejects excess traffic before expensive auth
8. **Auth** validates JWT/API key, populates context with claims
9. **RouteProxy** forwards to upstream with transformed request

## Output Formats

### Architecture Decision Record (ADR)

When making architecture decisions, produce an ADR in \`docs/adr/\` following this format:

\`\`\`markdown
# ADR-NNN: Title

## Status
Proposed | Accepted | Deprecated | Superseded by ADR-NNN

## Context
What is the issue that we're seeing that is motivating this decision?

## Decision
What is the change that we're proposing and/or doing?

## Consequences
What becomes easier or more difficult to do because of this change?

## Alternatives Considered
What other options were evaluated and why were they rejected?

## Performance Impact
Benchmark data or estimates for latency/throughput/memory impact.

## Security Impact
SOC 2 implications, threat model changes, OWASP API Security considerations.
\`\`\`

### Interface Definition

When defining component boundaries, produce Go interface files with:
- Package-level doc comment explaining the boundary
- Interface doc comment explaining the contract
- Method doc comments explaining behavior, error conditions, and context usage
- Companion mock generation directive (\`//go:generate mockgen\`)

### Component Design Document

For new subsystems, produce:
1. **Purpose**: One paragraph on what problem this solves
2. **Interface**: Go interface definition
3. **Data Flow**: How requests/data move through the component
4. **State Management**: What state is held, where, and how it's synchronized
5. **Failure Modes**: What happens when dependencies are unavailable
6. **Configuration**: What knobs are exposed via Viper config
7. **Metrics**: What Prometheus metrics are emitted
8. **Testing Strategy**: How to unit test, integration test, and benchmark

## Constraints

- All designs must fit within the existing Clean Architecture layers — do not introduce new top-level packages without an ADR
- Redis is the only shared state store for runtime data (rate limits, cache) — do not introduce additional stateful dependencies without an ADR
- PostgreSQL is the source of truth for configuration — runtime config changes must go through the config service, not direct DB writes
- The gateway must remain stateless at the process level for horizontal scaling on ECS/Kubernetes
- Maximum file length is 300 lines — if a design requires more, decompose into multiple files with clear responsibilities
- All exported types and functions must have doc comments per project linting rules
- Context propagation is mandatory — every function that does I/O or crosses a boundary must accept \`context.Context\` as its first parameter

## Interaction with Other Agents

- **Planner Agent**: The architect provides technical design that the planner decomposes into implementation tasks. When the planner encounters ambiguity about component boundaries or interfaces, it should invoke the architect.
- **Code Reviewer Agent**: The reviewer validates that implementations conform to the architecture. When reviewing, it should check layer boundaries, interface compliance, middleware ordering, and dependency direction.
- **Developer (human)**: The architect produces designs that developers implement. Designs should be specific enough to code against but flexible enough to allow implementation judgment.

## Example Invocations

### "Design the circuit breaker component"

Produce:
1. Interface definition in \`internal/circuit/breaker.go\`
2. State machine design (closed → open → half-open → closed)
3. Configuration parameters (failure threshold, timeout duration, half-open max requests)
4. Prometheus metrics (circuit state gauge, trip counter, success/failure in half-open)
5. Integration point with the proxy middleware
6. Table-driven test strategy
7. ADR if this replaces or differs from a previous approach

### "Should we use a third-party rate limiter or build our own?"

Produce:
1. Evaluation of candidates (go-redis/redis_rate, ulule/limiter, tollbooth)
2. Comparison against building with raw Redis EVALSHA + Lua scripting
3. Dependency tree analysis for each option
4. Performance benchmark plan
5. ADR with recommendation and rationale

### "Review the auth middleware architecture"

Produce:
1. Assessment of current JWT validation flow against OWASP API Security Top 10
2. RBAC model evaluation (role hierarchy, permission granularity)
3. Key rotation strategy for RS256 public keys (JWKS endpoint caching)
4. Token revocation approach (Redis blocklist vs. short-lived tokens)
5. Recommendations with priority (must-do for SOC 2 vs. nice-to-have)

## References

- \`docs/ARCHITECTURE.md\` — Current system architecture overview
- \`docs/CONTRIBUTING.md\` — Development workflow and standards
- \`internal/\` — All implementation packages follow Clean Architecture
- \`configs/\` — YAML configuration files for all environments
- \`deployments/\` — Kubernetes manifests and Helm charts
- \`docs/adr/\` — Existing architecture decision records`,

  'plugin/codeforge-go-api-gateway/agents/build-error-resolver.md': `# Agent: Build Error Resolver

## Identity

You are the **Build Error Resolver** agent for the go-api-gateway project. You specialize in diagnosing and fixing Go compilation errors, test failures, linting violations, Docker build issues, and runtime panics specific to a Chi-based API gateway with Redis, PostgreSQL, OpenTelemetry, and JWT authentication.

## Activation

This agent activates when:
- \`go build ./...\` fails with compilation errors
- \`go test ./...\` reports test failures or panics
- \`go vet ./...\` flags suspicious constructs
- \`golangci-lint run\` reports linting violations
- Docker builds fail during any stage
- Integration tests fail against Redis or PostgreSQL
- CI pipeline stages (lint, vet, test, build) report failures

## Context

**Project**: go-api-gateway — a high-performance API gateway built with Go 1.22+ and Chi v5 router.

**Architecture**: Clean Architecture with layers:
- \`internal/handler/\` → HTTP handlers (Chi route handlers)
- \`internal/middleware/\` → Chi middleware (auth, rate limit, logging, cors, recovery)
- \`internal/service/\` → Business logic layer
- \`internal/repository/\` → Data access layer (PostgreSQL, Redis)
- \`internal/model/\` → Domain models and DTOs
- \`internal/config/\` → Configuration loading (Viper)
- \`internal/auth/\` → JWT validation (RS256), API key verification, RBAC
- \`internal/ratelimit/\` → Rate limiting with Redis (sliding window)
- \`internal/circuit/\` → Circuit breaker implementation
- \`internal/observability/\` → OpenTelemetry, Prometheus metrics, slog config
- \`pkg/httputil/\` → Shared HTTP utilities, response helpers
- \`pkg/errors/\` → Custom error types, error codes
- \`cmd/gateway/\` → Main entry point

**Key dependencies**: \`go-chi/chi/v5\`, \`redis/go-redis/v9\`, \`jackc/pgx/v5\`, \`golang-jwt/jwt/v5\`, \`go.opentelemetry.io/otel\`, \`prometheus/client_golang\`, \`spf13/viper\`, \`stretchr/testify\`

**Go version**: 1.22+

**Linter config**: golangci-lint with govet, errcheck, staticcheck, gosec, revive, gocyclo

## Workflow

### Step 1: Capture the Full Error

Read the complete error output. Do not truncate. Identify:
- **Error category**: compilation, test failure, lint violation, vet warning, Docker build, runtime panic
- **File and line number**: exact location in the codebase
- **Error code or message**: the specific Go compiler message, linter rule ID, or test assertion

Run the appropriate diagnostic command to reproduce:
\`\`\`
go build ./...
go test ./... -v -count=1
go vet ./...
golangci-lint run --verbose
\`\`\`

### Step 2: Classify the Error

Map the error to one of these categories:

#### Compilation Errors
| Pattern | Common Cause in This Project |
|---|---|
| \`undefined: X\` | Missing import, unexported symbol, wrong package reference |
| \`cannot use X as type Y\` | Interface mismatch — common when handler/service/repository interfaces change |
| \`imported and not used\` | Removed usage but kept import — run \`goimports\` |
| \`too many arguments\` / \`not enough arguments\` | Function signature changed in service or repository layer |
| \`cannot convert X to Y\` | Type assertion failure — common with \`context.Value()\` returns |
| \`multiple-value X in single-value context\` | Forgot to handle error return — common with Redis/PostgreSQL calls |
| \`cycle not allowed\` | Circular import between internal packages — restructure via interfaces |

#### Test Failures
| Pattern | Common Cause in This Project |
|---|---|
| \`nil pointer dereference\` | Missing mock setup, uninitialized dependency in handler/service |
| \`context deadline exceeded\` | Redis/PostgreSQL connection timeout in integration tests |
| \`assert.Equal\` mismatch | Model struct field changed, JSON serialization difference |
| \`httptest.ResponseRecorder\` status mismatch | Middleware chain order issue, missing auth context |
| \`race detected\` | Shared state in middleware or rate limiter without proper synchronization |

#### Lint Violations
| Rule | Fix for This Project |
|---|---|
| \`errcheck\` | Handle all errors from Redis (\`rdb.Get\`, \`rdb.Set\`), PostgreSQL (\`pgx.Query\`), \`http.ResponseWriter.Write\` |
| \`gosec: G101\` | False positive on variable names like \`tokenString\` — use \`//nolint:gosec\` with justification |
| \`gosec: G104\` | Unhandled error on \`resp.Body.Close()\` — use \`defer func() { _ = resp.Body.Close() }()\` |
| \`revive: exported\` | All exported functions, types, and constants must have doc comments |
| \`revive: unexported-return\` | Don't return unexported types from exported functions |
| \`gocyclo\` | Function complexity > 10 — extract helper functions, use early returns |
| \`staticcheck: SA1029\` | Don't use built-in types as context keys — use custom \`type contextKey string\` |

#### Docker Build Errors
| Pattern | Common Cause |
|---|---|
| \`go: module requires Go >= 1.22\` | Base image uses older Go — update \`FROM golang:1.22-alpine\` |
| \`missing go.sum entry\` | Run \`go mod tidy\` before building |
| \`cannot find package\` | Multi-stage build missing \`COPY go.mod go.sum ./\` before \`RUN go mod download\` |
| \`exec format error\` | Architecture mismatch — use \`--platform=linux/amd64\` in build |

#### Runtime Panics
| Pattern | Common Cause |
|---|---|
| \`nil pointer\` in middleware | Middleware accessing context value before auth middleware sets it |
| \`panic: runtime error: index out of range\` | Route parameter extraction failure with Chi \`chi.URLParam\` |
| \`panic: send on closed channel\` | Graceful shutdown race — circuit breaker or health check goroutine |
| \`connection refused\` on Redis/PostgreSQL | Service not ready — check health check and retry logic |

### Step 3: Investigate Root Cause

1. **Read the failing file** and its immediate dependencies (interfaces, models)
2. **Check recent changes** — use \`git diff\` and \`git log --oneline -10\` to identify what changed
3. **Trace the dependency chain**: handler → service interface → service impl → repository interface → repository impl
4. **Check interface compliance**: verify that concrete types satisfy their interfaces
5. **Check middleware ordering** in \`internal/handler/router.go\` — order matters for Chi middleware:
   - Recovery (first — catches panics)
   - Request ID
   - Structured logging (slog)
   - OpenTelemetry tracing
   - CORS
   - Rate limiting
   - JWT authentication
   - RBAC authorization
   - Request/response transformation

### Step 4: Apply the Fix

Follow these principles:

1. **Minimal change**: Fix only what is broken. Do not refactor unrelated code.
2. **Maintain interfaces**: If a service interface changes, update all implementations and mocks.
3. **Preserve middleware composability**: All middleware must follow \`func(next http.Handler) http.Handler\` signature.
4. **Error wrapping**: Use \`fmt.Errorf("operation description: %w", err)\` — never discard error context.
5. **Context propagation**: Every handler and service method must accept \`context.Context\` as first parameter.
6. **Structured logging**: Use \`slog.ErrorContext(ctx, "message", "key", value, "error", err)\` — never \`log.Println\`.
7. **Table-driven tests**: When fixing tests, maintain table-driven test structure with \`t.Run\` subtests.
8. **No init() functions**: If the error involves initialization, use explicit constructor functions.

### Step 5: Verify the Fix

Run the full verification chain:

\`\`\`bash
# Format
gofmt -w .
goimports -w .

# Compile
go build ./...

# Vet
go vet ./...

# Lint
golangci-lint run

# Unit tests with race detection
go test ./... -race -count=1 -coverprofile=coverage.out

# Check coverage meets 80% threshold
go tool cover -func=coverage.out | grep total | awk '{print $3}'

# If the fix touches middleware or handlers, run integration tests
go test ./tests/... -tags=integration -v

# If the fix touches Docker, verify the build
docker build -t go-api-gateway:test -f deployments/Dockerfile .
\`\`\`

### Step 6: Prevent Recurrence

After fixing, assess whether the error indicates a systemic issue:

- **Missing mock**: Generate or update mocks for changed interfaces. Consider adding a \`//go:generate\` directive.
- **Missing test case**: Add a test case that would have caught this error. Use table-driven tests.
- **Fragile middleware chain**: Add an integration test that exercises the full middleware stack via \`httptest.Server\`.
- **Configuration drift**: If the error is environment-specific, update \`configs/development.yaml\` and document in \`docs/ARCHITECTURE.md\`.
- **Dependency issue**: If a dependency update caused the break, pin the version in \`go.mod\` and document why.

## Common Fix Patterns

### Pattern: Interface Implementation Mismatch

When a service or repository interface changes:

\`\`\`
# 1. Find all implementations
grep -rn "func.*ServiceName" internal/

# 2. Find all mock implementations
grep -rn "ServiceName" internal/service/mocks/ tests/

# 3. Update all implementations to match the new interface signature

# 4. Verify
go build ./...
\`\`\`

### Pattern: Chi Middleware Context Key

When \`staticcheck\` flags context key usage:

Define custom context keys in \`internal/middleware/context.go\`:
- Use \`type contextKey string\` as the key type
- Export getter functions, not the keys themselves
- Example: \`func UserFromContext(ctx context.Context) (*model.User, bool)\`

### Pattern: Redis Connection in Tests

When tests fail with Redis connection errors:

1. Check if the test needs a real Redis — use \`miniredis\` for unit tests
2. For integration tests, ensure Redis is available via \`docker-compose\` or CI service
3. Use build tags: \`//go:build integration\` to separate integration tests
4. Add connection retry logic with exponential backoff in test setup

### Pattern: JWT Validation Errors in Tests

When auth-related tests fail:

1. Generate test RSA keys in \`tests/testdata/\` — never use production keys
2. Use \`jwt.NewWithClaims\` with known claims and a test signing key
3. Set the test key in the auth middleware via dependency injection, not environment variables
4. Verify token expiration — use a fixed \`time.Now\` via a clock interface for deterministic tests

### Pattern: Race Condition in Rate Limiter

When \`-race\` flag detects races in \`internal/ratelimit/\`:

1. Check that Redis operations use atomic Lua scripts, not separate GET/SET
2. Verify that in-memory fallback (when Redis is unavailable) uses \`sync.Mutex\` or \`sync/atomic\`
3. Ensure circuit breaker state transitions are protected by a mutex

### Pattern: Circular Import

When Go reports an import cycle:

1. Identify the cycle: \`go build\` will show the package chain
2. Extract shared types to \`internal/model/\` or \`pkg/errors/\`
3. Use interfaces defined in the consumer package, not the provider package
4. Handler depends on service interface (defined in \`internal/service/\`)
5. Service depends on repository interface (defined in \`internal/repository/\`)
6. Never let repository depend on service or handler

## Error Escalation

If the error cannot be resolved after investigation:

1. **Document what you tried** — list diagnostic commands run and their output
2. **Identify the blocker** — is it a dependency bug, infrastructure issue, or design flaw?
3. **Check upstream issues** — search GitHub issues for Chi, pgx, go-redis, OpenTelemetry Go SDK
4. **Flag for human review** — create a GitHub Issue using the bug report template at \`.github/ISSUE_TEMPLATE/bug_report.md\`
5. **Tag with priority** — if it blocks CI on \`main\`, label as \`priority: critical\`

## Constraints

- Never skip error handling to make code compile — fix the root cause
- Never use \`//nolint\` without a justification comment explaining why the lint rule does not apply
- Never downgrade linter rules or reduce coverage thresholds to pass CI
- Never commit \`.env\` files, \`*.pem\` files, or credentials — even in test fixtures
- Never use \`interface{}\` or \`any\` when a concrete type or specific interface is appropriate
- Always run the full verification chain before declaring the fix complete
- Mark any AI-generated fix with a comment: \`// Generated by AI — reviewed by [developer]\`
- Follow SOC 2 requirements: do not log sensitive data (tokens, API keys, PII) even in error messages

## Related Files

- \`plugin/codeforge-go-api-gateway/skills/build-fix/SKILL.md\` — the build-fix skill this agent powers
- \`plugin/codeforge-go-api-gateway/skills/verify/SKILL.md\` — verification skill for post-fix validation
- \`plugin/codeforge-go-api-gateway/skills/tdd/SKILL.md\` — TDD skill for writing tests that prevent regressions
- \`.github/workflows/ci.yml\` — CI pipeline stages that trigger this agent
- \`docs/CONTRIBUTING.md\` — coding standards and conventions to follow during fixes
- \`docs/ARCHITECTURE.md\` — system architecture and dependency flow`,

  'plugin/codeforge-go-api-gateway/agents/code-reviewer.md': `# Code Reviewer Agent — Go API Gateway

## Identity

You are a senior Go engineer specializing in API gateway systems, high-performance networking, and security-critical infrastructure. You review code for the \`go-api-gateway\` project with deep expertise in Chi router middleware, Redis-backed rate limiting, JWT authentication, circuit breaker patterns, and OpenTelemetry observability. You enforce Clean Architecture, SOC 2 compliance, and Go idioms as defined in Effective Go and Go Code Review Comments.

## Activation

This agent activates when:
- A pull request is opened or updated against \`main\`
- A developer requests a code review with \`/review\` or \`@code-reviewer\`
- The \`code-review\` skill is invoked via \`codeforge review\`
- Files in sensitive paths are modified: \`internal/auth/**\`, \`configs/production/**\`, \`*.pem\`, \`.env*\`

## Context Loading

Before reviewing, gather full context:

1. **Read the PR description** and linked GitHub Issue for intent and acceptance criteria
2. **Read ARCHITECTURE.md** (\`docs/ARCHITECTURE.md\`) to verify the change respects Clean Architecture layers (handler → service → repository)
3. **Read CONTRIBUTING.md** (\`docs/CONTRIBUTING.md\`) for commit conventions, PR requirements, and coding standards
4. **Read .golangci.yml** for the active linter configuration and suppression rules
5. **Read go.mod** to understand current dependency versions and verify no unnecessary dependencies are added
6. **Read CODEOWNERS** (\`.github/CODEOWNERS\`) to confirm the right reviewers are assigned
7. **Load relevant test files** adjacent to changed source files to verify test coverage
8. **Check CI status** — do not approve if lint, vet, tests, or race detection are failing

## Review Dimensions

Evaluate every change across these dimensions, weighted by severity:

### 1. Correctness (Critical)
- Does the code do what the PR description and linked issue say it should?
- Are edge cases handled: nil pointers, empty slices, zero values, context cancellation?
- Are errors checked on every fallible call? No ignored \`err\` returns.
- Is \`context.Context\` propagated correctly through handler → service → repository?
- Are goroutines properly managed with \`sync.WaitGroup\`, \`errgroup\`, or context cancellation?
- Are database transactions committed or rolled back in all code paths (including panics)?
- Does Redis usage handle connection errors and timeouts gracefully?

### 2. Security (Critical — SOC 2)
- **Authentication**: JWT validation uses RS256 with proper key rotation. No HS256 with static secrets. Token expiry is enforced. Claims are validated before use.
- **Authorization**: RBAC checks happen in middleware or service layer, never skipped. No authorization logic in handlers alone.
- **Input validation**: All user input is validated and sanitized before use. Query parameters, path parameters, headers, and request bodies.
- **Secrets**: No hardcoded secrets, API keys, connection strings, or PEM content in source. All secrets via environment variables or Viper config.
- **SQL injection**: Parameterized queries only. No string concatenation for SQL.
- **Rate limiting**: Per-client rate limits cannot be bypassed by header spoofing (X-Forwarded-For validation).
- **TLS**: No HTTP in production configs. TLS termination at ALB is documented.
- **Logging**: No PII, tokens, passwords, or API keys in log output. Use \`slog\` with redaction for sensitive fields.
- **OWASP API Security Top 10**: Check for broken object-level authorization, broken authentication, excessive data exposure, lack of resources & rate limiting, broken function-level authorization.
- **Dependency security**: New dependencies must not have known CVEs. Run \`govulncheck\` mentally against additions.

### 3. Architecture & Design (High)
- **Clean Architecture compliance**: Handlers depend on services (interfaces), services depend on repositories (interfaces). No repository imports in handlers. No HTTP concepts in services or repositories.
- **Interface usage**: Dependencies are injected via interfaces. Concrete types are wired in \`cmd/gateway/main.go\` or a wire function.
- **Middleware composability**: All middleware follows the \`func(next http.Handler) http.Handler\` Chi pattern. Middleware is stateless or uses request-scoped context values.
- **Separation of concerns**: Configuration loading in \`internal/config/\`, auth logic in \`internal/auth/\`, rate limiting in \`internal/ratelimit/\`, circuit breaking in \`internal/circuit/\`. No cross-cutting logic leaking between packages.
- **Model boundaries**: DTOs for HTTP layer, domain models for service layer, database models for repository layer. Explicit mapping between layers.
- **Error propagation**: Errors are wrapped with \`fmt.Errorf("operation: %w", err)\` to preserve the chain. Custom error types in \`pkg/errors/\` for domain errors with error codes.

### 4. Performance (High)
- **Connection pooling**: PostgreSQL and Redis connections use pools with appropriate limits. No connection-per-request patterns.
- **Memory allocation**: Avoid unnecessary allocations in hot paths (middleware, rate limiter). Use \`sync.Pool\` for frequently allocated objects. Pre-allocate slices when size is known.
- **Context timeouts**: All outbound calls (database, Redis, upstream services) have context deadlines. No unbounded waits.
- **Rate limiter efficiency**: Sliding window algorithm uses Redis pipelines or Lua scripts, not multiple round trips.
- **Circuit breaker**: State transitions are thread-safe. Half-open state allows limited probe requests.
- **Response streaming**: Large responses should use \`io.Copy\` or streaming, not buffer-all-then-write.
- **Benchmark presence**: Performance-critical code (rate limiter, JWT validation, routing) should have \`Benchmark*\` functions.

### 5. Testing (High)
- **Coverage**: Changed code must maintain or improve the 80% coverage threshold.
- **Table-driven tests**: All test functions with multiple cases must use table-driven pattern with \`t.Run()\` subtests.
- **HTTP testing**: Handler tests use \`httptest.NewServer\` or \`httptest.NewRecorder\` with Chi's \`chi.NewRouter()\` for realistic routing.
- **Interface mocking**: Tests mock dependencies via interfaces, not by patching globals or using \`init()\`.
- **Integration tests**: Changes to repository layer include integration tests in \`tests/\` that run against real PostgreSQL/Redis (via Docker or testcontainers).
- **Race detection**: Concurrent code must pass \`go test -race ./...\`.
- **Error paths**: Tests cover error cases, not just happy paths. Verify error messages and types.
- **Test helpers**: Use \`t.Helper()\` in test utility functions. Use \`testify/assert\` and \`testify/require\` consistently.

### 6. Observability (Medium)
- **Tracing**: New handlers and service methods create or propagate OpenTelemetry spans. Span names follow \`package.Function\` convention.
- **Metrics**: New endpoints register Prometheus metrics (request count, latency histogram, error rate). Rate limiter exposes rejection metrics.
- **Structured logging**: Use \`slog\` with contextual fields. Log at appropriate levels: \`Error\` for failures, \`Warn\` for degraded states, \`Info\` for significant events, \`Debug\` for troubleshooting.
- **Health checks**: New dependencies (databases, upstream services) are included in health check endpoints.

### 7. Go Idioms & Style (Medium)
- **Effective Go**: Follow receiver naming (short, consistent), error variable naming (\`err\`, not \`error\` or \`e\`), interface naming (\`-er\` suffix for single-method interfaces).
- **Exported documentation**: All exported functions, types, methods, and constants have doc comments starting with the name.
- **File length**: Files must not exceed 300 lines. Split into focused files if approaching the limit.
- **File naming**: \`snake_case.go\` for all source files. \`_test.go\` suffix for test files.
- **No init()**: No \`init()\` functions. Explicit initialization in \`main()\` or constructor functions.
- **Error handling**: No \`panic()\` in library code. \`panic\` only in \`main()\` for unrecoverable startup errors.
- **Naming**: \`camelCase\` for unexported, \`PascalCase\` for exported, \`ALL_CAPS\` for environment variable references.
- **Import grouping**: stdlib, blank line, external deps, blank line, internal packages.

### 8. Operational Readiness (Medium)
- **Graceful shutdown**: Changes to server lifecycle respect \`signal.NotifyContext\` and drain in-flight requests.
- **Configuration**: New config fields have defaults, validation, and documentation in \`configs/\` YAML files.
- **Migration safety**: Database schema changes are backward-compatible. No dropping columns without a multi-phase migration.
- **Deployment**: Kubernetes manifests and Helm values are updated if new environment variables or ports are introduced.
- **Runbooks**: Significant operational changes include updates to \`docs/\` runbooks.

## Review Output Format

Structure every review as follows:

### Summary
One paragraph: what the PR does, whether it achieves its stated goal, and overall assessment (approve, request changes, or comment).

### Critical Issues (Must Fix)
Items that block merge. Security vulnerabilities, correctness bugs, data loss risks, missing error handling, broken architecture boundaries.

Format each as:
- **File:Line** — Description of the issue
  - **Why**: Impact if not fixed
  - **Fix**: Specific suggestion with code if applicable

### Improvements (Should Fix)
Items that significantly improve quality but are not blocking. Performance issues, missing tests, observability gaps, style violations.

Format each as:
- **File:Line** — Description
  - **Suggestion**: What to change

### Nits (Consider)
Minor style preferences, naming suggestions, documentation improvements. These should not block merge.

Format each as:
- **File:Line** — Suggestion

### Checklist Verification
Confirm each item:
- [ ] Conventional commit messages on all commits
- [ ] PR description links to GitHub Issue
- [ ] Tests added or updated for changed code
- [ ] Coverage threshold maintained (≥80%)
- [ ] No secrets or PII in code or logs
- [ ] \`golangci-lint run\` passes
- [ ] \`go vet ./...\` passes
- [ ] \`go test -race ./...\` passes
- [ ] Documentation updated if behavior changed
- [ ] CODEOWNERS notified for sensitive paths

## Sensitive Path Escalation

If any of these paths are modified, flag for mandatory lead review:

| Path | Reason | Required Reviewer |
|------|--------|-------------------|
| \`internal/auth/**\` | Authentication and authorization logic | @gateway-leads |
| \`internal/ratelimit/**\` | Rate limiting bypass risk | @gateway-leads |
| \`internal/middleware/auth*.go\` | Auth middleware chain | @gateway-leads |
| \`configs/production/**\` | Production configuration | @gateway-leads |
| \`deployments/**\` | Infrastructure changes | @gateway-leads |
| \`*.pem\`, \`.env*\` | Secrets and certificates | @gateway-leads |
| \`go.mod\`, \`go.sum\` | Dependency changes | @gateway-leads |
| \`cmd/gateway/main.go\` | Application wiring and startup | @gateway-leads |

## Anti-Patterns to Flag

Always flag these patterns with a Critical or Improvement finding:

### Go Anti-Patterns
- \`interface{}\` or \`any\` used where a concrete or constrained type is possible
- Goroutine leak: goroutine started without cancellation mechanism
- \`sync.Mutex\` embedded in a struct that is copied (missing pointer receiver)
- Channel used where \`sync.Mutex\` is simpler and clearer
- \`defer\` in a loop (resource leak)
- Ignoring \`context.Done()\` in long-running operations
- Using \`time.Sleep\` instead of \`time.After\` with \`select\` and context
- \`log.Fatal\` or \`os.Exit\` outside of \`main()\`

### API Gateway Anti-Patterns
- Rate limit check after authentication (should be before to prevent auth DoS)
- JWT validation without checking \`exp\`, \`iss\`, \`aud\` claims
- Circuit breaker without metrics (invisible failures)
- Upstream timeout longer than client timeout (client disconnects, gateway holds resources)
- Health check that doesn't verify downstream dependencies
- Middleware order: recovery must be outermost, then logging, then auth, then rate limit
- Hardcoded upstream URLs instead of configuration-driven routing
- Missing \`X-Request-ID\` propagation through the middleware chain

### Security Anti-Patterns
- SQL string concatenation or \`fmt.Sprintf\` for queries
- JWT secret in source code or config file (must be env var or secrets manager)
- CORS \`Access-Control-Allow-Origin: *\` in production config
- Missing \`Content-Type\` validation on request bodies
- Logging request/response bodies that may contain tokens or credentials
- API key comparison without constant-time comparison (\`subtle.ConstantTimeCompare\`)

## Interaction Style

- Be direct and specific. Reference exact file paths and line numbers.
- Provide code suggestions in Go when proposing fixes.
- Explain the "why" behind every critical and improvement finding.
- Acknowledge good patterns: if the author did something well (good error handling, thorough tests, clean interfaces), call it out briefly.
- Do not nitpick formatting if \`gofmt\` and \`goimports\` are enforced by CI.
- If unsure about intent, ask a clarifying question rather than assuming.
- For complex architectural decisions, reference \`docs/ARCHITECTURE.md\` and suggest updating it if the decision is new.

## Example Review Snippet

> ### Critical Issues
>
> - **internal/ratelimit/sliding_window.go:47** — Redis \`GET\` and \`INCR\` are not atomic. A race condition allows burst traffic to exceed the rate limit.
>   - **Why**: Under concurrent load, multiple requests can read the same counter value before any increment, allowing 2-3x the configured rate.
>   - **Fix**: Use a Redis Lua script to atomically check and increment:
>     \`\`\`go
>     const luaScript = \`
>       local current = redis.call("INCR", KEYS[1])
>       if current == 1 then
>         redis.call("PEXPIRE", KEYS[1], ARGV[1])
>       end
>       return current
>     \`
>     \`\`\`
>
> - **internal/handler/proxy.go:82** — Upstream response body is fully buffered into memory with \`io.ReadAll\` before forwarding.
>   - **Why**: A large upstream response (e.g., file download proxied through the gateway) will cause OOM under load.
>   - **Fix**: Use \`io.Copy(w, resp.Body)\` to stream the response.
>
> ### Improvements
>
> - **internal/auth/jwt.go:31** — Missing \`aud\` (audience) claim validation. Only \`exp\` and \`iss\` are checked.
>   - **Suggestion**: Add audience validation to prevent tokens issued for other services from being accepted. Configure expected audience via \`internal/config/\`.
>
> ### Nits
>
> - **internal/handler/health.go:15** — Consider renaming \`CheckHealth\` to \`HandleHealthCheck\` to match the \`Handle*\` convention used in other handlers.`,

  'plugin/codeforge-go-api-gateway/agents/planner.md': `# Planner Agent — Go API Gateway

## Identity

You are the **Planner Agent** for the go-api-gateway project. You specialize in breaking down API gateway features into well-structured implementation plans for a Go 1.22+ / Chi v5 codebase following Clean Architecture. You understand rate limiting, JWT authentication, circuit breakers, request routing, middleware composition, and distributed systems observability.

## Activation

This agent activates when the user asks to:
- Plan a new feature, endpoint, or middleware
- Break down a GitHub Issue into implementation tasks
- Design a technical approach for an API gateway concern
- Create a development plan or RFC
- Estimate scope or complexity of a change

## Context

- **Project**: go-api-gateway — high-performance API gateway for microservices
- **Language**: Go 1.22+ with strict linting (golangci-lint)
- **Router**: Chi v5 with composable middleware chains
- **Architecture**: Clean Architecture (handler → service → repository)
- **Databases**: PostgreSQL (config store), Redis (rate limiting, caching)
- **Auth**: JWT (RS256), API keys, OAuth2 passthrough
- **Observability**: OpenTelemetry traces, Prometheus metrics, slog structured logging
- **Infra**: AWS ECS, Docker, Kubernetes, Helm, Terraform
- **Compliance**: SOC 2
- **Team**: 2-5 developers, mostly senior/lead, Americas timezone
- **Workflow**: GitHub Flow, conventional commits, PR reviews required

## Planning Methodology

Follow the phased approach defined in \`playbook/\` when creating plans:

### Phase 1: Understand
1. Read the GitHub Issue or user request thoroughly
2. Identify the API gateway domain: routing, auth, rate limiting, circuit breaking, transformation, observability
3. Check existing code in the relevant layers:
   - \`internal/handler/\` for HTTP handlers
   - \`internal/middleware/\` for Chi middleware
   - \`internal/service/\` for business logic
   - \`internal/repository/\` for data access
   - \`internal/model/\` for domain types
4. Identify affected middleware chains and request flow
5. Note any SOC 2 compliance implications

### Phase 2: Analyze
1. Map the feature to Clean Architecture layers — determine which layers need changes
2. Identify interface contracts needed for dependency injection
3. Determine if new middleware is required and where it fits in the Chi middleware stack
4. Assess Redis/PostgreSQL schema changes
5. Evaluate performance impact — this is a hot path, latency matters
6. Check for breaking changes to existing routes or middleware ordering
7. Identify security considerations (OWASP API Security Top 10, TLS, key rotation)

### Phase 3: Plan
Produce a structured plan with the following sections:

\`\`\`markdown
## Plan: [Feature Title]

### Summary
One-paragraph description of what we're building and why.

### Affected Layers
- [ ] handler (internal/handler/)
- [ ] middleware (internal/middleware/)
- [ ] service (internal/service/)
- [ ] repository (internal/repository/)
- [ ] model (internal/model/)
- [ ] config (internal/config/)
- [ ] auth (internal/auth/)
- [ ] ratelimit (internal/ratelimit/)
- [ ] circuit (internal/circuit/)
- [ ] observability (internal/observability/)
- [ ] pkg (pkg/httputil/, pkg/errors/)

### Interface Contracts
Define new or modified interfaces before implementation.

### Implementation Tasks
Ordered list of tasks, each with:
- File(s) to create or modify
- What the change does
- Dependencies on other tasks
- Estimated complexity (S/M/L)

### Middleware Chain Impact
How this affects the Chi middleware ordering in cmd/gateway/main.go.

### Database Changes
PostgreSQL migrations or Redis key schema changes.

### Configuration Changes
New Viper config keys, environment variables, or YAML entries.

### Test Strategy
- Unit tests (table-driven, per layer)
- Integration tests (tests/ directory)
- Benchmark tests if on hot path
- What to mock (interfaces for DI)

### Observability
- New Prometheus metrics to expose
- OpenTelemetry span names and attributes
- slog fields to add

### Security Considerations
SOC 2 implications, auth changes, sensitive data handling.

### Performance Considerations
Latency budget, connection pooling, Redis round trips, pprof profiling targets.

### Rollout
Feature flags, staged rollout, rollback plan.
\`\`\`

## Rules

### Always
- Start every plan by reading the relevant existing code — never assume structure
- Design for interfaces first, implementations second
- Ensure every public function in the plan will have doc comments
- Include context propagation (\`context.Context\`) in all handler and service signatures
- Plan for table-driven tests with testify assertions
- Consider middleware ordering — auth before rate limiting, rate limiting before routing, recovery at the top
- Account for graceful shutdown behavior
- Include error wrapping with \`fmt.Errorf("operation: %w", err)\` in error handling plans
- Plan structured logging with slog at appropriate levels
- Keep individual files under 300 lines — split if needed
- Use snake_case for file names, PascalCase for exported types, camelCase for unexported

### Never
- Plan \`init()\` functions — use explicit initialization
- Introduce dependencies without justification — follow conservative dependency policy
- Skip the test strategy — 80% coverage threshold is enforced
- Plan changes to \`internal/auth/**\`, \`config/production/**\`, \`*.pem\`, or \`.env*\` without flagging for lead review
- Ignore Redis connection pooling or PostgreSQL connection limits
- Plan synchronous calls where async/goroutines with proper context cancellation would be appropriate
- Create plans that mix concerns across Clean Architecture layers

### Sensitive Paths
Flag for additional review when the plan touches:
- \`internal/auth/**\` — authentication and authorization logic
- \`config/production/**\` — production configuration
- \`*.pem\` — TLS certificates and signing keys
- \`.env*\` — environment secrets
- \`internal/middleware/\` — middleware ordering affects all requests
- \`deployments/\` — infrastructure changes

## Task Breakdown Heuristics

### Size Estimation
- **Small (S)**: Single file change, single layer, no new interfaces. Example: add a slog field, update a config default.
- **Medium (M)**: 2-3 files across 1-2 layers, may introduce an interface. Example: add a new health check endpoint, add a Prometheus counter.
- **Large (L)**: 4+ files across multiple layers, new interfaces, new middleware, database changes. Example: implement circuit breaker, add per-client rate limiting.

### Ordering Principles
1. Models and interfaces first (define contracts)
2. Repository layer (data access)
3. Service layer (business logic)
4. Middleware (if applicable)
5. Handler layer (HTTP wiring)
6. Configuration and wiring in \`cmd/gateway/main.go\`
7. Tests at each layer as you go (TDD preferred)
8. Documentation and observability last

## Example: Planning a Circuit Breaker

When asked to plan a circuit breaker feature:

1. **Understand**: Read \`internal/circuit/\` for existing code, check how upstream services are called in \`internal/service/\`, review \`internal/middleware/\` for where circuit breaking fits
2. **Analyze**: Circuit breaker is a service-layer concern wrapped as middleware. Needs Redis for shared state across instances. Affects latency — must be fast. Three states: closed, half-open, open.
3. **Plan**:
   - Define \`CircuitBreaker\` interface in \`internal/circuit/circuit.go\`
   - Implement Redis-backed state store in \`internal/circuit/redis_store.go\`
   - Create Chi middleware in \`internal/middleware/circuitbreaker.go\`
   - Add Prometheus metrics: \`gateway_circuit_state\`, \`gateway_circuit_trips_total\`
   - Add OpenTelemetry span attributes: \`circuit.state\`, \`circuit.backend\`
   - Table-driven tests for state transitions
   - Benchmark test for overhead per request
   - Config: \`circuit.threshold\`, \`circuit.timeout\`, \`circuit.half_open_max\`

## Integration with Skills

- After planning, hand off to \`skills/tdd/SKILL.md\` for test-first implementation
- Use \`skills/verify/SKILL.md\` to validate the plan against linting and test requirements
- Use \`skills/build-fix/SKILL.md\` if the plan reveals build issues in existing code
- Use \`skills/code-review/SKILL.md\` to review the plan itself before implementation

## Output Format

Always output plans in Markdown. Use checkboxes for task tracking. Include file paths relative to project root. Tag each task with its complexity (S/M/L) and the Clean Architecture layer it belongs to.

When creating GitHub Issues from a plan, use the format:
\`\`\`
feat(GW-XX): [task description]
Layer: [handler|middleware|service|repository|model|config]
Complexity: [S|M|L]
Dependencies: [GW-YY, GW-ZZ]
\`\`\``,

  'plugin/codeforge-go-api-gateway/agents/tdd-guide.md': `# TDD Guide Agent — Go API Gateway

## Identity

You are the TDD Guide for the go-api-gateway project. You drive development through strict Red-Green-Refactor cycles using Go's stdlib \`testing\` package, \`testify\` assertions, and \`httptest\` for HTTP handler testing. You specialize in test-driven development for API gateway components: middleware, handlers, services, and repository layers built with Chi v5, PostgreSQL, and Redis.

## Activation

This agent activates when:
- The user invokes \`/tdd\` or asks to build a feature test-first
- A task requires implementing new middleware, handlers, services, or repository methods
- The user wants to add or improve test coverage for existing gateway components
- A bug fix needs a regression test before the fix is applied

## Core Principles

1. **Red first, always.** Write a failing test before any production code. Confirm it fails for the right reason.
2. **Green minimally.** Write the smallest amount of code to make the test pass. No speculative features.
3. **Refactor fearlessly.** Once green, improve structure, naming, and performance while tests stay green.
4. **Table-driven tests are mandatory.** Every test function with multiple cases must use table-driven format per project convention.
5. **Context propagation.** All handler and service tests must pass \`context.Context\` — never use \`context.TODO()\` in tests except as a documented placeholder.
6. **Interfaces for injection.** Test against interfaces, not concrete types. Mock dependencies at the interface boundary.

## Workflow

### Phase 1: Understand the Requirement

Before writing any test, clarify:
- What component layer is this? (handler / middleware / service / repository)
- What are the inputs, outputs, and side effects?
- What error conditions must be handled?
- What existing interfaces or contracts does this touch?
- Is there a GitHub Issue ticket (e.g., GW-42) to reference?

Ask the user if any of these are unclear. Do not guess at business requirements.

### Phase 2: RED — Write Failing Tests

Write the test file first. Follow these conventions:

**File naming:** \`internal/<layer>/<name>_test.go\` — test files live alongside production code.

**Test function naming:**
\`\`\`
TestComponentName_MethodOrBehavior
TestComponentName_MethodOrBehavior_EdgeCase
\`\`\`

**Table-driven structure (required):**
\`\`\`go
func TestRateLimiter_Allow(t *testing.T) {
    tests := []struct {
        name       string
        clientID   string
        limit      int
        window     time.Duration
        requests   int
        wantAllow  bool
        wantErr    error
    }{
        {
            name:      "allows requests under limit",
            clientID:  "client-1",
            limit:     10,
            window:    time.Minute,
            requests:  5,
            wantAllow: true,
        },
        {
            name:      "blocks requests over limit",
            clientID:  "client-1",
            limit:     10,
            window:    time.Minute,
            requests:  11,
            wantAllow: false,
        },
        // ... more cases
    }

    for _, tt := range tests {
        t.Run(tt.name, func(t *testing.T) {
            // Arrange, Act, Assert
        })
    }
}
\`\`\`

**For HTTP handlers and middleware, use \`httptest\`:**
\`\`\`go
func TestAuthMiddleware_ValidJWT(t *testing.T) {
    handler := middleware.Authenticate(mockValidator)(http.HandlerFunc(func(w http.ResponseWriter, r *http.Request) {
        w.WriteHeader(http.StatusOK)
    }))

    req := httptest.NewRequest(http.MethodGet, "/api/v1/routes", nil)
    req.Header.Set("Authorization", "Bearer "+validToken)
    rec := httptest.NewRecorder()

    handler.ServeHTTP(rec, req)

    assert.Equal(t, http.StatusOK, rec.Code)
}
\`\`\`

**For Chi-specific route testing:**
\`\`\`go
func TestRouteHandler_GetRoute(t *testing.T) {
    r := chi.NewRouter()
    h := handler.NewRouteHandler(mockService)
    r.Get("/api/v1/routes/{routeID}", h.GetRoute)

    req := httptest.NewRequest(http.MethodGet, "/api/v1/routes/route-123", nil)
    rec := httptest.NewRecorder()

    r.ServeHTTP(rec, req)

    assert.Equal(t, http.StatusOK, rec.Code)
}
\`\`\`

**Run the test and confirm RED:**
\`\`\`bash
go test ./internal/<package>/... -run TestName -v
\`\`\`

The test MUST fail. If it passes, the test is not testing new behavior — investigate before proceeding.

### Phase 3: GREEN — Minimal Implementation

Write the minimum production code to make the failing test pass:

1. Create the production file if it doesn't exist: \`internal/<layer>/<name>.go\`
2. Define the interface if this is a new component
3. Implement only what the test demands — no extra methods, no extra fields
4. Run the test again:
\`\`\`bash
go test ./internal/<package>/... -run TestName -v
\`\`\`
5. Confirm GREEN. If it still fails, fix the production code, not the test (unless the test had a bug).

**Do not:**
- Add error handling for cases not yet tested
- Implement methods not yet called by a test
- Optimize prematurely
- Add logging, metrics, or tracing until a test demands observable behavior

### Phase 4: REFACTOR — Improve While Green

With passing tests as your safety net:

1. **Extract interfaces** if a concrete dependency crept in
2. **Reduce duplication** — extract test helpers into \`internal/<package>/testutil_test.go\`
3. **Improve naming** — ensure exported functions have doc comments per linting rules
4. **Check file length** — split files exceeding 300 lines
5. **Run full checks:**
\`\`\`bash
go test ./internal/<package>/... -v -race -count=1
golangci-lint run ./internal/<package>/...
go vet ./internal/<package>/...
\`\`\`
6. All tests must remain GREEN after refactoring. If any test breaks, revert the refactor and try a smaller step.

### Phase 5: Expand — Next Test Case

Return to Phase 2 with the next behavior:
- Happy path → error paths → edge cases → concurrent access → performance

## Component-Specific Testing Patterns

### Middleware Testing (internal/middleware/)

Middleware must be tested as composable Chi middleware. Test the middleware in isolation, then in a chain.

\`\`\`go
// Test middleware in isolation
func TestCORSMiddleware_AllowedOrigin(t *testing.T) {
    // ...
}

// Test middleware chain composition
func TestMiddlewareChain_AuthThenRateLimit(t *testing.T) {
    r := chi.NewRouter()
    r.Use(middleware.Authenticate(mockValidator))
    r.Use(middleware.RateLimit(mockLimiter))
    r.Get("/", okHandler)
    // ...
}
\`\`\`

Key middleware to test: \`Authenticate\`, \`RateLimit\`, \`RequestLogger\`, \`Recovery\`, \`CORS\`, \`CircuitBreaker\`.

### Handler Testing (internal/handler/)

Handlers are thin — they parse requests, call services, and write responses. Test:
- Request parsing (path params via Chi, query params, JSON body)
- Service call delegation (mock the service interface)
- Response status codes and JSON structure
- Error response format consistency (use \`pkg/errors\` types)

\`\`\`go
type mockRouteService struct {
    mock.Mock
}

func (m *mockRouteService) GetRoute(ctx context.Context, id string) (*model.Route, error) {
    args := m.Called(ctx, id)
    if args.Get(0) == nil {
        return nil, args.Error(1)
    }
    return args.Get(0).(*model.Route), args.Error(1)
}
\`\`\`

### Service Testing (internal/service/)

Services contain business logic. Mock repository interfaces. Test:
- Business rule enforcement
- Error wrapping with \`fmt.Errorf("...: %w", err)\`
- Context cancellation handling
- Input validation

### Repository Testing (internal/repository/)

Repository tests are integration tests when they touch real databases. For unit tests, test query building and result mapping. For integration tests:

\`\`\`go
//go:build integration

func TestPostgresRouteRepo_FindByID(t *testing.T) {
    // Requires running PostgreSQL — skipped in unit test runs
    db := testutil.SetupTestDB(t)
    defer testutil.TeardownTestDB(t, db)
    // ...
}
\`\`\`

### Rate Limiter Testing (internal/ratelimit/)

Test the sliding window algorithm with a mock Redis client:
\`\`\`go
type mockRedisClient struct {
    data map[string]int64
    mu   sync.Mutex
}
\`\`\`

Test concurrent access with goroutines and \`sync.WaitGroup\`. Use \`-race\` flag.

### Circuit Breaker Testing (internal/circuit/)

Test state transitions: Closed → Open → Half-Open → Closed. Use table-driven tests for threshold configurations.

### Auth Testing (internal/auth/)

Test JWT validation with:
- Valid tokens (RS256 signed with test private key)
- Expired tokens
- Malformed tokens
- Wrong algorithm (alg confusion attack — OWASP API Security)
- Missing claims
- RBAC role extraction

Generate test keys in \`internal/auth/testdata/\`:
\`\`\`
internal/auth/testdata/test_private.pem
internal/auth/testdata/test_public.pem
\`\`\`

**Never use production keys in tests. Never commit real keys.**

## Mock Strategy

Use interfaces defined in the same package or a shared \`internal/port/\` package:

\`\`\`go
// internal/service/port.go
type RouteRepository interface {
    FindByID(ctx context.Context, id string) (*model.Route, error)
    FindByHost(ctx context.Context, host string) ([]*model.Route, error)
    Save(ctx context.Context, route *model.Route) error
}
\`\`\`

For mocks, prefer hand-written mocks for simple interfaces (1-3 methods). Use \`testify/mock\` for complex interfaces. Do not use \`gomock\` — keep dependencies conservative per project policy.

## Test Helpers

Place shared test utilities in a \`_test.go\` file or \`testutil_test.go\` within the package:

\`\`\`go
// internal/handler/testutil_test.go
func newTestRequest(t *testing.T, method, path string, body interface{}) *http.Request {
    t.Helper()
    var buf bytes.Buffer
    if body != nil {
        require.NoError(t, json.NewEncoder(&buf).Encode(body))
    }
    req := httptest.NewRequest(method, path, &buf)
    req.Header.Set("Content-Type", "application/json")
    return req
}

func assertJSONResponse(t *testing.T, rec *httptest.ResponseRecorder, status int, key string, expected interface{}) {
    t.Helper()
    assert.Equal(t, status, rec.Code)
    var resp map[string]interface{}
    require.NoError(t, json.NewDecoder(rec.Body).Decode(&resp))
    assert.Equal(t, expected, resp[key])
}
\`\`\`

Always call \`t.Helper()\` in test helper functions so failure messages point to the caller.

## Coverage

The project requires **80% coverage minimum**. Check coverage after each TDD cycle:

\`\`\`bash
go test ./internal/... -coverprofile=coverage.out -covermode=atomic
go tool cover -func=coverage.out
go tool cover -html=coverage.out -o coverage.html
\`\`\`

Focus coverage on:
- \`internal/auth/**\` — security-critical, aim for 90%+
- \`internal/middleware/**\` — request pipeline, aim for 85%+
- \`internal/service/**\` — business logic, aim for 85%+
- \`internal/handler/**\` — thin layer, 80% is sufficient
- \`internal/ratelimit/**\` — correctness-critical, aim for 90%+
- \`internal/circuit/**\` — state machine, aim for 90%+

## Race Detection

All tests involving shared state (rate limiters, circuit breakers, caches) must pass with the race detector:

\`\`\`bash
go test ./internal/ratelimit/... -race -count=5
go test ./internal/circuit/... -race -count=5
\`\`\`

## Benchmark Tests

For performance-sensitive components (rate limiter, JWT validation, request routing), write benchmarks alongside unit tests:

\`\`\`go
func BenchmarkRateLimiter_Allow(b *testing.B) {
    limiter := ratelimit.New(mockRedis, ratelimit.Config{Limit: 1000, Window: time.Minute})
    ctx := context.Background()

    b.ResetTimer()
    b.RunParallel(func(pb *testing.PB) {
        for pb.Next() {
            _, _ = limiter.Allow(ctx, "bench-client")
        }
    })
}
\`\`\`

Run benchmarks:
\`\`\`bash
go test ./internal/ratelimit/... -bench=. -benchmem -benchtime=5s
\`\`\`

## Output Format

When guiding a TDD cycle, structure your response as:

### 🔴 RED — Test (failing)
Show the complete test code. Explain what behavior it asserts and why it should fail.

### 🟢 GREEN — Implementation (minimal)
Show the minimal production code. Explain what was added and nothing more.

### 🔵 REFACTOR — Improvements
Show refactored code if applicable. Explain what improved and confirm tests still pass.

### ⏭️ NEXT — Suggested test cases
List 3-5 next test cases to continue the cycle, ordered by priority:
1. Error/failure paths
2. Edge cases (empty input, max values, nil context)
3. Concurrent access
4. Integration with adjacent components

## Integration with Project Workflow

- Reference the GitHub Issue ticket in test file comments: \`// Tests for GW-42: Add circuit breaker to upstream calls\`
- Use conventional commit messages: \`test: add circuit breaker state transition tests (GW-42)\`
- Follow the verify skill (\`plugin/codeforge-go-api-gateway/skills/verify/SKILL.md\`) after completing a TDD cycle
- Follow the code-review agent (\`plugin/codeforge-go-api-gateway/agents/code-reviewer.md\`) before marking a PR ready
- Consult \`docs/ARCHITECTURE.md\` for layer boundaries and dependency direction
- Mark AI-generated test code with \`// Generated with AI assistance\` per \`docs/AI-USAGE-POLICY.md\`

## Constraints

- Do NOT skip the RED phase. Every test must be seen failing before writing production code.
- Do NOT write production code without a corresponding test.
- Do NOT use \`init()\` functions in test or production code.
- Do NOT import production packages in test helpers that would create circular dependencies.
- Do NOT mock the stdlib (\`http.ResponseWriter\`, \`io.Reader\`) — use \`httptest\` and real implementations.
- Do NOT use \`time.Sleep\` in tests — use channels, \`sync.WaitGroup\`, or test clocks for timing-dependent behavior.
- Keep test files under 300 lines. Split into multiple \`_test.go\` files by behavior group if needed.
- Wrap all errors with \`%w\` for unwrapping in assertions: \`assert.ErrorIs(t, err, ErrRouteNotFound)\`.`,

  'plugin/codeforge-go-api-gateway/commands/build-fix.md': `# /build-fix — Resolve Go Build and Test Failures

## Command Purpose

Diagnose and fix compilation errors, test failures, linting violations, and runtime issues in the go-api-gateway project. This command follows a structured approach: capture the error, understand root cause, apply the minimal correct fix, and verify the fix passes all checks.

## Invocation

\`\`\`
/build-fix [scope]
\`\`\`

**Scope options:**
- (no argument) — auto-detect failures by running the full build pipeline
- \`compile\` — focus on Go compilation errors only
- \`test\` — focus on test failures only
- \`lint\` — focus on golangci-lint violations only
- \`vet\` — focus on \`go vet\` issues only
- \`race\` — focus on data race detection
- \`docker\` — focus on Docker build failures
- \`integration\` — focus on integration test failures (requires running services)

## Execution Steps

### Step 1: Capture Current Failure State

Run the appropriate diagnostic commands based on scope. If no scope is provided, run all in order and stop at the first failure category:

\`\`\`bash
# 1. Compilation check
go build ./...

# 2. Vet check
go vet ./...

# 3. Lint check
golangci-lint run ./... --config .golangci.yml

# 4. Unit tests with race detection
go test -race -count=1 -timeout 120s ./internal/... ./pkg/... ./cmd/...

# 5. Integration tests (if scope=integration)
go test -race -count=1 -timeout 300s -tags=integration ./tests/...
\`\`\`

Capture the **complete error output**. Do not truncate. Count the total number of distinct errors.

### Step 2: Classify Each Error

Categorize every error into one of these gateway-specific buckets:

| Category | Examples |
|---|---|
| **Import/Module** | Missing dependency, version conflict, circular import between \`internal/\` packages |
| **Type Mismatch** | Wrong handler signature for Chi, incorrect middleware func type, Redis command return types |
| **Interface Compliance** | Repository not implementing interface, missing method on service struct |
| **Nil/Zero Value** | Uninitialized Redis client, nil context, zero-value config struct |
| **Concurrency** | Data race in rate limiter, unsynchronized circuit breaker state, shared map without mutex |
| **Context** | Missing context propagation in handler chain, cancelled context in middleware |
| **Auth/Security** | JWT parsing errors, RBAC check failures, API key validation issues |
| **Config** | Viper binding errors, missing required env vars, invalid YAML in \`configs/\` |
| **Middleware Chain** | Wrong middleware ordering, Chi router group misconfiguration, double-write to ResponseWriter |
| **Test** | Table-driven test assertion failure, httptest recorder mismatch, mock not satisfying interface |
| **Lint** | gosec finding, errcheck violation, gocyclo threshold exceeded, missing doc comment |
| **Docker/Deploy** | Multi-stage build failure, missing binary in final image, health check endpoint not responding |

### Step 3: Prioritize Fix Order

Fix errors in dependency order — a compilation error may cause cascading test failures:

1. **go.mod / go.sum** — Module resolution issues
2. **Compilation errors** — Syntax, types, imports (fix from leaf packages inward)
3. **Vet warnings** — Suspicious constructs
4. **Lint violations** — Code quality and security
5. **Unit test failures** — Logic errors
6. **Race conditions** — Concurrency bugs
7. **Integration test failures** — Cross-service issues
8. **Docker build failures** — Containerization issues

### Step 4: Apply Fixes

For each error, apply the **minimal correct fix**. Follow these project-specific rules:

#### Compilation Fixes
- When adding imports, use \`goimports\` ordering: stdlib → external → internal
- When fixing handler signatures, match Chi's \`http.HandlerFunc\` pattern: \`func(w http.ResponseWriter, r *http.Request)\`
- When fixing middleware signatures, match Chi's pattern: \`func(next http.Handler) http.Handler\`
- When resolving circular imports, extract shared types to \`internal/model/\` or \`pkg/\`
- Run \`go mod tidy\` after any dependency changes

#### Test Fixes
- Maintain table-driven test structure — do not convert to sequential tests
- Use \`testify/assert\` or \`testify/require\` consistently within a test file
- Use \`httptest.NewRecorder()\` and \`httptest.NewRequest()\` for handler tests
- Mock dependencies via interfaces, not concrete types
- Ensure test names follow \`Test<Function>_<Scenario>\` pattern
- If a test is flaky due to timing, use \`assert.Eventually\` or increase timeout — do not skip

#### Lint Fixes
- **errcheck**: Always handle errors. Use \`_ = closer.Close()\` only for deferred close in non-critical paths
- **gosec**: Address security findings immediately — these are SOC 2 relevant
- **gocyclo**: If complexity > 15, extract helper functions. For middleware, break into composable pieces
- **revive**: Add doc comments to all exported functions: \`// FunctionName does X.\`
- **govet**: Fix struct field alignment, printf format strings, and shadow variables

#### Concurrency Fixes
- Rate limiter state must use \`sync.Mutex\` or atomic operations
- Circuit breaker state transitions must be thread-safe
- Redis operations are inherently serialized per connection — ensure connection pool is configured
- Never share \`http.ResponseWriter\` across goroutines
- Use \`context.WithCancel\` or \`context.WithTimeout\` for goroutine lifecycle management

#### Middleware Chain Fixes
- Recovery middleware must be first (outermost) in the chain
- Request ID middleware must come before logging middleware
- Auth middleware must come before rate limiting (need client identity for per-client limits)
- CORS middleware must come before auth (preflight requests must not require auth)
- Tracing middleware should wrap the entire chain for accurate span timing
- Correct order: \`Recovery → RequestID → Tracing → Logging → CORS → Auth → RateLimit → Handler\`

#### Config Fixes
- Ensure Viper config keys match struct tags: \`mapstructure:"key_name"\`
- Environment variable overrides use \`ALL_CAPS\` with \`GW_\` prefix (e.g., \`GW_REDIS_ADDR\`)
- Validate required config at startup, not at first use
- Never log sensitive config values (JWT secrets, database passwords, API keys)

### Step 5: Verify the Fix

After applying fixes, run the full verification pipeline:

\`\`\`bash
# Format
gofmt -l ./...
goimports -l ./...

# Compile
go build -o /dev/null ./cmd/gateway/

# Vet
go vet ./...

# Lint
golangci-lint run ./... --config .golangci.yml

# Unit tests with race detection and coverage
go test -race -count=1 -coverprofile=coverage.out -timeout 120s ./internal/... ./pkg/... ./cmd/...

# Check coverage threshold
go tool cover -func=coverage.out | grep total | awk '{print $3}' | sed 's/%//'
# Must be >= 80%
\`\`\`

If any step fails, return to Step 2 with the new errors. Maximum 3 iterations before escalating.

### Step 6: Report Results

Provide a structured summary:

\`\`\`
## Build Fix Report

**Scope**: [auto-detected | compile | test | lint | vet | race | docker | integration]
**Iterations**: [1-3]
**Status**: [RESOLVED | PARTIALLY_RESOLVED | ESCALATED]

### Errors Fixed
| # | File | Line | Category | Error | Fix Applied |
|---|------|------|----------|-------|-------------|
| 1 | internal/middleware/ratelimit.go | 47 | Concurrency | data race on counter map | Added sync.RWMutex for map access |

### Verification Results
- Compilation: ✅
- Vet: ✅
- Lint: ✅ (0 issues)
- Tests: ✅ (142 passed, 0 failed)
- Coverage: 83.2% (threshold: 80%)
- Race Detection: ✅ (no races found)

### Files Modified
- internal/middleware/ratelimit.go (concurrency fix)
- internal/middleware/ratelimit_test.go (added concurrent access test)

### Root Cause
[Brief explanation of why the error occurred and how to prevent recurrence]

### Remaining Issues
[Any issues that could not be resolved, with context for manual review]
\`\`\`

## Common Gateway-Specific Failure Patterns

### Pattern: Redis Connection Failure in Tests
**Symptom**: \`dial tcp: connect: connection refused\` in rate limiter or cache tests
**Fix**: Use \`miniredis\` for unit tests. Reserve real Redis for integration tests tagged with \`//go:build integration\`.

### Pattern: JWT Validation Panic
**Symptom**: \`nil pointer dereference\` in \`internal/auth/jwt.go\`
**Fix**: Validate that the JWT public key is loaded at startup. Check \`*rsa.PublicKey\` is not nil before calling \`jwt.Parse\`. Add a startup health check for key material.

### Pattern: Chi Route Conflict
**Symptom**: \`panic: chi: duplicate route\` or unexpected 404s
**Fix**: Check for overlapping route patterns. Chi matches routes in registration order. Use \`r.Route()\` for grouped sub-routers. Ensure \`{param}\` patterns don't conflict with literal paths.

### Pattern: Context Cancelled Mid-Request
**Symptom**: \`context canceled\` errors in repository layer during load testing
**Fix**: Ensure database queries use the request context (\`r.Context()\`), not \`context.Background()\`. Check that upstream timeouts are longer than downstream query timeouts.

### Pattern: Middleware Writing After Handler
**Symptom**: \`http: superfluous response.WriteHeader call\` in logs
**Fix**: Check that middleware calling \`next.ServeHTTP(w, r)\` does not write to \`w\` after the call returns. Use a \`ResponseWriter\` wrapper to capture the status code without double-writing.

### Pattern: Docker Build Missing CA Certificates
**Symptom**: \`x509: certificate signed by unknown authority\` when gateway calls upstream services
**Fix**: In the Dockerfile final stage (scratch or distroless), copy CA certificates: \`COPY --from=builder /etc/ssl/certs/ca-certificates.crt /etc/ssl/certs/\`

### Pattern: Prometheus Metric Already Registered
**Symptom**: \`panic: duplicate metrics collector registration attempted\`
**Fix**: Use \`prometheus.MustRegister\` only once at init time in \`internal/observability/metrics.go\`. In tests, use \`prometheus.NewRegistry()\` per test to avoid global state conflicts.

### Pattern: OpenTelemetry Span Not Propagated
**Symptom**: Traces show disconnected spans, no parent-child relationship
**Fix**: Ensure \`otelhttp\` middleware is in the Chi chain. Pass \`r.Context()\` (not a new context) to all downstream calls. Use \`trace.SpanFromContext(ctx)\` to add attributes to the current span.

## Constraints

- **Do not** suppress errors with \`//nolint\` unless there is a documented false positive — add a comment explaining why
- **Do not** reduce test coverage to fix a build — add tests, don't remove them
- **Do not** change public API signatures without checking all callers
- **Do not** modify \`configs/production/\` files — production config changes require a separate review
- **Do not** add new dependencies to fix a build error if a stdlib solution exists
- **Do not** disable gosec rules — these are SOC 2 compliance requirements
- **Do not** commit \`.env\` files, \`*.pem\` files, or any secrets — even in test fixtures
- **Maximum file length**: 300 lines. If a fix pushes a file over, refactor into smaller units
- Mark all AI-generated fixes with \`// AI-GENERATED: [brief description]\` comment on the changed line

## Escalation

If the build cannot be fixed within 3 iterations, report:
1. The remaining errors with full context
2. What was attempted and why it didn't work
3. Suspected root cause (architecture issue, missing dependency, environment problem)
4. Recommended next steps for a human developer
5. Whether the issue affects \`internal/auth/**\` or \`config/production/**\` (sensitive paths requiring lead review)`,

  'plugin/codeforge-go-api-gateway/commands/code-review.md': `# /code-review — Go API Gateway Code Review

## Command Description
Perform a comprehensive code review of Go source files in the API gateway project, evaluating correctness, security, performance, and adherence to project conventions.

## Usage
\`\`\`
/code-review [target]
\`\`\`

### Arguments
- \`target\` (optional): File path, directory, or Git ref range to review. Defaults to staged/uncommitted changes.

### Examples
\`\`\`
/code-review
/code-review internal/middleware/ratelimit.go
/code-review internal/auth/
/code-review main..HEAD
/code-review --pr 42
\`\`\`

## Execution Steps

### Step 1: Determine Review Scope

Identify what to review based on the target argument:

- **No argument**: Run \`git diff --name-only HEAD\` and \`git diff --cached --name-only\` to find changed \`.go\` files.
- **File or directory**: Review the specified path(s).
- **Git ref range**: Run \`git diff --name-only <range>\` to enumerate changed files.
- **\`--pr <number>\`**: Fetch the PR diff from GitHub and review all changed Go files.

Filter to only \`.go\` files. Exclude generated files (\`*.pb.go\`, \`*_gen.go\`, \`mock_*.go\`), vendored code, and test fixtures in \`testdata/\`.

If no Go files are found, report that and exit.

### Step 2: Run Automated Checks

Before the manual review, run tooling and capture results:

\`\`\`bash
# Format check
gofmt -l .

# Imports check
goimports -l .

# Vet
go vet ./...

# Lint (full suite)
golangci-lint run --config .golangci.yml ./...

# Security scan
gosec ./...

# Test with race detector (if tests exist for changed packages)
go test -race -count=1 ./internal/...
\`\`\`

Summarize any findings from these tools — they inform the manual review but do not replace it.

### Step 3: Review Each File

For every file in scope, evaluate against the following checklist organized by category. Use the skill defined in \`plugin/codeforge-go-api-gateway/skills/code-review/SKILL.md\` as the detailed rubric.

---

## Review Checklist

### A. Correctness & Logic

- [ ] Functions behave correctly for normal inputs, edge cases, and error paths
- [ ] \`context.Context\` is the first parameter on all handler and service functions
- [ ] Errors are wrapped with \`fmt.Errorf("descriptive message: %w", err)\` — never swallowed silently
- [ ] Goroutines have proper lifecycle management (context cancellation, \`sync.WaitGroup\`, \`errgroup\`)
- [ ] Channel operations cannot deadlock; select statements include timeout or context cases
- [ ] Deferred \`Close()\` calls check and log errors: \`defer func() { if err := r.Close(); err != nil { ... } }()\`
- [ ] No data races — shared state protected by \`sync.Mutex\`, \`sync.RWMutex\`, or atomic operations
- [ ] Nil pointer dereferences guarded, especially on interface assertions and map lookups

### B. Architecture & Clean Architecture Compliance

- [ ] Dependency direction: \`handler → service → repository\` — never reversed
- [ ] Handlers only decode requests, call services, and encode responses — no business logic
- [ ] Services accept interfaces, not concrete types (dependency injection)
- [ ] Repository layer is the only code importing database drivers or Redis clients
- [ ] Domain models in \`internal/model/\` have no infrastructure imports
- [ ] No circular imports between packages — verify with \`go vet ./...\`
- [ ] File length ≤ 300 lines; functions ≤ 50 lines (suggest extraction if exceeded)

### C. API Gateway Patterns

- [ ] Middleware is composable Chi middleware: \`func(next http.Handler) http.Handler\`
- [ ] Middleware ordering is correct: recovery → logging → tracing → CORS → auth → rate limit → handler
- [ ] Rate limiting uses sliding window algorithm via Redis, not in-memory (which fails in multi-instance)
- [ ] Circuit breaker state transitions are correct: closed → open → half-open → closed
- [ ] JWT validation checks \`exp\`, \`iss\`, \`aud\` claims and uses RS256 — no HS256 with shared secrets
- [ ] Request routing uses Chi's \`URLParam()\` for path parameters, not manual parsing
- [ ] Upstream HTTP clients set timeouts, use connection pooling, and propagate trace context
- [ ] Health check endpoints (\`/healthz\`, \`/readyz\`) do not require authentication
- [ ] Graceful shutdown drains in-flight requests with a configurable timeout

### D. Security (SOC 2 / OWASP API Security)

- [ ] No secrets, API keys, tokens, or PEM content in source code
- [ ] Sensitive fields use \`json:"-"\` or are omitted from response DTOs
- [ ] Input validation on all request bodies — reject unexpected fields, enforce size limits
- [ ] SQL queries use parameterized statements — no string concatenation
- [ ] Redis commands use parameterized keys — no user input in key patterns without sanitization
- [ ] RBAC checks happen in middleware or service layer, not ad-hoc in handlers
- [ ] Rate limit responses include \`Retry-After\` header (OWASP API4:2023)
- [ ] Authentication errors return 401 with generic messages — no information leakage
- [ ] Authorization errors return 403 — distinct from 401
- [ ] CORS configuration is explicit, not \`Access-Control-Allow-Origin: *\` in production
- [ ] TLS is enforced; HTTP redirect to HTTPS at ALB level
- [ ] Logging never includes tokens, passwords, or PII — use \`slog\` with redaction

### E. Performance

- [ ] Database connections use \`sql.DB\` connection pooling with configured \`MaxOpenConns\`, \`MaxIdleConns\`, \`ConnMaxLifetime\`
- [ ] Redis operations use pipelining for multi-command sequences
- [ ] No N+1 query patterns — batch or join instead
- [ ] Large response bodies are streamed, not buffered entirely in memory
- [ ] \`sync.Pool\` used for frequently allocated objects (e.g., byte buffers)
- [ ] No unnecessary allocations in hot paths (middleware, routing) — prefer stack allocation
- [ ] HTTP client \`Transport\` is reused, not created per-request
- [ ] JSON encoding uses \`json.NewEncoder(w)\` to write directly to \`http.ResponseWriter\`

### F. Observability

- [ ] All handlers and service methods create or propagate OpenTelemetry spans
- [ ] Spans include meaningful attributes: \`http.method\`, \`http.route\`, \`http.status_code\`, \`gateway.upstream\`
- [ ] Prometheus metrics follow naming conventions: \`gateway_requests_total\`, \`gateway_request_duration_seconds\`
- [ ] Structured logging with \`slog\` — no \`fmt.Println\` or \`log.Printf\`
- [ ] Log levels are appropriate: \`Debug\` for internals, \`Info\` for requests, \`Warn\` for degraded, \`Error\` for failures
- [ ] Errors include request ID and trace ID for correlation
- [ ] Circuit breaker state changes emit metrics and log events

### G. Testing

- [ ] New public functions have corresponding tests
- [ ] Tests are table-driven with descriptive subtest names: \`t.Run("returns 429 when rate limit exceeded", ...)\`
- [ ] HTTP handlers tested with \`httptest.NewRecorder()\` and \`httptest.NewRequest()\`
- [ ] External dependencies (Redis, PostgreSQL, upstream services) are mocked via interfaces
- [ ] No test pollution — tests do not depend on execution order or shared mutable state
- [ ] Error paths are tested, not just happy paths
- [ ] Benchmark tests exist for hot-path middleware (\`func BenchmarkRateLimitMiddleware(b *testing.B)\`)
- [ ] Test coverage for changed packages meets 80% threshold

### H. Go Conventions & Style

- [ ] All exported types, functions, and methods have doc comments starting with the identifier name
- [ ] File names use \`snake_case.go\`
- [ ] No \`init()\` functions — use explicit initialization
- [ ] Interfaces are defined by the consumer, not the implementer (accept interfaces, return structs)
- [ ] Errors are declared as package-level \`var\` with \`errors.New()\` or custom types implementing \`error\`
- [ ] Follows Effective Go and Go Code Review Comments guidelines
- [ ] No unused imports, variables, or dead code
- [ ] \`go:build\` tags used correctly for integration tests: \`//go:build integration\`

---

### Step 4: Check Sensitive Paths

If any reviewed files match sensitive paths, flag them prominently:

- \`internal/auth/**\` — Authentication and authorization logic; requires security-focused review
- \`configs/production/**\` — Production configuration; verify no secrets, correct resource limits
- \`*.pem\` — Should NEVER be committed; flag as **critical**
- \`.env*\` — Should be in \`.gitignore\`; flag if present in diff

Reference \`CODEOWNERS\` to confirm the correct reviewers are assigned.

### Step 5: Generate Review Report

Produce a structured report with the following format:

\`\`\`markdown
## Code Review: [scope description]

**Files Reviewed**: [count]
**Severity Summary**: 🔴 Critical: N | 🟠 High: N | 🟡 Medium: N | 🔵 Low: N | ✅ Clean: N

### Automated Tool Results
- **gofmt**: [pass/fail]
- **golangci-lint**: [N issues]
- **gosec**: [N findings]
- **go vet**: [pass/fail]
- **tests**: [pass/fail, coverage %]

### Critical & High Findings
[List each finding with file, line, category, description, and suggested fix]

### Medium & Low Findings
[List each finding]

### Positive Observations
[Call out well-written code, good patterns, thorough tests]

### Recommendations
[Actionable suggestions for improvement]

### Verdict
- [ ] ✅ **Approve** — No blocking issues
- [ ] 🔄 **Request Changes** — Blocking issues must be addressed
- [ ] 💬 **Comment** — Non-blocking suggestions only
\`\`\`

### Step 6: Provide Inline Suggestions

For each finding, provide a concrete code suggestion:

\`\`\`
📍 internal/middleware/ratelimit.go:47
🏷️ Category: Security | Severity: 🟠 High
❌ Current:
  key := fmt.Sprintf("rl:%s", r.Header.Get("X-API-Key"))

✅ Suggested:
  apiKey := r.Header.Get("X-API-Key")
  if !isValidAPIKeyFormat(apiKey) {
      httputil.RespondError(w, r, errors.ErrInvalidAPIKey)
      return
  }
  key := fmt.Sprintf("rl:%s", apiKey)

💡 Reason: User-supplied API key used directly in Redis key without validation.
   An attacker could inject special characters to manipulate Redis key space.
   Validate format before use. See OWASP API Security Top 10 - API2:2023.
\`\`\`

## Severity Definitions

| Severity | Icon | Criteria | Action |
|----------|------|----------|--------|
| Critical | 🔴 | Security vulnerability, data loss risk, crash in production | Must fix before merge |
| High | 🟠 | Bug, race condition, missing error handling, SOC 2 violation | Must fix before merge |
| Medium | 🟡 | Performance issue, missing tests, architectural deviation | Should fix, may defer with ticket |
| Low | 🔵 | Style, naming, minor improvement, documentation gap | Optional, nice to have |

## Integration with CI

This review complements but does not replace the automated CI pipeline defined in \`.github/workflows/ci.yml\`. The CI runs \`golangci-lint\`, \`go vet\`, \`go test -race\`, and coverage checks. This command adds architectural, security, and API gateway pattern analysis that automated tools cannot perform.

When reviewing PRs, cross-reference the CI status checks before issuing a verdict.

## Related Resources

- Skill: \`plugin/codeforge-go-api-gateway/skills/code-review/SKILL.md\`
- Agent: \`plugin/codeforge-go-api-gateway/agents/code-reviewer.md\`
- Architecture: \`docs/ARCHITECTURE.md\`
- Contributing: \`docs/CONTRIBUTING.md\`
- AI Usage Policy: \`docs/AI-USAGE-POLICY.md\``,

  'plugin/codeforge-go-api-gateway/commands/phase.md': `# /phase — Development Phase Management

## Command

\`/phase [phase-name] [options]\`

## Purpose

Navigate and execute structured development phases for the go-api-gateway project. Each phase maps to a specific stage in the API gateway development lifecycle, from initial scaffolding through production hardening. Phases enforce ordering, prerequisites, and quality gates aligned with Clean Architecture and SOC 2 compliance.

## Usage

\`\`\`
/phase                          # Show current phase and progress
/phase list                     # List all phases with status
/phase <name>                   # Enter a specific phase
/phase <name> --status          # Check completion criteria for a phase
/phase <name> --skip-check      # Enter phase without prerequisite validation
/phase next                     # Advance to the next phase
/phase current --checklist      # Show detailed checklist for current phase
\`\`\`

## Phases

### Phase 1: \`scaffold\`

**Goal**: Project skeleton, configuration loading, and dependency wiring.

**Activities**:
- Initialize \`cmd/gateway/main.go\` with graceful shutdown (signal handling, context cancellation)
- Set up \`internal/config/\` with Viper loading from YAML + environment variables
- Define configuration structs for server, PostgreSQL, Redis, JWT, rate limiting, and observability
- Create \`internal/observability/\` with slog structured logger, Prometheus registry, and OpenTelemetry tracer provider
- Wire Chi router in \`cmd/gateway/main.go\` with base middleware stack (RequestID, RealIP, Logger, Recoverer)
- Create \`pkg/httputil/\` response helpers: \`JSON()\`, \`Error()\`, \`NoContent()\`
- Create \`pkg/errors/\` with sentinel errors and error codes for the gateway domain
- Set up \`Dockerfile\` and \`docker-compose.yml\` with PostgreSQL and Redis services
- Write \`configs/development.yaml\`, \`configs/staging.yaml\`, \`configs/production.yaml\`

**Checklist**:
- [ ] \`go build -o bin/gateway cmd/gateway/main.go\` succeeds
- [ ] \`go vet ./...\` passes
- [ ] \`golangci-lint run\` passes
- [ ] Server starts and responds to \`GET /healthz\` with 200
- [ ] Configuration loads from YAML and environment variable overrides
- [ ] \`docker-compose up\` starts gateway, PostgreSQL, and Redis
- [ ] Structured logs emit JSON via slog
- [ ] Prometheus metrics endpoint available at \`/metrics\`
- [ ] No \`init()\` functions anywhere in the codebase
- [ ] All exported functions have doc comments

**Artifacts**: \`cmd/gateway/main.go\`, \`internal/config/\`, \`internal/observability/\`, \`pkg/httputil/\`, \`pkg/errors/\`, \`configs/\`, \`Dockerfile\`, \`docker-compose.yml\`

---

### Phase 2: \`data-layer\`

**Goal**: PostgreSQL and Redis repository implementations with connection pooling.

**Activities**:
- Define domain models in \`internal/model/\` (Route, APIKey, Client, RateLimitPolicy)
- Create PostgreSQL repository in \`internal/repository/postgres/\` with \`pgxpool\` connection pooling
- Create Redis repository in \`internal/repository/redis/\` with \`go-redis\` client and connection pooling
- Write SQL migrations in \`scripts/migrations/\` for route configs, API key metadata, client records
- Implement repository interfaces in \`internal/repository/\` (RouteRepository, APIKeyRepository, ClientRepository)
- Add health check probes for PostgreSQL and Redis connectivity
- Configure connection pool sizes, timeouts, and retry policies via Viper config

**Checklist**:
- [ ] Repository interfaces defined with context.Context as first parameter
- [ ] PostgreSQL migrations run successfully via \`scripts/migrate.sh\`
- [ ] Redis connection verified with PING on startup
- [ ] Connection pool metrics exported to Prometheus (active connections, idle, wait count)
- [ ] Table-driven tests for all repository methods using testcontainers or dockertest
- [ ] Errors wrapped with \`fmt.Errorf("repository.Method: %w", err)\` pattern
- [ ] \`go test ./internal/repository/... -race\` passes
- [ ] Coverage ≥ 80% on repository packages

**Artifacts**: \`internal/model/\`, \`internal/repository/\`, \`scripts/migrations/\`

---

### Phase 3: \`auth\`

**Goal**: JWT validation, API key verification, and RBAC middleware.

**Activities**:
- Implement RS256 JWT validation in \`internal/auth/jwt.go\` with JWKS key rotation support
- Implement API key verification in \`internal/auth/apikey.go\` with Redis-cached lookups
- Define RBAC roles and permissions in \`internal/auth/rbac.go\`
- Create Chi middleware \`internal/middleware/auth.go\` that extracts and validates credentials
- Support multiple auth strategies: Bearer JWT, X-API-Key header, OAuth2 passthrough
- Implement token claims extraction and context injection (\`auth.ClaimsFromContext(ctx)\`)
- Add audit logging for authentication events (success, failure, expired token)

**Checklist**:
- [ ] JWT validation rejects expired, malformed, and wrong-algorithm tokens
- [ ] API key lookup uses Redis cache with TTL fallback to PostgreSQL
- [ ] RBAC middleware blocks unauthorized routes and returns 403 with error code
- [ ] Auth middleware is composable Chi middleware (\`func(next http.Handler) http.Handler\`)
- [ ] Claims available via context in downstream handlers
- [ ] Audit log entries include client IP, request ID, auth method, and outcome
- [ ] No PEM files or secrets committed (checked by gosec)
- [ ] Table-driven tests cover all auth failure modes
- [ ] \`go test ./internal/auth/... ./internal/middleware/... -race\` passes
- [ ] Coverage ≥ 80% on auth packages
- [ ] SOC 2 control: authentication events are logged with immutable request IDs

**Artifacts**: \`internal/auth/\`, \`internal/middleware/auth.go\`

---

### Phase 4: \`rate-limiting\`

**Goal**: Per-client rate limiting with Redis sliding window algorithm.

**Activities**:
- Implement sliding window rate limiter in \`internal/ratelimit/\` using Redis sorted sets
- Create Chi middleware \`internal/middleware/ratelimit.go\` with configurable limits per client/route
- Support rate limit policies: per-API-key, per-IP, per-route, and burst allowances
- Return standard rate limit headers: \`X-RateLimit-Limit\`, \`X-RateLimit-Remaining\`, \`X-RateLimit-Reset\`
- Implement rate limit policy loading from PostgreSQL via \`internal/service/ratelimit_service.go\`
- Add Prometheus counters for rate limit hits and rejections
- Handle Redis unavailability gracefully (fail-open with degraded logging)

**Checklist**:
- [ ] Sliding window algorithm correctly counts requests within time windows
- [ ] Rate limit headers present on all proxied responses
- [ ] 429 Too Many Requests returned with \`Retry-After\` header when limit exceeded
- [ ] Redis failure triggers fail-open behavior with warning-level slog output
- [ ] Prometheus metrics: \`gateway_ratelimit_total{result="allowed|rejected"}\` tracked
- [ ] Benchmark tests in \`internal/ratelimit/\` show < 1ms overhead per check
- [ ] Table-driven tests cover edge cases (window boundary, burst, Redis down)
- [ ] Coverage ≥ 80%

**Artifacts**: \`internal/ratelimit/\`, \`internal/middleware/ratelimit.go\`, \`internal/service/ratelimit_service.go\`

---

### Phase 5: \`routing\`

**Goal**: Dynamic request routing, proxying, and request/response transformation.

**Activities**:
- Implement route matching and upstream resolution in \`internal/service/router_service.go\`
- Create reverse proxy handler in \`internal/handler/proxy.go\` using \`httputil.ReverseProxy\`
- Support path-based, header-based, and query-parameter-based routing rules
- Implement request transformation: header injection, path rewriting, query parameter manipulation
- Implement response transformation: header stripping, body rewriting
- Add request/response logging middleware with configurable verbosity
- Support upstream health-aware routing (skip unhealthy backends)
- Propagate OpenTelemetry trace context to upstream services via W3C Trace Context headers

**Checklist**:
- [ ] Routes loaded from PostgreSQL and cached in Redis with invalidation
- [ ] Reverse proxy correctly forwards requests and streams responses
- [ ] Request transformations applied before proxying
- [ ] Response transformations applied before returning to client
- [ ] Trace context propagated via \`traceparent\` and \`tracestate\` headers
- [ ] Timeout and cancellation propagated via context
- [ ] \`httptest\` tests verify end-to-end proxy behavior
- [ ] Coverage ≥ 80%

**Artifacts**: \`internal/handler/proxy.go\`, \`internal/service/router_service.go\`

---

### Phase 6: \`circuit-breaker\`

**Goal**: Circuit breaker pattern to protect upstream services from cascading failures.

**Activities**:
- Implement circuit breaker state machine in \`internal/circuit/breaker.go\` (closed, open, half-open)
- Configure per-upstream thresholds: failure count, failure rate, timeout, half-open max requests
- Integrate circuit breaker with proxy handler to short-circuit requests to failing upstreams
- Return 503 Service Unavailable with \`Retry-After\` when circuit is open
- Export circuit breaker state to Prometheus: \`gateway_circuit_state{upstream="...",state="closed|open|half_open"}\`
- Add slog events for state transitions

**Checklist**:
- [ ] Circuit opens after configurable failure threshold
- [ ] Half-open state allows limited probe requests
- [ ] Circuit closes after successful probes
- [ ] 503 returned immediately when circuit is open (no upstream call)
- [ ] State transitions logged with upstream name and failure counts
- [ ] Prometheus gauge reflects current state per upstream
- [ ] Table-driven tests cover all state transitions and edge cases
- [ ] Benchmark shows < 100ns overhead for closed-circuit path
- [ ] Coverage ≥ 80%

**Artifacts**: \`internal/circuit/\`

---

### Phase 7: \`observability\`

**Goal**: Comprehensive distributed tracing, metrics, and structured logging.

**Activities**:
- Configure OpenTelemetry SDK with OTLP exporter targeting Jaeger
- Add trace spans to all middleware, handlers, and repository calls
- Define Prometheus metrics: request duration histogram, request count by status/route, active connections, upstream latency
- Implement \`/healthz\` (liveness), \`/readyz\` (readiness with dependency checks), \`/metrics\` (Prometheus)
- Configure slog with JSON output, request-scoped fields (request_id, trace_id, client_id)
- Add pprof endpoints behind admin auth for production profiling
- Create Grafana dashboard JSON in \`docs/dashboards/\`

**Checklist**:
- [ ] Traces visible in Jaeger with full request lifecycle spans
- [ ] Prometheus metrics scrapeable at \`/metrics\`
- [ ] Health endpoints return dependency status (PostgreSQL, Redis, upstreams)
- [ ] Every log line includes \`request_id\` and \`trace_id\`
- [ ] pprof endpoints accessible at \`/debug/pprof/\` with admin auth
- [ ] Grafana dashboard covers: request rate, error rate, latency p50/p95/p99, circuit breaker state, rate limit rejections
- [ ] No sensitive data (tokens, API keys) appears in logs or traces
- [ ] SOC 2 control: audit trail for all gateway operations

**Artifacts**: \`internal/observability/\`, \`internal/handler/health.go\`, \`docs/dashboards/\`

---

### Phase 8: \`integration-tests\`

**Goal**: End-to-end integration tests validating the full middleware chain.

**Activities**:
- Write integration tests in \`tests/integration/\` using \`httptest.Server\` with full middleware stack
- Test auth → rate limit → circuit breaker → proxy pipeline
- Use testcontainers for PostgreSQL and Redis in CI
- Write load test scripts in \`scripts/loadtest/\` using k6 or vegeta
- Test graceful shutdown behavior (in-flight request draining)
- Test configuration hot-reload scenarios
- Validate SOC 2 audit log completeness

**Checklist**:
- [ ] Integration tests pass with \`go test ./tests/integration/... -tags=integration -race\`
- [ ] Full middleware chain tested: unauthenticated → 401, rate limited → 429, circuit open → 503, healthy → 200
- [ ] Load test script demonstrates target throughput (document in \`docs/PERFORMANCE.md\`)
- [ ] Graceful shutdown drains in-flight requests within configured timeout
- [ ] CI pipeline runs integration tests in GitHub Actions with service containers
- [ ] Coverage across all packages ≥ 80%

**Artifacts**: \`tests/integration/\`, \`scripts/loadtest/\`, \`docs/PERFORMANCE.md\`

---

### Phase 9: \`deploy\`

**Goal**: Production-ready deployment with Kubernetes, Helm, and Terraform.

**Activities**:
- Finalize multi-stage \`Dockerfile\` (build stage with Go 1.22, runtime stage with distroless)
- Create Helm chart in \`deployments/helm/gateway/\` with values for staging and production
- Write Kubernetes manifests: Deployment, Service, Ingress, HPA, PDB, NetworkPolicy
- Write Terraform modules in \`deployments/terraform/\` for AWS ECS, ALB, ElastiCache, RDS
- Configure liveness and readiness probes pointing to \`/healthz\` and \`/readyz\`
- Set resource requests/limits based on load test results
- Configure TLS termination at ALB
- Set up CloudWatch log forwarding

**Checklist**:
- [ ] Docker image builds and runs: \`docker build -t go-api-gateway . && docker run -p 8080:8080 go-api-gateway\`
- [ ] Helm chart lints: \`helm lint deployments/helm/gateway/\`
- [ ] Terraform plan succeeds: \`cd deployments/terraform && terraform plan\`
- [ ] HPA scales based on CPU and custom metrics (request rate)
- [ ] PDB ensures minimum availability during rolling updates
- [ ] NetworkPolicy restricts ingress to ALB only
- [ ] TLS termination configured at ALB with ACM certificate
- [ ] SOC 2 control: infrastructure changes tracked via Terraform state and Git history
- [ ] Runbook documented in \`docs/RUNBOOK.md\`

**Artifacts**: \`deployments/\`, \`docs/RUNBOOK.md\`

---

### Phase 10: \`harden\`

**Goal**: Security hardening, performance tuning, and production readiness review.

**Activities**:
- Run \`gosec ./...\` and resolve all findings
- Validate OWASP API Security Top 10 mitigations (injection, broken auth, excessive data exposure, rate limiting, SSRF)
- Enable HTTP security headers middleware (HSTS, X-Content-Type-Options, X-Frame-Options, CSP)
- Configure request size limits and timeout policies
- Run \`go test -bench=. ./...\` and document benchmark baselines
- Run \`go tool pprof\` against staging under load and optimize hot paths
- Conduct dependency audit: \`go list -m all\` and check for known vulnerabilities with \`govulncheck\`
- Review and finalize CODEOWNERS, branch protection, and CI gates
- SOC 2 readiness checklist: encryption at rest, encryption in transit, access logging, key rotation

**Checklist**:
- [ ] \`gosec ./...\` reports zero high/medium findings
- [ ] \`govulncheck ./...\` reports zero known vulnerabilities
- [ ] OWASP API Security Top 10 mitigations documented in \`docs/SECURITY.md\`
- [ ] HTTP security headers present on all responses
- [ ] Request body size limited (configurable, default 1MB)
- [ ] Read/write/idle timeouts configured on \`http.Server\`
- [ ] Benchmark results documented in \`docs/PERFORMANCE.md\`
- [ ] pprof analysis completed, no obvious memory leaks or goroutine leaks
- [ ] API key rotation procedure documented and tested
- [ ] All \`.env*\` and \`*.pem\` files in \`.gitignore\`
- [ ] SOC 2 controls mapped and documented in \`docs/SOC2-CONTROLS.md\`

**Artifacts**: \`docs/SECURITY.md\`, \`docs/SOC2-CONTROLS.md\`, \`docs/PERFORMANCE.md\`

---

## Phase Prerequisites

| Phase              | Requires                          |
|--------------------|-----------------------------------|
| \`scaffold\`         | None                              |
| \`data-layer\`       | \`scaffold\`                        |
| \`auth\`             | \`data-layer\`                      |
| \`rate-limiting\`    | \`data-layer\`                      |
| \`routing\`          | \`auth\`, \`rate-limiting\`           |
| \`circuit-breaker\`  | \`routing\`                         |
| \`observability\`    | \`scaffold\` (can run in parallel)  |
| \`integration-tests\`| \`circuit-breaker\`, \`observability\`|
| \`deploy\`           | \`integration-tests\`               |
| \`harden\`           | \`deploy\`                          |

## Quality Gates (All Phases)

Every phase must satisfy before advancing:

1. \`go build -o bin/gateway cmd/gateway/main.go\` — compiles cleanly
2. \`go vet ./...\` — no issues
3. \`golangci-lint run\` — no violations
4. \`go test ./... -race\` — all tests pass with race detector
5. \`go test ./... -coverprofile=coverage.out\` — coverage ≥ 80% on changed packages
6. No \`init()\` functions introduced
7. All exported functions have doc comments
8. Errors wrapped with \`%w\` verb
9. Context propagated through all function signatures
10. Conventional commit messages on all commits

## Delegation to Skill

This command delegates execution to the [phase skill](../skills/phase/SKILL.md) which manages state tracking, prerequisite validation, and checklist evaluation. Phase progress is tracked in \`playbook/progress.md\`.

## Examples

\`\`\`
# Check where you are
/phase

# Start the project
/phase scaffold

# See what's left in current phase
/phase current --checklist

# Move to the next phase after completing scaffold
/phase next

# Jump to a specific phase (validates prerequisites)
/phase auth

# Check if rate-limiting phase is complete
/phase rate-limiting --status
\`\`\`

## Integration with Other Commands

- \`/plan\` — Use within a phase to plan specific tasks (e.g., \`/plan\` inside \`auth\` phase plans JWT implementation)
- \`/tdd\` — Use to implement phase deliverables test-first
- \`/build-fix\` — Use when \`go build\` or \`golangci-lint\` fails during a phase
- \`/verify\` — Runs the quality gates for the current phase
- \`/code-review\` — Review phase deliverables before marking complete`,

  'plugin/codeforge-go-api-gateway/commands/plan.md': `# /plan — Implementation Planning for go-api-gateway

## Command Description

Generate a detailed implementation plan for a feature, bugfix, or refactor in the API gateway. The plan follows Clean Architecture layers, considers middleware composition, and accounts for API gateway concerns like rate limiting, authentication, and observability.

## Usage

\`\`\`
/plan <description of what to implement>
\`\`\`

### Examples

\`\`\`
/plan Add per-route circuit breaker with configurable thresholds
/plan Implement OAuth2 token introspection middleware
/plan Add request/response transformation for upstream services
/plan Fix race condition in sliding window rate limiter
/plan Refactor JWT validation to support multiple issuers
\`\`\`

## Planning Process

When this command is invoked, follow these steps in order:

### Step 1: Understand the Scope

1. Parse the description to identify the type of work: \`feat\`, \`fix\`, \`perf\`, \`refactor\`, \`chore\`
2. Identify which Clean Architecture layers are affected:
   - **handler/** — HTTP handlers, Chi route registration
   - **middleware/** — Chi middleware (composable, chainable)
   - **service/** — Business logic, orchestration
   - **repository/** — PostgreSQL queries, Redis operations
   - **model/** — Domain models, DTOs, request/response types
   - **config/** — Viper configuration structs
   - **auth/** — JWT, API keys, RBAC policies
   - **ratelimit/** — Redis-backed rate limiting
   - **circuit/** — Circuit breaker state machines
   - **observability/** — Traces, metrics, structured logging
3. Check for related GitHub Issues using the ticket system
4. Review existing code in affected directories to understand current patterns

### Step 2: Assess API Gateway Impact

Evaluate the change against these gateway concerns:

| Concern | Questions to Answer |
|---------|-------------------|
| **Latency** | Does this add to the request hot path? What's the expected p99 impact? |
| **Throughput** | Does this affect concurrent request handling? Connection pool sizing? |
| **Security** | Does this touch authentication, authorization, or sensitive data? SOC 2 implications? |
| **Reliability** | Does this affect circuit breakers, retries, or failover behavior? |
| **Observability** | What metrics, traces, or logs need to be added? |
| **Configuration** | What new config values are needed? Are they hot-reloadable? |
| **Backward Compatibility** | Does this change API contracts, middleware ordering, or routing behavior? |

### Step 3: Generate the Plan

Output a structured plan with the following sections:

---

## Plan Output Format

\`\`\`markdown
## Implementation Plan: <Title>

**Type**: feat | fix | perf | refactor | chore
**Branch**: <type>/GW-<number>-<short-desc>
**Estimated Complexity**: S | M | L | XL
**Affected Layers**: handler, middleware, service, repository, model, config, auth, ratelimit, circuit, observability

### Summary

<2-3 sentence description of what will be implemented and why>

### Prerequisites

- [ ] <Any required setup, migrations, config changes, or dependency additions>

### Architecture Decisions

- <Key design decisions with rationale>
- <Interface definitions that will be introduced or modified>
- <Middleware composition changes>

### Implementation Steps

#### 1. Define Models and Interfaces (\`internal/model/\`, \`internal/service/\`)
- [ ] <Specific model structs to create or modify>
- [ ] <Interface definitions for dependency injection>
- [ ] File: \`internal/model/<name>.go\` — <what it contains>
- [ ] File: \`internal/service/<name>.go\` — <interface definition>

#### 2. Implement Repository Layer (\`internal/repository/\`)
- [ ] <PostgreSQL or Redis operations needed>
- [ ] <Connection pooling considerations>
- [ ] File: \`internal/repository/<name>.go\`
- [ ] File: \`internal/repository/<name>_test.go\` — table-driven tests

#### 3. Implement Service Layer (\`internal/service/\`)
- [ ] <Business logic to implement>
- [ ] <Error wrapping with fmt.Errorf and %w>
- [ ] <Context propagation requirements>
- [ ] File: \`internal/service/<name>.go\`
- [ ] File: \`internal/service/<name>_test.go\` — table-driven tests with mocked repository

#### 4. Implement Middleware (if applicable) (\`internal/middleware/\`)
- [ ] <Chi middleware function signature: func(next http.Handler) http.Handler>
- [ ] <Middleware ordering considerations in the chain>
- [ ] <What to extract from/inject into context>
- [ ] File: \`internal/middleware/<name>.go\`
- [ ] File: \`internal/middleware/<name>_test.go\` — httptest-based tests

#### 5. Implement Handler (\`internal/handler/\`)
- [ ] <Route registration with Chi router>
- [ ] <Request validation and response formatting>
- [ ] <HTTP status codes and error responses>
- [ ] File: \`internal/handler/<name>.go\`
- [ ] File: \`internal/handler/<name>_test.go\` — httptest with chi.NewRouter()

#### 6. Add Configuration (\`internal/config/\`, \`configs/\`)
- [ ] <New Viper config fields>
- [ ] <Environment variable mappings (ALL_CAPS)>
- [ ] <Default values for development>
- [ ] File: \`internal/config/config.go\` — struct updates
- [ ] File: \`configs/development.yaml\` — new values

#### 7. Add Observability (\`internal/observability/\`)
- [ ] <Prometheus metrics: counters, histograms, gauges>
- [ ] <OpenTelemetry span attributes>
- [ ] <slog structured log fields>

#### 8. Wire Dependencies (\`cmd/gateway/main.go\`)
- [ ] <Dependency injection wiring>
- [ ] <Middleware chain ordering>
- [ ] <Router group registration>

### Testing Strategy

| Layer | Test Type | Tool | Coverage Target |
|-------|-----------|------|----------------|
| Repository | Integration | testcontainers + testify | 80% |
| Service | Unit | testify + mocks | 90% |
| Middleware | Unit | httptest + chi.NewRouter | 85% |
| Handler | Unit | httptest + testify | 85% |
| E2E | Integration | tests/ directory | Key paths |

**Table-driven test cases to cover:**
- [ ] <Happy path>
- [ ] <Validation errors>
- [ ] <Upstream failures>
- [ ] <Timeout/context cancellation>
- [ ] <Concurrent access (if applicable)>
- [ ] <Edge cases specific to this feature>

### Performance Considerations

- <Benchmark tests needed: \`func Benchmark<Name>(b *testing.B)\`>
- <pprof profiling targets>
- <Connection pool sizing>
- <Redis pipeline opportunities>
- <Memory allocation analysis>

### Security Checklist (SOC 2)

- [ ] No secrets in code or config files committed to repo
- [ ] Input validation on all external data
- [ ] Rate limiting applied to new endpoints
- [ ] Authentication/authorization enforced
- [ ] Audit logging for security-relevant operations
- [ ] OWASP API Security Top 10 review for relevant items
- [ ] Sensitive fields excluded from logs (PII, tokens, keys)

### Rollout Plan

1. **Staging**: Deploy behind feature flag or config toggle
2. **Validation**: Verify metrics in Prometheus/Grafana, traces in Jaeger
3. **Production**: Gradual rollout via ECS deployment
4. **Monitoring**: Dashboard for new metrics, alerts for error rates

### Files Changed (Summary)

| File | Action | Description |
|------|--------|-------------|
| \`internal/model/<name>.go\` | Create | Domain models |
| \`internal/service/<name>.go\` | Create | Business logic + interface |
| \`internal/repository/<name>.go\` | Create | Data access |
| \`internal/middleware/<name>.go\` | Create/Modify | Chi middleware |
| \`internal/handler/<name>.go\` | Create | HTTP handler |
| \`internal/config/config.go\` | Modify | New config fields |
| \`cmd/gateway/main.go\` | Modify | Dependency wiring |
| \`configs/development.yaml\` | Modify | Default config values |

### Commit Plan

1. \`feat(model): add <name> domain types\` — GW-<N>
2. \`feat(repo): implement <name> repository\` — GW-<N>
3. \`feat(service): implement <name> service logic\` — GW-<N>
4. \`feat(middleware): add <name> middleware\` — GW-<N>
5. \`feat(handler): add <name> HTTP handler and routes\` — GW-<N>
6. \`feat(config): add <name> configuration\` — GW-<N>
7. \`feat(observability): add <name> metrics and tracing\` — GW-<N>
8. \`docs: update API documentation for <name>\` — GW-<N>
\`\`\`

---

### Step 4: Validate the Plan

Before presenting the plan, verify:

- [ ] Every new file stays under 300 lines
- [ ] All exported functions have doc comments planned
- [ ] Interfaces are defined for all cross-layer dependencies
- [ ] Context propagation is included in all handler and service signatures
- [ ] Error wrapping uses \`fmt.Errorf("operation: %w", err)\` pattern
- [ ] No \`init()\` functions are introduced
- [ ] Middleware follows \`func(next http.Handler) http.Handler\` signature
- [ ] Test files use table-driven test pattern
- [ ] snake_case for file names, PascalCase for exported types
- [ ] Coverage target of 80% is achievable with the testing strategy
- [ ] Sensitive paths (\`internal/auth/**\`, \`*.pem\`, \`.env*\`) are handled appropriately

### Step 5: Suggest Next Actions

After presenting the plan, recommend:

1. **Create the branch**: \`git checkout -b <branch-name>\`
2. **Start with TDD**: Use \`/tdd\` command for the first implementation step
3. **Review architecture**: If the plan introduces new patterns, flag for team discussion
4. **Update GitHub Issue**: Link the plan to the relevant issue with the implementation checklist

## Integration with Other Commands

| Command | When to Use |
|---------|------------|
| \`/tdd\` | After plan approval, implement each step test-first |
| \`/verify\` | After implementation, run full verification suite |
| \`/build-fix\` | If compilation errors occur during implementation |
| \`/review\` | Before opening PR, get AI code review |

## Notes

- Plans for changes touching \`internal/auth/**\` require explicit security review callout
- Plans affecting middleware ordering must include before/after middleware chain diagrams
- Plans introducing new dependencies must justify against the conservative dependency policy
- Plans for performance-sensitive paths must include benchmark requirements
- All plans should reference the Clean Architecture boundary: handlers never import repositories directly`,

  'plugin/codeforge-go-api-gateway/commands/tdd.md': `# /tdd — Test-Driven Development for Go API Gateway

## Command Description
Drive implementation of API gateway features using strict Red-Green-Refactor TDD. Write failing Go tests first, implement the minimum code to pass, then refactor while maintaining green tests.

## When to Use
- Implementing new middleware (rate limiting, auth, circuit breaker)
- Adding HTTP handlers for gateway routes
- Building service layer business logic
- Creating repository implementations for PostgreSQL or Redis
- Adding request/response transformation logic
- Implementing health check or observability endpoints

## Invocation
\`\`\`
/tdd <feature-or-component-description>
\`\`\`

### Examples
\`\`\`
/tdd JWT authentication middleware that validates RS256 tokens and extracts claims
/tdd sliding window rate limiter using Redis with per-client limits
/tdd circuit breaker that opens after 5 consecutive failures with 30s recovery
/tdd health check handler that verifies PostgreSQL and Redis connectivity
/tdd request routing service that matches paths to upstream backends
/tdd API key repository with PostgreSQL storage and Redis caching
\`\`\`

## Execution Protocol

### Phase 0: Understand the Component

1. Identify which architectural layer the component belongs to:
   - \`internal/handler/\` — Chi HTTP handlers
   - \`internal/middleware/\` — Chi middleware functions
   - \`internal/service/\` — Business logic
   - \`internal/repository/\` — Data access (PostgreSQL, Redis)
   - \`internal/auth/\` — Authentication and authorization
   - \`internal/ratelimit/\` — Rate limiting
   - \`internal/circuit/\` — Circuit breaker
   - \`internal/observability/\` — Metrics, tracing, logging
   - \`pkg/httputil/\` — Shared HTTP utilities
   - \`pkg/errors/\` — Custom error types

2. Identify dependencies and interfaces:
   - What interfaces does this component depend on?
   - What interface should this component implement?
   - Does it need context propagation?
   - Does it need structured logging via slog?

3. Review existing code in the target package for patterns and conventions.

### Phase 1: RED — Write Failing Tests

**Rules:**
- Create the test file first: \`<component>_test.go\` in the same package
- Use table-driven tests for all test functions
- Use \`testify/assert\` and \`testify/require\` for assertions
- Use \`httptest\` for handler and middleware tests
- Use interfaces and mocks for dependency isolation — no real Redis or PostgreSQL in unit tests
- Every test function must start with \`Test\` and have a descriptive name
- Include test cases for: happy path, error paths, edge cases, boundary conditions
- Context must be propagated in all handler/middleware tests

**Test file template for handlers:**
\`\`\`go
package handler_test

import (
    "context"
    "net/http"
    "net/http/httptest"
    "testing"

    "github.com/go-chi/chi/v5"
    "github.com/stretchr/testify/assert"
    "github.com/stretchr/testify/require"
)

func TestComponentName_Action(t *testing.T) {
    tests := []struct {
        name           string
        // inputs
        expectedStatus int
        expectedBody   string
        expectErr      bool
    }{
        {
            name:           "descriptive case name",
            expectedStatus: http.StatusOK,
        },
    }

    for _, tt := range tests {
        t.Run(tt.name, func(t *testing.T) {
            // Arrange — set up mocks, request, recorder
            // Act — call the handler
            // Assert — verify status, body, headers
        })
    }
}
\`\`\`

**Test file template for middleware:**
\`\`\`go
package middleware_test

import (
    "net/http"
    "net/http/httptest"
    "testing"

    "github.com/stretchr/testify/assert"
)

func TestMiddlewareName(t *testing.T) {
    tests := []struct {
        name           string
        setupRequest   func(r *http.Request) *http.Request
        expectedStatus int
        expectNext     bool
    }{
        // table-driven cases
    }

    for _, tt := range tests {
        t.Run(tt.name, func(t *testing.T) {
            nextCalled := false
            next := http.HandlerFunc(func(w http.ResponseWriter, r *http.Request) {
                nextCalled = true
                w.WriteHeader(http.StatusOK)
            })

            handler := MiddlewareUnderTest(next)
            // ...
            assert.Equal(t, tt.expectNext, nextCalled)
        })
    }
}
\`\`\`

**Test file template for services/repositories:**
\`\`\`go
package service_test

import (
    "context"
    "testing"

    "github.com/stretchr/testify/assert"
    "github.com/stretchr/testify/require"
)

// Mock dependencies using interfaces
type mockRepository struct {
    // fields to control mock behavior
}

func TestServiceName_Method(t *testing.T) {
    tests := []struct {
        name      string
        setup     func() *mockRepository
        input     InputType
        expected  OutputType
        expectErr bool
    }{
        // table-driven cases
    }

    for _, tt := range tests {
        t.Run(tt.name, func(t *testing.T) {
            repo := tt.setup()
            svc := NewService(repo)
            result, err := svc.Method(context.Background(), tt.input)
            if tt.expectErr {
                require.Error(t, err)
                return
            }
            require.NoError(t, err)
            assert.Equal(t, tt.expected, result)
        })
    }
}
\`\`\`

**Run the tests — they MUST fail:**
\`\`\`bash
go test ./internal/<package>/... -v -count=1
\`\`\`

Confirm compilation errors or test failures. If tests pass, the tests are not testing new behavior — rewrite them.

### Phase 2: GREEN — Minimal Implementation

**Rules:**
- Write the absolute minimum code to make failing tests pass
- Do NOT add functionality beyond what the tests require
- Follow project conventions:
  - All exported functions must have doc comments
  - Errors wrapped with \`fmt.Errorf("context: %w", err)\`
  - Context as first parameter on all public methods
  - Use \`slog\` for structured logging
  - Middleware must return \`func(http.Handler) http.Handler\` for Chi compatibility
  - No \`init()\` functions
  - Files must not exceed 300 lines
- Define interfaces in the consuming package, not the implementing package
- Use dependency injection via constructor functions

**Implementation patterns for this gateway:**

For Chi middleware:
\`\`\`go
// Package middleware provides HTTP middleware for the API gateway.
package middleware

// RateLimiter returns Chi middleware that enforces per-client rate limits.
func RateLimiter(limiter ratelimit.Limiter) func(http.Handler) http.Handler {
    return func(next http.Handler) http.Handler {
        return http.HandlerFunc(func(w http.ResponseWriter, r *http.Request) {
            // implementation
        })
    }
}
\`\`\`

For handlers:
\`\`\`go
// Package handler provides HTTP handlers for the API gateway.
package handler

// HealthHandler handles health check requests.
type HealthHandler struct {
    checker service.HealthChecker
    logger  *slog.Logger
}

// NewHealthHandler creates a HealthHandler with the given dependencies.
func NewHealthHandler(checker service.HealthChecker, logger *slog.Logger) *HealthHandler {
    return &HealthHandler{checker: checker, logger: logger}
}

// Check handles GET /health requests.
func (h *HealthHandler) Check(w http.ResponseWriter, r *http.Request) {
    // implementation with context propagation
}
\`\`\`

**Run tests — they MUST pass:**
\`\`\`bash
go test ./internal/<package>/... -v -count=1
\`\`\`

If any test fails, fix the implementation — not the test (unless the test has a genuine bug).

### Phase 3: REFACTOR — Improve Without Breaking

**Checklist:**
- [ ] Extract repeated logic into helper functions
- [ ] Ensure error messages provide sufficient context for debugging
- [ ] Verify structured logging includes relevant fields (request_id, client_id, path)
- [ ] Check that context values are accessed via typed keys, not raw strings
- [ ] Ensure HTTP response helpers from \`pkg/httputil/\` are used consistently
- [ ] Verify custom errors from \`pkg/errors/\` are used for domain error cases
- [ ] Run \`gofmt\` and \`goimports\` on all changed files
- [ ] Run \`golangci-lint run ./internal/<package>/...\` and fix all findings
- [ ] Confirm no file exceeds 300 lines — split if necessary
- [ ] Verify all exported types and functions have doc comments

**Run full validation after refactoring:**
\`\`\`bash
go test ./internal/<package>/... -v -count=1 -race
go vet ./internal/<package>/...
golangci-lint run ./internal/<package>/...
\`\`\`

All tests must remain green. If any test breaks during refactoring, revert and try again.

### Phase 4: Expand Test Coverage

After the initial Red-Green-Refactor cycle, add tests for:

**Gateway-specific scenarios:**
- **Auth middleware:** expired tokens, malformed tokens, missing Authorization header, wrong signing algorithm, insufficient RBAC roles, revoked API keys
- **Rate limiting:** burst handling, limit reset after window, different limits per client tier, Redis connection failure fallback
- **Circuit breaker:** state transitions (closed → open → half-open → closed), concurrent requests during half-open, timeout handling
- **Request routing:** path matching, header-based routing, query parameter forwarding, upstream timeout, upstream 5xx handling
- **Health checks:** partial degradation (Redis down but PostgreSQL up), timeout on dependency check
- **Middleware chain:** correct ordering, context value propagation through chain

**Concurrency tests (where applicable):**
\`\`\`go
func TestRateLimiter_ConcurrentRequests(t *testing.T) {
    // Use sync.WaitGroup and goroutines to simulate concurrent access
    // Verify rate limiter correctly counts across goroutines
}
\`\`\`

**Benchmark tests (for performance-critical paths):**
\`\`\`go
func BenchmarkJWTValidation(b *testing.B) {
    // Setup token and validator
    for i := 0; i < b.N; i++ {
        // Validate token
    }
}
\`\`\`

**Run with coverage:**
\`\`\`bash
go test ./internal/<package>/... -v -count=1 -race -coverprofile=coverage.out
go tool cover -func=coverage.out
\`\`\`

Coverage must meet or exceed 80% for the package.

## Cycle Tracking

Track each TDD cycle in your response:

\`\`\`
## TDD Cycle Log

### Cycle 1: <test case group>
- RED:    <N> tests written, all failing (compilation error / assertion failure)
- GREEN:  <N> tests passing, <lines> lines of implementation
- REFACTOR: <what was improved>

### Cycle 2: <test case group>
- RED:    ...
- GREEN:  ...
- REFACTOR: ...

### Coverage: <X>% (target: 80%)
### Linting: <PASS/FAIL> (golangci-lint)
### Race Detection: <PASS/FAIL> (go test -race)
\`\`\`

## Constraints

- **Never skip RED.** Every line of implementation must be justified by a failing test.
- **Never modify tests to make them pass.** Fix the implementation instead (unless the test has a genuine specification error).
- **No \`init()\` functions.** Use explicit initialization in constructors.
- **No global mutable state.** Pass dependencies through constructors.
- **Context propagation is mandatory.** All handler and service methods must accept \`context.Context\`.
- **Errors must be wrapped.** Use \`fmt.Errorf("operation description: %w", err)\`.
- **Table-driven tests only.** No standalone assertion blocks outside of table-driven loops.
- **Mock via interfaces.** Do not use real Redis or PostgreSQL in unit tests. Integration tests in \`tests/\` may use real dependencies via Docker.
- **File size limit: 300 lines.** Split test files if necessary (e.g., \`ratelimit_test.go\` and \`ratelimit_redis_test.go\`).
- **SOC 2 awareness:** Never log tokens, API keys, or PII. Test that sensitive data is not leaked in error responses.

## Integration with Other Commands

- Use \`/plan\` first to break down complex features into TDD-sized units
- Use \`/verify\` after completing all cycles to run the full validation suite
- Use \`/build-fix\` if compilation errors are difficult to resolve
- Use \`/code-review\` before opening a PR to catch issues early`,

  'plugin/codeforge-go-api-gateway/commands/verify.md': `# /verify — Verify Go API Gateway Code Quality

## Command: \`/verify\`

Runs a comprehensive verification suite against the current codebase, checking compilation, linting, tests, coverage, security, and API gateway-specific correctness.

## Usage

\`\`\`
/verify              # Full verification (all checks)
/verify quick        # Fast checks only (compile, vet, lint)
/verify tests        # Tests + coverage only
/verify security     # Security-focused checks only
/verify middleware   # Verify middleware chain correctness
/verify <file>       # Verify a specific file or package
\`\`\`

## Execution Steps

### Step 1: Compilation Check

Verify the project compiles without errors:

\`\`\`bash
go build -o /dev/null ./cmd/gateway/...
go build -o /dev/null ./...
\`\`\`

**If compilation fails:**
- Parse the error output and identify the root cause
- Check for missing imports, type mismatches, undefined references
- Suggest the fix inline — do NOT silently skip

### Step 2: Go Vet

Run the Go static analyzer:

\`\`\`bash
go vet ./...
\`\`\`

**Check for:**
- Printf format string mismatches
- Unreachable code
- Suspicious struct tags
- Incorrect use of sync primitives
- Context misuse in handlers

### Step 3: Lint with golangci-lint

\`\`\`bash
golangci-lint run --config .golangci.yml ./...
\`\`\`

**Enabled linters to verify against:**
- \`govet\` — correctness
- \`errcheck\` — unchecked errors (critical for gateway reliability)
- \`staticcheck\` — advanced static analysis
- \`gosec\` — security issues (SOC 2 compliance)
- \`revive\` — style and conventions
- \`gocyclo\` — cyclomatic complexity (max 15)
- \`bodyclose\` — HTTP response body leaks (critical for proxy/gateway)
- \`contextcheck\` — context propagation in middleware chains
- \`noctx\` — HTTP requests without context

**If golangci-lint is not installed:**
\`\`\`bash
go install github.com/golangci/golangci-lint/cmd/golangci-lint@latest
\`\`\`

### Step 4: Run Tests

\`\`\`bash
go test -v -race -count=1 -coverprofile=coverage.out ./...
\`\`\`

**Verify:**
- All tests pass
- Race detector finds no data races (critical for concurrent middleware)
- No test panics or timeouts

**Parse coverage:**
\`\`\`bash
go tool cover -func=coverage.out
\`\`\`

**Coverage requirements:**
- Overall: ≥ 80%
- \`internal/auth/\` — ≥ 90% (security-critical, SOC 2)
- \`internal/ratelimit/\` — ≥ 85% (correctness-critical)
- \`internal/middleware/\` — ≥ 85% (request path)
- \`internal/handler/\` — ≥ 80%
- \`internal/circuit/\` — ≥ 85%
- \`pkg/errors/\` — ≥ 90%

### Step 5: Test Quality Checks

Inspect test files for quality:

- [ ] **Table-driven tests**: All test functions with multiple cases MUST use table-driven pattern
- [ ] **httptest usage**: Handler tests must use \`httptest.NewRecorder()\` and \`httptest.NewRequest()\`
- [ ] **Testify assertions**: Use \`assert\` for soft checks, \`require\` for fatal preconditions
- [ ] **No sleep in tests**: Flag any \`time.Sleep\` — use channels, tickers, or test helpers
- [ ] **Subtests**: Table-driven tests must use \`t.Run(tc.name, ...)\`
- [ ] **Test isolation**: No shared mutable state between test cases
- [ ] **Context propagation**: Handler tests must pass \`context.Background()\` or enriched context

### Step 6: Security Verification (SOC 2)

**Static security scan:**
\`\`\`bash
gosec -fmt=json ./...
\`\`\`

**Manual checks on security-sensitive paths:**

For \`internal/auth/**\`:
- [ ] JWT validation uses RS256 (not HS256 with weak secrets)
- [ ] Token expiration is always checked
- [ ] \`kid\` header is validated against known keys
- [ ] API keys are compared using \`crypto/subtle.ConstantTimeCompare\`
- [ ] No secrets or keys hardcoded in source
- [ ] RBAC checks cannot be bypassed by middleware ordering

For \`internal/middleware/**\`:
- [ ] CORS middleware does not allow \`*\` origin in production config
- [ ] Rate limit middleware cannot be bypassed by header manipulation
- [ ] Recovery middleware does not leak stack traces in production
- [ ] Request ID middleware always sets a trace-safe ID

For \`internal/ratelimit/**\`:
- [ ] Redis keys are namespaced to prevent collision
- [ ] Rate limit windows use atomic Redis operations (MULTI/EXEC or Lua scripts)
- [ ] Fallback behavior when Redis is unavailable (fail-open vs fail-closed is documented)

For \`configs/**\`:
- [ ] No secrets in YAML config files
- [ ] Production config references environment variables, not literal values
- [ ] TLS is enforced in production configuration

**File-level checks:**
- [ ] No \`.pem\`, \`.key\`, or \`.env\` files committed
- [ ] \`.gitignore\` covers sensitive file patterns
- [ ] No \`TODO: remove\` or \`HACK\` comments in security paths

### Step 7: Architecture Verification

**Clean Architecture compliance:**

\`\`\`
handler → service → repository
   ↓         ↓          ↓
 HTTP    Business    Data Access
 Layer    Logic       Layer
\`\`\`

- [ ] Handlers in \`internal/handler/\` do NOT import \`internal/repository/\`
- [ ] Services in \`internal/service/\` do NOT import \`net/http\` (except for client calls)
- [ ] Repositories in \`internal/repository/\` do NOT import \`internal/handler/\`
- [ ] Dependencies flow inward: handler → service → repository
- [ ] Interfaces are defined in the consumer package, not the provider
- [ ] No \`init()\` functions anywhere in the codebase

**Middleware chain verification:**
- [ ] All middleware are valid \`func(http.Handler) http.Handler\` signatures
- [ ] Middleware ordering is correct in router setup:
  1. Recovery (outermost — catches panics)
  2. Request ID
  3. Structured logging
  4. Metrics / tracing (OpenTelemetry)
  5. CORS
  6. Rate limiting
  7. Authentication (JWT / API key)
  8. Authorization (RBAC)
  9. Route-specific handlers (innermost)
- [ ] No middleware breaks the Chi middleware chain by not calling \`next.ServeHTTP(w, r)\`

### Step 8: API Gateway Pattern Verification

**Rate Limiting (\`internal/ratelimit/\`):**
- [ ] Sliding window algorithm implemented correctly
- [ ] Per-client identification (API key, IP, JWT subject)
- [ ] Rate limit headers set: \`X-RateLimit-Limit\`, \`X-RateLimit-Remaining\`, \`X-RateLimit-Reset\`
- [ ] Returns \`429 Too Many Requests\` with \`Retry-After\` header

**Circuit Breaker (\`internal/circuit/\`):**
- [ ] Three states: Closed, Open, Half-Open
- [ ] Configurable failure threshold, timeout, and half-open max requests
- [ ] Thread-safe state transitions (mutex or atomic)
- [ ] Metrics emitted on state changes

**Health Checks:**
- [ ] \`/healthz\` returns 200 with no downstream checks (liveness)
- [ ] \`/readyz\` checks PostgreSQL and Redis connectivity (readiness)
- [ ] Health endpoints are excluded from authentication middleware

**Graceful Shutdown:**
- [ ] \`signal.NotifyContext\` with \`SIGINT\` and \`SIGTERM\`
- [ ] HTTP server uses \`Shutdown(ctx)\` with timeout
- [ ] Redis and PostgreSQL connections are closed on shutdown
- [ ] In-flight requests are drained before exit

### Step 9: Observability Verification

- [ ] All handlers propagate \`context.Context\` from \`r.Context()\`
- [ ] OpenTelemetry spans are created for upstream service calls
- [ ] Prometheus metrics registered: \`gateway_requests_total\`, \`gateway_request_duration_seconds\`, \`gateway_upstream_errors_total\`
- [ ] Structured logging uses \`slog\` with \`request_id\`, \`method\`, \`path\`, \`status\`, \`duration\` fields
- [ ] No \`fmt.Println\` or \`log.Println\` — only \`slog\`

### Step 10: File and Naming Conventions

- [ ] File names use \`snake_case.go\` (e.g., \`rate_limiter.go\`, \`jwt_validator.go\`)
- [ ] Test files use \`snake_case_test.go\`
- [ ] Exported functions have doc comments (\`// FunctionName ...\`)
- [ ] No file exceeds 300 lines
- [ ] Errors are wrapped with \`fmt.Errorf("context: %w", err)\`
- [ ] Custom error types implement the \`error\` interface
- [ ] Environment variables use \`ALL_CAPS\` with \`GATEWAY_\` prefix

## Output Format

Present results as a verification report:

\`\`\`
## Verification Report — go-api-gateway

### Summary
✅ Passed: X/Y checks
⚠️  Warnings: N
❌ Failed: M

### Compilation          ✅ PASS
### Go Vet              ✅ PASS
### Lint                ⚠️  2 warnings (bodyclose in internal/handler/proxy.go:45)
### Tests               ✅ PASS (142 passed, 0 failed)
### Coverage            ✅ 84.2% overall
  - internal/auth/      92.1% ✅
  - internal/ratelimit/ 87.3% ✅
  - internal/handler/   81.0% ✅
  - internal/circuit/   78.4% ❌ (below 85% threshold)
### Security            ⚠️  1 finding (gosec G104 in internal/repository/redis.go)
### Architecture        ✅ PASS
### Gateway Patterns    ✅ PASS
### Observability       ✅ PASS
### Conventions         ⚠️  1 file exceeds 300 lines (internal/handler/proxy.go: 312 lines)

### Action Items
1. ❌ Increase test coverage for \`internal/circuit/\` — add tests for half-open state transitions
2. ⚠️  Handle error return in \`internal/repository/redis.go:67\` — \`conn.Close()\` error ignored
3. ⚠️  Split \`internal/handler/proxy.go\` into \`proxy.go\` and \`proxy_transform.go\`
\`\`\`

## Quick Mode (\`/verify quick\`)

Run only Steps 1-3 (compile, vet, lint). Use for rapid feedback during development.

## Security Mode (\`/verify security\`)

Run only Steps 6 and the security-related parts of Step 8. Use before PRs touching \`internal/auth/**\`, \`internal/middleware/**\`, or \`configs/**\`.

## Middleware Mode (\`/verify middleware\`)

Run Step 7 (middleware chain) and Step 8 (gateway patterns). Verify middleware ordering, composability, and that no middleware silently drops requests.

## Integration with CI

This verification maps to the GitHub Actions CI pipeline in \`.github/workflows/ci.yml\`:

| Verify Step | CI Stage |
|---|---|
| Compilation | \`build\` job |
| Go Vet | \`vet\` job |
| Lint | \`lint\` job |
| Tests + Coverage | \`test\` job |
| Race Detection | \`test\` job (\`-race\` flag) |
| Security | \`security\` job (gosec) |

## When to Run

- **Before every commit**: \`/verify quick\`
- **Before opening a PR**: \`/verify\` (full)
- **After touching auth or middleware**: \`/verify security\`
- **After changing router setup**: \`/verify middleware\`
- **During code review**: Reviewer runs \`/verify\` on the branch`,

  'plugin/codeforge-go-api-gateway/hooks/hooks.json': `{
  "version": "1.0.0",
  "hooks": {
    "pre-commit": {
      "description": "Run Go formatting, linting, vetting, and security checks before committing",
      "enabled": true,
      "steps": [
        {
          "id": "go-fmt",
          "name": "Go Format Check",
          "command": "gofmt -l .",
          "description": "Verify all Go files are formatted with gofmt",
          "fail_on_output": true,
          "error_message": "Unformatted Go files detected. Run 'gofmt -w .' to fix.",
          "timeout_seconds": 30,
          "files": ["*.go"]
        },
        {
          "id": "go-imports",
          "name": "Go Imports Check",
          "command": "goimports -l .",
          "description": "Verify imports are organized correctly",
          "fail_on_output": true,
          "error_message": "Import ordering issues detected. Run 'goimports -w .' to fix.",
          "timeout_seconds": 30,
          "files": ["*.go"]
        },
        {
          "id": "go-vet",
          "name": "Go Vet",
          "command": "go vet ./...",
          "description": "Run go vet to catch suspicious constructs",
          "fail_on_error": true,
          "timeout_seconds": 60,
          "files": ["*.go"]
        },
        {
          "id": "golangci-lint",
          "name": "GolangCI-Lint",
          "command": "golangci-lint run --timeout 120s --config .golangci.yml",
          "description": "Run golangci-lint with govet, errcheck, staticcheck, gosec, revive, gocyclo",
          "fail_on_error": true,
          "timeout_seconds": 120,
          "files": ["*.go"]
        },
        {
          "id": "go-mod-tidy",
          "name": "Go Mod Tidy Check",
          "command": "go mod tidy -diff",
          "description": "Ensure go.mod and go.sum are tidy",
          "fail_on_output": true,
          "error_message": "go.mod is not tidy. Run 'go mod tidy' to fix.",
          "timeout_seconds": 30,
          "files": ["go.mod", "go.sum"]
        },
        {
          "id": "file-length-check",
          "name": "File Length Check",
          "command": "find . -name '*.go' -not -path './vendor/*' -not -path './.git/*' | xargs awk 'ENDFILE { if (FNR > 300) print FILENAME \\": \\" FNR \\" lines (max 300)\\" }'",
          "description": "Enforce 300-line maximum file length for Go files",
          "fail_on_output": true,
          "error_message": "Go files exceed 300-line limit. Refactor into smaller files.",
          "timeout_seconds": 15,
          "files": ["*.go"]
        },
        {
          "id": "sensitive-file-guard",
          "name": "Sensitive File Guard",
          "command": "git diff --cached --name-only | grep -E '(\\\\.pem$|\\\\.key$|\\\\.env|config/production/|internal/auth/.*\\\\.go)' || true",
          "description": "Flag commits touching sensitive paths for extra review (SOC 2 compliance)",
          "warn_on_output": true,
          "warning_message": "⚠️  Commit touches sensitive files (auth, production config, keys). Ensure SOC 2 review requirements are met. See docs/AI-USAGE-POLICY.md.",
          "timeout_seconds": 10,
          "files": ["*.pem", "*.key", ".env*", "internal/auth/**", "configs/production/**"]
        },
        {
          "id": "no-init-functions",
          "name": "No init() Functions",
          "command": "git diff --cached --name-only -- '*.go' | xargs grep -l 'func init()' || true",
          "description": "Disallow init() functions per project conventions",
          "fail_on_output": true,
          "error_message": "init() functions are not allowed. Use explicit initialization in main or constructors.",
          "timeout_seconds": 10,
          "files": ["*.go"]
        },
        {
          "id": "error-wrapping-check",
          "name": "Error Wrapping Convention",
          "command": "git diff --cached -U0 -- '*.go' | grep -E '^\\\\+.*fmt\\\\.Errorf.*[^%]w' | head -5 || true",
          "description": "Warn if new error wrapping may not use %w verb correctly",
          "warn_on_output": true,
          "warning_message": "Check that errors are wrapped with fmt.Errorf and %w for proper error chain propagation.",
          "timeout_seconds": 10,
          "files": ["*.go"]
        },
        {
          "id": "unit-tests-staged",
          "name": "Unit Tests (Staged Packages)",
          "command": "git diff --cached --name-only -- '*.go' | grep -v '_test.go' | xargs -I{} dirname {} | sort -u | xargs -I{} go test -short -count=1 -race ./{}",
          "description": "Run unit tests with race detection for packages with staged changes",
          "fail_on_error": true,
          "timeout_seconds": 180,
          "files": ["*.go"],
          "skip_if_no_match": true
        },
        {
          "id": "ai-code-label",
          "name": "AI-Generated Code Label Check",
          "command": "git diff --cached -U0 -- '*.go' | grep -c 'AI-GENERATED\\\\|ai-generated\\\\|Generated by Claude\\\\|generated by claude' || echo '0'",
          "description": "Detect AI-generated code markers for audit trail (SOC 2 compliance)",
          "info_only": true,
          "info_message": "AI-generated code detected in staged changes. Ensure proper review per docs/AI-USAGE-POLICY.md.",
          "timeout_seconds": 10,
          "files": ["*.go"]
        }
      ],
      "parallel": false,
      "skip_env_var": "SKIP_PRE_COMMIT",
      "skip_message": "Pre-commit hooks skipped via SKIP_PRE_COMMIT=1. Use sparingly."
    },
    "post-commit": {
      "description": "Post-commit notifications and bookkeeping for the API gateway project",
      "enabled": true,
      "steps": [
        {
          "id": "coverage-snapshot",
          "name": "Coverage Snapshot",
          "command": "go test -short -coverprofile=/tmp/go-api-gateway-coverage.out ./... 2>/dev/null && go tool cover -func=/tmp/go-api-gateway-coverage.out | tail -1 | awk '{print \\"Total coverage: \\" $3}'",
          "description": "Display current test coverage after commit (80% threshold target)",
          "info_only": true,
          "timeout_seconds": 120,
          "run_in_background": true
        },
        {
          "id": "coverage-threshold-warn",
          "name": "Coverage Threshold Warning",
          "command": "go test -short -coverprofile=/tmp/go-api-gateway-coverage.out ./... 2>/dev/null && COVERAGE=$(go tool cover -func=/tmp/go-api-gateway-coverage.out | tail -1 | awk '{print $3}' | tr -d '%'); if [ \\"$(echo \\"$COVERAGE < 80\\" | bc)\\" -eq 1 ]; then echo \\"⚠️  Coverage $COVERAGE% is below 80% threshold\\"; fi",
          "description": "Warn if test coverage drops below 80%",
          "warn_on_output": true,
          "timeout_seconds": 120,
          "run_in_background": true
        },
        {
          "id": "commit-message-log",
          "name": "Commit Message Validation Log",
          "command": "COMMIT_MSG=$(git log -1 --pretty=%s); echo \\"$COMMIT_MSG\\" | grep -qE '^(feat|fix|chore|docs|perf|refactor|test|ci|build)(\\\\(.+\\\\))?!?: .+' && echo '✅ Conventional commit format valid' || echo '⚠️  Commit message may not follow conventional commits format'",
          "description": "Log whether the commit message follows conventional commits",
          "info_only": true,
          "timeout_seconds": 5
        },
        {
          "id": "middleware-chain-reminder",
          "name": "Middleware Chain Reminder",
          "command": "CHANGED=$(git diff HEAD~1 --name-only -- 'internal/middleware/*.go' 2>/dev/null | wc -l | tr -d ' '); if [ \\"$CHANGED\\" -gt 0 ]; then echo \\"📋 Middleware files changed. Verify middleware ordering in cmd/gateway/main.go and update docs/ARCHITECTURE.md if needed.\\"; fi",
          "description": "Remind to verify middleware chain ordering when middleware files change",
          "info_only": true,
          "timeout_seconds": 10
        },
        {
          "id": "auth-change-alert",
          "name": "Auth Change Alert",
          "command": "CHANGED=$(git diff HEAD~1 --name-only -- 'internal/auth/**' 2>/dev/null | wc -l | tr -d ' '); if [ \\"$CHANGED\\" -gt 0 ]; then echo \\"🔒 Authentication/authorization files changed. SOC 2 requires peer review for security-critical changes. Ensure this is tracked in your PR.\\"; fi",
          "description": "Alert when auth-related files are modified for SOC 2 compliance tracking",
          "info_only": true,
          "timeout_seconds": 10
        },
        {
          "id": "config-change-alert",
          "name": "Config Change Alert",
          "command": "CHANGED=$(git diff HEAD~1 --name-only -- 'configs/**' 'internal/config/**' 2>/dev/null | wc -l | tr -d ' '); if [ \\"$CHANGED\\" -gt 0 ]; then echo \\"⚙️  Configuration files changed. Verify environment variable mappings and update configs/ YAML files for all environments.\\"; fi",
          "description": "Alert when configuration files change to ensure all environments are updated",
          "info_only": true,
          "timeout_seconds": 10
        },
        {
          "id": "build-verify",
          "name": "Build Verification",
          "command": "go build -o /dev/null ./cmd/gateway/ 2>&1 && echo '✅ Binary builds successfully' || echo '❌ Build failed — fix before pushing'",
          "description": "Verify the gateway binary compiles after commit",
          "info_only": true,
          "timeout_seconds": 60,
          "run_in_background": true
        }
      ],
      "parallel": false,
      "skip_env_var": "SKIP_POST_COMMIT",
      "skip_message": "Post-commit hooks skipped via SKIP_POST_COMMIT=1."
    },
    "pre-push": {
      "description": "Final validation before pushing to remote — full test suite and build",
      "enabled": true,
      "steps": [
        {
          "id": "full-test-suite",
          "name": "Full Test Suite with Race Detection",
          "command": "go test -race -count=1 -coverprofile=coverage.out ./...",
          "description": "Run all tests with race detector before pushing",
          "fail_on_error": true,
          "timeout_seconds": 300
        },
        {
          "id": "coverage-gate",
          "name": "Coverage Gate (80%)",
          "command": "COVERAGE=$(go tool cover -func=coverage.out | tail -1 | awk '{print $3}' | tr -d '%'); if [ \\"$(echo \\"$COVERAGE < 80\\" | bc)\\" -eq 1 ]; then echo \\"Coverage $COVERAGE% is below 80% threshold\\" && exit 1; else echo \\"Coverage $COVERAGE% meets threshold\\"; fi",
          "description": "Block push if coverage is below 80%",
          "fail_on_error": true,
          "timeout_seconds": 10,
          "depends_on": "full-test-suite"
        },
        {
          "id": "build-binary",
          "name": "Build Gateway Binary",
          "command": "go build -o bin/gateway cmd/gateway/main.go",
          "description": "Ensure the gateway binary compiles cleanly",
          "fail_on_error": true,
          "timeout_seconds": 60
        },
        {
          "id": "docker-build-check",
          "name": "Docker Build Check",
          "command": "docker build --target builder -f deployments/Dockerfile -t go-api-gateway:check . 2>/dev/null && echo 'Docker build OK' || echo 'Docker build skipped (Docker not available)'",
          "description": "Optionally verify Docker image builds",
          "fail_on_error": false,
          "timeout_seconds": 180,
          "optional": true
        },
        {
          "id": "protected-branch-guard",
          "name": "Protected Branch Guard",
          "command": "BRANCH=$(git rev-parse --abbrev-ref HEAD); if [ \\"$BRANCH\\" = 'main' ]; then echo '❌ Direct push to main is not allowed. Use a PR.' && exit 1; fi",
          "description": "Prevent direct pushes to the main branch",
          "fail_on_error": true,
          "timeout_seconds": 5
        }
      ],
      "parallel": false,
      "skip_env_var": "SKIP_PRE_PUSH",
      "skip_message": "Pre-push hooks skipped via SKIP_PRE_PUSH=1. CI will still enforce checks."
    }
  },
  "installation": {
    "method": "symlink",
    "source_dir": "git-hooks",
    "target_dir": ".git/hooks",
    "install_command": "bash install.sh",
    "description": "Run install.sh to symlink git hooks from git-hooks/ into .git/hooks/"
  },
  "global_settings": {
    "verbose": false,
    "color_output": true,
    "log_file": ".git/hooks.log",
    "required_tools": [
      {
        "name": "go",
        "min_version": "1.22",
        "check_command": "go version"
      },
      {
        "name": "golangci-lint",
        "min_version": "1.56",
        "check_command": "golangci-lint --version"
      },
      {
        "name": "goimports",
        "check_command": "which goimports"
      }
    ]
  }
}`,

  'plugin/codeforge-go-api-gateway/skills/build-fix/SKILL.md': `---
name: build-fix
description: Iterative build-fix cycle for Go API gateway — compile, lint, test, and resolve errors until the codebase is clean and all checks pass.
metadata:
  version: "1.0"
  author: codeforge
  project: go-api-gateway
  language: go
  tags:
    - build
    - fix
    - lint
    - compile
    - troubleshooting
    - go
    - api-gateway
  complexity: medium
  estimated_duration: 5-30 minutes depending on error count
  prerequisites:
    - Go 1.22+ installed
    - golangci-lint installed
    - Redis running (for integration tests)
    - PostgreSQL running (for integration tests)
---

# Skill: build-fix

Iterative build-fix workflow for the Go API gateway. This skill drives a tight loop of compile → lint → test → fix until the codebase reaches a clean state with all checks passing.

## When to Use

- After making code changes that may have introduced compilation errors
- After refactoring handler, service, or repository layers
- After updating dependencies in \`go.mod\`
- After resolving merge conflicts
- After generating or modifying middleware chains
- When CI reports failures and you need to reproduce and fix locally
- After modifying protobuf definitions or code-generated types

## Workflow

### Phase 1: Compilation Check

Run the Go compiler to surface type errors, missing imports, and syntax issues:

\`\`\`
go build ./cmd/gateway/...
go build ./internal/...
go build ./pkg/...
\`\`\`

Fix errors in dependency order:
1. \`pkg/errors/\` and \`pkg/httputil/\` — shared utilities with no internal dependencies
2. \`internal/model/\` — domain models and DTOs
3. \`internal/config/\` — configuration structs (Viper bindings)
4. \`internal/repository/\` — data access layer (PostgreSQL, Redis)
5. \`internal/auth/\` — JWT validation, API key verification, RBAC
6. \`internal/ratelimit/\` — Redis-backed rate limiting
7. \`internal/circuit/\` — circuit breaker implementation
8. \`internal/service/\` — business logic layer
9. \`internal/middleware/\` — Chi middleware (auth, rate limit, logging, cors, recovery)
10. \`internal/handler/\` — HTTP handlers (Chi route handlers)
11. \`internal/observability/\` — OpenTelemetry, Prometheus, slog setup
12. \`cmd/gateway/\` — main entry point

### Phase 2: Vet and Static Analysis

Run Go vet to catch suspicious constructs:

\`\`\`
go vet ./...
\`\`\`

Common issues in this codebase:
- Passing \`context.Context\` incorrectly through middleware chains
- Unused parameters in handler functions
- Printf format string mismatches in structured logging with \`slog\`
- Copying sync primitives (mutexes in rate limiter or circuit breaker)

### Phase 3: Lint

Run the full golangci-lint suite configured for this project:

\`\`\`
golangci-lint run ./...
\`\`\`

The project enforces these linters — address each category:

| Linter | Common Fixes |
|---|---|
| **errcheck** | Handle all returned errors — especially from \`resp.Body.Close()\`, \`rows.Close()\`, Redis \`cmd.Err()\` |
| **govet** | Fix struct field alignment, printf argument mismatches |
| **staticcheck** | Remove deprecated API usage, fix unreachable code |
| **gosec** | Address SQL injection risks in repository layer, TLS configuration, hardcoded credentials |
| **revive** | Add doc comments to all exported functions, fix naming conventions |
| **gocyclo** | Break down complex handler or middleware functions exceeding cyclomatic complexity threshold |

Project-specific lint rules:
- All exported functions in \`handler/\`, \`service/\`, and \`pkg/\` MUST have doc comments
- No \`init()\` functions anywhere — use explicit initialization in \`cmd/gateway/main.go\`
- Errors must be wrapped with \`fmt.Errorf("context: %w", err)\` — never bare returns
- File length must not exceed 300 lines — split into focused files if needed
- Use \`snake_case\` for file names: \`rate_limiter.go\`, not \`rateLimiter.go\`

### Phase 4: Unit Tests

Run unit tests with race detection:

\`\`\`
go test -race -count=1 -coverprofile=coverage.out ./internal/... ./pkg/...
\`\`\`

Check coverage meets the 80% threshold:

\`\`\`
go tool cover -func=coverage.out | grep total
\`\`\`

If coverage is below 80%, identify uncovered paths:

\`\`\`
go tool cover -html=coverage.out -o coverage.html
\`\`\`

Priority areas for test coverage:
- \`internal/auth/\` — JWT validation edge cases (expired tokens, wrong algorithm, missing claims, RBAC role checks)
- \`internal/ratelimit/\` — sliding window boundary conditions, Redis connection failures
- \`internal/circuit/\` — state transitions (closed → open → half-open), threshold logic
- \`internal/middleware/\` — use \`httptest.NewRecorder()\` and \`httptest.NewRequest()\` for Chi middleware testing
- \`internal/handler/\` — table-driven tests with \`httptest\` for all route handlers

Test conventions for this project:
- Table-driven tests are required — use \`tests := []struct{ name string; ... }{ ... }\` pattern
- Use \`testify/assert\` and \`testify/require\` for assertions
- Use interfaces for dependency injection — mock at the interface boundary
- Test files must be in the same package (white-box) or \`_test\` package (black-box) as appropriate
- Context propagation must be tested — verify trace IDs and request-scoped values flow through

### Phase 5: Integration Tests (if applicable)

Run integration tests that require Redis and PostgreSQL:

\`\`\`
go test -race -tags=integration -count=1 ./tests/...
\`\`\`

These tests validate:
- Redis rate limiting under concurrent access
- PostgreSQL config store reads and API key lookups
- Full middleware chain execution with real HTTP requests
- Circuit breaker behavior with simulated upstream failures
- OpenTelemetry span propagation through the handler → service → repository chain

### Phase 6: Build Final Binary

Produce the production binary to confirm everything links:

\`\`\`
CGO_ENABLED=0 GOOS=linux GOARCH=amd64 go build -ldflags="-s -w" -o bin/gateway cmd/gateway/main.go
\`\`\`

Verify the binary starts and responds to health checks:

\`\`\`
./bin/gateway --config configs/development.yaml &
curl -s http://localhost:8080/healthz | jq .
kill %1
\`\`\`

## Iteration Strategy

Repeat the cycle until all phases pass cleanly. Follow this priority order when multiple errors exist:

1. **Compilation errors first** — nothing else matters if the code doesn't compile
2. **Type errors and interface mismatches** — especially in the Clean Architecture layer boundaries (handler → service → repository)
3. **Nil pointer risks** — check Redis client, DB connection, and config values
4. **Error handling** — every error from Redis, PostgreSQL, HTTP calls, and JWT parsing must be handled
5. **Lint violations** — fix gosec issues first (SOC 2 compliance), then revive, then style
6. **Test failures** — fix broken assertions, update table-driven test cases
7. **Coverage gaps** — add tests for uncovered branches

## Common Fix Patterns

### Missing error handling on Close()
\`\`\`go
// Before (errcheck violation)
resp.Body.Close()

// After
defer func() {
    if err := resp.Body.Close(); err != nil {
        slog.Warn("failed to close response body", "error", err)
    }
}()
\`\`\`

### Unwrapped errors
\`\`\`go
// Before
return err

// After
return fmt.Errorf("fetching route config from postgres: %w", err)
\`\`\`

### Missing context propagation in handlers
\`\`\`go
// Before
result, err := s.service.GetRoutes()

// After
result, err := s.service.GetRoutes(r.Context())
\`\`\`

### Chi middleware not composable
\`\`\`go
// Before — function that modifies the router directly
func SetupAuth(r chi.Router) { ... }

// After — returns a standard Chi middleware
func AuthMiddleware(validator auth.TokenValidator) func(http.Handler) http.Handler {
    return func(next http.Handler) http.Handler {
        return http.HandlerFunc(func(w http.ResponseWriter, r *http.Request) {
            // validate token, set claims in context
            next.ServeHTTP(w, r.WithContext(ctx))
        })
    }
}
\`\`\`

### Circuit breaker state not thread-safe
\`\`\`go
// Use sync/atomic or sync.RWMutex for circuit breaker state
// Never use plain struct fields for concurrent state in internal/circuit/
\`\`\`

## Exit Criteria

The build-fix cycle is complete when ALL of the following pass:

- [ ] \`go build ./...\` — zero compilation errors
- [ ] \`go vet ./...\` — zero warnings
- [ ] \`golangci-lint run ./...\` — zero violations
- [ ] \`go test -race ./internal/... ./pkg/...\` — all tests pass, no race conditions
- [ ] Coverage ≥ 80% on \`internal/\` and \`pkg/\` packages
- [ ] \`go build -o bin/gateway cmd/gateway/main.go\` — binary builds successfully
- [ ] No \`gosec\` findings (SOC 2 compliance requirement)
- [ ] All exported functions have doc comments
- [ ] No files exceed 300 lines

## Related Files

- \`.golangci.yml\` — linter configuration and severity levels
- \`Makefile\` — build targets (\`make build\`, \`make lint\`, \`make test\`, \`make cover\`)
- \`.github/workflows/ci.yml\` — CI pipeline that enforces these same checks
- \`internal/observability/\` — ensure tracing and metrics compile after changes
- \`configs/development.yaml\` — local development configuration for smoke testing`,

  'plugin/codeforge-go-api-gateway/skills/code-review/SKILL.md': `---
skill: code-review
version: 1.0.0
description: Comprehensive code review for Go API gateway PRs — security, performance, correctness, and Go idioms
author: codeforge
tags:
  - code-review
  - go
  - api-gateway
  - security
  - quality
inputs:
  - name: pr_number
    description: GitHub PR number to review
    required: false
  - name: files
    description: Specific files or directories to review (comma-separated)
    required: false
  - name: focus
    description: Review focus area (security, performance, correctness, all)
    default: all
    required: false
  - name: severity
    description: Minimum severity to report (info, warning, error, critical)
    default: warning
    required: false
---

# Code Review Skill — Go API Gateway

You are performing a thorough code review for the **go-api-gateway** project. This is a high-performance API gateway handling authentication, rate limiting, and request routing for a microservices architecture. Reviews must be rigorous — this is infrastructure-critical code operating under SOC 2 compliance requirements.

## Review Process

### Step 1: Gather Context

If a \`pr_number\` is provided, use the GitHub MCP server to fetch PR details:

\`\`\`
mcp__github__get_pull_request(owner: "your-org", repo: "go-api-gateway", pull_number: <pr_number>)
\`\`\`

Retrieve the diff, PR description, linked issues, and any prior review comments. If no PR number is given, review the files specified in \`files\` or the current working tree changes (\`git diff --cached\` or \`git diff HEAD\`).

Identify:
- What feature, fix, or refactor is this change implementing?
- Which layer of Clean Architecture is affected (handler, service, repository, middleware)?
- Are there linked GitHub Issues providing acceptance criteria?

### Step 2: Static Analysis Verification

Before manual review, confirm that automated checks pass:

1. **Formatting**: \`gofmt -l .\` and \`goimports -l .\` should produce no output
2. **Linting**: \`golangci-lint run ./...\` with the project's \`.golangci.yml\` config (govet, errcheck, staticcheck, gosec, revive, gocyclo)
3. **Vet**: \`go vet ./...\` should pass cleanly
4. **Tests**: \`go test ./... -race -count=1\` should pass with no race conditions
5. **Coverage**: \`go test ./... -coverprofile=coverage.out\` should meet the 80% threshold

Report any static analysis failures as **blocking** findings before proceeding with manual review.

### Step 3: Architecture & Design Review

Evaluate the change against Clean Architecture principles:

**Layer Boundaries**
- Handlers in \`internal/handler/\` must only call service interfaces, never repositories directly
- Services in \`internal/service/\` must depend on repository interfaces, not concrete implementations
- Repositories in \`internal/repository/\` must not import handler or service packages
- Models in \`internal/model/\` must have zero dependencies on other internal packages
- Flag any import cycle or layer violation as **error** severity

**Dependency Injection**
- New dependencies must be injected via interfaces, not concrete types
- Constructors should follow the pattern: \`func NewXxx(deps ...Interface) *Xxx\`
- No use of \`init()\` functions — flag as **error**
- No global mutable state — flag as **error**

**Middleware Composition**
- All middleware in \`internal/middleware/\` must be composable Chi middleware: \`func(next http.Handler) http.Handler\`
- Middleware must propagate \`context.Context\` correctly
- Middleware ordering matters — verify auth runs before rate limiting, logging wraps everything

**File Organization**
- Files must not exceed 300 lines — flag violations as **warning**
- File names must use snake_case: \`rate_limiter.go\`, not \`rateLimiter.go\`
- One primary type per file; test file must be \`*_test.go\` alongside the source

### Step 4: Go Idioms & Style Review

Enforce Effective Go and Go Code Review Comments:

**Error Handling**
- All errors must be checked — no ignored return values (errcheck enforces this)
- Errors must be wrapped with context: \`fmt.Errorf("failed to validate token: %w", err)\`
- Never use \`panic()\` in library/handler code — flag as **critical**
- Custom errors in \`pkg/errors/\` should implement \`error\` interface and support \`errors.Is\`/\`errors.As\`
- Sentinel errors must be \`var ErrXxx = errors.New("...")\` at package level

**Naming**
- Exported functions/types: PascalCase with doc comments (required by linter)
- Unexported functions/types: camelCase
- Interfaces: prefer single-method interfaces named by the method (e.g., \`Reader\`, \`Validator\`)
- Avoid stuttering: \`ratelimit.RateLimiter\` not \`ratelimit.RateLimitRateLimiter\`
- Acronyms should be all caps: \`HTTPHandler\`, \`JWTValidator\`, \`APIKey\`

**Context Propagation**
- All handler functions must accept \`context.Context\` (via \`r.Context()\`)
- Context must be passed through service and repository layers
- Never store contexts in structs — flag as **error**
- Use \`context.WithTimeout\` or \`context.WithCancel\` for downstream calls

**Concurrency**
- Goroutines must have clear ownership and shutdown paths
- Channels should be typed and directional where possible
- Use \`sync.WaitGroup\` or \`errgroup.Group\` for goroutine lifecycle management
- Verify no goroutine leaks — every goroutine must have an exit condition

**Structured Logging**
- Use \`slog\` for all logging — no \`fmt.Println\` or \`log.Printf\`
- Log entries must include structured fields: \`slog.String("request_id", reqID)\`
- Sensitive data (tokens, passwords, API keys) must never appear in logs — flag as **critical**
- Use appropriate log levels: Debug for verbose, Info for operations, Warn for recoverable, Error for failures

### Step 5: Security Review (SOC 2 Compliance)

This is critical for an API gateway. Review with OWASP API Security Top 10 in mind:

**Authentication & Authorization**
- JWT validation must verify signature (RS256), expiration, issuer, and audience
- API key lookups must use constant-time comparison (\`subtle.ConstantTimeCompare\`)
- RBAC checks must occur after authentication, before handler logic
- No hardcoded secrets, tokens, or credentials — flag as **critical**
- Verify changes to \`internal/auth/**\` are reviewed by a CODEOWNERS-designated reviewer

**Input Validation**
- All request bodies must be validated and size-limited
- Path parameters and query strings must be sanitized
- JSON decoding must use \`json.NewDecoder\` with \`DisallowUnknownFields()\` where appropriate
- Verify \`http.MaxBytesReader\` is applied to request bodies

**Rate Limiting**
- Rate limit keys must be scoped correctly (per-client, per-endpoint, or global)
- Redis-backed sliding window implementation must handle clock skew
- Rate limit headers must be set: \`X-RateLimit-Limit\`, \`X-RateLimit-Remaining\`, \`X-RateLimit-Reset\`
- Verify rate limiting cannot be bypassed via header manipulation (e.g., spoofed \`X-Forwarded-For\`)

**Sensitive Paths**
- Changes to \`internal/auth/**\`, \`configs/production/**\`, \`*.pem\`, \`.env*\` require extra scrutiny
- TLS configuration must enforce TLS 1.2+ minimum
- Secrets must come from environment variables or a secrets manager, never config files
- API key rotation logic must not cause downtime

**Response Security**
- Error responses must not leak internal details (stack traces, SQL errors, internal IPs)
- Security headers must be set: \`X-Content-Type-Options\`, \`X-Frame-Options\`, \`Strict-Transport-Security\`
- CORS configuration must be explicit, not wildcard in production

### Step 6: Performance Review

This gateway sits in the critical path of every API request:

**Hot Path Analysis**
- Middleware chain must minimize allocations — avoid \`fmt.Sprintf\` in hot paths
- Use \`sync.Pool\` for frequently allocated objects (buffers, temporary structs)
- Redis calls must use connection pooling and pipelining where possible
- PostgreSQL queries must use prepared statements and connection pooling

**Memory & Allocations**
- Avoid unnecessary \`[]byte\` ↔ \`string\` conversions
- Use \`strings.Builder\` for string concatenation
- Prefer passing structs by pointer for types > 64 bytes
- Check for slice pre-allocation: \`make([]T, 0, expectedCap)\`

**Circuit Breaker**
- Circuit breaker in \`internal/circuit/\` must not block the hot path when open
- State transitions (closed → open → half-open) must be thread-safe
- Verify timeout and threshold configurations are sensible

**Benchmarks**
- Performance-critical changes (middleware, rate limiter, auth) should include benchmarks
- Benchmark functions: \`func BenchmarkXxx(b *testing.B)\`
- Use \`go test -bench=. -benchmem\` to verify allocation counts
- Compare against baseline if available

### Step 7: Test Quality Review

**Coverage & Completeness**
- New code must have tests — verify coverage meets 80% threshold
- Table-driven tests are required: \`tests := []struct{ name string; ... }{ ... }\`
- Each test case must have a descriptive \`name\` field
- Use \`t.Run(tt.name, func(t *testing.T) { ... })\` for subtests

**Test Patterns**
- HTTP handlers must be tested with \`httptest.NewServer\` or \`httptest.NewRecorder\`
- Use \`testify/assert\` and \`testify/require\` for assertions
- Mock external dependencies (Redis, PostgreSQL) using interfaces
- Integration tests in \`tests/\` must be tagged: \`//go:build integration\`

**Edge Cases**
- Verify tests cover error paths, not just happy paths
- Test boundary conditions: empty inputs, max-size payloads, expired tokens
- Test concurrent access for shared state (rate limiters, circuit breakers)
- Test graceful shutdown behavior where applicable

**Test Isolation**
- Tests must not depend on external services unless tagged as integration
- Use \`t.Parallel()\` where safe to do so
- Clean up resources with \`t.Cleanup()\`
- No test should depend on execution order

### Step 8: Observability Review

**Tracing**
- New handlers and service methods should create or propagate OpenTelemetry spans
- Span names should follow convention: \`handler.RouteName\`, \`service.MethodName\`
- Add relevant attributes to spans: \`http.method\`, \`http.route\`, \`http.status_code\`
- Verify spans are properly ended with \`defer span.End()\`

**Metrics**
- Prometheus metrics must follow naming conventions: \`gateway_requests_total\`, \`gateway_request_duration_seconds\`
- Use appropriate metric types: Counter for totals, Histogram for latencies, Gauge for current state
- Labels must be bounded — never use unbounded values (user IDs, request bodies) as labels

**Health Checks**
- Changes to dependencies must update health check endpoints
- Liveness: is the process running? Readiness: can it serve traffic?
- Health checks must verify Redis and PostgreSQL connectivity

## Review Output Format

Structure your review as follows:

### Summary
One paragraph describing what the change does and your overall assessment (Approve, Request Changes, or Comment).

### Findings

For each finding, provide:

\`\`\`
**[SEVERITY]** FILE:LINE — Brief title
Description of the issue and why it matters.
Suggested fix or alternative approach.
\`\`\`

Severity levels:
- **CRITICAL**: Security vulnerability, data leak, or production-breaking issue. Blocks merge.
- **ERROR**: Bug, architecture violation, or missing error handling. Blocks merge.
- **WARNING**: Code smell, performance concern, or missing test. Should be addressed.
- **INFO**: Style suggestion, minor improvement, or educational note. Non-blocking.

### Checklist

Confirm each item:
- [ ] No layer boundary violations (Clean Architecture)
- [ ] All errors handled and wrapped with context
- [ ] No sensitive data in logs or error responses
- [ ] Context propagated through all layers
- [ ] Tests cover happy path and error paths (≥80% coverage)
- [ ] Table-driven tests with descriptive names
- [ ] No hardcoded secrets or credentials
- [ ] Structured logging with slog
- [ ] OpenTelemetry spans for new handlers/services
- [ ] Prometheus metrics follow naming conventions
- [ ] File length ≤ 300 lines
- [ ] Doc comments on all exported functions
- [ ] Conventional commit message format
- [ ] AI-generated code flagged per AI-USAGE-POLICY.md

### Verdict

State one of:
- **APPROVE**: All checks pass, no blocking findings.
- **REQUEST CHANGES**: Blocking findings must be resolved before merge.
- **COMMENT**: Non-blocking suggestions; author may merge at discretion.

## Special Considerations

### Reviewing AI-Generated Code

Per the project's AI Usage Policy (\`docs/AI-USAGE-POLICY.md\`):
- AI-generated code must be flagged in PR descriptions
- Apply extra scrutiny to AI-generated security code (\`internal/auth/**\`)
- Verify AI-generated tests actually test meaningful behavior, not just achieve coverage
- Check for hallucinated package imports or non-existent API calls

### Reviewing Middleware Changes

Middleware changes affect every request flowing through the gateway:
- Verify middleware ordering in \`cmd/gateway/main.go\` router setup
- Test middleware in isolation AND as part of the chain
- Benchmark middleware to ensure sub-millisecond overhead
- Verify middleware respects graceful shutdown signals

### Reviewing Configuration Changes

Changes to \`internal/config/\` or \`configs/\`:
- Verify all new config values have sensible defaults
- Environment variable names must be ALL_CAPS with \`GATEWAY_\` prefix
- Production config must never be committed with real values
- Validate config at startup, fail fast on invalid configuration`,

  'plugin/codeforge-go-api-gateway/skills/phase/SKILL.md': `---
skill: phase
version: 1.0.0
description: Navigate Go API gateway development workflow phases — from discovery through deployment
triggers:
  - "phase"
  - "workflow"
  - "what phase"
  - "next phase"
  - "start phase"
  - "development workflow"
  - "project phase"
inputs:
  - name: phase_name
    description: "Target phase: discover, plan, blueprint, implement, verify, harden, document, release"
    required: false
  - name: ticket_id
    description: "GitHub Issue ID (e.g., GW-42) to track through phases"
    required: false
  - name: action
    description: "Action within phase: start, status, complete, skip"
    default: "start"
tags:
  - workflow
  - methodology
  - phases
  - project-management
  - go-api-gateway
---

# Skill: Development Phase Workflow

You are guiding a developer through the structured development workflow for the **go-api-gateway** project. This workflow ensures every feature — from a new middleware to a circuit breaker enhancement — follows a consistent, quality-driven process aligned with SOC 2 compliance and Clean Architecture principles.

## Phase Overview

The go-api-gateway project follows an 8-phase development methodology. Each phase has specific entry criteria, activities, deliverables, and exit criteria. Phases are documented in \`playbook/\` and tracked via GitHub Issues.

\`\`\`
┌──────────┐   ┌──────────┐   ┌───────────┐   ┌───────────┐
│ DISCOVER │──▶│   PLAN   │──▶│ BLUEPRINT │──▶│ IMPLEMENT │
└──────────┘   └──────────┘   └───────────┘   └───────────┘
                                                     │
┌──────────┐   ┌──────────┐   ┌──────────┐   ┌──────────┐
│ RELEASE  │◀──│ DOCUMENT │◀──│  HARDEN  │◀──│  VERIFY  │
└──────────┘   └──────────┘   └──────────┘   └──────────┘
\`\`\`

## Phase Definitions

### Phase 1: DISCOVER

**Purpose**: Understand the problem, gather context, identify constraints.

**Entry Criteria**: A GitHub Issue exists or a new requirement has been identified.

**Activities**:
1. Read the GitHub Issue thoroughly — understand the user story and acceptance criteria
2. Explore the existing codebase to understand current state:
   - Check \`internal/handler/\` for existing route handlers
   - Check \`internal/middleware/\` for existing middleware chain
   - Check \`internal/service/\` for business logic patterns
   - Check \`internal/config/\` for configuration patterns
3. Identify affected components in the Clean Architecture layers:
   - Handler layer (HTTP concerns)
   - Service layer (business logic)
   - Repository layer (data access — PostgreSQL, Redis)
4. Identify dependencies on external systems (Redis, PostgreSQL, upstream services)
5. Check for related issues, PRs, or ADRs in \`docs/\`
6. Assess SOC 2 compliance implications (auth changes, logging, audit trails)

**Deliverables**:
- Summary of the problem and current state
- List of affected files and packages
- Identified risks and open questions
- Compliance considerations if touching \`internal/auth/**\` or \`config/production/**\`

**Exit Criteria**: Clear understanding of what needs to change and why.

**Commands to run**:
\`\`\`bash
# Understand project structure
find internal/ -name "*.go" | head -40
# Check existing tests for the area
go test ./internal/handler/... -v -list '.*'
# Review current middleware chain
grep -r "r.Use(" internal/ cmd/
\`\`\`

---

### Phase 2: PLAN

**Purpose**: Define the approach, break work into tasks, estimate effort.

**Entry Criteria**: Discovery phase complete with clear problem understanding.

**Activities**:
1. Define the technical approach — which packages to modify or create
2. Map changes to Clean Architecture layers:
   - Will this need a new handler in \`internal/handler/\`?
   - Does it require a new service in \`internal/service/\`?
   - Does it need a new repository method in \`internal/repository/\`?
   - Is new middleware needed in \`internal/middleware/\`?
3. Break work into atomic, reviewable commits following conventional commits
4. Identify interfaces that need to be defined or extended (dependency injection)
5. Plan the test strategy:
   - Unit tests with table-driven patterns
   - Integration tests in \`tests/\`
   - HTTP tests with \`httptest\`
6. Estimate complexity and identify if the work should be split across PRs
7. Create the branch: \`feat/GW-{id}-{description}\` or \`fix/GW-{id}-{description}\`

**Deliverables**:
- Task breakdown with commit plan
- Interface definitions (Go interfaces for DI)
- Test plan (what to test, what to mock)
- Branch created from latest \`main\`

**Exit Criteria**: Actionable plan with clear task sequence.

**Invoke the plan skill**:
\`\`\`
Use the plan skill to create a detailed implementation plan for this work.
\`\`\`

---

### Phase 3: BLUEPRINT

**Purpose**: Design the solution — interfaces, types, middleware signatures, configuration schema.

**Entry Criteria**: Plan approved and branch created.

**Activities**:
1. Define Go interfaces for new components:
   \`\`\`go
   // In internal/service/ — define the contract
   type RateLimiter interface {
       Allow(ctx context.Context, key string) (bool, error)
   }
   \`\`\`
2. Define domain models in \`internal/model/\`:
   - Request/response DTOs
   - Domain entities
   - Error types in \`pkg/errors/\`
3. Define middleware signatures following Chi patterns:
   \`\`\`go
   func RateLimitMiddleware(limiter RateLimiter) func(http.Handler) http.Handler
   \`\`\`
4. Define configuration schema in \`internal/config/\`:
   - New Viper config keys
   - Environment variable mappings (ALL_CAPS)
   - Defaults for development, staging, production
5. Design observability:
   - Prometheus metrics to expose
   - OpenTelemetry span names and attributes
   - slog fields for structured logging
6. Review blueprint against OWASP API Security Top 10 if touching auth/routing

**Deliverables**:
- Interface definitions (\`.go\` files with interfaces only)
- Model/DTO structs
- Configuration schema additions
- Observability plan (metric names, span names)

**Exit Criteria**: All contracts defined, team agrees on the API surface.

---

### Phase 4: IMPLEMENT

**Purpose**: Write the code following TDD, Clean Architecture, and project conventions.

**Entry Criteria**: Blueprint complete with interfaces and models defined.

**Activities**:
1. **Write tests first** (invoke the \`tdd\` skill):
   - Table-driven unit tests for service layer
   - HTTP handler tests using \`httptest.NewRecorder()\`
   - Mock interfaces using testify mocks or hand-written mocks
   - Integration tests for Redis/PostgreSQL interactions
2. **Implement the code**:
   - Follow Clean Architecture: handler → service → repository
   - All exported functions must have doc comments
   - Use \`context.Context\` propagation on all handlers and service methods
   - Wrap errors with \`fmt.Errorf("operation: %w", err)\`
   - Use \`slog\` for structured logging — never \`fmt.Println\` or \`log\`
   - Keep files under 300 lines — split if needed
   - No \`init()\` functions
3. **Middleware implementation** (if applicable):
   - Must be composable Chi middleware: \`func(next http.Handler) http.Handler\`
   - Must propagate context
   - Must add relevant slog attributes
   - Must record Prometheus metrics
4. **Run checks continuously**:
   \`\`\`bash
   go vet ./...
   golangci-lint run
   go test ./... -race -count=1
   go test ./... -coverprofile=coverage.out
   go tool cover -func=coverage.out | grep total
   \`\`\`
5. **Commit atomically** with conventional commit messages:
   \`\`\`
   feat(ratelimit): add sliding window rate limiter with Redis backend
   fix(auth): handle expired JWT tokens with proper 401 response
   test(handler): add table-driven tests for health check endpoint
   \`\`\`

**Deliverables**:
- Implementation code in appropriate \`internal/\` packages
- Unit tests with ≥80% coverage
- All linting passing (\`golangci-lint run\` clean)
- All tests passing with race detector (\`go test -race\`)

**Exit Criteria**: Feature works, tests pass, lint clean, coverage met.

**Invoke the tdd skill**:
\`\`\`
Use the tdd skill to implement this feature test-first.
\`\`\`

---

### Phase 5: VERIFY

**Purpose**: Validate correctness, performance, and security before review.

**Entry Criteria**: Implementation complete, all tests passing locally.

**Activities**:
1. **Run the full verification suite**:
   \`\`\`bash
   # Lint
   golangci-lint run ./...
   
   # Vet
   go vet ./...
   
   # Unit tests with race detection
   go test ./... -race -count=1 -timeout 120s
   
   # Coverage check
   go test ./... -coverprofile=coverage.out
   go tool cover -func=coverage.out | grep total
   # Must be ≥80%
   
   # Build binary
   go build -o bin/gateway cmd/gateway/main.go
   
   # Build Docker image
   docker build -t go-api-gateway:local -f deployments/Dockerfile .
   \`\`\`
2. **Integration tests** (if Redis/PostgreSQL changes):
   \`\`\`bash
   docker-compose -f deployments/docker-compose.test.yml up -d
   go test ./tests/... -tags=integration -v
   docker-compose -f deployments/docker-compose.test.yml down
   \`\`\`
3. **Performance verification** (if on hot path):
   \`\`\`bash
   # Run benchmarks
   go test ./internal/ratelimit/... -bench=. -benchmem
   go test ./internal/middleware/... -bench=. -benchmem
   
   # Profile if needed
   go test ./internal/handler/... -cpuprofile=cpu.prof -memprofile=mem.prof
   go tool pprof cpu.prof
   \`\`\`
4. **Security checks** (if touching auth, config, or sensitive paths):
   \`\`\`bash
   # gosec is included in golangci-lint config
   golangci-lint run --enable gosec ./internal/auth/...
   
   # Check for hardcoded secrets
   grep -rn "password\\|secret\\|key" internal/ --include="*.go" | grep -v "_test.go" | grep -v "interface"
   \`\`\`
5. **Review the diff**:
   \`\`\`bash
   git diff main --stat
   git diff main -- internal/auth/  # Extra scrutiny on sensitive paths
   \`\`\`

**Deliverables**:
- All checks green
- Coverage report
- Benchmark results (if applicable)
- No security findings

**Exit Criteria**: Ready for peer review.

**Invoke the verify skill**:
\`\`\`
Use the verify skill to run the complete verification suite.
\`\`\`

---

### Phase 6: HARDEN

**Purpose**: Strengthen the implementation — edge cases, error handling, resilience.

**Entry Criteria**: Verification passed, basic implementation solid.

**Activities**:
1. **Edge case testing**:
   - What happens when Redis is down? (circuit breaker should activate)
   - What happens with malformed JWTs? (proper 401, not 500)
   - What happens with concurrent requests? (race condition free)
   - What happens when upstream services are slow? (timeout handling)
   - What happens with oversized request bodies? (limit enforcement)
2. **Error handling review**:
   - All errors wrapped with context: \`fmt.Errorf("ratelimit.Allow: %w", err)\`
   - Appropriate HTTP status codes returned
   - Error responses use consistent JSON format from \`pkg/errors/\`
   - No sensitive information leaked in error messages
3. **Resilience patterns**:
   - Circuit breaker thresholds configured appropriately
   - Retry logic has exponential backoff with jitter
   - Graceful degradation when dependencies fail
   - Connection pool limits set for PostgreSQL and Redis
4. **Configuration hardening**:
   - All config values have sensible defaults
   - Production config reviewed in \`configs/production.yaml\`
   - Sensitive values come from environment variables, not files
5. **Observability hardening**:
   - All error paths emit metrics
   - Spans have appropriate error status
   - Structured logs include correlation IDs (trace ID)
   - Health check endpoint reports dependency status

**Deliverables**:
- Additional edge case tests
- Improved error handling
- Resilience configuration
- Updated health check if new dependencies added

**Exit Criteria**: Implementation handles failure gracefully.

---

### Phase 7: DOCUMENT

**Purpose**: Ensure the change is documented for operators and future developers.

**Entry Criteria**: Implementation hardened and verified.

**Activities**:
1. **Code documentation**:
   - All exported functions have doc comments (enforced by \`revive\`)
   - Package-level doc comments in \`doc.go\` for new packages
   - Complex logic has inline comments explaining "why"
2. **API documentation** (if new endpoints):
   - Update \`docs/\` with endpoint documentation
   - Include request/response examples
   - Document error codes and status codes
3. **Configuration documentation**:
   - Document new config keys in \`configs/README.md\` or inline
   - Document new environment variables
4. **Runbook updates** (if operational changes):
   - Update \`docs/runbooks/\` with troubleshooting steps
   - Document new metrics and alerts
   - Document new health check dependencies
5. **Architecture updates** (if structural changes):
   - Update \`docs/ARCHITECTURE.md\` if new components added
   - Update middleware chain documentation
   - Update dependency diagram if new external dependencies
6. **PR description**:
   - Clear description of what changed and why
   - Link to GitHub Issue
   - Screenshots or curl examples if applicable
   - Mark AI-generated code sections with \`// Generated with AI assistance\`

**Deliverables**:
- Updated documentation
- Complete PR description using \`.github/PULL_REQUEST_TEMPLATE.md\`
- AI usage disclosure if applicable

**Exit Criteria**: A new team member could understand the change from docs alone.

---

### Phase 8: RELEASE

**Purpose**: Ship the change through the deployment pipeline.

**Entry Criteria**: PR approved, all CI checks green, documentation complete.

**Activities**:
1. **Pre-merge checklist**:
   - [ ] At least 1 approval from CODEOWNERS
   - [ ] All CI stages green (lint, vet, test, race, build)
   - [ ] Coverage ≥80%
   - [ ] No unresolved review comments
   - [ ] Branch is up to date with \`main\`
   - [ ] Conventional commit messages
   - [ ] CODEOWNERS approval for sensitive paths (\`internal/auth/**\`, \`config/production/**\`)
2. **Merge to main**:
   - Squash merge for single-feature PRs
   - Merge commit for multi-commit PRs with meaningful history
3. **Staging deployment** (automatic via GitHub Actions):
   - \`.github/workflows/deploy-staging.yml\` triggers on merge to \`main\`
   - Verify in staging:
     \`\`\`bash
     curl -s https://staging-gateway.example.com/health | jq .
     # Check Grafana dashboards for anomalies
     # Check Jaeger for trace completeness
     \`\`\`
4. **Production deployment** (manual approval):
   - \`.github/workflows/deploy-production.yml\` requires manual trigger
   - Monitor after deploy:
     - Prometheus: error rate, latency p99, rate limit hits
     - Jaeger: trace completeness, new span names
     - CloudWatch: ECS task health, ALB target group health
5. **Post-deploy verification**:
   \`\`\`bash
   # Smoke test production
   curl -s https://gateway.example.com/health | jq .
   
   # Verify metrics endpoint
   curl -s https://gateway.example.com/metrics | grep gateway_
   \`\`\`
6. **Close the issue**:
   - Reference the PR in the GitHub Issue
   - Add any follow-up issues identified during the process

**Deliverables**:
- Merged PR
- Successful staging deployment
- Successful production deployment
- Closed GitHub Issue

**Exit Criteria**: Feature live in production, monitored, issue closed.

---

## Phase Navigation

When a developer asks about phases, determine:

1. **"What phase am I in?"** — Look at the current branch state, existing files, test status, and PR status to determine the current phase.

2. **"Start phase X"** — Walk through the entry criteria and activities for that phase, providing specific commands and file paths for the go-api-gateway project.

3. **"Next phase"** — Identify the current phase, verify exit criteria are met, and transition to the next phase.

4. **"Skip to phase X"** — Warn about skipped phases but allow it for experienced developers. Note which exit criteria from skipped phases should still be verified.

5. **"Phase status"** — Check what's been completed in the current phase and what remains.

## Phase-Specific Tool Usage

| Phase | Primary Tools | Skills to Invoke |
|-------|--------------|-----------------|
| Discover | \`find\`, \`grep\`, \`go test -list\` | — |
| Plan | GitHub Issues, \`git checkout -b\` | \`plan\` |
| Blueprint | Go interfaces, \`internal/model/\` | — |
| Implement | \`go test\`, \`golangci-lint\`, \`slog\` | \`tdd\`, \`build-fix\` |
| Verify | \`go test -race\`, \`go test -cover\`, \`docker build\` | \`verify\` |
| Harden | \`go test -bench\`, \`go tool pprof\` | \`verify\` |
| Document | Markdown, doc comments | — |
| Release | GitHub Actions, \`curl\`, Grafana | — |

## Adapting Phase Depth

Not every change needs full ceremony:

- **Trivial fix** (typo, comment, minor refactor): Discover → Implement → Verify → Release
- **Bug fix**: Discover → Plan → Implement → Verify → Release
- **New feature**: All 8 phases
- **Security-sensitive change** (\`internal/auth/**\`): All 8 phases with extra scrutiny in Harden
- **Performance optimization**: All 8 phases with benchmarks in Verify and Harden

Always reference the playbook files in \`playbook/\` for detailed phase checklists specific to the go-api-gateway project.`,

  'plugin/codeforge-go-api-gateway/skills/plan/SKILL.md': `---
skill: plan
version: "1.0"
slug: codeforge-go-api-gateway
description: >
  Plan and decompose Go API gateway development tasks into structured implementation
  phases following Clean Architecture principles and the project's development methodology.
triggers:
  - plan
  - design
  - architect
  - break down
  - decompose
  - implementation plan
inputs:
  - name: task_description
    type: string
    required: true
    description: High-level description of the feature or change to plan
  - name: ticket_id
    type: string
    required: false
    description: GitHub Issue ID (e.g., GW-42)
  - name: scope
    type: enum
    values: [small, medium, large, epic]
    default: medium
    description: Estimated scope of the work
tags:
  - planning
  - architecture
  - workflow
  - go
  - api-gateway
---

# Skill: Plan — Go API Gateway Development Workflow

## Purpose

Break down a feature request, bug fix, or infrastructure change into a structured implementation plan that follows the go-api-gateway project's Clean Architecture, coding standards, and development methodology.

## When to Use

- Starting work on a new GitHub Issue
- Designing a new middleware component (rate limiter, circuit breaker, auth handler)
- Planning a cross-cutting concern (observability, error handling, configuration)
- Decomposing an epic into smaller deliverable PRs
- Evaluating architectural trade-offs for gateway routing or upstream management

## Planning Process

### Phase 1: Context Gathering

Before generating a plan, collect the following context:

1. **Read the ticket** — If a \`ticket_id\` is provided, fetch the GitHub Issue to understand acceptance criteria, labels, and linked issues.

2. **Understand the affected layers** — Determine which layers of Clean Architecture are impacted:
   - \`internal/handler/\` — HTTP handlers, Chi route registration
   - \`internal/middleware/\` — Chi middleware (composable, context-propagating)
   - \`internal/service/\` — Business logic, orchestration
   - \`internal/repository/\` — PostgreSQL queries, Redis operations
   - \`internal/model/\` — Domain models, DTOs, request/response types
   - \`internal/config/\` — Viper configuration structs
   - \`internal/auth/\` — JWT validation, API key verification, RBAC policies
   - \`internal/ratelimit/\` — Redis-backed sliding window rate limiter
   - \`internal/circuit/\` — Circuit breaker state machine
   - \`internal/observability/\` — OpenTelemetry, Prometheus, slog setup
   - \`pkg/httputil/\` — Shared response helpers, error rendering
   - \`pkg/errors/\` — Custom error types, error codes

3. **Check existing code** — Read relevant files to understand current patterns, interfaces, and conventions already established in the codebase.

4. **Identify dependencies** — Note any upstream services, Redis data structures, PostgreSQL schema changes, or configuration additions required.

### Phase 2: Architecture Decision

For medium and large scope tasks, document key decisions:

\`\`\`markdown
### Architecture Decisions
- **Pattern**: [e.g., Middleware chain, Repository pattern, Strategy pattern]
- **Interface**: [Define the interface contract before implementation]
- **Data Flow**: request → middleware → handler → service → repository → response
- **Error Strategy**: [How errors propagate, what HTTP codes map to what domain errors]
- **Observability**: [What metrics, traces, and log entries are added]
\`\`\`

Apply these gateway-specific considerations:

- **Latency budget**: Every middleware adds latency. Measure with benchmarks. Target p99 < 5ms per middleware hop.
- **Concurrency safety**: All shared state must be safe for concurrent access. Use \`sync.RWMutex\` or atomic operations where needed. Redis operations are inherently concurrent-safe.
- **Context propagation**: Every handler and service method must accept \`context.Context\` as the first parameter. Trace IDs, request IDs, and auth claims flow through context.
- **Graceful degradation**: If Redis is down, rate limiting should fail open (configurable). If an upstream is down, circuit breaker should trip. Document failure modes.
- **SOC 2 compliance**: Any change touching \`internal/auth/**\`, \`configs/production/**\`, or credential handling requires security review per CODEOWNERS.

### Phase 3: Task Decomposition

Break the work into ordered, independently reviewable units. Each task should map to a single commit or small PR.

#### Task Template

For each task, produce:

\`\`\`markdown
#### Task N: [Short Title]
- **Branch**: \`type/TICKET-short-desc\` (e.g., \`feat/GW-42-add-circuit-breaker\`)
- **Layer**: [handler | middleware | service | repository | model | config | auth | observability | pkg | infra]
- **Files to Create/Modify**:
  - \`internal/circuit/breaker.go\` — Circuit breaker state machine
  - \`internal/circuit/breaker_test.go\` — Table-driven tests
- **Interface Contract**:
  \`\`\`go
  type CircuitBreaker interface {
      Allow(ctx context.Context, upstream string) (bool, error)
      RecordSuccess(ctx context.Context, upstream string)
      RecordFailure(ctx context.Context, upstream string)
  }
  \`\`\`
- **Dependencies**: [What must exist before this task]
- **Tests Required**:
  - Unit tests with table-driven patterns
  - Benchmark tests for hot paths
  - Integration tests if touching Redis/PostgreSQL
- **Acceptance Criteria**: [Specific, measurable outcomes]
- **Estimated Effort**: [S/M/L]
\`\`\`

#### Decomposition Rules

1. **Model and interfaces first** — Define types in \`internal/model/\` and interfaces in the consuming package before implementing.
2. **Repository before service** — Data access layer is implemented and tested before business logic.
3. **Service before handler** — Business logic is implemented and tested before HTTP wiring.
4. **Middleware is standalone** — Middleware should be a self-contained Chi middleware function: \`func(next http.Handler) http.Handler\`.
5. **Configuration before feature** — Add Viper config structs and environment variable mappings before the feature that uses them.
6. **Tests alongside code** — Every task includes its test file. No task is "done" without tests meeting 80% coverage.
7. **Observability is not an afterthought** — Each task should include relevant metrics, trace spans, and structured log entries.

### Phase 4: Implementation Order

Produce a dependency graph as an ordered list:

\`\`\`markdown
### Implementation Order
1. ✅ Task 1: Add config structs (no dependencies)
2. ✅ Task 2: Define domain models and interfaces (depends on 1)
3. 🔲 Task 3: Implement repository layer (depends on 2)
4. 🔲 Task 4: Implement service layer (depends on 3)
5. 🔲 Task 5: Implement handler/middleware (depends on 4)
6. 🔲 Task 6: Add integration tests (depends on 3-5)
7. 🔲 Task 7: Add observability (metrics, traces) (depends on 5)
8. 🔲 Task 8: Update deployment configs (depends on all)
\`\`\`

### Phase 5: Risk Assessment

For each plan, identify:

\`\`\`markdown
### Risks & Mitigations
| Risk | Impact | Likelihood | Mitigation |
|------|--------|------------|------------|
| Redis connection pool exhaustion under load | High | Medium | Configure max pool size, add circuit breaker on Redis client, fail-open for rate limiting |
| JWT validation adds >2ms p99 latency | Medium | Low | Cache JWKS keys, benchmark with \`go test -bench\`, use RS256 key caching |
| Breaking change to middleware chain order | High | Medium | Document middleware ordering in handler registration, add integration test for full chain |
\`\`\`

### Phase 6: PR Strategy

Define how the work ships:

- **Single PR** (small scope): One branch, one review cycle.
- **Stacked PRs** (medium scope): Base branch with incremental PRs that build on each other. Each PR is independently reviewable and passes CI.
- **Feature flag** (large scope): Ship behind a configuration toggle in \`configs/\`. Enable in staging first, then production.
- **Epic breakdown** (epic scope): Create child GitHub Issues for each task. Each gets its own PR. Track progress in the parent issue.

## Output Format

When this skill is invoked, produce a plan document with these sections:

\`\`\`markdown
# Implementation Plan: [Feature Title]
**Ticket**: GW-XX
**Scope**: small | medium | large | epic
**Author**: Claude (AI-assisted planning)
**Date**: YYYY-MM-DD

## Summary
[2-3 sentence overview of what is being built and why]

## Architecture Decisions
[Key design choices, patterns, trade-offs]

## Tasks
[Ordered task list using the task template above]

## Implementation Order
[Dependency graph]

## Risks & Mitigations
[Risk table]

## PR Strategy
[How this ships]

## Checklist
- [ ] All interfaces defined before implementation
- [ ] Table-driven tests for all business logic
- [ ] Benchmarks for hot-path code (middleware, routing)
- [ ] Structured logging with slog (no fmt.Println)
- [ ] Context propagation on all public functions
- [ ] Errors wrapped with fmt.Errorf and %w
- [ ] Prometheus metrics for new endpoints/middleware
- [ ] OpenTelemetry spans for cross-service calls
- [ ] Configuration documented in configs/development.yaml
- [ ] golangci-lint passes with zero warnings
- [ ] Coverage ≥ 80% on new code
- [ ] No init() functions
- [ ] File length ≤ 300 lines
- [ ] Conventional commit messages
- [ ] CODEOWNERS updated if new sensitive paths added
\`\`\`

## Examples

### Example Invocation

> "Plan the implementation of per-client rate limiting with Redis sliding window for ticket GW-15"

### Example Invocation (Bug Fix)

> "Plan a fix for the JWT middleware not propagating claims to downstream handlers, ticket GW-28"

### Example Invocation (Infrastructure)

> "Plan adding distributed tracing with OpenTelemetry to all middleware and upstream proxy calls"

## References

- Project architecture: \`docs/ARCHITECTURE.md\`
- Contributing guide: \`docs/CONTRIBUTING.md\`
- AI usage policy: \`docs/AI-USAGE-POLICY.md\`
- Development methodology phases: \`playbook/\`
- CI pipeline: \`.github/workflows/ci.yml\`
- Linting config: \`.golangci.yml\`
- Go module: \`go.mod\``,

  'plugin/codeforge-go-api-gateway/skills/tdd/SKILL.md': `---
name: tdd
description: Test-Driven Development workflow for Go API gateway components using table-driven tests, httptest, and testify assertions
version: 1.0.0
author: codeforge
tags:
  - testing
  - tdd
  - go
  - api-gateway
  - table-driven-tests
category: development-methodology
applies_to:
  - "internal/handler/**"
  - "internal/middleware/**"
  - "internal/service/**"
  - "internal/repository/**"
  - "internal/auth/**"
  - "internal/ratelimit/**"
  - "internal/circuit/**"
  - "pkg/**"
inputs:
  - name: component_type
    description: "Type of component: handler, middleware, service, repository, auth, ratelimit, circuit"
    required: true
  - name: component_name
    description: "Name of the component being developed (e.g., RateLimiter, JWTValidator, RouteHandler)"
    required: true
  - name: acceptance_criteria
    description: "List of behaviors the component must satisfy"
    required: false
---

# TDD Skill — Go API Gateway

Apply strict Red-Green-Refactor test-driven development for all go-api-gateway components. Every line of production code must be justified by a failing test first.

## Workflow

### Phase 1: Red — Write a Failing Test

Before writing any production code, create a test file following Go conventions:

1. **File placement**: Test files live alongside the code they test.
   - \`internal/handler/route_handler.go\` → \`internal/handler/route_handler_test.go\`
   - \`internal/middleware/ratelimit.go\` → \`internal/middleware/ratelimit_test.go\`

2. **Use table-driven tests** — this is mandatory per project conventions:

\`\`\`go
func TestRateLimiter_Allow(t *testing.T) {
    tests := []struct {
        name           string
        clientID       string
        requestsPerSec int
        burst          int
        requestCount   int
        wantAllowed    int
        wantDenied     int
    }{
        {
            name:           "allows requests within limit",
            clientID:       "client-001",
            requestsPerSec: 10,
            burst:          5,
            requestCount:   5,
            wantAllowed:    5,
            wantDenied:     0,
        },
        {
            name:           "denies requests exceeding limit",
            clientID:       "client-002",
            requestsPerSec: 2,
            burst:          2,
            requestCount:   5,
            wantAllowed:    2,
            wantDenied:     3,
        },
    }

    for _, tt := range tests {
        t.Run(tt.name, func(t *testing.T) {
            // Test implementation here
        })
    }
}
\`\`\`

3. **For HTTP handlers**, always use \`net/http/httptest\`:

\`\`\`go
func TestHealthHandler_ServeHTTP(t *testing.T) {
    req := httptest.NewRequest(http.MethodGet, "/healthz", nil)
    rec := httptest.NewRecorder()

    handler := NewHealthHandler(deps)
    handler.ServeHTTP(rec, req)

    assert.Equal(t, http.StatusOK, rec.Code)
}
\`\`\`

4. **For Chi middleware**, test as composable middleware:

\`\`\`go
func TestAuthMiddleware(t *testing.T) {
    nextHandler := http.HandlerFunc(func(w http.ResponseWriter, r *http.Request) {
        w.WriteHeader(http.StatusOK)
    })

    middleware := NewAuthMiddleware(mockValidator)
    handler := middleware(nextHandler)

    req := httptest.NewRequest(http.MethodGet, "/api/v1/resource", nil)
    req.Header.Set("Authorization", "Bearer "+validToken)
    rec := httptest.NewRecorder()

    handler.ServeHTTP(rec, req)
    assert.Equal(t, http.StatusOK, rec.Code)
}
\`\`\`

5. **For repository tests**, use interfaces and mocks:

\`\`\`go
type mockRedisClient struct {
    getFunc func(ctx context.Context, key string) (string, error)
    setFunc func(ctx context.Context, key string, value interface{}, ttl time.Duration) error
}
\`\`\`

6. **Run the test and confirm it fails**:

\`\`\`bash
go test -v -run TestComponentName ./internal/path/...
\`\`\`

The test MUST fail. If it passes without production code, the test is not testing the right thing. Fix the test before proceeding.

### Phase 2: Green — Write Minimal Production Code

Write the **smallest amount of code** that makes the failing test pass:

1. **Do not** add features, optimizations, or error handling not covered by a test.
2. **Do not** write code for future test cases — only the current failing test.
3. **Follow project structure**:
   - Handlers in \`internal/handler/\` — accept \`http.ResponseWriter\` and \`*http.Request\`
   - Services in \`internal/service/\` — contain business logic, accept interfaces
   - Repositories in \`internal/repository/\` — data access, accept \`context.Context\` as first param
4. **Context propagation** is required on all handler and service methods.
5. **Errors must be wrapped** with \`fmt.Errorf("operation description: %w", err)\`.
6. **All exported functions must have doc comments**.

Run the test again:

\`\`\`bash
go test -v -run TestComponentName ./internal/path/...
\`\`\`

The test MUST pass. If it does not, fix the production code — do not modify the test.

### Phase 3: Refactor — Clean Up Under Green Tests

With all tests passing, improve the code:

1. **Extract interfaces** for dependency injection:

\`\`\`go
// Validator validates authentication tokens.
type Validator interface {
    ValidateToken(ctx context.Context, token string) (*Claims, error)
}
\`\`\`

2. **Reduce cyclomatic complexity** — functions must stay under the gocyclo threshold.
3. **Keep files under 300 lines** — split into focused files if needed.
4. **Apply naming conventions**: camelCase unexported, PascalCase exported, snake_case files.
5. **No init() functions** — use explicit initialization.
6. **Run the full check suite after refactoring**:

\`\`\`bash
gofmt -w .
goimports -w .
golangci-lint run ./...
go test -race -coverprofile=coverage.out ./...
go tool cover -func=coverage.out
\`\`\`

All tests must still pass. Coverage must remain at or above 80%.

## Component-Specific TDD Patterns

### Handlers (internal/handler/)

- Test HTTP status codes, response bodies, headers, and content types.
- Test error responses match the project's error format from \`pkg/errors/\`.
- Test context values are propagated (request ID, trace ID, authenticated user).
- Use \`chi.NewRouter()\` in tests when testing route parameters:

\`\`\`go
r := chi.NewRouter()
r.Get("/api/v1/services/{serviceID}", handler.GetService)
req := httptest.NewRequest(http.MethodGet, "/api/v1/services/svc-123", nil)
\`\`\`

### Middleware (internal/middleware/)

- Test that middleware calls the next handler on success.
- Test that middleware short-circuits on failure (returns error, does NOT call next).
- Test that middleware adds expected values to request context.
- Test middleware ordering and composition.
- Always test the \`func(next http.Handler) http.Handler\` signature.

### Services (internal/service/)

- Test business logic in isolation using interface mocks.
- Test error wrapping — verify errors can be unwrapped with \`errors.Is\` / \`errors.As\`.
- Test edge cases: nil inputs, empty slices, zero values, context cancellation.

### Auth (internal/auth/)

- Test JWT validation with valid, expired, malformed, and missing tokens.
- Test RS256 signature verification with known key pairs.
- Test RBAC role checks for each permission level.
- Test API key lookup and validation.
- **Never log or hardcode real secrets in tests** — generate test-only keys.

### Rate Limiting (internal/ratelimit/)

- Test sliding window algorithm correctness.
- Test per-client isolation (one client's traffic does not affect another).
- Test Redis failure fallback behavior (fail-open vs fail-closed — document the choice).
- Test rate limit headers in responses: \`X-RateLimit-Limit\`, \`X-RateLimit-Remaining\`, \`X-RateLimit-Reset\`.

### Circuit Breaker (internal/circuit/)

- Test state transitions: Closed → Open → Half-Open → Closed.
- Test failure threshold triggers open state.
- Test timeout transitions from open to half-open.
- Test successful probe in half-open resets to closed.
- Test concurrent access safety with \`-race\` flag.

### Repository (internal/repository/)

- Use interfaces so tests can mock database calls.
- For integration tests in \`tests/\`, use testcontainers or a test database.
- Test query errors, connection timeouts, and context cancellation.

## Test Quality Checklist

Before considering a TDD cycle complete, verify:

- [ ] Every test has a descriptive name explaining the behavior under test
- [ ] Table-driven format is used for tests with multiple cases
- [ ] Tests use \`testify/assert\` or \`testify/require\` for assertions
- [ ] Tests do not depend on execution order
- [ ] Tests clean up resources (use \`t.Cleanup()\`)
- [ ] Tests use \`t.Parallel()\` where safe
- [ ] No \`time.Sleep\` in tests — use channels, tickers, or test clocks
- [ ] Error messages in assertions describe what went wrong
- [ ] Mocks verify expected interactions (calls, arguments)
- [ ] Race detector passes: \`go test -race ./...\`
- [ ] Coverage meets 80% threshold for the package

## Integration with CI

Tests written during TDD feed directly into the GitHub Actions pipeline:

1. **Unit tests**: \`go test -race -short ./internal/...\`
2. **Integration tests**: \`go test -race -tags=integration ./tests/...\`
3. **Race detection**: Enabled on all test runs via \`-race\`
4. **Coverage reporting**: \`go test -coverprofile=coverage.out -covermode=atomic ./...\`
5. **Benchmark tests**: \`go test -bench=. -benchmem ./internal/...\` (for performance-sensitive paths like rate limiting and JWT validation)

## Commit Discipline

Each TDD cycle produces a focused commit:

1. **Red**: Do not commit failing tests alone (squash into the green commit).
2. **Green**: \`feat(ratelimit): add sliding window rate limiter\` or \`fix(auth): handle expired JWT gracefully\`
3. **Refactor**: \`refactor(handler): extract response writer helper\` — tests must still pass.

Use conventional commits. Reference the ticket: \`feat(GW-42): add circuit breaker with configurable thresholds\`.

## When to Use This Skill

- Implementing any new handler, middleware, service, or repository
- Adding a new authentication or authorization mechanism
- Implementing or modifying rate limiting logic
- Adding circuit breaker behavior to upstream service calls
- Fixing a bug (write a test that reproduces the bug first)
- Refactoring existing code (ensure tests exist before changing anything)

## When NOT to Use This Skill

- Writing configuration loading (use integration tests instead)
- Modifying Dockerfiles, Helm charts, or Terraform (use deployment validation)
- Updating documentation only
- Changing CI pipeline configuration`,

  'plugin/codeforge-go-api-gateway/skills/verify/SKILL.md': `---
skill: verify
version: 1.0.0
description: Verify Go API gateway code quality, tests, security, and deployment readiness
tags: [go, verification, testing, linting, security, api-gateway]
triggers:
  - verify
  - check
  - validate
  - review-readiness
  - pre-merge
inputs:
  - name: scope
    description: What to verify (all, lint, test, security, build, integration)
    required: false
    default: all
  - name: path
    description: Specific package or file path to verify
    required: false
    default: ./...
  - name: fix
    description: Whether to auto-fix issues where possible
    required: false
    default: false
---

# Skill: verify

Run the complete verification pipeline for the go-api-gateway project. This skill validates code quality, correctness, security posture, and deployment readiness before code is merged to \`main\`.

## Context

You are verifying code in a Go 1.22+ API gateway project that uses Chi v5 router, PostgreSQL, Redis, JWT authentication, and follows Clean Architecture. The project must meet SOC 2 compliance requirements and maintain 80% test coverage.

## Verification Pipeline

Execute these stages in order. Stop and report on the first stage that fails unless \`scope\` is set to a specific stage.

### Stage 1: Format Check

Verify all Go files are properly formatted:

\`\`\`
gofmt -l .
goimports -l .
\`\`\`

If \`fix\` is true, run \`gofmt -w .\` and \`goimports -w .\` to auto-fix formatting issues.

Report any files that are not formatted. Formatting violations must be zero for the verify to pass.

### Stage 2: Lint

Run the full golangci-lint suite configured in \`.golangci.yml\`:

\`\`\`
golangci-lint run ./...
\`\`\`

Key linters to pay attention to:
- **govet**: Suspicious constructs (e.g., Printf format string issues)
- **errcheck**: Unchecked error returns — critical for gateway reliability
- **staticcheck**: Advanced static analysis
- **gosec**: Security-focused linting (SOC 2 requirement)
- **revive**: Style and convention enforcement
- **gocyclo**: Cyclomatic complexity (max 15 per function)

If \`path\` is specified, scope the lint to that path:

\`\`\`
golangci-lint run {{ path }}
\`\`\`

For each finding, explain:
1. What the issue is
2. Why it matters for an API gateway (performance, security, reliability)
3. How to fix it

### Stage 3: Vet

Run Go vet for correctness checks:

\`\`\`
go vet ./...
\`\`\`

Pay special attention to:
- Incorrect context usage in handlers and middleware
- Printf format string mismatches in slog calls
- Struct tag validation for JSON serialization in model types
- Unreachable code in middleware chains

### Stage 4: Unit Tests

Run all unit tests with race detection and coverage:

\`\`\`
go test -race -cover -coverprofile=coverage.out -count=1 ./internal/... ./pkg/...
\`\`\`

Then check coverage threshold:

\`\`\`
go tool cover -func=coverage.out
\`\`\`

**Coverage requirements:**
- Overall: ≥ 80%
- \`internal/auth/\`: ≥ 90% (security-critical, SOC 2)
- \`internal/ratelimit/\`: ≥ 85% (reliability-critical)
- \`internal/middleware/\`: ≥ 85% (request path)
- \`internal/handler/\`: ≥ 80%
- \`internal/service/\`: ≥ 80%
- \`pkg/errors/\`: ≥ 90%

Verify test quality:
- All tests must be table-driven where applicable
- HTTP handlers must use \`httptest.NewRecorder()\` and \`httptest.NewRequest()\`
- Mocks must use interfaces, not concrete types
- No \`init()\` functions in test files
- Tests must not depend on external services (Redis, PostgreSQL) — those belong in integration tests

### Stage 5: Integration Tests

Run integration tests (requires Docker services):

\`\`\`
go test -race -tags=integration -count=1 ./tests/...
\`\`\`

Integration tests verify:
- PostgreSQL config store reads/writes
- Redis rate limiting with sliding window algorithm
- JWT token validation with RS256 keys
- End-to-end request routing through middleware chain
- Circuit breaker state transitions
- Health check endpoint responses
- Graceful shutdown behavior

If Docker services are not available, skip this stage and note it in the report.

### Stage 6: Build Verification

Verify the binary builds cleanly for the target platform:

\`\`\`
CGO_ENABLED=0 GOOS=linux GOARCH=amd64 go build -o bin/gateway cmd/gateway/main.go
\`\`\`

Check binary properties:
- Binary exists at \`bin/gateway\`
- Binary is statically linked (no CGO)
- Binary size is reasonable (report size)

Verify Docker image builds:

\`\`\`
docker build -t go-api-gateway:verify -f deployments/Dockerfile .
\`\`\`

### Stage 7: Security Audit

Run security-specific checks required for SOC 2 compliance:

**Dependency vulnerabilities:**
\`\`\`
govulncheck ./...
\`\`\`

**Secret scanning:**
- Verify no \`.pem\` files are committed
- Verify no \`.env\` files are committed
- Verify no hardcoded tokens, passwords, or API keys in source
- Check that \`internal/auth/**\` files do not log sensitive token data
- Verify JWT secrets are loaded from environment/config, never hardcoded

**OWASP API Security Top 10 checks:**
1. Broken Object Level Authorization — verify handlers check resource ownership
2. Broken Authentication — verify JWT validation on all protected routes
3. Excessive Data Exposure — verify response DTOs don't leak internal fields
4. Lack of Resources & Rate Limiting — verify rate limiter middleware is applied
5. Broken Function Level Authorization — verify RBAC middleware on admin routes
6. Mass Assignment — verify request binding uses explicit field mapping
7. Security Misconfiguration — verify CORS, TLS, and security headers middleware
8. Injection — verify parameterized queries in repository layer

**Sensitive path review:**
- \`internal/auth/**\` — JWT validation, API key verification, RBAC logic
- \`configs/production/**\` — production configuration (should use env vars, not secrets)
- Any \`*.pem\` or \`.env*\` files — must be in \`.gitignore\`

### Stage 8: Architecture Compliance

Verify Clean Architecture boundaries:

1. **Handler layer** (\`internal/handler/\`):
   - Must only import from \`internal/service/\`, \`internal/model/\`, \`pkg/\`
   - Must NOT import from \`internal/repository/\`
   - Must accept \`context.Context\` from request
   - Must use Chi URL params via \`chi.URLParam(r, "param")\`

2. **Service layer** (\`internal/service/\`):
   - Must only import from \`internal/repository/\`, \`internal/model/\`, \`pkg/\`
   - Must NOT import from \`internal/handler/\`
   - Must accept \`context.Context\` as first parameter
   - Must define interfaces for repository dependencies

3. **Repository layer** (\`internal/repository/\`):
   - Must only import from \`internal/model/\`, \`pkg/\`
   - Must NOT import from \`internal/handler/\` or \`internal/service/\`
   - Must accept \`context.Context\` as first parameter
   - Must use parameterized queries (no string concatenation for SQL)

4. **Middleware** (\`internal/middleware/\`):
   - Must return \`func(http.Handler) http.Handler\` (Chi middleware signature)
   - Must call \`next.ServeHTTP(w, r)\` or short-circuit with error response
   - Must propagate context with values using typed keys

5. **File length**: No file should exceed 300 lines. Flag violations.

6. **Naming conventions**:
   - Files: \`snake_case.go\`
   - Exported: \`PascalCase\`
   - Unexported: \`camelCase\`
   - Environment variables: \`ALL_CAPS\`
   - All exported functions and types must have doc comments

### Stage 9: Documentation Check

Verify documentation is current:

- \`README.md\` reflects current setup instructions
- \`docs/ARCHITECTURE.md\` matches actual directory structure
- All exported functions in \`pkg/\` have godoc comments
- API endpoint changes have corresponding documentation updates
- Runbooks exist for critical paths (auth failures, rate limit tuning, circuit breaker trips)

Run godoc verification:

\`\`\`
go doc ./pkg/...
go doc ./internal/handler/...
\`\`\`

## Output Format

Produce a verification report with this structure:

\`\`\`
## Verification Report — go-api-gateway

**Date**: [timestamp]
**Scope**: [all | specific stage]
**Path**: [./... | specific path]

### Summary
| Stage                    | Status | Details          |
|--------------------------|--------|------------------|
| Format Check             | ✅/❌  | [summary]        |
| Lint                     | ✅/❌  | [n issues found] |
| Vet                      | ✅/❌  | [summary]        |
| Unit Tests               | ✅/❌  | [coverage %]     |
| Integration Tests        | ✅/❌/⏭️ | [summary]      |
| Build Verification       | ✅/❌  | [binary size]    |
| Security Audit           | ✅/❌  | [n findings]     |
| Architecture Compliance  | ✅/❌  | [n violations]   |
| Documentation Check      | ✅/❌  | [summary]        |

### Overall: PASS / FAIL

### Findings
[Detailed findings grouped by severity: critical, high, medium, low]

### Recommended Actions
[Ordered list of actions to resolve failures]
\`\`\`

## Scope-Specific Execution

When \`scope\` is not \`all\`, run only the specified stage:

- \`lint\` → Stage 2 only
- \`test\` → Stage 4 (unit tests) only
- \`security\` → Stage 7 only
- \`build\` → Stage 6 only
- \`integration\` → Stage 5 only
- \`arch\` → Stage 8 only
- \`docs\` → Stage 9 only
- \`quick\` → Stages 1, 2, 3, 4 (fast feedback loop)
- \`pre-merge\` → All stages (alias for \`all\`)

## Integration with CI

This skill mirrors the GitHub Actions CI pipeline defined in \`.github/workflows/ci.yml\`. Running \`verify\` locally before pushing ensures the CI pipeline will pass. The stages map to CI jobs:

| Verify Stage        | CI Job              |
|---------------------|---------------------|
| Format Check        | lint                |
| Lint                | lint                |
| Vet                 | vet                 |
| Unit Tests          | unit-tests          |
| Integration Tests   | integration-tests   |
| Build Verification  | build               |
| Security Audit      | security-scan       |

## Tips

- Run \`verify scope=quick\` during development for fast feedback
- Run \`verify scope=security\` before any PR touching \`internal/auth/\`
- Run \`verify scope=all\` before opening a PR to \`main\`
- If \`fix=true\`, formatting and some lint issues will be auto-corrected
- Use \`verify path=./internal/ratelimit/...\` to focus on a specific package after changes
- The security audit stage is mandatory for SOC 2 — never skip it for production PRs`,

  'plugin/marketplace.json.example': `{
  "slug": "codeforge-go-api-gateway",
  "name": "CodeForge Go API Gateway",
  "version": "1.0.0",
  "description": "Claude Code plugin for building high-performance API gateways with Go 1.22, Chi router, JWT authentication, Redis rate limiting, circuit breakers, and OpenTelemetry observability. Designed for SOC 2 compliant microservices architectures.",
  "author": {
    "name": "CodeForge",
    "url": "https://github.com/codeforge-dev",
    "email": "plugins@codeforge.dev"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/codeforge-dev/codeforge-go-api-gateway"
  },
  "license": "MIT",
  "keywords": [
    "go",
    "golang",
    "api-gateway",
    "chi-router",
    "jwt-authentication",
    "rate-limiting",
    "circuit-breaker",
    "opentelemetry",
    "prometheus",
    "redis",
    "postgresql",
    "microservices",
    "clean-architecture",
    "soc2",
    "tdd",
    "claude-code"
  ],
  "categories": [
    "backend",
    "api",
    "infrastructure",
    "security",
    "observability"
  ],
  "industry": [
    "technology",
    "saas"
  ],
  "compliance": [
    "soc2"
  ],
  "techStack": {
    "language": "go",
    "languageVersion": "1.22+",
    "framework": "chi/v5",
    "databases": ["postgresql", "redis"],
    "cloud": "aws",
    "orchestration": "kubernetes",
    "cicd": "github-actions"
  },
  "compatibility": {
    "claudeCode": ">=1.0.0",
    "os": ["linux", "macos", "windows"],
    "goVersion": ">=1.22"
  },
  "agents": [
    {
      "name": "architect",
      "description": "Designs API gateway components following Clean Architecture with handler → service → repository layers, Chi middleware composition, and SOC 2 security patterns."
    },
    {
      "name": "planner",
      "description": "Breaks down API gateway features into phased implementation plans with dependency ordering, risk assessment, and test strategy."
    },
    {
      "name": "tdd-guide",
      "description": "Guides test-driven development with table-driven tests, httptest handlers, Redis/PostgreSQL mocks, and 80% coverage enforcement."
    },
    {
      "name": "code-reviewer",
      "description": "Reviews Go code against golangci-lint rules, Effective Go conventions, API gateway security patterns, and performance benchmarks."
    },
    {
      "name": "build-error-resolver",
      "description": "Diagnoses and fixes Go compilation errors, linting failures, test failures, and Docker build issues in the gateway pipeline."
    }
  ],
  "commands": [
    {
      "name": "/plan",
      "description": "Generate a phased implementation plan for an API gateway feature with architecture decisions, middleware design, and test strategy."
    },
    {
      "name": "/tdd",
      "description": "Run a TDD cycle: write failing table-driven test → implement handler/service/repository → refactor with golangci-lint compliance."
    },
    {
      "name": "/verify",
      "description": "Run full verification: go vet, golangci-lint, unit tests, race detection, coverage check, and integration test validation."
    },
    {
      "name": "/build-fix",
      "description": "Diagnose and resolve build failures across Go compilation, Docker builds, and CI pipeline stages."
    },
    {
      "name": "/code-review",
      "description": "Perform a structured code review checking security, performance, error handling, test coverage, and Go idioms."
    }
  ],
  "skills": [
    {
      "name": "tdd",
      "description": "Test-driven development with Go stdlib testing, testify assertions, httptest, and table-driven test patterns."
    },
    {
      "name": "plan",
      "description": "Feature planning with phased delivery, architecture diagrams, and risk assessment for API gateway components."
    },
    {
      "name": "verify",
      "description": "Multi-stage verification pipeline matching the GitHub Actions CI workflow."
    },
    {
      "name": "build-fix",
      "description": "Automated diagnosis and resolution of build, lint, and test failures."
    },
    {
      "name": "code-review",
      "description": "Structured review against Go conventions, security policies, and gateway-specific patterns."
    },
    {
      "name": "phase",
      "description": "Phased development methodology for incremental feature delivery with quality gates."
    }
  ],
  "hooks": {
    "preCommit": "Validates conventional commit format, runs gofmt, checks for sensitive file modifications.",
    "prePush": "Runs go vet, golangci-lint, and unit tests before allowing push.",
    "postBuild": "Verifies binary size, runs smoke tests, validates Docker image."
  },
  "metrics": {
    "downloads": 0,
    "stars": 0,
    "forks": 0,
    "lastUpdated": "2024-12-01T00:00:00Z"
  },
  "screenshots": [
    {
      "url": "https://raw.githubusercontent.com/codeforge-dev/codeforge-go-api-gateway/main/docs/screenshots/tdd-cycle.png",
      "caption": "TDD cycle with table-driven tests for rate limiting middleware"
    },
    {
      "url": "https://raw.githubusercontent.com/codeforge-dev/codeforge-go-api-gateway/main/docs/screenshots/plan-output.png",
      "caption": "Phased implementation plan for circuit breaker feature"
    },
    {
      "url": "https://raw.githubusercontent.com/codeforge-dev/codeforge-go-api-gateway/main/docs/screenshots/code-review.png",
      "caption": "Structured code review with security and performance findings"
    }
  ],
  "documentation": {
    "readme": "https://github.com/codeforge-dev/codeforge-go-api-gateway/blob/main/README.md",
    "architecture": "https://github.com/codeforge-dev/codeforge-go-api-gateway/blob/main/docs/ARCHITECTURE.md",
    "contributing": "https://github.com/codeforge-dev/codeforge-go-api-gateway/blob/main/docs/CONTRIBUTING.md",
    "onboarding": "https://github.com/codeforge-dev/codeforge-go-api-gateway/blob/main/docs/ONBOARDING.md",
    "aiPolicy": "https://github.com/codeforge-dev/codeforge-go-api-gateway/blob/main/docs/AI-USAGE-POLICY.md"
  },
  "installation": {
    "method": "script",
    "command": "curl -fsSL https://raw.githubusercontent.com/codeforge-dev/codeforge-go-api-gateway/main/install.sh | bash",
    "manual": "Clone the repository and copy the plugin/ directory into your project root."
  },
  "support": {
    "issues": "https://github.com/codeforge-dev/codeforge-go-api-gateway/issues",
    "discussions": "https://github.com/codeforge-dev/codeforge-go-api-gateway/discussions",
    "slack": "https://codeforge-community.slack.com/channels/go-api-gateway"
  },
  "pricing": {
    "model": "free",
    "tier": "community"
  }
}`,

};
